<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="120px" viewBox="0 0 988 482" enable-background="new 0 0 988 482" xml:space="preserve">
<path fill="#FAFAFB" opacity="1.000000" stroke="none"
	d="
M649.000000,483.000000
	C432.666656,483.000000 216.833328,483.000000 1.000000,483.000000
	C1.000000,322.333344 1.000000,161.666672 1.000000,1.000000
	C330.333344,1.000000 659.666687,1.000000 989.000000,1.000000
	C989.000000,161.666672 989.000000,322.333344 989.000000,483.000000
	C875.833313,483.000000 762.666687,483.000000 649.000000,483.000000
M60.726368,373.168488
	C60.726368,373.168488 60.748371,373.485626 60.178951,373.667938
	C59.779640,374.105011 59.380333,374.542053 58.350803,375.058807
	C57.962013,375.733948 57.573223,376.409119 56.804607,377.590546
	C56.146763,378.663147 55.488914,379.735748 54.210598,380.966034
	C54.020111,381.711884 53.829624,382.457764 53.316147,383.811462
	C52.921944,384.872925 52.527740,385.934387 51.646221,387.487762
	C50.965675,389.183746 50.285130,390.879761 49.031124,392.850922
	C48.792740,393.605591 48.554356,394.360229 48.043320,395.624969
	C47.959606,396.000000 47.875893,396.375061 47.222633,396.991974
	C47.004147,397.718292 46.785660,398.444580 46.235916,399.817810
	C44.542286,402.036926 42.848652,404.256042 40.387058,406.284729
	C38.867332,406.041260 37.347610,405.797760 35.411869,405.053284
	C34.833199,404.406708 34.254528,403.760132 33.802940,402.319519
	C33.018021,395.475555 32.217129,388.633392 31.455950,381.786804
	C31.146576,379.004059 31.124943,376.169800 30.557323,373.445435
	C30.344549,372.424255 28.953226,371.648590 28.099234,370.760986
	C27.544838,371.892517 26.990442,373.024017 26.272814,374.770569
	C26.267653,375.193604 26.262491,375.616669 25.737226,376.594696
	C24.132713,383.755188 23.037931,390.904358 26.209539,398.603149
	C26.333353,399.012115 26.457167,399.421051 26.322966,400.552887
	C27.306900,403.168640 28.079975,405.889404 29.319124,408.378082
	C31.817774,413.396332 34.980103,418.499176 41.215103,418.310699
	C47.749516,418.113190 49.464867,412.122498 51.771755,407.123810
	C54.678993,400.824280 57.379185,394.333618 61.117306,388.537170
	C65.803162,381.271149 69.231369,381.480621 74.229645,388.146301
	C74.593521,388.631561 75.263512,388.887268 75.995995,389.827057
	C76.468887,390.486725 76.941788,391.146393 77.230110,392.476715
	C80.127815,397.914185 85.082085,400.687927 90.767807,401.649536
	C101.394318,403.446747 112.000580,403.654480 121.734428,397.793854
	C124.196999,396.311157 126.104294,396.381805 128.386108,398.465240
	C133.841782,403.446594 136.546906,403.393951 143.177841,399.984528
	C144.934204,399.081451 147.677261,398.902924 149.524155,399.587402
	C155.876541,401.941620 159.774811,401.234863 164.152679,396.126801
	C169.491272,389.897797 168.945923,379.004120 162.401520,374.660278
	C161.459702,375.649170 160.517868,376.638031 158.962769,377.968475
	C158.559753,380.054657 158.123962,382.135223 157.764130,384.228851
	C157.477585,385.896057 157.283783,387.579254 156.248550,389.271729
	C155.715698,389.247101 155.182861,389.222473 154.616302,388.351837
	C154.807129,385.430084 154.997955,382.508331 155.188782,379.586578
	C154.599960,379.420319 154.011139,379.254028 153.422318,379.087769
	C152.279037,380.057526 151.135757,381.027252 149.393814,382.232819
	C148.462585,383.090729 147.531372,383.948639 145.924805,384.927551
	C142.251343,387.568878 138.751068,390.708893 133.606705,388.349304
	C133.783554,387.228699 134.148880,386.098267 134.090988,384.989929
	C134.013290,383.502380 133.608459,382.031891 133.344070,380.554047
	C131.814636,380.965027 130.285202,381.375977 128.368042,381.861511
	C128.368042,381.861511 128.028610,382.063232 127.319427,381.931244
	C126.161766,382.570007 125.004105,383.208740 123.251740,383.939819
	C122.881195,384.089813 122.510651,384.239777 121.538628,384.183655
	C120.892609,384.651825 120.246597,385.120026 118.894295,385.696167
	C118.003563,386.013641 117.112831,386.331085 115.673523,386.350128
	C114.975998,386.727661 114.278473,387.105194 112.927795,387.500214
	C112.288727,387.627563 111.649658,387.754944 110.419441,387.514648
	C107.628784,388.089935 104.838127,388.665253 101.151421,389.166534
	C98.753288,389.192474 96.355156,389.218445 93.497673,388.701355
	C91.634636,388.193665 89.771599,387.686005 87.458145,386.699615
	C85.829681,385.190918 84.201218,383.682190 82.691086,381.514160
	C81.589317,379.906738 80.487549,378.299316 79.262695,376.008759
	C78.241104,374.613190 77.219513,373.217621 76.022438,371.828552
	C76.022438,371.828552 75.996033,372.002167 75.950310,371.412170
	C75.390228,370.871490 74.830147,370.330841 74.058762,369.147308
	C71.098938,366.780060 68.301849,367.007599 65.064224,369.822327
	C64.419411,370.312469 63.774586,370.802612 62.510719,371.208069
	C62.002853,371.800934 61.494987,372.393799 60.726368,373.168488
M214.403091,90.546036
	C214.701202,90.096390 214.999313,89.646751 215.678818,89.118240
	C215.678818,89.118240 215.944458,88.833420 216.644348,88.922256
	C218.474548,87.642860 220.304749,86.363472 222.579422,84.974098
	C222.579422,84.974098 222.891068,84.638626 223.590881,84.712395
	C238.599426,76.385468 253.300949,67.290253 271.909546,64.677795
	C270.651337,67.635368 269.916779,69.362083 268.646301,71.433731
	C267.679840,72.825653 266.713348,74.217575 265.109161,75.792480
	C264.525787,76.897781 263.942383,78.003082 262.997467,79.344841
	C262.997467,79.344841 262.849274,79.750595 262.191010,79.950829
	C259.844055,83.377075 256.879639,86.580505 257.668182,91.975914
	C263.616058,90.584869 264.638611,85.789642 267.020538,81.687080
	C267.020538,81.687080 267.183289,81.293846 267.826843,81.081253
	C271.640900,74.571762 275.739563,68.202049 279.056824,61.448540
	C279.827667,59.879185 277.937042,57.002533 277.000000,54.999237
	C277.000000,54.999237 277.270325,54.726131 277.151184,54.018394
	C275.198730,53.568890 272.961700,52.260517 271.336639,52.799007
	C247.878250,60.572308 225.693344,70.970703 205.331116,85.141441
	C199.390213,89.275902 197.210617,95.026360 196.665100,101.714516
	C196.356842,105.493660 198.087402,108.081825 202.352051,109.042473
	C202.352051,109.042473 202.748596,109.154953 202.913986,109.816719
	C206.633698,112.470383 210.353394,115.124046 214.412979,118.330299
	C215.260208,119.308403 216.107437,120.286507 216.955246,121.979156
	C217.757614,122.599297 218.559967,123.219437 219.941544,124.093132
	C220.998444,125.377846 222.055344,126.662567 222.972778,128.586151
	C223.379318,129.041763 223.785858,129.497360 224.280121,130.709717
	C224.572296,131.406143 224.864487,132.102554 224.764771,133.571869
	C224.890823,134.119888 225.016891,134.667892 224.747849,135.822830
	C223.852600,136.949554 222.957367,138.076279 221.389130,139.091339
	C220.505325,139.258057 219.621536,139.424789 217.949295,139.283981
	C215.654510,138.249069 213.359711,137.214157 210.959686,135.435837
	C211.109314,134.967575 211.258942,134.499298 212.093750,133.780869
	C212.995178,131.551361 214.708267,129.084030 210.192841,128.334183
	C210.192841,128.334183 209.971039,128.117172 209.933167,127.504677
	C209.537643,127.155273 209.142120,126.805870 208.746597,126.456459
	C208.497559,126.968681 208.248505,127.480904 207.639282,128.167343
	C207.639282,128.167343 207.241135,128.127838 206.399002,128.036850
	C205.747635,128.948746 205.096268,129.860641 204.358017,131.334091
	C203.648438,131.926178 202.938873,132.518265 201.444870,133.019608
	C200.681046,133.793976 199.917221,134.568344 198.906158,135.887650
	C197.877335,136.432861 196.848511,136.978073 194.926727,137.245087
	C192.034378,138.038406 189.142044,138.831711 185.776382,139.623093
	C185.445526,139.579849 185.171143,139.431824 184.893143,138.441849
	C183.892914,137.977737 182.892685,137.513641 181.373825,136.738907
	C181.222305,136.169006 181.070801,135.599106 181.501083,134.613052
	C180.350769,131.405441 179.200470,128.197845 177.754242,124.579376
	C177.504074,124.385323 177.253891,124.191269 177.095093,123.338730
	C176.991928,122.912483 176.888779,122.486244 177.145279,121.278519
	C177.090805,119.854218 177.036316,118.429909 177.553162,116.523445
	C177.064026,114.677155 176.574890,112.830864 175.849060,110.285225
	C175.611603,108.840897 175.374146,107.396561 175.618057,105.566154
	C175.136383,104.685188 174.654724,103.804214 173.948380,103.102379
	C173.948380,103.102379 173.665024,103.150017 173.927795,102.464287
	C173.954788,101.975792 173.981781,101.487297 174.547546,100.543480
	C173.833298,98.351173 173.119049,96.158867 172.115479,93.346741
	C172.091782,92.895439 172.068085,92.444145 172.555298,91.582970
	C171.998871,90.712700 171.442429,89.842422 170.606689,88.601295
	C170.456360,88.309250 170.430664,88.006630 170.806351,86.877563
	C170.142197,85.945068 169.478058,85.012573 168.425980,83.789474
	C168.272018,83.498085 168.062347,83.254662 168.018082,82.398529
	C168.005630,81.934669 167.993195,81.470810 168.456329,80.703209
	C168.010178,80.128181 167.564026,79.553154 166.880890,78.651291
	C166.880890,78.651291 166.867218,78.247803 166.976898,77.532944
	C166.391464,76.677063 165.806046,75.821182 164.811859,74.522987
	C164.355072,74.157341 163.898300,73.791687 163.456589,73.116859
	C163.456589,73.116859 163.250259,72.886093 163.372086,72.162560
	C163.282028,71.437157 163.191971,70.711761 163.573837,69.557945
	C161.911972,68.395050 160.359329,66.671570 158.539948,66.317024
	C157.691025,66.151604 155.657806,68.500252 155.360367,69.954590
	C154.973221,71.847633 155.778168,73.984489 156.212280,76.664635
	C156.170517,77.102905 156.128754,77.541168 155.557648,78.332756
	C156.179123,79.283058 156.800583,80.233360 157.695129,81.034050
	C157.695129,81.034050 158.004349,80.997391 157.840942,81.657440
	C157.873795,82.108368 157.906662,82.559296 157.500763,83.305466
	C158.056778,83.902924 158.612808,84.500381 159.666245,85.497459
	C159.810455,85.653801 159.954651,85.810135 159.891602,86.631485
	C159.892166,87.094925 159.892731,87.558365 159.394592,88.449722
	C160.000748,89.285065 160.606903,90.120407 161.502045,91.319244
	C161.634567,91.626503 161.622543,91.928001 161.180374,93.020584
	C161.757446,94.019585 162.334518,95.018585 163.123184,96.393417
	C163.123184,96.393417 163.106644,96.824394 162.992310,97.675438
	C164.203857,101.461990 165.415390,105.248550 166.886871,109.772850
	C167.014267,110.539780 167.141663,111.306702 166.945099,112.443176
	C166.824356,112.774155 166.598099,112.998894 165.502594,113.115646
	C165.035416,114.147728 164.568237,115.179802 164.062958,116.661850
	C163.923859,116.967422 163.686874,117.132225 162.537338,117.165367
	C162.159286,118.020744 161.781235,118.876122 161.357986,120.303970
	C160.840225,121.098633 160.322449,121.893288 159.175598,122.808456
	C158.712967,123.473946 158.250351,124.139435 157.985855,124.985054
	C157.985855,124.985054 157.803848,124.788651 157.171188,124.858887
	C156.679504,125.509308 156.187820,126.159729 155.159485,127.016838
	C154.345932,127.475021 153.532394,127.933205 151.892136,128.219894
	C151.332870,128.978790 150.773605,129.737686 150.108490,130.900101
	C149.923187,131.159515 149.676041,131.250137 148.559158,131.043594
	C147.745117,131.825455 146.931061,132.607300 145.970963,133.496857
	C145.970963,133.496857 145.791367,133.522842 145.008469,133.249725
	C144.354614,133.905396 143.700760,134.561066 142.761292,135.578018
	C142.475769,135.737595 142.176498,135.769974 141.099808,135.319626
	C140.452560,135.955353 139.805298,136.591095 139.038834,137.062851
	C139.038834,137.062851 139.192932,137.194580 138.380371,137.029190
	C136.230438,137.970840 134.080490,138.912491 132.121750,140.165604
	C132.121750,140.165604 132.195786,140.523499 131.501129,140.192703
	C130.996170,140.106873 130.491211,140.021042 129.427689,139.355423
	C126.913597,139.256393 124.399498,139.157349 121.358749,138.916885
	C121.011238,138.842072 120.663719,138.767242 120.001831,138.998779
	C120.001831,138.998779 120.320084,138.696411 120.364838,138.014893
	C120.210709,137.353333 120.056572,136.691757 120.496452,135.550613
	C120.658798,134.023102 120.821144,132.495590 121.205551,130.430878
	C121.958382,129.859848 122.711220,129.288803 124.096115,128.852448
	C124.475418,128.260452 124.854713,127.668457 125.298645,126.599335
	C125.298645,126.599335 125.166275,126.136383 125.047256,126.009193
	C125.047256,126.009193 125.135582,126.159317 125.782127,126.183624
	C126.545845,125.798439 127.309563,125.413254 128.787292,125.047523
	C130.203201,123.869499 131.619110,122.691475 133.814819,121.319893
	C134.873245,121.199516 135.931686,121.079140 137.454269,121.530151
	C139.292160,121.381683 141.130035,121.233215 143.550354,121.103668
	C144.103531,121.592575 144.656708,122.081490 145.148254,123.361862
	C146.829269,126.551071 149.689407,127.073837 151.990341,124.939011
	C153.526779,123.513504 154.514175,120.465508 150.754074,118.383797
	C150.197662,117.190819 149.641251,115.997841 149.059128,114.081688
	C148.025482,113.394135 146.991852,112.706573 145.475525,112.087959
	C145.475525,112.087959 144.991272,112.031105 144.865051,111.326736
	C143.562897,110.921555 142.260757,110.516365 140.250534,109.842148
	C139.508057,109.913490 138.765594,109.984825 137.244476,109.801666
	C135.653000,110.098183 134.061508,110.394691 131.753662,110.331261
	C130.875229,110.930519 129.996796,111.529778 129.056320,111.999695
	C129.056320,111.999695 129.103226,112.131218 128.343948,112.006088
	C125.384415,113.034416 121.829086,113.339844 121.136795,118.117599
	C119.015953,120.045921 116.895111,121.974251 114.080124,123.862808
	C111.034325,127.872742 107.988525,131.882690 104.695305,136.487137
	C104.375748,137.251678 104.056190,138.016220 103.955002,138.900543
	C103.955002,138.900543 103.763115,138.741760 103.073044,138.786987
	C102.378288,139.855652 101.683533,140.924301 100.495659,142.115814
	C100.322838,142.395050 100.150024,142.674286 99.243080,142.982483
	C96.377762,144.484436 93.512436,145.986389 90.647110,147.488342
	C90.459167,147.115479 90.271217,146.742630 90.083275,146.369766
	C90.725777,145.248138 91.368286,144.126495 92.600731,142.855438
	C93.381332,142.226257 94.161934,141.597061 95.655975,140.927109
	C95.961281,140.151794 96.266594,139.376495 96.663734,137.986267
	C96.587570,137.593903 96.511406,137.201553 96.648689,136.947372
	C96.648689,136.947372 96.902023,136.925781 97.579636,136.903214
	C97.745689,135.607422 97.911743,134.311615 98.144836,132.304626
	C98.300064,131.608200 98.455292,130.911789 99.142540,129.920654
	C98.930229,128.547394 98.717918,127.174118 98.338654,125.052025
	C98.223152,124.035019 98.107651,123.018013 98.526016,121.584236
	C97.422821,119.019424 96.319626,116.454605 95.066124,113.457649
	C95.066124,113.457649 94.994965,113.005676 95.091644,112.237160
	C94.224503,111.713585 93.357368,111.190010 92.161079,110.696045
	C91.940300,110.706665 91.720352,110.697456 90.814888,110.333420
	C89.824036,112.882996 88.833191,115.432564 87.849831,118.697380
	C88.318962,120.019234 88.788094,121.341087 89.142319,123.323639
	C89.661133,123.989517 90.179947,124.655396 90.824287,126.122757
	C91.176193,130.940277 89.728775,132.411850 85.161705,131.950836
	C84.123962,131.846085 83.069870,131.903427 81.431129,131.708908
	C80.491203,130.619125 79.551270,129.529343 78.815605,127.774559
	C78.285446,127.146713 77.755287,126.518875 76.975815,125.295563
	C76.808640,124.672318 76.641472,124.049072 76.769310,122.804001
	C76.298462,122.147896 75.827614,121.491791 75.157440,120.396767
	C75.157440,120.396767 75.064415,119.923767 75.167305,119.165398
	C74.085136,117.458778 73.002968,115.752151 71.507866,113.571930
	C70.698997,112.949997 69.890129,112.328056 68.952034,111.148933
	C68.321526,110.732948 67.691017,110.316963 66.964302,109.266212
	C65.973274,109.505417 64.982239,109.744614 63.448288,110.226143
	C62.939705,110.749496 62.431122,111.272842 61.258469,111.925888
	C59.702663,113.731476 58.146858,115.537056 55.931755,117.530327
	C55.546783,118.315933 55.161812,119.101540 54.249893,120.104362
	C53.819321,120.729187 53.388748,121.354019 52.379574,121.959236
	C52.210331,122.632881 52.041088,123.306534 51.769672,124.547432
	C51.637093,125.104050 51.504513,125.660675 50.811428,126.430656
	C50.456059,126.911613 50.100689,127.392570 49.121769,128.026199
	C48.658978,128.942596 48.196182,129.858994 47.152618,131.087387
	C46.879757,132.806793 46.606895,134.526199 46.182758,136.237534
	C46.182758,136.237534 46.315456,136.310608 45.520603,136.340775
	C45.296894,137.419189 45.073189,138.497604 44.774471,139.542343
	C44.774471,139.542343 44.826172,139.478409 44.175632,140.038895
	C43.721874,141.211456 43.268112,142.384033 42.649288,143.975708
	C42.649288,143.975708 42.411755,144.358459 41.671963,144.308105
	C41.353008,145.035141 41.034054,145.762192 40.578682,146.584274
	C40.578682,146.584274 40.443691,146.681335 39.508801,146.310043
	C37.861080,146.426132 36.213356,146.542221 34.555798,146.558334
	C34.555798,146.558334 34.617371,146.478958 34.650391,145.710495
	C33.605896,143.447235 32.561401,141.183960 31.167974,138.132416
	C31.150513,136.409851 31.133049,134.687302 31.691887,132.386230
	C31.471575,128.260773 31.251263,124.135307 30.971308,119.326614
	C31.139309,118.907616 31.307308,118.488617 32.126968,117.811462
	C33.745392,114.748909 33.608669,111.787254 30.221304,110.390182
	C26.670147,108.925545 25.618504,112.226822 24.819803,114.611031
	C23.624964,118.177727 22.307074,121.900154 22.204790,125.588600
	C22.060446,130.793640 20.562307,136.417450 24.876522,141.659775
	C24.934513,142.101593 24.992504,142.543427 24.552404,143.285141
	C25.027506,143.858734 25.502607,144.432343 26.287008,145.395737
	C26.447617,145.704773 26.487572,146.028687 26.184683,147.148911
	C27.488968,149.083435 28.793253,151.017960 30.615303,153.124908
	C30.960165,153.203079 31.305027,153.281250 32.019341,153.062164
	C32.019341,153.062164 31.641369,153.346451 31.671741,153.988052
	C32.308193,154.461823 32.944649,154.935593 33.898762,155.012695
	C33.799900,155.150146 33.701035,155.287598 33.681004,156.045227
	C34.443150,156.751175 35.205292,157.457108 36.107853,158.861725
	C38.842194,160.824158 40.925610,160.590515 42.226814,156.588501
	C42.313255,156.245529 42.399700,155.902542 42.475994,155.462769
	C42.475994,155.462769 42.573017,155.470474 43.180805,155.389191
	C43.586472,154.728516 43.992142,154.067841 44.017185,153.029877
	C44.148140,153.151321 44.279091,153.272781 44.950336,153.383072
	C45.282703,153.247040 45.615074,153.110992 46.665974,152.957611
	C48.878384,153.183517 51.090794,153.409424 53.289696,153.659668
	C53.289696,153.659668 53.311317,153.668823 53.193592,154.396866
	C53.891438,154.847763 54.589283,155.298645 55.049515,155.951477
	C55.049515,155.951477 55.261646,155.722916 55.145817,156.498550
	C58.013805,160.176941 60.595383,159.929016 62.958897,155.966293
	C62.958897,155.966293 62.768833,155.788452 63.551464,155.942490
	C64.599251,156.356232 65.759315,156.601456 66.675919,157.212097
	C71.299110,160.292267 74.710152,159.216919 77.349106,153.292389
	C77.743706,152.197586 78.138313,151.102783 79.102921,150.253311
	C80.084419,151.162354 81.065918,152.071396 82.578857,153.304169
	C83.538719,154.027039 84.498589,154.749924 85.655319,155.345856
	C85.655319,155.345856 85.509338,155.529037 85.507034,156.094452
	C85.654327,156.442276 85.801620,156.790115 86.061958,157.885818
	C90.239388,161.672882 98.071747,159.561035 100.188347,153.697876
	C100.188347,153.697876 100.171982,153.326706 100.860016,153.243240
	C102.292290,151.521683 103.724571,149.800125 105.623245,147.842270
	C106.027573,147.535172 106.431908,147.228073 107.552658,146.960693
	C109.180969,145.718765 110.809288,144.476837 112.133842,143.466599
	C113.664665,144.728394 114.943115,145.782166 116.095749,146.781464
	C116.095749,146.781464 116.232666,146.788391 116.049652,147.595139
	C115.974983,152.458237 118.470093,154.041382 123.874863,153.021667
	C125.927711,153.059067 127.980568,153.096451 130.431610,153.628952
	C131.271362,153.062744 132.111115,152.496536 132.994431,152.001984
	C132.994431,152.001984 132.937729,151.939377 133.725952,152.058456
	C136.810760,150.358994 139.895569,148.659531 143.426544,146.467377
	C146.454086,144.548645 149.481613,142.629913 153.275208,140.859207
	C154.135468,139.817429 154.995728,138.775650 156.173370,137.198441
	C157.103195,136.105667 158.033020,135.012894 159.618835,133.802490
	C160.186737,132.903839 160.754639,132.005188 161.769531,130.854630
	C162.187073,130.573303 162.604599,130.291992 163.749741,130.042908
	C165.178070,129.042877 166.606384,128.042862 168.230713,126.905602
	C168.837128,128.211990 169.564819,129.779648 170.388992,131.713959
	C170.388992,131.713959 170.227570,132.058304 169.725113,132.135788
	C169.945663,132.366348 170.166214,132.596924 170.613724,133.047607
	C170.613724,133.047607 170.618484,133.363739 170.272720,134.183929
	C170.672699,139.140411 170.954041,144.150833 176.604065,147.259003
	C177.539215,148.296692 178.474380,149.334366 179.214325,151.213333
	C179.899719,154.709686 182.277634,154.078171 185.316116,153.341797
	C186.642548,153.337128 187.968979,153.332458 190.048218,153.694839
	C191.997284,152.400940 193.946350,151.107040 196.156830,149.407669
	C196.389023,149.159531 196.674789,149.026184 197.764496,149.049500
	C198.441132,148.241806 199.117783,147.434113 200.076920,146.119431
	C200.805176,145.504730 201.533432,144.890045 202.910751,144.787048
	C204.805588,147.191727 206.574600,149.715088 208.666916,151.933502
	C209.353638,152.661591 210.878845,152.598846 212.861618,152.954269
	C214.262054,153.032547 215.662491,153.110825 217.464539,153.670013
	C218.309784,153.114410 219.155045,152.558807 220.415573,151.615417
	C221.093582,151.295700 221.771591,150.975983 223.197739,150.851715
	C224.512863,149.320847 225.828003,147.789978 227.119873,146.112030
	C227.119873,146.112030 227.267319,146.132690 227.963409,146.017319
	C229.732513,142.058044 231.501602,138.098770 233.204865,134.286865
	C235.796402,135.852386 239.027969,137.804550 242.012802,139.974960
	C242.012802,139.974960 242.243851,139.740021 242.156830,140.483658
	C242.909317,140.911514 243.661789,141.339355 244.948669,141.983780
	C245.725281,142.829926 246.501877,143.676071 247.174072,145.252975
	C250.478683,147.835953 253.532562,150.860931 257.141235,152.907883
	C264.180450,156.900803 277.232269,152.154282 280.966553,144.991928
	C280.966553,144.991928 280.729523,144.742294 281.461731,144.846771
	C281.912933,144.119049 282.364105,143.391342 283.052124,142.115387
	C283.762451,141.426788 284.472778,140.738190 285.863403,139.996658
	C287.773193,138.305496 289.682953,136.614334 291.599792,134.916931
	C302.381927,148.794220 307.071411,145.103973 314.687653,140.442749
	C320.432892,136.926605 322.306213,137.076050 325.678223,143.527054
	C325.132141,144.439026 324.586060,145.350998 323.744995,146.306580
	C323.744995,146.306580 323.451660,146.252991 322.648987,146.185196
	C322.303802,148.785492 321.958618,151.385773 321.574707,154.715164
	C321.434906,155.430634 321.295105,156.146103 320.760773,157.101074
	C320.753571,157.627243 320.746368,158.153397 320.739166,158.679565
	C321.138062,158.531876 321.536926,158.384171 322.689728,158.229568
	C324.287506,157.350204 325.885315,156.470840 328.137604,155.294617
	C330.390656,154.357361 332.643738,153.420090 335.123383,153.125687
	C335.662567,152.593964 336.201752,152.062241 336.941162,150.981995
	C337.209534,150.704559 337.477905,150.427124 338.435913,150.107651
	C340.157135,150.614227 341.878326,151.120819 343.889557,151.624268
	C343.889557,151.624268 344.047119,151.867767 344.016846,152.476379
	C344.674194,152.662262 345.331543,152.848145 346.852264,153.055786
	C348.575897,153.068130 350.299530,153.080475 352.405731,153.598007
	C353.272278,153.070175 354.138824,152.542328 355.515900,151.652054
	C356.461090,151.225708 357.406311,150.799362 359.065186,150.691238
	C359.688568,150.088028 360.311920,149.484818 361.017273,148.425125
	C361.017273,148.425125 360.934937,147.968704 361.553253,147.734238
	C363.014496,146.107498 364.475708,144.480759 366.357544,142.991776
	C366.357544,142.991776 366.784729,142.876022 367.556488,142.808563
	C367.832397,141.984070 368.108276,141.159561 368.432220,139.656265
	C368.661957,138.780853 368.891693,137.905441 369.858765,136.858292
	C371.394531,133.980042 372.408844,131.159531 368.561432,128.267883
	C368.364868,127.848610 368.168335,127.429337 368.152618,126.352455
	C368.104492,125.900581 368.056366,125.448700 368.492371,124.662834
	C367.930939,124.156448 367.369507,123.650063 366.518036,123.150116
	C366.518036,123.150116 366.233765,123.208038 366.514038,122.733047
	C366.497131,122.365250 366.480225,121.997444 366.723541,120.887421
	C366.059845,120.343597 365.396149,119.799774 365.003540,119.146347
	C365.003540,119.146347 364.747742,119.288155 364.920135,118.338013
	C364.842438,117.382347 364.764709,116.426682 364.796875,114.914627
	C365.412079,114.211250 366.027283,113.507874 367.367859,112.850975
	C367.929626,111.936684 368.491394,111.022385 369.225830,109.561996
	C369.632690,108.925552 370.039520,108.289101 371.002014,107.557999
	C371.323975,107.366493 371.645935,107.174988 372.692780,106.900826
	C373.040527,106.111282 373.388275,105.321747 373.868774,103.975136
	C374.371826,103.181374 374.874878,102.387611 376.016022,101.389496
	C376.492981,100.674255 376.969971,99.959023 377.883087,99.147507
	C378.123627,98.953979 378.398010,98.848709 379.448212,98.965950
	C380.446075,99.021019 381.443970,99.076088 382.599457,100.006363
	C382.955383,102.038956 383.311279,104.071541 383.460785,106.809891
	C383.595520,108.530479 383.730286,110.251076 383.197296,111.923897
	C382.464355,112.333801 381.731415,112.743713 380.596466,112.921333
	C380.596466,112.921333 380.188263,112.703285 380.081116,111.985550
	C379.295288,111.375610 378.509460,110.765663 377.723633,110.155724
	C377.163910,111.124886 376.604156,112.094040 375.908356,113.826294
	C375.189972,122.183708 374.471588,130.541122 373.142029,139.020355
	C373.428741,141.088623 371.514160,143.996277 375.513947,145.114197
	C375.513947,145.114197 375.614197,145.539810 375.289337,146.268173
	C375.943390,147.109909 376.597443,147.951645 377.440582,149.159958
	C377.440582,149.159958 377.543610,149.559326 377.292267,150.235184
	C377.895477,150.797684 378.498688,151.360184 379.518646,152.344009
	C380.046478,153.174316 380.574310,154.004623 381.050232,155.535385
	C382.695221,156.381485 384.340179,157.227585 386.741058,158.025940
	C387.497437,158.033722 388.253784,158.041489 389.390533,158.562073
	C390.856598,157.267761 392.322662,155.973434 394.010101,154.101852
	C394.711456,153.081406 395.412811,152.060959 396.828552,150.903168
	C397.039795,150.071548 397.251038,149.239944 397.606781,147.792007
	C398.132996,146.880707 398.659241,145.969391 399.889282,144.880951
	C400.052216,144.038452 400.215149,143.195969 400.471283,141.747742
	C400.702087,141.182938 400.932892,140.618118 401.867035,139.900009
	C402.076508,139.072250 402.285980,138.244492 402.543976,136.907639
	C402.691254,136.603073 402.838562,136.298508 403.572693,135.969009
	C403.726807,135.315323 403.880890,134.661652 404.110840,133.339279
	C404.100891,132.899124 404.090942,132.458984 404.408875,131.662170
	C404.572815,131.361267 404.606659,131.046387 405.077026,130.453491
	C405.720978,129.637283 406.364929,128.821060 407.726807,127.955467
	C408.353271,126.845978 408.979736,125.736488 409.950806,124.929802
	C409.950806,124.929802 409.626526,124.605316 410.270782,124.822716
	C410.873566,124.302025 411.476379,123.781334 412.772888,123.037865
	C413.490051,123.108322 414.207214,123.178772 415.045532,123.868607
	C415.737946,124.222290 416.430328,124.575966 417.643524,125.336304
	C418.133118,126.550339 418.622711,127.764366 418.568604,129.338318
	C419.737152,131.549026 420.905701,133.759750 422.435333,136.533188
	C423.299591,138.340805 424.163818,140.148438 424.934387,142.638382
	C425.779083,143.440872 426.623810,144.243362 427.966583,145.466248
	C428.513367,145.772629 429.060181,146.079010 430.004669,146.017822
	C429.873810,146.142563 429.742950,146.267288 429.690460,147.014862
	C430.104950,147.487457 430.519470,147.960052 430.950409,149.114166
	C431.967438,149.742645 432.984467,150.371124 434.548218,151.141495
	C435.030029,151.432907 435.511841,151.724319 436.130127,152.789108
	C437.289764,152.997269 438.449402,153.205429 440.256042,153.262009
	C441.856110,153.228516 443.456177,153.195023 445.493073,153.670715
	C446.662964,153.115158 447.832825,152.559601 449.536316,151.604599
	C450.923798,150.556595 452.311249,149.508591 453.937347,148.449081
	C453.937347,148.449081 454.090912,148.266068 454.783997,148.298355
	C455.434418,147.701508 456.084869,147.104660 456.960724,146.479828
	C456.960724,146.479828 457.111084,146.309570 457.783630,146.338669
	C458.566467,145.911041 459.349304,145.483414 460.964600,145.081726
	C462.627716,145.063263 464.290863,145.044800 466.580444,145.259430
	C468.722687,146.835037 470.864960,148.410645 473.116455,150.713821
	C473.935120,150.983521 474.753784,151.253220 476.078339,151.593796
	C476.377075,151.752716 476.675781,151.911621 477.039917,152.707626
	C478.021149,152.830673 479.002380,152.953705 480.865936,153.032150
	C482.922729,153.073715 484.979523,153.115280 487.483185,153.666397
	C489.004822,152.822159 490.526428,151.977921 492.499481,150.631241
	C495.812836,146.765518 499.089996,142.867813 502.460419,139.052521
	C503.550018,137.819077 504.884521,136.801987 506.313141,136.383850
	C510.216980,138.422684 514.045532,140.635773 518.078064,142.376572
	C519.073792,142.806396 520.732239,141.700851 522.635681,140.908585
	C523.903198,139.644928 525.170654,138.381271 527.112488,136.881378
	C527.530273,133.709717 527.948120,130.538055 528.239258,126.831268
	C528.271912,126.102730 528.304504,125.374184 528.740723,123.783051
	C529.177917,119.860184 529.140320,116.125847 524.373596,113.705444
	C523.228943,112.514603 522.084290,111.323753 520.875366,109.396347
	C519.019165,107.555656 517.300842,106.960617 515.582092,110.255753
	C515.260864,110.354263 514.939636,110.452774 513.885498,110.285034
	C513.300659,110.929466 512.715820,111.573906 511.788208,112.707130
	C511.328949,113.083282 510.869659,113.459442 509.756897,113.887642
	C509.162903,114.909805 508.568909,115.931976 507.738129,117.540230
	C506.859558,118.712799 505.980988,119.885368 504.348755,121.145813
	C504.102325,121.977539 503.855896,122.809265 503.536469,124.249481
	C503.322357,124.819893 503.108215,125.390305 502.331116,125.992943
	C502.158691,126.649086 501.986237,127.305229 501.743469,128.618912
	C501.743805,129.052765 501.744141,129.486633 501.556396,130.090775
	C501.556396,130.090775 501.575531,130.343765 500.992920,130.577271
	C500.339203,131.389038 499.685486,132.200806 498.360626,133.045670
	C497.866119,133.951202 497.371613,134.856735 496.643768,136.256119
	C496.225677,136.594284 495.807556,136.932449 494.708008,137.116379
	C494.121002,137.693161 493.534027,138.269928 492.419159,139.160049
	C491.828369,139.315399 491.237549,139.470749 489.690826,139.244690
	C484.557587,138.704498 479.424347,138.164307 473.921753,137.601028
	C473.921753,137.601028 473.653961,137.345596 474.024048,136.687897
	C474.334137,135.762619 474.644257,134.837357 475.344604,133.512039
	C475.898132,133.017639 476.451660,132.523239 477.641663,132.145538
	C478.067413,132.079346 478.493164,132.013168 479.696838,132.045731
	C483.076416,130.866577 487.262268,130.786652 488.000244,125.999390
	C488.000244,125.999390 487.971619,125.979416 488.709259,125.912041
	C489.282379,124.401115 489.855499,122.890190 490.405548,120.923431
	C490.440704,120.470245 490.475891,120.017059 490.785919,118.839760
	C490.148224,118.262115 489.510498,117.684479 488.987061,117.013412
	C488.987061,117.013412 488.895630,117.129265 488.911560,116.418953
	C487.955444,115.938087 486.999329,115.457222 485.469818,114.767197
	C484.650177,114.169472 483.830505,113.571739 482.917664,112.232803
	C481.076904,111.673721 479.236115,111.114639 476.652405,110.610794
	C475.425507,110.432289 474.198608,110.253784 472.822296,109.280800
	C468.445160,107.637230 464.091644,106.450447 459.202362,110.193176
	C457.336823,110.322639 455.471313,110.452103 452.830109,110.227921
	C451.539520,110.777107 450.248901,111.326294 448.404175,112.151779
	C447.799469,112.274353 447.194794,112.396927 445.873077,112.248528
	C445.262909,112.857994 444.652740,113.467461 443.843750,114.531464
	C443.618408,114.797226 443.510254,115.104279 443.008575,115.545639
	C442.707001,115.716743 442.405426,115.887840 441.350494,116.139839
	C441.092560,116.967369 440.834625,117.794899 440.515717,119.124908
	C440.377960,119.431114 440.240204,119.737320 439.499359,120.078819
	C439.369080,120.726807 439.238770,121.374786 438.983032,122.782555
	C439.323975,124.185776 439.664948,125.588997 440.032898,127.643661
	C441.015594,127.791389 441.998322,127.939125 443.830566,128.026993
	C444.878448,128.392014 445.926361,128.757050 446.969788,129.710983
	C448.620087,130.489563 450.270386,131.268143 452.474915,132.189011
	C453.060699,132.671616 453.646515,133.154221 454.129272,134.500809
	C454.101776,135.369263 454.074310,136.237717 453.613190,137.366806
	C453.288269,137.451950 452.963348,137.537094 451.944092,137.311340
	C451.295715,137.875443 450.647369,138.439560 449.584045,139.279739
	C449.286713,139.440628 448.969513,139.533478 447.645844,139.195694
	C443.922455,139.288864 440.199036,139.382050 435.841125,139.319687
	C434.588989,138.156036 433.336884,136.992371 432.108582,135.099075
	C431.379059,134.076828 430.649506,133.054581 429.664978,131.583725
	C429.590271,131.249664 429.515564,130.915588 429.715607,129.834427
	C428.121063,125.712936 426.726593,121.496582 424.838562,117.514221
	C424.023712,115.795418 422.188293,114.560440 420.337982,112.765961
	C419.482056,111.961349 418.626160,111.156731 417.924194,109.629295
	C418.938080,108.059334 419.951996,106.489372 421.186310,104.682884
	C421.186310,104.682884 421.508759,104.659317 422.292267,104.842896
	C423.165955,103.533333 425.064484,101.576225 424.722382,101.034798
	C423.668793,99.367218 421.758759,98.240768 419.607330,96.669998
	C418.734558,95.788338 417.861786,94.906677 416.922791,93.299683
	C415.244232,93.241875 413.498322,92.868958 411.904907,93.209473
	C410.089569,93.597397 408.410217,94.621696 406.823914,95.209038
	C406.823914,95.209038 406.632721,95.319984 406.816711,94.548317
	C403.938873,90.784348 401.350006,90.930740 399.000000,95.000000
	C399.000000,95.000000 398.991211,94.992989 398.239563,94.931541
	C396.884064,96.549263 395.021759,97.999939 394.408020,99.862099
	C394.140564,100.673599 396.434021,102.329170 398.054138,103.772507
	C398.384094,104.155197 398.714020,104.537888 399.034760,105.605881
	C399.722473,106.043869 400.410187,106.481857 401.012299,106.996666
	C401.012299,106.996666 401.075439,106.900589 401.120392,107.664085
	C403.282898,107.686371 405.473602,107.928665 407.598419,107.656586
	C409.112152,107.462769 410.537231,106.576988 412.295868,106.118500
	C412.295868,106.118500 412.436798,106.402374 412.195709,107.191032
	C411.289612,108.941757 410.383484,110.692490 409.346558,112.340599
	C409.346558,112.340599 409.412079,112.493385 408.667511,112.245201
	C407.969421,113.317795 407.271362,114.390388 406.476379,115.462051
	C406.476379,115.462051 406.478943,115.558945 405.709320,115.325394
	C405.320251,116.095161 404.931183,116.864937 404.465973,118.126930
	C404.386871,118.457901 404.231873,118.748367 403.285583,119.103928
	C402.976257,119.898155 402.666931,120.692383 402.312103,121.806000
	C402.312103,121.806000 402.089722,122.039703 401.385376,122.086319
	C399.418365,126.581055 397.451324,131.075790 395.478302,136.087524
	C395.358215,136.408157 395.238098,136.728790 394.338440,137.175598
	C394.076721,138.318176 393.815033,139.460770 393.506195,141.114304
	C393.346558,141.413086 393.186920,141.711868 392.401855,142.017197
	C391.950378,142.402649 391.498901,142.788116 390.130402,143.067947
	C389.521759,142.978119 388.913147,142.888275 388.518494,142.055084
	C388.841980,141.078583 389.165497,140.102097 389.873383,138.838654
	C390.074799,138.542221 390.091248,138.235855 390.022095,137.133026
	C390.040283,136.094589 390.058502,135.056152 390.379547,133.417664
	C390.377472,132.975189 390.375427,132.532730 390.928131,131.625183
	C390.953033,129.692612 390.977966,127.760033 391.390442,125.253799
	C391.546448,124.819626 391.702484,124.385460 392.631714,123.852570
	C394.361237,121.077225 395.334381,118.363785 391.831848,115.115097
	C391.314209,110.051697 390.796600,104.988297 390.379059,99.188591
	C390.236084,98.464134 390.093140,97.739685 390.311127,96.149429
	C390.207428,92.434845 390.103760,88.720253 390.468170,84.531929
	C392.984741,81.365349 395.501343,78.198761 398.678009,74.927765
	C399.261475,74.027191 399.844910,73.126617 400.965271,71.853111
	C404.614624,67.502869 408.263977,63.152630 412.518127,58.790737
	C412.919403,58.170334 413.320679,57.549927 414.092834,56.797127
	C414.092834,56.797127 414.242096,56.432709 414.914429,56.273399
	C419.790131,49.683868 424.739471,43.145981 429.443665,36.436203
	C430.001312,35.640846 429.217773,33.905205 429.055878,32.605404
	C427.719147,32.958084 425.840088,32.870991 425.137299,33.737724
	C421.641479,38.048840 418.455353,42.611084 415.065521,47.082764
	C415.065521,47.082764 415.093018,47.173363 414.445190,47.248211
	C413.567932,48.447906 412.690674,49.647606 411.989838,50.950348
	C411.989838,50.950348 411.833710,50.818497 411.189545,50.992714
	C404.202454,58.872372 397.215363,66.752029 390.228271,74.631691
	C388.891479,69.018913 388.565491,64.242439 388.438141,59.460678
	C388.410400,58.419086 389.203369,57.381134 389.424591,56.301792
	C389.813446,54.404976 390.700775,52.299557 390.233063,50.596241
	C388.830322,45.487583 386.963531,40.496677 385.068298,35.539928
	C384.613831,34.351257 383.346252,33.473465 382.452637,32.452698
	C381.384064,33.485115 380.047302,34.353142 379.295532,35.579731
	C376.677368,39.851498 378.945251,44.147869 379.323669,48.501190
	C380.230164,58.928753 380.465729,69.413658 381.309631,79.848122
	C381.636688,83.891739 380.214447,86.741592 377.703247,89.699402
	C372.049408,96.358727 366.725403,103.298027 361.097504,110.125778
	C361.097504,110.125778 361.133698,110.291550 360.320374,110.321892
	C359.014557,109.853409 357.360321,109.739525 356.461792,108.856567
	C351.993408,104.465614 347.610260,99.974922 343.411469,95.325729
	C337.252411,88.505920 331.275421,81.521698 325.165466,74.243027
	C325.165466,74.243027 324.859528,74.037277 324.875458,73.334053
	C320.341858,66.566383 315.791443,59.809883 311.283691,53.025024
	C309.688477,50.623947 307.171265,48.395557 309.922028,45.096920
	C310.273743,44.675133 309.602753,42.791130 308.893066,42.204521
	C306.486328,40.215179 303.849487,38.504265 301.017212,37.002697
	C301.017212,37.002697 301.309509,36.694504 301.218933,36.057907
	C300.564453,35.553219 299.910004,35.048534 299.175171,34.094551
	C298.983887,33.843952 298.882782,33.561123 298.876434,32.443886
	C296.590759,32.221767 294.305084,31.999647 292.019409,31.777525
	C292.202881,33.202724 292.386353,34.627922 292.771149,36.659203
	C292.728394,37.077724 292.685608,37.496250 292.128693,38.016075
	C292.286987,38.707699 292.445282,39.399326 292.824036,40.707172
	C292.880951,41.138771 292.937836,41.570370 292.516205,42.363762
	C293.326599,42.916939 294.137024,43.470119 295.572113,44.206745
	C296.349243,44.533070 297.126343,44.859394 298.008392,45.627052
	C298.206299,45.870590 298.314819,46.148975 298.135040,47.148773
	C298.687225,47.784828 299.239380,48.420883 300.035553,49.422855
	C300.035553,49.422855 300.091675,49.859062 299.978851,50.609047
	C301.009827,52.060951 302.040833,53.512859 303.412476,55.033195
	C303.412476,55.033195 303.745758,55.131565 303.608490,55.770153
	C303.674408,56.199837 303.740326,56.629520 303.383118,57.441780
	C303.983002,57.939144 304.582916,58.436508 305.415405,59.112595
	C305.415405,59.112595 305.395355,59.405231 305.172913,60.137440
	C305.792206,60.753258 306.411469,61.369076 307.412567,62.062122
	C307.412567,62.062122 307.799652,62.105274 307.736328,62.787403
	C308.400146,63.675880 309.063965,64.564354 309.806793,65.969894
	C310.159027,66.337029 310.511230,66.704155 310.831146,67.741127
	C311.422424,68.363373 312.013702,68.985619 312.589783,69.892487
	C312.589783,69.892487 312.819611,70.061043 312.758881,70.722763
	C313.161957,71.505699 313.565033,72.288635 313.926819,73.783569
	C314.643524,74.509796 315.360199,75.236031 316.455200,76.046501
	C316.455200,76.046501 316.841125,76.082329 316.745941,76.688080
	C316.859344,77.080193 316.972778,77.472305 317.002106,78.625244
	C318.085175,79.705223 319.168213,80.785194 320.732208,82.038452
	C320.980621,82.468353 321.229034,82.898254 321.244812,84.095779
	C321.928955,84.678711 322.613068,85.261642 323.669312,85.868820
	C323.669312,85.868820 324.042175,85.864128 324.030457,86.523521
	C324.323456,87.109550 324.616425,87.695580 324.897125,88.931183
	C325.530273,89.689690 326.163452,90.448189 326.928833,91.924530
	C328.058777,92.893723 329.188721,93.862915 330.778534,95.162857
	C331.288025,95.936378 331.797546,96.709892 332.172302,98.252411
	C332.899475,98.717888 333.626678,99.183365 334.001221,99.997559
	C334.001221,99.997559 334.357330,99.652519 334.196503,100.372688
	C334.874603,100.874657 335.552704,101.376633 336.798859,102.199547
	C338.625641,104.305992 340.452423,106.412445 342.120575,109.125824
	C342.708191,109.551498 343.295776,109.977165 344.230927,110.302750
	C344.230927,110.302750 344.585144,110.229477 344.664185,110.883377
	C345.336456,111.364143 346.008698,111.844910 346.996338,112.001755
	C346.996338,112.001755 346.675537,112.320442 346.736023,112.967361
	C347.388885,113.487068 348.041718,114.006775 348.884338,115.060829
	C349.407654,115.821114 349.930969,116.581398 350.172699,118.252357
	C350.121002,119.512108 350.069305,120.771858 349.818878,122.636642
	C349.456146,123.377434 349.093414,124.118217 348.306763,125.018265
	C348.031281,125.199043 347.888794,125.454109 347.217041,125.989639
	C346.098999,127.970634 344.980988,129.951630 343.472778,131.968491
	C343.472778,131.968491 343.088470,132.044754 342.340546,132.096878
	C342.031586,132.914703 341.722656,133.732529 341.389709,135.067764
	C341.249573,135.380310 341.109436,135.692856 340.386292,136.031052
	C340.248779,136.684753 340.111267,137.338455 339.945923,138.671158
	C339.802399,139.098892 339.658875,139.526611 338.861938,140.209091
	C337.874939,142.169556 336.887970,144.130020 335.450714,146.085403
	C335.450714,146.085403 335.018158,145.960007 334.991364,145.279205
	C334.377899,144.495087 333.764404,143.710968 332.727966,142.588593
	C332.411072,142.151169 332.094177,141.713745 331.928772,140.547714
	C332.426392,139.707214 332.801422,138.757004 333.440399,138.043015
	C340.569458,130.076859 341.748169,122.819229 336.923492,113.199203
	C336.179047,111.714821 333.755463,110.217125 332.164520,110.274765
	C330.814392,110.323669 328.692535,112.464005 328.439697,113.940491
	C328.057739,116.171043 328.952240,118.639053 329.405334,120.986641
	C329.678345,122.401161 330.142914,123.778717 330.521393,125.172882
	C329.892883,125.366966 329.264343,125.561043 328.635834,125.755127
	C327.980103,123.365540 327.392181,120.954483 326.644440,118.594040
	C326.161133,117.068336 325.291016,114.305061 324.857544,114.355583
	C322.816040,114.593521 320.109894,115.056099 319.060028,116.482811
	C317.494202,118.610657 317.119202,121.614746 316.015778,124.042488
	C316.015778,124.042488 316.256042,124.223701 315.527588,124.162636
	C315.132965,124.888763 314.738342,125.614899 314.046112,125.992165
	C314.046112,125.992165 314.331390,126.350037 313.529297,126.188393
	C309.275543,126.870995 305.021759,127.553604 300.988708,128.004883
	C300.988708,128.004883 300.779449,128.246399 300.851288,127.438187
	C300.852844,125.194916 301.120483,122.909332 300.772583,120.721634
	C300.489471,118.941483 299.894531,116.714661 298.628113,115.759094
	C297.762817,115.106155 294.911682,115.744911 293.965240,116.757050
	C287.814362,123.334854 281.942200,130.173233 275.608307,137.266769
	C275.283905,137.329712 274.959534,137.392654 273.741882,137.174210
	C270.360779,137.461411 266.936127,138.216125 263.610626,137.906326
	C260.180389,137.586746 256.846680,136.231186 252.962158,135.240982
	C252.609970,134.887131 252.257782,134.533279 251.889832,133.419052
	C251.074127,133.058868 250.258423,132.698669 248.886078,132.216202
	C248.192490,131.597183 247.498917,130.978165 246.838425,129.565186
	C246.020615,129.176300 245.202789,128.787415 243.829010,128.170654
	C242.850647,127.180214 241.872269,126.189781 240.886093,124.422279
	C240.048340,124.087547 239.210602,123.752815 237.817047,123.299576
	C237.135315,122.670433 236.453568,122.041290 235.810089,120.603088
	C234.980576,120.232605 234.151062,119.862122 232.658417,119.374794
	C228.671875,116.403221 224.685333,113.431656 221.065704,109.733231
	C222.049011,107.509628 225.843948,105.091614 220.280487,103.201187
	C220.280487,103.201187 220.003067,102.982147 219.841553,102.194023
	C217.374542,101.911903 214.907547,101.629776 211.926910,101.390663
	C211.622177,101.244141 211.317429,101.097618 211.008102,100.374565
	C210.351166,100.208885 209.694214,100.043205 208.306061,99.904175
	C207.836456,99.999947 207.366852,100.095718 206.986633,99.944481
	C206.986633,99.944481 207.130035,99.724380 207.067673,98.924606
	C206.995956,97.857971 206.924255,96.791336 207.198181,95.206291
	C208.605133,94.348778 210.012100,93.491264 212.155136,92.818710
	C212.758408,92.182953 213.361679,91.547195 214.403091,90.546036
M553.000000,246.995117
	C553.000000,246.995117 552.737915,246.727661 552.115845,246.823517
	C552.396118,247.594986 552.676392,248.366455 553.615112,249.330063
	C554.064636,249.267410 554.514099,249.204773 555.478394,249.475861
	C556.659424,249.344864 557.840454,249.213882 559.802734,249.251114
	C560.862122,249.195023 561.921570,249.138931 563.408508,249.436401
	C564.283325,249.331665 565.158142,249.226929 566.695007,249.290054
	C567.144958,249.243225 567.594849,249.196411 568.651001,249.409256
	C569.073792,249.327194 569.496582,249.245132 570.451294,249.285980
	C570.624878,249.231445 570.798462,249.176895 571.405457,249.433609
	C573.815125,249.007477 574.281372,247.907333 571.973572,246.768845
	C570.467102,246.025726 568.589172,246.035507 566.425415,245.063492
	C565.848877,243.349350 565.272278,241.635208 565.133057,239.405136
	C565.489807,237.251999 565.846619,235.098877 566.431824,232.544434
	C566.549500,232.245682 566.556580,231.944351 567.029724,231.116074
	C567.944580,228.450211 569.587036,227.224243 572.617981,227.416687
	C576.923157,227.690033 581.263184,227.373749 585.578979,227.544907
	C586.913086,227.597809 589.154175,228.141907 589.386658,228.930710
	C591.310486,235.458008 596.190308,241.372482 593.775269,249.091034
	C599.660156,249.091034 605.442505,249.091034 611.148071,249.091034
	C608.201843,244.737793 604.961121,241.020096 602.961975,236.724533
	C600.459717,231.347916 598.978271,225.496353 597.054993,219.850189
	C593.311523,208.860077 589.619202,197.851913 585.758667,186.903076
	C585.262817,185.496887 583.890930,184.399567 582.924866,183.159149
	C581.901306,184.093048 580.386292,184.834412 579.932800,185.991699
	C576.676697,194.302399 573.636108,202.697556 570.146118,211.617523
	C570.017822,212.270325 569.889465,212.923141 569.180481,213.950668
	C568.214783,216.319778 567.249023,218.688873 565.948792,221.763977
	C564.872864,225.018036 563.796936,228.272079 562.189331,231.968964
	C561.309631,234.343140 560.429871,236.717300 559.129089,239.661209
	C557.776123,241.559219 556.423218,243.457230 554.470337,245.322556
	C553.893005,245.791595 553.315613,246.260635 553.000000,246.995117
M25.999466,247.000000
	C25.999466,247.000000 25.908567,246.902847 25.325699,246.909866
	C25.529974,247.644485 25.734249,248.379105 26.865376,249.317871
	C32.948616,249.263062 39.031860,249.208252 45.757870,249.205658
	C45.974586,248.565018 46.191299,247.924377 46.408009,247.283737
	C45.263966,247.145798 44.119926,247.007874 42.377686,246.581421
	C41.086536,245.096725 39.795391,243.612015 38.808315,241.389694
	C38.696846,240.881348 38.585377,240.372986 38.708973,239.108093
	C38.904217,237.535202 39.099461,235.962326 39.856148,234.018326
	C40.064915,232.967453 40.273682,231.916565 40.766499,230.266907
	C40.910133,229.621063 41.053768,228.975220 42.088524,228.085709
	C49.374630,228.412766 56.660732,228.739822 64.018578,229.686981
	C64.158066,230.077667 64.297562,230.468353 64.201401,231.508926
	C64.706734,232.452621 65.212067,233.396332 65.786217,234.994247
	C65.980255,235.619827 66.174294,236.245422 66.160950,237.479294
	C66.615639,238.148041 67.070328,238.816803 67.561523,240.005493
	C67.673683,240.332993 67.785843,240.660492 67.587532,241.552353
	C67.587532,244.029724 67.587532,246.507080 67.587532,249.103348
	C73.197815,249.103348 78.877640,249.103348 84.557465,249.103348
	C84.709694,248.652298 84.861923,248.201263 85.014153,247.750214
	C83.639320,246.919983 82.264496,246.089752 80.492279,244.728638
	C79.790489,243.877853 79.088699,243.027069 78.563690,241.595398
	C78.068291,241.030960 77.572884,240.466522 76.986229,239.289307
	C76.823822,238.911591 76.661423,238.533859 76.696068,237.552795
	C76.235802,236.912750 75.775528,236.272690 75.234993,234.984787
	C75.035233,234.365250 74.835472,233.745728 74.849754,232.392838
	C73.740868,229.760971 72.631981,227.129089 71.509781,223.987305
	C71.405228,223.665619 71.300682,223.343918 71.498810,222.480484
	C70.899101,220.614029 70.369888,218.721375 69.687500,216.885651
	C66.730522,208.931030 63.728821,200.993011 60.697796,192.399323
	C60.545605,191.995956 60.393414,191.592590 60.507542,190.497849
	C59.945564,188.766663 59.600552,186.916916 58.742760,185.347397
	C58.201275,184.356613 56.893532,183.784622 55.929489,183.024780
	C55.198975,184.084152 54.468464,185.143539 53.442722,186.774826
	C53.357208,187.194153 53.271690,187.613464 52.669430,188.238449
	C52.402615,189.164093 52.135799,190.089737 51.634182,191.474106
	C51.571522,191.810577 51.508858,192.147049 50.873676,192.842026
	C50.562630,193.885773 50.251579,194.929504 49.541225,196.557419
	C48.949341,198.265182 48.357460,199.972931 47.233063,201.991791
	C47.049496,202.713211 46.865929,203.434616 46.332039,204.754425
	C46.168922,205.426437 46.005810,206.098450 45.280949,207.012299
	C45.111629,207.728989 44.942314,208.445663 44.401421,209.850052
	C43.193043,213.128952 41.984665,216.407852 40.206787,220.036606
	C39.928097,221.060669 39.649410,222.084717 39.031357,223.785995
	C35.399574,231.020691 31.767790,238.255386 27.544376,245.390778
	C26.998587,245.895020 26.452795,246.399261 25.999466,247.000000
M360.997192,288.985657
	C360.997192,288.985657 361.166656,288.829102 361.085419,289.408356
	C361.703461,289.700043 362.321472,289.991730 363.595428,290.359741
	C364.018341,290.477692 364.441254,290.595642 365.233124,291.268921
	C366.601135,291.389648 368.012360,291.753967 369.317902,291.522491
	C369.918823,291.415894 370.312775,290.142212 370.800568,289.397736
	C370.055511,289.030151 369.310486,288.662567 368.068298,288.118195
	C367.714844,287.740845 367.361389,287.363525 366.967377,286.340668
	C366.317841,285.890503 365.668335,285.440338 364.517975,284.541748
	C362.876465,281.704559 361.234955,278.867371 360.340485,275.984131
	C361.221771,274.979004 362.103027,273.973877 363.227875,272.417053
	C363.840881,271.620300 364.453888,270.823547 365.688507,269.934479
	C365.845825,268.966705 366.003113,267.998932 366.046997,266.352722
	C366.064514,265.895447 366.082031,265.438202 366.561462,264.658569
	C366.049805,264.100891 365.538116,263.543243 364.552338,262.607605
	C363.694275,262.091278 362.836212,261.574951 361.943390,260.485596
	C361.296906,260.304108 360.650391,260.122620 359.153717,259.912537
	C356.790436,260.173309 354.427155,260.434082 351.210693,260.798004
	C349.781372,260.744385 348.352051,260.690765 346.461304,260.147583
	C345.405579,260.555634 344.349884,260.963715 343.294159,261.371796
	C344.236450,262.038483 345.178711,262.705200 346.567139,263.821625
	C346.701477,264.216278 346.835846,264.610931 346.417725,265.618256
	C346.596619,272.409363 346.775543,279.200500 346.901031,286.633148
	C346.259827,287.416290 345.618591,288.199463 344.404388,288.924225
	C344.112000,289.362732 343.819641,289.801239 343.527283,290.239716
	C344.011536,290.195129 344.495819,290.150543 345.871521,290.302795
	C348.601898,290.315491 351.332245,290.328156 354.508545,290.721405
	C354.925415,290.191559 355.342285,289.661713 355.759125,289.131866
	C355.066437,288.867432 354.373779,288.602966 353.115295,287.809570
	C352.808197,284.909180 352.501099,282.008759 352.865387,279.022369
	C353.309631,278.949493 353.753876,278.876617 354.759460,279.201416
	C356.327454,281.617340 357.895477,284.033295 359.253052,287.172516
	C359.893951,287.728485 360.534821,288.284485 360.997192,288.985657
M493.416901,457.688171
	C493.248413,457.742004 493.079895,457.795837 492.176361,457.645630
	C490.381836,457.719482 488.587280,457.793304 486.155792,457.495850
	C485.934418,457.389099 485.713043,457.282349 485.491272,456.357117
	C485.809784,452.672089 486.128296,448.987030 487.021332,445.539856
	C488.661713,447.012482 490.302094,448.485107 492.829346,450.753906
	C492.829346,447.009766 492.829346,443.987152 493.206116,440.623962
	C492.830780,440.032532 492.455414,439.441132 491.472198,438.661255
	C491.254364,439.011200 491.036499,439.361115 490.271179,439.988892
	C489.850464,440.660461 489.429749,441.332062 489.000000,442.000000
	C489.000000,442.000000 489.002563,442.009827 488.134949,442.063232
	C487.063904,441.222626 485.282928,440.548065 485.040955,439.513550
	C483.793182,434.179169 484.985931,433.043274 492.726440,432.540070
	C494.685516,434.034698 496.644623,435.529297 499.535126,437.734528
	C499.377319,435.431854 499.296234,434.248627 499.510681,432.576904
	C498.656403,431.508789 497.802124,430.440643 496.155609,429.133392
	C494.780975,429.165405 493.406342,429.197449 491.145233,428.987000
	C488.394531,429.126587 485.643829,429.266205 482.140991,429.242310
	C480.857727,429.204376 479.574432,429.166473 477.647430,428.948273
	C475.123077,432.311096 479.516724,433.830505 479.568420,437.354462
	C479.607086,443.086029 479.645752,448.817596 479.182343,454.895386
	C478.961639,455.640930 478.740936,456.386475 477.996002,457.389832
	C477.667542,457.598633 477.339081,457.807434 476.359070,458.014374
	C477.023285,458.927368 477.633118,460.582581 478.360321,460.635834
	C484.133911,461.058899 489.928925,461.254089 495.719635,461.321503
	C496.810150,461.334198 497.910919,460.464966 499.564911,459.627014
	C499.798431,458.544952 500.031952,457.462921 500.733307,456.159729
	C500.821838,455.441406 500.910370,454.723053 501.181763,453.498657
	C501.106873,453.335693 501.031982,453.172729 501.055206,452.433380
	C500.071320,452.960388 499.087433,453.487396 497.731110,454.503937
	C497.187134,455.112640 496.643188,455.721344 495.537262,456.302155
	C495.007080,456.774719 494.476868,457.247253 493.416901,457.688171
M144.520035,94.666756
	C144.529404,93.724396 144.538773,92.782028 144.619064,91.149254
	C144.204544,89.597496 143.790024,88.045746 143.681168,85.825935
	C143.116257,85.219986 142.551346,84.614029 141.749435,83.730965
	C141.749435,83.730965 141.579041,83.408569 141.727554,82.699081
	C140.419128,81.948547 139.110687,81.198013 137.802261,80.447479
	C137.192047,81.675163 136.594772,82.909515 135.967316,84.128319
	C135.503937,85.028404 135.001205,85.908226 134.302017,86.211510
	C134.246414,85.800560 134.190826,85.389610 134.609161,84.585899
	C133.644165,83.475822 132.679169,82.365753 131.714172,81.255676
	C130.811752,82.170837 129.909317,83.085999 129.000610,84.000504
	C129.000610,84.000504 129.002426,84.007370 128.326065,84.034607
	C126.838249,84.340668 125.316681,84.537811 123.872650,84.985199
	C122.578758,85.386063 120.276695,86.108482 120.297813,86.609947
	C120.460236,90.467094 121.080765,94.304947 121.801865,98.774612
	C122.167480,99.586884 122.533104,100.399162 122.897156,101.903961
	C123.860611,102.648643 124.824074,103.393326 125.874138,104.096619
	C125.874138,104.096619 125.888977,104.191452 125.995094,104.797440
	C127.354652,104.250580 128.714218,103.703720 130.474777,102.656578
	C131.290955,101.417976 132.107132,100.179375 133.479492,99.005608
	C133.665771,98.993752 133.852036,98.981903 134.744965,99.165390
	C139.366028,102.122215 141.358353,101.316895 143.450470,95.840157
	C143.587021,95.557877 143.723557,95.275597 144.520035,94.666756
M514.712830,457.711426
	C514.712830,457.711426 514.326538,457.862427 514.087341,457.440765
	C514.087341,457.440765 513.722961,457.121033 513.829407,456.295929
	C513.417236,454.062836 513.005127,451.829712 512.631958,449.195923
	C512.644836,448.926941 512.632690,448.659088 513.094238,448.019684
	C513.186890,447.250214 513.279541,446.480774 513.706543,445.515076
	C513.706543,445.515076 513.889587,445.173370 514.676453,445.455658
	C516.412659,446.576569 518.148804,447.697449 519.603210,449.362762
	C519.970581,450.018097 520.338013,450.673462 520.722046,451.900024
	C520.815430,452.268463 520.908813,452.636871 520.664978,453.337921
	C520.859131,453.875397 521.053284,454.412872 521.241699,455.706818
	C521.715637,460.809845 525.536377,460.203949 529.387024,460.711548
	C530.140869,460.342865 530.894775,459.974182 531.648621,459.605499
	C531.103760,459.062286 530.558838,458.519073 529.391541,457.637604
	C528.384216,455.816528 527.376892,453.995453 526.661194,451.542755
	C526.189331,450.596893 525.717529,449.651062 525.099182,448.065338
	C524.363403,446.991577 523.627686,445.917847 523.272827,444.701294
	C523.441833,444.412079 523.388733,444.171631 523.759949,443.599274
	C524.939941,441.840363 526.119873,440.081451 527.822937,438.070038
	C527.615967,436.967682 527.408997,435.865356 527.132568,434.043579
	C525.681335,430.305267 522.736023,428.814972 518.951355,428.817963
	C514.647888,428.821350 510.344513,428.989410 505.401703,428.958069
	C505.553864,429.703247 505.706024,430.448395 506.139557,431.526093
	C506.337311,431.739716 506.550323,431.936829 506.860626,433.036102
	C506.963776,441.048737 507.066956,449.061401 506.854797,457.430084
	C506.854797,457.430084 506.646942,457.857819 506.262177,457.707947
	C506.262177,457.707947 505.881897,457.868958 505.141602,457.885681
	C505.542694,458.892334 505.864532,460.706390 506.359711,460.754974
	C507.875305,460.903748 509.457520,460.374359 511.747284,460.216705
	C512.487244,460.197266 513.227173,460.177826 514.337891,460.631653
	C515.106812,460.109619 515.875732,459.587585 516.644653,459.065582
	C516.125916,458.672882 515.607117,458.280212 514.712830,457.711426
M583.529419,369.680939
	C583.174622,369.513184 582.819885,369.345428 582.377258,368.608368
	C581.842285,367.825562 581.307251,367.042755 580.874695,365.552246
	C578.512878,363.426575 576.151123,361.300873 573.235291,358.845886
	C571.391785,357.006927 569.548279,355.167969 567.854614,352.520325
	C567.369690,350.282318 566.884827,348.044342 566.096436,344.405457
	C576.118286,339.650757 586.505554,334.650208 597.001709,329.889709
	C597.784058,329.534882 599.346741,330.900543 600.357666,331.972961
	C600.173889,332.282318 599.990173,332.591675 599.095032,333.050842
	C596.049011,336.791290 597.078308,340.885986 598.320496,344.848602
	C598.694092,346.040527 600.017822,347.539612 601.111633,347.732269
	C602.225708,347.928497 604.186523,347.024323 604.751709,346.023315
	C608.162659,339.982727 611.844482,333.989777 614.283142,327.544830
	C615.750000,323.668304 616.569763,318.603363 611.152832,315.846375
	C611.152832,315.846375 611.155273,315.749634 611.028015,315.023804
	C607.502075,311.915710 604.097168,312.302582 600.204712,315.609589
	C599.793701,315.671173 599.382690,315.732788 598.558716,315.340698
	C597.712280,315.903168 596.865784,316.465607 595.507263,317.250641
	C595.143677,317.326843 594.780029,317.403046 593.709961,317.194519
	C592.805359,317.792145 591.900696,318.389801 590.489319,319.205475
	C590.132385,319.292358 589.775391,319.379242 588.782288,319.197845
	C588.149231,319.714813 587.516113,320.231781 586.386719,321.000854
	C586.031555,321.106293 585.676331,321.211731 584.588806,321.121155
	C583.059326,322.079071 581.529846,323.037018 579.527344,324.278778
	C579.181091,324.400635 578.834778,324.522522 577.840027,324.336395
	C577.229248,324.892578 576.618408,325.448792 575.427979,326.324585
	C573.602173,327.497559 571.776367,328.670502 569.234863,329.864227
	C566.969604,331.078217 564.704346,332.292206 561.767334,333.266113
	C561.192017,333.862396 560.616638,334.458649 559.558533,335.367798
	C559.026306,335.885162 558.494141,336.402557 557.302124,336.979858
	C556.737793,337.597382 556.173462,338.214905 555.200256,338.994781
	C555.200256,338.994781 555.053833,339.409637 554.388916,339.578674
	C550.603394,344.361969 551.037964,349.404114 554.650696,353.713837
	C563.151611,363.854950 572.105286,373.615387 580.732117,383.653320
	C581.983215,385.109070 582.443359,387.244690 582.298218,389.044647
	C569.167114,389.125061 556.035950,389.205444 542.473877,388.791534
	C541.645447,388.578064 540.817078,388.364594 539.750427,387.832397
	C539.750427,387.832397 539.352661,387.840973 538.966125,387.148712
	C538.101562,384.378357 536.519409,381.616241 536.487366,378.836304
	C536.258911,359.020477 536.389709,339.200775 536.281677,319.382996
	C536.267578,316.791107 535.544006,314.203094 535.148987,311.613281
	C534.566162,311.552399 533.983337,311.491486 533.400574,311.430603
	C531.449646,315.851074 525.803772,318.035583 526.370789,325.020721
	C526.468811,343.795685 526.566772,362.570679 526.192017,381.740601
	C526.035950,382.506561 525.879822,383.272522 525.214539,384.482849
	C525.156555,384.700562 525.098572,384.918274 524.344543,385.312531
	C521.259033,386.620697 518.173523,387.928833 514.183655,389.075104
	C511.431061,389.119415 508.678497,389.163727 505.515717,388.598907
	C503.940796,385.492432 502.365875,382.385956 500.233368,378.179688
	C497.593536,380.545563 495.170319,382.717316 492.187653,385.196899
	C490.797577,386.193726 489.407532,387.190582 487.318115,388.036102
	C486.248230,388.456238 485.178314,388.876343 483.202179,389.124146
	C480.439423,389.171753 477.676697,389.219360 474.499847,388.748688
	C473.661133,388.559631 472.822449,388.370575 471.526794,387.783875
	C470.785553,387.476105 470.044342,387.168365 469.094604,386.202972
	C465.862640,381.688721 462.631042,377.174194 459.398590,372.660309
	C455.880615,367.747742 453.055267,366.988770 447.819885,369.637604
	C447.554199,369.834656 447.288513,370.031708 446.383087,370.236908
	C445.022919,371.504364 443.662750,372.771790 441.738159,374.358521
	C440.735443,375.703369 439.732758,377.048218 438.095947,378.715027
	C435.704590,383.793945 433.313232,388.872833 430.372131,394.004639
	C430.188629,394.664001 430.005127,395.323334 429.716125,396.594604
	C429.404816,397.357056 429.093475,398.119476 428.114227,399.047211
	C427.950562,399.843109 427.786896,400.639038 427.371826,402.048950
	C426.376282,403.190552 425.380737,404.332184 423.681549,405.245209
	C421.988129,405.319092 420.294708,405.392975 418.085693,405.171539
	C417.585480,404.571838 417.085297,403.972137 416.775879,402.570709
	C415.850311,395.611267 414.842957,388.661224 414.041412,381.687531
	C413.742218,379.084473 414.210907,376.381805 413.813080,373.804260
	C413.305542,370.515625 411.202240,369.852783 409.001038,372.001221
	C409.001038,372.001221 408.972107,371.984283 408.304749,372.024353
	C408.207123,373.349884 408.109497,374.675446 407.976776,376.768921
	C407.850952,377.785217 407.725128,378.801514 406.906982,380.160034
	C407.174561,385.488281 407.442108,390.816498 407.867920,396.752625
	C407.915436,397.168182 407.962952,397.583740 407.538910,398.444092
	C409.318542,402.320984 411.098145,406.197906 413.098267,410.394348
	C413.098267,410.394348 413.239502,410.756042 413.062805,411.499786
	C414.042084,416.036499 417.543610,417.938751 421.482635,418.862488
	C425.893066,419.896729 429.235474,417.901733 431.379852,413.958496
	C432.404266,412.074646 433.431458,410.185150 434.317810,408.234802
	C436.577911,403.261658 438.581665,398.164307 441.013855,393.278839
	C444.763062,385.747925 449.236786,383.238220 455.293274,385.238495
	C455.293274,385.238495 455.436707,385.577698 455.186340,386.293732
	C456.145752,387.514526 457.105133,388.735291 458.299866,390.235352
	C458.299866,390.235352 458.415802,390.581604 458.178558,391.271088
	C458.797913,391.838562 459.417267,392.406006 460.290253,393.262451
	C460.290253,393.262451 460.490631,393.590637 460.244873,394.276703
	C460.738068,395.088348 461.088745,396.045563 461.746307,396.689240
	C468.933838,403.724884 478.414154,404.757172 486.888916,402.435150
	C493.516357,400.619232 498.674255,401.505585 504.964966,402.550781
	C513.517639,403.971863 523.078247,404.965576 529.340942,397.187805
	C532.980408,399.329376 535.987976,402.567200 539.113892,402.685730
	C553.050964,403.214233 567.026917,403.056335 580.978210,402.714325
	C586.947083,402.567993 593.522217,396.826904 594.523987,391.134338
	C595.341309,386.489899 594.275513,382.017273 589.676208,378.511749
	C589.291260,377.820435 588.906250,377.129120 588.790710,375.759918
	C588.181824,375.181854 587.572998,374.603790 586.705200,373.765350
	C586.705200,373.765350 586.557434,373.429230 586.794861,372.740845
	C585.881409,371.815125 584.967896,370.889435 583.529419,369.680939
M417.301636,433.485046
	C417.807648,434.086426 418.313660,434.687775 418.806549,435.966400
	C418.937836,436.628906 419.069092,437.291382 418.895996,438.853271
	C417.421722,445.711426 422.182037,453.642059 414.403534,459.823212
	C419.098328,459.823212 422.828918,459.823212 427.471100,459.823212
	C421.950439,454.972565 420.713470,445.732819 424.421234,441.904236
	C428.505096,447.351074 432.588928,452.797943 436.917755,458.944733
	C438.739502,460.446808 440.350403,460.702240 440.547882,457.783844
	C440.700409,455.530487 440.316925,453.240875 440.318970,450.124695
	C440.313141,448.416504 440.307312,446.708313 440.687897,444.294586
	C441.393951,439.250519 438.679749,433.196716 445.539215,429.625214
	C441.608673,429.022400 438.222015,428.911438 434.860565,429.152405
	C434.402191,429.185272 433.686859,431.812164 433.733337,431.833435
	C439.512085,434.478271 436.598999,439.622498 437.029572,443.690094
	C437.124084,444.582825 435.554443,445.651703 434.490784,445.985657
	C430.466003,440.907684 426.441223,435.829742 422.265625,430.078217
	C421.482483,429.862183 420.699310,429.646118 419.228088,429.209808
	C418.510223,429.246002 417.792389,429.282196 416.414978,429.034271
	C415.712189,429.507935 415.009399,429.981567 414.306610,430.455231
	C415.246094,431.219025 416.185608,431.982819 417.109985,432.894226
	C417.109985,432.894226 417.257599,432.879333 417.301636,433.485046
M329.773376,454.990295
	C329.633667,453.918457 329.493958,452.846619 329.354248,451.774780
	C328.553406,452.509949 327.752533,453.245148 326.722290,454.326447
	C326.722290,454.326447 326.744415,454.741119 326.181793,454.960175
	C325.726959,455.593933 325.272125,456.227692 324.161133,456.971069
	C323.112762,457.286255 322.064423,457.601471 320.314606,457.636688
	C318.492920,457.629730 316.671265,457.622772 314.468994,457.106903
	C314.002777,456.405914 313.536591,455.704895 313.453888,454.336212
	C313.928162,451.399780 314.402435,448.463318 315.623535,445.717072
	C317.377960,447.147614 319.132385,448.578125 321.821655,450.770905
	C321.568665,446.153107 321.368866,442.506409 320.999084,438.334747
	C320.644897,438.543304 320.290680,438.751892 319.534332,439.438538
	C318.698364,440.360657 317.862366,441.282776 316.146179,442.225769
	C315.288025,440.881531 314.078400,439.636475 313.663940,438.167114
	C313.185272,436.470032 313.407410,434.575256 313.622314,432.735779
	C313.622314,432.735779 313.796356,432.493073 314.715302,432.623932
	C320.449554,430.720337 324.078308,434.868164 328.152252,438.401733
	C329.175598,430.445984 327.976501,428.959961 321.329132,428.957428
	C318.859161,428.956482 316.389099,429.175018 313.081299,429.153778
	C310.796936,429.153778 308.512573,429.153778 305.294739,429.153778
	C306.512543,431.109039 307.061859,431.991058 307.454254,433.814026
	C307.403534,441.568970 307.352783,449.323883 306.840210,457.343506
	C306.550598,457.548370 306.260986,457.753235 305.246613,457.948151
	C305.563049,458.874084 305.840820,460.578094 306.202393,460.596039
	C308.138702,460.692322 310.095947,460.368164 312.747742,460.380219
	C313.472198,460.385956 314.196625,460.391693 315.307159,460.991119
	C318.085297,461.128876 320.868561,461.201538 323.640350,461.419922
	C327.593933,461.731476 329.663422,460.249084 329.264343,455.665344
	C329.264343,455.665344 329.244263,455.256012 329.773376,454.990295
M88.104385,428.653595
	C86.665085,429.385712 85.225784,430.117798 83.168404,431.104523
	C81.627457,433.239685 80.086510,435.374847 78.000648,437.987701
	C75.928162,442.904968 75.381927,447.756042 78.789093,453.111908
	C81.734901,455.492950 84.680710,457.873993 88.001717,460.862152
	C93.375397,462.793182 97.254387,460.139343 100.552322,456.445801
	C101.659523,455.205750 101.948410,453.235077 103.023651,450.580322
	C98.374054,453.687836 95.185196,455.819092 91.277779,457.795929
	C85.765755,456.951080 84.849503,452.251221 83.550064,447.296783
	C83.453033,444.807983 83.356003,442.319153 83.626472,439.169647
	C84.707520,436.995575 85.788559,434.821503 87.488487,432.707184
	C88.332169,432.108704 89.175842,431.510193 90.769318,430.951416
	C91.519859,430.977478 92.270393,431.003571 93.379761,431.451141
	C94.054573,431.651642 94.729385,431.852173 95.465752,432.656769
	C95.625992,432.780609 95.786240,432.904419 96.077805,433.730408
	C96.927879,435.274048 97.660194,436.902100 98.679779,438.324249
	C99.159592,438.993530 100.191589,439.266968 100.973381,439.719757
	C101.252815,438.788940 101.532242,437.858093 101.873558,436.126373
	C101.751663,434.796173 101.629776,433.465973 101.818375,431.382568
	C99.894386,427.093811 95.845070,430.202271 92.238472,428.693176
	C91.105713,428.732056 89.972954,428.770966 88.104385,428.653595
M348.997559,33.002136
	C348.997559,33.002136 348.854034,33.152542 348.850403,32.399269
	C344.783722,30.118500 343.194611,30.564480 343.096069,34.772621
	C345.098663,37.699562 347.014008,40.692245 349.145752,43.521900
	C350.030151,44.695801 351.377014,45.521252 352.211578,47.310593
	C352.170288,50.243134 352.128967,53.175671 352.012024,56.534393
	C352.012024,56.534393 351.830750,56.927452 351.084930,57.131973
	C350.671936,60.004738 350.258942,62.877502 349.850311,65.832558
	C349.850311,65.832558 349.774689,65.865250 349.099304,66.040253
	C348.540253,67.524170 347.348816,69.088806 347.526184,70.478722
	C348.567444,78.636238 349.792877,86.778275 351.304169,94.860458
	C351.581146,96.341599 353.458527,97.523460 354.597168,98.843475
	C355.572052,97.091278 356.546906,95.339073 357.571991,92.771408
	C357.527985,90.326698 357.483978,87.881981 357.786224,84.610237
	C357.087433,82.068695 356.388672,79.527153 355.576660,76.476212
	C355.531586,76.131401 355.486511,75.786598 355.778625,74.650673
	C356.036011,72.168907 353.239960,69.041710 358.349854,67.705055
	C361.450867,66.893883 364.685089,64.275620 366.357697,61.548203
	C366.961548,60.563530 363.228638,56.858063 361.366791,54.478645
	C361.029449,54.047539 360.167572,54.026878 359.286896,53.182293
	C359.373871,52.511913 359.460846,51.841534 360.049713,51.012402
	C360.026825,50.340908 360.003906,49.669411 359.925629,48.250183
	C359.943817,47.501247 359.961975,46.752312 360.518768,45.633274
	C360.704468,44.093052 360.890137,42.552826 361.146240,40.325787
	C361.772919,39.410023 362.399597,38.494263 363.479828,37.835640
	C363.638245,37.907070 363.796692,37.978504 364.214966,38.707600
	C365.659363,38.914223 367.103729,39.120846 368.548157,39.327469
	C368.521881,38.109699 368.495605,36.891933 368.265961,35.100830
	C367.835419,34.418041 367.404846,33.735249 366.890839,32.270802
	C364.070587,30.656044 361.282654,29.299608 358.915161,33.999928
	C358.594513,34.731178 358.273865,35.462425 357.529602,36.539974
	C357.478485,37.628956 357.427399,38.717937 356.921204,40.321590
	C356.291595,40.540604 355.661957,40.759617 354.632965,40.461941
	C353.329865,38.752918 352.026764,37.043896 350.840485,34.629082
	C350.175964,34.134518 349.511444,33.639954 348.997559,33.002136
M521.425598,266.497803
	C522.294434,265.359192 523.163330,264.220581 524.845886,263.051605
	C526.140625,263.198792 527.435303,263.345978 528.686707,264.366882
	C528.700500,271.881989 528.714233,279.397064 528.265381,287.411896
	C527.277405,287.924042 526.289429,288.436188 525.301453,288.948334
	C525.628662,289.353271 525.955872,289.758179 526.283081,290.163086
	C529.692505,290.163086 533.101929,290.163086 537.729126,290.163086
	C535.763367,288.585358 534.783142,287.798645 533.764954,286.073883
	C533.709778,278.711273 533.654602,271.348694 534.279358,263.594360
	C536.416748,264.183014 538.664185,264.534698 540.647705,265.455017
	C541.725952,265.955292 542.355713,267.422119 543.187805,268.452972
	C543.615479,267.025085 544.242188,265.619995 544.409180,264.162262
	C544.548035,262.950409 544.146423,261.676636 543.906921,259.836121
	C539.673462,260.343719 535.828735,260.804718 531.307312,261.154266
	C531.085144,261.208405 530.863037,261.262512 530.639404,261.351166
	C530.639404,261.351166 530.671021,261.351044 530.149170,260.845032
	C527.406189,260.827515 524.663269,260.809967 521.132141,260.493042
	C520.405029,261.659546 519.677979,262.826080 518.597656,264.549469
	C518.836182,265.827942 519.074707,267.106415 519.313293,268.384918
	C519.914795,267.939178 520.516235,267.493469 521.425598,266.497803
M384.143280,431.966400
	C384.623901,432.142548 385.104523,432.318695 386.046783,432.934509
	C387.338898,434.636963 388.631012,436.339417 389.942139,438.729584
	C390.871002,438.954895 391.799866,439.180237 392.728729,439.405579
	C392.570496,438.167603 392.412292,436.929596 392.277710,434.847107
	C393.068512,429.804169 388.691162,431.011414 386.081024,429.356293
	C385.392975,429.225433 384.704956,429.094574 383.464783,428.786194
	C383.079803,428.775391 382.694855,428.764618 382.041382,428.244507
	C380.917053,428.406311 379.792694,428.568115 377.996338,428.708069
	C377.341309,428.842743 376.686249,428.977417 375.369720,429.002319
	C374.512085,429.606995 373.654449,430.211639 372.245239,431.053131
	C371.502106,431.711761 370.758972,432.370392 369.393677,433.119659
	C369.036102,433.791626 368.678528,434.463623 368.078430,435.508057
	C368.078430,435.508057 367.945068,435.932037 367.267334,436.125793
	C364.491150,441.114227 363.140991,446.165741 366.732544,452.095398
	C368.483032,454.067566 370.233521,456.039734 372.110992,458.616760
	C372.800201,458.878418 373.489410,459.140076 374.830292,459.719055
	C375.768463,459.942505 376.706635,460.165955 377.993042,460.985931
	C384.627197,462.089905 391.576416,458.643982 392.518036,453.992065
	C393.101746,451.108368 394.130066,448.314667 395.015503,445.286713
	C391.755249,443.276703 385.090179,443.593140 382.757660,445.909515
	C383.977417,447.559296 385.831390,449.006775 386.197296,450.764069
	C387.223328,455.691467 385.628784,457.008423 378.127289,457.469513
	C375.921814,454.363464 373.716339,451.257416 371.800201,447.276855
	C371.658234,445.458557 371.516266,443.640228 371.616425,441.226868
	C371.647491,440.801056 371.678558,440.375214 372.192322,439.563293
	C372.215729,438.977997 372.239136,438.392731 372.716827,437.217529
	C374.257050,435.300049 375.797302,433.382568 378.028717,431.428711
	C380.008453,431.441040 381.988220,431.453400 384.143280,431.966400
M456.637390,442.413574
	C456.637390,442.413574 456.430298,442.220825 456.697388,441.310791
	C456.648773,438.471954 456.600159,435.633087 456.718079,432.707764
	C456.718079,432.707764 456.760681,432.525024 457.669617,432.588623
	C463.125885,431.486084 467.065430,434.122375 470.290833,438.592041
	C472.832916,431.668884 471.225189,428.912048 465.242004,428.897797
	C462.450531,428.891144 459.658417,429.155396 456.031525,429.211426
	C454.349609,429.181915 452.667664,429.152405 450.579224,428.736511
	C449.596100,429.033386 448.612976,429.330231 447.629852,429.627106
	C448.388123,430.451538 449.146393,431.275970 450.257660,432.553162
	C450.542389,433.043701 450.827148,433.534210 450.715424,434.551239
	C450.872589,436.022827 451.029724,437.494385 451.151581,439.904144
	C451.068146,445.235901 450.984711,450.567627 450.339233,456.072906
	C449.848083,456.665527 449.356903,457.258148 448.864990,457.911560
	C448.864990,457.911560 448.923309,457.928711 448.212372,457.924042
	C446.457764,460.314880 448.047302,460.590759 449.948700,460.669678
	C455.098328,460.883301 460.246399,461.215149 465.397919,461.281097
	C471.922607,461.364594 473.911133,458.448578 472.032776,451.886322
	C463.547516,457.619873 463.547516,457.619873 457.306458,457.216278
	C456.986786,456.845581 456.667114,456.474915 456.583160,455.203705
	C456.558289,452.082306 456.533386,448.960938 457.377533,445.634216
	C457.969666,445.578674 458.561768,445.523102 459.422882,446.024109
	C459.973969,446.246094 460.525024,446.468048 461.271179,447.076538
	C461.271179,447.076538 461.606934,447.349884 461.583588,448.064087
	C462.486816,448.854736 463.390015,449.645416 464.293274,450.436096
	C464.301117,449.273254 464.308960,448.110382 464.373779,446.179962
	C464.359619,444.898682 464.345459,443.617432 464.859528,442.054871
	C464.552460,441.068939 464.245422,440.083038 463.238586,438.960236
	C462.193268,440.131317 461.147949,441.302399 459.264496,442.310059
	C458.420105,442.433502 457.575745,442.556946 456.637390,442.413574
M54.203720,442.982605
	C54.014431,443.704407 53.825142,444.426239 53.348732,445.880432
	C51.415272,450.446564 49.481812,455.012695 47.200413,460.400513
	C50.220058,459.838226 53.793953,462.572449 58.081493,458.867096
	C51.146042,456.248901 55.274654,452.708649 56.090485,449.369080
	C58.196056,449.129578 60.155396,448.906708 62.804127,448.923523
	C63.665161,451.805817 64.526192,454.688141 64.710205,457.538574
	C64.030678,458.501373 63.351154,459.464203 62.671635,460.427002
	C63.785580,460.353607 64.899521,460.280182 66.883995,460.164520
	C68.914970,460.211426 70.945953,460.258362 73.013382,460.869446
	C73.866951,460.583191 74.720512,460.296936 75.574081,460.010651
	C74.804482,459.256927 74.034882,458.503235 72.716530,457.404510
	C72.227684,456.705841 71.738838,456.007202 71.543892,454.728088
	C71.076935,454.112976 70.609978,453.497833 69.950966,452.169586
	C69.699501,451.219666 69.448036,450.269745 69.541130,448.756958
	C69.085556,448.121552 68.629982,447.486115 68.021431,446.198669
	C67.849045,445.551941 67.676659,444.905212 67.786125,443.607330
	C67.281296,442.666687 66.776474,441.726013 66.125435,440.140411
	C65.937172,439.506836 65.748901,438.873230 65.834534,437.649506
	C65.379967,436.992218 64.925400,436.334930 64.295113,434.948792
	C63.477627,432.877228 62.660137,430.805634 61.241505,427.210724
	C59.832760,430.005524 59.162560,431.335114 57.916458,432.879150
	C57.680332,433.615906 57.444206,434.352661 56.953579,435.777710
	C56.223885,438.090576 55.494190,440.403442 54.203720,442.982605
M52.798298,265.946075
	C53.852440,264.432007 54.906578,262.917969 56.848843,260.128296
	C52.613239,260.128296 49.746346,259.832794 46.974380,260.218872
	C44.625938,260.545929 44.497120,261.933136 46.957882,263.630096
	C47.256195,264.078247 47.554508,264.526398 47.514820,265.584198
	C47.733719,270.999268 48.119907,276.414368 48.118729,281.829407
	C48.117783,286.182892 45.731323,288.609222 41.240997,288.245483
	C38.836403,288.050720 36.471569,287.365082 33.618629,286.468872
	C33.471073,286.070618 33.323513,285.672394 33.473373,284.717865
	C33.050503,284.082336 32.627628,283.446838 32.191288,281.898682
	C32.179192,280.066956 32.042580,278.225830 32.179790,276.405365
	C32.509693,272.028290 32.967968,267.660919 34.038002,263.276733
	C34.476044,262.430847 34.914085,261.584991 35.352119,260.739105
	C34.233913,260.787048 33.115707,260.834991 31.248684,260.843018
	C30.499926,260.877808 29.751167,260.912628 28.519232,260.426056
	C27.151598,260.700226 25.783964,260.974396 24.416336,261.248596
	C24.967253,261.811432 25.518169,262.374237 26.664803,263.420441
	C27.023943,264.963440 27.645153,266.498322 27.693037,268.050934
	C27.836033,272.687408 27.738541,277.330902 27.764982,281.971497
	C27.789454,286.266296 29.776875,289.133942 34.488277,290.880402
	C43.223267,293.375366 50.687611,290.342987 51.640881,283.500732
	C52.131618,279.978394 51.469604,276.295471 51.449776,271.873718
	C51.679993,269.959686 51.910210,268.045654 52.798298,265.946075
M255.077789,110.751053
	C256.799072,110.591927 258.520325,110.432800 260.672852,109.866974
	C260.911530,109.330742 261.150208,108.794518 261.954132,108.059425
	C262.886383,105.735321 262.203735,104.851242 259.210907,105.312508
	C258.858124,105.160149 258.505371,105.007790 258.174225,104.079285
	C258.360870,101.900627 258.547516,99.721962 258.757477,97.271179
	C252.016251,99.567757 250.440994,105.832512 254.961594,110.041000
	C254.961594,110.041000 254.948303,110.058792 255.077789,110.751053
M606.373230,437.421143
	C606.902100,437.966370 607.430969,438.511597 608.433289,439.509399
	C608.734314,437.069183 609.035339,434.628937 609.598755,431.712769
	C609.057800,431.409485 608.516846,431.106201 607.322937,430.690826
	C606.661194,430.691711 605.999512,430.692627 604.957642,430.103577
	C602.301636,429.643585 599.645630,429.183563 596.195740,428.664673
	C593.499329,429.856750 590.802856,431.048859 587.493652,432.245239
	C587.096130,432.872223 586.698669,433.499237 585.840332,434.653015
	C578.834595,445.626221 582.965576,457.681702 594.986694,460.889069
	C597.320007,460.567474 599.653259,460.245880 602.642700,459.881592
	C603.047546,459.721649 603.452332,459.561707 604.439148,459.567993
	C605.003906,459.074249 605.568726,458.580505 606.829590,457.900543
	C607.743286,456.446991 608.922241,455.092682 609.511536,453.517731
	C610.509399,450.850983 611.134766,448.044861 611.941040,445.212036
	C608.419495,445.212036 604.215088,445.212036 599.192932,445.212036
	C605.178406,450.136139 605.474731,453.821899 600.424072,457.852661
	C599.283142,457.896942 598.142151,457.941223 596.334595,457.742584
	C590.221497,455.454803 588.684265,450.201416 588.710632,444.624969
	C588.738708,438.691193 590.359985,433.149170 597.647888,431.093414
	C599.476746,431.625092 601.305542,432.156769 603.652832,433.118652
	C604.610718,434.353271 605.568604,435.587860 606.373230,437.421143
M220.720596,208.525208
	C220.170700,207.986145 219.620789,207.447067 218.987411,206.460312
	C218.987411,206.460312 218.724899,206.088181 218.821854,205.473099
	C218.288589,204.881836 217.755341,204.290558 217.056915,203.033920
	C215.838547,201.074448 214.620178,199.114990 213.549637,196.580139
	C213.031784,196.058044 212.513931,195.535950 211.882126,194.529968
	C211.882126,194.529968 211.601959,194.119308 211.725174,193.515701
	C211.198700,192.945251 210.672226,192.374817 210.046585,191.180725
	C210.019318,190.766342 209.992065,190.351944 210.627335,189.735168
	C212.549225,187.502823 211.961746,186.149185 209.106903,186.048050
	C207.032883,185.974564 204.943176,186.344696 202.126740,186.350815
	C201.130005,186.401871 200.133286,186.452927 198.333542,186.134430
	C196.887711,186.106445 195.402298,185.872131 194.012985,186.138748
	C193.332794,186.269287 192.831284,187.330994 192.248917,187.971268
	C192.901001,188.437607 193.553070,188.903961 194.746017,189.680283
	C195.143082,189.800186 195.540146,189.920090 196.098145,190.628403
	C196.770264,190.966965 197.442383,191.305527 198.532944,192.138824
	C199.423782,193.068970 200.314606,193.999100 201.191437,195.539185
	C201.757339,196.076797 202.323227,196.614410 203.067841,197.774384
	C203.583908,198.464828 204.099991,199.155289 204.454788,200.421356
	C204.968521,200.947281 205.482254,201.473206 206.149750,202.472580
	C206.149750,202.472580 206.448273,202.870926 206.330963,203.477554
	C206.842834,204.048309 207.354691,204.619080 208.045715,205.842072
	C209.449539,208.198212 210.853378,210.554367 212.196518,213.522614
	C212.723083,214.115646 213.249634,214.708664 213.954666,215.905472
	C214.236328,216.208908 214.518005,216.512360 214.661163,217.620056
	C212.317535,221.666183 209.973892,225.712296 207.054688,230.079254
	C202.717438,236.689178 198.554626,243.463669 190.332916,247.079788
	C187.774887,250.109772 190.397522,250.436615 192.347672,250.492096
	C198.156647,250.657318 203.975861,250.651550 209.784241,250.480392
	C210.885147,250.447952 211.954651,249.349854 214.142563,248.125900
	C210.833115,246.822067 208.877884,246.051743 206.691513,244.727066
	C206.498520,244.158905 206.305542,243.590759 206.424576,242.680695
	C206.326096,242.110916 206.227631,241.541138 206.356033,240.284286
	C207.300293,237.621216 208.244568,234.958130 209.455185,231.860306
	C209.632828,231.571304 209.810486,231.282318 210.000000,231.000610
	C210.000000,231.000610 209.992203,230.991058 210.662186,230.920471
	C212.109802,228.927063 213.360748,226.734253 215.091125,225.027527
	C215.910004,224.219833 217.646133,224.342087 219.063065,224.507004
	C219.063065,224.507004 219.338638,224.892517 219.241531,225.498199
	C219.768143,226.081528 220.294769,226.664871 221.018509,227.902023
	C222.831772,230.889755 224.645020,233.877502 226.343674,237.462433
	C226.856918,238.031082 227.370163,238.599731 227.961929,239.586380
	C227.961929,239.586380 228.227371,239.918686 228.159393,240.538971
	C228.700623,241.123337 229.241852,241.707703 229.920929,242.886505
	C230.168777,243.201599 230.416626,243.516693 230.518951,244.634354
	C231.097977,246.551071 226.839035,249.859756 231.691284,250.376663
	C236.791153,250.919922 241.996140,250.563049 247.149979,250.416077
	C247.895401,250.394821 248.611603,249.349014 249.341309,248.777313
	C248.563522,248.178314 247.785751,247.579300 246.431717,246.626755
	C243.153427,243.126175 239.875137,239.625580 236.695709,235.529404
	C236.176514,234.955292 235.657318,234.381195 235.060013,233.395325
	C235.060013,233.395325 234.790085,233.074722 234.820572,232.462158
	C234.299835,231.860916 233.779114,231.259689 233.048080,230.006348
	C230.621658,226.031647 228.195251,222.056931 225.837952,217.470337
	C225.301437,216.876755 224.764938,216.283173 224.058441,215.102524
	C223.798676,214.792084 223.538895,214.481659 223.612442,213.468460
	C225.156647,210.699417 226.700851,207.930374 228.728378,204.692215
	C232.625610,198.461472 237.232285,192.975311 244.047623,189.699966
	C244.776398,189.349731 245.192795,188.349503 245.754089,187.650787
	C244.851440,187.158951 243.959869,186.266098 243.044327,186.240799
	C237.384964,186.084503 231.718796,186.050125 226.058487,186.160477
	C224.949051,186.182114 223.855408,187.015015 222.754486,187.473740
	C223.662216,188.199326 224.464523,189.273270 225.497269,189.585861
	C228.735733,190.566071 230.487305,192.130646 229.005630,195.742157
	C227.892365,198.455658 226.893295,201.216003 225.221939,204.166626
	C223.776657,205.864639 222.331360,207.562653 220.876907,209.116348
	C220.876907,209.116348 220.733154,209.132095 220.720596,208.525208
M189.045578,55.106060
	C190.035278,54.985867 191.024979,54.865669 192.505768,54.514847
	C193.000778,54.007839 193.495789,53.500832 194.716034,52.888058
	C196.588776,50.978554 196.639267,49.405357 194.091568,47.946758
	C193.283768,47.484272 192.461792,46.394787 192.345291,45.501099
	C192.020615,43.010632 192.062363,40.472393 192.000610,37.998928
	C192.000610,37.998928 191.952942,37.960438 192.683975,37.920692
	C194.845581,36.177612 196.338745,33.717674 193.751038,31.841871
	C191.411880,30.146244 188.367599,30.473204 186.559921,34.317776
	C186.220978,34.446850 185.882019,34.575924 184.823898,34.342480
	C182.549271,35.561226 180.274628,36.779972 177.526413,38.259888
	C177.177124,38.344395 176.827835,38.428902 175.752472,38.202366
	C174.839417,38.810173 173.926376,39.417976 172.714142,40.237312
	C172.714142,40.237312 172.354095,40.305367 171.580719,40.128700
	C168.362061,41.698044 165.143387,43.267387 161.404053,45.207645
	C160.606232,45.493462 159.808395,45.779278 158.720978,45.570438
	C158.171158,46.087334 157.621338,46.604229 156.594986,47.377090
	C156.246384,47.466061 155.897766,47.555035 154.893326,47.316349
	C154.250702,47.854343 153.608078,48.392342 152.493546,49.185490
	C152.149399,49.278587 151.805252,49.371685 150.709152,49.167210
	C148.426102,50.325554 146.143066,51.483902 143.439270,52.983917
	C143.125000,53.160828 142.810745,53.337742 141.763062,53.211407
	C140.173370,54.137623 138.583664,55.063839 136.522476,56.248524
	C136.175613,56.334610 135.828766,56.420692 134.754868,56.212078
	C133.842606,56.819824 132.930359,57.427570 131.553024,58.291405
	C131.213669,58.389420 130.874313,58.487434 129.825424,58.279984
	C127.836967,59.401970 125.848503,60.523956 123.343643,62.022873
	C122.256226,63.031128 121.168808,64.039383 119.343002,65.134377
	C119.202927,66.798294 119.062859,68.462204 118.922775,70.126114
	C120.322548,69.854004 121.722321,69.581886 123.719757,68.976448
	C125.141891,68.289207 126.564026,67.601974 128.358871,67.436890
	C130.561203,66.270676 132.763519,65.104469 135.432419,63.675247
	C135.774963,63.577026 136.117493,63.478806 137.125458,63.686859
	C137.755463,63.134174 138.385452,62.581493 139.481995,61.769993
	C139.823700,61.674767 140.165421,61.579540 141.253418,61.761143
	C144.881363,59.959663 148.509308,58.158184 152.666428,55.983879
	C153.627670,55.507435 154.588913,55.030994 156.278732,54.830414
	C157.184738,54.217716 158.090759,53.605019 159.462326,52.736111
	C159.800903,52.634537 160.139465,52.532967 161.222229,52.730686
	C167.167770,49.862484 173.113312,46.994282 179.611420,43.816349
	C180.408218,43.547188 181.205032,43.278030 182.286484,43.488861
	C182.863892,43.005783 183.441299,42.522705 184.558044,41.683151
	C185.528625,41.223213 186.499191,40.763275 188.004105,40.687042
	C187.863144,41.322937 187.899887,42.085213 187.552200,42.574078
	C185.402832,45.596169 182.183029,48.457630 187.034348,52.619606
	C187.624725,53.261898 188.215118,53.904194 189.045578,55.106060
M437.971680,56.277317
	C439.383850,54.556450 440.796021,52.835583 442.825195,51.096916
	C443.545105,50.777611 444.265045,50.458305 445.665466,50.215054
	C446.121368,50.215572 446.577301,50.216091 447.511505,50.708561
	C451.339355,49.163582 451.366669,47.211647 448.040558,44.935741
	C448.040558,44.935741 448.106659,44.867218 448.202698,44.143497
	C448.284943,43.501320 448.144836,42.690193 448.484283,42.243481
	C451.380035,38.432995 448.613556,35.430248 446.470642,33.182098
	C445.034454,31.675371 441.231598,30.569658 439.693298,31.432913
	C437.135956,32.868023 435.547180,36.029152 433.572144,39.020908
	C433.793152,39.924686 434.014130,40.828465 434.131714,42.414135
	C434.769073,42.931786 435.406433,43.449440 436.676422,44.137459
	C437.735107,44.859112 438.793762,45.580765 439.856262,46.896645
	C439.794983,47.662968 439.733704,48.429287 439.055206,49.549362
	C435.289154,52.975723 431.523102,56.402081 427.220123,60.038383
	C426.770355,60.631241 426.320618,61.224102 425.195679,61.930824
	C423.691193,63.211903 422.186707,64.492973 420.203339,66.012169
	C419.818665,66.380890 419.434021,66.749611 418.345581,67.100746
	C416.237457,69.075272 413.817413,70.824387 412.156952,73.122398
	C411.363678,74.220238 412.012054,76.359810 412.007477,78.027542
	C413.369446,77.902184 414.874359,78.100784 416.060669,77.577354
	C417.951904,76.742920 419.631104,75.427925 421.947937,74.239494
	C422.261200,74.051445 422.574493,73.863403 423.606293,73.812248
	C425.859924,72.635223 428.113525,71.458191 431.051819,70.145172
	C434.694214,68.612801 438.336609,67.080429 442.487030,65.878517
	C443.351593,65.306870 444.216156,64.735214 445.539581,63.878269
	C445.882385,63.771755 446.225189,63.665241 447.310852,63.814003
	C450.226593,62.247543 453.142334,60.681084 456.493408,58.793694
	C456.828217,58.664330 457.163055,58.534962 458.203766,58.750820
	C459.143707,58.182701 460.083679,57.614582 461.488007,56.770142
	C461.832306,56.667831 462.176575,56.565521 463.183685,56.757156
	C463.804840,56.201473 464.425995,55.645790 465.501984,54.799992
	C465.843781,54.692043 466.185547,54.584091 467.238251,54.747803
	C469.209015,53.618736 471.179779,52.489674 473.709900,51.063553
	C474.312195,50.869629 474.914459,50.675705 476.242462,50.760983
	C477.850769,49.886082 479.459045,49.011181 481.517609,47.836510
	C481.858002,47.721493 482.198364,47.606476 483.186859,47.781559
	C483.825287,47.260864 484.463715,46.740173 485.556854,45.919182
	C485.901886,45.809898 486.246918,45.700611 487.241608,45.838894
	C487.869751,45.321552 488.497894,44.804207 489.691956,43.996971
	C490.304047,43.827171 490.916107,43.657375 492.165039,43.779739
	C492.816528,43.277458 493.468018,42.775177 494.601715,42.003403
	C494.953949,41.899391 495.306183,41.795380 496.395233,41.896469
	C497.941223,40.951302 499.487213,40.006134 501.554840,38.681828
	C502.782562,37.825829 504.010284,36.969833 505.889374,36.037449
	C506.335663,34.992680 507.321228,33.152740 507.141541,33.030869
	C505.878662,32.174343 504.013824,30.792837 503.010956,31.205681
	C498.219116,33.178371 493.640259,35.668442 488.509766,38.238571
	C488.157318,38.319561 487.804871,38.400555 486.729706,38.181053
	C485.823303,38.794033 484.916931,39.407013 483.709595,40.235554
	C483.709595,40.235554 483.347748,40.313450 482.575989,40.121323
	C477.722839,42.424122 472.869720,44.726925 467.544342,47.293438
	C467.200073,47.398129 466.855774,47.502819 465.856110,47.292843
	C465.221039,47.830425 464.585968,48.368008 463.495331,49.188690
	C463.154358,49.292751 462.813416,49.396816 461.698700,49.198479
	C458.455780,50.780838 455.212830,52.363201 451.514343,54.238514
	C451.171509,54.347775 450.828644,54.457035 449.840881,54.255489
	C449.195038,54.767715 448.549225,55.279945 447.357117,56.116756
	C446.751221,56.304108 446.145294,56.491459 444.887360,56.340706
	C444.252869,56.884529 443.618378,57.428356 442.514923,58.230476
	C442.171967,58.326035 441.829010,58.421593 440.643341,58.214363
	C439.602997,57.736698 438.562653,57.259033 437.971680,56.277317
M606.205627,268.379456
	C607.982971,266.176086 609.760254,263.972687 612.091797,261.082214
	C608.040222,261.082214 604.860840,261.082214 602.208557,261.082214
	C602.780212,263.615204 603.263855,265.758179 603.101196,268.078735
	C600.952332,269.844299 601.713318,274.571594 596.896606,273.256653
	C595.262878,270.189392 593.483032,267.189301 592.033569,264.037292
	C590.343018,260.361328 587.978027,259.774170 585.146362,261.904266
	C588.026245,267.213501 590.843140,272.406494 593.374329,278.199585
	C593.802002,278.861938 594.229614,279.524323 594.731750,280.988434
	C594.712463,282.599091 594.693176,284.209778 594.066162,286.019653
	C593.838379,286.778381 593.610657,287.537079 592.827148,288.805389
	C594.495850,290.948944 600.476624,291.287018 601.668213,289.260498
	C601.739990,289.138489 601.055481,288.571869 600.815491,287.588867
	C600.329895,286.992126 599.844360,286.395386 599.261353,285.003784
	C599.298157,283.404541 599.334900,281.805267 600.001404,279.988495
	C601.985229,276.325775 603.969055,272.663055 606.205627,268.379456
M190.486221,433.591309
	C191.342926,433.031525 192.199631,432.471741 193.581741,432.341827
	C196.674622,437.135437 199.767502,441.929047 202.536148,447.577423
	C202.723953,450.381195 202.911774,453.184967 202.896957,456.521973
	C202.530243,456.947388 202.163513,457.372772 201.103775,457.773773
	C198.399628,459.078400 198.897675,460.763031 201.285065,461.188690
	C204.441452,461.751465 207.828094,461.784119 210.988663,461.267303
	C212.789764,460.972778 214.212799,459.130371 210.474731,457.698700
	C210.105820,457.523010 209.736908,457.347321 209.519455,456.584137
	C209.165436,455.898071 208.811417,455.212036 208.525696,453.722198
	C208.488312,451.299530 208.450928,448.876831 208.916916,446.115326
	C209.255447,444.991089 209.593979,443.866821 209.946014,441.809113
	C209.415741,441.602478 208.885468,441.395844 207.772202,441.079926
	C206.848282,440.726776 205.924362,440.373627 204.882050,439.581604
	C204.882050,439.581604 204.665146,439.182098 204.788315,438.554169
	C204.235626,437.993134 203.682938,437.432068 202.836304,436.176941
	C202.588074,434.816010 202.339844,433.455048 202.743759,432.088257
	C205.714691,430.061707 204.441376,428.677582 201.827652,428.656525
	C197.469864,428.621429 193.106827,429.238190 188.030991,429.135925
	C186.351440,429.111298 184.671875,429.086670 182.303253,428.655640
	C177.871994,428.792297 173.440750,428.928955 168.133850,428.975189
	C165.835480,429.418427 162.731491,429.122803 161.460693,430.508453
	C160.135818,431.953064 160.578400,435.018646 160.248230,437.375519
	C160.729950,437.532867 161.211670,437.690216 161.693390,437.847565
	C164.470947,435.000092 166.537338,430.548096 172.297592,433.277283
	C170.808807,441.913269 175.758957,451.473938 168.490875,459.863586
	C173.291748,459.863586 177.898605,459.863586 182.620026,459.863586
	C180.763443,457.463715 178.287216,455.728027 178.153595,453.827606
	C177.666229,446.896362 177.960983,439.910126 177.960983,431.758057
	C181.019485,432.734589 183.393005,433.492401 185.872681,434.942749
	C186.856400,435.887238 187.840118,436.831726 188.823868,437.776184
	C189.202911,437.173370 189.581970,436.570557 190.091095,435.318573
	C190.063339,434.879272 190.035583,434.439941 190.486221,433.591309
M215.914764,387.958618
	C215.914764,387.958618 215.794174,387.750610 215.077332,387.804504
	C207.411285,391.294037 199.745239,394.783569 191.380188,398.157318
	C190.932999,398.291870 190.485794,398.426422 189.178741,398.292206
	C184.461746,398.799530 183.635361,396.244202 184.871536,392.493744
	C186.015427,389.023254 187.776459,385.738800 188.710358,382.224854
	C189.090332,380.795227 188.003967,378.975922 187.584808,377.333954
	C186.245743,377.986053 184.639572,378.365387 183.630020,379.353973
	C182.104950,380.847382 180.847855,382.676392 179.736389,384.519287
	C175.438644,391.645264 176.662613,400.828369 182.705185,407.641907
	C187.505646,413.054840 192.085068,413.453308 201.305466,409.243896
	C202.365524,408.759918 203.485626,408.341400 204.430420,407.681458
	C212.194427,402.258087 219.938248,396.805450 227.653061,391.312317
	C229.638046,389.899048 231.274536,388.201782 233.085510,391.712708
	C238.545166,402.297333 250.447800,405.387817 260.680328,399.195770
	C262.095245,398.339508 264.850616,397.299164 265.467987,397.900909
	C270.778870,403.077454 277.327393,401.528992 283.501312,401.559631
	C287.006683,401.576965 288.922791,402.359253 289.815369,406.152344
	C290.675781,409.808411 292.248383,413.462250 294.258789,416.642548
	C297.097198,421.132599 302.645142,422.056976 306.953735,419.196350
	C311.277161,416.325867 312.219666,411.891663 311.160522,407.260010
	C310.055725,402.428589 312.034241,401.213989 316.284119,401.619843
	C317.274994,401.714447 318.282196,401.640778 319.281891,401.639618
	C329.882416,401.627380 335.312256,397.287384 337.313019,386.887695
	C337.938202,383.638123 338.184052,380.274109 338.214233,376.958984
	C338.321899,365.130157 338.252502,353.299744 338.278107,341.470032
	C338.281342,339.978821 337.863556,337.705505 338.638702,337.123383
	C343.833008,333.222839 340.422546,328.986145 339.288269,325.006500
	C337.951202,320.315430 336.089935,315.773804 334.152252,310.311127
	C329.786896,315.284637 325.318512,318.671082 328.245453,325.020294
	C328.696442,325.998566 328.442108,327.321289 328.442963,328.484772
	C328.455170,345.312988 328.204987,362.147125 328.602722,378.966003
	C328.730865,384.383789 327.549347,387.920990 321.273621,389.179504
	C319.868622,389.294952 318.463623,389.410370 316.277222,389.184875
	C315.165192,389.293610 314.053162,389.402344 312.237488,389.272858
	C311.507019,389.344421 310.776550,389.415985 309.371460,389.032562
	C309.063232,387.484192 308.237732,385.826813 308.536987,384.406433
	C309.776581,378.522919 308.896790,373.172638 305.354980,368.306305
	C303.461365,365.704529 301.197937,365.248871 299.467712,368.220825
	C296.646515,373.066650 293.451569,377.893982 291.805115,383.163666
	C290.408936,387.632416 288.271698,389.497742 283.240509,389.281036
	C282.513275,389.357758 281.786072,389.434509 280.254028,389.169006
	C278.816528,389.267303 277.378998,389.365601 275.303223,389.191895
	C274.844910,389.206543 274.386597,389.221222 273.521149,388.590149
	C272.041138,385.322479 270.561127,382.054810 268.554443,377.624359
	C265.244446,380.911835 262.664764,383.473938 260.018707,386.007355
	C260.018707,386.007355 260.031006,386.078644 259.275146,386.176544
	C256.294922,387.125732 253.372787,388.560760 250.322678,388.925446
	C243.455826,389.746552 242.025894,388.340668 240.396118,381.642548
	C238.903748,375.509033 237.375397,369.349792 235.283157,363.405914
	C232.917770,356.686005 230.076065,350.115509 227.100464,343.636627
	C225.702530,340.592896 223.993011,340.194885 221.996109,343.792755
	C219.770676,347.802368 219.185211,351.325928 221.701355,355.392456
	C223.348099,358.053894 224.671661,360.997955 225.638489,363.978149
	C227.122559,368.552734 229.931427,373.200684 225.885345,378.197754
	C225.885345,378.197754 225.792145,378.571198 225.112167,378.735962
	C221.993744,381.749725 218.875305,384.763519 215.914764,387.958618
M114.877708,455.151489
	C114.877708,455.151489 114.775970,455.132751 114.857552,454.260956
	C113.924187,445.852356 111.242157,437.282562 118.097649,428.893311
	C115.705345,429.061462 114.295479,429.160553 112.092735,429.164734
	C110.763290,429.189270 109.433838,429.213806 107.427628,428.913483
	C106.445267,429.166901 105.462898,429.420319 104.622139,429.637238
	C105.728096,431.911224 107.168846,433.692841 107.409431,435.623962
	C107.855316,439.203094 107.199715,442.931335 107.747147,446.482758
	C108.309746,450.132599 109.761665,453.645325 111.168800,457.828308
	C113.011932,458.665375 114.855064,459.502411 117.068428,460.909180
	C124.056396,462.760925 131.509583,457.310059 131.404510,450.023590
	C131.305573,443.162140 132.593033,436.280701 133.271652,429.396912
	C131.062149,429.396912 127.686539,429.396912 123.770264,429.396912
	C128.548492,435.529022 128.598618,436.477997 127.759102,447.186981
	C127.423203,451.471832 127.016205,455.417938 122.023361,457.593994
	C121.131432,457.618683 120.239494,457.643402 119.000038,457.116425
	C117.612633,456.493256 116.225235,455.870117 114.877708,455.151489
M98.528732,276.181366
	C97.735146,280.860413 96.941559,285.539459 96.136803,290.284393
	C98.431854,290.284393 101.273834,290.284393 104.276756,290.284393
	C103.202446,287.662842 102.294258,285.446625 101.742447,282.327606
	C102.216011,277.732727 102.689568,273.137878 103.558517,269.127808
	C109.314842,276.689209 115.071159,284.250610 120.827484,291.812012
	C123.801804,281.579468 120.297493,271.144897 125.996788,261.405701
	C122.658752,261.405701 119.671432,261.405701 117.831734,261.405701
	C118.805046,268.065491 119.710541,274.261261 120.616043,280.457062
	C120.077240,280.569397 119.538437,280.681763 118.999634,280.794098
	C113.807541,274.376434 108.615448,267.958771 103.004738,260.941437
	C101.058739,260.741638 99.053497,260.162506 97.184311,260.454437
	C95.497612,260.717926 94.371750,261.955261 97.539299,263.341522
	C97.936920,264.279175 98.334549,265.216858 98.385773,266.862823
	C98.483948,269.683167 98.582115,272.503479 98.528732,276.181366
M329.548035,196.886719
	C330.380249,197.207291 331.212433,197.527847 332.186737,198.519913
	C333.564331,200.336014 334.941895,202.152115 336.313690,204.553238
	C336.855621,205.080399 337.397522,205.607559 338.109406,206.796921
	C349.244659,222.019958 360.379913,237.242996 371.515167,252.466034
	C372.126251,252.183624 372.737366,251.901215 373.348480,251.618805
	C373.468658,249.889511 373.680817,248.160919 373.694153,246.430832
	C373.787872,234.275986 373.588440,222.112381 373.995239,209.968750
	C374.265717,201.894516 374.641418,193.570755 382.214386,188.085907
	C382.407196,187.946274 382.145233,187.178757 382.088043,186.634369
	C375.173492,186.634369 368.360107,186.634369 360.718719,186.634369
	C373.328064,200.432846 368.582062,216.569412 369.478973,231.884262
	C368.032349,231.254425 367.084015,230.444809 366.362030,229.467896
	C357.070160,216.895889 347.624908,204.430359 338.645569,191.638062
	C335.585999,187.279251 332.332336,185.082413 326.228241,186.105301
	C323.627319,186.105301 321.026398,186.105301 318.425446,186.105301
	C318.290192,186.823029 318.154907,187.540756 318.019623,188.258484
	C319.707184,188.740540 321.394745,189.222610 323.518433,190.172882
	C324.233307,191.436539 324.948181,192.700211 325.333954,194.707123
	C325.437927,204.155350 325.541901,213.603561 325.473938,223.844452
	C325.099518,227.855301 324.725128,231.866135 323.827301,236.292862
	C321.742950,240.458450 319.658600,244.624054 317.217804,249.501968
	C323.891663,250.256790 330.921539,249.895386 337.483307,249.739700
	C334.978638,244.493790 331.934174,240.341614 331.060364,235.774170
	C329.695618,228.640564 329.733887,221.229538 329.307556,213.928482
	C329.018555,208.979538 328.952087,204.017593 328.933899,198.373108
	C328.914368,197.904968 328.894867,197.436829 329.548035,196.886719
M209.659027,439.979431
	C210.287170,440.064758 210.915329,440.150085 212.152435,440.009613
	C215.011185,436.663361 217.869949,433.317078 221.123123,429.509155
	C217.014862,429.509155 213.631485,429.509155 211.348343,429.509155
	C210.754868,433.176239 210.295120,436.017090 209.659027,439.979431
M34.616020,432.718262
	C34.616020,432.718262 34.785599,432.513031 35.696815,432.670837
	C41.194427,431.388824 45.431770,433.726624 48.948799,438.311554
	C51.094582,430.697266 49.824284,428.739502 43.318199,428.651733
	C40.855793,428.618530 38.388039,428.981476 35.044659,429.079346
	C32.408962,429.158264 29.773268,429.237183 26.431709,429.146576
	C25.976931,429.842621 25.522150,430.538696 25.067369,431.234741
	C25.793797,431.580597 26.520226,431.926453 27.768322,432.812592
	C28.098906,433.478851 28.429489,434.145142 28.370716,435.700867
	C28.526447,442.202179 28.682178,448.703491 28.544399,455.821411
	C28.283676,456.451630 28.022951,457.081879 27.054567,457.748474
	C26.569138,458.451477 26.083708,459.154480 25.598259,459.857483
	C26.417841,460.248138 27.213785,460.902496 28.061575,460.978516
	C30.326136,461.181488 32.620354,461.262024 34.887398,461.128967
	C35.824383,461.073975 36.722065,460.349304 37.637627,459.929199
	C36.846088,459.164215 36.054550,458.399261 34.940006,457.316711
	C34.940006,457.316711 34.521015,457.144562 34.618584,456.562775
	C34.348255,456.058105 34.077923,455.553467 33.900414,454.351685
	C33.865009,453.885376 33.829605,453.419098 34.179962,452.562958
	C34.053032,451.725861 33.926098,450.888763 33.907860,449.266876
	C33.629150,446.515747 34.368225,444.721497 37.986633,445.890747
	C38.530090,447.060181 38.941711,448.322601 39.672935,449.359619
	C40.035370,449.873627 40.985783,449.972992 41.670185,450.259949
	C41.899414,449.443390 42.128639,448.626862 42.496078,447.005890
	C42.379833,444.280243 42.263588,441.554596 41.843586,438.159454
	C38.884483,438.351654 37.893112,443.686066 33.895554,440.572021
	C33.868942,440.365631 33.842331,440.159210 34.258942,439.318726
	C34.291489,437.138458 34.324032,434.958191 34.616020,432.718262
M267.825653,245.169281
	C267.825653,245.169281 267.652832,245.158783 267.622864,244.364166
	C268.085052,239.831589 268.222137,235.226868 269.202698,230.809326
	C269.506531,229.440521 272.052307,227.733521 273.657166,227.639404
	C279.454132,227.299423 285.287506,227.580414 291.330902,228.306458
	C291.959229,229.852402 292.587585,231.398346 293.051666,233.608810
	C293.558014,234.592621 294.064331,235.576447 294.583740,237.300522
	C295.272461,239.162720 295.961212,241.024902 296.418182,243.553543
	C296.368652,244.712189 296.319153,245.870819 295.923737,247.964981
	C296.082031,248.257339 296.240295,248.549713 296.952332,249.378632
	C302.213684,249.378632 307.475037,249.378632 312.736389,249.378632
	C312.858704,248.833923 312.980988,248.289200 313.103302,247.744492
	C311.712311,246.910721 310.321350,246.076965 308.646393,244.749695
	C308.347290,244.522675 308.048157,244.295639 307.726379,243.458588
	C307.194366,242.897507 306.662384,242.336426 305.968262,241.172028
	C305.749695,240.819565 305.531097,240.467102 305.497162,239.538986
	C305.044281,238.950699 304.591400,238.362411 304.049286,237.077011
	C303.801086,236.424927 303.552917,235.772842 303.538025,234.487198
	C302.969940,233.339386 302.401855,232.191589 301.823395,230.357101
	C301.637756,229.945114 301.452148,229.533127 301.525909,228.558792
	C301.106812,227.902512 300.687683,227.246246 300.255768,225.933914
	C300.045471,225.317520 299.835175,224.701126 299.769226,223.347229
	C298.666107,220.699585 297.563019,218.051926 296.492279,214.917191
	C296.462250,214.582245 296.341370,214.284149 296.393127,213.469772
	C295.819580,211.741852 295.253418,210.011429 294.671234,208.286438
	C292.224609,201.037369 289.864441,193.756622 287.241760,186.571732
	C286.754272,185.236206 285.203552,184.288788 284.143524,183.162231
	C283.207581,184.214722 282.124512,185.175262 281.388367,186.352692
	C280.913208,187.112762 280.946472,188.190750 280.353455,189.727020
	C280.201843,190.429291 280.050262,191.131577 279.288513,192.098541
	C278.469543,194.411972 277.650604,196.725403 276.583588,199.436249
	C276.459320,199.733780 276.426331,200.041122 275.940002,200.800034
	C272.377502,209.894745 268.814972,218.989456 264.897980,228.793320
	C263.896484,231.814346 262.894989,234.835373 261.640686,238.229279
	C261.507294,238.498596 261.389435,238.774567 260.821503,239.380753
	C260.728699,239.743118 260.635895,240.105484 259.997375,240.808640
	C259.356445,241.884628 258.715515,242.960617 257.616730,244.257080
	C257.423340,244.529358 257.229950,244.801651 256.301208,245.134796
	C255.094254,246.131775 253.887299,247.128754 252.680344,248.125732
	C252.885559,248.542480 253.090759,248.959229 253.295959,249.375977
	C260.449493,249.669479 267.611450,250.130661 274.704742,249.222687
	C274.728088,248.573792 274.751404,247.924911 274.774750,247.276016
	C272.461639,246.631393 270.148499,245.986771 267.825653,245.169281
M582.714050,89.507256
	C582.142639,89.005402 581.571289,88.503548 580.852478,87.352859
	C579.052734,85.511307 577.253052,83.669762 575.111084,81.169014
	C573.555481,81.314285 571.999817,81.459549 570.444275,81.604805
	C571.300232,83.994446 572.156250,86.384087 573.247131,89.263824
	C573.680481,89.565094 574.113831,89.866364 574.954956,90.697411
	C576.341492,91.362404 577.728088,92.027397 579.074097,92.928886
	C579.074097,92.928886 579.311890,92.961021 579.358948,93.690407
	C579.822327,94.924522 580.119446,96.258713 580.788025,97.369286
	C581.787476,99.029350 583.048340,100.532036 584.197998,102.101662
	C585.206482,100.253372 586.732605,98.503403 587.106567,96.534584
	C587.723083,93.288834 587.594727,89.901611 587.803467,86.159576
	C589.703064,86.610977 590.637634,87.022423 591.566956,87.010735
	C593.061584,86.991943 594.552673,86.693680 596.045288,86.513496
	C595.537781,84.938873 595.496704,82.653481 594.419678,81.946877
	C592.540466,80.713829 589.553589,79.366859 587.902405,80.081421
	C586.157776,80.836418 585.329163,83.894928 584.297485,86.041855
	C583.660339,87.367447 583.391113,88.869812 582.962280,90.089432
	C582.962280,90.089432 582.758972,90.096428 582.714050,89.507256
M181.790802,201.900238
	C182.018890,196.335602 182.271179,190.771545 182.408691,185.204666
	C182.416122,184.903854 181.461517,184.579285 180.368835,184.025696
	C179.944534,184.441803 179.520233,184.857910 178.524460,185.335663
	C178.024857,185.586487 177.525269,185.837326 176.146988,185.960114
	C174.079102,186.022507 172.011200,186.084900 169.290878,185.796967
	C160.110855,185.796967 150.930832,185.796967 140.616959,185.796967
	C141.991180,187.559998 142.394241,188.614014 142.938126,188.692535
	C148.948761,189.560318 148.856750,193.962418 148.842987,198.451233
	C148.805237,210.762558 148.700256,223.076218 148.897598,235.384537
	C148.985504,240.867493 148.838623,245.816727 142.095718,247.232880
	C141.886719,247.276764 141.841064,248.098450 141.535782,249.248917
	C144.165985,249.368408 146.565567,249.449036 148.961517,249.591156
	C159.619949,250.223419 170.417435,248.197800 181.892105,251.272751
	C183.155212,244.788437 184.450684,238.138031 185.746140,231.487610
	C185.145401,231.159882 184.544662,230.832169 183.943924,230.504440
	C183.021942,231.591202 181.668869,232.533035 181.246918,233.787933
	C178.183777,242.897659 172.058960,247.051666 162.415756,246.652008
	C159.333755,246.524277 158.382370,245.229828 158.436600,242.342957
	C158.558456,235.856674 158.618851,229.363373 158.445297,222.879852
	C158.356262,219.553955 159.703415,218.487564 162.864685,218.604706
	C166.516403,218.740021 170.191086,218.638489 173.833130,218.351913
	C174.627899,218.289383 175.326797,217.008469 176.069855,216.288681
	C175.318909,215.605530 174.647766,214.500717 173.797974,214.339859
	C172.579727,214.109268 171.231064,214.567627 169.450760,214.576553
	C169.114212,214.596436 168.777664,214.616333 168.011276,214.091248
	C167.563385,213.874008 167.136856,213.574890 166.664429,213.451630
	C157.654785,211.101227 156.699127,200.633591 158.243881,191.986115
	C159.459274,185.182404 165.510086,190.733994 169.678329,189.607590
	C171.849640,191.061798 174.020950,192.516006 176.195358,194.600815
	C176.684311,195.275696 177.173264,195.950592 177.601135,197.109222
	C177.630188,197.445572 177.756226,197.740448 177.706451,198.412140
	C178.010193,199.158203 178.313950,199.904251 178.627228,201.358734
	C179.424133,201.599045 180.221039,201.839355 181.790802,201.900238
M141.452560,436.306091
	C141.475510,442.093903 141.498444,447.881683 140.971436,454.042389
	C139.616364,455.776794 138.261292,457.511200 136.606522,459.629211
	C137.453445,460.085815 138.362961,460.993835 139.283600,461.005249
	C145.590515,461.083496 151.906921,461.116547 158.202026,460.800659
	C159.418518,460.739624 161.594528,459.007446 161.538239,458.165833
	C161.348190,455.323883 164.827591,451.954132 160.542694,449.093964
	C159.911972,450.307434 159.184418,451.116577 159.082825,451.997833
	C158.388062,458.024536 153.933563,457.522339 149.845963,457.172394
	C148.825394,457.085083 147.040497,455.351257 147.127274,454.536041
	C148.012909,446.215485 143.669250,437.157928 151.585464,428.745239
	C147.930237,428.964508 145.405167,429.115997 142.165436,429.162476
	C141.443771,429.148712 140.722107,429.134979 139.647415,428.722534
	C138.706497,428.968140 137.765579,429.213745 136.549438,429.531189
	C138.433212,431.790161 139.949905,433.608917 141.452560,436.306091
M94.732674,96.162666
	C94.660255,95.044861 94.587845,93.927063 95.065071,92.257713
	C95.324432,88.425819 95.378616,84.442703 101.170135,87.456039
	C101.803421,87.785545 103.601875,87.048653 104.008369,86.326836
	C104.457611,85.529083 104.343491,83.613281 103.745987,83.172684
	C101.721550,81.679855 99.186760,79.436928 97.206596,79.750633
	C95.393959,80.037796 93.790550,83.122612 92.585655,85.252258
	C91.775620,86.683998 93.398064,89.553406 89.697800,88.737831
	C88.385979,87.166489 87.074158,85.595146 85.680389,83.354851
	C83.658676,82.486038 81.636971,81.617226 79.615250,80.748405
	C79.538628,82.859917 79.376274,84.974594 79.453796,87.080429
	C79.470390,87.531067 80.356758,87.949677 81.094749,88.997124
	C83.183754,90.322151 85.272751,91.647171 87.378426,93.706467
	C87.857666,95.119087 88.108940,96.673782 88.877083,97.906364
	C89.729904,99.274834 91.054298,100.349419 92.173378,101.551964
	C92.934502,100.022644 93.695625,98.493324 94.732674,96.162666
M274.781830,456.209259
	C274.691650,453.867249 274.601471,451.525269 274.850677,448.421753
	C274.744446,447.887909 274.638214,447.354065 274.704590,446.297028
	C274.744446,446.117798 274.784302,445.938538 275.627472,445.721191
	C277.750305,447.144714 279.873138,448.568268 282.988800,450.657562
	C283.233459,447.253021 283.574982,444.025726 283.632050,440.793427
	C283.649567,439.801666 282.888184,438.796143 282.483490,437.796906
	C281.660645,438.407990 280.835754,439.016357 280.015442,439.630798
	C278.755157,440.574829 277.498016,441.523102 276.239532,442.469574
	C275.790955,442.199249 275.342346,441.928955 274.893738,441.658661
	C275.159271,438.809326 274.426392,434.258301 275.867554,433.412842
	C281.350281,430.196075 285.810089,434.125946 289.902802,438.213104
	C291.465454,430.895538 290.061951,428.802490 284.105591,428.737549
	C279.122772,428.683197 274.131226,428.740021 269.157806,429.009705
	C267.971497,429.074066 266.841858,430.183075 265.686127,430.811554
	C266.809967,431.513489 267.933807,432.215454 269.272400,433.621277
	C269.389404,434.346436 269.506439,435.071625 269.236237,436.689026
	C269.355896,442.860199 269.475555,449.031372 269.404144,455.845276
	C269.301117,456.280151 269.198059,456.714996 268.362518,457.241364
	C267.656525,458.012360 266.950531,458.783325 266.244537,459.554321
	C267.167755,460.037476 268.056793,460.830597 269.021515,460.936829
	C270.821289,461.135040 272.679016,461.059265 274.485779,460.857422
	C275.806885,460.709778 277.085052,460.177765 278.382355,459.817108
	C277.237671,458.905243 276.092957,457.993408 274.781830,456.209259
M459.902222,95.054886
	C460.191315,96.028862 460.480408,97.002846 460.513855,98.635414
	C461.801147,99.687096 463.088470,100.738785 464.375763,101.790466
	C464.897949,100.534035 465.420135,99.277596 466.203522,97.233299
	C466.107300,96.143860 466.011047,95.054413 466.337311,93.361015
	C466.863800,91.043243 467.390289,88.725471 467.967957,86.182442
	C470.045135,86.786346 471.525787,87.661301 472.840302,87.458633
	C473.895813,87.295898 475.647430,85.155815 475.559448,85.038177
	C474.133453,83.131813 472.747955,80.741646 470.744324,79.884399
	C469.463806,79.336548 466.399658,80.620354 465.548340,81.972641
	C464.369293,83.845512 464.518677,86.554680 463.887177,89.103645
	C463.887177,89.103645 463.669952,89.295807 463.009125,89.492012
	C462.380127,89.235611 461.751160,88.979202 460.976410,88.101967
	C459.610107,86.748474 458.243805,85.394974 456.757874,83.369545
	C454.728210,82.528206 452.698547,81.686867 450.668884,80.845535
	C450.724792,82.711426 450.780701,84.577324 450.889618,87.111481
	C453.228760,88.752838 455.567871,90.394196 458.076752,92.634918
	C458.681091,93.183006 459.285431,93.731094 459.902222,95.054886
M428.984131,284.052246
	C428.752747,282.614655 428.521332,281.177063 428.049255,279.102356
	C425.280945,276.847168 422.262451,274.829285 419.825348,272.259918
	C417.954865,270.287964 416.817322,267.620758 416.034943,264.966705
	C418.298035,264.339020 420.561127,263.711334 422.159912,263.267914
	C423.969147,265.809357 425.226837,267.576050 427.086395,270.188202
	C428.957947,261.914764 427.207397,258.914978 421.377289,259.688904
	C418.490479,260.072144 415.884979,262.574402 412.614502,264.747101
	C410.096222,268.731049 411.211731,271.895905 414.838562,274.460358
	C416.986664,275.979218 419.161987,277.459961 421.339844,278.936035
	C424.093079,280.802063 425.359161,283.218079 423.592346,286.914917
	C418.218719,289.630585 415.920197,288.805450 413.617218,283.634125
	C413.189941,282.674713 411.904480,282.097443 411.015137,281.343781
	C410.481964,282.251038 409.339478,283.317841 409.527618,284.036163
	C410.140472,286.376282 410.601257,289.571747 412.275818,290.659271
	C416.597137,293.465729 421.597931,292.215637 425.680420,288.166870
	C426.584839,286.884674 427.489288,285.602448 428.984131,284.052246
M258.671509,433.539734
	C257.571289,432.580872 256.471039,431.621979 255.066437,429.994629
	C250.462158,427.442017 245.996872,427.156982 241.202850,431.085266
	C240.091187,432.338409 238.979507,433.591553 237.218216,435.014801
	C236.668106,436.407043 236.118011,437.799286 235.255203,439.896729
	C235.082260,441.167847 234.909302,442.438995 234.183914,443.968750
	C234.543121,445.964172 234.902328,447.959564 235.296188,450.649994
	C237.536438,453.538696 239.776703,456.427429 242.267899,459.650238
	C242.480804,459.846588 242.731339,459.959320 243.000778,460.000153
	C243.000778,460.000153 243.012787,459.980255 243.164017,460.766113
	C248.677261,464.624695 260.279968,460.168701 261.219666,451.782562
	C261.464966,450.526215 261.710297,449.269836 262.168091,447.128540
	C261.574677,443.482910 260.981262,439.837311 260.562927,435.607910
	C260.017914,435.112549 259.472900,434.617188 258.671509,433.539734
M503.714325,79.909439
	C505.954590,78.710388 508.194855,77.511345 511.037567,76.248817
	C511.748291,75.585602 512.458984,74.922386 513.824036,74.091278
	C513.520874,72.477287 513.217712,70.863297 512.490479,68.748596
	C510.970734,67.541756 509.450989,66.334915 507.887421,64.427277
	C506.318420,62.480324 504.958160,62.219639 503.700378,65.164673
	C503.700378,65.164673 503.349152,65.260941 502.607605,65.168144
	C498.065491,69.129921 497.911713,70.363663 501.167450,74.975555
	C500.756561,75.618027 500.345642,76.260490 499.361450,77.170006
	C498.821503,78.072815 498.281525,78.975624 497.208374,79.995132
	C497.399902,80.698921 497.591431,81.402710 497.989014,82.618286
	C498.105164,82.967056 498.221313,83.315826 498.119446,84.450821
	C498.588196,86.027695 499.056976,87.604568 499.730957,89.868919
	C499.819031,90.579910 499.907104,91.290901 499.503876,92.362572
	C499.907623,93.285057 500.311371,94.207542 500.897430,95.831573
	C500.939056,96.553467 500.980713,97.275368 500.464935,98.497017
	C500.777069,100.734093 501.089172,102.971176 501.618622,105.797478
	C501.679901,106.210739 501.741180,106.623993 501.317108,107.497787
	C501.978455,108.593773 502.418182,110.035118 503.384796,110.655281
	C503.958038,111.023071 505.695801,110.397873 506.332123,109.695595
	C508.487854,107.316505 508.388916,99.984596 506.198120,96.144867
	C506.146759,95.428223 506.095428,94.711571 506.590515,93.520485
	C505.785461,90.984520 504.980408,88.448563 503.919678,85.196953
	C503.612427,83.464539 503.305176,81.732132 503.000000,80.000000
	C503.000000,80.000000 502.999634,79.997757 503.714325,79.909439
M286.149567,287.800995
	C285.484222,288.428345 284.818848,289.055725 284.153503,289.683075
	C284.768860,289.861053 285.384216,290.039032 286.817230,290.407501
	C288.208557,290.332886 289.599915,290.258270 291.676361,290.610199
	C295.465912,290.610199 299.255432,290.610199 303.495941,290.610199
	C304.138214,287.938904 304.824890,285.082794 305.511566,282.226685
	C305.042786,282.022797 304.574005,281.818909 304.105225,281.615051
	C302.966034,283.088226 302.090546,284.959076 300.620789,285.933746
	C298.794006,287.145142 296.508362,287.743073 294.341583,288.293762
	C293.931458,288.398010 292.662842,287.068970 292.626953,286.358978
	C292.484863,283.548828 292.099152,280.513641 293.008698,277.997467
	C293.406219,276.897705 296.726196,276.909424 298.676819,276.284607
	C299.319031,276.078918 299.828552,275.459045 300.972046,274.595703
	C298.168243,273.911743 296.108215,273.409241 293.619446,272.476929
	C293.210236,272.030670 292.801025,271.584412 292.585541,270.558685
	C292.187805,269.885315 291.790039,269.211945 291.424591,267.833008
	C291.442963,266.426910 291.461334,265.020782 292.230652,263.380035
	C297.695923,261.031494 299.656708,266.082581 303.263977,269.455963
	C303.263977,265.702087 303.263977,262.980072 303.263977,259.583130
	C298.838470,260.261261 295.027893,260.845184 290.408478,261.117279
	C288.984985,261.215118 287.561523,261.312958 286.094513,260.897217
	C285.552765,260.979492 285.011047,261.061798 284.469299,261.144073
	C284.969452,261.785065 285.469635,262.426025 286.516296,263.703735
	C286.605316,271.688629 286.694305,279.673523 286.149567,287.800995
M558.966919,432.262421
	C558.578369,431.873383 558.189758,431.484344 557.727295,430.420959
	C556.779236,430.093872 555.831177,429.766785 554.205872,429.241455
	C553.504517,429.273743 552.803162,429.306030 551.489807,429.034546
	C550.845032,429.485504 550.200317,429.936462 549.555603,430.387421
	C550.405701,431.158203 551.255798,431.928955 552.445618,433.288666
	C552.880798,433.809875 553.315979,434.331116 553.594543,435.673615
	C553.702881,440.152069 554.136108,444.653900 553.815918,449.101501
	C553.562744,452.616852 552.383728,456.065552 551.574585,459.730652
	C554.114136,459.730652 557.898438,459.730652 562.814636,459.730652
	C557.067017,455.113525 555.728271,445.853180 559.238098,441.468445
	C559.916077,442.284363 560.593994,443.100250 561.209717,444.526581
	C561.792236,445.040649 562.374695,445.554688 563.140076,446.625946
	C563.540771,447.049561 563.941528,447.473206 564.251160,448.533173
	C565.107666,449.445374 565.964172,450.357574 567.025574,451.786499
	C567.426880,452.168701 567.828125,452.550873 568.181580,453.557495
	C568.751831,454.098328 569.322144,454.639130 570.067505,455.748230
	C570.691711,456.509949 571.315918,457.271698 572.026978,458.761078
	C575.917358,461.529053 575.257751,458.417572 575.618896,456.130157
	C577.001343,447.374237 572.233459,437.734253 579.902344,429.671204
	C575.689514,429.671204 572.025696,429.671204 568.361938,429.671204
	C575.023315,434.866821 572.052673,441.077942 572.316040,447.649170
	C570.277710,446.205017 569.227173,445.460693 568.005310,444.092407
	C566.897156,442.760651 565.789062,441.428894 564.722656,439.462006
	C563.872620,438.554199 563.022644,437.646393 561.954041,436.243988
	C561.591187,435.844452 561.228394,435.444916 560.887695,434.425690
	C560.302002,433.884003 559.716309,433.342316 558.966919,432.262421
M483.906799,406.379822
	C482.680725,406.455048 480.709900,406.089050 480.358429,406.682404
	C478.894867,409.152863 476.252350,412.827820 477.104370,414.378632
	C478.988525,417.808105 482.461273,420.615997 485.838135,422.838684
	C487.028900,423.622498 489.828461,421.962128 492.891815,421.154541
	C494.420898,421.496887 496.599152,426.394806 499.753784,421.946716
	C501.909546,418.907074 504.150696,415.498230 500.750641,412.106873
	C498.214905,409.577545 495.043610,407.685425 492.155304,405.509552
	C492.014465,406.076294 491.873596,406.643036 491.732758,407.209778
	C489.545746,407.414490 487.358765,407.619232 484.825989,407.486877
	C484.557587,407.307556 484.275330,407.153656 483.906799,406.379822
M234.120041,283.109497
	C237.605881,275.655212 241.091721,268.200928 244.512878,260.884949
	C241.011719,260.884949 237.697144,260.884949 235.738312,260.884949
	C235.738312,264.877441 236.089157,267.995056 235.631546,270.989075
	C235.238281,273.562073 234.108551,276.087067 232.931763,278.447418
	C232.374329,279.565491 230.946426,280.249542 229.800049,280.365479
	C228.032074,275.354279 226.056580,270.404327 224.553436,265.314911
	C222.996628,260.043854 222.629715,259.706085 217.397827,261.344482
	C220.971359,270.845490 224.557144,280.379028 228.094955,290.556427
	C229.079132,290.383484 230.063309,290.210541 231.366257,289.493469
	C231.599854,288.687531 231.833450,287.881622 232.579239,286.973572
	C232.761673,286.312408 232.944107,285.651245 233.291977,284.449921
	C233.355087,284.078796 233.418198,283.707672 234.120041,283.109497
M500.856659,187.284637
	C499.224091,186.987625 497.591553,186.690613 495.145477,186.103851
	C493.422119,186.130920 491.698730,186.157990 489.329926,185.837128
	C480.264954,185.837128 471.199982,185.837128 462.135010,185.837128
	C461.874817,186.389786 461.614624,186.942459 461.354431,187.495117
	C465.988831,189.293884 469.760773,191.710403 469.230988,197.768219
	C469.301971,198.491135 469.372986,199.214066 469.131042,200.818909
	C469.231781,204.233856 469.332520,207.648788 469.221924,211.930557
	C469.293243,214.599457 469.364563,217.268356 469.110260,220.831253
	C469.217041,226.575500 469.323822,232.319733 469.203156,238.848633
	C469.228485,239.934097 469.253815,241.019547 468.766907,242.592987
	C466.518616,244.525284 464.270355,246.457596 461.448090,248.883209
	C469.866150,248.883209 477.660583,248.883209 486.388885,248.883209
	C483.392822,246.296509 479.581726,244.596298 479.396179,242.564880
	C478.673889,234.658051 479.101807,226.646149 479.101807,217.069061
	C480.907440,219.567886 481.883911,220.783340 482.714661,222.091354
	C487.351562,229.392319 491.944641,236.721085 496.569550,244.029678
	C500.203430,249.772156 510.077240,251.772629 515.241882,248.062561
	C511.967468,245.185150 508.110077,242.686874 505.451111,239.259003
	C500.980316,233.495377 497.130646,227.224777 493.386627,220.948563
	C492.795105,219.957016 493.696503,217.466736 494.659760,216.279724
	C496.807037,213.633713 499.429810,211.373566 502.441284,208.667023
	C502.939880,207.726196 503.438477,206.785370 504.597198,205.583115
	C506.699402,201.014160 508.632080,196.438385 505.176514,191.256607
	C505.176514,191.256607 504.868256,191.019119 504.881897,190.376602
	C503.912140,189.649719 502.942352,188.922836 501.676697,187.878616
	C501.676697,187.878616 501.242920,187.888718 500.856659,187.284637
M451.583435,335.572449
	C449.738312,334.023315 447.893158,332.474213 446.058899,330.359589
	C445.377991,330.191162 444.697113,330.022766 443.412628,329.931335
	C442.927643,330.279175 442.442688,330.627014 441.303284,331.073334
	C440.922546,331.778870 440.541809,332.484406 439.515900,333.437225
	C439.312561,333.329071 439.109253,333.220917 438.889771,332.413788
	C438.164734,332.023804 437.439667,331.633820 436.239532,330.995453
	C435.838531,330.642792 435.437531,330.290131 435.002106,329.373322
	C434.299011,329.500153 433.595886,329.626984 432.393738,330.082306
	C431.945526,330.731903 431.497314,331.381500 430.340149,332.139954
	C430.082581,332.922638 429.824982,333.705322 429.383270,335.014832
	C429.206787,335.342102 429.030304,335.669403 428.238251,336.049866
	C428.121857,336.904419 427.584290,338.155640 427.956085,338.550354
	C430.770477,341.538239 433.657928,344.481873 436.779266,347.137665
	C437.498901,347.750000 439.211731,347.154510 440.465454,347.188995
	C442.399841,347.242188 444.524506,346.871948 446.228973,347.543243
	C450.857849,349.366241 452.188324,345.868073 453.759979,343.121216
	C455.275696,340.472137 456.482697,337.455383 451.583435,335.572449
M358.374878,434.438629
	C358.948029,433.670990 359.521179,432.903351 360.811981,432.178467
	C361.421631,431.444000 362.031281,430.709534 362.640961,429.975098
	C361.727570,429.716980 360.814148,429.458862 359.055359,429.136292
	C357.081177,429.188141 355.106995,429.239990 352.510315,429.030823
	C351.885101,429.416595 351.259888,429.802368 350.634644,430.188141
	C351.410522,430.811646 352.186401,431.435120 353.596252,432.527863
	C355.788086,437.688751 355.723419,442.936707 354.754974,449.291534
	C350.166595,443.254913 346.137817,438.250427 342.458466,433.001068
	C340.305542,429.929504 337.768280,428.519226 333.425903,428.999329
	C333.599640,430.028015 333.773376,431.056671 334.398193,432.575592
	C335.133575,433.663666 335.868958,434.751740 336.321106,436.758789
	C336.329773,440.576843 336.350250,444.394958 336.343964,448.212982
	C336.337189,452.307831 337.735321,456.878143 332.141449,458.953552
	C336.212250,461.606110 342.353516,461.348969 344.938690,458.502197
	C339.342896,456.830658 340.512604,451.851624 339.664307,447.003448
	C339.664307,444.809326 339.664307,442.615204 339.664307,440.421112
	C340.020416,440.363678 340.376526,440.306274 340.732605,440.248871
	C345.862732,446.840698 350.992859,453.432495 356.122986,460.024323
	C356.695465,459.756378 357.267944,459.488434 357.840424,459.220490
	C357.840424,456.471008 357.840424,453.721527 358.354279,450.340973
	C358.289154,445.221222 358.224060,440.101471 358.374878,434.438629
M449.792694,228.103287
	C453.898651,219.654221 454.554535,210.685608 452.091766,201.878677
	C450.996399,197.961731 447.424805,194.737228 444.681458,190.679123
	C444.006775,190.331345 443.332092,189.983551 442.234131,189.046021
	C438.772888,188.037338 435.335724,186.265427 431.846100,186.155151
	C418.413300,185.730621 404.963776,185.821243 391.520325,185.786270
	C390.672150,185.784058 389.822540,186.348587 388.433105,186.841019
	C389.432068,187.758286 389.952057,188.663269 390.565918,188.732208
	C395.757355,189.315262 396.230927,193.113113 396.241821,197.059738
	C396.280243,211.004471 396.312317,224.951111 396.086395,238.892807
	C396.049042,241.198212 394.707245,243.482483 393.219788,245.787170
	C391.678040,246.480057 390.136292,247.172943 388.594543,247.865814
	C388.721436,248.318558 388.848297,248.771286 388.975159,249.224014
	C390.644653,249.224014 392.314117,249.224014 394.798828,249.372406
	C403.197083,249.243088 411.595367,249.113754 420.841919,249.150223
	C428.103943,248.579224 434.476196,246.000687 440.266144,240.466629
	C442.181213,238.313934 444.096283,236.161255 446.598419,233.878311
	C446.910034,233.213821 447.221649,232.549332 447.948975,231.405151
	C448.383789,230.468658 448.818604,229.532166 449.792694,228.103287
M935.000000,353.000427
	C935.000000,353.000427 935.126099,353.119293 935.800110,353.036346
	C939.970581,347.278595 944.515076,341.752319 948.245972,335.722626
	C963.620911,310.874603 972.073669,283.950836 972.049805,254.524261
	C971.994507,186.361404 972.033081,118.198463 972.037598,50.035557
	C972.037964,44.869511 971.632324,39.653328 972.216736,34.552246
	C972.747131,29.922567 970.746094,29.107428 966.898438,29.109039
	C863.237488,29.152431 759.576538,29.171150 655.915649,29.085249
	C651.584534,29.081659 650.169495,30.380041 650.176819,34.808895
	C650.294250,105.971382 650.251892,177.134125 650.259033,248.296814
	C650.260193,259.927917 651.047241,271.343567 653.681274,282.866974
	C657.579285,299.919434 663.056396,316.169861 672.000610,331.139801
	C675.777710,337.461517 680.511475,343.211609 684.989258,349.570404
	C684.989258,349.570404 685.245178,349.867340 685.141785,350.573883
	C689.464966,355.790039 693.584229,361.195374 698.184570,366.154388
	C701.142883,369.343384 704.808777,371.876038 708.456787,374.975647
	C708.456787,374.975647 708.824707,375.144775 708.910828,375.821655
	C713.745178,379.844360 718.372131,384.152710 723.450623,387.839020
	C742.837158,401.910919 764.578125,411.013550 787.614868,417.024475
	C795.621277,419.113617 804.173340,421.996826 812.054871,421.041534
	C825.810364,419.374359 839.517517,415.872498 852.742615,411.588654
	C874.615845,404.503540 894.632751,393.428253 911.831909,378.072296
	C920.283569,370.526276 927.401550,361.486603 935.000000,353.000427
M541.840698,120.218765
	C541.176331,104.597221 540.914185,88.944870 539.720886,73.363838
	C538.758667,60.800007 536.760132,48.309566 534.954773,35.825123
	C534.764404,34.508953 532.776123,33.452789 531.621948,32.275993
	C530.618896,33.460297 529.195740,34.489021 528.689026,35.857151
	C526.949524,40.553143 527.321899,45.166096 528.004395,50.271786
	C530.135986,66.217461 531.063538,82.328407 532.304993,98.387100
	C533.061035,108.167419 533.172058,118.009232 534.236633,127.750870
	C535.349121,137.931030 540.201172,145.669983 548.797668,152.141769
	C553.654419,155.798141 555.803650,156.514938 560.649902,153.110306
	C564.891174,150.130615 570.325134,148.894806 575.116028,146.641617
	C584.851196,142.063156 594.275757,136.703781 604.300354,132.915100
	C608.919189,131.169449 610.442383,128.270050 611.608215,124.570457
	C612.532715,121.636757 610.875305,120.116829 607.797729,119.472984
	C597.745789,117.369995 587.743408,115.027824 577.732849,112.730217
	C574.491943,111.986374 571.180359,111.376915 568.080200,110.224220
	C555.147278,105.415474 545.428833,118.818512 547.458801,130.419556
	C547.744385,132.051895 548.009216,133.687897 548.283691,135.322205
	C543.126648,131.625290 543.073059,126.156700 541.840698,120.218765
M353.740356,375.094788
	C353.814270,383.891785 353.888184,392.688782 353.962067,401.485779
	C354.603180,401.568726 355.244263,401.651672 355.885345,401.734589
	C359.772858,396.995026 363.699585,392.231201 363.733704,385.497162
	C363.792694,373.847504 363.599335,362.195129 363.785828,350.548279
	C363.868622,345.378052 362.209839,339.859222 366.159363,335.185303
	C366.613129,334.648346 366.245575,333.258118 366.011597,332.325562
	C364.675537,327.000977 363.351044,321.670258 361.830963,316.396851
	C361.318268,314.618256 360.244873,313.001251 359.326538,311.100983
	C353.772949,316.546722 353.790436,316.644073 353.802887,327.226654
	C353.821320,342.869720 353.762543,358.512848 353.740356,375.094788
M86.547661,45.210178
	C73.873817,50.759769 61.199974,56.309364 48.526131,61.858955
	C48.213600,61.411167 47.901070,60.963375 47.588539,60.515587
	C49.255608,58.847843 50.958248,57.213852 52.580997,55.504047
	C54.749443,53.219261 56.210213,49.771397 60.494759,50.985645
	C60.632263,51.024612 61.966297,48.134274 62.098156,46.555672
	C62.245213,44.795090 61.989616,42.833492 61.312298,41.208172
	C60.103508,38.307503 58.930809,35.063263 56.739300,33.061581
	C55.856857,32.255573 51.816734,33.748638 50.104416,35.227009
	C45.024567,39.612812 45.362614,42.165508 50.726059,46.267616
	C51.716339,47.025002 52.585743,47.940434 53.735130,48.987072
	C49.368877,52.910645 45.392273,56.631828 41.254417,60.164112
	C36.343098,64.356667 31.147812,68.229439 26.410793,72.603790
	C25.303013,73.626762 25.544754,76.111137 25.165600,77.923149
	C26.989830,77.865952 29.055807,78.354324 30.601822,77.669273
	C51.865562,68.247078 73.067932,58.685947 94.261971,49.107143
	C101.982468,45.617805 109.725342,42.155514 117.254715,38.285362
	C118.698471,37.543251 119.191727,34.951931 120.123489,33.213734
	C118.271927,33.082573 116.147926,32.293167 114.613518,32.928257
	C105.415337,36.735397 96.352753,40.870152 86.547661,45.210178
M540.875122,230.469177
	C540.873596,220.483658 541.058044,210.493332 540.799072,200.514481
	C540.649658,194.754074 540.684998,189.494812 547.658264,187.712662
	C547.751648,187.688797 547.703186,187.110336 547.742737,186.397766
	C540.016785,186.397766 532.328186,186.397766 524.238770,186.397766
	C524.765137,187.401398 524.917969,188.124283 525.209778,188.185593
	C531.618530,189.532364 531.483948,194.448837 531.466797,199.386658
	C531.428589,210.370560 531.478210,221.354736 531.449707,232.338699
	C531.433350,238.615631 533.216675,245.701630 524.607666,248.747559
	C532.345276,248.747559 540.082886,248.747559 548.733398,248.747559
	C540.826416,242.782593 540.826416,242.782593 540.864807,233.950912
	C540.868408,233.118790 540.871094,232.286682 540.875122,230.469177
M242.743973,54.076843
	C253.501373,49.220123 264.312317,44.476173 274.973358,39.416420
	C277.245026,38.338272 278.971527,36.111427 280.949188,34.413795
	C280.637512,33.752117 280.325836,33.090435 280.014160,32.428757
	C278.103638,32.687561 276.046326,32.580509 274.311249,33.276611
	C269.846191,35.067974 265.557526,37.292801 261.138855,39.207062
	C238.113815,49.181988 215.056946,59.083660 192.055603,69.112747
	C189.980362,70.017601 187.846451,71.341515 186.448853,73.050621
	C185.529861,74.174438 185.884872,76.340050 185.669357,78.039131
	C187.213394,77.981544 188.962173,78.381943 190.270523,77.797104
	C207.564514,70.066513 224.796585,62.197350 242.743973,54.076843
M97.329346,236.341766
	C98.066765,242.085861 96.206062,246.301620 89.743156,248.171997
	C91.915695,249.123169 93.573578,249.499954 95.233353,249.508469
	C104.065704,249.553802 112.899071,249.451111 121.730698,249.539322
	C123.480721,249.556808 125.437546,249.797806 126.924469,250.616196
	C129.542923,252.057373 130.482483,251.345169 130.977402,248.651978
	C131.788208,244.239929 132.910431,239.882919 133.641800,235.459778
	C133.870438,234.076965 133.263016,232.555908 133.038315,231.098145
	C131.866776,232.172638 130.128418,233.028290 129.615387,234.357040
	C126.197006,243.210907 121.731583,246.335739 112.393784,246.660049
	C108.412544,246.798325 107.174850,245.470184 107.232277,241.519211
	C107.430847,227.855606 107.503777,214.183350 107.220589,200.522766
	C107.100464,194.727615 107.181305,189.590515 114.020897,187.724503
	C114.150139,187.689240 114.135124,187.125244 114.264015,186.343109
	C106.221313,186.343109 98.278976,186.343109 90.336632,186.343109
	C89.911842,186.777740 89.487061,187.212372 89.062271,187.647003
	C98.997375,189.293396 97.290314,196.261215 97.303970,202.385483
	C97.328499,213.385071 97.271912,224.384857 97.329346,236.341766
M570.076172,55.314487
	C581.054504,50.524132 592.100464,45.879879 602.969543,40.853256
	C606.177429,39.369686 608.885681,36.805885 611.822937,34.737122
	C611.505737,33.977551 611.188538,33.217976 610.871338,32.458405
	C608.961609,32.665916 607.002502,32.678036 605.158325,33.144585
	C603.755981,33.499344 602.531006,34.503262 601.173767,35.096016
	C585.321899,42.018921 569.402039,48.791328 553.653442,55.941109
	C550.797424,57.237751 548.101807,59.676483 546.262268,62.252239
	C542.886292,66.979385 545.421265,72.030579 551.252197,72.675385
	C552.616577,72.826263 554.121094,71.710457 555.561096,71.177429
	C554.912231,69.834846 554.437134,68.362236 553.559998,67.190559
	C552.850586,66.242920 551.657166,65.657669 550.062378,64.442123
	C557.037537,61.290855 563.229980,58.493187 570.076172,55.314487
M64.102989,331.205353
	C60.664398,327.662903 59.555836,332.167542 57.380135,333.367065
	C56.501087,332.770447 55.764503,332.041107 54.879753,331.719849
	C53.254658,331.129791 50.221798,330.129120 50.072582,330.431854
	C48.725189,333.165070 44.519840,335.678802 47.485931,339.073059
	C49.989697,341.938232 53.617222,343.821381 56.747349,346.139191
	C60.287292,341.306671 63.613937,346.667633 67.058098,346.346802
	C67.209389,346.332733 67.349808,346.195923 67.494209,346.114410
	C71.480698,343.862854 72.034988,337.933411 68.522568,334.830109
	C67.282150,333.734192 65.966156,332.723846 64.102989,331.205353
M42.136131,107.575401
	C44.663353,106.295929 46.559269,102.586502 50.190704,106.128426
	C54.248707,110.086395 56.859749,106.153008 59.146851,103.621353
	C60.051620,102.619820 60.263016,99.463150 59.465912,98.732597
	C56.818020,96.305794 54.707596,91.080460 49.835869,94.494423
	C47.112865,96.402618 45.523949,97.116379 42.675076,94.650902
	C39.460491,91.868896 36.648701,94.816429 34.557487,96.955994
	C33.534325,98.002823 32.983143,101.170570 33.729530,101.973335
	C35.890495,104.297569 38.817234,105.909805 42.136131,107.575401
M409.317841,428.844849
	C406.004791,428.844849 402.691772,428.844849 399.601898,428.844849
	C403.460968,439.793854 403.213348,449.714996 400.409973,459.879333
	C403.459076,459.879333 406.987427,459.879333 411.021729,459.879333
	C409.704712,457.870392 408.032318,456.504333 408.112335,455.250092
	C408.651398,446.802216 404.529358,437.808960 410.799744,429.967285
	C410.843170,429.912964 410.231018,429.334442 409.317841,428.844849
M537.295044,443.530029
	C536.926208,448.875183 536.557312,454.220306 536.173889,459.776123
	C538.644226,459.776123 542.265869,459.776123 546.579590,459.776123
	C541.396912,454.491669 541.299866,436.230621 545.826233,429.353516
	C541.953674,429.353516 538.230652,429.353516 535.743408,429.353516
	C536.299866,434.094666 536.796509,438.326294 537.295044,443.530029
M305.196381,87.782219
	C305.471771,87.177948 305.735443,86.568016 306.024384,85.970299
	C308.428101,80.998253 307.435577,79.348991 301.944641,79.294533
	C299.954346,79.274788 297.751556,78.848213 296.019165,79.541039
	C293.080597,80.716232 290.273590,82.418701 287.761841,84.354408
	C286.893738,85.023392 286.479248,87.322914 286.964233,88.360229
	C287.321320,89.123955 289.483337,89.313370 290.830841,89.284195
	C293.121246,89.234604 295.403625,88.811340 297.689362,88.545105
	C297.737579,88.861389 297.785828,89.177666 297.834076,89.493942
	C294.233521,92.297935 290.632996,95.101929 286.313416,98.465866
	C294.125641,100.323792 299.704956,96.936981 305.196381,87.782219
M476.258759,282.324524
	C476.842773,275.242828 474.721161,267.937469 478.062866,261.143646
	C474.915283,261.143646 471.833252,261.143646 468.376648,261.143646
	C472.108826,266.164703 472.089355,285.020966 468.614288,290.245056
	C471.961548,290.245056 475.172729,290.245056 478.150818,290.245056
	C477.465393,287.719604 476.861603,285.494904 476.258759,282.324524
M174.193726,280.937531
	C174.900375,274.382324 172.403839,267.507446 176.301361,261.292725
	C173.113464,261.292725 170.094666,261.292725 166.605240,261.292725
	C170.336639,266.217834 170.278427,285.048645 166.741394,290.149780
	C170.196030,290.149780 173.376831,290.149780 175.849091,290.149780
	C175.269012,287.228394 174.730591,284.516724 174.193726,280.937531
M260.189636,357.226410
	C261.404938,357.555389 262.825500,358.458374 263.798737,358.110382
	C267.333282,356.846466 268.515656,350.145630 265.687561,347.553223
	C263.262878,345.330597 260.557159,343.414520 258.033722,341.408966
	C251.534592,347.532379 251.532623,350.042694 257.684235,355.234558
	C258.320251,355.771362 258.973541,356.287689 260.189636,357.226410
M194.572357,122.864471
	C200.147186,118.743622 200.152557,118.674736 195.309662,113.658470
	C194.962860,113.299255 194.600433,112.952744 194.278778,112.572021
	C190.667557,108.297409 187.848328,111.369728 184.989944,113.607262
	C181.635757,116.232933 183.357468,118.409111 185.660904,120.547005
	C186.388107,121.221939 187.045242,122.001434 187.606613,122.820663
	C189.569809,125.685707 191.687347,126.019386 194.572357,122.864471
M591.471863,144.911575
	C589.179749,146.845642 585.985779,148.952347 589.310364,152.039581
	C591.735901,154.291962 593.554626,159.835663 598.261353,156.416443
	C600.390015,154.870087 605.518250,153.948776 603.161743,149.238525
	C600.739258,144.396469 595.921753,142.566254 591.471863,144.911575
M305.447662,429.218658
	C305.368561,429.706512 305.289429,430.194336 305.210297,430.682220
	C305.618652,430.691742 306.027039,430.701263 306.435394,430.710754
	C306.352509,430.209930 306.269592,429.709076 305.447662,429.218658
M391.474182,137.493240
	C391.474182,137.493240 391.513214,137.492493 391.474182,137.493240
z"/>
<path fill="#384E7D" opacity="1.000000" stroke="none"
	d="
M685.245178,349.867340
	C685.245178,349.867340 684.989258,349.570404 684.964233,349.034363
	C676.347961,335.097778 667.827515,321.682373 662.682190,306.433105
	C657.133728,289.989380 652.869812,273.343201 652.877502,255.827484
	C652.909729,183.028259 652.903870,110.229027 652.913818,37.429802
	C652.914734,30.923416 652.921021,30.914854 659.372620,30.914442
	C761.158325,30.907953 862.944153,30.937431 964.729614,30.791031
	C969.381042,30.784342 970.180725,32.345638 970.174072,36.529324
	C970.057922,109.661568 970.111267,182.794067 970.031189,255.926392
	C970.024841,261.720428 969.748596,267.583099 968.847290,273.295471
	C964.556763,300.490234 954.746643,325.452026 938.101746,347.572815
	C936.854919,349.229828 936.106262,351.261658 935.126099,353.119293
	C935.126099,353.119293 935.000000,353.000427 934.716064,353.044312
	C927.313110,360.251068 920.519653,367.776794 913.015503,374.510468
	C888.018127,396.941376 858.313538,409.926392 825.737976,416.774963
	C820.437439,417.889313 814.712708,419.451630 809.601013,418.519775
	C796.115662,416.061401 782.716797,412.836121 769.548401,409.005646
	C753.345947,404.292633 738.680542,396.157959 724.892090,386.469299
	C719.530884,382.702179 714.180176,378.920074 708.824707,375.144775
	C708.824707,375.144775 708.456787,374.975647 708.275513,374.508545
	C702.868469,368.374084 697.672302,362.679047 692.403381,357.052155
	C690.093811,354.585571 687.635742,352.258026 685.245178,349.867340
M963.893860,271.294098
	C963.777100,270.848328 963.660339,270.402557 963.817444,269.203644
	C964.031067,268.160675 964.244690,267.117737 964.990173,265.916962
	C964.952454,264.918396 964.914734,263.919830 964.600037,262.045349
	C964.600769,191.061691 964.604370,120.078033 964.591980,49.094376
	C964.591492,46.105782 964.441833,43.117207 964.494812,39.401363
	C964.394592,38.923252 964.294373,38.445141 964.133484,37.323494
	C963.770325,37.135452 963.407104,36.947411 962.474854,36.468765
	C962.055725,36.460518 961.636658,36.452271 960.917297,35.713825
	C959.635742,35.493103 958.354187,35.079536 957.072571,35.079136
	C859.925171,35.048725 762.777771,35.043964 665.630432,35.109505
	C664.003601,35.110600 662.377441,35.996132 660.112244,36.581078
	C659.767273,36.830868 659.422363,37.080662 658.530212,37.422367
	C658.523499,37.923923 658.516724,38.425480 658.308105,39.420284
	C658.348633,39.593262 658.389160,39.766235 658.082764,40.803539
	C657.939392,44.184052 657.796021,47.564564 656.938232,51.221821
	C656.640747,52.457798 656.084290,53.693523 656.083130,54.929787
	C656.039612,99.896370 656.033325,144.863037 656.115845,189.829514
	C656.118469,191.239243 657.112427,192.647125 657.831238,194.928619
	C657.769470,197.600540 657.707642,200.272476 656.932983,203.223404
	C656.640564,203.961029 656.095093,204.697861 656.092834,205.436340
	C656.040405,222.590836 656.017334,239.745682 656.115173,256.899719
	C656.121155,257.951294 657.170532,258.996857 657.946472,260.860901
	C658.176025,262.517700 658.405579,264.174530 658.295227,266.454346
	C658.700073,267.449585 659.104858,268.444855 659.527771,270.197632
	C659.631409,271.458862 659.734985,272.720062 659.463013,274.323029
	C659.671387,274.877411 659.879822,275.431824 660.070129,276.717072
	C660.234802,277.423798 660.399414,278.130554 660.263550,279.407562
	C660.655457,280.098145 661.047424,280.788727 661.558472,282.254883
	C673.540344,332.173553 701.886292,369.413208 747.842590,393.805054
	C748.576721,394.096252 749.310791,394.387421 750.696594,395.032928
	C754.940552,396.802551 759.184448,398.572205 763.795227,400.860748
	C764.546936,401.114532 765.298706,401.368317 766.603210,401.949158
	C767.231018,402.060638 767.858765,402.172119 768.830505,402.815643
	C769.574341,403.032196 770.318176,403.248749 771.687500,403.796661
	C772.613525,403.964539 773.539551,404.132446 774.806519,404.833466
	C775.557861,405.047577 776.309204,405.261688 777.764221,405.845123
	C780.289856,406.400391 782.815491,406.955658 785.709167,408.032776
	C786.484497,408.272827 787.259827,408.512878 788.669739,409.046814
	C789.591492,409.142029 790.513306,409.237213 791.847778,409.890594
	C792.917603,410.096741 793.987366,410.302887 795.749695,410.817749
	C796.501160,410.874023 797.252686,410.930328 798.518433,411.506195
	C801.027832,411.875824 803.537231,412.245422 806.760559,412.868011
	C807.514160,412.890015 808.267761,412.912018 809.489197,413.437927
	C810.988892,413.280579 812.488525,413.123260 814.790100,413.041809
	C815.841980,412.872620 816.893921,412.703430 818.612366,412.773224
	C819.611633,412.312042 820.610901,411.850830 822.042419,411.518463
	C822.350586,411.538300 822.642029,411.477783 823.309204,411.636108
	C823.867798,411.408356 824.426392,411.180634 825.747253,410.994110
	C826.477844,410.801636 827.208374,410.609161 828.529480,410.660370
	C829.229431,410.253693 829.929443,409.847046 831.313599,409.507324
	C832.209045,409.336212 833.104431,409.165100 834.736572,409.076111
	C836.029724,408.514191 837.322815,407.952271 839.050110,407.510559
	C839.358887,407.522339 839.647522,407.451721 840.374451,407.566254
	C841.084351,407.129639 841.794189,406.693024 843.221008,406.254456
	C844.129272,405.986725 845.037537,405.718964 846.552612,405.635651
	C847.228638,405.199219 847.904724,404.762756 849.316956,404.330444
	C851.863953,403.434052 854.410889,402.537689 857.584290,401.752258
	C858.252319,401.279327 858.920349,400.806396 860.312683,400.282135
	C880.161255,392.749969 897.626465,381.298096 913.174316,367.050323
	C930.066223,351.570862 942.534302,332.785370 952.633057,311.961853
	C952.805115,311.322662 952.977112,310.683441 953.168945,309.391724
	C953.490662,308.612610 953.812378,307.833496 954.693604,306.971863
	C954.806030,306.317139 954.918396,305.662445 955.084351,304.247253
	C956.466248,300.192902 957.848145,296.138550 959.784851,291.969025
	C959.822510,291.303406 959.860107,290.637756 959.928955,289.210236
	C960.377075,287.491577 960.825195,285.772919 961.816956,283.959900
	C961.868896,283.304077 961.920898,282.648224 961.982910,281.080048
	C962.447144,278.764313 962.911438,276.448547 963.809937,274.020905
	C963.859680,273.343903 963.909485,272.666901 963.893860,271.294098
z"/>
<path fill="#2E2F52" opacity="1.000000" stroke="none"
	d="
M176.785614,122.059998
	C176.888779,122.486244 176.991928,122.912483 176.810089,123.774521
	C176.814362,124.852478 177.103622,125.494644 177.544586,126.474930
	C177.776245,127.545952 177.856171,128.278854 177.706390,129.158203
	C177.902054,129.897400 178.327454,130.490158 178.906677,131.384308
	C179.680084,132.800217 180.299683,133.914719 180.919281,135.029205
	C181.070801,135.599106 181.222305,136.169006 181.651840,137.195282
	C182.267014,138.149231 182.604156,138.646805 182.978683,139.465393
	C184.347565,140.179062 185.679062,140.571716 187.385040,140.925385
	C189.005981,140.785995 190.252472,140.685608 191.822479,140.707352
	C192.802048,140.351334 193.458069,139.873199 194.372406,139.196106
	C195.027039,138.505844 195.423370,138.014557 195.819687,137.523270
	C196.848511,136.978073 197.877335,136.432861 199.365417,135.593170
	C200.626236,134.569244 201.427765,133.839813 202.229309,133.110367
	C202.938873,132.518265 203.648438,131.926178 204.698273,130.978348
	C205.400970,130.435760 205.763397,130.248932 206.476746,130.080750
	C208.158081,130.422287 209.488495,130.745178 210.881012,131.380005
	C210.813034,132.090378 210.682968,132.488831 210.263916,132.969116
	C209.994995,134.037094 210.015060,135.023239 210.121780,136.338837
	C211.095001,137.949661 211.981567,139.231033 212.932526,140.765930
	C213.661560,141.027527 214.326233,141.035599 215.362000,140.981491
	C216.484375,140.929901 217.235672,140.940506 218.161682,141.200851
	C219.578308,140.701385 220.820221,139.952179 222.062134,139.202988
	C222.957367,138.076279 223.852600,136.949554 225.184662,135.491592
	C225.466537,134.373230 225.311600,133.586105 225.156662,132.798981
	C224.864487,132.102554 224.572296,131.406143 224.455292,130.165741
	C224.124390,129.063614 223.618317,128.505447 223.112244,127.947289
	C222.055344,126.662567 220.998444,125.377846 219.619476,123.644058
	C218.516495,122.551529 217.735580,121.908073 216.954666,121.264618
	C216.107437,120.286507 215.260208,119.308403 214.221680,117.717896
	C210.269775,114.455315 206.509186,111.805130 202.748596,109.154953
	C202.748596,109.154953 202.352051,109.042473 202.162140,108.552460
	C200.727783,105.704437 198.154160,103.135017 198.489258,101.028236
	C199.475845,94.825310 201.846085,89.343193 207.734039,85.382774
	C226.709961,72.618980 247.147415,62.965000 268.623413,55.401016
	C271.258118,54.473061 274.376221,54.917618 277.270325,54.726131
	C277.270325,54.726131 277.000000,54.999237 277.078125,55.269112
	C279.382660,61.682137 275.847076,66.401367 273.172302,71.282745
	C271.305054,74.690498 269.188507,77.961678 267.183289,81.293854
	C267.183289,81.293846 267.020538,81.687080 266.503418,81.825401
	C264.273163,83.860405 262.560059,85.757088 260.846924,87.653770
	C260.657104,87.524086 260.467255,87.394402 260.277405,87.264717
	C261.134705,84.760010 261.991974,82.255302 262.849243,79.750595
	C262.849274,79.750595 262.997467,79.344841 263.516205,79.174530
	C264.605560,77.872643 265.176208,76.741066 265.746857,75.609489
	C266.713348,74.217575 267.679840,72.825653 269.268127,71.219559
	C270.782104,68.771629 271.674286,66.537865 272.566437,64.304100
	C270.243866,64.116203 267.686646,63.205784 265.640930,63.870216
	C258.271240,66.263802 250.810867,68.653084 243.883850,72.059044
	C236.588287,75.646217 229.864609,80.396523 222.891068,84.638626
	C222.891068,84.638626 222.579422,84.974098 221.990417,84.968094
	C219.582443,86.252525 217.763458,87.542976 215.944458,88.833420
	C215.944458,88.833420 215.678818,89.118240 215.177948,89.078247
	C214.092957,89.542877 213.508850,90.047501 212.688736,90.781944
	C212.108185,91.552429 211.763626,92.093094 211.419052,92.633751
	C210.012100,93.491264 208.605133,94.348778 206.672180,95.461655
	C205.310150,96.739731 204.474106,97.762428 203.638046,98.785126
	C204.802048,99.098213 205.966034,99.411301 207.130035,99.724380
	C207.130035,99.724380 206.986633,99.944481 206.964676,100.351242
	C207.627747,100.849419 208.312759,100.940826 209.338272,101.052544
	C210.123398,101.032265 210.568054,100.991684 211.012695,100.951096
	C211.317429,101.097618 211.622177,101.244141 212.259003,101.610443
	C212.688599,101.967934 212.786102,102.105629 212.927475,102.516418
	C213.647293,102.872360 214.323242,102.955215 215.367157,103.023026
	C216.460022,103.120918 217.184967,103.233879 217.955200,103.649246
	C217.826233,105.463005 217.651962,106.974358 217.569626,108.757889
	C218.673981,109.506752 219.686386,109.983421 220.698792,110.460091
	C224.685333,113.431656 228.671875,116.403221 233.107056,119.743042
	C234.294403,120.544907 235.033112,120.978531 235.771820,121.412155
	C236.453568,122.041290 237.135315,122.670433 238.204147,123.674545
	C239.358795,124.432793 240.126358,124.816071 240.893906,125.199348
	C241.872269,126.189781 242.850647,127.180214 244.193970,128.613541
	C245.307724,129.490677 246.056519,129.924911 246.805328,130.359146
	C247.498917,130.978165 248.192490,131.597183 249.249359,132.604156
	C250.376953,133.387894 251.141266,133.783661 251.905594,134.179428
	C252.257782,134.533279 252.609970,134.887131 253.377045,135.600525
	C260.517059,141.009277 268.848633,141.607071 274.635132,137.455597
	C274.959534,137.392654 275.283905,137.329712 276.144836,137.127335
	C279.602325,134.604965 282.788300,132.475739 285.375427,129.773224
	C288.436432,126.575668 290.874115,122.789040 293.816925,119.465813
	C294.646912,118.528557 296.300385,118.320518 297.576111,117.778008
	C297.849548,119.076408 298.432098,120.399139 298.332184,121.668129
	C298.123627,124.316490 297.329071,127.018227 300.779449,128.246399
	C300.779449,128.246399 300.988708,128.004883 301.042847,128.467224
	C306.011078,130.648468 310.616913,130.785889 314.331390,126.350037
	C314.331390,126.350037 314.046112,125.992165 314.514526,126.132782
	C315.407318,125.590172 315.831665,124.906937 316.256042,124.223701
	C316.256042,124.223701 316.015778,124.042488 316.454590,124.049652
	C317.575775,122.929268 318.101837,121.658340 318.975189,120.705917
	C320.491577,119.052284 322.222687,117.595589 323.863770,116.056305
	C323.832001,117.974861 323.469330,119.965965 323.869232,121.789886
	C324.212524,123.355591 325.096588,125.413910 326.340729,126.015877
	C327.887482,126.764244 330.050323,126.239273 331.947083,126.264236
	C331.839111,124.629890 331.808502,122.985832 331.604858,121.363495
	C331.310089,119.014900 330.684662,116.686012 330.638977,114.340179
	C330.623718,113.555740 331.897736,112.177216 332.682739,112.100769
	C333.524933,112.018753 334.966827,112.947815 335.317322,113.783585
	C337.980133,120.133362 339.009979,126.612305 335.412445,132.980652
	C331.850769,139.285538 326.247223,140.176804 320.805206,135.473511
	C320.195404,134.946472 319.513153,134.503250 318.864471,134.021164
	C318.989044,134.473709 319.113617,134.926254 319.238190,135.378784
	C314.210907,137.715622 309.309723,141.570236 304.124023,142.001160
	C297.787109,142.527756 294.654999,136.617157 292.774963,129.042023
	C289.549927,133.718079 287.366547,136.883835 285.183136,140.049606
	C284.472778,140.738190 283.762451,141.426788 282.614319,142.432953
	C281.694214,143.414444 281.211884,144.078369 280.729523,144.742310
	C280.729523,144.742294 280.966553,144.991928 280.514526,144.915421
	C277.869446,146.294846 275.626770,147.681931 273.492798,149.219788
	C267.424255,153.593094 261.284180,153.551422 255.064713,149.628647
	C252.439911,147.973114 249.872177,146.227097 247.278488,144.522217
	C246.501877,143.676071 245.725281,142.829926 244.615234,141.560211
	C243.602493,140.671112 242.923172,140.205566 242.243851,139.740021
	C242.243851,139.740021 242.012802,139.974960 242.082596,139.533081
	C238.408447,135.865555 234.664505,132.639938 231.270172,129.715515
	C229.796356,135.760178 228.531845,140.946442 227.267319,146.132690
	C227.267319,146.132690 227.119873,146.112030 226.804626,146.220123
	C225.142776,147.770905 223.796188,149.213577 222.449600,150.656265
	C221.771591,150.975983 221.093582,151.295700 219.838135,151.736572
	C218.512665,151.920441 217.764648,151.983170 216.740494,151.739990
	C214.780045,151.404465 213.095734,151.374863 211.100098,151.227478
	C208.842133,147.686646 206.895477,144.263641 204.778259,140.622864
	C204.062241,140.912537 203.516785,141.419968 202.903900,142.229736
	C202.644882,143.113174 202.453278,143.694275 202.261688,144.275360
	C201.533432,144.890045 200.805176,145.504730 199.615295,146.411011
	C198.418350,147.127579 197.683029,147.552551 196.601135,147.959885
	C195.492706,148.605591 194.730850,149.268936 193.772507,150.177063
	C192.632721,150.830093 191.689407,151.238373 190.314697,151.481171
	C187.916031,151.568222 185.948746,151.820770 183.626892,152.061066
	C181.984726,151.489883 180.697128,150.930969 179.409531,150.372040
	C178.474380,149.334366 177.539215,148.296692 176.349823,146.745193
	C175.210312,144.049286 174.325058,141.867188 173.592697,139.363480
	C173.337570,138.334427 172.929535,137.626968 172.369476,136.576965
	C172.133453,135.493835 172.049438,134.753281 172.224335,133.835083
	C172.057877,132.781586 171.632492,131.905716 171.079926,130.642761
	C170.958511,129.174866 170.964294,128.094055 171.220352,126.853745
	C171.182709,125.766380 170.894791,124.838516 170.493530,123.543915
	C169.900208,122.056190 169.420212,120.935204 168.754166,119.599800
	C168.064026,119.960312 167.559937,120.535240 167.003082,121.339279
	C166.950302,121.568405 166.660263,121.938530 166.328979,122.049667
	C165.827850,122.998444 165.658020,123.836082 165.441193,124.917847
	C165.274460,125.480598 165.081940,125.746529 164.485962,126.024673
	C163.834244,126.845116 163.513184,127.600639 163.132172,128.633453
	C163.055542,129.277374 163.038834,129.644012 163.022125,130.010666
	C162.604599,130.291992 162.187073,130.573303 161.178436,130.974213
	C160.045853,132.035904 159.504349,132.978012 158.962830,133.920120
	C158.033020,135.012894 157.103195,136.105667 155.674347,137.490631
	C154.286591,138.758926 153.397873,139.735062 152.509155,140.711182
	C149.481613,142.629913 146.454086,144.548645 142.838165,146.693359
	C139.833313,147.946548 137.416824,148.973755 134.572586,149.965912
	C130.189484,150.467789 126.234138,151.004730 121.958221,151.484467
	C119.835999,149.880951 118.034332,148.334671 116.232666,146.788391
	C116.232666,146.788391 116.095749,146.781464 116.190918,146.495453
	C116.222092,145.797348 116.158104,145.385223 116.359756,144.709412
	C116.416397,141.968002 116.207397,139.490311 116.025574,136.704376
	C116.404243,135.926147 116.755730,135.456146 117.345078,135.242340
	C118.495323,136.564484 119.407700,137.630447 120.320084,138.696411
	C120.320084,138.696411 120.001831,138.998779 120.081810,139.198593
	C122.940704,143.458603 122.940704,143.458603 125.453354,141.065582
	C127.239044,140.990967 128.616837,140.988266 130.125702,141.212280
	C130.903122,141.133835 131.549454,140.828659 132.195786,140.523499
	C132.195786,140.523499 132.121750,140.165604 132.388168,140.106415
	C134.834030,139.096344 137.013489,138.145462 139.192932,137.194580
	C139.192932,137.194580 139.038834,137.062851 139.436752,137.175583
	C140.510941,136.750595 141.187195,136.212891 141.863464,135.675171
	C142.176498,135.769974 142.475769,135.737595 143.248383,135.403778
	C144.420761,134.660629 145.106064,134.091736 145.791367,133.522842
	C145.791367,133.522842 145.970963,133.496857 146.388611,133.430679
	C147.659851,132.633652 148.513428,131.902802 149.367020,131.171951
	C149.676041,131.250137 149.923187,131.159515 150.510834,130.654144
	C151.515060,129.735916 152.116943,129.063660 152.718842,128.391388
	C153.532394,127.933205 154.345932,127.475021 155.788284,126.951012
	C156.879333,126.186340 157.341583,125.487495 157.803848,124.788651
	C157.803848,124.788651 157.985855,124.985054 158.248413,124.923843
	C158.942215,124.137733 159.373444,123.412834 159.804672,122.687943
	C160.322449,121.893288 160.840225,121.098633 161.709045,119.900055
	C162.490738,118.716187 162.921387,117.936226 163.352020,117.156265
	C163.686874,117.132225 163.923859,116.967422 164.408997,116.340332
	C165.258774,115.051674 165.762543,114.084534 166.266296,113.117386
	C166.598099,112.998894 166.824356,112.774155 167.433197,112.203354
	C167.709076,110.615234 167.496872,109.266922 167.154327,107.572037
	C166.820114,106.012329 166.616241,104.799210 166.570038,103.266586
	C166.280975,102.260468 165.834229,101.573853 165.246307,100.607086
	C165.048798,99.914764 164.992447,99.502586 165.011322,98.705856
	C164.056671,96.362427 163.026794,94.403542 161.881866,92.346977
	C161.766815,92.249290 161.466003,92.223724 161.466003,92.223724
	C161.622543,91.928001 161.634567,91.626503 161.445160,90.769775
	C161.281876,89.473671 161.175476,88.727051 161.298126,87.822945
	C161.051071,87.099129 160.574951,86.532799 160.098846,85.966461
	C159.954651,85.810135 159.810455,85.653801 159.562393,85.078995
	C159.440948,84.310699 159.423355,83.960876 159.547394,83.262154
	C159.127472,82.274628 158.565918,81.636009 158.004349,80.997391
	C158.004349,80.997391 157.695129,81.034050 157.664490,80.802635
	C157.540756,79.929581 157.447678,79.287949 157.540924,78.102554
	C157.592178,76.815346 157.457153,76.071884 157.314560,74.997482
	C157.425705,73.792595 157.544403,72.918655 158.000320,71.929443
	C159.975128,72.171486 161.612686,72.528793 163.250259,72.886093
	C163.250259,72.886093 163.456589,73.116859 163.327240,73.608864
	C163.712814,74.761116 164.227768,75.421364 164.864899,76.275238
	C164.987091,76.468864 165.048355,76.922668 164.989990,77.304398
	C165.886734,79.477150 166.841873,81.268181 167.796997,83.059212
	C168.062347,83.254662 168.272018,83.498085 168.554840,84.298935
	C168.796265,85.537727 168.908813,86.267059 168.781799,87.140152
	C168.985443,87.851112 169.428665,88.418304 170.048996,89.309662
	C170.416183,90.346077 170.606247,91.058327 170.484772,91.850006
	C170.692490,92.978989 171.211746,94.028557 171.843048,95.386261
	C171.972321,96.129097 171.989532,96.563812 171.745636,97.110718
	C171.777878,97.821861 172.071213,98.420799 172.482651,99.298882
	C172.669281,99.975250 172.737793,100.372467 172.508591,100.836670
	C172.695602,101.652443 173.180313,102.401230 173.665024,103.150017
	C173.665024,103.150017 173.948380,103.102379 173.942963,103.339737
	C173.917267,104.039436 173.897003,104.501770 173.536407,105.017189
	C173.674835,108.035622 174.145615,111.002380 174.670898,113.959473
	C174.686615,114.047935 175.273651,114.034912 175.710297,114.426422
	C175.852646,115.531364 175.879013,116.279076 175.645508,117.257767
	C175.852295,119.012489 176.318954,120.536240 176.785614,122.059998
z"/>
<path fill="#2F325C" opacity="1.000000" stroke="none"
	d="
M542.904846,389.285828
	C556.035950,389.205444 569.167114,389.125061 583.121765,388.982971
	C583.767151,387.245392 584.214478,385.036713 583.312317,383.977539
	C575.828064,375.191193 568.415588,366.300812 560.324158,358.089569
	C554.867432,352.552155 552.479736,346.865601 555.053833,339.409637
	C555.053833,339.409637 555.200256,338.994781 555.764648,338.930298
	C556.873291,338.217194 557.417603,337.568573 557.961914,336.919922
	C558.494141,336.402557 559.026306,335.885162 560.108093,335.244385
	C561.251465,334.582672 561.845276,334.044434 562.439087,333.506195
	C564.704346,332.292206 566.969604,331.078217 569.651123,330.206421
	C570.377441,332.698090 570.687500,334.847534 570.650574,337.041748
	C567.855347,338.762695 565.239319,340.243591 563.002380,342.165649
	C560.352112,344.442871 560.426086,346.646973 564.278198,348.260620
	C565.560059,350.133911 566.632385,351.731476 567.704773,353.329010
	C569.548279,355.167969 571.391785,357.006927 573.554443,359.347717
	C576.173218,361.986328 578.472717,364.123138 580.772278,366.259918
	C581.307251,367.042755 581.842285,367.825562 582.317383,369.295166
	C582.932678,370.610962 583.607727,371.239960 584.510742,372.033508
	C585.344971,372.608398 585.951172,373.018829 586.557434,373.429230
	C586.557434,373.429230 586.705200,373.765350 586.792297,374.210327
	C587.426697,375.249512 587.973938,375.843658 588.521240,376.437805
	C588.906250,377.129120 589.291260,377.820435 589.780823,379.073120
	C589.910400,380.093475 589.935364,380.552460 589.731567,381.193970
	C590.177490,382.603271 590.852173,383.830109 591.687317,385.445251
	C591.832520,387.210663 591.817261,388.587708 591.473267,390.015198
	C586.462646,396.500031 580.331055,398.612915 572.296143,398.215576
	C560.023499,397.608582 547.689880,398.233398 535.067383,398.244385
	C533.183899,396.591736 531.615112,395.029968 529.947632,393.176636
	C528.707581,392.951691 527.228943,392.578796 526.478271,393.154755
	C520.700684,397.587372 514.598633,400.093536 507.117981,398.130737
	C505.137695,397.611145 502.841888,398.294098 500.795776,398.270020
	C500.900543,398.115143 500.657532,398.399414 500.637695,398.031677
	C499.621674,397.169556 498.625458,396.675201 497.334534,396.119934
	C496.708984,395.838196 496.378113,395.617401 495.945679,395.124451
	C494.234528,395.244080 492.619141,395.613647 491.016663,396.032745
	C488.539398,396.680603 486.106079,397.714630 483.592377,397.964966
	C475.319427,398.788940 467.366699,398.206848 461.334412,391.316742
	C461.082275,391.028778 460.391479,391.124847 459.657990,390.950928
	C459.079224,390.767120 458.747498,390.674347 458.415802,390.581604
	C458.415802,390.581604 458.299866,390.235352 458.218872,389.753540
	C457.237518,388.040375 456.337097,386.809021 455.436707,385.577698
	C455.436707,385.577698 455.293274,385.238495 455.203796,384.764160
	C454.088501,383.126770 453.062653,381.963715 451.948242,380.454956
	C448.524017,377.390839 446.729156,380.200806 444.419678,381.958557
	C442.893005,383.120544 440.840912,383.592163 439.024048,384.372864
	C438.961121,382.705170 438.901764,381.037354 438.832123,379.369934
	C438.818481,379.043457 438.765106,378.718628 438.730042,378.393036
	C439.732758,377.048218 440.735443,375.703369 442.357239,374.197540
	C444.325134,372.767303 445.673981,371.498047 447.022827,370.228821
	C447.288513,370.031708 447.554199,369.834656 448.531067,369.755249
	C455.016418,369.243958 457.554138,372.706421 460.183838,377.276062
	C462.321228,380.990204 466.197815,383.703461 469.303101,386.860596
	C470.044342,387.168365 470.785553,387.476105 471.792145,388.283539
	C473.009644,388.944458 473.961792,389.105713 474.913940,389.266968
	C477.676697,389.219360 480.439423,389.171753 483.889832,389.430206
	C485.724121,389.220001 486.870789,388.703735 488.017456,388.187439
	C489.407532,387.190582 490.797577,386.193726 492.840210,385.046143
	C497.186676,382.188293 499.823486,383.125732 502.086090,386.978485
	C502.738892,388.089996 504.612152,388.484741 505.925903,389.208069
	C508.678497,389.163727 511.431061,389.119415 514.897217,389.396912
	C519.705933,390.149780 522.980835,388.893005 525.040649,385.135956
	C525.098572,384.918274 525.156555,384.700562 525.764160,384.127930
	C526.430725,382.963898 526.547729,382.154785 526.664734,381.345642
	C526.566772,362.570679 526.468811,343.795685 526.815308,324.379578
	C527.539185,323.145264 527.682190,322.410797 528.123169,321.984985
	C529.524414,320.632111 531.036682,319.394226 532.506042,318.111908
	C533.001221,319.711975 533.856140,321.297058 533.923401,322.914917
	C534.116638,327.563568 534.062439,332.226807 533.978027,336.881989
	C533.725342,350.814270 533.185913,364.746826 533.270630,378.676147
	C533.293762,382.467651 534.875427,386.418365 539.352661,387.840973
	C539.352661,387.840973 539.750427,387.832397 539.901855,388.294281
	C541.003845,388.932739 541.954346,389.109283 542.904846,389.285828
z"/>
<path fill="#7D8DAD" opacity="1.000000" stroke="none"
	d="
M935.463135,353.077820
	C936.106262,351.261658 936.854919,349.229828 938.101746,347.572815
	C954.746643,325.452026 964.556763,300.490234 968.847290,273.295471
	C969.748596,267.583099 970.024841,261.720428 970.031189,255.926392
	C970.111267,182.794067 970.057922,109.661568 970.174072,36.529324
	C970.180725,32.345638 969.381042,30.784342 964.729614,30.791031
	C862.944153,30.937431 761.158325,30.907953 659.372620,30.914442
	C652.921021,30.914854 652.914734,30.923416 652.913818,37.429802
	C652.903870,110.229027 652.909729,183.028259 652.877502,255.827484
	C652.869812,273.343201 657.133728,289.989380 662.682190,306.433105
	C667.827515,321.682373 676.347961,335.097778 684.874817,348.859924
	C680.511475,343.211609 675.777710,337.461517 672.000610,331.139801
	C663.056396,316.169861 657.579285,299.919434 653.681274,282.866974
	C651.047241,271.343567 650.260193,259.927917 650.259033,248.296814
	C650.251892,177.134125 650.294250,105.971382 650.176819,34.808895
	C650.169495,30.380041 651.584534,29.081659 655.915649,29.085249
	C759.576538,29.171150 863.237488,29.152431 966.898438,29.109039
	C970.746094,29.107428 972.747131,29.922567 972.216736,34.552246
	C971.632324,39.653328 972.037964,44.869511 972.037598,50.035557
	C972.033081,118.198463 971.994507,186.361404 972.049805,254.524261
	C972.073669,283.950836 963.620911,310.874603 948.245972,335.722626
	C944.515076,341.752319 939.970581,347.278595 935.463135,353.077820
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M312.819611,70.061043
	C312.819611,70.061043 312.589783,69.892487 312.704681,69.374992
	C312.167542,68.262100 311.515472,67.666695 310.863434,67.071289
	C310.511230,66.704155 310.159027,66.337029 309.859192,65.316895
	C309.207611,63.811028 308.503632,62.958149 307.799652,62.105270
	C307.799652,62.105274 307.412567,62.062122 307.256226,61.691078
	C306.531677,60.681767 305.963531,60.043499 305.395355,59.405231
	C305.395355,59.405231 305.415405,59.112595 305.349548,58.698681
	C305.187225,57.858238 305.090729,57.431705 305.232269,56.831757
	C304.895447,56.149414 304.320618,55.640488 303.745758,55.131561
	C303.745758,55.131565 303.412476,55.033195 303.301056,54.659645
	C302.766052,53.232723 302.342468,52.179356 301.970398,50.778988
	C301.421936,49.603462 300.821960,48.774929 300.010742,47.723518
	C299.310974,47.154495 298.822479,46.808350 298.333954,46.462204
	C298.314819,46.148975 298.206299,45.870590 297.969971,45.049667
	C296.984894,43.964027 296.038177,43.455776 295.062683,42.956356
	C295.033875,42.965187 295.048462,42.906101 295.051941,42.455883
	C295.023376,38.977249 294.991333,35.948830 295.213104,32.797691
	C296.601898,32.865334 297.736847,33.055698 298.871826,33.246067
	C298.882782,33.561123 298.983887,33.843952 299.159729,34.698898
	C299.866058,35.766998 300.587769,36.230751 301.309509,36.694504
	C301.309509,36.694504 301.017212,37.002697 301.094482,37.195961
	C303.255157,39.661087 305.338593,41.932949 307.424805,44.202240
	C305.552612,48.657101 316.894348,68.070389 324.859528,74.037277
	C324.859528,74.037277 325.165466,74.243027 325.129242,74.797134
	C329.494141,81.051926 333.614685,87.000061 338.368378,92.389816
	C344.134491,98.927460 350.388855,105.039497 356.533936,111.234566
	C358.283417,112.998268 360.258606,113.796257 361.133698,110.291550
	C361.133698,110.291550 361.097504,110.125778 361.515259,110.084518
	C368.191467,102.983398 374.579498,96.031403 380.613495,88.784622
	C382.046326,87.063782 382.983032,84.349770 382.964630,82.102287
	C382.889832,72.971596 382.455322,63.838963 381.938965,54.719193
	C381.734680,51.110912 380.727539,47.547062 380.538452,43.939266
	C380.387360,41.056599 380.921844,38.138000 381.152039,35.235352
	C381.691254,35.222054 382.230469,35.208755 382.769684,35.195461
	C383.821045,38.025185 385.044861,40.804867 385.883972,43.696186
	C387.188171,48.189838 390.662903,52.701393 386.175598,57.386909
	C385.830780,57.746979 386.020599,58.681042 386.064575,59.341473
	C386.372467,63.969624 386.620911,68.604836 387.093445,73.216789
	C387.214294,74.396507 388.005554,76.407585 388.603455,76.450798
	C389.843079,76.540382 391.521301,75.902069 392.383698,74.973061
	C396.783600,70.233482 401.106964,65.408989 405.201630,60.405159
	C407.654449,57.407730 409.638794,54.026966 411.833710,50.818497
	C411.833710,50.818497 411.989838,50.950348 412.246277,50.919151
	C413.366150,49.649757 414.229584,48.411564 415.093018,47.173367
	C415.093018,47.173363 415.065521,47.082764 415.452179,47.056587
	C418.964905,43.782932 422.091003,40.535458 425.217072,37.287979
	C425.657959,37.604649 426.098816,37.921322 426.539703,38.237991
	C424.942291,40.757721 423.410095,43.321835 421.732056,45.786659
	C419.290527,49.372871 416.743896,52.887527 414.242096,56.432709
	C414.242096,56.432709 414.092834,56.797127 413.611694,56.883636
	C412.724792,57.580891 412.319061,58.191639 411.913330,58.802383
	C408.263977,63.152630 404.614624,67.502869 400.320190,71.994370
	C399.122711,73.101151 398.570312,74.066666 398.017914,75.032181
	C395.501343,78.198761 392.984741,81.365349 389.837830,84.833893
	C387.623779,89.210144 386.530609,93.253746 389.950165,97.015228
	C390.093140,97.739685 390.236084,98.464134 389.979187,99.810196
	C389.416138,105.177666 389.138794,109.925026 389.200836,114.667961
	C389.211334,115.470428 390.682770,116.253792 391.433563,117.478165
	C391.544769,119.924004 391.701630,121.937645 391.858521,123.951294
	C391.702484,124.385460 391.546448,124.819626 390.870422,125.602493
	C390.358063,127.997536 390.365723,130.043900 390.373352,132.090256
	C390.375427,132.532730 390.377472,132.975189 389.852844,133.764877
	C387.023804,134.992615 389.265869,140.092361 384.796204,138.642822
	C384.845734,137.873642 384.910431,137.436462 385.363953,136.904724
	C387.194763,132.119751 388.513214,127.435005 385.006653,122.553772
	C384.860626,120.442123 384.829956,118.741516 385.054108,116.900894
	C385.133209,116.160408 384.957520,115.559937 384.711517,114.645638
	C384.382507,113.545105 384.123779,112.758385 383.865051,111.971664
	C383.730286,110.251076 383.595520,108.530479 383.898254,106.296082
	C384.523651,102.410988 384.999817,99.023201 384.808044,95.673668
	C384.655762,93.014397 383.337616,92.824486 380.806824,95.102264
	C380.022827,96.551346 379.364532,97.691521 378.706268,98.831688
	C378.398010,98.848709 378.123627,98.953979 377.264313,99.163696
	C376.222992,99.984543 375.800446,100.789192 375.377899,101.593849
	C374.874878,102.387611 374.371826,103.181374 373.519989,104.285690
	C372.830780,104.760078 372.490356,104.923927 371.766632,105.115593
	C371.071014,105.979820 370.758667,106.816238 370.446350,107.652649
	C370.039520,108.289101 369.632690,108.925552 368.815979,109.885406
	C367.818268,111.074036 367.230377,111.939262 366.642456,112.804489
	C366.027283,113.507874 365.412079,114.211250 364.400391,115.303299
	C363.989044,116.972015 363.974213,118.252052 363.916809,119.849594
	C364.660736,121.180740 365.447235,122.194389 366.233765,123.208038
	C366.233765,123.208038 366.518036,123.150116 366.587036,123.455940
	C366.707977,124.182381 366.759918,124.602997 366.600739,125.206757
	C366.916992,125.929955 367.444397,126.470001 367.971771,127.010056
	C368.168335,127.429337 368.364868,127.848610 368.591797,128.963867
	C368.514282,131.750015 368.406433,133.840149 367.975403,136.126465
	C367.080444,138.499771 366.508698,140.676880 365.936920,142.854004
	C364.475708,144.480759 363.014496,146.107498 360.852173,147.815674
	C355.438080,149.228058 350.725067,150.558990 345.681030,151.880127
	C344.915710,151.869476 344.481415,151.868622 344.047119,151.867767
	C344.047119,151.867767 343.889557,151.624268 343.680664,151.315186
	C342.989960,150.323303 342.508118,149.640488 342.038666,148.488052
	C341.849457,144.479263 341.647888,140.940109 341.490173,137.153473
	C341.683594,136.606689 341.833130,136.307373 342.279602,135.991791
	C342.691528,135.309692 342.806519,134.643860 342.983582,133.655243
	C343.059967,132.903229 343.074219,132.473984 343.088470,132.044754
	C343.088470,132.044754 343.472778,131.968491 344.031128,131.948090
	C345.686096,129.879623 346.782684,127.831535 347.879272,125.783447
	C347.888794,125.454109 348.031281,125.199043 348.877930,124.960800
	C349.989899,123.983711 350.530640,123.064095 351.180847,121.804924
	C351.011627,120.090805 350.732971,118.716248 350.454285,117.341690
	C349.930969,116.581398 349.407654,115.821114 348.859802,114.411301
	C348.115326,113.281319 347.395447,112.800880 346.675537,112.320442
	C346.675537,112.320442 346.996338,112.001755 346.893860,111.790039
	C346.055939,111.128708 345.320557,110.679092 344.585144,110.229477
	C344.585144,110.229477 344.230927,110.302750 344.036255,110.008064
	C343.320801,109.315216 342.799988,108.917061 342.279205,108.518898
	C340.452423,106.412445 338.625641,104.305992 336.511841,101.711975
	C335.602295,100.700439 334.979797,100.176483 334.357330,99.652527
	C334.357330,99.652519 334.001221,99.997559 334.144012,99.501907
	C333.626892,98.498642 332.966980,97.991028 332.307068,97.483414
	C331.797546,96.709892 331.288025,95.936378 330.583679,94.684448
	C330.257355,93.807724 330.125946,93.409401 329.982452,92.657303
	C328.941956,91.224396 327.913574,90.145279 326.668671,88.974594
	C326.169220,88.706329 325.994537,88.454529 325.971130,87.798111
	C325.356812,86.933769 324.699493,86.398949 324.042175,85.864136
	C324.042175,85.864128 323.669312,85.868820 323.495209,85.516647
	C322.706543,84.552368 322.092010,83.940254 321.477448,83.328156
	C321.229034,82.898254 320.980621,82.468353 320.471680,81.630707
	C319.815399,80.466583 319.419617,79.710197 319.041901,78.592705
	C318.320343,77.515175 317.580719,76.798752 316.841125,76.082329
	C316.841125,76.082329 316.455200,76.046501 316.304413,75.682678
	C315.764954,74.554794 315.376282,73.790726 315.015015,72.659500
	C314.301453,71.548576 313.560547,70.804810 312.819611,70.061043
M349.763245,133.185913
	C349.191833,135.100830 348.376770,136.996429 348.222168,138.944443
	C348.183990,139.425201 350.528442,140.798019 351.374695,140.522614
	C354.774719,139.416122 358.122467,138.014160 361.243622,136.279053
	C362.039154,135.836823 362.592041,133.418411 362.112946,132.513199
	C360.706635,129.856125 358.725037,127.503517 356.509125,124.384735
	C353.949921,127.688423 352.052673,130.137558 349.763245,133.185913
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M322.109436,389.346680
	C327.549347,387.920990 328.730865,384.383789 328.602722,378.966003
	C328.204987,362.147125 328.455170,345.312988 328.442963,328.484772
	C328.442108,327.321289 328.696442,325.998566 328.245453,325.020294
	C325.318512,318.671082 329.786896,315.284637 334.152252,310.311127
	C336.089935,315.773804 337.951202,320.315430 339.288269,325.006500
	C340.422546,328.986145 343.833008,333.222839 338.638702,337.123383
	C337.863556,337.705505 338.281342,339.978821 338.278107,341.470032
	C338.252502,353.299744 338.321899,365.130157 338.214233,376.958984
	C338.184052,380.274109 337.938202,383.638123 337.313019,386.887695
	C335.312256,397.287384 329.882416,401.627380 319.281891,401.639618
	C318.282196,401.640778 317.274994,401.714447 316.284119,401.619843
	C312.034241,401.213989 310.055725,402.428589 311.160522,407.260010
	C312.219666,411.891663 311.277161,416.325867 306.953735,419.196350
	C302.645142,422.056976 297.097198,421.132599 294.258789,416.642548
	C292.248383,413.462250 290.675781,409.808411 289.815369,406.152344
	C288.922791,402.359253 287.006683,401.576965 283.501312,401.559631
	C277.327393,401.528992 270.778870,403.077454 265.467987,397.900909
	C264.850616,397.299164 262.095245,398.339508 260.680328,399.195770
	C250.447800,405.387817 238.545166,402.297333 233.085510,391.712708
	C231.274536,388.201782 229.638046,389.899048 227.653061,391.312317
	C219.938248,396.805450 212.194427,402.258087 204.430420,407.681458
	C203.485626,408.341400 202.365524,408.759918 201.305466,409.243896
	C192.085068,413.453308 187.505646,413.054840 182.705185,407.641907
	C176.662613,400.828369 175.438644,391.645264 179.736389,384.519287
	C180.847855,382.676392 182.104950,380.847382 183.630020,379.353973
	C184.639572,378.365387 186.245743,377.986053 187.584808,377.333923
	C188.003967,378.975922 189.090332,380.795227 188.710358,382.224854
	C187.776459,385.738800 186.015427,389.023254 184.871536,392.493744
	C183.635361,396.244202 184.461746,398.799530 189.507263,398.730957
	C186.814133,399.409149 183.792480,399.648590 180.893570,399.878326
	C181.625580,401.310425 182.215729,403.093872 183.328827,404.447144
	C184.248856,405.565643 185.721771,406.765961 187.061783,406.913757
	C194.692535,407.755341 201.592667,405.350128 207.782135,401.105377
	C214.459183,396.526215 220.942093,391.658173 227.418213,386.794342
	C230.371826,384.576050 232.626328,384.045898 234.456406,388.066895
	C239.081451,398.228912 250.907303,401.519989 259.916351,394.983246
	C262.554962,393.068695 264.137634,392.896179 266.777405,395.057495
	C268.785156,396.701385 271.765533,397.558411 274.425568,397.906494
	C278.028870,398.377960 281.782074,397.702820 285.385712,398.173096
	C287.084320,398.394775 289.188751,399.783173 290.058075,401.261200
	C292.436707,405.305298 294.119202,409.752075 296.350708,413.892029
	C297.690704,416.378082 299.789368,418.024750 302.903412,416.551025
	C305.906738,415.129730 308.356110,413.293518 308.061432,409.436096
	C307.788239,405.859894 307.589294,402.278046 307.314453,398.031036
	C311.381439,398.031036 315.166504,397.916229 318.942017,398.057312
	C324.973267,398.282715 329.573822,395.812836 332.509216,390.675018
	C333.334320,389.230835 332.972015,387.108246 333.154388,385.296844
	C331.720947,386.075378 330.241791,386.781372 328.864777,387.649384
	C326.780792,388.963043 325.448944,393.068970 322.109436,389.346680
z"/>
<path fill="#232657" opacity="1.000000" stroke="none"
	d="
M321.691528,389.263092
	C325.448944,393.068970 326.780792,388.963043 328.864777,387.649384
	C330.241791,386.781372 331.720947,386.075378 333.154388,385.296844
	C332.972015,387.108246 333.334320,389.230835 332.509216,390.675018
	C329.573822,395.812836 324.973267,398.282715 318.942017,398.057312
	C315.166504,397.916229 311.381439,398.031036 307.314453,398.031036
	C307.589294,402.278046 307.788239,405.859894 308.061432,409.436096
	C308.356110,413.293518 305.906738,415.129730 302.903412,416.551025
	C299.789368,418.024750 297.690704,416.378082 296.350708,413.892029
	C294.119202,409.752075 292.436707,405.305298 290.058075,401.261200
	C289.188751,399.783173 287.084320,398.394775 285.385712,398.173096
	C281.782074,397.702820 278.028870,398.377960 274.425568,397.906494
	C271.765533,397.558411 268.785156,396.701385 266.777405,395.057495
	C264.137634,392.896179 262.554962,393.068695 259.916351,394.983246
	C250.907303,401.519989 239.081451,398.228912 234.456406,388.066895
	C232.626328,384.045898 230.371826,384.576050 227.418213,386.794342
	C220.942093,391.658173 214.459183,396.526215 207.782135,401.105377
	C201.592667,405.350128 194.692535,407.755341 187.061783,406.913757
	C185.721771,406.765961 184.248856,405.565643 183.328827,404.447144
	C182.215729,403.093872 181.625580,401.310425 180.893570,399.878326
	C183.792480,399.648590 186.814133,399.409149 189.937195,398.865295
	C190.485794,398.426422 190.932999,398.291870 191.880798,398.489807
	C193.266708,399.018982 194.332047,399.636597 195.009308,399.346954
	C201.386978,396.618866 207.734955,393.812042 213.987549,390.811371
	C214.874969,390.385437 215.205765,388.799591 215.794174,387.750610
	C215.794174,387.750610 215.914764,387.958618 216.209290,387.925415
	C220.604996,385.786774 225.441147,384.413696 225.792145,378.571198
	C225.792145,378.571198 225.885345,378.197754 226.419983,378.079407
	C230.918564,376.042542 230.509216,372.589355 229.529617,369.383118
	C227.857101,363.909027 225.564896,358.622559 223.939575,353.136810
	C223.428192,351.410828 224.219406,349.298889 224.414413,347.363617
	C225.798721,348.633636 227.943207,349.658569 228.444550,351.213318
	C231.819107,361.678375 235.256943,372.157288 237.813889,382.837677
	C239.135712,388.358917 242.602753,389.997162 247.148010,390.772919
	C254.574554,392.040375 257.269928,390.937408 260.031006,386.078644
	C260.031006,386.078644 260.018707,386.007355 260.435272,386.032654
	C261.344299,385.998199 261.953156,386.104095 262.311035,385.852692
	C265.509644,383.605682 268.118713,382.748871 269.697479,387.716248
	C269.973053,388.583405 272.461700,388.747223 273.928284,389.235901
	C274.386597,389.221222 274.844910,389.206543 275.728607,389.636292
	C277.788940,389.890839 279.423889,389.701050 281.058838,389.511230
	C281.786072,389.434509 282.513275,389.357758 283.723572,389.723083
	C287.471008,391.563477 290.051697,391.182465 292.128510,387.873505
	C292.794189,386.812897 294.696289,386.528351 296.280029,386.135559
	C297.595825,386.659241 298.664307,386.936035 299.732788,387.212860
	C300.126617,385.279114 300.520416,383.345398 300.914215,381.411652
	C300.437408,381.298523 299.960602,381.185425 299.483826,381.072296
	C298.340332,382.119843 297.196838,383.167389 295.791748,383.974976
	C297.005127,378.624969 295.850586,371.945007 303.363892,370.076355
	C306.806335,375.135956 306.833130,379.859680 304.238068,384.941711
	C303.618256,386.155487 303.942871,389.181946 304.617310,389.457855
	C306.170929,390.093475 308.206207,389.551666 310.046082,389.487579
	C310.776550,389.415985 311.507019,389.344421 312.686401,389.680664
	C314.443115,389.900909 315.750854,389.713348 317.058624,389.525787
	C318.463623,389.410370 319.868622,389.294952 321.691528,389.263092
M297.307800,403.512268
	C296.981598,404.040009 296.655396,404.567719 296.329193,405.095428
	C296.592804,405.226044 296.856415,405.356689 297.119995,405.487335
	C297.317383,404.970581 297.514801,404.453796 297.307800,403.512268
M301.580322,405.808899
	C301.202179,405.804138 300.824066,405.799347 300.445923,405.794586
	C300.444733,405.951416 300.432648,406.244476 300.443970,406.245361
	C300.819489,406.275452 301.197296,406.277557 301.580322,405.808899
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M117.107216,134.986160
	C116.755730,135.456146 116.404243,135.926147 115.748665,136.703461
	C114.987534,137.252457 114.530487,137.494125 113.785080,137.869125
	C112.695610,138.685562 111.894508,139.368683 110.739525,140.072723
	C109.924431,141.059906 109.463219,142.026169 108.905075,143.306015
	C108.150841,144.720062 107.493538,145.820511 106.836235,146.920975
	C106.431908,147.228073 106.027573,147.535172 105.028442,147.946472
	C103.013092,149.809341 101.592537,151.568024 100.171982,153.326706
	C100.171982,153.326706 100.188347,153.697876 99.879684,153.902863
	C98.603584,154.571381 97.636154,155.034897 96.236298,155.377701
	C92.372360,155.347672 88.940849,155.438354 85.509338,155.529037
	C85.509338,155.529037 85.655319,155.345856 85.689514,155.071442
	C84.538170,153.517334 83.352615,152.237625 82.035522,150.795502
	C81.903969,150.633057 81.872284,150.216217 81.938477,149.877380
	C81.482925,148.664108 80.961189,147.789673 80.306580,146.607727
	C80.156906,145.855759 80.140106,145.411301 80.378220,144.737671
	C79.890068,143.796524 79.146988,143.084564 78.096672,142.266541
	C76.292435,140.351944 74.795441,138.543442 73.477272,136.348328
	C72.395126,133.320374 71.134148,130.679001 69.723091,127.744919
	C68.720314,125.948288 67.867607,124.444374 67.012344,122.652107
	C66.357605,122.179123 65.705429,121.994499 64.700584,121.905128
	C61.577122,124.338921 58.806328,126.677460 55.649773,129.046265
	C54.661564,130.597031 54.059120,132.117554 53.455753,133.885010
	C53.397514,134.468124 53.248867,134.757339 52.657555,135.045807
	C49.674160,141.192749 47.042103,147.293488 44.410046,153.394226
	C44.279091,153.272781 44.148140,153.151321 43.830688,153.145203
	C43.287128,153.997177 42.930073,154.733826 42.573017,155.470474
	C42.573017,155.470474 42.475994,155.462769 42.079582,155.377274
	C38.989506,155.336212 36.295834,155.380646 33.602165,155.425064
	C33.701035,155.287598 33.799900,155.150146 33.825974,154.841843
	C33.049248,154.229477 32.345306,153.787964 31.641369,153.346451
	C31.641369,153.346451 32.019341,153.062164 31.931671,152.847351
	C30.885653,151.423538 29.927301,150.214508 28.803371,148.836243
	C28.457537,148.398438 28.355906,148.102875 28.498375,147.370087
	C28.027569,143.636703 27.255251,140.332214 26.794861,136.984848
	C26.370075,133.896332 26.280014,130.761780 26.042522,127.647514
	C26.615349,127.630028 27.188175,127.612549 27.761003,127.595062
	C27.869696,129.037827 27.731939,130.553192 28.131611,131.910263
	C29.535484,136.677063 27.602234,142.614822 33.256271,146.106384
	C33.890259,146.299454 34.253815,146.389206 34.617371,146.478958
	C34.617371,146.478958 34.555798,146.558334 34.617928,146.891220
	C35.087032,147.633270 35.493999,148.042435 35.990883,148.733841
	C37.083401,148.801453 38.086002,148.586823 39.309181,148.194458
	C39.834404,147.571609 40.139046,147.126480 40.443691,146.681335
	C40.443691,146.681335 40.578682,146.584274 40.963619,146.526489
	C41.729897,145.997009 42.111233,145.525299 42.841869,145.058212
	C43.758095,143.990067 44.325020,142.917267 44.920570,141.633896
	C44.949192,141.423309 45.155033,141.051422 45.423431,141.017792
	C45.869640,140.340973 46.047455,139.697784 46.261639,138.708542
	C46.303825,137.678513 46.309639,136.994568 46.315453,136.310608
	C46.315456,136.310608 46.182758,136.237534 46.499096,136.260025
	C46.815434,136.282516 47.266182,136.108932 47.595757,136.005493
	C48.570900,133.892426 49.216469,131.882812 49.871796,129.868530
	C49.881550,129.863876 49.845516,129.850891 50.250610,129.808151
	C50.894447,128.582703 51.133190,127.400002 51.371933,126.217293
	C51.504513,125.660675 51.637093,125.104050 52.132912,124.157593
	C52.650158,123.171448 52.804169,122.575150 52.958176,121.978851
	C53.388748,121.354019 53.819321,120.729187 54.904251,119.988602
	C55.902760,119.029449 56.246910,118.186050 56.591057,117.342644
	C58.146858,115.537056 59.702663,113.731476 61.729553,112.135361
	C64.494179,112.131935 66.787720,111.919029 69.081261,111.706123
	C69.890129,112.328056 70.698997,112.949997 71.666306,114.150818
	C72.234558,115.792343 72.644363,116.854996 73.016487,118.316597
	C74.230812,121.497849 75.482819,124.280151 76.940231,127.281448
	C77.634209,127.813477 78.122780,128.126526 78.611343,128.439560
	C79.551270,129.529343 80.491203,130.619125 81.826714,132.151917
	C84.147079,133.057327 86.071854,133.519745 88.140930,134.205704
	C88.887505,134.075256 89.489799,133.721298 90.350311,133.189270
	C91.002075,132.881958 91.395615,132.752686 92.036453,132.963669
	C93.644226,133.536652 95.004700,133.769379 96.467743,134.286194
	C96.680885,135.355453 96.791458,136.140625 96.902023,136.925781
	C96.902023,136.925781 96.648689,136.947372 96.250061,136.909668
	C95.613205,137.591660 95.374985,138.311325 95.066765,139.353210
	C94.978683,140.106232 94.960602,140.537048 94.942528,140.967865
	C94.161934,141.597061 93.381332,142.226257 91.916046,142.950333
	C89.959633,143.360916 88.561325,143.445526 87.450134,144.054260
	C86.225334,144.725250 85.264183,145.877472 84.188187,146.820068
	C85.334572,147.859589 86.329460,149.489777 87.655251,149.829849
	C91.935417,150.927689 97.996056,147.343353 99.977203,142.953522
	C100.150024,142.674286 100.322838,142.395050 101.101303,142.044373
	C102.392342,140.895874 103.077728,139.818817 103.763107,138.741760
	C103.763115,138.741760 103.955002,138.900543 104.215439,138.871811
	C104.967461,137.867264 105.459030,136.891449 106.057953,135.597809
	C109.034966,131.487503 111.904617,127.695038 114.774277,123.902580
	C116.895111,121.974251 119.015953,120.045921 121.669342,117.845505
	C123.364059,116.951019 124.526245,116.328613 126.023666,115.767906
	C126.928764,115.252777 127.498619,114.675949 128.059601,114.074188
	C128.050720,114.049271 128.102814,114.071716 128.501450,114.072754
	C131.551270,111.849396 136.570770,115.002838 138.023117,110.056168
	C138.765594,109.984825 139.508057,109.913490 140.632034,110.307190
	C142.339447,111.191856 143.665359,111.611481 144.991272,112.031105
	C144.991272,112.031105 145.475525,112.087959 145.768570,112.326691
	C146.400665,113.003601 146.739716,113.441780 147.053726,114.282440
	C147.212601,116.020142 147.396484,117.355377 147.577667,118.671021
	C145.573792,119.043083 143.998398,119.335594 142.079620,119.637314
	C140.355499,119.626923 138.974777,119.607330 137.175705,119.401360
	C135.224548,119.911636 133.691757,120.608292 132.034851,121.412804
	C131.910751,121.520653 131.588058,121.583885 131.238617,121.440430
	C130.288391,121.900101 129.687592,122.503227 129.045593,123.053040
	C129.004395,122.999733 129.097015,123.098091 128.722137,123.044724
	C127.276703,124.047348 126.206139,125.103333 125.135582,126.159317
	C125.135582,126.159317 125.047256,126.009193 124.732910,126.004532
	C119.616974,127.071533 117.918159,130.667648 117.107216,134.986160
z"/>
<path fill="#2C2F57" opacity="1.000000" stroke="none"
	d="
M133.634811,389.195923
	C138.751068,390.708893 142.251343,387.568878 146.628098,385.027191
	C148.859680,385.422485 150.387985,385.718170 151.968781,386.362732
	C152.897537,387.540375 153.773773,388.369110 154.650009,389.197815
	C155.182861,389.222473 155.715698,389.247101 156.886948,389.472961
	C158.307007,388.343506 159.606720,387.069244 159.758926,385.670105
	C160.046463,383.026978 159.674149,380.312012 159.576050,377.626923
	C160.517868,376.638031 161.459702,375.649170 162.751312,375.164490
	C163.759521,379.702667 165.204971,383.793915 164.916489,387.759003
	C164.267151,396.683777 156.590866,400.353333 148.704803,396.398987
	C147.109085,395.598846 144.297363,395.930908 142.628036,396.826019
	C138.519135,399.029297 133.985291,401.848602 130.506012,397.486664
	C126.099655,391.962494 122.120010,394.221344 117.638580,396.361755
	C116.450432,396.929230 115.342972,397.755859 114.097984,398.100220
	C100.897812,401.751251 88.303337,401.698486 77.414680,391.806061
	C76.941788,391.146393 76.468887,390.486725 75.971848,389.169037
	C72.732826,380.726654 71.690483,379.908813 64.950790,380.144440
	C64.075104,380.779999 63.557556,381.434753 62.884804,382.370422
	C61.201111,384.121704 59.672623,385.592102 57.793583,387.073364
	C55.673203,387.054749 53.903374,387.025299 52.133541,386.995850
	C52.527740,385.934387 52.921944,384.872925 53.760071,383.396912
	C54.413017,382.257660 54.622044,381.533020 54.831070,380.808350
	C55.488914,379.735748 56.146763,378.663147 57.311520,377.304016
	C58.205963,376.338043 58.593498,375.658600 58.981026,374.979126
	C59.380333,374.542053 59.779640,374.105011 60.625565,373.870667
	C61.650974,373.616486 62.229774,373.159637 62.892212,372.473511
	C63.144760,371.946198 63.196068,371.629028 63.129776,371.292786
	C63.774586,370.802612 64.419411,370.312469 65.738174,369.854980
	C66.933975,369.868744 67.455826,369.849854 68.192322,370.141907
	C70.936661,370.969269 73.466347,371.485718 75.996033,372.002167
	C75.996033,372.002167 76.022438,371.828552 76.031174,372.169342
	C76.104965,372.975586 76.170013,373.441040 75.968475,374.090088
	C76.884605,375.806763 78.067314,377.339874 79.472229,379.086792
	C80.653862,380.258240 81.613304,381.215851 82.572754,382.173462
	C84.201218,383.682190 85.829681,385.190918 87.764473,387.262115
	C90.032875,388.297882 91.994949,388.771149 93.957024,389.244385
	C96.355156,389.218445 98.753288,389.192474 101.862869,389.446259
	C105.386406,389.111420 108.198502,388.496857 111.010597,387.882324
	C111.649658,387.754944 112.288727,387.627563 113.592484,387.654602
	C114.503555,387.852295 114.749954,387.895660 115.111237,388.141602
	C115.589859,388.384674 115.953583,388.425140 116.317307,388.465637
	C116.120918,388.261475 115.924522,388.057312 115.854439,387.668457
	C116.199974,387.245453 116.280426,386.967041 116.222107,386.648560
	C117.112831,386.331085 118.003563,386.013641 119.562469,385.764221
	C120.867126,385.351440 121.503616,384.870605 122.140106,384.389771
	C122.510651,384.239777 122.881195,384.089813 123.901566,383.976318
	C125.701134,383.677643 126.850883,383.342468 128.012375,383.366760
	C128.947464,384.494598 129.870789,385.262970 130.847595,386.379486
	C131.812317,387.550415 132.723557,388.373169 133.634811,389.195923
z"/>
<path fill="#373B60" opacity="1.000000" stroke="none"
	d="
M325.663055,193.963882
	C324.948181,192.700211 324.233307,191.436539 323.354706,189.616669
	C324.487579,188.177017 325.784210,187.293610 327.080811,186.410202
	C332.332336,185.082413 335.585999,187.279251 338.645569,191.638062
	C347.624908,204.430359 357.070160,216.895889 366.362030,229.467896
	C367.084015,230.444809 368.032349,231.254425 369.478973,231.884262
	C368.582062,216.569412 373.328064,200.432846 360.718719,186.634369
	C368.360107,186.634369 375.173492,186.634369 382.088043,186.634369
	C382.145233,187.178757 382.407196,187.946274 382.214386,188.085907
	C374.641418,193.570755 374.265717,201.894516 373.995239,209.968750
	C373.588440,222.112381 373.787872,234.275986 373.694153,246.430832
	C373.680817,248.160919 373.468658,249.889511 373.348480,251.618805
	C372.737366,251.901215 372.126251,252.183624 371.515167,252.466034
	C360.379913,237.242996 349.244659,222.019958 338.032654,206.154572
	C337.410431,204.997559 336.864929,204.482895 336.319458,203.968216
	C334.941895,202.152115 333.564331,200.336014 332.078125,197.838226
	C330.679962,196.439590 329.390381,195.722641 327.838257,195.006912
	C327.400726,195.011719 327.225739,195.015320 326.879822,194.768158
	C326.360291,194.332870 326.011688,194.148376 325.663055,193.963882
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M541.910339,120.653473
	C543.073059,126.156700 543.126648,131.625290 548.283691,135.322205
	C548.009216,133.687897 547.744385,132.051895 547.458801,130.419556
	C545.428833,118.818512 555.147278,105.415474 568.080200,110.224220
	C571.180359,111.376915 574.491943,111.986374 577.732849,112.730217
	C587.743408,115.027824 597.745789,117.369995 607.797729,119.472984
	C610.875305,120.116829 612.532715,121.636757 611.608215,124.570457
	C610.442383,128.270050 608.919189,131.169449 604.300354,132.915100
	C594.275757,136.703781 584.851196,142.063156 575.116028,146.641617
	C570.325134,148.894806 564.891174,150.130615 560.649902,153.110306
	C555.803650,156.514938 553.654419,155.798141 548.797668,152.141769
	C540.201172,145.669983 535.349121,137.931030 534.236633,127.750870
	C533.172058,118.009232 533.061035,108.167419 532.304993,98.387100
	C531.063538,82.328407 530.135986,66.217461 528.004395,50.271786
	C527.321899,45.166096 526.949524,40.553143 528.689026,35.857151
	C529.195740,34.489021 530.618896,33.460297 531.621948,32.275993
	C532.776123,33.452789 534.764404,34.508953 534.954773,35.825123
	C536.760132,48.309566 538.758667,60.800007 539.720886,73.363838
	C540.914185,88.944870 541.176331,104.597221 541.910339,120.653473
M604.174744,121.850052
	C591.731567,118.657043 579.158386,115.881927 566.906982,112.072121
	C561.769104,110.474396 557.998657,111.668381 554.735168,114.744247
	C549.571228,119.611435 547.745239,125.689240 550.115051,132.770050
	C550.558228,134.094070 549.913940,135.782028 549.771484,137.302032
	C548.161865,136.966888 546.473938,136.825348 544.974060,136.218811
	C544.167236,135.892517 543.682861,134.768692 542.973755,133.244278
	C541.696777,128.289047 539.635681,123.387932 539.289185,118.368462
	C538.227844,102.993896 537.941223,87.567673 537.121033,72.173920
	C536.645874,63.255947 535.879944,54.345074 534.928650,45.464874
	C534.532227,41.763718 533.313354,38.150658 532.468445,34.497543
	C532.029846,34.569469 531.591248,34.641399 531.152588,34.713326
	C530.477173,38.223251 528.918945,41.829834 529.290710,45.225094
	C530.437134,55.694912 532.971375,66.035355 533.755310,76.516640
	C534.768799,90.066879 534.272522,103.725594 535.111145,117.295280
	C535.502441,123.628212 537.503174,129.861679 538.901123,136.857819
	C541.105591,140.295380 542.775940,144.287994 545.638123,147.041977
	C550.065308,151.301804 555.455200,153.474426 561.783875,150.290085
	C567.078979,147.625793 572.650208,145.504242 577.909973,142.777283
	C586.489563,138.329163 593.971008,131.645523 604.770996,130.133820
	C608.700562,129.856323 608.404541,126.483978 608.879700,123.984879
	C608.962341,123.550140 606.355652,122.604065 604.174744,121.850052
z"/>
<path fill="#383B5E" opacity="1.000000" stroke="none"
	d="
M353.738495,374.625366
	C353.762543,358.512848 353.821320,342.869720 353.802887,327.226654
	C353.790436,316.644073 353.772949,316.546722 359.326538,311.100983
	C360.244873,313.001251 361.318268,314.618256 361.830963,316.396851
	C363.351044,321.670258 364.675537,327.000977 366.011597,332.325562
	C366.245575,333.258118 366.613129,334.648346 366.159363,335.185303
	C362.209839,339.859222 363.868622,345.378052 363.785828,350.548279
	C363.599335,362.195129 363.792694,373.847504 363.733704,385.497162
	C363.699585,392.231201 359.772858,396.995026 355.885345,401.734589
	C355.244263,401.651672 354.603180,401.568726 353.962067,401.485779
	C353.888184,392.688782 353.814270,383.891785 353.738495,374.625366
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M86.896194,45.052643
	C96.352753,40.870152 105.415337,36.735397 114.613518,32.928257
	C116.147926,32.293167 118.271927,33.082573 120.123489,33.213734
	C119.191727,34.951931 118.698471,37.543251 117.254715,38.285362
	C109.725342,42.155514 101.982468,45.617805 94.261971,49.107143
	C73.067932,58.685947 51.865562,68.247078 30.601822,77.669273
	C29.055807,78.354324 26.989830,77.865952 25.165600,77.923149
	C25.544754,76.111137 25.303013,73.626762 26.410793,72.603790
	C31.147812,68.229439 36.343098,64.356667 41.254417,60.164112
	C45.392273,56.631828 49.368877,52.910645 53.735130,48.987072
	C52.585743,47.940434 51.716339,47.025002 50.726059,46.267616
	C45.362614,42.165508 45.024567,39.612812 50.104416,35.227009
	C51.816734,33.748638 55.856857,32.255573 56.739300,33.061581
	C58.930809,35.063263 60.103508,38.307503 61.312298,41.208172
	C61.989616,42.833492 62.245213,44.795090 62.098156,46.555672
	C61.966297,48.134274 60.632263,51.024612 60.494759,50.985645
	C56.210213,49.771397 54.749443,53.219261 52.580997,55.504047
	C50.958248,57.213852 49.255608,58.847843 47.588539,60.515587
	C47.901070,60.963375 48.213600,61.411167 48.526131,61.858955
	C61.199974,56.309364 73.873817,50.759769 86.896194,45.052643
M49.900822,66.274277
	C67.999329,60.295799 115.300705,38.129105 118.361389,33.200047
	C115.397713,34.835720 113.741280,35.937115 111.944305,36.713032
	C91.475548,45.551311 71.019791,54.422234 50.453812,63.029358
	C48.093731,64.017082 45.086189,63.457760 42.378849,63.615738
	C42.249817,63.080162 42.120785,62.544586 41.991749,62.009007
	C36.898930,66.210228 31.806108,70.411446 26.713289,74.612663
	C27.145712,75.236481 27.578136,75.860306 28.010559,76.484131
	C35.076805,73.190422 42.143047,69.896713 49.900822,66.274277
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M419.993622,248.984436
	C411.595367,249.113754 403.197083,249.243088 394.298828,249.008820
	C393.855316,247.689011 393.911804,246.732758 393.968292,245.776520
	C394.707245,243.482483 396.049042,241.198212 396.086395,238.892807
	C396.312317,224.951111 396.280243,211.004471 396.241821,197.059738
	C396.230927,193.113113 395.757355,189.315262 390.565918,188.732208
	C389.952057,188.663269 389.432068,187.758286 388.433105,186.841019
	C389.822540,186.348587 390.672150,185.784058 391.520325,185.786270
	C404.963776,185.821243 418.413300,185.730621 431.846100,186.155151
	C435.335724,186.265427 438.772888,188.037338 442.023499,189.426880
	C438.274506,189.023499 434.736145,188.239273 430.533783,187.307877
	C431.304352,189.056885 431.668091,189.882462 431.637634,190.674988
	C424.805603,188.343933 418.282715,188.012482 411.622772,189.614227
	C407.840942,190.523788 405.623688,192.113739 405.752869,196.664474
	C406.064117,207.629822 405.846924,218.610123 405.846710,229.584381
	C405.846436,243.718552 405.848053,243.718552 419.991425,246.372833
	C419.987244,247.492126 419.990448,248.238281 419.993622,248.984436
M401.957672,204.041428
	C401.957672,215.171982 401.957672,226.302536 401.957672,237.433090
	C402.419922,237.409485 402.882172,237.385895 403.344421,237.362289
	C403.344421,222.435516 403.344421,207.508743 403.344421,192.581970
	C402.912659,192.588074 402.480927,192.594162 402.049164,192.600266
	C402.049164,196.120468 402.049164,199.640686 401.957672,204.041428
M402.380890,240.681137
	C402.609222,240.990921 402.837585,241.300705 403.065948,241.610489
	C403.258057,241.420074 403.450195,241.229660 403.642303,241.039246
	C403.347595,240.795868 403.052917,240.552490 402.380890,240.681137
z"/>
<path fill="#282B57" opacity="1.000000" stroke="none"
	d="
M473.653961,137.345596
	C473.653961,137.345596 473.921753,137.601028 474.245300,137.910583
	C475.689178,138.919632 476.809479,139.619110 477.974731,140.587677
	C478.681824,140.904953 479.343933,140.953156 480.335602,140.972656
	C481.093414,141.038391 481.521698,141.132828 482.061462,141.587616
	C484.522247,142.091980 486.875610,142.189560 489.219574,142.394623
	C491.113403,142.560303 492.995880,142.855560 495.202179,143.133499
	C491.547455,151.070419 483.150604,153.142426 475.776489,148.957993
	C472.371063,147.025604 468.850555,145.296036 465.141724,143.368561
	C464.622406,143.051697 464.343628,142.840759 464.003723,142.344421
	C463.297516,141.717987 462.652374,141.376938 461.959290,140.705185
	C460.898224,139.228241 459.885132,138.082031 458.893127,136.602722
	C458.589935,135.224640 458.265656,134.179642 457.955688,132.749405
	C455.597168,130.931747 453.224365,129.499329 450.641357,128.060410
	C450.431183,128.053909 450.010986,128.035828 449.966675,127.669785
	C448.159515,124.954506 446.396729,122.605286 443.918152,119.302193
	C447.828003,117.841270 450.309387,116.865860 452.823669,115.984306
	C458.704407,113.922440 464.627258,112.171577 470.973480,113.761749
	C471.255432,113.832397 471.714752,113.195198 472.403076,112.896286
	C473.130127,112.920876 473.545502,112.936890 474.162659,113.233688
	C475.294952,114.179169 476.190491,114.900726 477.161621,115.499641
	C485.536957,120.664909 485.541016,120.658310 480.033142,128.027679
	C480.022278,128.007919 480.031372,128.044373 479.670532,128.035110
	C478.550659,128.715790 477.791626,129.405731 477.015869,130.418030
	C477.001099,131.169861 477.003143,131.599350 477.005157,132.028839
	C476.451660,132.523239 475.898132,133.017639 474.819275,133.643250
	C473.850128,133.845245 473.406311,133.916000 472.697418,133.984222
	C472.283600,134.677231 472.134857,135.372803 472.201172,136.364426
	C472.828796,136.888840 473.241394,137.117218 473.653961,137.345596
M469.220703,128.424957
	C470.158508,128.831650 471.096283,129.238342 472.034119,129.645035
	C472.248505,128.482620 472.462921,127.320190 472.782593,125.545891
	C474.740479,124.173386 475.552704,122.436340 472.484436,122.015335
	C467.850220,121.379471 463.117950,121.458237 458.044525,121.214935
	C460.797028,128.741806 463.393860,130.112503 469.220703,128.424957
z"/>
<path fill="#373B60" opacity="1.000000" stroke="none"
	d="
M540.874634,230.961868
	C540.871094,232.286682 540.868408,233.118790 540.864807,233.950912
	C540.826416,242.782593 540.826416,242.782593 548.733398,248.747559
	C540.082886,248.747559 532.345276,248.747559 524.607666,248.747559
	C533.216675,245.701630 531.433350,238.615631 531.449707,232.338699
	C531.478210,221.354736 531.428589,210.370560 531.466797,199.386658
	C531.483948,194.448837 531.618530,189.532364 525.209778,188.185593
	C524.917969,188.124283 524.765137,187.401398 524.238770,186.397766
	C532.328186,186.397766 540.016785,186.397766 547.742737,186.397766
	C547.703186,187.110336 547.751648,187.688797 547.658264,187.712662
	C540.684998,189.494812 540.649658,194.754074 540.799072,200.514481
	C541.058044,210.493332 540.873596,220.483658 540.874634,230.961868
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M242.394043,54.219841
	C224.796585,62.197350 207.564514,70.066513 190.270523,77.797104
	C188.962173,78.381943 187.213394,77.981544 185.669373,78.039131
	C185.884872,76.340050 185.529861,74.174438 186.448853,73.050621
	C187.846451,71.341515 189.980362,70.017601 192.055603,69.112747
	C215.056946,59.083660 238.113815,49.181988 261.138855,39.207062
	C265.557526,37.292801 269.846191,35.067974 274.311249,33.276611
	C276.046326,32.580509 278.103638,32.687561 280.014160,32.428757
	C280.325836,33.090435 280.637512,33.752117 280.949188,34.413795
	C278.971527,36.111427 277.245026,38.338272 274.973358,39.416420
	C264.312317,44.476173 253.501373,49.220123 242.394043,54.219841
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M501.858795,208.956177
	C499.429810,211.373566 496.807037,213.633713 494.659760,216.279724
	C493.696503,217.466736 492.795105,219.957016 493.386627,220.948563
	C497.130646,227.224777 500.980316,233.495377 505.451111,239.259003
	C508.110077,242.686874 511.967468,245.185150 515.241882,248.062561
	C510.077240,251.772629 500.203430,249.772156 496.569550,244.029678
	C491.944641,236.721085 487.351562,229.392319 482.714661,222.091354
	C481.883911,220.783340 480.907440,219.567886 479.101807,217.069061
	C479.101807,226.646149 478.673889,234.658051 479.396179,242.564880
	C479.581726,244.596298 483.392822,246.296509 486.388885,248.883209
	C477.660583,248.883209 469.866150,248.883209 461.448090,248.883209
	C464.270355,246.457596 466.518616,244.525284 469.262573,242.591843
	C469.436035,244.245041 469.113861,245.899384 468.782257,247.602020
	C472.321930,247.602020 475.848450,247.602020 479.062317,247.602020
	C474.867249,235.438004 475.295105,223.511322 478.661713,211.641495
	C486.809113,216.851837 490.275787,216.682526 496.111511,211.053131
	C498.223511,210.420990 500.041168,209.688583 501.858795,208.956177
z"/>
<path fill="#34375D" opacity="1.000000" stroke="none"
	d="
M206.448273,202.870926
	C206.448273,202.870926 206.149750,202.472580 206.102890,201.951691
	C205.576050,200.902435 205.096054,200.374084 204.616058,199.845734
	C204.099991,199.155289 203.583908,198.464828 203.016251,197.138870
	C202.378250,195.978653 201.791855,195.453949 201.205444,194.929245
	C200.314606,193.999100 199.423782,193.068970 198.251633,191.595184
	C197.292618,190.714355 196.614914,190.377182 195.937210,190.040009
	C195.540146,189.920090 195.143082,189.800186 194.550201,189.217743
	C195.948425,188.004791 197.542480,187.254379 199.136551,186.503967
	C200.133286,186.452927 201.130005,186.401871 202.642090,186.756409
	C205.426544,188.087189 207.695663,189.012375 209.964813,189.937561
	C209.992065,190.351944 210.019318,190.766342 210.035248,191.804169
	C210.549942,192.991501 211.075943,193.555405 211.601959,194.119308
	C211.601959,194.119308 211.882126,194.529968 211.902451,195.060333
	C212.415787,196.112320 212.908798,196.633926 213.401794,197.155533
	C214.620178,199.114990 215.838547,201.074448 217.076721,203.692184
	C217.639313,204.929688 218.182114,205.508942 218.724899,206.088181
	C218.724899,206.088181 218.987411,206.460312 218.988541,207.006729
	C219.570831,208.079468 220.151993,208.605789 220.733154,209.132095
	C220.733154,209.132095 220.876907,209.116348 220.923706,209.511642
	C221.740021,211.328369 222.509567,212.749802 223.279114,214.171234
	C223.538895,214.481659 223.798676,214.792084 224.080780,215.725128
	C224.658371,216.925903 225.213608,217.504059 225.768829,218.082214
	C228.195251,222.056931 230.621658,226.031647 233.089813,230.665253
	C233.684402,231.907669 234.237244,232.491196 234.790085,233.074722
	C234.790085,233.074722 235.060013,233.395325 235.042709,233.914795
	C235.549225,234.997849 236.073029,235.561417 236.596848,236.125000
	C239.875137,239.625580 243.153427,243.126175 246.648590,247.212585
	C241.824203,248.327850 236.782959,248.857285 232.229340,249.335495
	C231.532669,246.885315 231.098572,245.358551 230.664459,243.831802
	C230.416626,243.516693 230.168777,243.201599 229.917862,242.260925
	C229.352325,241.063110 228.789841,240.490906 228.227371,239.918686
	C228.227371,239.918686 227.961929,239.586380 227.979431,239.069595
	C227.484039,237.990280 226.971161,237.427750 226.458282,236.865234
	C224.645020,233.877502 222.831772,230.889755 220.973312,227.254730
	C220.398285,226.035797 219.868454,225.464157 219.338638,224.892517
	C219.338638,224.892517 219.063065,224.507004 219.041077,223.915253
	C217.612625,221.154266 216.206146,218.985031 214.799667,216.815796
	C214.518005,216.512360 214.236328,216.208908 213.925323,215.275482
	C213.349716,214.067154 212.803467,213.488831 212.257217,212.910507
	C210.853378,210.554367 209.449539,208.198212 208.011414,205.209595
	C207.467514,204.008392 206.957886,203.439651 206.448273,202.870926
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M169.026733,189.233704
	C165.510086,190.733994 159.459274,185.182404 158.243881,191.986115
	C156.699127,200.633591 157.654785,211.101227 166.664429,213.451630
	C167.136856,213.574890 167.563385,213.874008 167.826599,214.506439
	C161.857483,214.330246 157.739014,210.743729 157.076950,205.063690
	C156.425385,199.473816 156.286148,193.824234 155.913452,188.067169
	C153.374130,188.067169 150.738892,188.067169 149.227493,188.067169
	C151.958160,207.973206 151.742935,227.776550 149.353699,247.692993
	C151.271698,247.692993 153.848282,247.692993 156.979950,247.692993
	C156.979950,239.951935 156.980545,232.520035 156.979782,225.088135
	C156.978973,217.117935 156.983231,217.245743 164.961319,216.944794
	C166.645676,216.881256 168.280457,215.503845 169.938095,214.731842
	C171.231064,214.567627 172.579727,214.109268 173.797974,214.339859
	C174.647766,214.500717 175.318909,215.605530 176.069855,216.288666
	C175.326797,217.008469 174.627899,218.289383 173.833130,218.351913
	C170.191086,218.638489 166.516403,218.740021 162.864685,218.604706
	C159.703415,218.487564 158.356262,219.553955 158.445297,222.879852
	C158.618851,229.363373 158.558456,235.856674 158.436600,242.342957
	C158.382370,245.229828 159.333755,246.524277 162.415756,246.652008
	C172.058960,247.051666 178.183777,242.897659 181.246918,233.787933
	C181.668869,232.533035 183.021942,231.591202 183.943924,230.504440
	C184.544662,230.832169 185.145401,231.159882 185.746140,231.487610
	C184.450684,238.138031 183.155212,244.788437 181.892105,251.272751
	C170.417435,248.197800 159.619949,250.223419 148.961517,249.591156
	C146.565567,249.449036 144.165985,249.368408 141.535782,249.248917
	C141.841064,248.098450 141.886719,247.276764 142.095718,247.232880
	C148.838623,245.816727 148.985504,240.867493 148.897598,235.384537
	C148.700256,223.076218 148.805237,210.762558 148.842987,198.451233
	C148.856750,193.962418 148.948761,189.560318 142.938126,188.692535
	C142.394241,188.614014 141.991180,187.559998 140.616959,185.796967
	C150.930832,185.796967 160.110855,185.796967 169.465286,186.189758
	C167.100067,186.926331 168.152954,188.100723 169.026733,189.233704
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M97.289284,235.863159
	C97.271912,224.384857 97.328499,213.385071 97.303970,202.385483
	C97.290314,196.261215 98.997375,189.293396 89.062271,187.647003
	C89.487061,187.212372 89.911842,186.777740 90.336632,186.343109
	C98.278976,186.343109 106.221313,186.343109 114.264015,186.343109
	C114.135124,187.125244 114.150139,187.689240 114.020897,187.724503
	C107.181305,189.590515 107.100464,194.727615 107.220589,200.522766
	C107.503777,214.183350 107.430847,227.855606 107.232277,241.519211
	C107.174850,245.470184 108.412544,246.798325 112.393784,246.660049
	C121.731583,246.335739 126.197006,243.210907 129.615387,234.357040
	C130.128418,233.028290 131.866776,232.172638 133.038315,231.098145
	C133.263016,232.555908 133.870438,234.076965 133.641800,235.459778
	C132.910431,239.882919 131.788208,244.239929 130.977402,248.651978
	C130.482483,251.345169 129.542923,252.057373 126.924469,250.616196
	C125.437546,249.797806 123.480721,249.556808 121.730698,249.539322
	C112.899071,249.451111 104.065704,249.553802 95.233353,249.508469
	C93.573578,249.499954 91.915695,249.123169 89.743156,248.171997
	C96.206062,246.301620 98.066765,242.085861 97.289284,235.863159
M98.984894,217.500000
	C98.984901,220.658691 99.219795,223.838562 98.937073,226.971741
	C98.306503,233.959793 101.253494,241.425308 95.633003,247.974701
	C96.919441,247.974701 97.579155,247.971603 98.238831,247.975174
	C105.086655,248.012207 105.088989,248.012512 105.087486,241.403687
	C105.084457,228.104004 104.902176,214.800781 105.169159,201.506546
	C105.263222,196.822617 106.454056,192.160721 107.100014,187.787384
	C104.652115,187.787384 100.951263,187.787384 97.244278,187.787384
	C100.431961,197.692459 98.381332,207.176315 98.984894,217.500000
z"/>
<path fill="#7D8DAD" opacity="1.000000" stroke="none"
	d="
M708.867798,375.483215
	C714.180176,378.920074 719.530884,382.702179 724.892090,386.469299
	C738.680542,396.157959 753.345947,404.292633 769.548401,409.005646
	C782.716797,412.836121 796.115662,416.061401 809.601013,418.519775
	C814.712708,419.451630 820.437439,417.889313 825.737976,416.774963
	C858.313538,409.926392 888.018127,396.941376 913.015503,374.510468
	C920.519653,367.776794 927.313110,360.251068 934.777649,353.105530
	C927.401550,361.486603 920.283569,370.526276 911.831909,378.072296
	C894.632751,393.428253 874.615845,404.503540 852.742615,411.588654
	C839.517517,415.872498 825.810364,419.374359 812.054871,421.041534
	C804.173340,421.996826 795.621277,419.113617 787.614868,417.024475
	C764.578125,411.013550 742.837158,401.910919 723.450623,387.839020
	C718.372131,384.152710 713.745178,379.844360 708.867798,375.483215
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M569.749268,55.505005
	C563.229980,58.493187 557.037537,61.290855 550.062378,64.442123
	C551.657166,65.657669 552.850586,66.242920 553.559998,67.190559
	C554.437134,68.362236 554.912231,69.834846 555.561096,71.177429
	C554.121094,71.710457 552.616577,72.826263 551.252197,72.675385
	C545.421265,72.030579 542.886292,66.979385 546.262268,62.252239
	C548.101807,59.676483 550.797424,57.237751 553.653442,55.941109
	C569.402039,48.791328 585.321899,42.018921 601.173767,35.096016
	C602.531006,34.503262 603.755981,33.499344 605.158325,33.144585
	C607.002502,32.678036 608.961609,32.665916 610.871338,32.458405
	C611.188538,33.217976 611.505737,33.977551 611.822937,34.737122
	C608.885681,36.805885 606.177429,39.369686 602.969543,40.853256
	C592.100464,45.879879 581.054504,50.524132 569.749268,55.505005
z"/>
<path fill="#3B3950" opacity="1.000000" stroke="none"
	d="
M487.452423,38.481548
	C487.804871,38.400555 488.157318,38.319561 489.122864,38.156033
	C493.161804,36.561512 496.539215,34.923580 500.030151,33.580715
	C502.459106,32.646347 505.374115,31.447588 505.238037,36.113850
	C504.010284,36.969833 502.782562,37.825829 500.939636,38.826851
	C498.769073,39.878372 497.213745,40.784866 495.658417,41.691364
	C495.306183,41.795380 494.953949,41.899391 494.050690,42.055191
	C492.842529,42.567188 492.185364,43.027393 491.528198,43.487587
	C490.916107,43.657375 490.304047,43.827171 489.100830,44.062489
	C487.870483,44.615780 487.231201,45.103554 486.591949,45.591324
	C486.246918,45.700611 485.901886,45.809898 485.024292,46.001343
	C483.840729,46.552818 483.189728,47.022137 482.538757,47.491455
	C482.198364,47.606476 481.858002,47.721493 480.939667,47.919399
	C478.746735,48.828789 477.131744,49.655285 475.516754,50.481785
	C474.914459,50.675705 474.312195,50.869629 473.084290,51.126976
	C470.481598,52.285648 468.504456,53.380894 466.527344,54.476143
	C466.185547,54.584091 465.843781,54.692043 464.965515,54.886379
	C463.792969,55.469574 463.156921,55.966381 462.520874,56.463200
	C462.176575,56.565521 461.832306,56.667831 460.927185,56.827591
	C459.410187,57.391899 458.454041,57.898758 457.497864,58.405605
	C457.163055,58.534962 456.828217,58.664330 455.906494,58.872612
	C452.402405,60.487259 449.485199,62.022987 446.567993,63.558723
	C446.225189,63.665241 445.882385,63.771755 444.954102,63.959053
	C443.572113,64.542572 442.775543,65.045311 441.979004,65.548050
	C438.336609,67.080429 434.694214,68.612801 430.332336,70.122299
	C427.371185,71.291405 425.129486,72.483391 422.887787,73.675369
	C422.574493,73.863403 422.261200,74.051445 421.284027,74.183701
	C418.281433,74.803192 415.942780,75.478470 413.604095,76.153755
	C413.329407,75.692070 413.054749,75.230385 412.780060,74.768700
	C414.869812,72.218582 416.959595,69.668465 419.049377,67.118347
	C419.434021,66.749611 419.818665,66.380890 420.799377,65.947906
	C422.910767,65.274162 424.426147,64.664688 425.937378,64.404129
	C426.424194,65.389778 426.915161,66.026512 427.406128,66.663239
	C427.808533,66.210953 428.210938,65.758659 428.613342,65.306366
	C427.763031,64.848557 426.912689,64.390732 426.074829,63.576744
	C426.015167,62.752705 425.943024,62.284832 425.870850,61.816963
	C426.320618,61.224102 426.770355,60.631241 427.854156,59.970238
	C430.430695,59.354023 432.373169,58.805954 434.052429,58.552559
	C433.222198,60.010746 432.655243,61.174263 432.036011,62.550167
	C432.735474,62.702175 433.487274,62.641796 434.566284,62.426270
	C437.091064,61.019798 439.288574,59.768478 441.486053,58.517151
	C441.829010,58.421593 442.171967,58.326035 443.059021,58.171005
	C444.248535,57.633953 444.893951,57.156372 445.539398,56.678802
	C446.145294,56.491459 446.751221,56.304108 447.933990,56.025505
	C449.169189,55.478271 449.827484,55.022285 450.485809,54.566299
	C450.828644,54.457035 451.171509,54.347775 452.116028,54.131706
	C455.969299,52.516895 459.220856,51.008892 462.472443,49.500885
	C462.813416,49.396816 463.154358,49.292751 464.033478,49.115532
	C465.218231,48.564079 465.864868,48.085789 466.511505,47.607506
	C466.855774,47.502819 467.200073,47.398129 468.155823,47.198601
	C473.627441,44.840332 478.487610,42.576893 483.347748,40.313454
	C483.347748,40.313450 483.709595,40.235554 484.194336,40.191654
	C485.603546,39.592350 486.527985,39.036949 487.452423,38.481548
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M458.872040,136.935822
	C459.885132,138.082031 460.898224,139.228241 461.717346,140.882660
	C461.360229,141.948654 461.197083,142.506485 460.914185,143.277618
	C460.572296,143.747177 460.295532,143.911209 459.594421,143.973618
	C458.520142,144.746002 457.815613,145.527786 457.111084,146.309570
	C457.111084,146.309570 456.960724,146.479828 456.458649,146.367874
	C455.334686,146.925980 454.712799,147.596024 454.090942,148.266083
	C454.090912,148.266068 453.937347,148.449081 453.439362,148.326904
	C450.941986,149.354553 448.942596,150.504379 446.641724,151.803589
	C445.895782,151.973511 445.451385,151.994034 444.746826,151.722321
	C440.655975,150.620911 436.825317,149.811722 432.762817,148.938446
	C432.248596,148.697189 432.046844,148.453323 431.902466,147.781616
	C431.123474,147.077667 430.367798,146.734848 429.612091,146.392029
	C429.742950,146.267288 429.873810,146.142563 429.891693,145.842117
	C429.113678,145.147583 428.448608,144.628769 427.580872,143.999405
	C427.116669,143.689163 426.973663,143.425262 426.985870,142.702179
	C425.003326,138.541504 422.984039,134.775818 420.840210,130.790009
	C420.679291,130.237976 420.642883,129.906052 420.726562,129.180908
	C419.639160,126.787331 418.431702,124.786987 417.054504,122.451187
	C414.352631,120.656143 411.877167,119.596619 409.937195,123.332428
	C409.760895,123.921722 409.693695,124.263519 409.626526,124.605316
	C409.626526,124.605316 409.950806,124.929802 409.481995,124.782761
	C408.389191,125.113968 407.765228,125.592209 406.761230,126.090126
	C405.757629,127.645706 405.134064,129.181610 404.510498,130.717514
	C404.606659,131.046387 404.572815,131.361267 403.890015,131.865112
	C401.417694,134.772964 399.464233,137.477859 397.510803,140.182770
	C397.385437,137.746185 398.299316,135.900421 398.909271,133.959152
	C399.581451,131.819794 399.974579,129.592773 400.527069,127.154282
	C400.717041,126.606110 400.869202,126.307579 401.380035,125.951851
	C402.613342,124.023392 403.487946,122.152122 404.415894,120.051163
	C404.566986,119.515472 404.727081,119.246613 405.235260,118.997971
	C405.771057,118.330429 406.021179,117.679802 406.295776,116.779068
	C406.373138,116.205612 406.426025,115.882278 406.478943,115.558945
	C406.478943,115.558945 406.476379,115.462051 406.834381,115.423615
	C407.932281,114.421249 408.672180,113.457314 409.412079,112.493385
	C409.412079,112.493385 409.346558,112.340599 409.680908,112.408249
	C410.361420,112.386711 410.707581,112.297523 411.285095,112.438782
	C414.699371,113.435318 417.882355,114.201401 421.316864,115.114822
	C421.883392,115.957909 422.198395,116.653656 422.382385,117.700714
	C422.790619,118.712921 423.329865,119.373825 424.008423,120.303177
	C424.277893,121.159668 424.408081,121.747719 424.400330,122.736420
	C426.430664,127.493446 428.598969,131.849823 430.843445,136.551788
	C432.954285,138.239517 434.988922,139.581665 437.350983,140.926117
	C438.102173,141.026276 438.526001,141.124146 439.052185,141.573380
	C441.452087,141.683289 443.749603,141.441818 446.361267,141.099060
	C447.112946,140.979111 447.550446,140.960449 448.181702,141.201874
	C451.874359,139.953262 455.373199,138.444534 458.872040,136.935822
z"/>
<path fill="#2F325C" opacity="1.000000" stroke="none"
	d="
M276.484619,200.358276
	C276.426331,200.041122 276.459320,199.733780 277.044373,199.087982
	C278.302979,196.437744 279.100800,194.135803 279.898651,191.833847
	C280.050262,191.131577 280.201843,190.429291 280.841248,189.312531
	C282.214661,187.607254 283.100311,186.316467 284.306122,184.559067
	C285.285126,186.155136 286.177795,187.158142 286.573486,188.329102
	C289.113922,195.846405 291.503784,203.414673 294.057190,210.927444
	C294.443085,212.062881 295.423920,212.996140 296.129578,214.022919
	C296.341370,214.284149 296.462250,214.582245 296.354248,215.551147
	C297.352448,218.818329 298.488647,221.451538 299.624878,224.084732
	C299.835175,224.701126 300.045471,225.317520 300.156128,226.562317
	C300.459839,227.834183 300.863190,228.477661 301.266541,229.121124
	C301.452148,229.533127 301.637756,229.945114 301.611145,230.878113
	C302.034210,232.639664 302.669464,233.880203 303.304718,235.120758
	C303.552917,235.772842 303.801086,236.424927 304.035217,237.714050
	C304.451599,238.938950 304.882050,239.526794 305.312500,240.114655
	C305.531097,240.467102 305.749695,240.819565 306.011353,241.799011
	C306.619324,242.973526 307.184204,243.521072 307.749054,244.068619
	C308.048157,244.295639 308.347290,244.522675 308.826477,245.339722
	C308.396057,246.644287 307.853394,247.896179 307.163757,247.983215
	C303.596039,248.433502 299.990784,248.585892 296.398590,248.842102
	C296.240295,248.549713 296.082031,248.257339 296.457642,247.423798
	C296.877716,245.550766 296.763824,244.218918 296.649963,242.887085
	C295.961212,241.024902 295.272461,239.162720 294.704590,236.563019
	C294.288940,234.865097 293.752441,233.904694 293.215942,232.944290
	C292.587585,231.398346 291.959229,229.852402 291.214874,227.700302
	C290.743317,226.722183 290.387756,226.350220 289.906769,225.722580
	C289.514801,224.965286 289.248322,224.463684 289.280334,223.754120
	C289.466339,222.650833 289.491028,221.711304 289.219238,220.867249
	C287.359161,215.090378 285.436859,209.333542 283.659698,203.243759
	C283.320801,202.246384 282.856781,201.575500 282.252411,200.685715
	C282.081329,200.296204 282.050568,200.125610 282.018890,199.642120
	C281.558502,199.051147 281.098999,198.773056 280.639526,198.494980
	C280.458801,199.051224 280.278107,199.607468 280.051056,200.377274
	C280.004700,200.590836 279.727600,200.928802 279.391968,201.023972
	C278.881866,201.946930 278.707458,202.774734 278.529907,203.765198
	C278.526794,203.927856 278.362549,204.208755 277.969849,203.987900
	C277.212952,202.630798 276.848785,201.494537 276.484619,200.358276
z"/>
<path fill="#2C2F57" opacity="1.000000" stroke="none"
	d="
M51.446198,192.483521
	C51.508858,192.147049 51.571522,191.810577 52.033348,191.146866
	C52.683739,189.890686 52.934959,188.961731 53.186180,188.032791
	C53.271690,187.613464 53.357208,187.194153 53.891781,186.375153
	C55.537651,186.336945 57.055752,186.367264 57.852886,187.140656
	C58.937408,188.192932 59.471241,189.812775 60.241222,191.189224
	C60.393414,191.592590 60.545605,191.995956 60.511261,192.963715
	C62.995743,201.500824 65.609894,209.493362 68.378273,217.432114
	C69.059448,219.385498 70.243347,221.163574 71.196136,223.022232
	C71.300682,223.343918 71.405228,223.665619 71.374146,224.617798
	C72.370911,227.874252 73.503311,230.500214 74.635712,233.126190
	C74.835472,233.745728 75.035233,234.365250 75.164810,235.618835
	C75.562759,236.887299 76.030891,237.521713 76.499016,238.156143
	C76.661423,238.533859 76.823822,238.911591 76.960434,239.890259
	C77.418716,241.052902 77.902809,241.614609 78.386902,242.176300
	C79.088699,243.027069 79.790489,243.877853 80.708023,245.408539
	C80.233284,246.773514 79.587791,247.986130 78.844307,248.049500
	C76.077766,248.285400 73.279030,248.143646 71.126228,248.143646
	C69.842270,245.297623 68.870140,243.142807 67.898010,240.987991
	C67.785843,240.660492 67.673683,240.332993 67.678070,239.427048
	C67.319199,238.189407 66.843765,237.530197 66.368332,236.871002
	C66.174294,236.245422 65.980255,235.619827 65.866226,234.326599
	C65.443169,232.725647 64.940109,231.792343 64.437057,230.859039
	C64.297562,230.468353 64.158066,230.077667 64.040451,229.029083
	C63.055393,227.532913 62.048466,226.694641 61.028339,225.513580
	C60.980690,224.711502 60.946243,224.252182 61.038296,223.492096
	C58.955677,215.627289 56.790237,208.049713 54.454247,200.525085
	C54.268036,199.925262 52.902760,199.691498 52.039711,198.934448
	C51.652229,197.699951 51.310452,196.818619 51.112778,195.600159
	C51.319988,194.336533 51.383095,193.410034 51.446198,192.483521
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M438.412994,378.554016
	C438.765106,378.718628 438.818481,379.043457 438.832123,379.369934
	C438.901764,381.037354 438.961121,382.705170 439.024048,384.372864
	C440.840912,383.592163 442.893005,383.120544 444.419678,381.958557
	C446.729156,380.200806 448.524017,377.390839 451.589661,380.567413
	C449.178833,382.183899 446.765198,383.019409 444.945221,384.557404
	C437.741882,390.644501 435.552460,399.605743 432.026367,407.804657
	C427.331390,418.721344 422.393158,419.605194 414.132019,411.144928
	C413.921997,410.929901 413.540833,410.881958 413.239502,410.756042
	C413.239502,410.756042 413.098267,410.394348 413.034698,409.866547
	C411.317566,405.558929 409.664001,401.779114 408.010437,397.999298
	C407.962952,397.583740 407.915436,397.168182 407.908264,395.984192
	C407.832153,390.083099 407.715729,384.950439 407.599304,379.817810
	C407.725128,378.801514 407.850952,377.785217 408.249359,376.136261
	C408.671997,374.330505 408.822052,373.157379 408.972107,371.984283
	C408.972107,371.984283 409.001038,372.001221 409.401245,372.033051
	C410.549713,373.657501 411.835083,375.214966 411.942017,376.849548
	C412.222046,381.130096 411.376343,385.553589 412.120667,389.716064
	C412.955566,394.385010 415.042755,398.829987 416.585083,403.372406
	C417.085297,403.972137 417.585480,404.571838 418.495789,405.642334
	C420.732300,405.899994 422.558746,405.686890 424.385193,405.473785
	C425.380737,404.332184 426.376282,403.190552 427.740753,401.564087
	C428.333832,400.346802 428.557983,399.614349 428.782135,398.881897
	C429.093475,398.119476 429.404816,397.357056 430.056702,396.147949
	C430.572144,395.118103 430.747009,394.534912 430.921875,393.951721
	C433.313232,388.872833 435.704590,383.793945 438.412994,378.554016
z"/>
<path fill="#313458" opacity="1.000000" stroke="none"
	d="
M570.997559,336.997009
	C570.687500,334.847534 570.377441,332.698090 570.009033,330.196045
	C571.776367,328.670502 573.602173,327.497559 576.022705,326.218079
	C577.241089,325.622498 577.864807,325.133423 578.488525,324.644379
	C578.834778,324.522522 579.181091,324.400635 580.117310,324.170715
	C582.245239,323.147491 583.783203,322.232300 585.321167,321.317139
	C585.676331,321.211731 586.031555,321.106293 586.944214,320.955078
	C588.140625,320.428223 588.779541,319.947174 589.418457,319.466095
	C589.775391,319.379242 590.132385,319.292358 591.073608,319.166199
	C592.577393,318.577698 593.496948,318.028473 594.416443,317.479248
	C594.780029,317.403046 595.143677,317.326843 596.106140,317.204376
	C597.460571,316.703552 598.216125,316.248993 598.971680,315.794403
	C599.382690,315.732788 599.793701,315.671173 600.884888,315.615356
	C604.761780,315.663971 607.958496,315.706818 611.155273,315.749634
	C611.155273,315.749634 611.152832,315.846375 611.199829,316.222870
	C611.740845,318.832977 613.225037,321.437592 612.552002,323.233887
	C610.066772,329.866180 606.929688,336.260620 603.862488,342.660553
	C603.468933,343.481812 601.631592,344.495087 601.184814,344.225098
	C600.216736,343.640106 599.156555,342.293854 599.133118,341.236786
	C599.071716,338.464539 599.545776,335.680450 599.806458,332.901062
	C599.990173,332.591675 600.173889,332.282318 600.744629,331.565338
	C601.946899,329.190552 605.979736,327.684814 601.785217,324.750946
	C599.045349,324.979309 596.337952,325.056305 594.050598,326.075806
	C586.286194,329.536560 578.670227,333.330383 570.997559,336.997009
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M80.123306,144.966843
	C80.140106,145.411301 80.156906,145.855759 80.200241,146.918335
	C80.775284,148.429718 81.323784,149.322968 81.872284,150.216217
	C81.872284,150.216217 81.903969,150.633057 81.970673,151.129395
	C82.040718,152.077301 82.044067,152.528854 82.047417,152.980423
	C81.065918,152.071396 80.084419,151.162354 78.530853,149.911621
	C77.401611,148.964996 76.859642,148.345154 76.284737,147.757553
	C73.081635,144.483749 69.979187,140.936874 65.375832,146.109070
	C64.934753,146.604645 62.594578,146.331482 62.056522,145.668335
	C58.789528,141.641876 56.268818,143.846069 53.334167,146.135559
	C49.912197,148.805237 51.473076,151.134872 53.303207,153.635315
	C51.090794,153.409424 48.878384,153.183517 46.350410,152.602432
	C48.359524,146.498032 50.684204,140.748825 53.008884,134.999603
	C53.248867,134.757339 53.397514,134.468124 53.748283,133.710922
	C54.706333,131.865250 55.370930,130.440628 56.035530,129.015991
	C58.806328,126.677460 61.577122,124.338921 64.832169,122.184608
	C65.882568,122.559372 66.448738,122.749916 67.014900,122.940460
	C67.867607,124.444374 68.720314,125.948288 69.659393,128.132523
	C70.929993,131.453537 72.114212,134.094238 73.298439,136.734940
	C74.795441,138.543442 76.292435,140.351944 78.185287,142.577087
	C79.095200,143.651428 79.609253,144.309128 80.123306,144.966843
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M400.489258,127.403931
	C399.974579,129.592773 399.581451,131.819794 398.909271,133.959152
	C398.299316,135.900421 397.385437,137.746185 397.510803,140.182770
	C399.464233,137.477859 401.417694,134.772964 403.726074,132.043457
	C404.090942,132.458984 404.100891,132.899124 403.780273,133.791458
	C403.295105,134.827072 403.140472,135.410507 402.985840,135.993942
	C402.838562,136.298508 402.691254,136.603073 402.237671,137.318878
	C401.675507,138.504501 401.419586,139.278915 401.163696,140.053314
	C400.932892,140.618118 400.702087,141.182938 400.144745,142.210297
	C399.607269,143.467926 399.396362,144.263000 399.185455,145.058090
	C398.659241,145.969391 398.132996,146.880707 397.283142,148.287506
	C396.677704,149.535507 396.395935,150.288010 396.114166,151.040527
	C395.412811,152.060959 394.711456,153.081406 393.585632,154.500732
	C391.777496,155.949493 390.393829,156.999374 389.010162,158.049255
	C388.253784,158.041489 387.497437,158.033722 386.206055,157.759827
	C384.148102,156.607468 382.625092,155.721207 381.102112,154.834930
	C380.574310,154.004623 380.046478,153.174316 379.312927,151.828049
	C378.586029,150.727829 378.064819,150.143585 377.543610,149.559326
	C377.543610,149.559326 377.440582,149.159958 377.366119,148.654678
	C376.732513,147.279526 376.173370,146.409668 375.614197,145.539810
	C375.614197,145.539810 375.513947,145.114197 375.441284,144.537872
	C374.830139,142.273880 374.291687,140.586212 373.753204,138.898544
	C374.471588,130.541122 375.189972,122.183708 376.330231,113.497589
	C377.466827,113.134590 378.181580,113.100296 378.924011,113.377197
	C379.435394,114.338470 379.919128,114.988533 380.335022,116.003448
	C380.154816,119.905945 380.042419,123.443588 379.717133,127.279099
	C379.646973,129.724380 379.789703,131.871796 379.921936,134.417206
	C380.397430,137.548218 380.587006,140.376724 381.430237,142.994690
	C383.270905,148.709473 387.343231,149.328506 391.613098,144.516418
	C392.277893,143.565369 392.652588,142.788010 393.027283,142.010651
	C393.186920,141.711868 393.346558,141.413086 393.803986,140.656403
	C394.440521,139.148819 394.779266,138.099121 395.117981,137.049438
	C395.238098,136.728790 395.358215,136.408157 395.774445,135.640060
	C397.543457,132.596375 399.016357,130.000153 400.489258,127.403931
z"/>
<path fill="#424055" opacity="1.000000" stroke="none"
	d="
M130.534958,58.585449
	C130.874313,58.487434 131.213669,58.389420 132.121704,58.223633
	C133.620895,57.606167 134.551407,57.056477 135.481903,56.506779
	C135.828766,56.420692 136.175613,56.334610 137.111847,56.154678
	C139.299637,55.212101 140.898056,54.363373 142.496475,53.514648
	C142.810745,53.337742 143.125000,53.160828 144.009125,52.881844
	C146.873016,51.674778 149.167068,50.569782 151.461105,49.464783
	C151.805252,49.371685 152.149399,49.278587 153.041595,49.123283
	C154.242813,48.588718 154.895981,48.116360 155.549164,47.644005
	C155.897766,47.555035 156.246384,47.466061 157.141724,47.293983
	C158.129166,46.828949 158.569870,46.447025 159.010574,46.065098
	C159.808395,45.779278 160.606232,45.493462 162.037750,45.071419
	C165.898987,43.391918 169.126541,41.848644 172.354095,40.305367
	C172.354095,40.305367 172.714142,40.237312 173.197617,40.188980
	C174.613571,39.598236 175.546066,39.055824 176.478546,38.513409
	C176.827835,38.428902 177.177124,38.344395 178.127060,38.167854
	C180.999496,36.952213 183.271286,35.828606 185.543076,34.704998
	C185.882019,34.575924 186.220978,34.446850 187.161682,34.149952
	C189.431992,33.663261 191.100571,33.344395 193.527756,32.880554
	C192.773468,35.313660 192.363205,36.637047 191.952942,37.960438
	C191.952942,37.960438 192.000610,37.998928 191.650787,37.995438
	C190.023895,38.762413 188.746841,39.532875 187.469772,40.303337
	C186.499191,40.763275 185.528625,41.223213 183.976852,41.800407
	C182.931046,42.281399 182.466446,42.645138 182.001831,43.008873
	C181.205032,43.278030 180.408218,43.547188 178.964157,43.918289
	C172.370605,46.823956 166.424332,49.627678 160.478043,52.431396
	C160.139465,52.532967 159.800903,52.634537 158.893753,52.805344
	C157.400162,53.434566 156.475143,53.994553 155.550140,54.554543
	C154.588913,55.030994 153.627670,55.507435 152.036377,56.098663
	C147.773270,57.970402 144.140198,59.727360 140.507126,61.484314
	C140.165421,61.579540 139.823700,61.674767 138.935486,61.841171
	C137.745987,62.401756 137.103012,62.891167 136.460037,63.380585
	C136.117493,63.478806 135.774963,63.577026 134.836212,63.779400
	C132.155396,64.893951 130.070770,65.904343 127.986160,66.914742
	C126.564026,67.601974 125.141891,68.289207 123.040268,69.028107
	C121.600975,67.735725 120.841187,66.391685 120.081390,65.047638
	C121.168808,64.039383 122.256226,63.031128 123.951096,61.897675
	C126.550682,60.710133 128.542816,59.647789 130.534958,58.585449
z"/>
<path fill="#212550" opacity="1.000000" stroke="none"
	d="
M169.694427,214.654190
	C168.280457,215.503845 166.645676,216.881256 164.961319,216.944794
	C156.983231,217.245743 156.978973,217.117935 156.979782,225.088135
	C156.980545,232.520035 156.979950,239.951935 156.979950,247.692993
	C153.848282,247.692993 151.271698,247.692993 149.353699,247.692993
	C151.742935,227.776550 151.958160,207.973206 149.227493,188.067169
	C150.738892,188.067169 153.374130,188.067169 155.913452,188.067169
	C156.286148,193.824234 156.425385,199.473816 157.076950,205.063690
	C157.739014,210.743729 161.857483,214.330246 168.041534,214.778931
	C168.777664,214.616333 169.114212,214.596436 169.694427,214.654190
z"/>
<path fill="#EBECF2" opacity="1.000000" stroke="none"
	d="
M261.047058,452.407562
	C260.279968,460.168701 248.677261,464.624695 243.484619,460.440155
	C244.353912,459.326904 245.512512,457.997437 245.363770,457.830078
	C238.025909,449.575043 238.989380,441.004181 244.551880,432.236877
	C247.389633,432.347321 249.865509,432.434601 252.582489,432.754395
	C253.685333,434.290253 254.547058,435.593628 255.331085,437.201294
	C255.666519,438.190277 256.079651,438.874878 256.502228,439.905334
	C256.640106,441.163879 256.768555,442.076599 256.712860,443.197632
	C256.651978,444.274689 256.775177,445.143433 256.813934,446.348511
	C256.648468,447.604095 256.567474,448.523346 256.224121,449.613525
	C255.780823,450.557953 255.599854,451.331451 255.230438,452.433960
	C254.265808,454.393829 253.489624,456.024689 252.713440,457.655548
	C253.193588,458.014069 253.673737,458.372559 254.153885,458.731079
	C256.135345,456.535034 258.116791,454.338989 260.325134,452.246002
	C260.552063,452.349060 261.047058,452.407562 261.047058,452.407562
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M411.511627,50.905605
	C409.638794,54.026966 407.654449,57.407730 405.201630,60.405159
	C401.106964,65.408989 396.783600,70.233482 392.383698,74.973061
	C391.521301,75.902069 389.843079,76.540382 388.603455,76.450798
	C388.005554,76.407585 387.214294,74.396507 387.093445,73.216789
	C386.620911,68.604836 386.372467,63.969624 386.064575,59.341473
	C386.020599,58.681042 385.830780,57.746979 386.175598,57.386909
	C390.662903,52.701393 387.188171,48.189838 385.883972,43.696186
	C385.044861,40.804867 383.821045,38.025185 382.769684,35.195461
	C382.230469,35.208755 381.691254,35.222054 381.152039,35.235352
	C380.921844,38.138000 380.387360,41.056599 380.538452,43.939266
	C380.727539,47.547062 381.734680,51.110912 381.938965,54.719193
	C382.455322,63.838963 382.889832,72.971596 382.964630,82.102287
	C382.983032,84.349770 382.046326,87.063782 380.613495,88.784622
	C374.579498,96.031403 368.191467,102.983398 361.600067,110.083313
	C366.725403,103.298027 372.049408,96.358727 377.703247,89.699402
	C380.214447,86.741592 381.636688,83.891739 381.309631,79.848122
	C380.465729,69.413658 380.230164,58.928753 379.323669,48.501190
	C378.945251,44.147869 376.677368,39.851498 379.295532,35.579731
	C380.047302,34.353142 381.384064,33.485115 382.452637,32.452698
	C383.346252,33.473465 384.613831,34.351257 385.068298,35.539928
	C386.963531,40.496677 388.830322,45.487583 390.233063,50.596241
	C390.700775,52.299557 389.813446,54.404976 389.424591,56.301792
	C389.203369,57.381134 388.410400,58.419086 388.438141,59.460678
	C388.565491,64.242439 388.891479,69.018913 390.228271,74.631691
	C397.215363,66.752029 404.202454,58.872372 411.511627,50.905605
z"/>
<path fill="#2F325C" opacity="1.000000" stroke="none"
	d="
M432.031830,190.708038
	C431.668091,189.882462 431.304352,189.056885 430.533783,187.307877
	C434.736145,188.239273 438.274506,189.023499 442.235138,189.721741
	C443.332092,189.983551 444.006775,190.331345 444.868958,191.276169
	C451.640411,199.360809 453.284454,207.978699 451.123810,217.566055
	C450.305176,221.198624 449.865723,224.916611 449.253418,228.595673
	C448.818604,229.532166 448.383789,230.468658 447.453186,231.714081
	C446.642059,232.684860 446.326691,233.346710 446.011353,234.008575
	C444.096283,236.161255 442.181213,238.313934 439.641785,240.365509
	C438.653046,239.838043 438.288635,239.411713 438.181885,238.766617
	C438.542114,237.908066 438.644653,237.268280 438.784424,236.447510
	C438.821594,236.266541 439.102173,236.026138 439.452576,235.973099
	C440.087067,235.123230 440.371185,234.326401 440.700806,233.171387
	C441.374207,231.248199 442.002167,229.683197 442.946442,227.972717
	C443.381531,226.725113 443.500275,225.622986 443.596313,224.263824
	C443.666016,223.677719 443.758453,223.348648 444.163391,222.746643
	C444.259155,218.643021 444.042450,214.812286 443.723663,210.745178
	C443.622284,210.168808 443.623047,209.828827 443.751343,209.119690
	C443.444244,207.460953 443.009552,206.171356 442.411072,204.538986
	C440.626007,198.349136 437.056641,193.977432 432.031830,190.708038
z"/>
<path fill="#212550" opacity="1.000000" stroke="none"
	d="
M478.320007,211.508881
	C475.295105,223.511322 474.867249,235.438004 479.062317,247.602020
	C475.848450,247.602020 472.321930,247.602020 468.782257,247.602020
	C469.113861,245.899384 469.436035,244.245041 469.518677,242.347855
	C469.253815,241.019547 469.228485,239.934097 469.672852,238.312378
	C470.415558,233.404739 470.845398,229.034531 470.877991,224.661346
	C470.889679,223.090317 469.944427,221.512161 469.435883,219.937256
	C469.364563,217.268356 469.293243,214.599457 469.677185,211.356781
	C469.902985,207.167679 469.673462,203.552322 469.443970,199.936981
	C469.372986,199.214066 469.301971,198.491135 469.659668,197.306915
	C470.088348,194.066666 470.088348,191.287704 470.088348,188.252930
	C472.554565,188.252930 474.443359,188.252930 476.048096,188.252930
	C476.048096,194.754440 475.936646,200.969070 476.139221,207.173416
	C476.181305,208.463120 477.387146,209.714813 478.184021,211.084381
	C478.311401,211.184708 478.320007,211.508881 478.320007,211.508881
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M496.047241,395.396606
	C496.378113,395.617401 496.708984,395.838196 497.464020,396.435181
	C498.811279,397.340759 499.734406,397.870087 500.657532,398.399414
	C500.657532,398.399414 500.900543,398.115143 500.940063,398.602417
	C502.987244,399.663300 504.960907,400.501526 507.008453,400.764587
	C515.780518,401.891693 523.649658,399.947357 530.046265,393.468201
	C531.615112,395.029968 533.183899,396.591736 535.249878,398.592224
	C537.414062,399.623505 539.085083,400.738922 540.747498,400.726135
	C554.041138,400.623566 567.338257,400.454407 580.623413,399.991852
	C586.802490,399.776764 590.132446,396.444153 591.802002,389.964783
	C591.817261,388.587708 591.832520,387.210663 591.770752,385.124237
	C591.115967,383.280426 590.538086,382.145935 589.960266,381.011475
	C589.935364,380.552460 589.910400,380.093475 589.971130,379.300293
	C594.275513,382.017273 595.341309,386.489899 594.523987,391.134338
	C593.522217,396.826904 586.947083,402.567993 580.978210,402.714325
	C567.026917,403.056335 553.050964,403.214233 539.113892,402.685730
	C535.987976,402.567200 532.980408,399.329376 529.340942,397.187805
	C523.078247,404.965576 513.517639,403.971863 504.964966,402.550781
	C498.674255,401.505585 493.516357,400.619232 486.888916,402.435150
	C478.414154,404.757172 468.933838,403.724884 461.746307,396.689240
	C461.088745,396.045563 460.738068,395.088348 460.697083,394.005890
	C472.436371,402.795685 483.378052,403.316620 496.047241,395.396606
z"/>
<path fill="#252751" opacity="1.000000" stroke="none"
	d="
M501.575531,130.343765
	C501.575531,130.343765 501.556396,130.090775 502.017883,129.990601
	C504.658966,125.605057 506.838593,121.319679 509.114685,116.770309
	C509.677551,116.312149 510.143921,116.117996 510.752136,116.008560
	C510.985535,116.142601 511.077118,116.191917 511.168701,116.241226
	C511.017609,116.107559 510.866486,115.973892 510.577698,115.604691
	C510.525970,115.208862 510.611908,115.048569 511.068420,114.894478
	C513.904480,113.727814 516.369995,112.554947 518.673889,111.458969
	C523.875122,115.094147 524.905273,117.455841 525.048218,127.335892
	C525.191223,137.223831 524.416504,138.109802 516.087463,139.585236
	C515.508362,139.503815 515.211121,139.366806 514.895508,138.760864
	C513.706116,138.042694 512.570923,137.715393 511.289307,137.397583
	C511.142822,137.407059 510.900085,137.241882 510.873077,136.872803
	C508.878052,135.347046 506.870514,134.251312 504.956421,133.011383
	C503.756805,132.234299 502.697693,131.240402 501.575531,130.343765
M520.411743,127.863129
	C520.765320,127.483109 521.118958,127.103096 521.472534,126.723076
	C520.944275,126.498177 520.416016,126.273270 519.738464,125.727341
	C519.738464,125.727341 519.755005,125.373657 519.859009,124.621605
	C518.232117,123.159081 516.786926,120.939934 514.916687,120.490776
	C513.593201,120.172951 510.833069,121.905876 510.259338,123.341042
	C509.446075,125.375244 510.752808,127.228172 514.267334,126.655388
	C515.479553,127.311508 516.691772,127.967628 518.110413,129.121704
	C518.676636,128.685547 519.242798,128.249390 519.962402,128.012314
	C519.962402,128.012314 519.793823,127.824829 520.411743,127.863129
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M570.527100,211.065918
	C573.636108,202.697556 576.676697,194.302399 579.932800,185.991699
	C580.386292,184.834412 581.901306,184.093048 582.924866,183.159149
	C583.890930,184.399567 585.262817,185.496887 585.758667,186.903076
	C589.619202,197.851913 593.311523,208.860077 597.054993,219.850189
	C598.978271,225.496353 600.459717,231.347916 602.961975,236.724533
	C604.961121,241.020096 608.201843,244.737793 611.148071,249.091034
	C605.442505,249.091034 599.660156,249.091034 593.775269,249.091034
	C596.190308,241.372482 591.310486,235.458008 589.386658,228.930710
	C589.154175,228.141907 586.913086,227.597809 585.578979,227.544907
	C581.263184,227.373749 576.923157,227.690033 572.617981,227.416687
	C569.587036,227.224243 567.944580,228.450211 566.624146,230.954742
	C566.022095,226.970184 568.318176,225.965088 571.592224,225.970230
	C577.406738,225.979340 583.221436,225.939346 589.339050,226.113464
	C592.427307,233.333511 595.212463,240.359955 598.164246,247.806671
	C600.434937,247.806671 603.831238,247.806671 606.978699,247.806671
	C595.575562,228.141510 591.972351,205.561188 581.758057,184.934174
	C580.432617,189.250336 579.107178,193.566498 577.443359,197.975311
	C574.912415,202.400604 572.719788,206.733261 570.527100,211.065918
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M51.889885,387.241821
	C53.903374,387.025299 55.673203,387.054749 57.721146,387.422363
	C54.706562,394.804565 51.754738,402.039917 47.960888,408.802917
	C46.341972,411.688843 42.911907,415.507904 40.400887,415.438263
	C37.433117,415.356018 34.115410,411.917908 31.789072,409.212524
	C29.504982,406.556305 28.274075,402.994446 26.580982,399.830017
	C26.457167,399.421051 26.333353,399.012115 26.434444,398.006287
	C26.435703,394.969421 26.042786,392.530701 26.024622,390.089203
	C25.989784,385.406891 26.167686,380.722961 26.257328,376.039703
	C26.262491,375.616669 26.267653,375.193604 26.748367,374.416107
	C27.829218,375.332001 28.884491,376.577423 28.956480,377.877319
	C29.183582,381.977997 28.443220,386.213684 29.202774,390.181702
	C30.051453,394.615265 32.131641,398.813110 33.675861,403.113525
	C34.254528,403.760132 34.833199,404.406708 35.716789,405.603394
	C37.732803,406.260712 39.443905,406.367950 41.155014,406.475159
	C42.848652,404.256042 44.542286,402.036926 46.697479,399.395447
	C47.370090,398.232086 47.581135,397.491089 47.792175,396.750092
	C47.875893,396.375061 47.959606,396.000000 48.503693,395.282257
	C49.177567,394.151611 49.391071,393.363678 49.604576,392.575745
	C50.285130,390.879761 50.965675,389.183746 51.889885,387.241821
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M77.322395,392.141388
	C88.303337,401.698486 100.897812,401.751251 114.097984,398.100220
	C115.342972,397.755859 116.450432,396.929230 117.638580,396.361755
	C122.120010,394.221344 126.099655,391.962494 130.506012,397.486664
	C133.985291,401.848602 138.519135,399.029297 142.628036,396.826019
	C144.297363,395.930908 147.109085,395.598846 148.704803,396.398987
	C156.590866,400.353333 164.267151,396.683777 164.916489,387.759003
	C165.204971,383.793915 163.759521,379.702667 163.095032,375.273346
	C168.945923,379.004120 169.491272,389.897797 164.152679,396.126801
	C159.774811,401.234863 155.876541,401.941620 149.524155,399.587402
	C147.677261,398.902924 144.934204,399.081451 143.177841,399.984528
	C136.546906,403.393951 133.841782,403.446594 128.386108,398.465240
	C126.104294,396.381805 124.196999,396.311157 121.734428,397.793854
	C112.000580,403.654480 101.394318,403.446747 90.767807,401.649536
	C85.082085,400.687927 80.127815,397.914185 77.322395,392.141388
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M64.393829,331.439880
	C65.966156,332.723846 67.282150,333.734192 68.522568,334.830109
	C72.034988,337.933411 71.480698,343.862854 67.494209,346.114410
	C67.349808,346.195923 67.209389,346.332733 67.058098,346.346802
	C63.613937,346.667633 60.287292,341.306671 56.747353,346.139160
	C53.617222,343.821381 49.989697,341.938232 47.485931,339.073059
	C44.519840,335.678802 48.725189,333.165070 50.072582,330.431854
	C50.221798,330.129120 53.254658,331.129791 54.879753,331.719849
	C55.764503,332.041107 56.501087,332.770447 57.380135,333.367065
	C59.555836,332.167542 60.664398,327.662903 64.393829,331.439880
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M182.992325,429.062012
	C184.671875,429.086670 186.351440,429.111298 188.382599,429.670288
	C187.744995,431.553162 186.755753,432.901672 185.766525,434.250183
	C183.393005,433.492401 181.019485,432.734589 177.960983,431.758057
	C177.960983,439.910126 177.666229,446.896362 178.153595,453.827606
	C178.287216,455.728027 180.763443,457.463715 182.620026,459.863586
	C177.898605,459.863586 173.291748,459.863586 168.490875,459.863586
	C175.758957,451.473938 170.808807,441.913269 172.297592,433.277283
	C166.537338,430.548096 164.470947,435.000092 161.693390,437.847565
	C161.211670,437.690216 160.729950,437.532867 160.248230,437.375519
	C160.578400,435.018646 160.135818,431.953064 161.460693,430.508453
	C162.731491,429.122803 165.835480,429.418427 168.870453,429.304016
	C174.068802,429.442566 178.530563,429.252319 182.992325,429.062012
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M41.789768,107.688446
	C38.817234,105.909805 35.890495,104.297569 33.729530,101.973335
	C32.983143,101.170570 33.534325,98.002823 34.557487,96.955994
	C36.648701,94.816429 39.460491,91.868896 42.675076,94.650902
	C45.523949,97.116379 47.112865,96.402618 49.835869,94.494423
	C54.707596,91.080460 56.818020,96.305794 59.465912,98.732597
	C60.263016,99.463150 60.051620,102.619820 59.146851,103.621353
	C56.859749,106.153008 54.248707,110.086395 50.190704,106.128426
	C46.559269,102.586502 44.663353,106.295929 41.789768,107.688446
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M103.423355,261.541138
	C108.615448,267.958771 113.807541,274.376434 118.999634,280.794098
	C119.538437,280.681763 120.077240,280.569397 120.616043,280.457062
	C119.710541,274.261261 118.805046,268.065491 117.831734,261.405701
	C119.671432,261.405701 122.658752,261.405701 125.996788,261.405701
	C120.297493,271.144897 123.801804,281.579468 120.827484,291.812012
	C115.071159,284.250610 109.314842,276.689209 103.285599,268.500122
	C101.585838,267.299774 100.159004,266.727142 98.732170,266.154510
	C98.334549,265.216858 97.936920,264.279175 97.571213,262.860168
	C99.543205,262.099548 101.483276,261.820343 103.423355,261.541138
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M285.523254,140.023132
	C287.366547,136.883835 289.549927,133.718079 292.774963,129.042023
	C294.654999,136.617157 297.787109,142.527756 304.124023,142.001160
	C309.309723,141.570236 314.210907,137.715622 319.238190,135.378784
	C319.113617,134.926254 318.989044,134.473709 318.864471,134.021164
	C319.513153,134.503250 320.195404,134.946472 320.805206,135.473511
	C326.247223,140.176804 331.850769,139.285538 335.412445,132.980652
	C339.009979,126.612305 337.980133,120.133362 335.317322,113.783585
	C334.966827,112.947815 333.524933,112.018753 332.682739,112.100769
	C331.897736,112.177216 330.623718,113.555740 330.638977,114.340179
	C330.684662,116.686012 331.310089,119.014900 331.604858,121.363495
	C331.808502,122.985832 331.839111,124.629890 331.947083,126.264236
	C330.050323,126.239273 327.887482,126.764244 326.340729,126.015877
	C325.096588,125.413910 324.212524,123.355591 323.869232,121.789886
	C323.469330,119.965965 323.832001,117.974861 323.863770,116.056305
	C322.222687,117.595589 320.491577,119.052284 318.975189,120.705917
	C318.101837,121.658340 317.575775,122.929268 316.565460,124.151413
	C317.119202,121.614746 317.494202,118.610657 319.060028,116.482811
	C320.109894,115.056099 322.816040,114.593521 324.857544,114.355583
	C325.291016,114.305061 326.161133,117.068336 326.644440,118.594040
	C327.392181,120.954483 327.980103,123.365540 328.635834,125.755127
	C329.264343,125.561043 329.892883,125.366966 330.521393,125.172882
	C330.142914,123.778717 329.678345,122.401161 329.405334,120.986641
	C328.952240,118.639053 328.057739,116.171043 328.439697,113.940491
	C328.692535,112.464005 330.814392,110.323669 332.164520,110.274765
	C333.755463,110.217125 336.179047,111.714821 336.923492,113.199203
	C341.748169,122.819229 340.569458,130.076859 333.440399,138.043015
	C332.801422,138.757004 332.426392,139.707214 331.499329,140.894501
	C329.368713,141.808121 327.667511,142.374954 325.966309,142.941788
	C322.306213,137.076050 320.432892,136.926605 314.687653,140.442749
	C307.071411,145.103973 302.381927,148.794220 291.599792,134.916931
	C289.682953,136.614334 287.773193,138.305496 285.523254,140.023132
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M259.653076,386.127594
	C257.269928,390.937408 254.574554,392.040375 247.148010,390.772919
	C242.602753,389.997162 239.135712,388.358917 237.813889,382.837677
	C235.256943,372.157288 231.819107,361.678375 228.444550,351.213318
	C227.943207,349.658569 225.798721,348.633636 224.414413,347.363617
	C224.219406,349.298889 223.428192,351.410828 223.939575,353.136810
	C225.564896,358.622559 227.857101,363.909027 229.529617,369.383118
	C230.509216,372.589355 230.918564,376.042542 226.596146,378.001831
	C229.931427,373.200684 227.122559,368.552734 225.638489,363.978149
	C224.671661,360.997955 223.348099,358.053894 221.701355,355.392456
	C219.185211,351.325928 219.770676,347.802368 221.996109,343.792755
	C223.993011,340.194885 225.702530,340.592896 227.100464,343.636627
	C230.076065,350.115509 232.917770,356.686005 235.283157,363.405914
	C237.375397,369.349792 238.903748,375.509033 240.396118,381.642548
	C242.025894,388.340668 243.455826,389.746552 250.322678,388.925446
	C253.372787,388.560760 256.294922,387.125732 259.653076,386.127594
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M360.094299,432.135681
	C359.521179,432.903351 358.948029,433.670990 357.939026,434.975647
	C357.615570,440.665771 357.727997,445.818909 357.840424,450.972046
	C357.840424,453.721527 357.840424,456.471008 357.840424,459.220490
	C357.267944,459.488434 356.695465,459.756378 356.122986,460.024323
	C350.992859,453.432495 345.862732,446.840698 340.732605,440.248871
	C340.376526,440.306274 340.020416,440.363678 339.664307,440.421112
	C339.664307,442.615204 339.664307,444.809326 339.284973,447.298157
	C338.643890,445.752472 338.461151,443.896362 338.099670,442.075745
	C337.683716,439.980713 337.109680,437.917084 336.604309,435.839813
	C335.868958,434.751740 335.133575,433.663666 334.223389,431.975098
	C334.062347,430.658020 334.076050,429.941437 334.089783,429.224854
	C337.768280,428.519226 340.305542,429.929504 342.458466,433.001068
	C346.137817,438.250427 350.166595,443.254913 354.754974,449.291534
	C355.723419,442.936707 355.788086,437.688751 353.333466,431.949890
	C353.091400,430.678589 353.112091,429.985199 353.132812,429.291840
	C355.106995,429.239990 357.081177,429.188141 359.482178,429.536469
	C359.970764,430.669647 360.032532,431.402679 360.094299,432.135681
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M328.786072,199.061462
	C328.952087,204.017593 329.018555,208.979538 329.307556,213.928482
	C329.733887,221.229538 329.695618,228.640564 331.060364,235.774170
	C331.934174,240.341614 334.978638,244.493790 337.483307,249.739700
	C330.921539,249.895386 323.891663,250.256790 317.217804,249.501968
	C319.658600,244.624054 321.742950,240.458450 324.492737,236.192780
	C328.900360,237.809311 328.043701,234.789230 328.053345,233.103104
	C328.098724,225.153610 327.923492,217.202438 328.006012,209.253738
	C328.041321,205.853973 328.512787,202.458755 328.786072,199.061462
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M53.296452,153.647491
	C51.473076,151.134872 49.912197,148.805237 53.334167,146.135559
	C56.268818,143.846069 58.789528,141.641876 62.056522,145.668335
	C62.594578,146.331482 64.934753,146.604645 65.375832,146.109070
	C69.979187,140.936874 73.081635,144.483749 76.284737,147.757553
	C76.859642,148.345154 77.401611,148.964996 78.245850,149.788971
	C78.138313,151.102783 77.743706,152.197586 76.780792,153.608032
	C73.131752,156.771042 70.091087,159.068954 66.462234,154.474228
	C66.202362,154.145203 64.044304,155.315353 62.768833,155.788452
	C62.768833,155.788452 62.958897,155.966293 62.516762,155.960571
	C59.803635,155.877533 57.532642,155.800217 55.261646,155.722916
	C55.261646,155.722916 55.049515,155.951477 55.141357,155.530273
	C54.592571,154.628983 53.951942,154.148911 53.311317,153.668823
	C53.311317,153.668823 53.289696,153.659668 53.296452,153.647491
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M412.436798,106.402374
	C412.436798,106.402374 412.295868,106.118500 412.069153,105.714005
	C410.180542,105.435326 408.503662,105.462608 406.860657,105.712532
	C404.916992,106.008217 403.002563,106.496048 401.075439,106.900589
	C401.075439,106.900589 401.012299,106.996666 401.009766,106.643188
	C400.352783,105.833336 399.698364,105.376961 399.043945,104.920586
	C398.714020,104.537888 398.384094,104.155197 397.668396,103.341751
	C393.607330,99.355698 397.511871,97.436005 398.991211,94.992989
	C398.991211,94.992989 399.000000,95.000000 399.374664,94.964417
	C402.043793,95.059212 404.338257,95.189598 406.632721,95.319984
	C406.632721,95.319984 406.823914,95.209038 406.845032,95.636276
	C408.308044,96.042709 409.801666,96.253525 411.179504,95.945831
	C413.160187,95.503510 415.056610,94.683701 416.988983,94.025017
	C417.861786,94.906677 418.734558,95.788338 419.948242,97.124985
	C422.762177,99.583740 423.784607,101.837425 421.508759,104.659317
	C421.508759,104.659317 421.186310,104.682884 420.698853,104.794388
	C417.619843,105.404724 415.028320,105.903549 412.436798,106.402374
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M539.159424,387.494843
	C534.875427,386.418365 533.293762,382.467651 533.270630,378.676147
	C533.185913,364.746826 533.725342,350.814270 533.978027,336.881989
	C534.062439,332.226807 534.116638,327.563568 533.923401,322.914917
	C533.856140,321.297058 533.001221,319.711975 532.506042,318.111908
	C531.036682,319.394226 529.524414,320.632111 528.123169,321.984985
	C527.682190,322.410797 527.539185,323.145264 526.934082,323.931030
	C525.803772,318.035583 531.449646,315.851074 533.400574,311.430603
	C533.983337,311.491486 534.566162,311.552399 535.148987,311.613281
	C535.544006,314.203094 536.267578,316.791107 536.281677,319.382996
	C536.389709,339.200775 536.258911,359.020477 536.487366,378.836304
	C536.519409,381.616241 538.101562,384.378357 539.159424,387.494843
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M50.968674,195.937286
	C51.310452,196.818619 51.652229,197.699951 51.901474,199.259277
	C49.592037,205.773270 47.891006,211.881500 44.999310,217.361404
	C42.570801,221.963531 43.599922,223.800583 47.973572,225.039612
	C45.557606,226.351105 43.377502,227.340240 41.197403,228.329376
	C41.053768,228.975220 40.910133,229.621063 40.306450,230.701752
	C39.662506,232.220886 39.478603,233.305161 39.294704,234.389435
	C39.099461,235.962326 38.904217,237.535202 38.343124,239.542755
	C38.152935,240.694046 38.328594,241.410675 38.504246,242.127304
	C39.795391,243.612015 41.086536,245.096725 42.833801,247.002777
	C43.898312,248.000580 44.506706,248.577011 45.115105,249.153442
	C39.031860,249.208252 32.948616,249.263062 26.415800,248.846985
	C25.947006,247.885010 25.927788,247.393921 25.908569,246.902847
	C25.908567,246.902847 25.999466,247.000000 26.252834,247.000488
	C27.049465,246.497330 27.592728,245.993698 28.135998,245.490082
	C31.767790,238.255386 35.399574,231.020691 39.530079,223.340363
	C40.277962,221.825409 40.527126,220.756073 40.776291,219.686752
	C41.984665,216.407852 43.193043,213.128952 44.851021,209.379578
	C45.481308,208.196228 45.662003,207.483337 45.842693,206.770462
	C46.005810,206.098450 46.168922,205.426437 46.789230,204.335297
	C47.419476,203.171005 47.592525,202.425842 47.765579,201.680695
	C48.357460,199.972931 48.949341,198.265182 49.998528,196.273636
	C50.626781,195.972321 50.797729,195.954803 50.968674,195.937286
z"/>
<path fill="#383B5E" opacity="1.000000" stroke="none"
	d="
M428.853821,335.996674
	C429.030304,335.669403 429.206787,335.342102 429.740875,334.594360
	C430.415344,333.459595 430.732208,332.745331 431.049072,332.031067
	C431.497314,331.381500 431.945526,330.731903 432.987183,330.044617
	C434.065948,329.983765 434.551239,329.960602 435.036530,329.937469
	C435.437531,330.290131 435.838531,330.642792 436.557312,331.421448
	C437.552032,332.269257 438.228973,332.691040 438.905914,333.112793
	C439.109253,333.220917 439.312561,333.329071 440.168793,333.295471
	C441.200378,332.427460 441.579071,331.701141 441.957733,330.974854
	C442.442688,330.627014 442.927643,330.279175 443.882935,330.150482
	C444.918182,330.554779 445.483093,330.739960 446.048035,330.925110
	C447.893158,332.474213 449.738312,334.023315 451.838928,336.093231
	C451.144623,339.367432 450.194855,342.120819 449.245087,344.874237
	C444.874695,342.286133 439.761780,345.177338 435.662109,343.399750
	C432.851166,342.180939 431.086304,338.549561 428.853821,335.996674
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M409.621399,428.922791
	C410.231018,429.334442 410.843170,429.912964 410.799744,429.967285
	C404.529358,437.808960 408.651398,446.802216 408.112335,455.250092
	C408.032318,456.504333 409.704712,457.870392 411.021729,459.879333
	C406.987427,459.879333 403.459076,459.879333 400.409973,459.879333
	C403.213348,449.714996 403.460968,439.793854 399.601898,428.844849
	C402.691772,428.844849 406.004791,428.844849 409.621399,428.922791
z"/>
<path fill="#383B5E" opacity="1.000000" stroke="none"
	d="
M589.036011,225.919891
	C583.221436,225.939346 577.406738,225.979340 571.592224,225.970230
	C568.318176,225.965088 566.022095,226.970184 566.335815,231.216949
	C566.556580,231.944351 566.549500,232.245682 566.019165,232.944397
	C565.302917,235.536591 564.999329,237.728821 564.695740,239.921066
	C565.272278,241.635208 565.848877,243.349350 566.727295,245.682159
	C567.367676,247.250412 567.706238,248.200012 568.044800,249.149597
	C567.594849,249.196411 567.144958,249.243225 566.185913,248.943024
	C564.778259,248.758270 563.879578,248.920563 562.980957,249.082855
	C561.921570,249.138931 560.862122,249.195023 559.202637,248.896393
	C557.389587,248.741821 556.176636,248.941971 554.963623,249.142136
	C554.514099,249.204773 554.064636,249.267410 553.275635,248.830139
	C552.870056,247.796021 552.804016,247.261841 552.737915,246.727661
	C552.737915,246.727661 553.000000,246.995117 553.180542,246.936371
	C553.930786,246.370163 554.500488,245.862701 555.070251,245.355225
	C556.423218,243.457230 557.776123,241.559219 559.653809,239.271790
	C561.026001,236.430283 561.873474,233.978210 562.720947,231.526123
	C563.796936,228.272079 564.872864,225.018036 566.454590,221.339111
	C567.893982,218.468155 568.827576,216.022049 569.761169,213.575943
	C569.889465,212.923141 570.017822,212.270325 570.336670,211.341721
	C572.719788,206.733261 574.912415,202.400604 577.528259,198.043365
	C577.951538,198.018799 578.070312,198.194702 578.047791,198.538300
	C578.013184,199.579269 578.001099,200.276657 577.924500,201.338593
	C575.186096,208.777145 572.512207,215.851135 569.478271,223.877792
	C576.156677,223.877792 581.913391,223.877792 587.963013,224.024979
	C588.515991,224.754745 588.776001,225.337311 589.036011,225.919891
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M537.294067,443.043945
	C536.796509,438.326294 536.299866,434.094666 535.743408,429.353516
	C538.230652,429.353516 541.953674,429.353516 545.826233,429.353516
	C541.299866,436.230621 541.396912,454.491669 546.579590,459.776123
	C542.265869,459.776123 538.644226,459.776123 536.173889,459.776123
	C536.557312,454.220306 536.926208,448.875183 537.294067,443.043945
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M305.036682,88.107605
	C299.704956,96.936981 294.125641,100.323792 286.313416,98.465866
	C290.632996,95.101929 294.233521,92.297935 297.834076,89.493942
	C297.785828,89.177666 297.737579,88.861389 297.689362,88.545105
	C295.403625,88.811340 293.121246,89.234604 290.830841,89.284195
	C289.483337,89.313370 287.321320,89.123955 286.964233,88.360229
	C286.479248,87.322914 286.893738,85.023392 287.761841,84.354408
	C290.273590,82.418701 293.080597,80.716232 296.019165,79.541039
	C297.751556,78.848213 299.954346,79.274788 301.944641,79.294533
	C307.435577,79.348991 308.428101,80.998253 306.024384,85.970299
	C305.735443,86.568016 305.471771,87.177948 305.036682,88.107605
M302.880341,86.598831
	C303.496826,85.043602 304.113342,83.488373 304.729828,81.933144
	C303.193970,81.753860 301.657684,81.428932 300.122314,81.433182
	C298.314545,81.438187 296.369965,81.365669 294.734528,81.985664
	C292.627411,82.784447 290.768158,84.237038 288.802155,85.408035
	C289.065094,85.726418 289.328003,86.044800 289.590912,86.363182
	C293.775116,86.556099 297.959290,86.749008 302.880341,86.598831
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M476.258270,282.797363
	C476.861603,285.494904 477.465393,287.719604 478.150818,290.245056
	C475.172729,290.245056 471.961548,290.245056 468.614288,290.245056
	C472.089355,285.020966 472.108826,266.164703 468.376648,261.143646
	C471.833252,261.143646 474.915283,261.143646 478.062866,261.143646
	C474.721161,267.937469 476.842773,275.242828 476.258270,282.797363
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M26.451975,400.191467
	C28.274075,402.994446 29.504982,406.556305 31.789072,409.212524
	C34.115410,411.917908 37.433117,415.356018 40.400887,415.438263
	C42.911907,415.507904 46.341972,411.688843 47.960888,408.802917
	C51.754738,402.039917 54.706562,394.804565 58.071701,387.411499
	C59.672623,385.592102 61.201111,384.121704 63.197800,382.308777
	C64.213638,381.365387 64.761284,380.764526 65.308922,380.163635
	C71.690483,379.908813 72.732826,380.726654 75.869438,388.880341
	C75.263512,388.887268 74.593521,388.631561 74.229645,388.146301
	C69.231369,381.480621 65.803162,381.271149 61.117306,388.537170
	C57.379185,394.333618 54.678993,400.824280 51.771755,407.123810
	C49.464867,412.122498 47.749516,418.113190 41.215103,418.310699
	C34.980103,418.499176 31.817774,413.396332 29.319124,408.378082
	C28.079975,405.889404 27.306900,403.168640 26.451975,400.191467
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M277.210754,54.372261
	C274.376221,54.917618 271.258118,54.473061 268.623413,55.401016
	C247.147415,62.965000 226.709961,72.618980 207.734039,85.382774
	C201.846085,89.343193 199.475845,94.825310 198.489258,101.028236
	C198.154160,103.135017 200.727783,105.704437 202.026489,108.397301
	C198.087402,108.081825 196.356842,105.493660 196.665100,101.714516
	C197.210617,95.026360 199.390213,89.275902 205.331116,85.141441
	C225.693344,70.970703 247.878250,60.572308 271.336639,52.799007
	C272.961700,52.260517 275.198730,53.568890 277.210754,54.372261
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M174.192947,281.371307
	C174.730591,284.516724 175.269012,287.228394 175.849091,290.149780
	C173.376831,290.149780 170.196030,290.149780 166.741394,290.149780
	C170.278427,285.048645 170.336639,266.217834 166.605240,261.292725
	C170.094666,261.292725 173.113464,261.292725 176.301361,261.292725
	C172.403839,267.507446 174.900375,274.382324 174.192947,281.371307
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M528.979126,460.242798
	C525.536377,460.203949 521.715637,460.809845 521.435669,455.170654
	C521.420471,454.091400 521.211304,453.548370 521.002136,453.005310
	C520.908813,452.636871 520.815430,452.268463 520.831909,451.334717
	C520.589539,450.119080 520.237244,449.468719 519.884949,448.818359
	C518.148804,447.697449 516.412659,446.576569 514.266724,445.101501
	C513.892212,444.322754 513.927429,443.898163 514.329163,443.309723
	C520.593628,441.881287 522.416382,439.940643 521.731262,435.655212
	C521.088440,431.633881 518.692078,430.463623 512.555359,431.309387
	C511.035034,432.187897 509.958740,433.147919 508.678040,433.885773
	C507.908630,433.148193 507.343628,432.632782 506.778625,432.117371
	C506.550323,431.936829 506.337311,431.739716 506.059967,431.011353
	C506.000610,430.026337 506.020874,429.556122 506.041077,429.085876
	C510.344513,428.989410 514.647888,428.821350 518.951355,428.817963
	C522.736023,428.814972 525.681335,430.305267 527.063965,434.844513
	C527.096802,436.537811 527.198364,437.430176 527.299866,438.322540
	C526.119873,440.081451 524.939941,441.840363 523.301514,443.897095
	C522.683838,444.424408 522.700073,444.640778 522.891907,444.844086
	C523.627686,445.917847 524.363403,446.991577 525.087219,448.717590
	C525.506653,450.304688 525.938110,451.239532 526.369568,452.174377
	C527.376892,453.995453 528.384216,455.816528 529.591187,458.099945
	C529.520264,459.122467 529.249695,459.682617 528.979126,460.242798
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M269.057648,432.917358
	C267.933807,432.215454 266.809967,431.513489 265.686127,430.811554
	C266.841858,430.183075 267.971497,429.074066 269.157806,429.009705
	C274.131226,428.740021 279.122772,428.683197 284.105591,428.737549
	C290.061951,428.802490 291.465454,430.895538 289.902802,438.213104
	C285.810089,434.125946 281.350281,430.196075 275.867554,433.412842
	C274.426392,434.258301 275.159271,438.809326 274.893738,441.658661
	C275.342346,441.928955 275.790955,442.199249 276.239532,442.469574
	C277.498016,441.523102 278.755157,440.574829 280.015442,439.630798
	C280.835754,439.016357 281.660645,438.407990 282.483459,437.796906
	C282.888184,438.796143 283.649567,439.801666 283.632050,440.793427
	C283.574982,444.025726 283.233459,447.253021 282.988800,450.657562
	C279.873138,448.568268 277.750305,447.144714 275.080261,445.402679
	C273.924164,440.510498 273.315216,435.936829 272.592743,430.510193
	C271.554443,431.217194 270.306030,432.067291 269.057648,432.917358
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M594.631714,460.309174
	C582.965576,457.681702 578.834595,445.626221 586.355103,434.344360
	C587.282043,433.437439 587.694275,432.839203 588.106445,432.240936
	C590.802856,431.048859 593.499329,429.856750 596.598389,429.051392
	C596.979736,429.913666 596.958496,430.389221 596.937256,430.864777
	C590.359985,433.149170 588.738708,438.691193 588.710632,444.624969
	C588.684265,450.201416 590.221497,455.454803 596.597900,458.215759
	C596.118103,459.229034 595.374878,459.769104 594.631714,460.309174
z"/>
<path fill="#2C2F57" opacity="1.000000" stroke="none"
	d="
M502.150024,208.811600
	C500.041168,209.688583 498.223511,210.420990 496.148865,210.663376
	C496.141022,209.161972 496.390167,208.150589 496.935120,206.988998
	C497.033234,204.846664 496.835541,202.854507 496.499664,200.485596
	C494.229431,196.464386 492.097382,192.819962 489.981567,188.801834
	C489.990295,187.680450 489.982819,186.932755 489.975372,186.185059
	C491.698730,186.157990 493.422119,186.130920 495.666565,186.596130
	C497.872742,187.355194 499.557831,187.621964 501.242920,187.888718
	C501.242920,187.888718 501.676697,187.878616 501.855774,188.356430
	C502.979309,189.562546 503.923767,190.290833 504.868256,191.019135
	C504.868256,191.019119 505.176514,191.256607 505.104004,191.930725
	C504.666687,197.018082 504.301880,201.431305 503.937073,205.844543
	C503.438477,206.785370 502.939880,207.726196 502.150024,208.811600
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M501.284241,130.460510
	C502.697693,131.240402 503.756805,132.234299 504.956421,133.011383
	C506.870514,134.251312 508.878052,135.347046 510.502930,136.870453
	C508.808838,136.720093 507.457916,136.203003 506.106995,135.685928
	C504.884521,136.801987 503.550018,137.819077 502.460419,139.052521
	C499.089996,142.867813 495.812836,146.765518 491.919281,150.856735
	C489.904816,151.773758 488.470581,152.465286 487.036316,153.156830
	C484.979523,153.115280 482.922729,153.073715 480.238525,152.769348
	C478.732269,152.361191 477.853394,152.215866 476.974518,152.070526
	C476.675781,151.911621 476.377075,151.752716 475.677765,151.272385
	C474.520538,150.629395 473.763855,150.307816 473.007202,149.986237
	C470.864960,148.410645 468.722687,146.835037 466.216156,144.869400
	C465.695312,144.144409 465.538788,143.809448 465.382233,143.474487
	C468.850555,145.296036 472.371063,147.025604 475.776489,148.957993
	C483.150604,153.142426 491.547455,151.070419 495.202179,143.133499
	C492.995880,142.855560 491.113403,142.560303 489.219574,142.394623
	C486.875610,142.189560 484.522247,142.091980 482.478394,141.457779
	C485.404785,140.520432 488.025787,140.073257 490.646759,139.626099
	C491.237549,139.470749 491.828369,139.315399 493.000244,139.044128
	C494.184021,138.375687 494.786713,137.823151 495.389435,137.270615
	C495.807556,136.932449 496.225677,136.594284 497.074402,135.957779
	C498.013947,134.777161 498.522858,133.894867 499.031769,133.012573
	C499.685486,132.200806 500.339203,131.389038 501.284241,130.460510
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M142.880096,429.267456
	C145.405167,429.115997 147.930237,428.964508 151.585464,428.745239
	C143.669250,437.157928 148.012909,446.215485 147.127274,454.536041
	C147.040497,455.351257 148.825394,457.085083 149.845963,457.172394
	C153.933563,457.522339 158.388062,458.024536 159.082825,451.997833
	C159.184418,451.116577 159.911972,450.307434 160.542694,449.093964
	C164.827591,451.954132 161.348190,455.323883 161.538239,458.165833
	C161.594528,459.007446 159.418518,460.739624 158.202026,460.800659
	C151.906921,461.116547 145.590515,461.083496 139.283600,461.005249
	C138.362961,460.993835 137.453445,460.085815 136.606522,459.629211
	C138.261292,457.511200 139.616364,455.776794 141.408844,454.219055
	C141.584671,455.886993 141.323090,457.378296 141.066315,458.842224
	C142.865784,458.842224 144.621521,458.842224 145.735825,458.842224
	C145.735825,449.594879 145.735825,440.615509 145.735825,431.693970
	C144.771347,430.874451 143.825729,430.070953 142.880096,429.267456
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M225.843384,203.955490
	C226.893295,201.216003 227.892365,198.455658 229.005630,195.742157
	C230.487305,192.130646 228.735733,190.566071 225.497269,189.585861
	C224.464523,189.273270 223.662216,188.199326 222.754486,187.473740
	C223.855408,187.015015 224.949051,186.182114 226.058487,186.160477
	C231.718796,186.050125 237.384964,186.084503 243.044327,186.240799
	C243.959869,186.266098 244.851440,187.158951 245.754089,187.650787
	C245.192795,188.349503 244.776398,189.349731 244.047623,189.699966
	C237.232285,192.975311 232.625610,198.461472 228.171219,204.806610
	C227.023834,204.599167 226.433609,204.277328 225.843384,203.955490
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M296.032684,385.888733
	C294.696289,386.528351 292.794189,386.812897 292.128510,387.873505
	C290.051697,391.182465 287.471008,391.563477 284.074219,389.842407
	C288.271698,389.497742 290.408936,387.632416 291.805115,383.163666
	C293.451569,377.893982 296.646515,373.066650 299.467712,368.220825
	C301.197937,365.248871 303.461365,365.704529 305.354980,368.306305
	C308.896790,373.172638 309.776581,378.522919 308.536987,384.406433
	C308.237732,385.826813 309.063232,387.484192 309.708771,389.260071
	C308.206207,389.551666 306.170929,390.093475 304.617310,389.457855
	C303.942871,389.181946 303.618256,386.155487 304.238068,384.941711
	C306.833130,379.859680 306.806335,375.135956 303.363892,370.076355
	C295.850586,371.945007 297.005127,378.624969 295.782990,384.251740
	C296.034760,385.141876 296.033722,385.515289 296.032684,385.888733
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M228.142914,289.912598
	C224.557144,280.379028 220.971359,270.845490 217.397827,261.344482
	C222.629715,259.706085 222.996628,260.043854 224.553436,265.314911
	C226.056580,270.404327 228.032074,275.354279 229.832397,281.077026
	C231.070267,282.304596 232.275787,282.820557 233.481308,283.336548
	C233.418198,283.707672 233.355087,284.078796 232.926208,284.872986
	C232.395996,285.889282 232.231522,286.482483 232.067047,287.075684
	C231.833450,287.881622 231.599854,288.687531 230.844269,289.735046
	C229.595840,289.955292 228.869370,289.933929 228.142914,289.912598
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M367.007935,286.986176
	C367.361389,287.363525 367.714844,287.740845 368.368469,288.573486
	C367.400513,289.590363 366.132355,290.151978 364.864166,290.713562
	C364.441254,290.595642 364.018341,290.477692 363.158386,290.035187
	C362.203125,289.416779 361.684906,289.122955 361.166656,288.829102
	C361.166656,288.829102 360.997192,288.985657 361.051422,288.602600
	C360.558258,287.629425 360.010864,287.039307 359.463470,286.449219
	C357.895477,284.033295 356.327454,281.617340 354.456238,278.661316
	C353.670563,277.583496 353.188141,277.045776 352.705719,276.508057
	C352.535156,277.374817 352.364594,278.241608 352.194031,279.108368
	C352.501099,282.008759 352.808197,284.909180 353.473145,288.406555
	C353.908203,289.449310 353.985413,289.895081 354.062622,290.340820
	C351.332245,290.328156 348.601898,290.315491 345.460052,289.923401
	C345.024841,289.356873 345.001099,289.169739 344.977386,288.982605
	C345.618591,288.199463 346.259827,287.416290 347.182617,286.315826
	C347.634155,285.996033 347.804077,285.993530 348.246094,286.178772
	C349.056183,286.243896 350.063721,286.125854 350.064972,285.997986
	C350.139923,278.313721 350.132141,270.628662 350.132141,262.036072
	C349.031921,263.560303 348.511475,264.281311 347.735779,265.002380
	C347.310486,265.003448 347.140350,265.004517 346.970215,265.005615
	C346.835846,264.610931 346.701477,264.216278 346.481812,263.139160
	C346.571899,261.850189 346.747314,261.243683 346.922729,260.637146
	C348.352051,260.690765 349.781372,260.744385 351.715515,261.177673
	C352.438721,262.100098 352.657074,262.642822 352.590515,263.536926
	C351.270142,272.198730 351.271423,272.195679 358.852966,275.399384
	C359.137817,275.519745 359.348297,275.815918 359.593445,276.030182
	C361.234955,278.867371 362.876465,281.704559 364.784668,285.082214
	C365.703583,286.077148 366.355743,286.531677 367.007935,286.986176
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M436.672791,458.244781
	C432.588928,452.797943 428.505096,447.351074 424.267944,441.246613
	C422.476532,439.710632 420.838440,438.832275 419.200348,437.953888
	C419.069092,437.291382 418.937836,436.628906 418.870728,435.296204
	C418.375763,434.043793 417.816681,433.461578 417.257599,432.879333
	C417.257599,432.879333 417.109985,432.894226 417.112610,432.476990
	C417.101654,431.145966 417.088104,430.232178 417.074524,429.318390
	C417.792389,429.282196 418.510223,429.246002 419.666748,429.626343
	C420.875763,430.279175 421.646118,430.515503 422.416443,430.751801
	C426.441223,435.829742 430.466003,440.907684 434.639038,446.649475
	C435.868958,448.194641 436.950592,449.075989 438.048553,449.970612
	C439.023895,447.818756 439.662689,446.409424 440.301514,445.000122
	C440.307312,446.708313 440.313141,448.416504 439.944550,450.806519
	C438.604340,453.740509 437.638580,455.992645 436.672791,458.244781
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M122.691452,457.627747
	C127.016205,455.417938 127.423203,451.471832 127.759102,447.186981
	C128.598618,436.477997 128.548492,435.529022 123.770264,429.396912
	C127.686539,429.396912 131.062149,429.396912 133.271652,429.396912
	C132.593033,436.280701 131.305573,443.162140 131.404510,450.023590
	C131.509583,457.310059 124.056396,462.760925 117.281296,460.486389
	C119.681641,459.635223 121.869125,459.206909 124.618774,458.668488
	C123.527695,458.079315 123.109573,457.853516 122.691452,457.627747
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M259.904236,357.019958
	C258.973541,356.287689 258.320251,355.771362 257.684235,355.234558
	C251.532623,350.042694 251.534592,347.532379 258.033722,341.408966
	C260.557159,343.414520 263.262878,345.330597 265.687561,347.553223
	C268.515656,350.145630 267.333282,356.846466 263.798737,358.110382
	C262.825500,358.458374 261.404938,357.555389 259.904236,357.019958
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M208.355194,441.189209
	C208.885468,441.395844 209.415741,441.602478 209.563019,442.517212
	C208.924530,444.301575 208.669037,445.377869 208.413559,446.454163
	C208.450928,448.876831 208.488312,451.299530 208.348999,454.429565
	C208.570877,455.815155 208.969452,456.493378 209.368011,457.171631
	C209.736908,457.347321 210.105820,457.523010 210.645355,458.209137
	C207.659256,459.883789 204.456680,461.497101 201.796783,457.798187
	C202.163513,457.372772 202.530243,456.947388 203.298416,455.998444
	C203.420044,452.557495 203.140213,449.640076 202.860382,446.722656
	C199.767502,441.929047 196.674622,437.135437 193.435059,431.755920
	C196.400253,429.787476 199.530457,428.230164 202.091599,432.094116
	C202.339844,433.455048 202.588074,434.816010 202.928680,436.848907
	C203.569092,438.074615 204.117111,438.628357 204.665146,439.182098
	C204.665146,439.182098 204.882050,439.581604 204.983673,440.201416
	C206.175262,440.943909 207.265228,441.066559 208.355194,441.189209
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M485.171753,407.823914
	C487.358765,407.619232 489.545746,407.414490 491.732758,407.209778
	C491.873596,406.643036 492.014465,406.076294 492.155304,405.509552
	C495.043610,407.685425 498.214905,409.577545 500.750641,412.106873
	C504.150696,415.498230 501.909546,418.907074 499.753784,421.946716
	C496.599152,426.394806 494.420898,421.496887 492.891815,421.154541
	C489.828461,421.962128 487.028900,423.622498 485.838135,422.838684
	C482.461273,420.615997 478.988525,417.808105 477.104370,414.378632
	C476.252350,412.827820 478.894867,409.152863 480.358429,406.682404
	C480.709900,406.089050 482.680725,406.455048 483.614990,406.837524
	C481.800598,409.266571 478.598572,411.988007 479.079407,413.064545
	C480.372467,415.959656 483.238495,418.152161 486.064575,421.268127
	C488.609863,416.746704 491.066315,416.428467 494.141846,419.294495
	C494.772980,419.882629 497.679199,419.366943 498.055695,418.616791
	C498.879578,416.975006 499.628235,414.282104 498.824493,413.057892
	C497.364349,410.833954 494.750305,409.367554 492.676575,407.634125
	C487.919739,411.869110 487.791504,411.866791 485.171753,407.823914
z"/>
<path fill="#282B57" opacity="1.000000" stroke="none"
	d="
M484.998871,407.655396
	C487.791504,411.866791 487.919739,411.869110 492.676575,407.634125
	C494.750305,409.367554 497.364349,410.833954 498.824493,413.057892
	C499.628235,414.282104 498.879578,416.975006 498.055695,418.616791
	C497.679199,419.366943 494.772980,419.882629 494.141846,419.294495
	C491.066315,416.428467 488.609863,416.746704 486.064575,421.268127
	C483.238495,418.152161 480.372467,415.959656 479.079407,413.064545
	C478.598572,411.988007 481.800598,409.266571 483.651215,407.160217
	C484.275330,407.153656 484.557587,407.307556 484.998871,407.655396
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M461.606934,447.349915
	C461.606934,447.349884 461.271179,447.076538 461.161865,446.631165
	C460.419678,445.946411 459.786774,445.707001 459.153900,445.467529
	C458.561768,445.523102 457.969666,445.578674 456.591888,445.876404
	C455.986633,449.447144 456.167023,452.775696 456.347412,456.104248
	C456.667114,456.474915 456.986786,456.845581 457.456482,457.807404
	C454.712128,458.241943 451.817719,458.085327 448.923309,457.928711
	C448.923309,457.928711 448.864990,457.911560 449.216583,457.934204
	C450.012543,457.270996 450.456909,456.585205 450.901276,455.899384
	C450.984711,450.567627 451.068146,445.235901 451.404175,439.191956
	C451.475159,436.994751 451.293549,435.509766 451.111908,434.024750
	C450.827148,433.534210 450.542389,433.043701 450.155701,432.012329
	C450.364441,430.688660 450.675110,429.905792 450.985779,429.122894
	C452.667664,429.152405 454.349609,429.181915 456.431244,429.577942
	C456.807526,430.804657 456.784088,431.664825 456.760681,432.525024
	C456.760681,432.525024 456.718079,432.707764 456.292053,432.900635
	C456.054108,436.135956 456.242188,439.178406 456.430298,442.220825
	C456.430298,442.220825 456.637390,442.413574 456.774902,442.803101
	C457.975861,442.952942 459.039246,442.713226 460.102661,442.473511
	C461.147949,441.302399 462.193268,440.131317 463.527039,439.439240
	C463.987427,440.724213 464.159393,441.530182 464.331329,442.336151
	C464.345459,443.617432 464.359619,444.898682 463.898071,446.660156
	C462.817230,447.210205 462.212067,447.280060 461.606934,447.349915
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M134.135223,84.978661
	C134.190826,85.389610 134.246414,85.800560 134.279236,86.879196
	C134.748749,89.106491 134.997620,90.803139 135.782761,92.197891
	C137.544098,95.326729 139.550949,95.630348 141.548035,92.348961
	C141.964432,93.023209 142.252213,93.529701 142.635986,94.387733
	C142.783813,94.976608 142.835693,95.213943 142.901108,95.551285
	C142.914658,95.651299 142.944962,95.850861 142.944962,95.850861
	C141.358353,101.316895 139.366028,102.122215 134.324097,98.801018
	C133.576599,98.604691 133.249954,98.772728 132.923309,98.940773
	C132.107132,100.179375 131.290955,101.417976 129.913315,102.897583
	C128.197556,103.489540 127.043266,103.840500 125.888977,104.191452
	C125.888977,104.191452 125.874138,104.096619 125.869827,103.737175
	C124.876587,102.655632 123.887650,101.933533 122.898720,101.211433
	C122.533104,100.399162 122.167480,99.586884 121.828522,98.105225
	C122.368515,94.625389 123.565598,95.071205 125.635262,96.236244
	C129.251602,98.271919 131.413681,96.756638 130.897430,92.632866
	C130.533310,89.724205 129.652542,86.880226 129.002426,84.007370
	C129.002426,84.007370 129.000610,84.000504 129.389481,83.998550
	C131.230637,84.323959 132.682938,84.651314 134.135223,84.978661
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M194.321884,123.101807
	C191.687347,126.019386 189.569809,125.685707 187.606613,122.820663
	C187.045242,122.001434 186.388107,121.221939 185.660904,120.547005
	C183.357468,118.409111 181.635757,116.232933 184.989944,113.607262
	C187.848328,111.369728 190.667557,108.297409 194.278778,112.572021
	C194.600433,112.952744 194.962860,113.299255 195.309662,113.658470
	C200.152557,118.674736 200.147186,118.743622 194.321884,123.101807
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M37.634415,445.303070
	C34.368225,444.721497 33.629150,446.515747 33.637939,449.839783
	C33.510078,451.259399 33.652138,452.106079 33.794197,452.952789
	C33.829605,453.419098 33.865009,453.885376 33.659698,454.857117
	C33.786327,455.956573 34.153671,456.550568 34.521015,457.144562
	C34.521015,457.144562 34.940006,457.316711 35.033096,457.828827
	C32.671535,458.131348 30.216881,457.921722 27.762226,457.712097
	C28.022951,457.081879 28.283676,456.451630 28.987389,455.291595
	C29.206940,448.111664 28.983501,441.461517 28.760067,434.811401
	C28.429489,434.145142 28.098906,433.478851 27.483822,432.247711
	C27.178740,430.893921 27.158155,430.105042 27.137573,429.316132
	C29.773268,429.237183 32.408962,429.158264 35.443295,429.418335
	C35.489819,430.675873 35.137707,431.594452 34.785599,432.513031
	C34.785599,432.513031 34.616020,432.718262 34.184406,432.916748
	C33.773769,435.394440 33.794746,437.673615 33.815720,439.952820
	C33.842331,440.159210 33.868942,440.365631 33.868561,441.250977
	C34.889111,442.476105 36.419514,443.755585 36.899361,443.439636
	C38.825520,442.171295 40.426300,440.408813 42.147346,438.828949
	C42.263588,441.554596 42.379833,444.280243 42.118477,447.368958
	C40.372051,446.922363 39.003231,446.112701 37.634415,445.303070
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M591.780396,144.699890
	C595.921753,142.566254 600.739258,144.396469 603.161743,149.238525
	C605.518250,153.948776 600.390015,154.870087 598.261353,156.416443
	C593.554626,159.835663 591.735901,154.291962 589.310364,152.039581
	C585.985779,148.952347 589.179749,146.845642 591.780396,144.699890
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M317.026398,442.204895
	C317.862366,441.282776 318.698364,440.360657 320.046936,439.213928
	C320.762695,438.946136 320.965881,438.902924 321.169067,438.859741
	C321.368866,442.506409 321.568665,446.153107 321.821655,450.770905
	C319.132385,448.578125 317.377960,447.147614 314.979004,445.451599
	C310.708221,448.046082 311.980957,451.536804 313.070374,455.003906
	C313.536591,455.704895 314.002777,456.405914 314.707764,457.706177
	C314.938049,459.002747 314.929565,459.700073 314.921082,460.397400
	C314.196625,460.391693 313.472198,460.385956 312.168518,459.984497
	C309.716644,459.045197 307.844025,458.501678 305.971375,457.958130
	C306.260986,457.753235 306.550598,457.548370 307.443207,457.087799
	C308.278870,449.149414 308.524384,441.467010 308.695221,433.782959
	C308.701752,433.487823 307.988861,433.176697 307.611206,432.873047
	C307.061859,431.991058 306.512543,431.109039 305.294739,429.153778
	C308.512573,429.153778 310.796936,429.153778 313.492828,429.544952
	C313.868347,430.788452 313.832336,431.640747 313.796326,432.493073
	C313.796356,432.493073 313.622314,432.735779 313.122345,432.897522
	C312.410278,435.632660 311.635437,438.327362 312.156158,440.742706
	C312.609222,442.844147 314.093567,446.159088 317.026398,442.204895
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M599.371704,280.206024
	C599.334900,281.805267 599.298157,283.404541 599.213989,285.713959
	C599.685303,287.020111 600.204041,287.616119 600.722778,288.212128
	C601.055481,288.571869 601.739990,289.138489 601.668213,289.260498
	C600.476624,291.287018 594.495850,290.948944 593.422363,288.469360
	C594.236389,287.362366 594.455139,286.591400 594.673889,285.820435
	C594.693176,284.209778 594.712463,282.599091 594.820068,280.293274
	C594.492249,278.931885 594.076111,278.265686 593.659973,277.599457
	C590.843140,272.406494 588.026245,267.213501 585.146362,261.904266
	C587.978027,259.774170 590.343018,260.361328 592.033569,264.037292
	C593.483032,267.189301 595.262878,270.189392 596.992981,273.909607
	C597.850098,276.443756 598.610901,278.324890 599.371704,280.206024
z"/>
<path fill="#313458" opacity="1.000000" stroke="none"
	d="
M65.560638,438.239655
	C65.748901,438.873230 65.937172,439.506836 66.080460,440.792053
	C66.525078,442.381927 67.014671,443.320221 67.504272,444.258484
	C67.676659,444.905212 67.849045,445.551941 68.004547,446.810913
	C68.390633,448.055389 68.793602,448.687622 69.196579,449.319824
	C69.448036,450.269745 69.699501,451.219666 69.953812,452.811584
	C70.387779,454.071899 70.818893,454.690216 71.250000,455.308533
	C71.738838,456.007202 72.227684,456.705841 72.959396,458.005493
	C73.127144,459.172760 73.052032,459.739044 72.976929,460.305298
	C70.945953,460.258362 68.914970,460.211426 66.363586,459.741455
	C65.691193,458.735748 65.539207,458.153107 65.387230,457.570435
	C64.526192,454.688141 63.665161,451.805817 62.459122,448.465149
	C62.067860,447.332550 62.021599,446.658386 61.984055,445.578247
	C60.996952,442.451874 60.001133,439.731384 58.792301,436.853516
	C58.429554,436.198395 58.279823,435.700714 58.297112,434.906433
	C58.473545,433.961487 58.482956,433.313110 58.492363,432.664734
	C59.162560,431.335114 59.832760,430.005524 61.241505,427.210724
	C62.660137,430.805634 63.477627,432.877228 64.264282,435.616028
	C64.675842,436.935364 65.118240,437.587524 65.560638,438.239655
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M413.151154,411.127930
	C413.540833,410.881958 413.921997,410.929901 414.132019,411.144928
	C422.393158,419.605194 427.331390,418.721344 432.026367,407.804657
	C435.552460,399.605743 437.741882,390.644501 444.945221,384.557404
	C446.765198,383.019409 449.178833,382.183899 451.678223,380.913116
	C453.062653,381.963715 454.088501,383.126770 455.075684,384.631897
	C449.236786,383.238220 444.763062,385.747925 441.013855,393.278839
	C438.581665,398.164307 436.577911,403.261658 434.317810,408.234802
	C433.431458,410.185150 432.404266,412.074646 431.379852,413.958496
	C429.235474,417.901733 425.893066,419.896729 421.482635,418.862488
	C417.543610,417.938751 414.042084,416.036499 413.151154,411.127930
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M391.322968,144.690109
	C387.343231,149.328506 383.270905,148.709473 381.430237,142.994690
	C380.587006,140.376724 380.397430,137.548218 380.207947,134.162933
	C380.312988,131.334183 380.121490,129.157700 379.929993,126.981224
	C380.042419,123.443588 380.154816,119.905945 380.508301,115.605553
	C380.832428,114.279739 380.915436,113.716690 380.998474,113.153625
	C381.731415,112.743713 382.464355,112.333801 383.531158,111.947784
	C384.123779,112.758385 384.382507,113.545105 384.540039,114.814819
	C384.558990,115.878853 384.679138,116.459885 384.799286,117.040909
	C384.829956,118.741516 384.860626,120.442123 384.890991,123.009041
	C384.918854,128.250000 384.946991,132.624649 384.975159,136.999298
	C384.910431,137.436462 384.845734,137.873642 384.570068,138.847351
	C383.111786,143.482895 385.278412,143.637207 388.304504,142.798431
	C388.913147,142.888275 389.521759,142.978119 390.637878,143.502502
	C391.204559,144.188049 391.263763,144.439072 391.322968,144.690109
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M191.029465,247.066147
	C198.554626,243.463669 202.717438,236.689178 207.687866,229.989136
	C208.878098,230.263016 209.435150,230.627029 209.992203,230.991058
	C209.992203,230.991058 210.000000,231.000610 209.710098,231.092743
	C209.343079,231.554947 209.265961,231.925003 209.188843,232.295059
	C208.244568,234.958130 207.300293,237.621216 205.997116,240.766541
	C205.796310,241.840057 205.954437,242.431320 206.112564,243.022598
	C206.305542,243.590759 206.498520,244.158905 206.869873,245.322021
	C208.080307,246.785049 209.112366,247.653137 210.713058,248.999512
	C204.547150,248.999512 199.178055,249.092590 193.818146,248.912521
	C192.868973,248.880630 191.958054,247.710602 191.029465,247.066147
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M32.985832,146.003082
	C27.602234,142.614822 29.535484,136.677063 28.131611,131.910263
	C27.731939,130.553192 27.869696,129.037827 27.761003,127.595062
	C27.188175,127.612549 26.615349,127.630028 26.042522,127.647514
	C26.280014,130.761780 26.370075,133.896332 26.794861,136.984848
	C27.255251,140.332214 28.027569,143.636703 28.242184,147.210785
	C27.349300,147.096954 26.878090,146.732208 26.406876,146.367477
	C26.487572,146.028687 26.447617,145.704773 26.174442,144.895432
	C25.724749,143.925171 25.387621,143.455200 25.050495,142.985245
	C24.992504,142.543427 24.934513,142.101593 24.835184,140.948029
	C24.649065,138.410629 24.252672,136.563736 24.404802,134.763184
	C24.947441,128.340851 25.580124,121.921364 26.436632,115.535400
	C26.568295,114.553749 28.055099,113.753853 28.915173,112.869896
	C29.651745,113.954796 30.461498,114.999260 31.093061,116.142189
	C31.394842,116.688316 31.358503,117.421280 31.475309,118.069618
	C31.307308,118.488617 31.139309,118.907616 30.708431,119.954292
	C30.668900,124.709557 30.892242,128.837143 31.115585,132.964737
	C31.133049,134.687302 31.150513,136.409851 31.220131,138.875977
	C31.843468,141.747391 32.414650,143.875229 32.985832,146.003082
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M359.547821,51.171150
	C359.460846,51.841534 359.373871,52.511913 359.261475,53.795635
	C359.142548,54.611389 359.049042,54.813797 358.562195,55.014206
	C356.884583,55.112610 355.600372,55.213020 354.207825,55.206123
	C354.099518,55.098824 353.875458,54.891983 353.962158,54.551414
	C353.537079,51.642284 353.025299,49.073730 352.513550,46.505169
	C351.377014,45.521252 350.030151,44.695801 349.145752,43.521900
	C347.014008,40.692245 345.098663,37.699562 343.433411,34.232586
	C345.465210,33.512547 347.159607,33.332542 348.854034,33.152542
	C348.854034,33.152542 348.997559,33.002136 348.946716,33.386948
	C349.505127,34.292797 350.114410,34.813828 350.723633,35.334862
	C352.026764,37.043896 353.329865,38.752918 354.891296,41.057022
	C356.759796,43.102524 358.369965,44.552948 359.980133,46.003372
	C359.961975,46.752312 359.943817,47.501247 359.716949,48.823257
	C359.521454,49.987942 359.534637,50.579544 359.547821,51.171150
z"/>
<path fill="#2E2F52" opacity="1.000000" stroke="none"
	d="
M561.271973,443.916199
	C560.593994,443.100250 559.916077,442.284363 559.127686,440.817688
	C557.261841,438.395416 555.506531,436.623871 553.751160,434.852325
	C553.315979,434.331116 552.880798,433.809875 552.294556,432.657837
	C552.129578,431.130768 552.115723,430.234528 552.101807,429.338318
	C552.803162,429.306030 553.504517,429.273743 554.616455,429.638519
	C555.951721,430.388824 556.876465,430.742065 557.801208,431.095306
	C558.189758,431.484344 558.578369,431.873383 559.014282,432.863556
	C559.662903,433.991577 560.264221,434.518494 560.865540,435.045380
	C561.228394,435.444916 561.591187,435.844452 562.007874,436.829529
	C562.934753,438.309113 563.807800,439.203125 564.680908,440.097137
	C565.789062,441.428894 566.897156,442.760651 568.046509,444.770264
	C569.452087,447.013733 570.686096,448.722076 572.209839,450.113129
	C574.835022,452.509552 574.814331,455.583344 571.940063,458.033447
	C571.315918,457.271698 570.691711,456.509949 570.022827,455.140808
	C569.395325,453.999969 568.812378,453.466522 568.229431,452.933075
	C567.828125,452.550873 567.426880,452.168701 566.985107,451.192322
	C566.077087,449.697723 565.209656,448.797272 564.342224,447.896820
	C563.941528,447.473206 563.540771,447.049561 563.077637,446.031189
	C562.434082,444.929688 561.853027,444.422943 561.271973,443.916199
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M582.956787,90.292816
	C583.391113,88.869812 583.660339,87.367447 584.297485,86.041855
	C585.329163,83.894928 586.157776,80.836418 587.902405,80.081421
	C589.553589,79.366859 592.540466,80.713829 594.419678,81.946877
	C595.496704,82.653481 595.537781,84.938873 596.045288,86.513504
	C594.552673,86.693680 593.061584,86.991943 591.566956,87.010735
	C590.637634,87.022423 589.703064,86.610977 587.803467,86.159576
	C587.594727,89.901611 587.723083,93.288834 587.106567,96.534584
	C586.732605,98.503403 585.206482,100.253372 584.197998,102.101669
	C583.048340,100.532036 581.787476,99.029350 580.788025,97.369286
	C580.119446,96.258713 579.822327,94.924522 579.660889,93.411217
	C581.310791,95.379951 582.658691,97.627884 584.197876,100.194870
	C587.762146,95.828018 585.116150,93.101440 582.956787,90.292816
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M489.652649,186.011108
	C489.982819,186.932755 489.990295,187.680450 489.537872,188.807159
	C480.202148,187.669373 478.290161,189.255920 478.263214,198.040344
	C478.249969,202.355087 478.128937,206.669479 478.056641,210.984039
	C477.387146,209.714813 476.181305,208.463120 476.139221,207.173416
	C475.936646,200.969070 476.048096,194.754440 476.048096,188.252930
	C474.443359,188.252930 472.554565,188.252930 470.088348,188.252930
	C470.088348,191.287704 470.088348,194.066666 469.760864,196.954514
	C469.760773,191.710403 465.988831,189.293884 461.354431,187.495117
	C461.614624,186.942459 461.874817,186.389786 462.135010,185.837128
	C471.199982,185.837128 480.264954,185.837128 489.652649,186.011108
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M439.852448,46.302422
	C438.793762,45.580765 437.735107,44.859112 436.306274,43.744385
	C435.369110,42.811626 434.802094,42.271942 434.235107,41.732250
	C434.014130,40.828465 433.793152,39.924686 433.851074,38.583664
	C436.897125,35.151844 439.366974,31.517544 444.754486,33.536484
	C444.821106,33.926956 444.858887,34.552208 445.038483,35.133675
	C446.042236,38.384045 447.080292,41.623825 448.106659,44.867218
	C448.106659,44.867218 448.040558,44.935741 448.053894,45.318771
	C447.722565,47.206738 447.377899,48.711674 447.033203,50.216610
	C446.577301,50.216091 446.121368,50.215572 445.164215,49.888535
	C443.059448,48.475483 441.455963,47.388950 439.852448,46.302422
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M87.626511,460.255066
	C84.680710,457.873993 81.734901,455.492950 78.778687,452.341309
	C78.694046,446.883789 78.619804,442.196899 78.545563,437.510010
	C80.086510,435.374847 81.627457,433.239685 83.828491,431.030090
	C85.282257,431.519562 86.075935,432.083527 86.869614,432.647461
	C85.788559,434.821503 84.707520,436.995575 83.142334,439.675903
	C82.838867,442.843536 83.019539,445.504883 83.200203,448.166260
	C84.849503,452.251221 85.765755,456.951080 91.558960,458.254364
	C90.435600,459.226898 89.031052,459.740967 87.626511,460.255066
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M492.829346,440.964539
	C492.829346,443.987152 492.829346,447.009766 492.829346,450.753906
	C490.302094,448.485107 488.661713,447.012482 486.323639,445.331940
	C482.119049,447.762756 482.057709,453.269043 485.491699,457.175629
	C485.713043,457.282349 485.934418,457.389099 486.401855,457.957794
	C483.435516,458.285248 480.223053,458.150757 477.010620,458.016266
	C477.339081,457.807434 477.667542,457.598633 478.571960,457.159241
	C479.326752,456.135468 479.505585,455.342316 479.684387,454.549164
	C479.645752,448.817596 479.607086,443.086029 479.750000,436.462280
	C479.384796,433.422913 478.837982,431.275726 478.291168,429.128571
	C479.574432,429.166473 480.857727,429.204376 482.604462,429.669983
	C483.106934,433.487274 482.956146,436.895386 483.283539,440.256927
	C483.404999,441.504211 484.420654,443.262299 485.449554,443.639740
	C486.317780,443.958191 487.794952,442.616638 489.002563,442.009827
	C489.002563,442.009827 489.000000,442.000000 489.352051,441.972290
	C490.075623,441.200073 490.447113,440.455566 490.818604,439.711060
	C491.036499,439.361115 491.254364,439.011200 491.726807,439.057373
	C492.264069,439.957153 492.546692,440.460846 492.829346,440.964539
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M571.983521,458.397278
	C574.814331,455.583344 574.835022,452.509552 572.209839,450.113129
	C570.686096,448.722076 569.452087,447.013733 568.132141,445.082275
	C569.227173,445.460693 570.277710,446.205017 572.316040,447.649170
	C572.052673,441.077942 575.023315,434.866821 568.361938,429.671204
	C572.025696,429.671204 575.689514,429.671204 579.902344,429.671204
	C572.233459,437.734253 577.001343,447.374237 575.618896,456.130157
	C575.257751,458.417572 575.917358,461.529053 571.983521,458.397278
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M377.644806,460.389374
	C376.706635,460.165955 375.768463,459.942505 374.408539,459.288269
	C373.319214,458.575623 372.651611,458.293762 371.984009,458.011902
	C370.233521,456.039734 368.483032,454.067566 366.775848,451.339844
	C367.194458,445.700226 367.569763,440.816132 367.945068,435.932037
	C367.945068,435.932037 368.078430,435.508057 368.492432,435.252899
	C369.276245,434.341522 369.646027,433.685272 370.015839,433.029053
	C370.758972,432.370392 371.502106,431.711761 372.853394,431.002655
	C373.910187,430.905212 374.358826,430.858276 375.439392,430.977112
	C376.493378,431.250305 376.915436,431.357697 377.337524,431.465088
	C375.797302,433.382568 374.257050,435.300049 372.263306,437.596039
	C371.776428,438.632843 371.743042,439.291107 371.709625,439.949402
	C371.678558,440.375214 371.647491,440.801056 371.192566,441.667847
	C371.016113,444.122986 371.263489,446.137177 371.510864,448.151367
	C373.716339,451.257416 375.921814,454.363464 378.499268,457.942108
	C378.462433,459.072937 378.053619,459.731171 377.644806,460.389374
z"/>
<path fill="#313458" opacity="1.000000" stroke="none"
	d="
M244.189972,432.213715
	C238.989380,441.004181 238.025909,449.575043 245.363770,457.830078
	C245.512512,457.997437 244.353912,459.326904 243.408997,460.047241
	C243.012787,459.980255 243.000778,460.000153 242.952621,459.735291
	C242.608627,459.419006 242.312790,459.367584 242.016953,459.316132
	C239.776703,456.427429 237.536438,453.538696 235.497818,450.037354
	C235.378418,447.519836 235.057388,445.614960 234.736359,443.710114
	C234.909302,442.438995 235.082260,441.167847 235.716339,439.439453
	C236.740921,437.603027 237.304367,436.223877 237.867828,434.844727
	C238.979507,433.591553 240.091187,432.338409 241.848129,431.056824
	C243.058929,431.423492 243.624451,431.818604 244.189972,432.213715
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M602.010193,325.031494
	C605.979736,327.684814 601.946899,329.190552 600.839172,331.312042
	C599.346741,330.900543 597.784058,329.534882 597.001709,329.889709
	C586.505554,334.650208 576.118286,339.650757 566.096436,344.405457
	C566.884827,348.044342 567.369690,350.282318 567.779663,352.924683
	C566.632385,351.731476 565.560059,350.133911 564.238342,347.914001
	C561.758484,343.619537 565.427490,342.941803 567.136108,342.077087
	C578.679749,336.235107 590.368469,330.679657 602.010193,325.031494
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M554.721375,339.494141
	C552.479736,346.865601 554.867432,352.552155 560.324158,358.089569
	C568.415588,366.300812 575.828064,375.191193 583.312317,383.977539
	C584.214478,385.036713 583.767151,387.245392 583.607422,388.993469
	C582.443359,387.244690 581.983215,385.109070 580.732117,383.653320
	C572.105286,373.615387 563.151611,363.854950 554.650696,353.713837
	C551.037964,349.404114 550.603394,344.361969 554.721375,339.494141
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M599.450745,332.975952
	C599.545776,335.680450 599.071716,338.464539 599.133118,341.236786
	C599.156555,342.293854 600.216736,343.640106 601.184814,344.225098
	C601.631592,344.495087 603.468933,343.481812 603.862488,342.660553
	C606.929688,336.260620 610.066772,329.866180 612.552002,323.233887
	C613.225037,321.437592 611.740845,318.832977 611.248169,316.221619
	C616.569763,318.603363 615.750000,323.668304 614.283142,327.544830
	C611.844482,333.989777 608.162659,339.982727 604.751709,346.023315
	C604.186523,347.024323 602.225708,347.928497 601.111633,347.732269
	C600.017822,347.539612 598.694092,346.040527 598.320496,344.848602
	C597.078308,340.885986 596.049011,336.791290 599.450745,332.975952
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M34.088795,286.900940
	C36.471569,287.365082 38.836403,288.050720 41.240997,288.245483
	C45.731323,288.609222 48.117783,286.182892 48.118729,281.829407
	C48.119907,276.414368 47.733719,270.999268 47.974850,265.496155
	C49.399414,267.833801 50.363949,270.259430 51.328484,272.685089
	C51.469604,276.295471 52.131618,279.978394 51.640881,283.500732
	C50.687611,290.342987 43.223267,293.375366 34.246536,290.183716
	C34.032799,288.625000 34.060795,287.762970 34.088795,286.900940
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M553.672852,435.262970
	C555.506531,436.623871 557.261841,438.395416 559.035400,440.512268
	C555.728271,445.853180 557.067017,455.113525 562.814636,459.730652
	C557.898438,459.730652 554.114136,459.730652 551.574585,459.730652
	C552.383728,456.065552 553.562744,452.616852 553.815918,449.101501
	C554.136108,444.653900 553.702881,440.152069 553.672852,435.262970
z"/>
<path fill="#3B3950" opacity="1.000000" stroke="none"
	d="
M503.349152,65.260941
	C503.349152,65.260941 503.700378,65.164673 504.225037,65.110687
	C505.810211,65.080490 506.870697,65.104286 507.931213,65.128082
	C509.450989,66.334915 510.970734,67.541756 512.695923,69.415665
	C512.990845,71.474876 513.080261,72.867012 513.169678,74.259163
	C512.458984,74.922386 511.748291,75.585602 510.347900,76.182861
	C507.438721,77.410522 505.219177,78.704140 502.999634,79.997757
	C502.999634,79.997757 503.000000,80.000000 502.663330,79.987579
	C498.536499,81.281288 500.648132,77.992371 499.934753,76.902962
	C500.345642,76.260490 500.756561,75.618027 501.665558,74.640244
	C502.448730,73.633530 503.113647,72.480377 502.962982,72.361542
	C499.666382,69.761909 502.286469,67.559441 503.349152,65.260941
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M286.138031,261.410797
	C287.561523,261.312958 288.984985,261.215118 290.826691,261.826508
	C291.323181,262.895386 291.401428,263.255035 291.479706,263.614685
	C291.461334,265.020782 291.442963,266.426910 291.291473,268.491669
	C291.569519,269.812927 291.980652,270.475555 292.391815,271.138153
	C292.801025,271.584412 293.210236,272.030670 293.810272,273.091156
	C290.480957,276.685638 290.774628,280.710724 290.947906,284.722534
	C291.026398,286.540131 290.980621,288.363129 290.991241,290.183655
	C289.599915,290.258270 288.208557,290.332886 286.513428,289.988037
	C286.400879,288.931885 286.592102,288.295135 286.783325,287.658417
	C286.694305,279.673523 286.605316,271.688629 286.307922,262.973602
	C286.112366,261.965942 286.125183,261.688385 286.138031,261.410797
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M355.441437,75.441788
	C355.486511,75.786598 355.531586,76.131401 355.461731,77.012589
	C356.044495,80.178406 356.742218,82.807838 357.439941,85.437271
	C357.483978,87.881981 357.527985,90.326698 357.230042,93.349487
	C354.806305,95.572067 353.333435,95.594376 352.882599,92.513397
	C351.980164,86.346390 350.947083,80.197067 350.145203,74.017448
	C349.796356,71.329285 349.884827,68.584381 349.774689,65.865250
	C349.774689,65.865250 349.850311,65.832558 350.105591,65.821526
	C350.532806,65.826111 350.704742,65.841721 350.946533,66.133987
	C351.024384,66.600693 351.032440,66.790741 351.167419,67.266632
	C351.635864,67.792419 351.977417,68.032364 352.314758,68.617195
	C353.354156,71.121986 354.397797,73.281883 355.441437,75.441788
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M419.048157,438.403564
	C420.838440,438.832275 422.476532,439.710632 424.129578,440.904846
	C420.713470,445.732819 421.950439,454.972565 427.471100,459.823212
	C422.828918,459.823212 419.098328,459.823212 414.403534,459.823212
	C422.182037,453.642059 417.421722,445.711426 419.048157,438.403564
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M233.800674,283.223022
	C232.275787,282.820557 231.070267,282.304596 229.888824,281.459412
	C230.946426,280.249542 232.374329,279.565491 232.931763,278.447418
	C234.108551,276.087067 235.238281,273.562073 235.631546,270.989075
	C236.089157,267.995056 235.738312,264.877441 235.738312,260.884949
	C237.697144,260.884949 241.011719,260.884949 244.512878,260.884949
	C241.091721,268.200928 237.605881,275.655212 233.800674,283.223022
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M499.648102,77.036484
	C500.648132,77.992371 498.536499,81.281288 502.662292,79.987442
	C503.305176,81.732132 503.612427,83.464539 503.964569,85.946930
	C504.687653,89.129578 505.365845,91.562256 506.044067,93.994926
	C506.095428,94.711571 506.146759,95.428223 506.159241,96.932007
	C506.096863,99.969856 506.283447,102.248199 505.991974,104.463654
	C505.689209,106.765038 504.644531,108.542809 501.802460,107.037254
	C501.741180,106.623993 501.679901,106.210739 501.658875,105.096100
	C501.473541,102.262230 501.247955,100.129745 501.022369,97.997261
	C500.980713,97.275368 500.939056,96.553467 500.919495,95.146538
	C500.626068,93.641632 500.310638,92.821762 499.995178,92.001900
	C499.907104,91.290901 499.819031,90.579910 499.753296,89.143753
	C499.296204,86.833923 498.816833,85.249268 498.337433,83.664597
	C498.221313,83.315826 498.105164,82.967056 497.988861,81.994705
	C497.906342,80.873558 497.823975,80.375992 497.741577,79.878433
	C498.281525,78.975624 498.821503,78.072815 499.648102,77.036484
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M377.818909,460.687653
	C378.053619,459.731171 378.462433,459.072937 378.820679,458.114594
	C385.628784,457.008423 387.223328,455.691467 386.197296,450.764069
	C385.831390,449.006775 383.977417,447.559296 382.757660,445.909515
	C385.090179,443.593140 391.755249,443.276703 395.015503,445.286713
	C394.130066,448.314667 393.101746,451.108368 392.518036,453.992065
	C391.576416,458.643982 384.627197,462.089905 377.818909,460.687653
M391.532166,447.681030
	C391.154572,445.589447 391.154572,445.589447 387.619812,446.509583
	C387.619812,449.983887 387.619812,453.338623 387.619812,458.481079
	C389.308044,456.199097 390.585785,455.129669 390.956635,453.806152
	C391.431732,452.110504 391.176788,450.210358 391.532166,447.681030
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M223.240967,84.675507
	C229.864609,80.396523 236.588287,75.646217 243.883850,72.059044
	C250.810867,68.653084 258.271240,66.263802 265.640930,63.870216
	C267.686646,63.205784 270.243866,64.116203 272.566437,64.304100
	C271.674286,66.537865 270.782104,68.771629 269.536072,71.047104
	C269.916779,69.362083 270.651337,67.635368 271.909546,64.677795
	C253.300949,67.290253 238.599426,76.385468 223.240967,84.675507
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M33.853714,286.684906
	C34.060795,287.762970 34.032799,288.625000 33.989361,289.918701
	C29.776875,289.133942 27.789454,286.266296 27.764982,281.971497
	C27.738541,277.330902 27.836033,272.687408 27.693037,268.050934
	C27.645153,266.498322 27.023943,264.963440 26.573153,262.953918
	C27.321804,261.974060 28.162106,261.460724 29.002407,260.947449
	C29.751167,260.912628 30.499926,260.877808 31.739351,261.191376
	C32.611496,262.123016 32.992973,262.706329 33.374454,263.289612
	C32.967968,267.660919 32.509693,272.028290 32.179790,276.405365
	C32.042580,278.225830 32.179192,280.066956 32.101257,282.639435
	C32.399467,284.011505 32.787712,284.642822 33.175957,285.274139
	C33.323513,285.672394 33.471073,286.070618 33.853714,286.684906
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M440.494690,444.647339
	C439.662689,446.409424 439.023895,447.818756 438.048553,449.970612
	C436.950592,449.075989 435.868958,448.194641 434.769226,446.976379
	C435.554443,445.651703 437.124084,444.582825 437.029572,443.690094
	C436.598999,439.622498 439.512085,434.478271 433.733337,431.833435
	C433.686859,431.812164 434.402191,429.185272 434.860565,429.152405
	C438.222015,428.911438 441.608673,429.022400 445.539215,429.625214
	C438.679749,433.196716 441.393951,439.250519 440.494690,444.647339
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M448.567841,457.926392
	C451.817719,458.085327 454.712128,458.241943 457.716919,458.066162
	C463.547516,457.619873 463.547516,457.619873 472.032776,451.886322
	C473.911133,458.448578 471.922607,461.364594 465.397919,461.281097
	C460.246399,461.215149 455.098328,460.883301 449.948700,460.669678
	C448.047302,460.590759 446.457764,460.314880 448.567841,457.926392
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M128.664246,84.020988
	C129.652542,86.880226 130.533310,89.724205 130.897430,92.632866
	C131.413681,96.756638 129.251602,98.271919 125.635262,96.236244
	C123.565598,95.071205 122.368515,94.625389 121.707153,97.792313
	C121.080765,94.304947 120.460236,90.467094 120.297813,86.609947
	C120.276695,86.108482 122.578758,85.386063 123.872650,84.985199
	C125.316681,84.537811 126.838249,84.340668 128.664246,84.020988
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M336.462708,436.299316
	C337.109680,437.917084 337.683716,439.980713 338.099670,442.075745
	C338.461151,443.896362 338.643890,445.752472 339.249939,447.717407
	C340.512604,451.851624 339.342896,456.830658 344.938690,458.502197
	C342.353516,461.348969 336.212250,461.606110 332.141449,458.953552
	C337.735321,456.878143 336.337189,452.307831 336.343964,448.212982
	C336.350250,444.394958 336.329773,440.576843 336.462708,436.299316
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M601.008667,458.019806
	C605.474731,453.821899 605.178406,450.136139 599.192932,445.212036
	C604.215088,445.212036 608.419495,445.212036 611.941040,445.212036
	C611.134766,448.044861 610.509399,450.850983 609.511536,453.517731
	C608.922241,455.092682 607.743286,456.446991 606.188110,457.958191
	C604.983521,458.477844 604.420349,458.939789 603.857178,459.401764
	C603.452332,459.561707 603.047546,459.721649 602.208252,459.652527
	C601.518738,458.955566 601.263672,458.487671 601.008667,458.019806
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M89.967583,89.382118
	C93.398064,89.553406 91.775620,86.683998 92.585655,85.252258
	C93.790550,83.122612 95.393959,80.037796 97.206596,79.750633
	C99.186760,79.436928 101.721550,81.679855 103.745987,83.172684
	C104.343491,83.613281 104.457611,85.529083 104.008369,86.326836
	C103.601875,87.048653 101.803421,87.785545 101.170135,87.456039
	C95.378616,84.442703 95.324432,88.425819 94.530373,92.388748
	C92.652977,91.473900 91.310280,90.428009 89.967583,89.382118
z"/>
<path fill="#313458" opacity="1.000000" stroke="none"
	d="
M256.486481,449.442596
	C256.567474,448.523346 256.648468,447.604095 257.075439,446.172424
	C257.246613,444.769745 257.071808,443.879517 256.896973,442.989288
	C256.768555,442.076599 256.640106,441.163879 256.638245,439.584320
	C256.312805,438.243958 255.860794,437.570465 255.408783,436.896973
	C254.547058,435.593628 253.685333,434.290253 252.839966,432.365234
	C253.694489,431.383423 254.532654,431.023285 255.370819,430.663116
	C256.471039,431.621979 257.571289,432.580872 258.787872,434.108704
	C259.398773,435.182343 259.893311,435.687012 260.387848,436.191681
	C260.981262,439.837311 261.574677,443.482910 261.777466,447.747009
	C260.957306,449.624634 260.527771,450.883789 260.098236,452.142944
	C258.116791,454.338989 256.135345,456.535034 254.153885,458.731079
	C253.673737,458.372559 253.193588,458.014069 252.713440,457.655548
	C253.489624,456.024689 254.265808,454.393829 255.555984,452.327454
	C256.208801,451.075500 256.347626,450.259064 256.486481,449.442596
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M464.099243,88.905754
	C464.518677,86.554680 464.369293,83.845512 465.548340,81.972641
	C466.399658,80.620354 469.463806,79.336548 470.744324,79.884399
	C472.747955,80.741646 474.133453,83.131813 475.559448,85.038177
	C475.647430,85.155815 473.895813,87.295898 472.840302,87.458633
	C471.525787,87.661301 470.045135,86.786346 467.967957,86.182442
	C467.390289,88.725471 466.863800,91.043243 465.827209,93.518906
	C463.918762,92.025475 462.520447,90.374146 461.122162,88.722809
	C461.751160,88.979202 462.380127,89.235611 463.470642,89.670792
	C464.217163,89.826866 464.502167,89.804161 464.787170,89.781456
	C464.557861,89.489555 464.328552,89.197655 464.099243,88.905754
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M360.727051,110.306717
	C360.258606,113.796257 358.283417,112.998268 356.533936,111.234566
	C350.388855,105.039497 344.134491,98.927460 338.368378,92.389816
	C333.614685,87.000061 329.494141,81.051926 325.156921,74.979385
	C331.275421,81.521698 337.252411,88.505920 343.411469,95.325729
	C347.610260,99.974922 351.993408,104.465614 356.461792,108.856567
	C357.360321,109.739525 359.014557,109.853409 360.727051,110.306717
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M291.333801,290.396912
	C290.980621,288.363129 291.026398,286.540131 290.947906,284.722534
	C290.774628,280.710724 290.480957,276.685638 294.024658,273.306061
	C296.108215,273.409241 298.168243,273.911743 300.972046,274.595703
	C299.828552,275.459045 299.319031,276.078918 298.676819,276.284607
	C296.726196,276.909424 293.406219,276.897705 293.008698,277.997467
	C292.099152,280.513641 292.484863,283.548828 292.626953,286.358978
	C292.662842,287.068970 293.931458,288.398010 294.341583,288.293762
	C296.508362,287.743073 298.794006,287.145142 300.620789,285.933746
	C302.090546,284.959076 302.966034,283.088226 304.105225,281.615051
	C304.574005,281.818909 305.042786,282.022797 305.511566,282.226685
	C304.824890,285.082794 304.138214,287.938904 303.495941,290.610199
	C299.255432,290.610199 295.465912,290.610199 291.333801,290.396912
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M414.578247,56.353050
	C416.743896,52.887527 419.290527,49.372871 421.732056,45.786659
	C423.410095,43.321835 424.942291,40.757721 426.539703,38.237991
	C426.098816,37.921322 425.657959,37.604649 425.217072,37.287979
	C422.091003,40.535458 418.964905,43.782932 415.499512,47.057655
	C418.455353,42.611084 421.641479,38.048840 425.137299,33.737724
	C425.840088,32.870991 427.719147,32.958084 429.055908,32.605408
	C429.217773,33.905205 430.001312,35.640846 429.443665,36.436203
	C424.739471,43.145981 419.790131,49.683868 414.578247,56.353050
M426.493378,35.647247
	C426.493378,35.647247 426.595367,35.461189 426.595367,35.461189
	C426.595367,35.461189 426.392731,35.490322 426.493378,35.647247
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M415.353851,265.262756
	C416.817322,267.620758 417.954865,270.287964 419.825348,272.259918
	C422.262451,274.829285 425.280945,276.847168 428.088867,279.876160
	C428.216888,281.873352 428.305298,283.096802 428.393738,284.320221
	C427.489288,285.602448 426.584839,286.884674 425.216187,287.821716
	C424.580261,287.167999 424.408539,286.859436 424.236816,286.550842
	C425.359161,283.218079 424.093079,280.802063 421.339844,278.936035
	C419.161987,277.459961 416.986664,275.979218 414.838562,274.460358
	C411.211731,271.895905 410.096222,268.731049 413.218170,264.459900
	C414.332520,264.536041 414.843170,264.899384 415.353851,265.262756
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M516.333374,139.607666
	C524.416504,138.109802 525.191223,137.223831 525.048218,127.335892
	C524.905273,117.455841 523.875122,115.094147 518.673889,111.458969
	C516.369995,112.554947 513.904480,113.727814 511.015320,114.626282
	C510.531250,114.179779 510.470825,114.007690 510.410400,113.835602
	C510.869659,113.459442 511.328949,113.083282 512.278931,112.440857
	C513.385925,111.633476 514.002136,111.092369 514.618408,110.551270
	C514.939636,110.452774 515.260864,110.354263 516.193970,110.137711
	C518.183777,110.057411 519.561707,110.095169 520.939636,110.132919
	C522.084290,111.323753 523.228943,112.514603 524.651367,114.263580
	C526.065186,118.096359 527.201172,121.371002 528.337158,124.645645
	C528.304504,125.374184 528.271912,126.102730 528.027710,127.355797
	C527.356873,130.959427 526.897522,134.038528 526.438171,137.117615
	C525.170654,138.381271 523.903198,139.644928 521.975586,141.011383
	C519.654724,140.612000 517.994080,140.109833 516.333374,139.607666
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M61.975342,445.984192
	C62.021599,446.658386 62.067860,447.332550 62.114426,448.345276
	C60.155396,448.906708 58.196056,449.129578 56.090485,449.369080
	C55.274654,452.708649 51.146042,456.248901 58.081493,458.867096
	C53.793953,462.572449 50.220058,459.838226 47.200413,460.400513
	C49.481812,455.012695 51.415272,450.446564 53.702782,445.479370
	C54.330082,444.996490 54.605827,444.924225 55.066193,445.135315
	C55.856880,445.601318 56.465439,445.793457 57.480797,446.015625
	C59.250179,446.025116 60.612759,446.004669 61.975342,445.984192
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M461.049286,88.412392
	C462.520447,90.374146 463.918762,92.025475 465.615936,93.820885
	C466.011047,95.054413 466.107300,96.143860 465.815247,97.809143
	C463.582977,101.575241 462.258514,98.837502 460.769531,97.976822
	C460.480408,97.002846 460.191315,96.028862 459.901306,94.312340
	C459.235931,93.058372 458.571472,92.546959 457.907013,92.035553
	C455.567871,90.394196 453.228760,88.752838 450.914886,86.362770
	C451.157776,78.439262 454.848419,84.376900 456.877533,84.041473
	C458.243805,85.394974 459.610107,86.748474 461.049286,88.412392
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M324.867493,73.685669
	C316.894348,68.070389 305.552612,48.657101 307.424805,44.202240
	C305.338593,41.932949 303.255157,39.661087 301.236145,37.038105
	C303.849487,38.504265 306.486328,40.215179 308.893066,42.204521
	C309.602753,42.791130 310.273743,44.675133 309.922028,45.096920
	C307.171265,48.395557 309.688477,50.623947 311.283691,53.025024
	C315.791443,59.809883 320.341858,66.566383 324.867493,73.685669
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M428.546021,336.023254
	C431.086304,338.549561 432.851166,342.180939 435.662109,343.399750
	C439.761780,345.177338 444.874695,342.286133 449.245087,344.874237
	C450.194855,342.120819 451.144623,339.367432 452.125580,336.259399
	C456.482697,337.455383 455.275696,340.472137 453.759979,343.121216
	C452.188324,345.868073 450.857849,349.366241 446.228973,347.543243
	C444.524506,346.871948 442.399841,347.242188 440.465454,347.188995
	C439.211731,347.154510 437.498901,347.750000 436.779266,347.137665
	C433.657928,344.481873 430.770477,341.538239 427.956085,338.550354
	C427.584290,338.155640 428.121857,336.904419 428.546021,336.023254
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M359.966980,276.007141
	C359.348297,275.815918 359.137817,275.519745 358.852966,275.399384
	C351.271423,272.195679 351.270142,272.198730 352.924683,263.497009
	C354.936066,263.109589 356.328400,263.113495 358.064514,263.252594
	C359.285461,266.605164 360.162598,269.822510 360.829346,273.006409
	C360.610657,273.187622 360.602356,273.402222 360.593994,273.616852
	C360.719971,273.400269 360.845947,273.183716 361.305176,273.024841
	C362.087036,273.044617 362.535645,273.006683 362.984283,272.968750
	C362.103027,273.973877 361.221771,274.979004 359.966980,276.007141
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M269.165039,433.269318
	C270.306030,432.067291 271.554443,431.217194 272.592743,430.510193
	C273.315216,435.936829 273.924164,440.510498 274.678619,445.421722
	C274.784302,445.938538 274.744446,446.117798 274.375732,446.615479
	C274.201721,447.683716 274.356506,448.433472 274.511292,449.183258
	C274.601471,451.525269 274.691650,453.867249 274.786957,457.019043
	C272.635803,459.761169 270.633575,460.400696 269.095032,457.149872
	C269.198059,456.714996 269.301117,456.280151 269.810486,455.313843
	C270.019043,448.453857 269.821259,442.125336 269.623444,435.796783
	C269.506439,435.071625 269.389404,434.346436 269.165039,433.269318
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M89.832687,89.059975
	C91.310280,90.428009 92.652977,91.473900 94.255554,92.664520
	C94.587845,93.927063 94.660255,95.044861 94.311798,96.656754
	C92.424965,98.792992 91.126083,99.407440 89.892891,96.839783
	C89.231636,95.462959 88.216949,94.255875 87.361755,92.972198
	C85.272751,91.647171 83.183754,90.322151 80.990433,88.283600
	C80.655739,85.837372 80.425346,84.104668 80.083321,81.532326
	C82.663071,82.664108 84.212700,83.343956 85.762329,84.023804
	C87.074158,85.595146 88.385979,87.166489 89.832687,89.059975
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M513.962585,443.473602
	C513.927429,443.898163 513.892212,444.322754 513.873291,444.960327
	C513.889587,445.173370 513.706543,445.515076 513.211609,445.714233
	C512.676270,446.739716 512.635864,447.566040 512.595459,448.392395
	C512.632690,448.659088 512.644836,448.926941 512.408752,449.787170
	C512.697998,452.625977 513.210510,454.873505 513.722961,457.121033
	C513.722961,457.121033 514.087341,457.440765 513.857178,457.770508
	C512.706604,458.440247 511.786224,458.780212 510.503174,459.127075
	C509.415283,459.117340 508.690063,459.100708 507.814087,458.809082
	C507.324524,458.308685 506.985718,458.083252 506.646942,457.857819
	C506.646942,457.857819 506.854797,457.430084 507.378601,457.095703
	C508.240021,455.185974 508.840546,453.615265 508.868408,452.034424
	C508.973816,446.060669 508.893311,440.083679 508.882416,434.107910
	C509.958740,433.147919 511.035034,432.187897 512.482178,431.726501
	C513.222900,435.974609 513.592773,439.724121 513.962585,443.473602
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M122.357407,457.610870
	C123.109573,457.853516 123.527695,458.079315 124.618774,458.668488
	C121.869125,459.206909 119.681641,459.635223 117.096176,460.201508
	C114.855064,459.502411 113.011932,458.665375 110.938156,457.097260
	C109.839813,447.323578 108.972099,438.280975 108.104393,429.238342
	C109.433838,429.213806 110.763290,429.189270 112.528763,429.625488
	C112.699059,436.857056 112.261673,443.628662 112.294975,450.397949
	C112.302750,451.980255 113.906502,453.554688 114.775970,455.132751
	C114.775970,455.132751 114.877708,455.151489 114.846603,455.579956
	C116.326195,456.561646 117.836884,457.114868 119.347565,457.668091
	C120.239494,457.643402 121.131432,457.618683 122.357407,457.610870
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M142.522766,429.214966
	C143.825729,430.070953 144.771347,430.874451 145.735825,431.693970
	C145.735825,440.615509 145.735825,449.594879 145.735825,458.842224
	C144.621521,458.842224 142.865784,458.842224 141.066315,458.842224
	C141.323090,457.378296 141.584671,455.886993 141.683823,454.032593
	C141.498444,447.881683 141.475510,442.093903 141.630249,435.514526
	C141.205460,432.855682 140.602951,430.988464 140.000443,429.121216
	C140.722107,429.134979 141.443771,429.148712 142.522766,429.214966
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M169.352539,189.420654
	C168.152954,188.100723 167.100067,186.926331 169.791504,186.364914
	C172.011200,186.084900 174.079102,186.022507 176.744202,186.239700
	C177.926239,186.104202 178.511093,185.689102 179.095947,185.274017
	C179.520233,184.857910 179.944534,184.441803 180.663696,184.594604
	C180.978348,190.802231 180.998138,196.440948 181.017944,202.079651
	C180.221039,201.839355 179.424133,201.599045 178.745285,200.639435
	C178.568649,199.278046 178.273956,198.635956 177.979263,197.993866
	C177.756226,197.740448 177.630188,197.445572 177.715302,196.509552
	C177.283737,195.263321 176.738007,194.616760 176.192261,193.970215
	C174.020950,192.516006 171.849640,191.061798 169.352539,189.420654
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M582.959473,90.191116
	C585.116150,93.101440 587.762146,95.828018 584.197876,100.194870
	C582.658691,97.627884 581.310791,95.379951 579.637390,93.046524
	C579.311890,92.961021 579.074097,92.928886 578.988647,92.482513
	C577.451233,91.413307 575.999207,90.790466 574.547180,90.167633
	C574.113831,89.866364 573.680481,89.565094 573.073242,88.642990
	C572.059814,85.260292 570.240417,82.094406 575.453369,81.828201
	C577.253052,83.669762 579.052734,85.511307 580.948547,87.983856
	C581.616028,89.108711 582.187500,89.602577 582.758972,90.096436
	C582.758972,90.096428 582.962280,90.089432 582.959473,90.191116
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M33.739403,402.716522
	C32.131641,398.813110 30.051453,394.615265 29.202774,390.181702
	C28.443220,386.213684 29.183582,381.977997 28.956480,377.877319
	C28.884491,376.577423 27.829218,375.332001 26.829983,374.108582
	C26.990442,373.024017 27.544838,371.892517 28.099232,370.760986
	C28.953226,371.648590 30.344549,372.424255 30.557323,373.445435
	C31.124943,376.169800 31.146576,379.004059 31.455950,381.786804
	C32.217129,388.633392 33.018021,395.475555 33.739403,402.716522
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M257.036560,245.073929
	C257.229950,244.801651 257.423340,244.529358 258.209656,244.111511
	C259.382751,242.799911 259.962921,241.633881 260.543091,240.467850
	C260.635895,240.105484 260.728699,239.743118 261.309692,239.124237
	C261.829742,238.530609 261.861603,238.193512 261.893463,237.856400
	C262.894989,234.835373 263.896484,231.814346 265.405060,228.428360
	C266.322754,227.896744 266.733398,227.730087 267.159973,228.019302
	C266.631073,231.358185 265.940430,234.223221 265.582520,237.129242
	C265.227356,240.013168 263.454437,243.398956 267.652832,245.158783
	C267.652832,245.158783 267.825653,245.169281 267.833069,245.652954
	C265.067291,250.251572 261.179749,247.353592 257.808502,247.607880
	C257.615967,247.622391 257.296783,245.957306 257.036560,245.073929
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M300.815369,127.842293
	C297.329071,127.018227 298.123627,124.316490 298.332184,121.668129
	C298.432098,120.399139 297.849548,119.076408 297.576111,117.778008
	C296.300385,118.320518 294.646912,118.528557 293.816925,119.465813
	C290.874115,122.789040 288.436432,126.575668 285.375427,129.773224
	C282.788300,132.475739 279.602325,134.604965 276.330078,136.957092
	C281.942200,130.173233 287.814362,123.334854 293.965240,116.757050
	C294.911682,115.744911 297.762817,115.106155 298.628113,115.759094
	C299.894531,116.714661 300.489471,118.941483 300.772583,120.721634
	C301.120483,122.909332 300.852844,125.194916 300.815369,127.842293
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M495.945679,395.124451
	C483.378052,403.316620 472.436371,402.795685 460.819946,393.662842
	C460.490631,393.590637 460.290253,393.262451 460.199982,392.794434
	C460.041473,391.898285 459.973267,391.470123 459.905060,391.041992
	C460.391479,391.124847 461.082275,391.028778 461.334412,391.316742
	C467.366699,398.206848 475.319427,398.788940 483.592377,397.964966
	C486.106079,397.714630 488.539398,396.680603 491.016663,396.032745
	C492.619141,395.613647 494.234528,395.244080 495.945679,395.124451
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M423.914551,286.732880
	C424.408539,286.859436 424.580261,287.167999 424.909637,287.982727
	C421.597931,292.215637 416.597137,293.465729 412.275818,290.659271
	C410.601257,289.571747 410.140472,286.376282 409.527618,284.036163
	C409.339478,283.317841 410.481964,282.251038 411.015137,281.343781
	C411.904480,282.097443 413.189941,282.674713 413.617218,283.634125
	C415.920197,288.805450 418.218719,289.630585 423.914551,286.732880
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M31.801140,117.940536
	C31.358503,117.421280 31.394842,116.688316 31.093061,116.142189
	C30.461498,114.999260 29.651745,113.954796 28.915173,112.869896
	C28.055099,113.753853 26.568295,114.553749 26.436632,115.535400
	C25.580124,121.921364 24.947441,128.340851 24.404802,134.763184
	C24.252672,136.563736 24.649065,138.410629 24.670055,140.654221
	C20.562307,136.417450 22.060446,130.793640 22.204790,125.588600
	C22.307074,121.900154 23.624964,118.177727 24.819803,114.611031
	C25.618504,112.226822 26.670147,108.925545 30.221304,110.390182
	C33.608669,111.787254 33.745392,114.748909 31.801140,117.940536
z"/>
<path fill="#2E2F52" opacity="1.000000" stroke="none"
	d="
M337.746307,150.149689
	C337.477905,150.427124 337.209534,150.704559 336.558105,151.230515
	C335.748962,151.813629 335.322876,152.148224 334.896790,152.482819
	C332.643738,153.420090 330.390656,154.357361 327.448273,155.299911
	C325.452423,154.819534 324.145905,154.333862 323.003601,153.447464
	C323.262421,150.782150 323.357056,148.517578 323.451660,146.252991
	C323.451660,146.252991 323.744995,146.306580 324.094208,146.493317
	C325.226715,146.684647 326.615509,146.477264 326.702484,146.725632
	C328.001007,150.434906 330.040131,149.902878 332.792419,148.270874
	C333.925720,147.598862 335.666656,147.951492 337.245972,148.221222
	C337.489258,149.119492 337.617767,149.634583 337.746307,150.149689
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M267.637848,244.761475
	C263.454437,243.398956 265.227356,240.013168 265.582520,237.129242
	C265.940430,234.223221 266.631073,231.358185 267.199341,227.922760
	C267.222809,227.370316 267.506348,227.013397 267.851379,226.998840
	C268.791107,226.652771 269.385803,226.321243 270.450073,225.997009
	C277.290497,225.995605 283.661377,225.986923 290.032227,225.978256
	C290.387756,226.350220 290.743317,226.722183 291.102997,227.360535
	C285.287506,227.580414 279.454132,227.299423 273.657166,227.639404
	C272.052307,227.733521 269.506531,229.440521 269.202698,230.809326
	C268.222137,235.226868 268.085052,239.831589 267.637848,244.761475
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M35.241203,432.591919
	C35.137707,431.594452 35.489819,430.675873 35.882324,429.460571
	C38.388039,428.981476 40.855793,428.618530 43.318199,428.651733
	C49.824284,428.739502 51.094582,430.697266 48.948799,438.311554
	C45.431770,433.726624 41.194427,431.388824 35.241203,432.591919
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M457.215149,432.556824
	C456.784088,431.664825 456.807526,430.804657 456.848755,429.620667
	C459.658417,429.155396 462.450531,428.891144 465.242004,428.897797
	C471.225189,428.912048 472.832916,431.668884 470.290833,438.592041
	C467.065430,434.122375 463.125885,431.486084 457.215149,432.556824
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M314.255798,432.558502
	C313.832336,431.640747 313.868347,430.788452 313.911743,429.614807
	C316.389099,429.175018 318.859161,428.956482 321.329132,428.957428
	C327.976501,428.959961 329.175598,430.445984 328.152252,438.401733
	C324.078308,434.868164 320.449554,430.720337 314.255798,432.558502
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M349.437012,65.952751
	C349.884827,68.584381 349.796356,71.329285 350.145203,74.017448
	C350.947083,80.197067 351.980164,86.346390 352.882599,92.513397
	C353.333435,95.594376 354.806305,95.572067 357.204956,93.757225
	C356.546906,95.339073 355.572052,97.091278 354.597168,98.843475
	C353.458527,97.523460 351.581146,96.341599 351.304169,94.860458
	C349.792877,86.778275 348.567444,78.636238 347.526184,70.478722
	C347.348816,69.088806 348.540253,67.524170 349.437012,65.952751
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M247.226288,144.887604
	C249.872177,146.227097 252.439911,147.973114 255.064713,149.628647
	C261.284180,153.551422 267.424255,153.593094 273.492798,149.219788
	C275.626770,147.681931 277.869446,146.294846 280.404663,144.783035
	C277.232269,152.154282 264.180450,156.900803 257.141235,152.907883
	C253.532562,150.860931 250.478683,147.835953 247.226288,144.887604
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M449.523071,228.349472
	C449.865723,224.916611 450.305176,221.198624 451.123810,217.566055
	C453.284454,207.978699 451.640411,199.360809 445.016815,191.535828
	C447.424805,194.737228 450.996399,197.961731 452.091766,201.878677
	C454.554535,210.685608 453.898651,219.654221 449.523071,228.349472
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M107.766006,429.075928
	C108.972099,438.280975 109.839813,447.323578 110.765961,456.792145
	C109.761665,453.645325 108.309746,450.132599 107.747147,446.482758
	C107.199715,442.931335 107.855316,439.203094 107.409431,435.623962
	C107.168846,433.692841 105.728096,431.911224 104.622139,429.637238
	C105.462898,429.420319 106.445267,429.166901 107.766006,429.075928
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M415.694397,265.114746
	C414.843170,264.899384 414.332520,264.536041 413.487030,264.145325
	C415.884979,262.574402 418.490479,260.072144 421.377289,259.688904
	C427.207397,258.914978 428.957947,261.914764 427.086395,270.188202
	C425.226837,267.576050 423.969147,265.809357 422.159912,263.267914
	C420.561127,263.711334 418.298035,264.339020 415.694397,265.114746
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M416.680481,402.971558
	C415.042755,398.829987 412.955566,394.385010 412.120667,389.716064
	C411.376343,385.553589 412.222046,381.130096 411.942017,376.849548
	C411.835083,375.214966 410.549713,373.657501 409.392822,372.018555
	C411.202240,369.852783 413.305542,370.515625 413.813080,373.804260
	C414.210907,376.381805 413.742218,379.084473 414.041412,381.687531
	C414.842957,388.661224 415.850311,395.611267 416.680481,402.971558
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M209.835358,438.857971
	C210.295120,436.017090 210.754868,433.176239 211.348343,429.509155
	C213.631485,429.509155 217.014862,429.509155 221.123123,429.509155
	C217.869949,433.317078 215.011185,436.663361 211.579880,439.868286
	C210.616669,439.437317 210.226013,439.147644 209.835358,438.857971
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M296.261353,213.746338
	C295.423920,212.996140 294.443085,212.062881 294.057190,210.927444
	C291.503784,203.414673 289.113922,195.846405 286.573486,188.329102
	C286.177795,187.158142 285.285126,186.155136 284.306122,184.559067
	C283.100311,186.316467 282.214661,187.607254 281.040466,189.012146
	C280.946472,188.190750 280.913208,187.112762 281.388367,186.352692
	C282.124512,185.175262 283.207581,184.214722 284.143524,183.162231
	C285.203552,184.288788 286.754272,185.236206 287.241760,186.571732
	C289.864441,193.756622 292.224609,201.037369 294.671234,208.286438
	C295.253418,210.011429 295.819580,211.741852 296.261353,213.746338
z"/>
<path fill="#7D8DAD" opacity="1.000000" stroke="none"
	d="
M685.193481,350.220612
	C687.635742,352.258026 690.093811,354.585571 692.403381,357.052155
	C697.672302,362.679047 702.868469,368.374084 708.125854,374.372162
	C704.808777,371.876038 701.142883,369.343384 698.184570,366.154388
	C693.584229,361.195374 689.464966,355.790039 685.193481,350.220612
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M530.640991,261.316589
	C530.863037,261.262512 531.085144,261.208405 531.675171,261.560791
	C532.561829,262.640259 533.080627,263.313171 533.599487,263.986084
	C533.654602,271.348694 533.709778,278.711273 533.465454,286.548431
	C532.189026,287.005341 531.212036,286.987732 530.399658,286.534058
	C530.589783,277.837524 530.615417,269.577057 530.640991,261.316589
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M267.506348,227.013397
	C267.506348,227.013397 267.222809,227.370316 267.183411,227.466858
	C266.733398,227.730087 266.322754,227.896744 265.582275,228.073792
	C268.814972,218.989456 272.377502,209.894745 276.212311,200.579163
	C276.848785,201.494537 277.212952,202.630798 277.996521,204.343140
	C277.794281,206.161453 277.172668,207.403687 276.419617,208.315918
	C275.666199,208.026566 274.553131,207.932877 274.499481,208.129013
	C274.051971,209.764755 271.148651,211.733337 274.981812,213.315918
	C274.501801,214.606430 273.975159,215.555435 273.315491,216.176239
	C272.901764,215.525330 272.621002,215.202621 272.340271,214.879929
	C272.243286,215.786041 272.146301,216.692169 272.132660,217.672073
	C272.216003,217.745865 272.109161,217.941208 271.733368,217.977692
	C270.073822,221.013901 268.790100,224.013657 267.506348,227.013397
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M187.736938,40.495193
	C188.746841,39.532875 190.023895,38.762413 191.630188,37.972485
	C192.062363,40.472393 192.020615,43.010632 192.345291,45.501099
	C192.461792,46.394787 193.283768,47.484272 194.091568,47.946758
	C196.639267,49.405357 196.588776,50.978554 194.280838,52.584549
	C192.179123,50.034382 190.512604,47.787720 188.846085,45.541061
	C188.308655,45.659935 187.771240,45.778809 187.233810,45.897682
	C187.030273,47.967804 186.826721,50.037922 186.623169,52.108044
	C182.183029,48.457630 185.402832,45.596169 187.552200,42.574078
	C187.899887,42.085213 187.863144,41.322937 187.736938,40.495193
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M533.939392,263.790222
	C533.080627,263.313171 532.561829,262.640259 532.013489,261.616547
	C535.828735,260.804718 539.673462,260.343719 543.906921,259.836121
	C544.146423,261.676636 544.548035,262.950409 544.409180,264.162262
	C544.242188,265.619995 543.615479,267.025085 543.187805,268.452972
	C542.355713,267.422119 541.725952,265.955292 540.647705,265.455017
	C538.664185,264.534698 536.416748,264.183014 533.939392,263.790222
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M355.610046,75.046234
	C354.397797,73.281883 353.354156,71.121986 352.371704,68.538391
	C352.432861,68.114700 352.538055,67.952103 352.927856,67.910004
	C354.227966,67.555161 355.217773,67.379105 356.034027,66.904579
	C358.707336,65.350494 361.317535,63.687859 363.951996,62.066948
	C362.376587,59.852684 360.800934,57.638596 359.226318,55.423752
	C359.131836,55.290897 359.045624,55.152187 358.955566,55.016205
	C359.049042,54.813797 359.142548,54.611389 359.391937,54.112854
	C360.167572,54.026878 361.029449,54.047539 361.366791,54.478645
	C363.228638,56.858063 366.961548,60.563530 366.357697,61.548203
	C364.685089,64.275620 361.450867,66.893883 358.349854,67.705055
	C353.239960,69.041710 356.036011,72.168907 355.610046,75.046234
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M328.859985,198.717285
	C328.512787,202.458755 328.041321,205.853973 328.006012,209.253738
	C327.923492,217.202438 328.098724,225.153610 328.053345,233.103104
	C328.043701,234.789230 328.900360,237.809311 324.754425,235.984848
	C324.725128,231.866135 325.099518,227.855301 325.918640,223.206909
	C326.592499,213.385880 326.821625,204.202408 327.050751,195.018921
	C327.225739,195.015320 327.400726,195.011719 327.816406,195.294434
	C328.329895,196.043381 328.602631,196.506027 328.875366,196.968689
	C328.894867,197.436829 328.914368,197.904968 328.859985,198.717285
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M256.668884,245.104370
	C257.296783,245.957306 257.615967,247.622391 257.808502,247.607880
	C261.179749,247.353592 265.067291,250.251572 267.837921,245.739380
	C270.148499,245.986771 272.461639,246.631393 274.774750,247.276016
	C274.751404,247.924911 274.728088,248.573792 274.704742,249.222687
	C267.611450,250.130661 260.449493,249.669479 253.295959,249.375977
	C253.090759,248.959229 252.885559,248.542480 252.680344,248.125732
	C253.887299,247.128754 255.094254,246.131775 256.668884,245.104370
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M101.386063,283.230408
	C102.294258,285.446625 103.202446,287.662842 104.276756,290.284393
	C101.273834,290.284393 98.431854,290.284393 96.136803,290.284393
	C96.941559,285.539459 97.735146,280.860413 98.896790,275.861877
	C99.971916,278.105042 100.678986,280.667725 101.386063,283.230408
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M114.816757,454.696838
	C113.906502,453.554688 112.302750,451.980255 112.294975,450.397949
	C112.261673,443.628662 112.699059,436.857056 112.925201,429.672974
	C114.295479,429.160553 115.705345,429.061462 118.097649,428.893311
	C111.242157,437.282562 113.924187,445.852356 114.816757,454.696838
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M476.684845,458.015320
	C480.223053,458.150757 483.435516,458.285248 486.720337,458.143433
	C488.587280,457.793304 490.381836,457.719482 492.649597,458.012268
	C493.422363,458.594635 493.721893,458.810394 494.012299,459.015411
	C494.003204,459.004639 493.982544,458.984253 494.231567,459.263489
	C495.989410,459.696014 497.498169,459.849335 499.006958,460.002686
	C497.910919,460.464966 496.810150,461.334198 495.719635,461.321503
	C489.928925,461.254089 484.133911,461.058899 478.360321,460.635834
	C477.633118,460.582581 477.023285,458.927368 476.684845,458.015320
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M273.724731,388.913025
	C272.461700,388.747223 269.973053,388.583405 269.697479,387.716248
	C268.118713,382.748871 265.509644,383.605682 262.311035,385.852692
	C261.953156,386.104095 261.344299,385.998199 260.468475,386.046997
	C262.664764,383.473938 265.244446,380.911835 268.554443,377.624359
	C270.561127,382.054810 272.041138,385.322479 273.724731,388.913025
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M291.855164,263.497375
	C291.401428,263.255035 291.323181,262.895386 291.231110,261.982422
	C295.027893,260.845184 298.838470,260.261261 303.263977,259.583130
	C303.263977,262.980072 303.263977,265.702087 303.263977,269.455963
	C299.656708,266.082581 297.695923,261.031494 291.855164,263.497375
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M94.994965,113.005676
	C94.994965,113.005676 95.066124,113.457649 95.059616,114.042923
	C96.032791,117.085808 97.012474,119.543404 97.992149,122.001007
	C98.107651,123.018013 98.223152,124.035019 98.262947,125.853195
	C98.328331,127.841362 98.469429,129.028366 98.610527,130.215363
	C98.455292,130.911789 98.300064,131.608200 97.829865,132.691528
	C97.170448,133.230743 96.826004,133.383041 96.339203,133.045898
	C96.548912,125.899467 94.975334,119.685616 92.681549,113.637512
	C92.153137,113.667191 91.624733,113.696869 91.096321,113.726555
	C90.781319,116.596436 90.466324,119.466324 89.930130,122.424294
	C89.708946,122.512375 89.257225,122.662933 89.257217,122.662933
	C88.788094,121.341087 88.318962,120.019234 88.148697,118.155853
	C89.465454,115.299026 90.483345,112.983727 91.501236,110.668427
	C91.720352,110.697456 91.940300,110.706665 92.451546,110.941040
	C93.492996,111.792587 94.243980,112.399132 94.994965,113.005676
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M437.924255,238.985367
	C438.288635,239.411713 438.653046,239.838043 439.351471,240.531342
	C434.476196,246.000687 428.103943,248.579224 420.417786,249.067322
	C419.990448,248.238281 419.987244,247.492126 420.347229,246.189606
	C427.042633,245.776993 432.292145,243.301971 437.067261,238.990814
	C437.543396,238.990448 437.733826,238.987900 437.924255,238.985367
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M448.154663,44.505360
	C447.080292,41.623825 446.042236,38.384045 445.038483,35.133675
	C444.858887,34.552208 444.821106,33.926956 444.754486,33.536484
	C439.366974,31.517544 436.897125,35.151844 433.840240,38.304886
	C435.547180,36.029152 437.135956,32.868023 439.693298,31.432913
	C441.231598,30.569658 445.034454,31.675371 446.470642,33.182098
	C448.613556,35.430248 451.380035,38.432995 448.484283,42.243481
	C448.144836,42.690193 448.284943,43.501320 448.154663,44.505360
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M99.610138,142.968002
	C97.996056,147.343353 91.935417,150.927689 87.655251,149.829849
	C86.329460,149.489777 85.334572,147.859589 84.188187,146.820068
	C85.264183,145.877472 86.225334,144.725250 87.450134,144.054260
	C88.561325,143.445526 89.959633,143.360916 91.621078,143.025055
	C91.368286,144.126495 90.725777,145.248138 90.083275,146.369766
	C90.271217,146.742630 90.459167,147.115479 90.647110,147.488342
	C93.512436,145.986389 96.377762,144.484436 99.610138,142.968002
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M488.568787,442.036560
	C487.794952,442.616638 486.317780,443.958191 485.449554,443.639740
	C484.420654,443.262299 483.404999,441.504211 483.283539,440.256927
	C482.956146,436.895386 483.106934,433.487274 482.980530,429.751709
	C485.643829,429.266205 488.394531,429.126587 491.592407,429.394653
	C492.043640,430.562500 492.047699,431.322693 492.051758,432.082855
	C484.985931,433.043274 483.793182,434.179169 485.040955,439.513550
	C485.282928,440.548065 487.063904,441.222626 488.568787,442.036560
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M215.435760,387.777557
	C215.205765,388.799591 214.874969,390.385437 213.987549,390.811371
	C207.734955,393.812042 201.386978,396.618866 195.009308,399.346954
	C194.332047,399.636597 193.266708,399.018982 192.230301,398.547729
	C199.745239,394.783569 207.411285,391.294037 215.435760,387.777557
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M190.681183,247.072968
	C191.958054,247.710602 192.868973,248.880630 193.818146,248.912521
	C199.178055,249.092590 204.547150,248.999512 210.713058,248.999512
	C209.112366,247.653137 208.080307,246.785049 206.985443,245.599197
	C208.877884,246.051743 210.833115,246.822067 214.142563,248.125900
	C211.954651,249.349854 210.885147,250.447952 209.784241,250.480392
	C203.975861,250.651550 198.156647,250.657318 192.347672,250.492096
	C190.397522,250.436615 187.774887,250.109772 190.681183,247.072968
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M227.615356,146.075012
	C228.531845,140.946442 229.796356,135.760178 231.270172,129.715515
	C234.664505,132.639938 238.408447,135.865555 242.205963,139.423950
	C239.027969,137.804550 235.796402,135.852386 233.204865,134.286865
	C231.501602,138.098770 229.732513,142.058044 227.615356,146.075012
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M87.814117,460.558594
	C89.031052,459.740967 90.435600,459.226898 91.918243,458.331543
	C95.185196,455.819092 98.374054,453.687836 103.023651,450.580322
	C101.948410,453.235077 101.659523,455.205750 100.552322,456.445801
	C97.254387,460.139343 93.375397,462.793182 87.814117,460.558594
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M337.131195,147.838074
	C335.666656,147.951492 333.925720,147.598862 332.792419,148.270874
	C330.040131,149.902878 328.001007,150.434906 326.702484,146.725632
	C326.615509,146.477264 325.226715,146.684647 324.241699,146.471527
	C324.586060,145.350998 325.132141,144.439026 325.822266,143.234421
	C327.667511,142.374954 329.368713,141.808121 331.423584,141.258789
	C332.094177,141.713745 332.411072,142.151169 332.907135,143.114685
	C333.730255,144.413864 334.374207,145.186935 335.018158,145.960007
	C335.018158,145.960007 335.450714,146.085403 335.854614,146.297394
	C336.549377,146.952271 336.840302,147.395172 337.131195,147.838074
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M469.198853,386.531799
	C466.197815,383.703461 462.321228,380.990204 460.183838,377.276062
	C457.554138,372.706421 455.016418,369.243958 448.785645,369.779022
	C453.055267,366.988770 455.880615,367.747742 459.398590,372.660309
	C462.631042,377.174194 465.862640,381.688721 469.198853,386.531799
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M210.327194,230.955765
	C209.435150,230.627029 208.878098,230.263016 207.975647,229.828705
	C209.973892,225.712296 212.317535,221.666183 214.730408,217.217926
	C216.206146,218.985031 217.612625,221.154266 218.992889,223.683243
	C217.646133,224.342087 215.910004,224.219833 215.091125,225.027527
	C213.360748,226.734253 212.109802,228.927063 210.327194,230.955765
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M202.417679,432.091187
	C199.530457,428.230164 196.400253,429.787476 193.172363,431.541016
	C192.199631,432.471741 191.342926,433.031525 189.986984,433.818115
	C189.645508,434.685852 189.803253,435.326782 189.961029,435.967743
	C189.581970,436.570557 189.202911,437.173370 188.823853,437.776184
	C187.840118,436.831726 186.856400,435.887238 185.819611,434.596466
	C186.755753,432.901672 187.744995,431.553162 188.740112,429.892578
	C193.106827,429.238190 197.469864,428.621429 201.827652,428.656525
	C204.441376,428.677582 205.714691,430.061707 202.417679,432.091187
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M603.747559,267.901154
	C603.263855,265.758179 602.780212,263.615204 602.208557,261.082214
	C604.860840,261.082214 608.040222,261.082214 612.091797,261.082214
	C609.760254,263.972687 607.982971,266.176086 605.757385,268.656921
	C604.788635,268.589966 604.268066,268.245544 603.747559,267.901154
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M267.505066,81.187553
	C269.188507,77.961678 271.305054,74.690498 273.172302,71.282745
	C275.847076,66.401367 279.382660,61.682137 277.213623,55.133194
	C277.937042,57.002533 279.827667,59.879185 279.056824,61.448540
	C275.739563,68.202049 271.640900,74.571762 267.505066,81.187553
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M326.879822,194.768158
	C326.821625,204.202408 326.592499,213.385880 326.004608,222.810577
	C325.541901,213.603561 325.437927,204.155350 325.498505,194.335510
	C326.011688,194.148376 326.360291,194.332870 326.879822,194.768158
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M315.114136,460.694275
	C314.929565,459.700073 314.938049,459.002747 314.898041,457.960632
	C316.671265,457.622772 318.492920,457.629730 320.723694,458.143005
	C322.880920,459.127228 324.629120,459.605194 326.377289,460.083130
	C326.658600,459.509888 326.939941,458.936646 327.221252,458.363403
	C326.419922,457.862762 325.618591,457.362122 324.817261,456.861450
	C325.272125,456.227692 325.726959,455.593933 326.690735,455.117950
	C327.827820,455.528290 328.456024,455.780853 329.084198,456.033417
	C329.663422,460.249084 327.593933,461.731476 323.640350,461.419922
	C320.868561,461.201538 318.085297,461.128876 315.114136,460.694275
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M141.419434,92.181198
	C139.550949,95.630348 137.544098,95.326729 135.782761,92.197891
	C134.997620,90.803139 134.748749,89.106491 134.386230,87.171974
	C135.001205,85.908226 135.503937,85.028404 135.967316,84.128319
	C136.594772,82.909515 137.192047,81.675163 137.802261,80.447479
	C139.110687,81.198013 140.419128,81.948547 141.267090,82.968842
	C138.177673,82.345680 137.232269,83.776802 137.960464,85.909065
	C138.720306,88.134033 140.234848,90.101280 141.419434,92.181198
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M67.742767,241.270172
	C68.870140,243.142807 69.842270,245.297623 71.126228,248.143646
	C73.279030,248.143646 76.077766,248.285400 78.844307,248.049500
	C79.587791,247.986130 80.233284,246.773514 80.906715,245.673981
	C82.264496,246.089752 83.639320,246.919983 85.014153,247.750214
	C84.861923,248.201263 84.709694,248.652298 84.557465,249.103348
	C78.877640,249.103348 73.197815,249.103348 67.587532,249.103348
	C67.587532,246.507080 67.587532,244.029724 67.742767,241.270172
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M363.106079,272.692902
	C362.535645,273.006683 362.087036,273.044617 361.321777,273.043335
	C361.005188,273.004089 361.039764,273.039825 361.039734,273.039825
	C360.162598,269.822510 359.285461,266.605164 358.098389,262.906555
	C358.527039,261.945557 359.265625,261.465790 360.330261,261.064636
	C361.096954,261.115021 361.537537,261.086823 361.978149,261.058655
	C362.836212,261.574951 363.694275,262.091278 364.783447,263.105560
	C365.376190,264.062653 365.737885,264.521790 366.099548,264.980927
	C366.082031,265.438202 366.064514,265.895447 365.821533,266.880005
	C365.419678,268.280487 365.243286,269.153656 365.066895,270.026794
	C364.453888,270.823547 363.840881,271.620300 363.106079,272.692902
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M262.520142,79.850708
	C261.991974,82.255302 261.134705,84.760010 260.277405,87.264717
	C260.467255,87.394402 260.657104,87.524086 260.846924,87.653770
	C262.560059,85.757088 264.273163,83.860405 266.316437,81.927017
	C264.638611,85.789642 263.616058,90.584869 257.668182,91.975914
	C256.879639,86.580505 259.844055,83.377075 262.520142,79.850708
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M230.591705,244.233078
	C231.098572,245.358551 231.532669,246.885315 232.229340,249.335495
	C236.782959,248.857285 241.824203,248.327850 246.936707,247.389374
	C247.785751,247.579300 248.563522,248.178314 249.341309,248.777313
	C248.611603,249.349014 247.895401,250.394821 247.149979,250.416077
	C241.996140,250.563049 236.791153,250.919922 231.691284,250.376663
	C226.839035,249.859756 231.097977,246.551071 230.591705,244.233078
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M71.347473,222.751358
	C70.243347,221.163574 69.059448,219.385498 68.378273,217.432114
	C65.609894,209.493362 62.995743,201.500824 60.534058,193.288544
	C63.728821,200.993011 66.730522,208.931030 69.687500,216.885651
	C70.369888,218.721375 70.899101,220.614029 71.347473,222.751358
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M434.315674,58.257881
	C432.373169,58.805954 430.430695,59.354023 428.122620,59.865265
	C431.523102,56.402081 435.289154,52.975723 439.682251,49.618309
	C440.942291,50.163078 441.575256,50.638905 442.208221,51.114723
	C440.796021,52.835583 439.383850,54.556450 437.479553,56.650085
	C436.096863,57.434532 435.206268,57.846207 434.315674,58.257881
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M101.564255,282.778992
	C100.678986,280.667725 99.971916,278.105042 98.972565,275.433105
	C98.582115,272.503479 98.483948,269.683167 98.558975,266.508667
	C100.159004,266.727142 101.585838,267.299774 103.087906,268.207703
	C102.689568,273.137878 102.216011,277.732727 101.564255,282.778992
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M505.720825,388.903503
	C504.612152,388.484741 502.738892,388.089996 502.086090,386.978485
	C499.823486,383.125732 497.186676,382.188293 493.119934,384.892242
	C495.170319,382.717316 497.593536,380.545563 500.233368,378.179688
	C502.365875,382.385956 503.940796,385.492432 505.720825,388.903503
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M530.640198,261.333862
	C530.615417,269.577057 530.589783,277.837524 530.156128,286.532837
	C529.408081,286.949158 529.067993,286.930664 528.727966,286.912170
	C528.714233,279.397064 528.700500,271.881989 528.967590,263.521423
	C529.722656,262.234344 530.196838,261.792694 530.671021,261.351044
	C530.671021,261.351044 530.639404,261.351166 530.640198,261.333862
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M307.532715,433.343536
	C307.988861,433.176697 308.701752,433.487823 308.695221,433.782959
	C308.524384,441.467010 308.278870,449.149414 307.674133,456.955444
	C307.352783,449.323883 307.403534,441.568970 307.532715,433.343536
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M41.642963,228.207550
	C43.377502,227.340240 45.557606,226.351105 48.271767,225.021301
	C49.189381,224.770584 49.572937,224.860550 50.234138,225.261353
	C54.021706,225.666901 57.531620,225.761627 61.041542,225.856354
	C62.048466,226.694641 63.055393,227.532913 64.004578,228.719055
	C56.660732,228.739822 49.374630,228.412766 41.642963,228.207550
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M508.678009,433.885742
	C508.893311,440.083679 508.973816,446.060669 508.868408,452.034424
	C508.840546,453.615265 508.240021,455.185974 507.536255,456.917694
	C507.066956,449.061401 506.963776,441.048737 506.819641,432.576721
	C507.343628,432.632782 507.908630,433.148193 508.678009,433.885742
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M458.893127,136.602737
	C455.373199,138.444534 451.874359,139.953262 448.254608,140.955170
	C448.299927,140.151672 448.466156,139.854996 448.632385,139.558319
	C448.969513,139.533478 449.286713,139.440628 450.114380,139.185577
	C451.309296,138.601700 451.973877,138.111984 452.638428,137.622253
	C452.963348,137.537094 453.288269,137.451950 454.214722,137.248352
	C457.012512,135.565857 456.784637,134.407043 454.232300,133.636810
	C453.646515,133.154221 453.060699,132.671616 452.133606,131.845642
	C451.493286,131.036469 451.194244,130.570663 451.260620,130.057770
	C453.731171,131.051987 455.836304,132.093307 457.941406,133.134628
	C458.265656,134.179642 458.589935,135.224640 458.893127,136.602737
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M186.828766,52.363823
	C186.826721,50.037922 187.030273,47.967804 187.233810,45.897682
	C187.771240,45.778809 188.308655,45.659935 188.846085,45.541061
	C190.512604,47.787720 192.179123,50.034382 193.918213,52.637432
	C193.495789,53.500832 193.000778,54.007839 191.973663,54.461288
	C190.562866,54.453983 189.684174,54.500237 188.805496,54.546486
	C188.215118,53.904194 187.624725,53.261898 186.828766,52.363823
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M141.548035,92.348961
	C140.234848,90.101280 138.720306,88.134033 137.960464,85.909065
	C137.232269,83.776802 138.177673,82.345680 141.192825,83.323578
	C141.579041,83.408569 141.749435,83.730965 141.853836,84.172859
	C142.430664,85.241165 142.903091,85.867577 143.375519,86.493996
	C143.790024,88.045746 144.204544,89.597496 144.282745,91.577652
	C143.477600,92.682762 143.008804,93.359474 142.540009,94.036194
	C142.252213,93.529701 141.964432,93.023209 141.548035,92.348961
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M254.940903,110.052437
	C250.440994,105.832512 252.016251,99.567757 258.757477,97.271179
	C258.547516,99.721962 258.360870,101.900627 257.792175,104.452065
	C253.538620,104.221161 253.483765,104.337303 254.940903,110.052437
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M443.519287,115.452621
	C443.510254,115.104279 443.618408,114.797226 444.263428,114.307175
	C445.318756,113.561760 445.954437,113.040634 446.590088,112.519508
	C447.194794,112.396927 447.799469,112.274353 449.040161,112.100395
	C450.986053,111.559860 452.295898,111.070709 453.605774,110.581558
	C455.471313,110.452103 457.336823,110.322639 459.975281,110.162621
	C461.521393,110.231514 462.294617,110.330963 462.946869,110.757919
	C461.169037,111.696953 459.550354,112.459129 457.847870,112.890907
	C453.293610,114.045929 448.703400,115.059227 443.975281,115.959900
	C443.823120,115.790962 443.519287,115.452621 443.519287,115.452621
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M418.697479,67.109543
	C416.959595,69.668465 414.869812,72.218582 412.780060,74.768700
	C413.054749,75.230385 413.329407,75.692070 413.604095,76.153755
	C415.942780,75.478470 418.281433,74.803192 421.010040,74.222031
	C419.631104,75.427925 417.951904,76.742920 416.060669,77.577354
	C414.874359,78.100784 413.369446,77.902184 412.007446,78.027542
	C412.012054,76.359810 411.363678,74.220238 412.156952,73.122398
	C413.817413,70.824387 416.237457,69.075272 418.697479,67.109543
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M142.423019,119.628113
	C143.998398,119.335594 145.573792,119.043083 147.577667,118.671021
	C147.396484,117.355377 147.212601,116.020142 147.335571,114.315186
	C148.123230,114.231934 148.604019,114.518402 149.084839,114.804871
	C149.641251,115.997841 150.197662,117.190819 150.846680,119.100868
	C150.628296,124.924614 150.365891,125.050674 145.209869,122.570404
	C144.656708,122.081490 144.103531,121.592575 143.203461,120.838425
	C142.712067,120.258148 142.567551,119.943130 142.423019,119.628113
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M391.479218,117.045975
	C390.682770,116.253792 389.211334,115.470428 389.200836,114.667961
	C389.138794,109.925026 389.416138,105.177666 389.929138,100.178345
	C390.796600,104.988297 391.314209,110.051697 391.747009,115.802322
	C391.601166,116.675026 391.540192,116.860497 391.479218,117.045975
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M274.188507,137.314911
	C268.848633,141.607071 260.517059,141.009277 253.631348,135.644485
	C256.846680,136.231186 260.180389,137.586746 263.610626,137.906326
	C266.936127,138.216125 270.360779,137.461411 274.188507,137.314911
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M603.424377,267.989929
	C604.268066,268.245544 604.788635,268.589966 605.631042,268.967346
	C603.969055,272.663055 601.985229,276.325775 599.686523,280.097260
	C598.610901,278.324890 597.850098,276.443756 597.131226,274.232880
	C601.713318,274.571594 600.952332,269.844299 603.424377,267.989929
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M25.997276,376.317200
	C26.167686,380.722961 25.989784,385.406891 26.024622,390.089203
	C26.042786,392.530701 26.435703,394.969421 26.435976,397.683960
	C23.037931,390.904358 24.132713,383.755188 25.997276,376.317200
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M346.693970,265.311951
	C347.140350,265.004517 347.310486,265.003448 347.724976,265.470703
	C347.970886,272.623047 347.972412,279.307037 347.973969,285.991058
	C347.804077,285.993530 347.634155,285.996033 347.209351,285.995056
	C346.775543,279.200500 346.596619,272.409363 346.693970,265.311951
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M505.563721,36.075653
	C505.374115,31.447588 502.459106,32.646347 500.030151,33.580715
	C496.539215,34.923580 493.161804,36.561512 489.360779,38.024025
	C493.640259,35.668442 498.219116,33.178371 503.010956,31.205681
	C504.013824,30.792837 505.878662,32.174343 507.141541,33.030869
	C507.321228,33.152740 506.335663,34.992680 505.563721,36.075653
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M255.218628,430.328857
	C254.532654,431.023285 253.694489,431.383423 252.598846,432.132721
	C249.865509,432.434601 247.389633,432.347321 244.551880,432.236877
	C243.624451,431.818604 243.058929,431.423492 242.133209,430.918976
	C245.996872,427.156982 250.462158,427.442017 255.218628,430.328857
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M296.675476,249.110382
	C299.990784,248.585892 303.596039,248.433502 307.163757,247.983215
	C307.853394,247.896179 308.396057,246.644287 308.968445,245.586456
	C310.321350,246.076965 311.712311,246.910721 313.103302,247.744492
	C312.980988,248.289200 312.858704,248.833923 312.736389,249.378632
	C307.475037,249.378632 302.213684,249.378632 296.675476,249.110382
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M28.565388,435.256134
	C28.983501,441.461517 29.206940,448.111664 29.134144,454.983276
	C28.682178,448.703491 28.526447,442.202179 28.565388,435.256134
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M170.970093,127.013252
	C170.964294,128.094055 170.958511,129.174866 170.847198,130.710449
	C170.741653,131.165237 170.292511,131.347321 170.292511,131.347321
	C169.564819,129.779648 168.837128,128.211990 168.230713,126.905602
	C166.606384,128.042862 165.178070,129.042877 163.385925,130.026794
	C163.038834,129.644012 163.055542,129.277374 163.431854,128.522903
	C164.133179,127.409973 164.474915,126.684868 164.816635,125.959755
	C165.081940,125.746529 165.274460,125.480598 165.718170,124.750298
	C166.248169,123.538589 166.454208,122.738556 166.660263,121.938530
	C166.660263,121.938530 166.950302,121.568405 167.310913,121.295746
	C168.094437,120.620132 168.517319,120.217171 168.940216,119.814209
	C169.420212,120.935204 169.900208,122.056190 170.349274,123.850357
	C170.535599,125.353432 170.752838,126.183342 170.970093,127.013252
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M501.559784,107.267517
	C504.644531,108.542809 505.689209,106.765038 505.991974,104.463654
	C506.283447,102.248199 506.096863,99.969856 506.256165,97.278793
	C508.388916,99.984596 508.487854,107.316505 506.332123,109.695595
	C505.695801,110.397873 503.958038,111.023071 503.384796,110.655281
	C502.418182,110.035118 501.978455,108.593773 501.559784,107.267517
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M528.496704,287.162018
	C529.067993,286.930664 529.408081,286.949158 529.991577,286.968872
	C531.212036,286.987732 532.189026,287.005341 533.484436,287.017456
	C534.783142,287.798645 535.763367,288.585358 537.729126,290.163086
	C533.101929,290.163086 529.692505,290.163086 526.283081,290.163086
	C525.955872,289.758179 525.628662,289.353271 525.301453,288.948334
	C526.289429,288.436188 527.277405,287.924042 528.496704,287.162018
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M442.103851,116.058937
	C442.405426,115.887840 442.707001,115.716743 443.263916,115.499130
	C443.519287,115.452621 443.823120,115.790962 443.868347,116.318184
	C443.092346,119.557220 442.271149,122.269028 441.701843,124.148956
	C444.151917,125.950546 445.586823,127.005661 447.006409,128.325958
	C446.985474,128.768112 446.979858,128.945084 446.974243,129.122070
	C445.926361,128.757050 444.878448,128.392014 443.212524,127.783829
	C441.731598,127.357857 440.868774,127.175041 440.005920,126.992218
	C439.664948,125.588997 439.323975,124.185776 439.329071,122.277039
	C439.817566,121.195526 439.959991,120.619530 440.102448,120.043526
	C440.240204,119.737320 440.377960,119.431114 440.821838,118.717438
	C441.453278,117.559631 441.778564,116.809280 442.103851,116.058937
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M269.429840,436.242920
	C269.821259,442.125336 270.019043,448.453857 269.906036,454.992493
	C269.475555,449.031372 269.355896,442.860199 269.429840,436.242920
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M225.532654,204.061066
	C226.433609,204.277328 227.023834,204.599167 227.929565,205.041168
	C226.700851,207.930374 225.156647,210.699417 223.445770,213.819855
	C222.509567,212.749802 221.740021,211.328369 220.928284,209.583801
	C222.331360,207.562653 223.776657,205.864639 225.532654,204.061066
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M473.960907,112.952904
	C473.545502,112.936890 473.130127,112.920876 472.223511,112.677101
	C471.130249,111.780258 470.528229,111.111168 470.294342,110.322250
	C471.432251,110.160034 472.201965,110.117653 472.971710,110.075272
	C474.198608,110.253784 475.425507,110.432289 477.223328,110.861656
	C479.533112,111.733017 481.271973,112.353516 483.010864,112.974014
	C483.830505,113.571739 484.650177,114.169472 485.712219,115.132751
	C485.950409,115.674721 485.946167,115.851128 485.562469,116.040482
	C481.442322,115.019920 477.701630,113.986412 473.960907,112.952904
z"/>
<path fill="#3B3950" opacity="1.000000" stroke="none"
	d="
M366.974274,33.052460
	C367.404846,33.735249 367.835419,34.418041 368.187317,35.770462
	C366.724152,36.976711 365.339630,37.513325 363.955109,38.049938
	C363.796692,37.978504 363.638245,37.907070 363.110718,37.350288
	C361.145477,36.641182 359.549316,36.417427 357.953186,36.193672
	C358.273865,35.462425 358.594513,34.731178 359.468933,33.609200
	C362.339905,33.163136 364.657104,33.107800 366.974274,33.052460
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M268.728760,457.195618
	C270.633575,460.400696 272.635803,459.761169 274.870178,457.455200
	C276.092957,457.993408 277.237671,458.905243 278.382355,459.817108
	C277.085052,460.177765 275.806885,460.709778 274.485779,460.857422
	C272.679016,461.059265 270.821289,461.135040 269.021515,460.936829
	C268.056793,460.830597 267.167755,460.037476 266.244537,459.554321
	C266.950531,458.783325 267.656525,458.012360 268.728760,457.195618
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M609.336426,432.188721
	C609.035339,434.628937 608.734314,437.069183 608.221985,438.983032
	C607.515991,437.911957 607.021240,437.367188 606.526489,436.822449
	C605.568604,435.587860 604.610718,434.353271 603.430603,432.566101
	C603.918152,431.573517 604.627991,431.133514 605.337769,430.693542
	C605.999512,430.692627 606.661194,430.691711 607.721558,430.994263
	C608.525574,431.594727 608.931030,431.891724 609.336426,432.188721
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M202.586212,144.531204
	C202.453278,143.694275 202.644882,143.113174 203.207855,142.208313
	C204.035782,141.536575 204.492294,141.188599 204.948822,140.840637
	C206.895477,144.263641 208.842133,147.686646 211.207336,151.489441
	C211.757446,152.212051 211.889038,152.554901 212.020630,152.897736
	C210.878845,152.598846 209.353638,152.661591 208.666916,151.933502
	C206.574600,149.715088 204.805588,147.191727 202.586212,144.531204
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M157.663086,72.044708
	C157.544403,72.918655 157.425705,73.792595 157.096558,75.098328
	C156.673325,75.791565 156.401321,75.953667 156.070099,76.016418
	C155.778168,73.984489 154.973221,71.847633 155.360367,69.954590
	C155.657806,68.500252 157.691025,66.151604 158.539948,66.317024
	C160.359329,66.671570 161.911972,68.395050 163.020782,69.606277
	C161.089127,69.197945 159.710541,68.741272 158.331940,68.284599
	C158.108994,69.537964 157.886032,70.791336 157.663086,72.044708
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M469.273071,220.384247
	C469.944427,221.512161 470.889679,223.090317 470.877991,224.661346
	C470.845398,229.034531 470.415558,233.404739 469.786591,237.920044
	C469.323822,232.319733 469.217041,226.575500 469.273071,220.384247
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M181.404373,201.989944
	C180.998138,196.440948 180.978348,190.802231 180.956635,184.714645
	C181.461517,184.579285 182.416122,184.903854 182.408691,185.204666
	C182.271179,190.771545 182.018890,196.335602 181.404373,201.989944
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M201.450287,457.785980
	C204.456680,461.497101 207.659256,459.883789 210.919983,458.345215
	C214.212799,459.130371 212.789764,460.972778 210.988663,461.267303
	C207.828094,461.784119 204.441452,461.751465 201.285065,461.188690
	C198.897675,460.763031 198.399628,459.078400 201.450287,457.785980
z"/>
<path fill="#424055" opacity="1.000000" stroke="none"
	d="
M254.951248,110.046722
	C253.483765,104.337303 253.538620,104.221161 257.781342,104.840141
	C258.505371,105.007790 258.858124,105.160149 259.546600,105.747482
	C260.384491,106.874397 260.886719,107.566345 261.388916,108.258293
	C261.150208,108.794518 260.911530,109.330742 260.122620,110.018097
	C258.031036,110.132408 256.489685,110.095604 254.948303,110.058792
	C254.948303,110.058792 254.961594,110.041000 254.951248,110.046722
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M154.633148,388.774841
	C153.773773,388.369110 152.897537,387.540375 152.066864,386.021851
	C152.943970,383.242554 153.138992,381.557709 149.992462,381.997009
	C151.135757,381.027252 152.279037,380.057526 153.422318,379.087769
	C154.011139,379.254028 154.599960,379.420319 155.188782,379.586578
	C154.997955,382.508331 154.807129,385.430084 154.633148,388.774841
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M422.513367,117.349396
	C422.198395,116.653656 421.883392,115.957909 421.299072,114.799347
	C420.958618,113.926247 420.887543,113.515968 420.816467,113.105682
	C422.188293,114.560440 424.023712,115.795418 424.838562,117.514221
	C426.726593,121.496582 428.121063,125.712936 429.285919,130.026184
	C427.416901,127.590553 425.977570,124.963158 424.538269,122.335770
	C424.408081,121.747719 424.277893,121.159668 424.059692,119.976471
	C423.485596,118.704018 422.999481,118.026703 422.513367,117.349396
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M52.657555,135.045807
	C50.684204,140.748825 48.359524,146.498032 45.991142,152.611099
	C45.615074,153.110992 45.282703,153.247040 44.680191,153.388641
	C47.042103,147.293488 49.674160,141.192749 52.657555,135.045807
z"/>
<path fill="#3B3950" opacity="1.000000" stroke="none"
	d="
M51.389130,272.279419
	C50.363949,270.259430 49.399414,267.833801 48.143852,265.191345
	C47.554508,264.526398 47.256195,264.078247 47.003185,263.081482
	C48.916897,262.252228 50.785305,261.971588 52.974201,261.642853
	C52.609856,263.604340 52.375137,264.867981 52.140423,266.131622
	C51.910210,268.045654 51.679993,269.959686 51.389130,272.279419
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M160.850128,52.581039
	C166.424332,49.627678 172.370605,46.823956 178.687866,44.073158
	C173.113312,46.994282 167.167770,49.862484 160.850128,52.581039
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M111.093414,140.051804
	C111.894508,139.368683 112.695610,138.685562 113.879143,138.252533
	C114.872421,140.659470 115.483269,142.816284 116.094116,144.973114
	C116.158104,145.385223 116.222092,145.797348 116.253815,146.522705
	C114.943115,145.782166 113.664665,144.728394 112.133842,143.466599
	C110.809288,144.476837 109.180969,145.718765 107.194443,146.940826
	C107.493538,145.820511 108.150841,144.720062 109.201309,143.186813
	C110.094124,141.853287 110.593765,140.952545 111.093414,140.051804
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M27.408398,457.730286
	C30.216881,457.921722 32.671535,458.131348 35.194603,457.987610
	C36.054550,458.399261 36.846088,459.164215 37.637627,459.929199
	C36.722065,460.349304 35.824383,461.073975 34.887398,461.128967
	C32.620354,461.262024 30.326136,461.181488 28.061575,460.978516
	C27.213785,460.902496 26.417841,460.248138 25.598269,459.857483
	C26.083708,459.154480 26.569138,458.451477 27.408398,457.730286
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M63.160149,155.865479
	C64.044304,155.315353 66.202362,154.145203 66.462234,154.474228
	C70.091087,159.068954 73.131752,156.771042 76.576134,153.899445
	C74.710152,159.216919 71.299110,160.292267 66.675919,157.212097
	C65.759315,156.601456 64.599251,156.356232 63.160149,155.865479
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M133.620758,388.772614
	C132.723557,388.373169 131.812317,387.550415 130.976761,386.033569
	C132.401810,382.787994 131.354492,381.785980 128.755783,381.786926
	C130.285202,381.375977 131.814636,380.965027 133.344070,380.554077
	C133.608459,382.031891 134.013290,383.502380 134.090988,384.989929
	C134.148880,386.098267 133.783554,387.228699 133.620758,388.772614
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M358.097351,450.656494
	C357.727997,445.818909 357.615570,440.665771 357.831055,435.247192
	C358.224060,440.101471 358.289154,445.221222 358.097351,450.656494
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M516.087463,139.585236
	C517.994080,140.109833 519.654724,140.612000 521.700745,141.207642
	C520.732239,141.700851 519.073792,142.806396 518.078064,142.376572
	C514.045532,140.635773 510.216980,138.422684 506.210083,136.034882
	C507.457916,136.203003 508.808838,136.720093 510.529907,137.239532
	C510.900085,137.241882 511.142822,137.407059 511.482117,137.685181
	C512.864197,138.359451 513.906982,138.755600 514.949768,139.151749
	C515.211121,139.366806 515.508362,139.503815 516.087463,139.585236
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M337.245972,148.221222
	C336.840302,147.395172 336.549377,146.952271 336.079742,146.299927
	C336.887970,144.130020 337.874939,142.169556 339.322144,140.494873
	C340.530334,143.506332 341.278320,146.232010 342.026306,148.957672
	C342.508118,149.640488 342.989960,150.323303 343.535645,151.316757
	C341.878326,151.120819 340.157135,150.614227 338.091125,150.128662
	C337.617767,149.634583 337.489258,149.119492 337.245972,148.221222
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M407.253143,379.988922
	C407.715729,384.950439 407.832153,390.083099 407.829132,395.680237
	C407.442108,390.816498 407.174561,385.488281 407.253143,379.988922
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M412.316254,106.796707
	C415.028320,105.903549 417.619843,105.404724 420.588623,104.912651
	C419.951996,106.489372 418.938080,108.059334 417.466431,110.008804
	C415.023682,110.994987 413.038727,111.601662 411.053772,112.208344
	C410.707581,112.297523 410.361420,112.386711 409.746277,112.459557
	C410.383484,110.692490 411.289612,108.941757 412.316254,106.796707
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M52.469360,266.038849
	C52.375137,264.867981 52.609856,263.604340 52.974201,261.642853
	C50.785305,261.971588 48.916897,262.252228 46.803314,262.896423
	C44.497120,261.933136 44.625938,260.545929 46.974380,260.218872
	C49.746346,259.832794 52.613239,260.128296 56.848843,260.128296
	C54.906578,262.917969 53.852440,264.432007 52.469360,266.038849
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M91.789154,132.623413
	C91.395615,132.752686 91.002075,132.881958 90.063690,133.106903
	C89.011436,133.462463 88.504036,133.722321 87.996635,133.982178
	C86.071854,133.519745 84.147079,133.057327 82.122803,132.240540
	C83.069870,131.903427 84.123962,131.846085 85.161705,131.950836
	C89.728775,132.411850 91.176193,130.940277 90.875359,125.603676
	C90.926430,125.084595 91.156212,124.854118 91.355255,124.925560
	C91.554306,124.997002 91.977348,125.008484 92.026100,125.293465
	C92.410339,126.038933 92.745827,126.499413 93.048141,127.354874
	C93.129410,128.531647 93.243843,129.313431 93.214821,130.358063
	C92.643959,131.288391 92.216553,131.955917 91.789154,132.623413
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M87.370087,93.339333
	C88.216949,94.255875 89.231636,95.462959 89.892891,96.839783
	C91.126083,99.407440 92.424965,98.792992 94.173828,97.057426
	C93.695625,98.493324 92.934502,100.022644 92.173370,101.551964
	C91.054298,100.349419 89.729904,99.274834 88.877083,97.906364
	C88.108940,96.673782 87.857666,95.119087 87.370087,93.339333
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M492.389099,432.311462
	C492.047699,431.322693 492.043640,430.562500 492.035645,429.515930
	C493.406342,429.197449 494.780975,429.165405 496.613098,429.565369
	C497.785461,431.020050 498.500305,432.042725 499.215149,433.065399
	C499.296234,434.248627 499.377319,435.431854 499.535126,437.734528
	C496.644623,435.529297 494.685516,434.034698 492.389099,432.311462
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M114.427200,123.882690
	C111.904617,127.695038 109.034966,131.487503 105.805405,135.618530
	C105.277908,135.935593 105.110321,135.914108 104.942726,135.892624
	C107.988525,131.882690 111.034325,127.872742 114.427200,123.882690
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M96.668716,155.498398
	C97.636154,155.034897 98.603584,154.571381 99.896347,154.087891
	C98.071747,159.561035 90.239388,161.672882 86.353531,157.511383
	C90.428856,159.297943 93.729553,158.503967 96.668716,155.498398
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M117.345078,135.242340
	C117.918159,130.667648 119.616974,127.071533 124.792419,126.068130
	C125.166275,126.136383 125.298645,126.599335 124.946686,126.893616
	C124.217834,127.697853 123.840942,128.207809 123.464050,128.717758
	C122.711220,129.288803 121.958382,129.859848 120.772575,130.829010
	C120.193886,132.828156 120.048164,134.429184 119.902443,136.030197
	C120.056572,136.691757 120.210709,137.353333 120.342461,138.355652
	C119.407700,137.630447 118.495323,136.564484 117.345078,135.242340
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M388.411499,142.426758
	C385.278412,143.637207 383.111786,143.482895 384.585266,139.179352
	C389.265869,140.092361 387.023804,134.992615 389.701447,134.064911
	C390.058502,135.056152 390.040283,136.094589 389.751099,137.654724
	C389.483063,138.492828 389.486023,138.809204 389.488953,139.125595
	C389.165497,140.102097 388.841980,141.078583 388.411499,142.426758
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M225.452148,378.653564
	C225.441147,384.413696 220.604996,385.786774 216.130341,387.834778
	C218.875305,384.763519 221.993744,381.749725 225.452148,378.653564
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M346.012054,151.889923
	C350.725067,150.558990 355.438080,149.228058 360.543030,147.932922
	C360.934937,147.968704 361.017273,148.425125 360.662567,148.658112
	C359.655731,149.385071 359.003632,149.879044 358.351501,150.373032
	C357.406311,150.799362 356.461090,151.225708 354.920105,151.779022
	C353.557251,152.301590 352.790192,152.697205 352.023163,153.092834
	C350.299530,153.080475 348.575897,153.068130 346.442078,152.759186
	C346.025330,152.271698 346.018707,152.080811 346.012054,151.889923
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M85.721359,83.689331
	C84.212700,83.343956 82.663071,82.664108 80.083321,81.532326
	C80.425346,84.104668 80.655739,85.837372 80.864288,87.976555
	C80.356758,87.949677 79.470390,87.531067 79.453796,87.080429
	C79.376274,84.974594 79.538628,82.859917 79.615250,80.748405
	C81.636971,81.617226 83.658676,82.486038 85.721359,83.689331
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M490.168793,139.435394
	C488.025787,140.073257 485.404785,140.520432 482.366882,141.097427
	C481.521698,141.132828 481.093414,141.038391 480.147583,140.740921
	C479.063293,140.464798 478.496552,140.391708 477.929810,140.318604
	C476.809479,139.619110 475.689178,138.919632 474.429993,137.922134
	C479.424347,138.164307 484.557587,138.704498 490.168793,139.435394
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M386.256958,429.868683
	C388.691162,431.011414 393.068512,429.804169 392.129395,435.612946
	C391.295105,436.933136 390.609100,437.487488 389.923157,438.041870
	C388.631012,436.339417 387.338898,434.636963 385.975189,432.055725
	C386.021393,430.740845 386.139160,430.304779 386.256958,429.868683
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M509.018219,117.034302
	C506.838593,121.319679 504.658966,125.605057 502.111908,129.905457
	C501.744141,129.486633 501.743805,129.052765 502.070160,128.162857
	C502.562622,127.124779 502.728363,126.542747 502.894104,125.960716
	C503.108215,125.390305 503.322357,124.819893 503.849579,123.790955
	C504.475922,122.574272 504.789185,121.816109 505.102417,121.057945
	C505.980988,119.885368 506.859558,118.712799 508.115967,117.285416
	C508.668610,117.031837 508.843414,117.033073 509.018219,117.034302
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M380.932556,94.793350
	C383.337616,92.824486 384.655762,93.014397 384.808044,95.673668
	C384.999817,99.023201 384.523651,102.410988 384.001465,105.943199
	C383.311279,104.071541 382.955383,102.038956 382.707153,99.207443
	C382.187408,97.203461 381.559998,95.998405 380.932556,94.793350
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M171.965424,134.012711
	C172.049438,134.753281 172.133453,135.493835 172.261063,136.881073
	C172.683044,138.246872 173.061417,138.965988 173.439789,139.685089
	C174.325058,141.867188 175.210312,144.049286 176.088440,146.594528
	C170.954041,144.150833 170.672699,139.140411 170.670609,133.889618
	C171.367477,133.734451 171.666458,133.873581 171.965424,134.012711
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M424.400330,122.736420
	C425.977570,124.963158 427.416901,127.590553 429.148560,130.399719
	C429.515564,130.915588 429.590271,131.249664 429.757965,132.148682
	C430.288971,133.754547 430.727020,134.795441 431.066711,135.929962
	C430.968353,136.023605 430.767273,136.206207 430.767273,136.206207
	C428.598969,131.849823 426.430664,127.493446 424.400330,122.736420
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M182.647797,428.858826
	C178.530563,429.252319 174.068802,429.442566 169.308258,429.349243
	C173.440750,428.928955 177.871994,428.792297 182.647797,428.858826
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M482.961853,40.217392
	C478.487610,42.576893 473.627441,44.840332 468.391937,47.066750
	C472.869720,44.726925 477.722839,42.424122 482.961853,40.217392
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M400.527100,127.154297
	C399.016357,130.000153 397.543457,132.596375 395.777435,135.381561
	C397.451324,131.075790 399.418365,126.581055 401.740051,122.413948
	C401.736938,123.830734 401.379120,124.919884 401.021332,126.009041
	C400.869202,126.307579 400.717041,126.606110 400.527100,127.154297
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M420.964783,131.010117
	C422.984039,134.775818 425.003326,138.541504 426.712311,142.612213
	C425.944061,142.596832 425.486053,142.276443 425.028076,141.956055
	C424.163818,140.148438 423.299591,138.340805 422.281494,135.880219
	C421.740021,133.821548 421.352386,132.415833 420.964783,131.010117
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M326.654541,186.257751
	C325.784210,187.293610 324.487579,188.177017 323.136627,189.382553
	C321.394745,189.222610 319.707184,188.740540 318.019623,188.258484
	C318.154907,187.540756 318.290192,186.823029 318.425446,186.105301
	C321.026398,186.105301 323.627319,186.105301 326.654541,186.257751
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M351.830750,56.927452
	C351.830750,56.927452 352.012024,56.534393 352.302307,56.214722
	C353.020203,55.560696 353.447845,55.226345 353.875458,54.891991
	C353.875458,54.891983 354.099518,55.098824 354.120422,55.538895
	C355.242828,57.600121 356.344299,59.221279 358.060577,61.747280
	C356.524811,62.350258 354.998566,62.949512 353.549377,63.201019
	C353.027924,60.877998 352.429321,58.902725 351.830750,56.927452
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M202.831299,109.485840
	C206.509186,111.805130 210.269775,114.455315 214.051727,117.441597
	C210.353394,115.124046 206.633698,112.470383 202.831299,109.485840
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M367.606201,436.028931
	C367.569763,440.816132 367.194458,445.700226 366.704712,451.006958
	C363.140991,446.165741 364.491150,441.114227 367.606201,436.028931
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M605.147705,430.398560
	C604.627991,431.133514 603.918152,431.573517 603.171387,432.350952
	C601.305542,432.156769 599.476746,431.625092 597.292603,430.979095
	C596.958496,430.389221 596.979736,429.913666 596.995361,429.080811
	C599.645630,429.183563 602.301636,429.643585 605.147705,430.398560
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M31.403736,132.675476
	C30.892242,128.837143 30.668900,124.709557 30.738255,120.295914
	C31.251263,124.135307 31.471575,128.260773 31.403736,132.675476
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M313.930359,126.269211
	C310.616913,130.785889 306.011078,130.648468 300.932495,128.582886
	C305.021759,127.553604 309.275543,126.870995 313.930359,126.269211
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M504.267120,205.713837
	C504.301880,201.431305 504.666687,197.018082 505.094482,192.125046
	C508.632080,196.438385 506.699402,201.014160 504.267120,205.713837
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M472.897003,109.678040
	C472.201965,110.117653 471.432251,110.160034 469.881592,110.186264
	C467.089722,110.256874 465.078766,110.343643 463.067810,110.430412
	C462.294617,110.330963 461.521393,110.231514 460.364105,110.038269
	C464.091644,106.450447 468.445160,107.637230 472.897003,109.678040
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M78.273102,437.748840
	C78.619804,442.196899 78.694046,446.883789 78.697952,452.006653
	C75.381927,447.756042 75.928162,442.904968 78.273102,437.748840
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M434.052429,58.552555
	C435.206268,57.846207 436.096863,57.434532 437.254883,56.902115
	C438.562653,57.259033 439.602997,57.736698 441.064697,58.365761
	C439.288574,59.768478 437.091064,61.019798 434.037476,62.283012
	C432.817017,62.309204 432.452637,62.323494 432.088287,62.337780
	C432.655243,61.174263 433.222198,60.010746 434.052429,58.552555
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M432.994659,149.002533
	C436.825317,149.811722 440.655975,150.620911 444.746399,152.009613
	C445.022827,152.779953 445.039520,152.970749 445.056244,153.161545
	C443.456177,153.195023 441.856110,153.228516 439.723633,153.074310
	C438.125366,152.596313 437.059509,152.306030 435.993622,152.015732
	C435.511841,151.724319 435.030029,151.432907 434.215088,150.788391
	C433.586182,149.957718 433.290405,149.480133 432.994659,149.002533
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M159.269409,377.797699
	C159.674149,380.312012 160.046463,383.026978 159.758926,385.670105
	C159.606720,387.069244 158.307007,388.343506 157.287079,389.464752
	C157.283783,387.579254 157.477585,385.896057 157.764130,384.228851
	C158.123962,382.135223 158.559753,380.054657 159.269409,377.797699
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M485.491486,456.766357
	C482.057709,453.269043 482.119049,447.762756 486.036377,445.213013
	C486.128296,448.987030 485.809784,452.672089 485.491486,456.766357
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M93.071770,428.869537
	C95.845070,430.202271 99.894386,427.093811 101.234360,431.720032
	C98.901627,432.055878 97.152908,432.054260 95.404198,432.052673
	C94.729385,431.852173 94.054573,431.651642 93.188797,430.880188
	C93.022484,429.829315 93.047127,429.349426 93.071770,428.869537
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M316.586304,442.215332
	C314.093567,446.159088 312.609222,442.844147 312.156158,440.742706
	C311.635437,438.327362 312.410278,435.632660 312.973816,432.912811
	C313.407410,434.575256 313.185272,436.470032 313.663940,438.167114
	C314.078400,439.636475 315.288025,440.881531 316.586304,442.215332
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M192.318451,37.940567
	C192.363205,36.637047 192.773468,35.313660 193.527756,32.880554
	C191.100571,33.344395 189.431992,33.663261 187.374161,33.977692
	C188.367599,30.473204 191.411880,30.146244 193.751038,31.841871
	C196.338745,33.717674 194.845581,36.177612 192.318451,37.940567
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M145.179062,122.966133
	C150.365891,125.050674 150.628296,124.924614 150.985779,119.406662
	C154.514175,120.465508 153.526779,123.513504 151.990341,124.939011
	C149.689407,127.073837 146.829269,126.551071 145.179062,122.966133
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M411.285095,112.438782
	C413.038727,111.601662 415.023682,110.994987 417.389435,110.370209
	C418.626160,111.156731 419.482056,111.961349 420.577209,112.935822
	C420.887543,113.515968 420.958618,113.926247 421.047485,114.652000
	C417.882355,114.201401 414.699371,113.435318 411.285095,112.438782
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M456.817688,83.705505
	C454.848419,84.376900 451.157776,78.439262 450.888367,86.028641
	C450.780701,84.577324 450.724792,82.711426 450.668884,80.845535
	C452.698547,81.686867 454.728210,82.528206 456.817688,83.705505
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M600.716370,457.936218
	C601.263672,458.487671 601.518738,458.955566 601.880127,459.673859
	C599.653259,460.245880 597.320007,460.567474 594.809204,460.599121
	C595.374878,459.769104 596.118103,459.229034 596.931274,458.337219
	C598.142151,457.941223 599.283142,457.896942 600.716370,457.936218
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M351.457825,57.029713
	C352.429321,58.902725 353.027924,60.877998 353.271301,63.291275
	C352.236328,64.438629 351.556519,65.147980 350.876709,65.857330
	C350.704742,65.841721 350.532806,65.826111 350.103394,65.780380
	C350.258942,62.877502 350.671936,60.004738 351.457825,57.029713
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M116.141159,147.191772
	C118.034332,148.334671 119.835999,149.880951 122.094414,151.731201
	C122.698647,152.368637 122.846123,152.702118 122.993591,153.035599
	C118.470093,154.041382 115.974983,152.458237 116.141159,147.191772
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M166.412369,103.586082
	C166.616241,104.799210 166.820114,106.012329 166.982895,107.847076
	C166.836838,108.657509 166.731888,108.846306 166.626923,109.035110
	C165.415390,105.248550 164.203857,101.461990 163.272614,97.448128
	C164.013962,97.844017 164.475021,98.467209 164.936096,99.090408
	C164.992447,99.502586 165.048798,99.914764 165.149002,100.910919
	C165.599365,102.191956 166.005859,102.889023 166.412369,103.586082
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M575.282227,81.498604
	C570.240417,82.094406 572.059814,85.260292 572.955811,88.397934
	C572.156250,86.384087 571.300232,83.994446 570.444214,81.604813
	C571.999817,81.459549 573.555481,81.314285 575.282227,81.498604
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M499.285950,459.814819
	C497.498169,459.849335 495.989410,459.696014 494.560425,459.248871
	C495.126556,458.080048 495.612885,457.205048 496.099243,456.330048
	C496.643188,455.721344 497.187134,455.112640 498.207947,454.168488
	C499.442200,453.558594 500.199646,453.284149 500.957092,453.009705
	C501.031982,453.172729 501.106873,453.335693 500.798370,453.941071
	C500.365143,455.049286 500.315277,455.715057 500.265442,456.380859
	C500.031952,457.462921 499.798431,458.544952 499.285950,459.814819
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M390.130646,96.582329
	C386.530609,93.253746 387.623779,89.210144 389.603790,85.070770
	C390.103760,88.720253 390.207428,92.434845 390.130646,96.582329
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M502.978394,65.214539
	C502.286469,67.559441 499.666382,69.761909 502.962982,72.361542
	C503.113647,72.480377 502.448730,73.633530 501.806091,74.386719
	C497.911713,70.363663 498.065491,69.129921 502.978394,65.214539
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M137.633789,109.928917
	C136.570770,115.002838 131.551270,111.849396 128.570953,113.804077
	C128.528961,113.066650 128.816086,112.598930 129.103210,112.131210
	C129.103226,112.131218 129.056320,111.999695 129.411469,112.094986
	C130.667755,111.690590 131.568893,111.190887 132.470032,110.691200
	C134.061508,110.394691 135.653000,110.098183 137.633789,109.928917
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M401.097900,107.282333
	C403.002563,106.496048 404.916992,106.008217 406.860657,105.712532
	C408.503662,105.462608 410.180542,105.435326 411.922150,105.654755
	C410.537231,106.576988 409.112152,107.462769 407.598419,107.656586
	C405.473602,107.928665 403.282898,107.686371 401.097900,107.282333
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M368.298584,135.930298
	C368.406433,133.840149 368.514282,131.750015 368.796143,129.245926
	C372.408844,131.159531 371.394531,133.980042 369.341492,136.763916
	C368.765045,136.340576 368.589844,136.094162 368.298584,135.930298
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M60.374382,190.843536
	C59.471241,189.812775 58.937408,188.192932 57.852886,187.140656
	C57.055752,186.367264 55.537651,186.336945 54.039398,186.089203
	C54.468464,185.143539 55.198975,184.084152 55.929489,183.024780
	C56.893532,183.784622 58.201275,184.356613 58.742760,185.347397
	C59.600552,186.916916 59.945564,188.766663 60.374382,190.843536
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M416.955872,93.662354
	C415.056610,94.683701 413.160187,95.503510 411.179504,95.945831
	C409.801666,96.253525 408.308044,96.042709 406.768982,95.716461
	C408.410217,94.621696 410.089569,93.597397 411.904907,93.209473
	C413.498322,92.868958 415.244232,93.241875 416.955872,93.662354
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M490.511047,119.563873
	C490.475891,120.017059 490.440704,120.470245 490.130096,121.320938
	C489.226959,123.138779 488.599304,124.559097 487.971619,125.979416
	C487.971619,125.979416 488.000244,125.999390 487.712219,126.068283
	C486.957153,126.443253 486.490112,126.749329 486.002075,126.670074
	C486.339020,123.151978 486.696960,120.019211 487.366272,116.911362
	C488.083649,117.000610 488.489655,117.064941 488.895630,117.129265
	C488.895630,117.129265 488.987061,117.013412 488.969574,117.366013
	C489.471771,118.333694 489.991425,118.948776 490.511047,119.563873
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M407.774658,398.221680
	C409.664001,401.779114 411.317566,405.558929 412.924438,409.706787
	C411.098145,406.197906 409.318542,402.320984 407.774658,398.221680
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M469.287506,200.377945
	C469.673462,203.552322 469.902985,207.167679 469.782898,210.923370
	C469.332520,207.648788 469.231781,204.233856 469.287506,200.377945
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M448.139099,139.377014
	C448.466156,139.854996 448.299927,140.151672 448.060791,140.695068
	C447.550446,140.960449 447.112946,140.979111 445.930084,140.974823
	C443.106384,141.041916 441.028107,141.131958 438.949799,141.222015
	C438.526001,141.124146 438.102173,141.026276 437.293488,140.672043
	C436.764282,140.102203 436.619965,139.788727 436.475647,139.475235
	C440.199036,139.382050 443.922455,139.288864 448.139099,139.377014
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M357.741394,36.366821
	C359.549316,36.417427 361.145477,36.641182 362.883911,37.221718
	C362.399597,38.494263 361.772919,39.410023 360.781433,40.630135
	C359.403168,40.558632 358.389709,40.182777 357.376282,39.806923
	C357.427399,38.717937 357.478485,37.628956 357.741394,36.366821
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M436.795288,458.594757
	C437.638580,455.992645 438.604340,453.740509 439.870911,451.227844
	C440.316925,453.240875 440.700409,455.530487 440.547882,457.783844
	C440.350403,460.702240 438.739502,460.446808 436.795288,458.594757
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M210.296066,189.836365
	C207.695663,189.012375 205.426544,188.087189 203.008942,186.839508
	C204.943176,186.344696 207.032883,185.974564 209.106903,186.048050
	C211.961746,186.149185 212.549225,187.502823 210.296066,189.836365
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M41.995468,438.494202
	C40.426300,440.408813 38.825520,442.171295 36.899361,443.439636
	C36.419514,443.755585 34.889111,442.476105 33.874626,441.563080
	C37.893112,443.686066 38.884483,438.351654 41.995468,438.494202
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M357.148743,40.064255
	C358.389709,40.182777 359.403168,40.558632 360.746216,40.973545
	C360.890137,42.552826 360.704468,44.093052 360.249451,45.818321
	C358.369965,44.552948 356.759796,43.102524 355.091003,41.315361
	C355.661957,40.759617 356.291595,40.540604 357.148743,40.064255
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M96.236298,155.377701
	C93.729553,158.503967 90.428856,159.297943 86.297012,157.137451
	C85.801620,156.790115 85.654327,156.442276 85.508186,155.811737
	C88.940849,155.438354 92.372360,155.347672 96.236298,155.377701
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M530.410095,261.098022
	C530.196838,261.792694 529.722656,262.234344 528.989258,263.084564
	C527.435303,263.345978 526.140625,263.198792 524.269653,262.798767
	C523.102417,261.961456 522.511353,261.376923 521.920288,260.792419
	C524.663269,260.809967 527.406189,260.827515 530.410095,261.098022
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M220.882248,110.096664
	C219.686386,109.983421 218.673981,109.506752 217.873611,108.604324
	C218.930664,106.551445 219.775665,104.924301 220.620682,103.297165
	C225.843948,105.091614 222.049011,107.509628 220.882248,110.096664
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M123.434227,153.028625
	C122.846123,152.702118 122.698647,152.368637 122.414978,151.788422
	C126.234138,151.004730 130.189484,150.467789 134.422241,150.214417
	C134.112350,150.978455 133.525040,151.458908 132.937729,151.939377
	C132.937729,151.939377 132.994431,152.001984 132.632736,151.924377
	C131.525162,152.275803 130.779297,152.704819 130.033417,153.133835
	C127.980568,153.096451 125.927711,153.059067 123.434227,153.028625
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M175.594315,114.069206
	C175.273651,114.034912 174.686615,114.047935 174.670898,113.959473
	C174.145615,111.002380 173.674835,108.035622 173.743439,105.196365
	C174.572769,105.532394 174.854721,105.742317 175.136688,105.952232
	C175.374146,107.396561 175.611603,108.840897 175.875748,111.018929
	C175.799728,112.524826 175.697021,113.297012 175.594315,114.069206
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M568.347900,249.279419
	C567.706238,248.200012 567.367676,247.250412 566.953369,246.004425
	C568.589172,246.035507 570.467102,246.025726 571.973572,246.768845
	C574.281372,247.907333 573.815125,249.007477 571.089722,249.100952
	C570.489136,248.899887 570.204285,249.031479 569.919373,249.163071
	C569.496582,249.245132 569.073792,249.327194 568.347900,249.279419
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M177.936096,129.011765
	C177.856171,128.278854 177.776245,127.545952 177.730408,126.200500
	C177.859711,125.388710 177.954926,125.189476 178.050156,124.990242
	C179.200470,128.197845 180.350769,131.405441 181.210175,134.821136
	C180.299683,133.914719 179.680084,132.800217 178.996826,131.082794
	C178.600830,129.990509 178.268478,129.501129 177.936096,129.011765
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M524.692627,385.224243
	C522.980835,388.893005 519.705933,390.149780 515.349365,389.477875
	C518.173523,387.928833 521.259033,386.620697 524.692627,385.224243
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M611.091675,315.386719
	C607.958496,315.706818 604.761780,315.663971 601.175232,315.499878
	C604.097168,312.302582 607.502075,311.915710 611.091675,315.386719
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M342.038666,148.488052
	C341.278320,146.232010 340.530334,143.506332 339.648834,140.367508
	C339.658875,139.526611 339.802399,139.098892 340.226379,138.295685
	C340.819977,137.747131 341.133148,137.574036 341.446320,137.400940
	C341.647888,140.940109 341.849457,144.479263 342.038666,148.488052
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M140.880280,61.622726
	C144.140198,59.727360 147.773270,57.970402 151.771790,56.285080
	C148.509308,58.158184 144.881363,59.959663 140.880280,61.622726
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M133.331848,151.998917
	C133.525040,151.458908 134.112350,150.978455 134.850006,150.249481
	C137.416824,148.973755 139.833313,147.946548 142.615082,146.939697
	C139.895569,148.659531 136.810760,150.358994 133.331848,151.998917
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M149.693146,382.114929
	C153.138992,381.557709 152.943970,383.242554 152.014359,385.672913
	C150.387985,385.718170 148.859680,385.422485 146.965759,384.966675
	C147.531372,383.948639 148.462585,383.090729 149.693146,382.114929
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M57.073997,445.985626
	C56.465439,445.793457 55.856880,445.601318 55.101974,444.776733
	C54.891922,443.668304 54.828209,443.192322 54.764496,442.716309
	C55.494190,440.403442 56.223885,438.090576 57.311760,435.457825
	C57.669937,435.137970 58.130089,435.203003 58.130089,435.203003
	C58.279823,435.700714 58.429554,436.198395 58.732521,437.222778
	C58.281837,440.494843 57.677914,443.240234 57.073997,445.985626
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M298.874146,32.844978
	C297.736847,33.055698 296.601898,32.865334 294.829712,32.777863
	C293.651581,33.938213 293.110687,34.995670 292.569794,36.053123
	C292.386353,34.627922 292.202881,33.202724 292.019409,31.777527
	C294.305084,31.999647 296.590759,32.221767 298.874146,32.844978
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M528.538940,124.214348
	C527.201172,121.371002 526.065186,118.096359 524.906006,114.444450
	C529.140320,116.125847 529.177917,119.860184 528.538940,124.214348
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M313.262146,454.670044
	C311.980957,451.536804 310.708221,448.046082 314.605591,445.356506
	C314.402435,448.463318 313.928162,451.399780 313.262146,454.670044
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M462.085571,49.349686
	C459.220856,51.008892 455.969299,52.516895 452.343811,53.985229
	C455.212830,52.363201 458.455780,50.780838 462.085571,49.349686
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M158.000305,71.929443
	C157.886032,70.791336 158.108994,69.537964 158.331940,68.284599
	C159.710541,68.741272 161.089127,69.197945 162.784821,69.820488
	C163.191971,70.711761 163.282028,71.437157 163.311172,72.524323
	C161.612686,72.528793 159.975128,72.171486 158.000305,71.929443
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M456.465271,455.653992
	C456.167023,452.775696 455.986633,449.447144 456.157349,445.979065
	C456.533386,448.960938 456.558289,452.082306 456.465271,455.653992
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M460.641693,98.306122
	C462.258514,98.837502 463.582977,101.575241 465.684631,98.203072
	C465.420135,99.277596 464.897949,100.534035 464.375763,101.790466
	C463.088470,100.738785 461.801147,99.687096 460.641693,98.306122
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M421.900513,104.751106
	C423.784607,101.837425 422.762177,99.583740 420.235291,97.242020
	C421.758759,98.240768 423.668793,99.367218 424.722382,101.034798
	C425.064484,101.576225 423.165955,103.533333 421.900513,104.751106
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M360.004211,260.986053
	C359.265625,261.465790 358.527039,261.945557 357.754578,262.771332
	C356.328400,263.113495 354.936066,263.109589 353.209595,263.145630
	C352.657074,262.642822 352.438721,262.100098 352.142120,261.126129
	C354.427155,260.434082 356.790436,260.173309 359.581543,260.188232
	C360.007660,260.638000 360.005951,260.812042 360.004211,260.986053
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M292.670471,36.356163
	C293.110687,34.995670 293.651581,33.938213 294.575867,32.900585
	C294.991333,35.948830 295.023376,38.977249 294.768127,42.416962
	C293.985443,42.552822 293.490112,42.277390 292.994751,42.001965
	C292.937836,41.570370 292.880951,41.138771 292.867371,40.049057
	C292.821411,38.898888 292.732117,38.406834 292.642822,37.914780
	C292.685608,37.496250 292.728394,37.077724 292.670471,36.356163
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M101.811676,436.927277
	C101.532242,437.858093 101.252815,438.788940 100.973373,439.719788
	C100.191589,439.266968 99.159592,438.993530 98.679779,438.324249
	C97.660194,436.902100 96.927879,435.274048 96.380859,433.362366
	C98.393166,434.305298 100.102417,435.616302 101.811676,436.927277
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M101.842621,436.526825
	C100.102417,435.616302 98.393166,434.305298 96.315193,433.011261
	C95.786240,432.904419 95.625992,432.780609 95.434975,432.354706
	C97.152908,432.054260 98.901627,432.055878 101.079117,432.096619
	C101.629776,433.465973 101.751663,434.796173 101.842621,436.526825
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M139.823929,428.921875
	C140.602951,430.988464 141.205460,432.855682 141.637268,435.075317
	C139.949905,433.608917 138.433212,431.790161 136.549438,429.531189
	C137.765579,429.213745 138.706497,428.968140 139.823929,428.921875
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M580.823486,365.906067
	C578.472717,364.123138 576.173218,361.986328 573.831543,359.512360
	C576.151123,361.300873 578.512878,363.426575 580.823486,365.906067
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M398.615387,94.962265
	C397.511871,97.436005 393.607330,99.355698 397.423584,103.256203
	C396.434021,102.329170 394.140564,100.673599 394.408020,99.862099
	C395.021759,97.999939 396.884064,96.549263 398.615387,94.962265
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M191.498947,140.585236
	C190.252472,140.685608 189.005981,140.785995 187.321594,140.671753
	C186.672333,140.179764 186.461014,139.902405 186.249695,139.625031
	C189.142044,138.831711 192.034378,138.038406 195.373199,137.384186
	C195.423370,138.014557 195.027039,138.505844 194.064148,139.114410
	C192.831360,139.682877 192.165146,140.134048 191.498947,140.585236
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M486.023071,127.055397
	C486.490112,126.749329 486.957153,126.443253 487.700195,126.055176
	C487.262268,130.786652 483.076416,130.866577 479.457092,131.699402
	C480.662628,130.384399 482.107849,129.415726 483.849915,128.437897
	C484.772186,127.970955 485.397614,127.513176 486.023071,127.055397
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M128.723572,112.068649
	C128.816086,112.598930 128.528961,113.066650 128.172318,113.803040
	C128.102814,114.071716 128.050720,114.049271 127.745613,114.064301
	C126.856483,114.621628 126.272453,115.163918 125.688431,115.706207
	C124.526245,116.328613 123.364059,116.951019 121.872269,117.592484
	C121.829086,113.339844 125.384415,113.034416 128.723572,112.068649
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M183.981461,152.073303
	C185.948746,151.820770 187.916031,151.568222 190.128113,151.693115
	C190.013748,152.489639 189.654572,152.908707 189.295410,153.327774
	C187.968979,153.332458 186.642548,153.337128 184.871948,153.162781
	C184.279007,152.680267 184.130234,152.376785 183.981461,152.073303
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M202.698273,447.150024
	C203.140213,449.640076 203.420044,452.557495 203.399734,455.731812
	C202.911774,453.184967 202.723953,450.381195 202.698273,447.150024
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M446.939423,63.686359
	C449.485199,62.022987 452.402405,60.487259 455.688843,59.033081
	C453.142334,60.681084 450.226593,62.247543 446.939423,63.686359
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M171.967407,40.217033
	C169.126541,41.848644 165.898987,43.391918 162.298080,44.885963
	C165.143387,43.267387 168.362061,41.698044 171.967407,40.217033
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M526.775330,136.999496
	C526.897522,134.038528 527.356873,130.959427 528.091064,127.623367
	C527.948120,130.538055 527.530273,133.709717 526.775330,136.999496
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M198.735046,186.319199
	C197.542480,187.254379 195.948425,188.004791 194.279755,189.062759
	C193.553070,188.903961 192.901001,188.437607 192.248901,187.971252
	C192.831284,187.330994 193.332794,186.269287 194.012985,186.138748
	C195.402298,185.872131 196.887711,186.106445 198.735046,186.319199
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M305.609009,457.953125
	C307.844025,458.501678 309.716644,459.045197 311.817627,459.889008
	C310.095947,460.368164 308.138702,460.692322 306.202393,460.596039
	C305.840820,460.578094 305.563049,458.874084 305.609009,457.953125
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M142.079620,119.637314
	C142.567551,119.943130 142.712067,120.258148 142.912262,120.828964
	C141.130035,121.233215 139.292160,121.381683 137.282745,120.998566
	C137.272171,120.173904 137.433121,119.880829 137.594055,119.587746
	C138.974777,119.607330 140.355499,119.626923 142.079620,119.637314
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M406.724731,94.934151
	C404.338257,95.189598 402.043793,95.059212 399.371399,94.959763
	C401.350006,90.930740 403.938873,90.784348 406.724731,94.934151
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M456.563843,441.765808
	C456.242188,439.178406 456.054108,436.135956 456.208801,432.943909
	C456.600159,435.633087 456.648773,438.471954 456.563843,441.765808
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M377.683105,431.446899
	C376.915436,431.357697 376.493378,431.250305 375.612183,430.776978
	C375.445801,429.978027 375.738495,429.545044 376.031219,429.112091
	C376.686249,428.977417 377.341309,428.842743 378.777863,428.856384
	C380.476227,428.921082 381.393036,428.837463 382.309875,428.753845
	C382.694855,428.764618 383.079803,428.775391 383.736664,429.291779
	C383.994995,430.353485 383.981476,430.909607 383.967957,431.465729
	C381.988220,431.453400 380.008453,431.441040 377.683105,431.446899
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M55.203732,156.110733
	C57.532642,155.800217 59.803635,155.877533 62.434902,155.859390
	C60.595383,159.929016 58.013805,160.176941 55.203732,156.110733
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M212.868149,140.512421
	C211.981567,139.231033 211.095001,137.949661 210.382385,136.362106
	C210.725876,136.097046 210.895401,136.138153 211.064926,136.179260
	C213.359711,137.214157 215.654510,138.249069 218.198242,139.656433
	C218.293777,140.336304 218.140366,140.643707 217.986954,140.951111
	C217.235672,140.940506 216.484375,140.929901 215.165192,140.745148
	C214.020920,140.551468 213.444534,140.531937 212.868149,140.512421
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M103.214043,261.241272
	C101.483276,261.820343 99.543205,262.099548 97.319099,262.672241
	C94.371750,261.955261 95.497612,260.717926 97.184311,260.454437
	C99.053497,260.162506 101.058739,260.741638 103.214043,261.241272
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M76.734825,127.062447
	C75.482819,124.280151 74.230812,121.497849 73.262741,118.474998
	C74.052582,118.797554 74.558495,119.360664 75.064415,119.923767
	C75.064415,119.923767 75.157440,120.396767 75.168091,120.919205
	C75.610603,122.103043 76.042450,122.764435 76.474304,123.425827
	C76.641472,124.049072 76.808640,124.672318 76.970352,125.883026
	C76.888199,126.667816 76.811508,126.865128 76.734825,127.062447
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M119.712196,65.091003
	C120.841187,66.391685 121.600975,67.735725 122.741432,69.194778
	C121.722321,69.581886 120.322548,69.854004 118.922775,70.126114
	C119.062859,68.462204 119.202927,66.798294 119.712196,65.091003
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M75.973175,371.707153
	C73.466347,371.485718 70.936661,370.969269 68.475723,369.929504
	C70.453011,369.534180 72.361534,369.662170 74.270065,369.790192
	C74.830147,370.330841 75.390228,370.871490 75.973175,371.707153
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M110.715019,387.698486
	C108.198502,388.496857 105.386406,389.111420 102.310890,389.483276
	C104.838127,388.665253 107.628784,388.089935 110.715019,387.698486
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M33.641586,155.735138
	C36.295834,155.380646 38.989506,155.336212 42.084656,155.425674
	C42.399700,155.902542 42.313255,156.245529 41.749031,156.861557
	C39.503311,157.477432 37.735374,157.820251 35.967438,158.163055
	C35.205292,157.457108 34.443150,156.751175 33.641586,155.735138
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M172.006744,96.998520
	C171.989532,96.563812 171.972321,96.129097 172.018661,95.112671
	C172.189743,94.342827 172.297256,94.154701 172.404785,93.966568
	C173.119049,96.158867 173.833298,98.351173 174.070984,100.736053
	C173.363663,100.717239 173.100952,100.664268 172.806290,100.769691
	C172.737793,100.372467 172.669281,99.975250 172.664536,99.128342
	C172.487778,98.118607 172.247269,97.558563 172.006744,96.998520
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M353.962158,54.551422
	C353.447845,55.226345 353.020203,55.560696 352.340088,56.001629
	C352.128967,53.175671 352.170288,50.243134 352.362549,46.907883
	C353.025299,49.073730 353.537079,51.642284 353.962158,54.551422
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M391.433563,117.478165
	C391.540192,116.860497 391.601166,116.675026 391.825745,116.246658
	C395.334381,118.363785 394.361237,121.077225 392.245117,123.901932
	C391.701630,121.937645 391.544769,119.924004 391.433563,117.478165
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M323.050323,146.219086
	C323.357056,148.517578 323.262421,150.782150 322.696289,153.474731
	C322.020996,153.930527 321.817200,153.958298 321.613403,153.986069
	C321.958618,151.385773 322.303802,148.785492 323.050323,146.219086
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M366.932556,32.661633
	C364.657104,33.107800 362.339905,33.163136 359.590027,33.228477
	C361.282654,29.299608 364.070587,30.656044 366.932556,32.661633
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M390.650757,131.857727
	C390.365723,130.043900 390.358063,127.997536 390.676666,125.889313
	C390.977966,127.760033 390.953033,129.692612 390.650757,131.857727
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M134.372192,84.782280
	C132.682938,84.651314 131.230637,84.323959 129.392624,83.998886
	C129.909317,83.085999 130.811752,82.170837 131.714172,81.255676
	C132.679169,82.365753 133.644165,83.475822 134.372192,84.782280
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M521.526245,260.642731
	C522.511353,261.376923 523.102417,261.961456 523.862854,262.813965
	C523.163330,264.220581 522.294434,265.359192 521.000610,266.592194
	C520.033997,265.788605 519.492432,264.890625 518.950928,263.992615
	C519.677979,262.826080 520.405029,261.659546 521.526245,260.642731
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M37.810524,445.596924
	C39.003231,446.112701 40.372051,446.922363 42.049370,447.771149
	C42.128639,448.626862 41.899414,449.443390 41.670181,450.259949
	C40.985783,449.972992 40.035370,449.873627 39.672935,449.359619
	C38.941711,448.322601 38.530090,447.060181 37.810524,445.596924
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M83.375137,447.731506
	C83.019539,445.504883 82.838867,442.843536 82.958588,440.006256
	C83.356003,442.319153 83.453033,444.807983 83.375137,447.731506
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M507.964844,459.084045
	C508.690063,459.100708 509.415283,459.117340 510.571716,459.369232
	C511.006592,459.772552 511.010193,459.940643 511.013824,460.108704
	C509.457520,460.374359 507.875305,460.903748 506.359711,460.754974
	C505.864532,460.706390 505.542694,458.892334 505.665039,458.166260
	C506.780640,458.659271 507.372742,458.871674 507.964844,459.084045
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M393.594055,245.781845
	C393.911804,246.732758 393.855316,247.689011 393.891235,248.934631
	C392.314117,249.224014 390.644653,249.224014 388.975159,249.224014
	C388.848297,248.771286 388.721436,248.318558 388.594543,247.865814
	C390.136292,247.172943 391.678040,246.480057 393.594055,245.781845
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M420.840210,130.790009
	C421.352386,132.415833 421.740021,133.821548 422.100952,135.598862
	C420.905701,133.759750 419.737152,131.549026 419.110748,129.194412
	C419.970764,129.225052 420.288635,129.399582 420.606506,129.574127
	C420.642883,129.906052 420.679291,130.237976 420.840210,130.790009
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M348.852234,32.775906
	C347.159607,33.332542 345.465210,33.512547 343.431458,33.853939
	C343.194611,30.564480 344.783722,30.118500 348.852234,32.775906
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M129.994629,140.985565
	C128.616837,140.988266 127.239044,140.990967 125.159607,140.904175
	C123.600441,140.229233 122.742928,139.643784 121.885406,139.058319
	C124.399498,139.157349 126.913597,139.256393 129.721954,139.907837
	C130.009033,140.635361 130.001831,140.810471 129.994629,140.985565
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M207.098846,99.324493
	C205.966034,99.411301 204.802048,99.098213 203.638046,98.785126
	C204.474106,97.762428 205.310150,96.739731 206.499359,95.720863
	C206.924255,96.791336 206.995956,97.857971 207.098846,99.324493
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M357.613098,85.023750
	C356.742218,82.807838 356.044495,80.178406 355.518311,77.267288
	C356.388672,79.527153 357.087433,82.068695 357.613098,85.023750
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M91.158066,110.500923
	C90.483345,112.983727 89.465454,115.299026 88.144951,117.798225
	C88.833191,115.432564 89.824036,112.882996 91.158066,110.500923
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M98.259079,121.792618
	C97.012474,119.543404 96.032791,117.085808 95.134766,114.259003
	C96.319626,116.454605 97.422821,119.019424 98.259079,121.792618
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M87.179054,432.677307
	C86.075935,432.083527 85.282257,431.519562 84.137527,430.902771
	C85.225784,430.117798 86.665085,429.385712 88.599503,429.007141
	C89.402931,429.877686 89.711227,430.394684 90.019524,430.911682
	C89.175842,431.510193 88.332169,432.108704 87.179054,432.677307
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M69.016647,111.427528
	C66.787720,111.919029 64.494179,112.131935 62.061584,112.070518
	C62.431122,111.272842 62.939705,110.749496 64.100922,110.180328
	C65.522545,110.056671 66.291519,109.978821 67.060501,109.900978
	C67.691017,110.316963 68.321526,110.732948 69.016647,111.427528
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M461.595276,447.707001
	C462.212067,447.280060 462.817230,447.210205 463.869568,447.043945
	C464.308960,448.110382 464.301117,449.273254 464.293274,450.436096
	C463.390015,449.645416 462.486816,448.854736 461.595276,447.707001
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M74.164413,369.468750
	C72.361534,369.662170 70.453011,369.534180 68.261078,369.618561
	C67.455826,369.849854 66.933975,369.868744 66.034912,369.780884
	C68.301849,367.007599 71.098938,366.780060 74.164413,369.468750
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M436.158386,139.397461
	C436.619965,139.788727 436.764282,140.102203 436.966095,140.669739
	C434.988922,139.581665 432.954285,138.239517 430.843445,136.551788
	C430.767273,136.206207 430.968353,136.023605 431.296936,135.967438
	C431.625519,135.911255 432.084778,135.828705 432.084778,135.828705
	C433.336884,136.992371 434.588989,138.156036 436.158386,139.397461
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M74.742737,232.759521
	C73.503311,230.500214 72.370911,227.874252 71.380798,224.872742
	C72.631981,227.129089 73.740868,229.760971 74.742737,232.759521
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M299.697052,223.715973
	C298.488647,221.451538 297.352448,218.818329 296.338074,215.794693
	C297.563019,218.051926 298.666107,220.699585 299.697052,223.715973
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M506.317291,93.757706
	C505.365845,91.562256 504.687653,89.129578 504.092407,86.304749
	C504.980408,88.448563 505.785461,90.984520 506.317291,93.757706
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M367.975403,136.126465
	C368.589844,136.094162 368.765045,136.340576 368.972839,136.849792
	C368.891693,137.905441 368.661957,138.780853 368.138184,140.158569
	C367.491028,141.399261 367.137878,142.137650 366.784729,142.876022
	C366.784729,142.876022 366.357544,142.991776 366.147217,142.922882
	C366.508698,140.676880 367.080444,138.499771 367.975403,136.126465
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M365.048645,290.991272
	C366.132355,290.151978 367.400513,289.590363 368.617065,288.661865
	C369.310486,288.662567 370.055511,289.030151 370.800568,289.397736
	C370.312775,290.142212 369.918823,291.415894 369.317902,291.522491
	C368.012360,291.753967 366.601135,291.389648 365.048645,290.991272
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M477.969299,429.038422
	C478.837982,431.275726 479.384796,433.422913 479.793518,436.026886
	C479.516724,433.830505 475.123077,432.311096 477.969299,429.038422
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M151.085129,49.315994
	C149.167068,50.569782 146.873016,51.674778 144.219498,52.711010
	C146.143066,51.483902 148.426102,50.325554 151.085129,49.315994
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M420.726562,129.180908
	C420.288635,129.399582 419.970764,129.225052 419.382568,129.014465
	C418.622711,127.764366 418.133118,126.550339 417.391052,124.838799
	C417.021973,123.967094 416.905426,123.592888 416.896973,123.109955
	C417.005096,123.001221 417.224243,122.786636 417.224243,122.786636
	C418.431702,124.786987 419.639160,126.787331 420.726562,129.180908
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M189.671814,153.511307
	C189.654572,152.908707 190.013748,152.489639 190.559509,151.858612
	C191.689407,151.238373 192.632721,150.830093 194.096161,150.189560
	C195.042648,149.909241 195.469025,149.861191 195.895401,149.813141
	C193.946350,151.107040 191.997284,152.400940 189.671814,153.511307
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M220.450592,103.249176
	C219.775665,104.924301 218.930664,106.551445 217.781662,108.332146
	C217.651962,106.974358 217.826233,105.463005 218.292953,103.533554
	C219.057953,103.071022 219.530502,103.026581 220.003067,102.982147
	C220.003067,102.982147 220.280487,103.201187 220.450592,103.249176
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M279.593567,191.966187
	C279.100800,194.135803 278.302979,196.437744 277.168396,198.889267
	C277.650604,196.725403 278.469543,194.411972 279.593567,191.966187
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M65.048721,457.554504
	C65.539207,458.153107 65.691193,458.735748 65.928322,459.762604
	C64.899521,460.280182 63.785580,460.353607 62.671631,460.427002
	C63.351154,459.464203 64.030678,458.501373 65.048721,457.554504
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M446.943237,151.654205
	C448.942596,150.504379 450.941986,149.354553 453.320038,148.332672
	C452.311249,149.508591 450.923798,150.556595 448.926392,151.730835
	C447.858734,151.789444 447.401001,151.721832 446.943237,151.654205
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M447.272339,50.462585
	C447.377899,48.711674 447.722565,47.206738 448.099792,45.306129
	C451.366669,47.211647 451.339355,49.163582 447.272339,50.462585
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M26.295780,146.758194
	C26.878090,146.732208 27.349300,147.096954 28.076704,147.620987
	C28.355906,148.102875 28.457537,148.398438 28.780346,149.185547
	C29.314447,150.786911 29.705990,151.869705 30.097534,152.952484
	C28.793253,151.017960 27.488968,149.083435 26.295780,146.758194
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M442.516724,51.105824
	C441.575256,50.638905 440.942291,50.163078 439.990906,49.441433
	C439.733704,48.429287 439.794983,47.662968 439.854370,46.599533
	C441.455963,47.388950 443.059448,48.475483 444.823975,49.850506
	C444.265045,50.458305 443.545105,50.777611 442.516724,51.105824
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M410.046265,123.084915
	C411.877167,119.596619 414.352631,120.656143 417.054504,122.451180
	C417.224243,122.786636 417.005096,123.001221 416.582520,123.076202
	C415.748108,123.183868 415.336243,123.216553 414.924377,123.249237
	C414.207214,123.178772 413.490051,123.108322 412.093964,123.063538
	C410.958771,123.087776 410.502533,123.086349 410.046265,123.084915
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M564.914429,239.663101
	C564.999329,237.728821 565.302917,235.536591 565.904907,233.145050
	C565.846619,235.098877 565.489807,237.251999 564.914429,239.663101
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M500.743652,98.247139
	C501.247955,100.129745 501.473541,102.262230 501.550201,104.801483
	C501.089172,102.971176 500.777069,100.734093 500.743652,98.247139
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M324.489197,456.916260
	C325.618591,457.362122 326.419922,457.862762 327.221252,458.363403
	C326.939941,458.936646 326.658600,459.509888 326.377289,460.083130
	C324.629120,459.605194 322.880920,459.127228 321.074402,458.282990
	C322.064423,457.601471 323.112762,457.286255 324.489197,456.916260
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M34.037331,439.635773
	C33.794746,437.673615 33.773769,435.394440 34.054684,432.946594
	C34.324032,434.958191 34.291489,437.138458 34.037331,439.635773
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M128.561920,381.824219
	C131.354492,381.785980 132.401810,382.787994 130.923279,385.685364
	C129.870789,385.262970 128.947464,384.494598 128.044479,383.131470
	C128.064835,382.536713 128.028610,382.063232 128.028610,382.063232
	C128.028610,382.063232 128.368042,381.861511 128.561920,381.824219
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M364.085022,38.378769
	C365.339630,37.513325 366.724152,36.976711 368.289001,36.057129
	C368.495605,36.891933 368.521881,38.109699 368.548157,39.327469
	C367.103729,39.120846 365.659363,38.914223 364.085022,38.378769
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M216.294403,88.877838
	C217.763458,87.542976 219.582443,86.252525 221.768188,85.023087
	C220.304749,86.363472 218.474548,87.642860 216.294403,88.877838
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M128.172516,67.175812
	C130.070770,65.904343 132.155396,64.893951 134.602936,63.910904
	C132.763519,65.104469 130.561203,66.270676 128.172516,67.175812
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M185.183487,34.523739
	C183.271286,35.828606 180.999496,36.952213 178.363861,38.037273
	C180.274628,36.779972 182.549271,35.561226 185.183487,34.523739
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M423.247040,73.743813
	C425.129486,72.483391 427.371185,71.291405 429.989990,70.190292
	C428.113525,71.458191 425.859924,72.635223 423.247040,73.743813
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M562.455139,231.747543
	C561.873474,233.978210 561.026001,236.430283 559.864319,238.986908
	C560.429871,236.717300 561.309631,234.343140 562.455139,231.747543
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M513.776184,456.708496
	C513.210510,454.873505 512.697998,452.625977 512.389282,449.987549
	C513.005127,451.829712 513.417236,454.062836 513.776184,456.708496
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M503.356995,79.953598
	C505.219177,78.704140 507.438721,77.410522 510.046692,76.214607
	C508.194855,77.511345 505.954590,78.710388 503.356995,79.953598
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M569.470825,213.763306
	C568.827576,216.022049 567.893982,218.468155 566.621826,220.986115
	C567.249023,218.688873 568.214783,216.319778 569.470825,213.763306
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M321.594055,154.350616
	C321.817200,153.958298 322.020996,153.930527 322.532104,153.875458
	C324.145905,154.333862 325.452423,154.819534 327.121033,155.448334
	C325.885315,156.470840 324.287506,157.350204 322.199158,157.842667
	C321.524109,157.257690 321.339691,157.059631 321.155304,156.861572
	C321.295105,156.146103 321.434906,155.430634 321.594055,154.350616
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M100.515991,153.284973
	C101.592537,151.568024 103.013092,149.809341 104.795242,148.064606
	C103.724571,149.800125 102.292290,151.521683 100.515991,153.284973
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M36.037647,158.512390
	C37.735374,157.820251 39.503311,157.477432 41.657772,157.118378
	C40.925610,160.590515 38.842194,160.824158 36.037647,158.512390
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M138.786652,137.111877
	C137.013489,138.145462 134.834030,139.096344 132.292572,139.950684
	C134.080490,138.912491 136.230438,137.970840 138.786652,137.111877
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M210.552902,132.887268
	C210.682968,132.488831 210.813034,132.090378 211.015533,131.047272
	C210.892883,129.718735 210.697784,129.034851 210.502686,128.350983
	C214.708267,129.084030 212.995178,131.551361 211.545746,133.613464
	C210.849472,133.259781 210.701187,133.073532 210.552902,132.887268
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M378.896301,113.065994
	C378.181580,113.100296 377.466827,113.134590 376.398254,113.116043
	C376.604156,112.094040 377.163910,111.124886 377.723633,110.155716
	C378.509460,110.765663 379.295288,111.375610 379.812225,112.439507
	C379.327667,112.950981 379.111969,113.008492 378.896301,113.065994
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M28.760818,260.686737
	C28.162106,261.460724 27.321804,261.974060 26.275295,262.712219
	C25.518169,262.374237 24.967253,261.811432 24.416332,261.248596
	C25.783964,260.974396 27.151598,260.700226 28.760818,260.686737
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M466.882812,54.611969
	C468.504456,53.380894 470.481598,52.285648 472.804626,51.275505
	C471.179779,52.489674 469.209015,53.618736 466.882812,54.611969
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M183.626892,152.061050
	C184.130234,152.376785 184.279007,152.680267 184.542053,153.214218
	C182.277634,154.078171 179.899719,154.709686 179.311920,150.792694
	C180.697128,150.930969 181.984726,151.489883 183.626892,152.061050
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M175.710297,114.426422
	C175.697021,113.297012 175.799728,112.524826 175.994110,111.368607
	C176.574890,112.830864 177.064026,114.677155 176.998550,116.778130
	C176.264420,117.030800 176.084885,117.028793 175.905365,117.026794
	C175.879013,116.279076 175.852646,115.531364 175.710297,114.426422
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M219.922302,102.588089
	C219.530502,103.026581 219.057953,103.071022 218.247650,103.231155
	C217.184967,103.233879 216.460022,103.120918 215.182419,102.775635
	C214.047699,102.443314 213.465668,102.343323 212.883621,102.243332
	C212.786102,102.105629 212.688599,101.967934 212.515808,101.588943
	C214.907547,101.629776 217.374542,101.911903 219.922302,102.588089
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M130.180191,58.432716
	C128.542816,59.647789 126.550682,60.710133 124.209290,61.709209
	C125.848503,60.523956 127.836967,59.401970 130.180191,58.432716
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M326.951691,453.980316
	C327.752533,453.245148 328.553406,452.509949 329.354248,451.774780
	C329.493958,452.846619 329.633667,453.918457 329.290588,454.856018
	C328.189087,454.474609 327.570404,454.227478 326.951691,453.980316
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M380.806824,95.102257
	C381.559998,95.998405 382.187408,97.203461 382.628326,98.769836
	C381.443970,99.076088 380.446075,99.021019 379.077240,98.898819
	C379.364532,97.691521 380.022827,96.551346 380.806824,95.102257
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M401.380035,125.951851
	C401.379120,124.919884 401.736938,123.830734 402.092224,122.390640
	C402.089722,122.039703 402.312103,121.806000 402.605743,121.531525
	C403.387115,120.931656 403.874847,120.606255 404.362579,120.280853
	C403.487946,122.152122 402.613342,124.023392 401.380035,125.951851
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M483.553070,128.447052
	C482.107849,129.415726 480.662628,130.384399 479.068146,131.650024
	C478.493164,132.013168 478.067413,132.079346 477.323425,132.087189
	C477.003143,131.599350 477.001099,131.169861 477.332397,130.364746
	C478.454254,129.340866 479.242828,128.692627 480.031372,128.044373
	C480.031372,128.044373 480.022278,128.007919 480.474823,128.036102
	C481.802612,128.191864 482.677826,128.319443 483.553070,128.447052
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M518.774292,264.271057
	C519.492432,264.890625 520.033997,265.788605 520.846619,266.867188
	C520.516235,267.493469 519.914795,267.939178 519.313293,268.384888
	C519.074707,267.106415 518.836182,265.827942 518.774292,264.271057
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M346.692017,260.392365
	C346.747314,261.243683 346.571899,261.850189 346.258728,262.914307
	C345.178711,262.705200 344.236450,262.038483 343.294159,261.371796
	C344.349884,260.963715 345.405579,260.555634 346.692017,260.392365
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M371.655518,447.714111
	C371.263489,446.137177 371.016113,444.122986 371.071472,441.965363
	C371.516266,443.640228 371.658234,445.458557 371.655518,447.714111
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M33.256268,146.106384
	C32.414650,143.875229 31.843468,141.747391 31.394596,139.270111
	C32.561401,141.183960 33.605896,143.447235 34.633881,146.094727
	C34.253815,146.389206 33.890259,146.299454 33.256268,146.106384
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M373.447632,138.959442
	C374.291687,140.586212 374.830139,142.273880 375.342712,144.342712
	C371.514160,143.996277 373.428741,141.088623 373.447632,138.959442
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M121.622078,138.987610
	C122.742928,139.643784 123.600441,140.229233 124.751709,140.976105
	C122.940704,143.458603 122.940704,143.458603 120.238998,139.045410
	C120.663719,138.767242 121.011238,138.842072 121.622078,138.987610
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M210.347778,128.342590
	C210.697784,129.034851 210.892883,129.718735 210.953461,130.735336
	C209.488495,130.745178 208.158081,130.422287 206.499573,129.792786
	C206.528046,129.033386 206.884583,128.580612 207.241135,128.127838
	C207.241135,128.127838 207.639282,128.167343 208.140015,128.177414
	C209.084167,128.164047 209.527603,128.140610 209.971039,128.117172
	C209.971039,128.117172 210.192841,128.334183 210.347778,128.342590
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M93.727348,388.972900
	C91.994949,388.771149 90.032875,388.297882 87.989685,387.501465
	C89.771599,387.686005 91.634636,388.193665 93.727348,388.972900
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M381.076172,155.185150
	C382.625092,155.721207 384.148102,156.607468 385.828125,157.783707
	C384.340179,157.227585 382.695221,156.381485 381.076172,155.185150
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M222.823669,150.753998
	C223.796188,149.213577 225.142776,147.770905 226.816254,146.293671
	C225.828003,147.789978 224.512863,149.320847 222.823669,150.753998
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M446.702972,370.232849
	C445.673981,371.498047 444.325134,372.767303 442.639404,374.037903
	C443.662750,372.771790 445.022919,371.504364 446.702972,370.232849
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M144.928162,111.678925
	C143.665359,111.611481 142.339447,111.191856 140.986069,110.441711
	C142.260757,110.516365 143.562897,110.921555 144.928162,111.678925
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M131.588058,121.583878
	C131.588058,121.583885 131.910751,121.520653 132.242355,121.512848
	C132.573959,121.505043 133.035019,121.513451 133.035019,121.513451
	C131.619110,122.691475 130.203201,123.869499 128.528931,124.777885
	C128.546066,124.038200 128.821548,123.568146 129.097015,123.098091
	C129.097015,123.098091 129.004395,122.999733 129.363632,123.067154
	C130.344589,122.617668 130.966324,122.100777 131.588058,121.583878
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M450.895203,130.104874
	C451.194244,130.570663 451.493286,131.036469 451.856506,131.774506
	C450.270386,131.268143 448.620087,130.489563 446.972015,129.416534
	C446.979858,128.945084 446.985474,128.768112 447.198303,128.473114
	C447.688751,128.526520 447.995819,128.618225 448.488281,128.900055
	C449.404388,129.483856 450.158875,129.797821 450.925110,130.099808
	C450.936890,130.087830 450.895203,130.104874 450.895203,130.104874
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M234.460129,443.839417
	C235.057388,445.614960 235.378418,447.519836 235.480499,449.689819
	C234.902328,447.959564 234.543121,445.964172 234.460129,443.839417
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M82.631920,381.843811
	C81.613304,381.215851 80.653862,380.258240 79.383911,378.806885
	C78.967621,377.936707 78.861832,377.560242 78.913406,377.060699
	C79.070778,376.937653 79.385780,376.691895 79.385780,376.691895
	C80.487549,378.299316 81.589317,379.906738 82.631920,381.843811
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M425.941528,64.055222
	C424.426147,64.664688 422.910767,65.274162 421.038818,65.828842
	C422.186707,64.492973 423.691193,63.211903 425.533264,61.873894
	C425.943024,62.284832 426.015167,62.752705 426.045227,63.607925
	C426.003174,63.995270 425.941528,64.055229 425.941528,64.055222
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M465.141724,143.368561
	C465.538788,143.809448 465.695312,144.144409 465.902924,144.752853
	C464.290863,145.044800 462.627716,145.063263 460.504150,144.800873
	C460.017212,144.341019 459.990662,144.162003 459.964111,143.983002
	C460.295532,143.911209 460.572296,143.747177 461.298920,143.281982
	C462.557220,142.925293 463.311035,142.777542 464.064850,142.629822
	C464.343628,142.840759 464.622406,143.051697 465.141724,143.368561
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M167.907532,82.728867
	C166.841873,81.268181 165.886734,79.477150 165.253067,77.414818
	C166.005417,77.511612 166.436325,77.879707 166.867218,78.247803
	C166.867218,78.247803 166.880890,78.651291 166.958511,79.115738
	C167.350998,80.055771 167.665878,80.531357 167.980743,81.006950
	C167.993195,81.470810 168.005630,81.934669 167.907532,82.728867
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M389.932617,438.385742
	C390.609100,437.487488 391.295105,436.933136 392.117615,436.035217
	C392.412292,436.929596 392.570496,438.167603 392.728729,439.405579
	C391.799866,439.180237 390.871002,438.954895 389.932617,438.385742
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M416.744751,429.176331
	C417.088104,430.232178 417.101654,431.145966 417.120148,432.403198
	C416.185608,431.982819 415.246094,431.219025 414.306610,430.455231
	C415.009399,429.981567 415.712189,429.507935 416.744751,429.176331
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M33.706226,263.283173
	C32.992973,262.706329 32.611496,262.123016 32.113758,261.211334
	C33.115707,260.834991 34.233913,260.787048 35.352119,260.739105
	C34.914085,261.584991 34.476044,262.430847 33.706226,263.283173
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M72.995148,460.587372
	C73.052032,459.739044 73.127144,459.172760 73.233765,458.178040
	C74.034882,458.503235 74.804482,459.256927 75.574081,460.010651
	C74.720512,460.296936 73.866951,460.583191 72.995148,460.587372
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M165.011307,98.705856
	C164.475021,98.467209 164.013962,97.844017 163.329773,97.022606
	C163.106644,96.824394 163.123184,96.393417 163.044037,95.831787
	C162.642227,94.328323 162.319580,93.386490 161.996933,92.444664
	C163.026794,94.403542 164.056671,96.362427 165.011307,98.705856
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M389.200348,158.305664
	C390.393829,156.999374 391.777496,155.949493 393.474945,154.789368
	C392.322662,155.973434 390.856598,157.267761 389.200348,158.305664
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M347.548157,125.886551
	C346.782684,127.831535 345.686096,129.879623 344.226227,131.930176
	C344.980988,129.951630 346.098999,127.970634 347.548157,125.886551
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M487.259766,153.411621
	C488.470581,152.465286 489.904816,151.773758 491.693573,151.107956
	C490.526428,151.977921 489.004822,152.822159 487.259766,153.411621
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M47.266182,136.108932
	C47.266182,136.108932 46.815434,136.282516 46.574734,136.264069
	C46.606895,134.526199 46.879757,132.806793 47.584785,131.048279
	C48.016953,131.009155 48.297749,131.242310 48.247063,131.598236
	C47.886311,133.339096 47.576244,134.724014 47.266182,136.108932
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M520.907471,109.764633
	C519.561707,110.095169 518.183777,110.057411 516.391968,109.979050
	C517.300842,106.960617 519.019165,107.555656 520.907471,109.764633
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M96.481560,133.535339
	C96.826004,133.383041 97.170448,133.230743 97.796341,133.047119
	C97.911743,134.311615 97.745689,135.607422 97.240829,136.914490
	C96.791458,136.140625 96.680885,135.355453 96.537384,134.180115
	C96.504463,133.789948 96.481560,133.535339 96.481560,133.535339
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M133.424927,121.416672
	C133.035019,121.513451 132.573959,121.505043 132.366455,121.404999
	C133.691757,120.608292 135.224548,119.911636 137.175705,119.401360
	C137.433121,119.880829 137.272171,120.173904 137.050674,120.712875
	C135.931686,121.079140 134.873245,121.199516 133.424927,121.416672
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M175.645508,117.257767
	C176.084885,117.028793 176.264420,117.030800 176.712891,117.019211
	C177.036316,118.429909 177.090805,119.854218 176.965454,121.669258
	C176.318954,120.536240 175.852295,119.012489 175.645508,117.257767
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M39.976246,146.495697
	C40.139046,147.126480 39.834404,147.571609 38.914398,148.109329
	C37.499676,148.285141 36.700321,148.368362 35.900967,148.451599
	C35.493999,148.042435 35.087032,147.633270 34.622849,146.941208
	C36.213356,146.542221 37.861080,146.426132 39.976246,146.495697
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M450.913666,434.287994
	C451.293549,435.509766 451.475159,436.994751 451.421814,438.722870
	C451.029724,437.494385 450.872589,436.022827 450.913666,434.287994
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M40.771034,406.379944
	C39.443905,406.367950 37.732803,406.260712 35.924797,405.853882
	C37.347610,405.797760 38.867332,406.041260 40.771034,406.379944
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M498.228455,84.057709
	C498.816833,85.249268 499.296204,86.833923 499.650696,88.800011
	C499.056976,87.604568 498.588196,86.027695 498.228455,84.057709
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M551.795837,429.186432
	C552.115723,430.234528 552.129578,431.130768 552.124634,432.363342
	C551.255798,431.928955 550.405701,431.158203 549.555603,430.387390
	C550.200317,429.936462 550.845032,429.485504 551.795837,429.186432
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M450.782501,428.929688
	C450.675110,429.905792 450.364441,430.688660 449.979248,431.785950
	C449.146393,431.275970 448.388123,430.451538 447.629852,429.627075
	C448.612976,429.330231 449.596100,429.033386 450.782501,428.929688
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M482.964264,112.603409
	C481.271973,112.353516 479.533112,111.733017 477.594788,110.834038
	C479.236115,111.114639 481.076904,111.673721 482.964264,112.603409
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M280.656433,389.340118
	C279.423889,389.701050 277.788940,389.890839 276.047729,389.772278
	C277.378998,389.365601 278.816528,389.267303 280.656433,389.340118
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M218.161682,141.200851
	C218.140366,140.643707 218.293777,140.336304 218.592468,139.810211
	C219.621536,139.424789 220.505325,139.258057 221.725616,139.147156
	C220.820221,139.952179 219.578308,140.701385 218.161682,141.200851
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M212.441132,152.925995
	C211.889038,152.554901 211.757446,152.212051 211.518646,151.607239
	C213.095734,151.374863 214.780045,151.404465 216.740906,152.026230
	C217.032608,152.808624 217.047760,152.998871 217.062927,153.189117
	C215.662491,153.110825 214.262054,153.032547 212.441132,152.925995
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M501.049805,187.586670
	C499.557831,187.621964 497.872742,187.355194 496.073303,186.741028
	C497.591553,186.690613 499.224091,186.987625 501.049805,187.586670
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M75.115860,119.544586
	C74.558495,119.360664 74.052582,118.797554 73.300415,118.076042
	C72.644363,116.854996 72.234558,115.792343 71.872772,114.387619
	C73.002968,115.752151 74.085136,117.458778 75.115860,119.544586
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M186.013031,139.624054
	C186.461014,139.902405 186.672333,140.179764 186.947113,140.710754
	C185.679062,140.571716 184.347565,140.179062 183.314453,139.429626
	C184.059631,139.108231 184.506424,139.143631 184.953201,139.179031
	C185.171143,139.431824 185.445526,139.579849 186.013031,139.624054
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M45.436485,249.179550
	C44.506706,248.577011 43.898312,248.000580 43.132900,247.147034
	C44.119926,247.007874 45.263966,247.145798 46.408012,247.283737
	C46.191299,247.924377 45.974586,248.565018 45.436485,249.179550
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M255.013046,110.404922
	C256.489685,110.095604 258.031036,110.132408 259.907013,110.221443
	C258.520325,110.432800 256.799072,110.591927 255.013046,110.404922
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M513.496826,74.175217
	C513.080261,72.867012 512.990845,71.474876 512.907959,69.666016
	C513.217712,70.863297 513.520874,72.477287 513.496826,74.175217
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M170.796310,91.770576
	C170.606247,91.058327 170.416183,90.346077 170.302643,89.314575
	C170.548111,88.987595 170.717056,88.979874 170.885986,88.972153
	C171.442429,89.842422 171.998871,90.712700 172.084503,91.759880
	C171.372787,91.726265 171.100327,91.670860 170.796310,91.770576
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M157.354614,78.646317
	C157.447678,79.287949 157.540756,79.929581 157.527939,80.877441
	C156.800583,80.233360 156.179123,79.283058 156.051544,78.233162
	C156.764679,78.384117 157.034393,78.555038 157.354614,78.646317
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M303.421387,234.803986
	C302.669464,233.880203 302.034210,232.639664 301.616333,231.221451
	C302.401855,232.191589 302.969940,233.339386 303.421387,234.803986
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M122.897934,101.557693
	C123.887650,101.933533 124.876587,102.655632 125.826523,103.757866
	C124.824074,103.393326 123.860611,102.648643 122.897934,101.557693
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M584.954956,321.219147
	C583.783203,322.232300 582.245239,323.147491 580.353882,324.028809
	C581.529846,323.037018 583.059326,322.079071 584.954956,321.219147
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M496.026825,41.793915
	C497.213745,40.784866 498.769073,39.878372 500.678802,39.016418
	C499.487213,40.006134 497.941223,40.951302 496.026825,41.793915
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M424.033386,405.359497
	C422.558746,405.686890 420.732300,405.899994 418.753571,405.789978
	C420.294708,405.392975 421.988129,405.319092 424.033386,405.359497
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M119.173805,457.392273
	C117.836884,457.114868 116.326195,456.561646 114.826668,455.627686
	C116.225235,455.870117 117.612633,456.493256 119.173805,457.392273
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M404.793762,130.585510
	C405.134064,129.181610 405.757629,127.645706 406.753143,126.415985
	C407.086334,127.149727 407.047577,127.577286 407.008850,128.004837
	C406.364929,128.821060 405.720978,129.637283 404.793762,130.585510
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M329.211700,196.927704
	C328.602631,196.506027 328.329895,196.043381 328.078979,195.293213
	C329.390381,195.722641 330.679962,196.439590 332.007080,197.502472
	C331.212433,197.527847 330.380249,197.207291 329.211700,196.927704
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M82.313141,153.142303
	C82.044067,152.528854 82.040718,152.077301 82.102219,151.291840
	C83.352615,152.237625 84.538170,153.517334 85.591087,155.134918
	C84.498589,154.749924 83.538719,154.027039 82.313141,153.142303
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M142.129761,53.363029
	C140.898056,54.363373 139.299637,55.212101 137.347595,56.025440
	C138.583664,55.063839 140.173370,54.137623 142.129761,53.363029
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M76.235062,373.906494
	C76.170013,373.441040 76.104965,372.975586 76.118919,372.166077
	C77.219513,373.217621 78.241104,374.613190 79.324234,376.350342
	C79.385780,376.691895 79.070778,376.937653 78.718323,376.833527
	C77.655594,375.788422 76.945328,374.847473 76.235062,373.906494
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M172.224350,133.835083
	C171.666458,133.873581 171.367477,133.734451 170.843491,133.479523
	C170.618484,133.363739 170.613724,133.047607 170.553986,132.726837
	C170.494247,132.406082 170.227570,132.058304 170.227570,132.058304
	C170.227570,132.058304 170.388992,131.713959 170.340759,131.530640
	C170.292511,131.347321 170.741653,131.165237 170.974380,131.097534
	C171.632492,131.905716 172.057877,132.781586 172.224350,133.835083
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M360.453156,432.157074
	C360.032532,431.402679 359.970764,430.669647 359.904846,429.568695
	C360.814148,429.458862 361.727570,429.716980 362.640961,429.975098
	C362.031281,430.709534 361.421631,431.444000 360.453156,432.157074
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M301.918884,51.125988
	C302.342468,52.179356 302.766052,53.232723 303.130737,54.625427
	C302.040833,53.512859 301.009827,52.060951 300.295349,50.344757
	C301.047516,50.428974 301.483215,50.777481 301.918884,51.125988
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M120.199448,135.790405
	C120.048164,134.429184 120.193886,132.828156 120.661545,131.097610
	C120.821144,132.495590 120.658798,134.023102 120.199448,135.790405
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M475.879608,50.621384
	C477.131744,49.655285 478.746735,48.828789 480.714539,48.069286
	C479.459045,49.011181 477.850769,49.886082 475.879608,50.621384
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M453.217957,110.404739
	C452.295898,111.070709 450.986053,111.559860 449.317261,111.962250
	C450.248901,111.326294 451.539520,110.777107 453.217957,110.404739
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M574.751099,90.432526
	C575.999207,90.790466 577.451233,91.413307 579.008911,92.364273
	C577.728088,92.027397 576.341492,91.362404 574.751099,90.432526
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M98.876534,130.068008
	C98.469429,129.028366 98.328331,127.841362 98.346420,126.227600
	C98.717918,127.174118 98.930229,128.547394 98.876534,130.068008
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M414.769104,47.210793
	C414.229584,48.411564 413.366150,49.649757 412.158081,50.867630
	C412.690674,49.647606 413.567932,48.447906 414.769104,47.210793
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M319.023865,78.953819
	C319.419617,79.710197 319.815399,80.466583 320.231201,81.544067
	C319.168213,80.785194 318.085175,79.705223 317.318573,78.329735
	C318.097992,78.340759 318.560913,78.647293 319.023865,78.953819
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M260.325134,452.246002
	C260.527771,450.883789 260.957306,449.624634 261.671204,448.189484
	C261.710297,449.269836 261.464966,450.526215 261.133362,452.095062
	C261.047058,452.407562 260.552063,452.349060 260.325134,452.246002
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M352.821564,429.161316
	C353.112091,429.985199 353.091400,430.678589 353.016479,431.715271
	C352.186401,431.435120 351.410522,430.811646 350.634644,430.188171
	C351.259888,429.802368 351.885101,429.416595 352.821564,429.161316
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M499.362915,432.821167
	C498.500305,432.042725 497.785461,431.020050 497.009216,429.684937
	C497.802124,430.440643 498.656403,431.508789 499.362915,432.821167
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M329.994537,93.011078
	C330.125946,93.409401 330.257355,93.807724 330.353699,94.519073
	C329.188721,93.862915 328.058777,92.893723 326.988464,91.446243
	C327.048065,90.967964 327.301514,90.736221 327.562561,90.891800
	C328.547272,91.701942 329.270905,92.356514 329.994537,93.011078
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M125.942032,104.494446
	C127.043266,103.840500 128.197556,103.489540 129.712814,103.147720
	C128.714218,103.703720 127.354652,104.250580 125.942032,104.494446
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M237.543030,434.929749
	C237.304367,436.223877 236.740921,437.603027 235.872696,439.086853
	C236.118011,437.799286 236.668106,436.407043 237.543030,434.929749
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M166.756897,109.403976
	C166.731888,108.846306 166.836838,108.657509 167.113235,108.193665
	C167.496872,109.266922 167.709076,110.615234 167.595154,112.018585
	C167.141663,111.306702 167.014267,110.539780 166.756897,109.403976
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M428.688904,284.186218
	C428.305298,283.096802 428.216888,281.873352 428.209167,280.194702
	C428.521332,281.177063 428.752747,282.614655 428.688904,284.186218
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M26.784641,429.231354
	C27.158155,430.105042 27.178740,430.893921 27.222988,431.977570
	C26.520226,431.926453 25.793797,431.580597 25.067371,431.234741
	C25.522150,430.538696 25.976931,429.842621 26.784641,429.231354
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M296.534058,243.220306
	C296.763824,244.218918 296.877716,245.550766 296.630615,246.956024
	C296.319153,245.870819 296.368652,244.712189 296.534058,243.220306
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M555.221008,249.308990
	C556.176636,248.941971 557.389587,248.741821 558.812012,248.812271
	C557.840454,249.213882 556.659424,249.344864 555.221008,249.308990
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M507.909302,64.777679
	C506.870697,65.104286 505.810211,65.080490 504.356689,64.984879
	C504.958160,62.219639 506.318420,62.480324 507.909302,64.777679
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M446.641724,151.803589
	C447.401001,151.721832 447.858734,151.789444 448.659607,151.930542
	C447.832825,152.559601 446.662964,153.115158 445.274658,153.416138
	C445.039520,152.970749 445.022827,152.779953 445.006592,152.301865
	C445.451385,151.994034 445.895782,151.973511 446.641724,151.803589
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M408.638428,372.004333
	C408.822052,373.157379 408.671997,374.330505 408.266907,375.752289
	C408.109497,374.675446 408.207123,373.349884 408.638428,372.004333
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M128.722137,123.044724
	C128.821548,123.568146 128.546066,124.038200 128.171936,124.768158
	C127.309563,125.413254 126.545845,125.798439 125.458855,126.171471
	C126.206139,125.103333 127.276703,124.047348 128.722137,123.044724
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M316.667908,389.355347
	C315.750854,389.713348 314.443115,389.900909 313.038239,389.799805
	C314.053162,389.402344 315.165192,389.293610 316.667908,389.355347
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M509.114685,116.770309
	C508.843414,117.033073 508.668610,117.031837 508.234344,116.992371
	C508.568909,115.931976 509.162903,114.909805 510.083649,113.861618
	C510.470825,114.007690 510.531250,114.179779 510.644775,114.620071
	C510.611908,115.048569 510.525970,115.208862 510.582794,115.665024
	C510.725586,115.960892 510.610321,115.923851 510.610321,115.923843
	C510.143921,116.117996 509.677551,116.312149 509.114685,116.770309
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M488.340454,125.945732
	C488.599304,124.559097 489.226959,123.138779 490.141632,121.548859
	C489.855499,122.890190 489.282379,124.401115 488.340454,125.945732
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M30.356419,153.038696
	C29.705990,151.869705 29.314447,150.786911 28.945927,149.354813
	C29.927301,150.214508 30.885653,151.423538 31.746944,152.995987
	C31.305027,153.281250 30.960165,153.203079 30.356419,153.038696
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M487.667786,388.111786
	C486.870789,388.703735 485.724121,389.220001 484.342926,389.516357
	C485.178314,388.876343 486.248230,388.456238 487.667786,388.111786
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M529.183044,460.477173
	C529.249695,459.682617 529.520264,459.122467 529.902405,458.269104
	C530.558838,458.519073 531.103760,459.062286 531.648621,459.605469
	C530.894775,459.974182 530.140869,460.342865 529.183044,460.477173
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M455.311523,385.935730
	C456.337097,386.809021 457.237518,388.040375 458.101227,389.613892
	C457.105133,388.735291 456.145752,387.514526 455.311523,385.935730
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M366.373901,122.970543
	C365.447235,122.194389 364.660736,121.180740 364.117401,119.799950
	C364.360596,119.432800 364.747742,119.288155 364.747742,119.288155
	C364.747742,119.288155 365.003540,119.146347 364.898163,119.511780
	C365.349640,120.461349 365.906464,121.045502 366.463318,121.629646
	C366.480225,121.997444 366.497131,122.365250 366.373901,122.970543
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M586.676147,373.085022
	C585.951172,373.018829 585.344971,372.608398 584.456787,371.715210
	C584.134705,370.809509 584.094604,370.386597 584.054443,369.963715
	C584.967896,370.889435 585.881409,371.815125 586.676147,373.085022
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M350.313507,117.797028
	C350.732971,118.716248 351.011627,120.090805 350.918579,121.765099
	C350.370483,122.053757 350.194031,122.042679 350.017609,122.031609
	C350.069305,120.771858 350.121002,119.512108 350.313507,117.797028
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M44.891949,141.844482
	C44.325020,142.917267 43.758095,143.990067 42.877983,144.877869
	C42.564793,144.692871 42.411755,144.358459 42.411755,144.358459
	C42.411755,144.358459 42.649288,143.975708 42.976616,143.650177
	C43.833279,142.831268 44.362614,142.337875 44.891949,141.844482
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M90.394424,430.931580
	C89.711227,430.394684 89.402931,429.877686 88.967407,429.085266
	C89.972954,428.770966 91.105713,428.732056 92.655121,428.781372
	C93.047127,429.349426 93.022484,429.829315 93.009384,430.669434
	C92.270393,431.003571 91.519859,430.977478 90.394424,430.931580
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M152.892181,140.785202
	C153.397873,139.735062 154.286591,138.758926 155.515656,137.758331
	C154.995728,138.775650 154.135468,139.817429 152.892181,140.785202
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M52.927803,188.135620
	C52.934959,188.961731 52.683739,189.890686 52.150749,190.917511
	C52.135799,190.089737 52.402615,189.164093 52.927803,188.135620
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M515.088379,457.887573
	C515.607117,458.280212 516.125916,458.672882 516.644653,459.065552
	C515.875732,459.587585 515.106812,460.109619 514.254456,460.093201
	C514.476807,458.999023 514.782593,458.443298 515.088379,457.887573
z"/>
<path fill="#424566" opacity="1.000000" stroke="none"
	d="
M504.875061,190.697876
	C503.923767,190.290833 502.979309,189.562546 502.003723,188.515106
	C502.942352,188.922836 503.912140,189.649719 504.875061,190.697876
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M261.671509,108.158859
	C260.886719,107.566345 260.384491,106.874397 259.805908,105.873566
	C262.203735,104.851242 262.886383,105.735321 261.671509,108.158859
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M265.428009,75.700981
	C265.176208,76.741066 264.605560,77.872643 263.696960,79.056305
	C263.942383,78.003082 264.525787,76.897781 265.428009,75.700981
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M409.039795,112.369293
	C408.672180,113.457314 407.932281,114.421249 406.882812,115.424088
	C407.271362,114.390388 407.969421,113.317795 409.039795,112.369293
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M407.367828,127.980148
	C407.047577,127.577286 407.086334,127.149727 407.133179,126.396317
	C407.765228,125.592209 408.389191,125.113968 409.309692,124.631363
	C408.979736,125.736488 408.353271,126.845978 407.367828,127.980148
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M564.296692,448.214996
	C565.209656,448.797272 566.077087,449.697723 566.882629,450.933960
	C565.964172,450.357574 565.107666,449.445374 564.296692,448.214996
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M260.270233,240.638245
	C259.962921,241.633881 259.382751,242.799911 258.438599,244.001282
	C258.715515,242.960617 259.356445,241.884628 260.270233,240.638245
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M286.466431,287.729706
	C286.592102,288.295135 286.400879,288.931885 286.104614,289.892822
	C285.384216,290.039032 284.768860,289.861053 284.153503,289.683075
	C284.818848,289.055725 285.484222,288.428345 286.466431,287.729706
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M103.418076,138.764374
	C103.077728,139.818817 102.392342,140.895874 101.347862,141.982956
	C101.683533,140.924301 102.378288,139.855652 103.418076,138.764374
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M564.701782,439.779572
	C563.807800,439.203125 562.934753,438.309113 562.117188,437.076843
	C563.022644,437.646393 563.872620,438.554199 564.701782,439.779572
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M170.484772,91.850006
	C171.100327,91.670860 171.372787,91.726265 171.829041,91.964813
	C172.068085,92.444145 172.091782,92.895439 172.260132,93.656654
	C172.297256,94.154701 172.189743,94.342827 171.906616,94.804543
	C171.211746,94.028557 170.692490,92.978989 170.484772,91.850006
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M526.515381,451.858582
	C525.938110,451.239532 525.506653,450.304688 525.160461,449.037537
	C525.717529,449.651062 526.189331,450.596893 526.515381,451.858582
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M142.635986,94.387726
	C143.008804,93.359474 143.477600,92.682762 144.247284,91.922852
	C144.538773,92.782028 144.529404,93.724396 143.940735,94.931267
	C143.203476,95.280937 143.045517,95.366104 142.887558,95.451279
	C142.835693,95.213943 142.783813,94.976608 142.635986,94.387726
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M33.987076,452.757874
	C33.652138,452.106079 33.510078,451.259399 33.583595,450.232178
	C33.926098,450.888763 34.053032,451.725861 33.987076,452.757874
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M176.115509,38.357887
	C175.546066,39.055824 174.613571,39.598236 173.347198,40.083214
	C173.926376,39.417976 174.839417,38.810173 176.115509,38.357887
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M499.749512,92.182236
	C500.310638,92.821762 500.626068,93.641632 500.828308,94.795761
	C500.311371,94.207542 499.907623,93.285057 499.749512,92.182236
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M495.818237,456.316101
	C495.612885,457.205048 495.126556,458.080048 494.311371,458.969666
	C493.982544,458.984253 494.003204,459.004639 493.975922,458.689697
	C493.947968,458.156433 493.947296,457.938110 493.946655,457.719788
	C494.476868,457.247253 495.007080,456.774719 495.818237,456.316101
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M487.091064,38.331299
	C486.527985,39.036949 485.603546,39.592350 484.344849,40.083874
	C484.916931,39.407013 485.823303,38.794033 487.091064,38.331299
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M527.561401,438.196289
	C527.198364,437.430176 527.096802,436.537811 527.098633,435.204224
	C527.408997,435.865356 527.615967,436.967682 527.561401,438.196289
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M501.006165,452.721558
	C500.199646,453.284149 499.442200,453.558594 498.394165,453.923706
	C499.087433,453.487396 500.071320,452.960388 501.006165,452.721558
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M67.645203,443.932922
	C67.014671,443.320221 66.525078,442.381927 66.153564,441.114502
	C66.776474,441.726013 67.281296,442.666687 67.645203,443.932922
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M464.595428,442.195496
	C464.159393,441.530182 463.987427,440.724213 463.876953,439.507690
	C464.245422,440.083038 464.552460,441.068939 464.595428,442.195496
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M217.263733,153.429565
	C217.047760,152.998871 217.032608,152.808624 217.017059,152.332153
	C217.764648,151.983170 218.512665,151.920441 219.630493,151.930450
	C219.155045,152.558807 218.309784,153.114410 217.263733,153.429565
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M335.004761,145.619598
	C334.374207,145.186935 333.730255,144.413864 333.118622,143.283813
	C333.764404,143.710968 334.377899,144.495087 335.004761,145.619598
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M594.063232,317.336884
	C593.496948,318.028473 592.577393,318.577698 591.327026,319.057190
	C591.900696,318.389801 592.805359,317.792145 594.063232,317.336884
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M228.118927,290.234497
	C228.869370,289.933929 229.595840,289.955292 230.684906,290.007141
	C230.063309,290.210541 229.079132,290.383484 228.118927,290.234497
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M457.850830,58.578217
	C458.454041,57.898758 459.410187,57.391899 460.694977,56.965752
	C460.083679,57.614582 459.143707,58.182701 457.850830,58.578217
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M424.981232,142.297211
	C425.486053,142.276443 425.944061,142.596832 426.675598,143.007202
	C426.973663,143.425262 427.116669,143.689163 427.514343,144.237457
	C427.650482,144.586044 427.468536,145.045837 427.468536,145.045837
	C426.623810,144.243362 425.779083,143.440872 424.981232,142.297211
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M542.689331,389.038696
	C541.954346,389.109283 541.003845,388.932739 540.020996,388.453644
	C540.817078,388.364594 541.645447,388.578064 542.689331,389.038696
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M474.706909,389.007812
	C473.961792,389.105713 473.009644,388.944458 472.020630,388.482361
	C472.822449,388.370575 473.661133,388.559631 474.706909,389.007812
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M598.765198,315.567566
	C598.216125,316.248993 597.460571,316.703552 596.362183,317.093079
	C596.865784,316.465607 597.712280,315.903168 598.765198,315.567566
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M354.285583,290.531128
	C353.985413,289.895081 353.908203,289.449310 353.756042,288.671021
	C354.373779,288.602966 355.066437,288.867432 355.759155,289.131866
	C355.342285,289.661713 354.925415,290.191559 354.285583,290.531128
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M127.674019,381.997253
	C128.028610,382.063232 128.064835,382.536713 128.032730,382.772003
	C126.850883,383.342468 125.701134,383.677643 124.198914,383.930176
	C125.004105,383.208740 126.161766,382.570007 127.674019,381.997253
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M394.728210,137.112518
	C394.779266,138.099121 394.440521,139.148819 393.827576,140.400940
	C393.815033,139.460770 394.076721,138.318176 394.728210,137.112518
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M188.925537,54.826271
	C189.684174,54.500237 190.562866,54.453983 191.728119,54.576603
	C191.024979,54.865669 190.035278,54.985867 188.925537,54.826271
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M557.764282,430.758118
	C556.876465,430.742065 555.951721,430.388824 554.955078,429.737640
	C555.831177,429.766785 556.779236,430.093872 557.764282,430.758118
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M365.377686,269.980652
	C365.243286,269.153656 365.419678,268.280487 365.878235,267.219238
	C366.003113,267.998932 365.845825,268.966705 365.377686,269.980652
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M161.069077,87.980423
	C161.175476,88.727051 161.281876,89.473671 161.300674,90.588020
	C160.606903,90.120407 160.000748,89.285065 159.937988,88.226746
	C160.677277,87.995995 160.873169,87.988213 161.069077,87.980423
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M170.746338,88.786728
	C170.717056,88.979874 170.548111,88.987595 170.125519,88.990402
	C169.428665,88.418304 168.985443,87.851112 169.059128,87.191330
	C169.893890,87.296967 170.211746,87.495193 170.529602,87.693420
	C170.430664,88.006630 170.456360,88.309250 170.746338,88.786728
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M384.055603,431.716064
	C383.981476,430.909607 383.994995,430.353485 384.012726,429.380554
	C384.704956,429.094574 385.392975,429.225433 386.169006,429.612488
	C386.139160,430.304779 386.021393,430.740845 385.744385,431.835876
	C385.104523,432.318695 384.623901,432.142548 384.055603,431.716064
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M333.757843,429.112091
	C334.076050,429.941437 334.062347,430.658020 333.997864,431.729980
	C333.773376,431.056671 333.599640,430.028015 333.757843,429.112091
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M155.914429,54.692474
	C156.475143,53.994553 157.400162,53.434566 158.660980,52.933449
	C158.090759,53.605019 157.184738,54.217716 155.914429,54.692474
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M352.529724,279.065369
	C352.364594,278.241608 352.535156,277.374817 352.705719,276.508057
	C353.188141,277.045776 353.670563,277.583496 354.175537,278.462463
	C353.753876,278.876617 353.309631,278.949493 352.529724,279.065369
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M135.118378,56.359428
	C134.551407,57.056477 133.620895,57.606167 132.354248,58.095585
	C132.930359,57.427570 133.842606,56.819824 135.118378,56.359428
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M44.920570,141.633896
	C44.362614,142.337875 43.833279,142.831268 43.059143,143.440628
	C43.268112,142.384033 43.721874,141.211456 44.489189,139.795746
	C44.802742,139.552612 44.869438,139.513733 44.944916,139.897400
	C45.065269,140.537857 45.110153,140.794632 45.155033,141.051422
	C45.155033,141.051422 44.949192,141.423309 44.920570,141.633896
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M170.667969,87.285492
	C170.211746,87.495193 169.893890,87.296967 169.298706,87.047562
	C168.908813,86.267059 168.796265,85.537727 168.748810,84.444244
	C169.478058,85.012573 170.142197,85.945068 170.667969,87.285492
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M159.405762,83.611053
	C159.423355,83.960876 159.440948,84.310699 159.313690,84.879181
	C158.612808,84.500381 158.056778,83.902924 157.980988,83.216087
	C158.776047,83.288155 159.090912,83.449608 159.405762,83.611053
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M382.175629,428.499176
	C381.393036,428.837463 380.476227,428.921082 379.113892,428.867310
	C379.792694,428.568115 380.917053,428.406311 382.175629,428.499176
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M432.096680,135.463898
	C432.084778,135.828705 431.625519,135.911255 431.395294,135.873795
	C430.727020,134.795441 430.288971,133.754547 429.885437,132.372986
	C430.649506,133.054581 431.379059,134.076828 432.096680,135.463898
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M440.019409,127.317947
	C440.868774,127.175041 441.731598,127.357857 442.787720,127.813766
	C441.998322,127.939125 441.015594,127.791389 440.019409,127.317947
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M293.133789,233.276550
	C293.752441,233.904694 294.288940,234.865097 294.698059,236.192886
	C294.064331,235.576447 293.558014,234.592621 293.133789,233.276550
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M132.111847,110.511230
	C131.568893,111.190887 130.667755,111.690590 129.442505,112.159660
	C129.996796,111.529778 130.875229,110.930519 132.111847,110.511230
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M67.012405,109.583595
	C66.291519,109.978821 65.522545,110.056671 64.372391,110.059166
	C64.982239,109.744614 65.973274,109.505417 67.012405,109.583595
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M210.263916,132.969116
	C210.701187,133.073532 210.849472,133.259781 211.203156,133.738541
	C211.258942,134.499298 211.109314,134.967575 211.012299,135.807556
	C210.895401,136.138153 210.725876,136.097046 210.295746,136.032654
	C210.015060,135.023239 209.994995,134.037094 210.263916,132.969116
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M224.960724,133.185425
	C225.311600,133.586105 225.466537,134.373230 225.382202,135.188141
	C225.016891,134.667892 224.890823,134.119888 224.960724,133.185425
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M342.921509,133.978027
	C342.806519,134.643860 342.691528,135.309692 342.026245,136.002319
	C341.307068,136.021210 341.138184,136.013306 340.969299,136.005402
	C341.109436,135.692856 341.249573,135.380310 341.651611,134.699036
	C342.249512,134.212875 342.585510,134.095444 342.921509,133.978027
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M375.451782,145.903992
	C376.173370,146.409668 376.732513,147.279526 377.271576,148.471390
	C376.597443,147.951645 375.943390,147.109909 375.451782,145.903992
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M454.180786,134.068817
	C456.784637,134.407043 457.012512,135.565857 454.431519,137.118042
	C454.074310,136.237717 454.101776,135.369263 454.180786,134.068817
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M175.377380,105.759193
	C174.854721,105.742317 174.572769,105.532394 174.083771,105.143295
	C173.897003,104.501770 173.917267,104.039436 174.055298,103.250168
	C174.654724,103.804214 175.136383,104.685188 175.377380,105.759193
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M340.677795,136.018219
	C341.138184,136.013306 341.307068,136.021210 341.729309,136.018585
	C341.833130,136.307373 341.683594,136.606689 341.490173,137.153473
	C341.133148,137.574036 340.819977,137.747131 340.240295,137.956192
	C340.111267,137.338455 340.248779,136.684753 340.677795,136.018219
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M40.491539,219.861679
	C40.527126,220.756073 40.277962,221.825409 39.699760,223.001755
	C39.649410,222.084717 39.928097,221.060669 40.491539,219.861679
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M404.415894,120.051163
	C403.874847,120.606255 403.387115,120.931656 402.628479,121.371841
	C402.666931,120.692383 402.976257,119.898155 403.880371,119.057968
	C404.475189,119.012001 404.949585,119.014893 404.949585,119.014893
	C404.727081,119.246613 404.566986,119.515472 404.415894,120.051163
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M432.762817,148.938446
	C433.290405,149.480133 433.586182,149.957718 433.941711,150.717438
	C432.984467,150.371124 431.967438,149.742645 431.185913,148.686371
	C431.589539,148.219971 431.757629,148.181366 431.925751,148.142761
	C432.046844,148.453323 432.248596,148.697189 432.762817,148.938446
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M149.071976,114.443283
	C148.604019,114.518402 148.123230,114.231934 147.360596,113.912720
	C146.739716,113.441780 146.400665,113.003601 146.009918,112.292221
	C146.991852,112.706573 148.025482,113.394135 149.071976,114.443283
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M405.235260,118.997971
	C404.949585,119.014893 404.475189,119.012001 404.238098,119.005165
	C404.231873,118.748367 404.386871,118.457901 404.795471,117.785416
	C405.507111,117.305656 405.889191,117.167419 406.271301,117.029175
	C406.021179,117.679802 405.771057,118.330429 405.235260,118.997971
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M39.575424,234.203888
	C39.478603,233.305161 39.662506,232.220886 40.164429,231.001160
	C40.273682,231.916565 40.064915,232.967453 39.575424,234.203888
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M64.319229,231.183990
	C64.940109,231.792343 65.443169,232.725647 65.831818,233.999481
	C65.212067,233.396332 64.706734,232.452621 64.319229,231.183990
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M364.833923,118.813080
	C364.747742,119.288155 364.360596,119.432800 364.159973,119.482445
	C363.974213,118.252052 363.989044,116.972015 364.345428,115.581497
	C364.764709,116.426682 364.842438,117.382347 364.833923,118.813080
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M51.091682,126.323975
	C51.133190,127.400002 50.894447,128.582703 50.237942,129.475922
	C49.795223,128.748779 49.770267,128.311157 49.745316,127.873520
	C50.100689,127.392570 50.456059,126.911613 51.091682,126.323975
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M45.918030,136.325684
	C46.309639,136.994568 46.303825,137.678513 45.909836,138.834869
	C45.289082,139.396530 45.056499,139.485809 44.830322,139.552795
	C44.836720,139.530487 44.849480,139.576019 44.849480,139.576019
	C45.073189,138.497604 45.296894,137.419189 45.918030,136.325684
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M436.061890,152.402435
	C437.059509,152.306030 438.125366,152.596313 439.400146,153.150085
	C438.449402,153.205429 437.289764,152.997269 436.061890,152.402435
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M95.136765,139.031006
	C95.374985,138.311325 95.613205,137.591660 96.143341,136.840576
	C96.511406,137.201553 96.587570,137.593903 96.373337,138.356201
	C95.767548,138.827759 95.452156,138.929382 95.136765,139.031006
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M352.214447,153.345428
	C352.790192,152.697205 353.557251,152.301590 354.664856,151.960236
	C354.138824,152.542328 353.272278,153.070175 352.214447,153.345428
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M563.194702,249.259628
	C563.879578,248.920563 564.778259,248.758270 565.854919,248.859100
	C565.158142,249.226929 564.283325,249.331665 563.194702,249.259628
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M286.116272,261.153992
	C286.125183,261.688385 286.112366,261.965942 286.034668,262.655243
	C285.469635,262.426025 284.969452,261.785065 284.469299,261.144073
	C285.011047,261.061798 285.552765,260.979492 286.116272,261.153992
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M130.232513,153.381393
	C130.779297,152.704819 131.525162,152.275803 132.610962,151.888550
	C132.111115,152.496536 131.271362,153.062744 130.232513,153.381393
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M477.007202,152.389069
	C477.853394,152.215866 478.732269,152.361191 479.797363,152.791641
	C479.002380,152.953705 478.021149,152.830673 477.007202,152.389069
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M165.884445,113.116516
	C165.762543,114.084534 165.258774,115.051674 164.428040,116.115356
	C164.568237,115.179802 165.035416,114.147728 165.884445,113.116516
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M166.922058,77.890373
	C166.436325,77.879707 166.005417,77.511612 165.311432,77.033096
	C165.048355,76.922668 164.987091,76.468864 164.992722,75.999687
	C165.072449,75.342102 165.146545,75.153702 165.220627,74.965302
	C165.806046,75.821182 166.391464,76.677063 166.922058,77.890373
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M196.026123,149.610413
	C195.469025,149.861191 195.042648,149.909241 194.292633,149.944794
	C194.730850,149.268936 195.492706,148.605591 196.598221,148.218689
	C196.965958,148.665955 196.990036,148.836792 197.014130,149.007614
	C196.674789,149.026184 196.389023,149.159531 196.026123,149.610413
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M206.820068,128.082336
	C206.884583,128.580612 206.528046,129.033386 206.148682,129.774139
	C205.763397,130.248932 205.400970,130.435760 204.741699,130.697571
	C205.096268,129.860641 205.747635,128.948746 206.820068,128.082336
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M314.987610,73.026672
	C315.376282,73.790726 315.764954,74.554794 316.115265,75.640564
	C315.360199,75.236031 314.643524,74.509796 314.202545,73.420944
	C314.648010,73.047783 314.817780,73.037231 314.987610,73.026672
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M315.014984,72.659508
	C314.817780,73.037231 314.648010,73.047783 314.223206,73.064957
	C313.565033,72.288635 313.161957,71.505699 312.789246,70.391907
	C313.560547,70.804810 314.301453,71.548576 315.014984,72.659508
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M319.041901,78.592705
	C318.560913,78.647293 318.097992,78.340759 317.360596,77.949326
	C316.972778,77.472305 316.859344,77.080193 316.793518,76.385208
	C317.580719,76.798752 318.320343,77.515175 319.041901,78.592705
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M301.970398,50.778992
	C301.483215,50.777481 301.047516,50.428974 300.351746,49.969765
	C300.091675,49.859062 300.035553,49.422855 300.025513,48.963924
	C300.084351,48.318794 300.153168,48.132599 300.221954,47.946400
	C300.821960,48.774929 301.421936,49.603462 301.970398,50.778992
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M184.923172,138.810440
	C184.506424,139.143631 184.059631,139.108231 183.277069,139.108612
	C182.604156,138.646805 182.267014,138.149231 181.911163,137.350601
	C182.892685,137.513641 183.892914,137.977737 184.923172,138.810440
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M367.005157,112.827728
	C367.230377,111.939262 367.818268,111.074036 368.729675,110.158447
	C368.491394,111.022385 367.929626,111.936684 367.005157,112.827728
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M148.963089,131.107773
	C148.513428,131.902802 147.659851,132.633652 146.461639,133.376831
	C146.931061,132.607300 147.745117,131.825455 148.963089,131.107773
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M159.290833,133.861298
	C159.504349,132.978012 160.045853,132.035904 160.954941,131.100174
	C160.754639,132.005188 160.186737,132.903839 159.290833,133.861298
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M161.881866,92.346977
	C162.319580,93.386490 162.642227,94.328323 162.938232,95.643860
	C162.334518,95.018585 161.757446,94.019585 161.323181,92.622154
	C161.466003,92.223724 161.766815,92.249290 161.881866,92.346977
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M307.768005,62.446335
	C308.503632,62.958149 309.207611,63.811028 309.819672,65.058365
	C309.063965,64.564354 308.400146,63.675880 307.768005,62.446335
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M349.918243,122.334122
	C350.194031,122.042679 350.370483,122.053757 350.809143,122.104660
	C350.530640,123.064095 349.989899,123.983711 349.089905,124.881165
	C349.093414,124.118217 349.456146,123.377434 349.918243,122.334122
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M216.954956,121.621887
	C217.735580,121.908073 218.516495,122.551529 219.329880,123.517281
	C218.559967,123.219437 217.757614,122.599297 216.954956,121.621887
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M514.900635,457.799500
	C514.782593,458.443298 514.476807,458.999023 514.069092,459.856567
	C513.227173,460.177826 512.487244,460.197266 511.380554,460.162720
	C511.010193,459.940643 511.006592,459.772552 510.934418,459.362335
	C511.786224,458.780212 512.706604,458.440247 513.976746,457.981354
	C514.326538,457.862427 514.712830,457.711426 514.900635,457.799500
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M442.233032,65.713287
	C442.775543,65.045311 443.572113,64.542572 444.724670,64.101700
	C444.216156,64.735214 443.351593,65.306870 442.233032,65.713287
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M49.433540,127.949860
	C49.770267,128.311157 49.795223,128.748779 49.832848,129.518646
	C49.845516,129.850891 49.881550,129.863876 49.634567,129.981735
	C49.024307,130.480499 48.661026,130.861404 48.297749,131.242310
	C48.297749,131.242310 48.016953,131.009155 47.875168,130.892273
	C48.196182,129.858994 48.658978,128.942596 49.433540,127.949860
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M104.819016,136.189880
	C105.110321,135.914108 105.277908,135.935593 105.698051,135.936356
	C105.459030,136.891449 104.967461,137.867264 104.106255,138.811920
	C104.056190,138.016220 104.375748,137.251678 104.819016,136.189880
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M459.594421,143.973618
	C459.990662,144.162003 460.017212,144.341019 460.087921,144.787903
	C459.349304,145.483414 458.566467,145.911041 457.447357,146.324112
	C457.815613,145.527786 458.520142,144.746002 459.594421,143.973618
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M488.903595,116.774109
	C488.489655,117.064941 488.083649,117.000610 487.255554,116.686813
	C486.536285,116.300751 486.239075,116.164146 485.941895,116.027542
	C485.946167,115.851128 485.950409,115.674721 485.998901,115.237335
	C486.999329,115.457222 487.955444,115.938087 488.903595,116.774109
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M375.700470,429.057190
	C375.738495,429.545044 375.445801,429.978027 374.980286,430.611176
	C374.358826,430.858276 373.910187,430.905212 373.129150,430.884216
	C373.654449,430.211639 374.512085,429.606995 375.700470,429.057190
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M51.112778,195.600159
	C50.797729,195.954803 50.626781,195.972321 50.198181,195.981552
	C50.251579,194.929504 50.562630,193.885773 51.159939,192.662781
	C51.383095,193.410034 51.319988,194.336533 51.112778,195.600159
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M398.347961,74.979973
	C398.570312,74.066666 399.122711,73.101151 400.051727,72.180840
	C399.844910,73.126617 399.261475,74.027191 398.347961,74.979973
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M208.063690,441.134583
	C207.265228,441.066559 206.175262,440.943909 205.042877,440.420898
	C205.924362,440.373627 206.848282,440.726776 208.063690,441.134583
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M95.043304,112.621414
	C94.243980,112.399132 93.492996,111.792587 92.616119,110.926239
	C93.357368,111.190010 94.224503,111.713585 95.043304,112.621414
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M459.683594,442.391785
	C459.039246,442.713226 457.975861,442.952942 456.821899,442.936523
	C457.575745,442.556946 458.420105,442.433502 459.683594,442.391785
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M208.665237,446.284729
	C208.669037,445.377869 208.924530,444.301575 209.556259,442.983948
	C209.593979,443.866821 209.255447,444.991089 208.665237,446.284729
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M201.837097,133.064987
	C201.427765,133.839813 200.626236,134.569244 199.489044,135.320709
	C199.917221,134.568344 200.681046,133.793976 201.837097,133.064987
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M325.928131,88.127632
	C325.994537,88.454529 326.169220,88.706329 326.687500,89.263382
	C327.049072,90.007904 327.175293,90.372063 327.301514,90.736221
	C327.301514,90.736221 327.048065,90.967964 326.922333,91.087326
	C326.163452,90.448189 325.530273,89.689690 325.158051,88.568199
	C325.588684,88.179352 325.758423,88.153488 325.928131,88.127632
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M498.696198,133.029114
	C498.522858,133.894867 498.013947,134.777161 497.191071,135.710846
	C497.371613,134.856735 497.866119,133.951202 498.696198,133.029114
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M292.755493,42.182861
	C293.490112,42.277390 293.985443,42.552822 294.764618,42.867180
	C295.048462,42.906101 295.033875,42.965187 295.012054,43.223351
	C294.975952,43.662106 294.961670,43.842701 294.947418,44.023300
	C294.137024,43.470119 293.326599,42.916939 292.755493,42.182861
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M197.389313,149.028564
	C196.990036,148.836792 196.965958,148.665955 196.944794,148.236328
	C197.683029,147.552551 198.418350,147.127579 199.474060,146.664520
	C199.117783,147.434113 198.441132,148.241806 197.389313,149.028564
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M295.259766,44.115021
	C294.961670,43.842701 294.975952,43.662106 295.040863,43.214516
	C296.038177,43.455776 296.984894,43.964027 297.917542,44.829002
	C297.126343,44.859394 296.349243,44.533070 295.259766,44.115021
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M172.508591,100.836670
	C173.100952,100.664268 173.363663,100.717239 173.801605,100.963715
	C173.981781,101.487297 173.954788,101.975792 173.796417,102.807152
	C173.180313,102.401230 172.695602,101.652443 172.508591,100.836670
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M325.971130,87.798111
	C325.758423,88.153488 325.588684,88.179352 325.164185,88.243408
	C324.616425,87.695580 324.323456,87.109550 324.036316,86.193832
	C324.699493,86.398949 325.356812,86.933769 325.971130,87.798111
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M472.962494,133.986786
	C473.406311,133.916000 473.850128,133.845245 474.624146,133.843292
	C474.644257,134.837357 474.334137,135.762619 473.838989,137.016754
	C473.241394,137.117218 472.828796,136.888840 472.474396,136.078278
	C472.675873,134.992981 472.819183,134.489883 472.962494,133.986786
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M512.844849,448.206055
	C512.635864,447.566040 512.676270,446.739716 513.044434,445.812317
	C513.279541,446.480774 513.186890,447.250214 512.844849,448.206055
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M69.368851,449.038391
	C68.793602,448.687622 68.390633,448.055389 68.081039,447.136932
	C68.629982,447.486115 69.085556,448.121552 69.368851,449.038391
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M47.499321,201.836243
	C47.592525,202.425842 47.419476,203.171005 46.964394,204.036102
	C46.865929,203.434616 47.049496,202.713211 47.499321,201.836243
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M320.958038,156.981323
	C321.339691,157.059631 321.524109,157.257690 321.822205,157.846130
	C321.536926,158.384171 321.138062,158.531876 320.739166,158.679565
	C320.746368,158.153397 320.753571,157.627243 320.958038,156.981323
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M450.163330,54.410896
	C449.827484,55.022285 449.169189,55.478271 448.207123,55.863216
	C448.549225,55.279945 449.195038,54.767715 450.163330,54.410896
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M561.240845,444.221375
	C561.853027,444.422943 562.434082,444.929688 562.986206,445.752625
	C562.374695,445.554688 561.792236,445.040649 561.240845,444.221375
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M303.677124,55.450859
	C304.320618,55.640488 304.895447,56.149414 304.935242,56.845402
	C304.202209,57.041378 304.004211,57.050293 303.806213,57.059204
	C303.740326,56.629520 303.674408,56.199837 303.677124,55.450859
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M462.852264,56.610172
	C463.156921,55.966381 463.792969,55.469574 464.738098,55.031441
	C464.425995,55.645790 463.804840,56.201473 462.852264,56.610172
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M204.535431,200.133545
	C205.096054,200.374084 205.576050,200.902435 206.026001,201.714966
	C205.482254,201.473206 204.968521,200.947281 204.535431,200.133545
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M141.481628,135.497406
	C141.187195,136.212891 140.510941,136.750595 139.496368,137.257568
	C139.805298,136.591095 140.452560,135.955353 141.481628,135.497406
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M459.288391,445.745850
	C459.786774,445.707001 460.419678,445.946411 461.064331,446.437927
	C460.525024,446.468048 459.973969,446.246094 459.288391,445.745850
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M372.047485,458.314331
	C372.651611,458.293762 373.319214,458.575623 374.082703,459.129639
	C373.489410,459.140076 372.800201,458.878418 372.047485,458.314331
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M445.213379,56.509750
	C444.893951,57.156372 444.248535,57.633953 443.293518,58.041855
	C443.618378,57.428356 444.252869,56.884529 445.213379,56.509750
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M209.952103,127.810928
	C209.527603,128.140610 209.084167,128.164047 208.320099,128.090302
	C208.248505,127.480904 208.497559,126.968681 208.746597,126.456467
	C209.142120,126.805870 209.537643,127.155273 209.952103,127.810928
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M292.385742,37.965427
	C292.732117,38.406834 292.821411,38.898888 292.757141,39.740948
	C292.445282,39.399326 292.286987,38.707699 292.385742,37.965427
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M49.317848,392.713318
	C49.391071,393.363678 49.177567,394.151611 48.640015,395.027222
	C48.554356,394.360229 48.792740,393.605591 49.317848,392.713318
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M47.507408,396.871033
	C47.581135,397.491089 47.370090,398.232086 46.863110,399.071991
	C46.785660,398.444580 47.004147,397.718292 47.507408,396.871033
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M45.561821,206.891388
	C45.662003,207.483337 45.481308,208.196228 45.036808,209.035736
	C44.942314,208.445663 45.111629,207.728989 45.561821,206.891388
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M430.647003,393.978180
	C430.747009,394.534912 430.572144,395.118103 430.109497,395.841980
	C430.005127,395.323334 430.188629,394.664001 430.647003,393.978180
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M220.726868,208.828644
	C220.151993,208.605789 219.570831,208.079468 219.030273,207.230576
	C219.620789,207.447067 220.170700,207.986145 220.726868,208.828644
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M428.448181,398.964539
	C428.557983,399.614349 428.333832,400.346802 427.866455,401.257080
	C427.786896,400.639038 427.950562,399.843109 428.448181,398.964539
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M157.487518,124.823769
	C157.341583,125.487495 156.879333,126.186340 156.056610,126.847672
	C156.187820,126.159729 156.679504,125.509308 157.487518,124.823769
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M459.657990,390.950928
	C459.973267,391.470123 460.041473,391.898285 460.073181,392.649963
	C459.417267,392.406006 458.797913,391.838562 458.297180,390.926331
	C458.747498,390.674347 459.079224,390.767120 459.657990,390.950928
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M396.471375,150.971848
	C396.395935,150.288010 396.677704,149.535507 397.210876,148.595657
	C397.251038,149.239944 397.039795,150.071548 396.471375,150.971848
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M358.708344,150.532135
	C359.003632,149.879044 359.655731,149.385071 360.621582,148.886353
	C360.311920,149.484818 359.688568,150.088028 358.708344,150.532135
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M315.891815,124.193169
	C315.831665,124.906937 315.407318,125.590172 314.663330,126.307220
	C314.738342,125.614899 315.132965,124.888763 315.891815,124.193169
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M177.902191,124.784805
	C177.954926,125.189476 177.859711,125.388710 177.578674,125.862381
	C177.103622,125.494644 176.814362,124.852478 176.764404,124.103760
	C177.253891,124.191269 177.504074,124.385323 177.902191,124.784805
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M342.983612,133.655243
	C342.585510,134.095444 342.249512,134.212875 341.663635,134.440338
	C341.722656,133.732529 342.031586,132.914703 342.714508,132.070816
	C343.074219,132.473984 343.059967,132.903229 342.983612,133.655243
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M206.389618,203.174240
	C206.957886,203.439651 207.467514,204.008392 207.921844,204.883484
	C207.354691,204.619080 206.842834,204.048309 206.389618,203.174240
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M519.744080,449.090576
	C520.237244,449.468719 520.589539,450.119080 520.823608,451.049133
	C520.338013,450.673462 519.970581,450.018097 519.744080,449.090576
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M345.681030,151.880127
	C346.018707,152.080811 346.025330,152.271698 346.010406,152.748306
	C345.331543,152.848145 344.674194,152.662262 344.031982,152.172073
	C344.481415,151.868622 344.915710,151.869476 345.681030,151.880127
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M274.681000,448.802490
	C274.356506,448.433472 274.201721,447.683716 274.289429,446.877075
	C274.638214,447.354065 274.744446,447.887909 274.681000,448.802490
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M604.148193,459.484863
	C604.420349,458.939789 604.983521,458.477844 605.840088,458.051331
	C605.568726,458.580505 605.003906,459.074249 604.148193,459.484863
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M218.773376,205.780640
	C218.182114,205.508942 217.639313,204.929688 217.159302,204.024872
	C217.755341,204.290558 218.288589,204.881836 218.773376,205.780640
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M403.279266,135.981476
	C403.140472,135.410507 403.295105,134.827072 403.742371,134.125793
	C403.880890,134.661652 403.726807,135.315323 403.279266,135.981476
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M303.594666,57.250492
	C304.004211,57.050293 304.202209,57.041378 304.697205,57.018814
	C305.090729,57.431705 305.187225,57.858238 305.233276,58.609322
	C304.582916,58.436508 303.983002,57.939144 303.594666,57.250492
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M76.940231,127.281448
	C76.811508,126.865128 76.888199,126.667816 77.095001,126.180771
	C77.755287,126.518875 78.285446,127.146713 78.713470,128.107056
	C78.122780,128.126526 77.634209,127.813477 76.940231,127.281448
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M336.316589,204.260727
	C336.864929,204.482895 337.410431,204.997559 337.947693,205.823486
	C337.397522,205.607559 336.855621,205.080399 336.316589,204.260727
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M368.062195,126.681259
	C367.444397,126.470001 366.916992,125.929955 366.900024,125.206276
	C367.609711,125.014038 367.808990,125.005432 368.008240,124.996826
	C368.056366,125.448700 368.104492,125.900581 368.062195,126.681259
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M130.125702,141.212280
	C130.001831,140.810471 130.009033,140.635361 130.001251,140.197723
	C130.491211,140.021042 130.996170,140.106873 131.848450,140.358093
	C131.549454,140.828659 130.903122,141.133835 130.125702,141.212280
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M412.215729,58.796562
	C412.319061,58.191639 412.724792,57.580891 413.426239,56.949833
	C413.320679,57.549927 412.919403,58.170334 412.215729,58.796562
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M587.800049,432.243103
	C587.694275,432.839203 587.282043,433.437439 586.585510,434.080963
	C586.698669,433.499237 587.096130,432.872223 587.800049,432.243103
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M473.061829,150.350037
	C473.763855,150.307816 474.520538,150.629395 475.424805,151.236938
	C474.753784,151.253220 473.935120,150.983521 473.061829,150.350037
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M417.279602,433.182190
	C417.816681,433.461578 418.375763,434.043793 418.877258,434.957581
	C418.313660,434.687775 417.807648,434.086426 417.279602,433.182190
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M369.704773,433.074341
	C369.646027,433.685272 369.276245,434.341522 368.613708,435.066681
	C368.678528,434.463623 369.036102,433.791626 369.704773,433.074341
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M300.010742,47.723518
	C300.153168,48.132599 300.084351,48.318794 299.903534,48.780968
	C299.239380,48.420883 298.687225,47.784828 298.234497,46.805489
	C298.822479,46.808350 299.310974,47.154495 300.010742,47.723518
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M326.836975,454.153381
	C327.570404,454.227478 328.189087,454.474609 329.026031,454.988892
	C329.244263,455.256012 329.264343,455.665344 329.174255,455.849365
	C328.456024,455.780853 327.827820,455.528290 326.972046,455.008423
	C326.744415,454.741119 326.722290,454.326447 326.836975,454.153381
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M500.499390,456.270294
	C500.315277,455.715057 500.365143,455.049286 500.706940,454.194092
	C500.910370,454.723053 500.821838,455.441406 500.499390,456.270294
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M34.569801,456.853668
	C34.153671,456.550568 33.786327,455.956573 33.613289,455.205688
	C34.077923,455.553467 34.348255,456.058105 34.569801,456.853668
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M58.297112,434.906433
	C58.130089,435.203003 57.669937,435.137970 57.439011,435.113708
	C57.444206,434.352661 57.680332,433.615906 58.204414,432.771942
	C58.482956,433.313110 58.473545,433.961487 58.297112,434.906433
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M377.417938,149.897247
	C378.064819,150.143585 378.586029,150.727829 379.104553,151.617386
	C378.498688,151.360184 377.895477,150.797684 377.417938,149.897247
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M560.876587,434.735535
	C560.264221,434.518494 559.662903,433.991577 559.096069,433.132629
	C559.716309,433.342316 560.302002,433.884003 560.876587,434.735535
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M466.183807,47.450172
	C465.864868,48.085789 465.218231,48.564079 464.261261,48.973980
	C464.585968,48.368008 465.221039,47.830425 466.183807,47.450172
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M335.010071,152.804260
	C335.322876,152.148224 335.748962,151.813629 336.458008,151.504776
	C336.201752,152.062241 335.662567,152.593964 335.010071,152.804260
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M246.821869,129.962158
	C246.056519,129.924911 245.307724,129.490677 244.471954,128.727478
	C245.202789,128.787415 246.020615,129.176300 246.821869,129.962158
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M359.798767,51.091774
	C359.534637,50.579544 359.521454,49.987942 359.744629,49.197128
	C360.003906,49.669411 360.026825,50.340908 359.798767,51.091774
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M486.916779,45.715111
	C487.231201,45.103554 487.870483,44.615780 488.817871,44.207436
	C488.497894,44.804207 487.869751,45.321552 486.916779,45.715111
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M251.897705,133.799240
	C251.141266,133.783661 250.376953,133.387894 249.527679,132.665314
	C250.258423,132.698669 251.074127,133.058868 251.897705,133.799240
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M204.726730,438.868134
	C204.117111,438.628357 203.569092,438.074615 203.075653,437.195923
	C203.682938,437.432068 204.235626,437.993134 204.726730,438.868134
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M606.449829,437.121765
	C607.021240,437.367188 607.515991,437.911957 607.985229,438.756775
	C607.430969,438.511597 606.902100,437.966370 606.449829,437.121765
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M95.066765,139.353210
	C95.452156,138.929382 95.767548,138.827759 96.327423,138.663666
	C96.266594,139.376495 95.961281,140.151794 95.299248,140.947479
	C94.960602,140.537048 94.978683,140.106232 95.066765,139.353210
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M158.865784,45.817772
	C158.569870,46.447025 158.129166,46.828949 157.379974,47.166000
	C157.621338,46.604229 158.171158,46.087334 158.865784,45.817772
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M371.950989,439.756348
	C371.743042,439.291107 371.776428,438.632843 372.036194,437.890991
	C372.239136,438.392731 372.215729,438.977997 371.950989,439.756348
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M71.396957,455.018311
	C70.818893,454.690216 70.387779,454.071899 70.049835,453.168152
	C70.609978,453.497833 71.076935,454.112976 71.396957,455.018311
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M65.697586,437.944580
	C65.118240,437.587524 64.675842,436.935364 64.352142,435.980438
	C64.925400,436.334930 65.379967,436.992218 65.697586,437.944580
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M223.042511,128.266724
	C223.618317,128.505447 224.124390,129.063614 224.411438,129.787369
	C223.785858,129.497360 223.379318,129.041763 223.042511,128.266724
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M401.515381,139.976654
	C401.419586,139.278915 401.675507,138.504501 402.213409,137.573425
	C402.285980,138.244492 402.076508,139.072250 401.515381,139.976654
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M482.862793,47.636505
	C483.189728,47.022137 483.840729,46.552818 484.796936,46.151489
	C484.463715,46.740173 483.825287,47.260864 482.862793,47.636505
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M491.846619,43.633667
	C492.185364,43.027393 492.842529,42.567188 493.809570,42.189941
	C493.468018,42.775177 492.816528,43.277458 491.846619,43.633667
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M520.833557,453.171631
	C521.211304,453.548370 521.420471,454.091400 521.438599,454.792419
	C521.053284,454.412872 520.859131,453.875397 520.833557,453.171631
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M155.221252,47.480175
	C154.895981,48.116360 154.242813,48.588718 153.277557,48.995708
	C153.608078,48.392342 154.250702,47.854343 155.221252,47.480175
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M568.205505,453.245300
	C568.812378,453.466522 569.395325,453.999969 569.935303,454.856689
	C569.322144,454.639130 568.751831,454.098328 568.205505,453.245300
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M178.810196,185.304840
	C178.511093,185.689102 177.926239,186.104202 177.183533,186.303726
	C177.525269,185.837326 178.024857,185.586487 178.810196,185.304840
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M434.183411,42.073196
	C434.802094,42.271942 435.369110,42.811626 435.989929,43.659203
	C435.406433,43.449440 434.769073,42.931786 434.183411,42.073196
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M260.475403,435.899780
	C259.893311,435.687012 259.398773,435.182343 258.916046,434.399780
	C259.472900,434.617188 260.017914,435.112549 260.475403,435.899780
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M31.656555,153.667252
	C32.345306,153.787964 33.049248,154.229477 33.667145,155.040176
	C32.944649,154.935593 32.308193,154.461823 31.656555,153.667252
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M123.780083,128.785095
	C123.840942,128.207809 124.217834,127.697853 124.914368,127.132179
	C124.854713,127.668457 124.475418,128.260452 123.780083,128.785095
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M54.484108,442.849457
	C54.828209,443.192322 54.891922,443.668304 54.919853,444.502930
	C54.605827,444.924225 54.330082,444.996490 53.846340,445.113159
	C53.825142,444.426239 54.014431,443.704407 54.484108,442.849457
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M176.193817,194.285522
	C176.738007,194.616760 177.283737,195.263321 177.745850,196.267670
	C177.173264,195.950592 176.684311,195.275696 176.193817,194.285522
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M301.264221,36.376205
	C300.587769,36.230751 299.866058,35.766998 299.199921,34.923546
	C299.910004,35.048534 300.564453,35.553219 301.264221,36.376205
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M42.876911,155.429840
	C42.930073,154.733826 43.287128,153.997177 44.021000,153.333847
	C43.992142,154.067841 43.586472,154.728516 42.876911,155.429840
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M422.341034,430.415009
	C421.646118,430.515503 420.875763,430.279175 420.010803,429.736450
	C420.699310,429.646118 421.482483,429.862183 422.341034,430.415009
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M305.817200,429.213440
	C306.269592,429.709076 306.352509,430.209930 306.435394,430.710754
	C306.027039,430.701263 305.618652,430.691742 305.210297,430.682190
	C305.289429,430.194336 305.368561,429.706512 305.817200,429.213440
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M201.198441,195.234222
	C201.791855,195.453949 202.378250,195.978653 202.926880,196.827698
	C202.323227,196.614410 201.757339,196.076797 201.198441,195.234222
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M182.144165,43.248871
	C182.466446,42.645138 182.931046,42.281399 183.707184,41.978645
	C183.441299,42.522705 182.863892,43.005783 182.144165,43.248871
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M213.475708,196.867828
	C212.908798,196.633926 212.415787,196.112320 211.959427,195.302277
	C212.513931,195.535950 213.031784,196.058044 213.475708,196.867828
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M502.612610,125.976830
	C502.728363,126.542747 502.562622,127.124779 502.105316,127.834091
	C501.986237,127.305229 502.158691,126.649086 502.612610,125.976830
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M350.782074,34.981972
	C350.114410,34.813828 349.505127,34.292797 348.871399,33.458576
	C349.511444,33.639954 350.175964,34.134518 350.782074,34.981972
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M479.433350,454.722290
	C479.505585,455.342316 479.326752,456.135468 478.834106,457.030334
	C478.740936,456.386475 478.961639,455.640930 479.433350,454.722290
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M493.017731,440.794250
	C492.546692,440.460846 492.264069,439.957153 492.030762,439.151581
	C492.455414,439.441132 492.830780,440.032532 493.017731,440.794250
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M145.399918,133.386292
	C145.106064,134.091736 144.420761,134.660629 143.391190,135.223145
	C143.700760,134.561066 144.354614,133.905396 145.399918,133.386292
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M609.467590,431.950745
	C608.931030,431.891724 608.525574,431.594727 608.047974,431.050293
	C608.516846,431.106201 609.057800,431.409485 609.467590,431.950745
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M209.443741,456.877869
	C208.969452,456.493378 208.570877,455.815155 208.314850,454.831421
	C208.811417,455.212036 209.165436,455.898071 209.443741,456.877869
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M152.305481,128.305634
	C152.116943,129.063660 151.515060,129.735916 150.563751,130.452393
	C150.773605,129.737686 151.332870,128.978790 152.305481,128.305634
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M196.017670,190.334198
	C196.614914,190.377182 197.292618,190.714355 198.042404,191.347809
	C197.442383,191.305527 196.770264,190.966965 196.017670,190.334198
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M177.842865,198.203003
	C178.273956,198.635956 178.568649,199.278046 178.740524,200.285217
	C178.313950,199.904251 178.010193,199.158203 177.842865,198.203003
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M490.544891,439.849976
	C490.447113,440.455566 490.075623,441.200073 489.356567,441.974121
	C489.429749,441.332062 489.850464,440.660461 490.544891,439.849976
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M505.721405,429.021973
	C506.020874,429.556122 506.000610,430.026337 505.919281,430.845093
	C505.706024,430.448395 505.553864,429.703247 505.721405,429.021973
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M211.663574,193.817505
	C211.075943,193.555405 210.549942,192.991501 210.084839,192.115997
	C210.672226,192.374817 211.198700,192.945251 211.663574,193.817505
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M450.620239,455.986145
	C450.456909,456.585205 450.012543,457.270996 449.216980,457.903809
	C449.356903,457.258148 449.848083,456.665527 450.620239,455.986145
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M53.252457,154.032837
	C53.951942,154.148911 54.592571,154.628983 55.260162,155.429306
	C54.589283,155.298645 53.891438,154.847763 53.252457,154.032837
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M228.193390,240.228821
	C228.789841,240.490906 229.352325,241.063110 229.848938,241.963699
	C229.241852,241.707703 228.700623,241.123337 228.193390,240.228821
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M457.991882,92.335236
	C458.571472,92.546959 459.235931,93.058372 459.895081,93.924484
	C459.285431,93.731094 458.681091,93.183006 457.991882,92.335236
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M344.624664,110.556427
	C345.320557,110.679092 346.055939,111.128708 346.736145,111.951996
	C346.008698,111.844910 345.336456,111.364143 344.624664,110.556427
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M361.126038,289.118713
	C361.684906,289.122955 362.203125,289.416779 362.830444,289.997009
	C362.321472,289.991730 361.703461,289.700043 361.126038,289.118713
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M344.690887,288.953430
	C345.001099,289.169739 345.024841,289.356873 345.014343,289.824982
	C344.495819,290.150543 344.011536,290.195129 343.527283,290.239746
	C343.819641,289.801239 344.112000,289.362732 344.690887,288.953430
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M206.268570,242.851654
	C205.954437,242.431320 205.796310,241.840057 205.883667,241.110077
	C206.227631,241.541138 206.326096,242.110916 206.268570,242.851654
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M307.737732,243.763611
	C307.184204,243.521072 306.619324,242.973526 306.092407,242.100677
	C306.662384,242.336426 307.194366,242.897507 307.737732,243.763611
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M399.537354,144.969513
	C399.396362,144.263000 399.607269,143.467926 400.098145,142.513153
	C400.215149,143.195969 400.052216,144.038452 399.537354,144.969513
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M497.474976,79.936783
	C497.823975,80.375992 497.906342,80.873558 497.885864,81.738808
	C497.591431,81.402710 497.399902,80.698921 497.474976,79.936783
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M159.547394,83.262154
	C159.090912,83.449608 158.776047,83.288155 158.200363,83.068466
	C157.906662,82.559296 157.873795,82.108368 157.922638,81.327415
	C158.565918,81.636009 159.127472,82.274628 159.547394,83.262154
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M359.358276,286.810852
	C360.010864,287.039307 360.558258,287.629425 361.140686,288.530029
	C360.534821,288.284485 359.893951,287.728485 359.358276,286.810852
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M600.769165,287.900513
	C600.204041,287.616119 599.685303,287.020111 599.262695,286.111389
	C599.844360,286.395386 600.329895,286.992126 600.769165,287.900513
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M594.369995,285.920044
	C594.455139,286.591400 594.236389,287.362366 593.700256,288.214569
	C593.610657,287.537079 593.838379,286.778381 594.369995,285.920044
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M143.528336,86.159966
	C142.903091,85.867577 142.430664,85.241165 141.972336,84.311417
	C142.551346,84.614029 143.116257,85.219986 143.528336,86.159966
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M66.264641,237.175140
	C66.843765,237.530197 67.319199,238.189407 67.659821,239.167084
	C67.070328,238.816803 66.615639,238.148041 66.264641,237.175140
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M378.924011,113.377197
	C379.111969,113.008492 379.327667,112.950981 379.865784,112.798370
	C380.188263,112.703285 380.596466,112.921333 380.797485,113.037483
	C380.915436,113.716690 380.832428,114.279739 380.576111,115.240692
	C379.919128,114.988533 379.435394,114.338470 378.924011,113.377197
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M165.016235,74.744141
	C165.146545,75.153702 165.072449,75.342102 164.870544,75.806061
	C164.227768,75.421364 163.712814,74.761116 163.319702,73.763458
	C163.898300,73.791687 164.355072,74.157341 165.016235,74.744141
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M589.100342,319.331970
	C588.779541,319.947174 588.140625,320.428223 587.192383,320.829041
	C587.516113,320.231781 588.149231,319.714813 589.100342,319.331970
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M157.540909,78.102554
	C157.034393,78.555038 156.764679,78.384117 156.316208,78.056503
	C156.128754,77.541168 156.170517,77.102905 156.141190,76.340530
	C156.401321,75.953667 156.673325,75.791565 157.104111,75.429276
	C157.457153,76.071884 157.592178,76.815346 157.540909,78.102554
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M446.231567,112.384018
	C445.954437,113.040634 445.318756,113.561760 444.362854,114.079910
	C444.652740,113.467461 445.262909,112.857994 446.231567,112.384018
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M346.705780,112.643906
	C347.395447,112.800880 348.115326,113.281319 348.764893,114.144119
	C348.041718,114.006775 347.388885,113.487068 346.705780,112.643906
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M76.597542,237.854462
	C76.030891,237.521713 75.562759,236.887299 75.204941,235.942749
	C75.775528,236.272690 76.235802,236.912750 76.597542,237.854462
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M391.613098,144.516418
	C391.263763,144.439072 391.204559,144.188049 391.096375,143.555313
	C391.498901,142.788116 391.950378,142.402649 392.714569,142.013916
	C392.652588,142.788010 392.277893,143.565369 391.613098,144.516418
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M226.400970,237.163834
	C226.971161,237.427750 227.484039,237.990280 227.940155,238.860596
	C227.370163,238.599731 226.856918,238.031082 226.400970,237.163834
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M332.239685,97.867912
	C332.966980,97.991028 333.626892,98.498642 334.320312,99.327545
	C333.626678,99.183365 332.899475,98.717888 332.239685,97.867912
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M305.404846,239.826813
	C304.882050,239.526794 304.451599,238.938950 304.079834,238.062622
	C304.591400,238.362411 305.044281,238.950699 305.404846,239.826813
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M514.251953,110.418152
	C514.002136,111.092369 513.385925,111.633476 512.450317,112.196457
	C512.715820,111.573906 513.300659,110.929466 514.251953,110.418152
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M38.656281,241.758499
	C38.328594,241.410675 38.152935,240.694046 38.225594,239.921021
	C38.585377,240.372986 38.696846,240.881348 38.656281,241.758499
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M168.218536,80.855080
	C167.665878,80.531357 167.350998,80.055771 167.076996,79.279160
	C167.564026,79.553154 168.010178,80.128181 168.218536,80.855080
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M78.475296,241.885849
	C77.902809,241.614609 77.418716,241.052902 77.006058,240.196655
	C77.572884,240.466522 78.068291,241.030960 78.475296,241.885849
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M360.330261,261.064636
	C360.005951,260.812042 360.007660,260.638000 360.006653,260.202515
	C360.650391,260.122620 361.296906,260.304108 361.960754,260.772095
	C361.537537,261.086823 361.096954,261.115021 360.330261,261.064636
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M370.724182,107.605324
	C370.758667,106.816238 371.071014,105.979820 371.753540,105.435013
	C372.071777,106.145569 372.019836,106.564522 371.967896,106.983475
	C371.645935,107.174988 371.323975,107.366493 370.724182,107.605324
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M454.437469,148.282227
	C454.712799,147.596024 455.334686,146.925980 456.345947,146.381866
	C456.084869,147.104660 455.434418,147.701508 454.437469,148.282227
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M281.095642,144.794540
	C281.211884,144.078369 281.694214,143.414444 282.495911,142.707062
	C282.364105,143.391342 281.912933,144.119049 281.095642,144.794540
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M292.488678,270.848419
	C291.980652,270.475555 291.569519,269.812927 291.275330,268.844452
	C291.790039,269.211945 292.187805,269.885315 292.488678,270.848419
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M431.902466,147.781616
	C431.757629,148.181366 431.589539,148.219971 431.177673,148.345612
	C430.519470,147.960052 430.104950,147.487457 429.651276,146.703445
	C430.367798,146.734848 431.123474,147.077667 431.902466,147.781616
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M25.617134,246.906357
	C25.927788,247.393921 25.947006,247.885010 25.952375,248.744904
	C25.734249,248.379105 25.529974,247.644485 25.617134,246.906357
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M552.426880,246.775589
	C552.804016,247.261841 552.870056,247.796021 552.946411,248.734055
	C552.676392,248.366455 552.396118,247.594986 552.426880,246.775589
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M582.736511,89.801849
	C582.187500,89.602577 581.616028,89.108711 581.022217,88.308266
	C581.571289,88.503548 582.142639,89.005402 582.736511,89.801849
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M372.330322,106.942146
	C372.019836,106.564522 372.071777,106.145569 372.136841,105.407196
	C372.490356,104.923927 372.830780,104.760078 373.453613,104.564224
	C373.388275,105.321747 373.040527,106.111282 372.330322,106.942146
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M208.997787,101.032234
	C208.312759,100.940826 207.627747,100.849419 206.919983,100.474747
	C207.366852,100.095718 207.836456,99.999947 208.668259,100.179794
	C209.019562,100.647682 209.008667,100.839958 208.997787,101.032234
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M212.924728,90.552124
	C213.508850,90.047501 214.092957,89.542877 214.987244,89.117683
	C214.999313,89.646751 214.701202,90.096390 213.917603,90.657394
	C213.262985,90.696541 213.093857,90.624336 212.924728,90.552124
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M334.276917,100.012604
	C334.979797,100.176483 335.602295,100.700439 336.227783,101.551498
	C335.552704,101.376633 334.874603,100.874657 334.276917,100.012604
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M212.688736,90.781944
	C213.093857,90.624336 213.262985,90.696541 213.698517,90.840096
	C213.361679,91.547195 212.758408,92.182953 211.787094,92.726227
	C211.763626,92.093094 212.108185,91.552429 212.688736,90.781944
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M366.330505,264.819763
	C365.737885,264.521790 365.376190,264.062653 365.020508,263.294556
	C365.538116,263.543243 366.049805,264.100891 366.330505,264.819763
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M321.361145,83.711960
	C322.092010,83.940254 322.706543,84.552368 323.309143,85.504532
	C322.613068,85.261642 321.928955,84.678711 321.361145,83.711960
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M366.987671,286.663422
	C366.355743,286.531677 365.703583,286.077148 365.035095,285.306396
	C365.668335,285.440338 366.317841,285.890503 366.987671,286.663422
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M232.323151,287.024628
	C232.231522,286.482483 232.395996,285.889282 232.843506,285.143066
	C232.944107,285.651245 232.761673,286.312408 232.323151,287.024628
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M33.324665,284.996002
	C32.787712,284.642822 32.399467,284.011505 32.107986,283.095764
	C32.627628,283.446838 33.050503,284.082336 33.324665,284.996002
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M27.840183,245.440430
	C27.592728,245.993698 27.049465,246.497330 26.206604,246.952225
	C26.452795,246.399261 26.998587,245.895020 27.840183,245.440430
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M24.801449,143.135193
	C25.387621,143.455200 25.724749,143.925171 26.019793,144.700531
	C25.502607,144.432343 25.027506,143.858734 24.801449,143.135193
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M342.199890,108.822357
	C342.799988,108.917061 343.320801,109.315216 343.862488,110.058105
	C343.295776,109.977165 342.708191,109.551498 342.199890,108.822357
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M593.517151,277.899536
	C594.076111,278.265686 594.492249,278.931885 594.782837,279.892395
	C594.229614,279.524323 593.802002,278.861938 593.517151,277.899536
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M209.338272,101.052544
	C209.008667,100.839958 209.019562,100.647682 209.033875,100.166473
	C209.694214,100.043205 210.351166,100.208885 211.010406,100.662827
	C210.568054,100.991684 210.123398,101.032265 209.338272,101.052544
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M554.770264,245.338898
	C554.500488,245.862701 553.930786,246.370163 553.049683,246.803650
	C553.315613,246.260635 553.893005,245.791595 554.770264,245.338898
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M375.696960,101.491669
	C375.800446,100.789192 376.222992,99.984543 377.046234,99.211838
	C376.969971,99.959023 376.492981,100.674255 375.696960,101.491669
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M161.298126,87.822945
	C160.873169,87.988213 160.677277,87.995995 160.187347,88.012787
	C159.892731,87.558365 159.892166,87.094925 159.995224,86.298973
	C160.574951,86.532799 161.051071,87.099129 161.298126,87.822945
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M399.039368,105.263237
	C399.698364,105.376961 400.352783,105.833336 401.052551,106.604782
	C400.410187,106.481857 399.722473,106.043869 399.039368,105.263237
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M62.808575,372.702759
	C62.229774,373.159637 61.650974,373.616486 60.910271,373.779480
	C60.748371,373.485626 60.726368,373.168488 61.168102,373.104065
	C62.009415,372.927368 62.408993,372.815063 62.808575,372.702759
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M89.199768,122.993286
	C89.257225,122.662933 89.708946,122.512375 90.075562,122.649460
	C90.595680,122.876556 90.749184,122.966568 90.920937,123.359436
	C91.011528,124.059563 91.083870,124.456841 91.156212,124.854118
	C91.156212,124.854118 90.926430,125.084595 90.812592,125.202934
	C90.179947,124.655396 89.661133,123.989517 89.199768,122.993286
z"/>
<path fill="#BFBEC8" opacity="1.000000" stroke="none"
	d="
M136.792755,63.533722
	C137.103012,62.891167 137.745987,62.401756 138.702209,61.970581
	C138.385452,62.581493 137.755463,63.134174 136.792755,63.533722
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M58.665916,375.018982
	C58.593498,375.658600 58.205963,376.338043 57.501434,377.050873
	C57.573223,376.409119 57.962013,375.733948 58.665916,375.018982
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M588.656006,376.098877
	C587.973938,375.843658 587.426697,375.249512 586.921753,374.340515
	C587.572998,374.603790 588.181824,375.181854 588.656006,376.098877
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M52.668877,121.969040
	C52.804169,122.575150 52.650158,123.171448 52.183998,123.873962
	C52.041088,123.306534 52.210331,122.632881 52.668877,121.969040
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M62.892212,372.473511
	C62.408993,372.815063 62.009415,372.927368 61.298477,373.013184
	C61.494987,372.393799 62.002853,371.800934 62.820251,371.250427
	C63.196068,371.629028 63.144760,371.946198 62.892212,372.473511
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M504.725586,121.101883
	C504.789185,121.816109 504.475922,122.574272 503.886078,123.486710
	C503.855896,122.809265 504.102325,121.977539 504.725586,121.101883
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M583.791931,369.822327
	C584.094604,370.386597 584.134705,370.809509 584.228882,371.550690
	C583.607727,371.239960 582.932678,370.610962 582.361328,369.579834
	C582.819885,369.345428 583.174622,369.513184 583.791931,369.822327
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M76.621803,123.114914
	C76.042450,122.764435 75.610603,122.103043 75.267761,121.138664
	C75.827614,121.491791 76.298462,122.147896 76.621803,123.114914
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M236.646271,235.827209
	C236.073029,235.561417 235.549225,234.997849 235.081757,234.120667
	C235.657318,234.381195 236.176514,234.955292 236.646271,235.827209
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M526.428345,381.543121
	C526.547729,382.154785 526.430725,382.963898 526.018738,383.905762
	C525.879822,383.272522 526.035950,382.506561 526.428345,381.543121
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M212.226868,213.216553
	C212.803467,213.488831 213.349716,214.067154 213.836090,214.973587
	C213.249634,214.708664 212.723083,214.115646 212.226868,213.216553
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M414.984955,123.558922
	C415.336243,123.216553 415.748108,123.183868 416.474426,123.184937
	C416.905426,123.592888 417.021973,123.967094 417.130646,124.635468
	C416.430328,124.575966 415.737946,124.222290 414.984955,123.558922
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M409.937195,123.332420
	C410.502533,123.086349 410.958771,123.087776 411.747101,123.174919
	C411.476379,123.781334 410.873566,124.302025 409.948639,124.714012
	C409.693695,124.263519 409.760895,123.921722 409.937195,123.332420
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M114.996346,387.939056
	C114.749954,387.895660 114.503555,387.852295 113.919052,387.645813
	C114.278473,387.105194 114.975998,386.727661 115.947815,386.499329
	C116.280426,386.967041 116.199974,387.245453 115.670639,387.676270
	C115.360527,387.868774 114.996346,387.939056 114.996346,387.939056
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M368.250305,124.829834
	C367.808990,125.005432 367.609711,125.014038 367.111145,125.023125
	C366.759918,124.602997 366.707977,124.182381 366.732056,123.452713
	C367.369507,123.650063 367.930939,124.156448 368.250305,124.829834
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M242.200348,140.111847
	C242.923172,140.205566 243.602493,140.671112 244.348053,141.451935
	C243.661789,141.339355 242.909317,140.911514 242.200348,140.111847
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M240.889999,124.810814
	C240.126358,124.816071 239.358795,124.432793 238.482056,123.733795
	C239.210602,123.752815 240.048340,124.087547 240.889999,124.810814
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M121.839371,384.286713
	C121.503616,384.870605 120.867126,385.351440 119.915604,385.710236
	C120.246597,385.120026 120.892609,384.651825 121.839371,384.286713
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M439.800903,120.061172
	C439.959991,120.619530 439.817566,121.195526 439.391785,121.897148
	C439.238770,121.374786 439.369080,120.726807 439.800903,120.061172
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M225.803391,217.776276
	C225.213608,217.504059 224.658371,216.925903 224.165787,216.018661
	C224.764938,216.283173 225.301437,216.876755 225.803391,217.776276
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M159.490143,122.748199
	C159.373444,123.412834 158.942215,124.137733 158.149353,124.833771
	C158.250351,124.139435 158.712967,123.473946 159.490143,122.748199
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M305.284119,59.771336
	C305.963531,60.043499 306.531677,60.681767 307.065308,61.652462
	C306.411469,61.369076 305.792206,60.753258 305.284119,59.771336
z"/>
<path fill="#747587" opacity="1.000000" stroke="none"
	d="
M54.520836,380.887207
	C54.622044,381.533020 54.413017,382.257660 53.921562,383.092957
	C53.829624,382.457764 54.020111,381.711884 54.520836,380.887207
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M366.593445,121.258530
	C365.906464,121.045502 365.349640,120.461349 364.762634,119.566574
	C365.396149,119.799774 366.059845,120.343597 366.593445,121.258530
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M557.632019,336.949890
	C557.417603,337.568573 556.873291,338.217194 555.969055,338.849121
	C556.173462,338.214905 556.737793,337.597382 557.632019,336.949890
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M427.717560,145.256042
	C427.468536,145.045837 427.650482,144.586044 427.717041,144.347992
	C428.448608,144.628769 429.113678,145.147583 429.692841,146.025909
	C429.060181,146.079010 428.513367,145.772629 427.717560,145.256042
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M234.805328,232.768433
	C234.237244,232.491196 233.684402,231.907669 233.194977,230.991302
	C233.779114,231.259689 234.299835,231.860916 234.805328,232.768433
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M562.103210,333.386169
	C561.845276,334.044434 561.251465,334.582672 560.349487,335.087921
	C560.616638,334.458649 561.192017,333.862396 562.103210,333.386169
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M430.694611,332.085510
	C430.732208,332.745331 430.415344,333.459595 429.832947,334.330933
	C429.824982,333.705322 430.082581,332.922638 430.694611,332.085510
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M441.630493,331.024109
	C441.579071,331.701141 441.200378,332.427460 440.491394,333.171844
	C440.541809,332.484406 440.922546,331.778870 441.630493,331.024109
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M438.897827,332.763306
	C438.228973,332.691040 437.552032,332.269257 436.794861,331.545654
	C437.439667,331.633820 438.164734,332.023804 438.897827,332.763306
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M446.304871,233.943451
	C446.326691,233.346710 446.642059,232.684860 447.245361,231.953918
	C447.221649,232.549332 446.910034,233.213821 446.304871,233.943451
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M446.053467,330.642334
	C445.483093,330.739960 444.918182,330.554779 444.184723,330.112000
	C444.697113,330.022766 445.377991,330.191162 446.053467,330.642334
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M435.019318,329.655396
	C434.551239,329.960602 434.065948,329.983765 433.236725,329.880371
	C433.595886,329.626984 434.299011,329.500153 435.019318,329.655396
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M406.295776,116.779068
	C405.889191,117.167419 405.507111,117.305656 404.833557,117.539307
	C404.931183,116.864937 405.320251,116.095161 406.094116,115.442169
	C406.426025,115.882278 406.373138,116.205612 406.295776,116.779068
z"/>
<path fill="#B4B4C0" opacity="1.000000" stroke="none"
	d="
M578.164307,324.490387
	C577.864807,325.133423 577.241089,325.622498 576.312500,326.058289
	C576.618408,325.448792 577.229248,324.892578 578.164307,324.490387
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M441.727173,116.099388
	C441.778564,116.809280 441.453278,117.559631 440.852356,118.466202
	C440.834625,117.794899 441.092560,116.967369 441.727173,116.099388
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M235.790955,121.007622
	C235.033112,120.978531 234.294403,120.544907 233.438629,119.801468
	C234.151062,119.862122 234.980576,120.232605 235.790955,121.007622
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M219.290085,225.195358
	C219.868454,225.464157 220.398285,226.035797 220.874756,226.927811
	C220.294769,226.664871 219.768143,226.081528 219.290085,225.195358
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M495.048706,137.193497
	C494.786713,137.823151 494.184021,138.375687 493.264160,138.887451
	C493.534027,138.269928 494.121002,137.693161 495.048706,137.193497
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M452.291260,137.466797
	C451.973877,138.111984 451.309296,138.601700 450.321869,139.047546
	C450.647369,138.439560 451.295715,137.875443 452.291260,137.466797
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M301.396240,228.839966
	C300.863190,228.477661 300.459839,227.834183 300.162537,226.890350
	C300.687683,227.246246 301.106812,227.902512 301.396240,228.839966
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M310.847290,67.406204
	C311.515472,67.666695 312.167542,68.262100 312.712280,69.232681
	C312.013702,68.985619 311.422424,68.363373 310.847290,67.406204
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M56.261406,117.436485
	C56.246910,118.186050 55.902760,119.029449 55.167725,119.879990
	C55.161812,119.101540 55.546783,118.315933 56.261406,117.436485
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M367.170624,142.842285
	C367.137878,142.137650 367.491028,141.399261 368.114197,140.497971
	C368.108276,141.159561 367.832397,141.984070 367.170624,142.842285
z"/>
<path fill="#CECED9" opacity="1.000000" stroke="none"
	d="
M490.648499,119.201813
	C489.991425,118.948776 489.471771,118.333694 488.912445,117.412720
	C489.510498,117.684479 490.148224,118.262115 490.648499,119.201813
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M162.944687,117.160812
	C162.921387,117.936226 162.490738,118.716187 161.731628,119.613815
	C161.781235,118.876122 162.159286,118.020744 162.944687,117.160812
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M42.041859,144.333282
	C42.411755,144.358459 42.564793,144.692871 42.528679,144.873230
	C42.111233,145.525299 41.729897,145.997009 41.031830,146.478973
	C41.034054,145.762192 41.353008,145.035141 42.041859,144.333282
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M190.026062,435.643158
	C189.803253,435.326782 189.645508,434.685852 189.747772,434.022766
	C190.035583,434.439941 190.063339,434.879272 190.026062,435.643158
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M507.814087,458.809082
	C507.372742,458.871674 506.780640,458.659271 506.035217,458.157898
	C505.881897,457.868958 506.262177,457.707947 506.454559,457.782898
	C506.985718,458.083252 507.324524,458.308685 507.814087,458.809082
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M391.493713,137.492859
	C391.513214,137.492493 391.474182,137.493240 391.493713,137.492859
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M261.767090,238.042847
	C261.861603,238.193512 261.829742,238.530609 261.542480,238.962448
	C261.389435,238.774567 261.507294,238.498596 261.767090,238.042847
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M133.201401,98.973190
	C133.249954,98.772728 133.576599,98.604691 133.970764,98.703354
	C133.852036,98.981903 133.665771,98.993752 133.201401,98.973190
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M493.681763,457.703979
	C493.947296,457.938110 493.947968,458.156433 493.985016,458.700470
	C493.721893,458.810394 493.422363,458.594635 493.017120,458.114258
	C493.079895,457.795837 493.248413,457.742004 493.681763,457.703979
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M209.322021,232.077682
	C209.265961,231.925003 209.343079,231.554947 209.704163,231.089111
	C209.810486,231.282318 209.632828,231.571304 209.322021,232.077682
z"/>
<path fill="#5C5B6D" opacity="1.000000" stroke="none"
	d="
M142.901108,95.551285
	C143.045517,95.366104 143.203476,95.280937 143.610764,95.094543
	C143.723557,95.275597 143.587021,95.557877 143.197723,95.845505
	C142.944962,95.850861 142.914658,95.651299 142.901108,95.551285
z"/>
<path fill="#EBECF2" opacity="1.000000" stroke="none"
	d="
M242.142426,459.483185
	C242.312790,459.367584 242.608627,459.419006 242.961990,459.729462
	C242.731339,459.959320 242.480804,459.846588 242.142426,459.483185
z"/>
<path fill="#D3D3DD" opacity="1.000000" stroke="none"
	d="
M169.976349,132.097046
	C170.227570,132.058304 170.494247,132.406082 170.440506,132.616791
	C170.166214,132.596924 169.945663,132.366348 169.976349,132.097046
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M321.084045,438.597229
	C320.965881,438.902924 320.762695,438.946136 320.248016,438.974915
	C320.290680,438.751892 320.644897,438.543304 321.084045,438.597229
z"/>
<path fill="#3F4161" opacity="1.000000" stroke="none"
	d="
M209.747192,439.418701
	C210.226013,439.147644 210.616669,439.437317 211.275391,439.981201
	C210.915329,440.150085 210.287170,440.064758 209.747192,439.418701
z"/>
<path fill="#7D7D8D" opacity="1.000000" stroke="none"
	d="
M523.082397,444.772705
	C522.700073,444.640778 522.683838,444.424408 522.978271,444.087463
	C523.388733,444.171631 523.441833,444.412079 523.082397,444.772705
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M389.681152,138.982117
	C389.486023,138.809204 389.483063,138.492828 389.701416,138.047974
	C390.091248,138.235855 390.074799,138.542221 389.681152,138.982117
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M44.811974,139.559174
	C44.849480,139.576019 44.836720,139.530487 44.861526,139.550446
	C44.886337,139.570404 44.869438,139.513733 44.869438,139.513733
	C44.869438,139.513733 44.802742,139.552612 44.814457,139.515503
	C44.826172,139.478409 44.774471,139.542343 44.811974,139.559174
z"/>
<path fill="#383B5E" opacity="1.000000" stroke="none"
	d="
M570.185303,249.224518
	C570.204285,249.031479 570.489136,248.899887 570.873047,248.945312
	C570.798462,249.176895 570.624878,249.231445 570.185303,249.224518
z"/>
<path fill="#C4D0E9" opacity="1.000000" stroke="none"
	d="
M791.435059,409.332428
	C790.513306,409.237213 789.591492,409.142029 788.254395,408.562378
	C787.006409,407.888977 786.173767,407.699951 785.341125,407.510956
	C782.815491,406.955658 780.289856,406.400391 777.289795,405.365112
	C776.032104,404.690155 775.248840,404.495239 774.465576,404.300323
	C773.539551,404.132446 772.613525,403.964539 771.254517,403.337280
	C770.043274,402.679840 769.264893,402.481750 768.486572,402.283630
	C767.858765,402.172119 767.231018,402.060638 766.220581,401.468933
	C765.034790,400.773102 764.231628,400.557465 763.428406,400.341858
	C759.184448,398.572205 754.940552,396.802551 750.277283,394.541290
	C749.087891,393.778687 748.317810,393.507721 747.547729,393.236786
	C701.886292,369.413208 673.540344,332.173553 661.633545,281.560059
	C661.327087,280.189270 660.945557,279.513275 660.564087,278.837280
	C660.399414,278.130554 660.234802,277.423798 660.299194,276.194519
	C660.298340,275.108398 660.068481,274.544830 659.838623,273.981293
	C659.734985,272.720062 659.631409,271.458862 659.659790,269.480469
	C659.406250,267.785980 659.020752,266.808655 658.635254,265.831329
	C658.405579,264.174530 658.176025,262.517700 657.964233,259.994263
	C657.997864,253.820068 658.060303,248.512161 658.020569,243.205017
	C657.920166,229.784637 657.773743,216.364578 657.645813,202.944397
	C657.707642,200.272476 657.769470,197.600540 657.882812,194.037872
	C657.966492,146.562424 658.000488,99.977745 658.014893,53.393059
	C658.015137,52.577103 657.778687,51.761070 657.652649,50.945076
	C657.796021,47.564564 657.939392,44.184052 658.611572,40.380501
	C659.845459,40.070900 660.550476,40.184330 661.227600,40.512161
	C661.517212,41.154312 661.834717,41.582062 662.233521,42.452110
	C662.361572,45.912170 662.408447,48.929935 662.268982,52.311516
	C662.033630,53.503716 661.941772,54.332108 661.941650,55.160503
	C661.933167,121.194511 661.927002,187.228516 661.958618,253.262512
	C661.959412,254.882965 662.385620,256.503235 662.552917,258.516907
	C662.888428,261.668060 663.284424,264.425934 663.647949,267.624634
	C664.919006,275.218414 666.222656,282.371399 667.402100,289.837402
	C667.691589,290.825592 668.105286,291.500732 668.649048,292.165741
	C668.779175,292.155609 668.991699,292.004303 668.973267,292.401642
	C669.452026,294.729340 669.798767,296.713654 670.469482,298.581665
	C677.278320,317.544098 686.831055,334.969147 699.808899,350.440430
	C721.924194,376.804626 750.185303,393.472870 783.001770,403.314575
	C783.710510,403.730560 784.355286,403.864899 785.298462,404.051025
	C785.999756,404.104523 786.402710,404.106293 786.914856,404.464111
	C788.374695,405.009338 789.725342,405.198547 791.460083,405.532104
	C796.215576,406.500885 800.586975,407.325348 805.197021,408.383209
	C806.309326,408.638184 807.182861,408.659698 808.482483,408.804504
	C811.248840,408.813354 813.589172,408.698883 816.209106,408.692078
	C817.004333,408.574463 817.520020,408.349121 818.433228,408.123444
	C820.530334,407.676056 822.229858,407.229034 824.347168,406.834839
	C827.790649,406.413727 830.816223,405.939789 834.005615,405.793640
	C834.808472,406.436188 835.447449,406.750916 835.896240,407.283936
	C835.137268,407.999420 834.568604,408.496704 833.999878,408.993958
	C833.104431,409.165100 832.209045,409.336212 830.645142,409.364075
	C829.297424,409.619476 828.618164,410.018066 827.938965,410.416687
	C827.208374,410.609161 826.477844,410.801636 825.192688,410.746643
	C824.064331,410.778412 823.490540,411.057617 822.916748,411.336853
	C822.642029,411.477783 822.350586,411.538300 821.457153,411.346436
	C819.896484,411.627686 818.921143,412.080963 817.945801,412.534210
	C816.893921,412.703430 815.841980,412.872620 814.159302,412.742798
	C812.026123,412.607208 810.523743,412.770630 809.021362,412.934021
	C808.267761,412.912018 807.514160,412.890015 806.284241,412.415955
	C803.206665,411.638123 800.605408,411.312347 798.004150,410.986603
	C797.252686,410.930328 796.501160,410.874023 795.270630,410.341156
	C793.672729,409.687195 792.553894,409.509796 791.435059,409.332428
z"/>
<path fill="#C1D0E5" opacity="1.000000" stroke="none"
	d="
M836.086426,407.065674
	C835.447449,406.750916 834.808472,406.436188 834.290161,405.584564
	C846.829712,400.254272 859.561768,396.128387 871.584106,390.489441
	C884.981934,384.205383 897.369873,375.994843 908.306885,365.851807
	C928.035400,347.555573 942.741821,325.944824 951.639893,300.200195
	C952.123779,299.316711 952.309448,298.564301 952.604614,297.446716
	C954.352417,290.724030 955.990784,284.366516 957.784546,277.886536
	C958.092896,277.516815 958.110413,277.260162 958.189575,276.662964
	C958.995239,270.218353 959.603760,264.104828 960.439636,257.593994
	C960.600342,254.793335 960.533691,252.389999 960.607605,249.600677
	C960.639771,248.138763 960.531311,247.062836 960.589539,245.548248
	C960.805298,244.280609 960.897400,243.451614 960.897522,242.622635
	C960.907410,178.598557 960.915588,114.574471 960.888977,50.550400
	C960.888062,48.402142 960.529846,46.254032 960.401672,43.697929
	C960.270386,42.214275 960.075500,41.138542 960.324951,40.026394
	C961.966736,40.036194 963.164246,40.082409 964.361694,40.128624
	C964.441833,43.117207 964.591492,46.105782 964.591980,49.094376
	C964.604370,120.078033 964.600769,191.061691 964.494751,262.828857
	C964.412415,264.433167 964.435364,265.253967 964.458313,266.074768
	C964.244690,267.117737 964.031067,268.160675 963.373901,269.696045
	C962.782104,270.993378 962.633911,271.798370 962.583252,272.890808
	C962.912415,273.496460 963.144043,273.814606 963.375732,274.132751
	C962.911438,276.448547 962.447144,278.764313 961.724670,281.702179
	C961.402039,282.900970 961.337708,283.477600 961.273376,284.054260
	C960.825195,285.772919 960.377075,287.491577 959.667603,289.770142
	C959.347473,290.914795 959.288757,291.499512 959.230042,292.084229
	C957.848145,296.138550 956.466248,300.192902 954.797974,304.787903
	C954.385803,305.903839 954.259949,306.479126 954.134094,307.054382
	C953.812378,307.833496 953.490662,308.612610 952.877563,309.847839
	C952.415283,310.875153 952.244446,311.446381 952.073669,312.017578
	C942.534302,332.785370 930.066223,351.570862 913.174316,367.050323
	C897.626465,381.298096 880.161255,392.749969 859.606201,400.233124
	C858.252380,400.669830 857.605103,401.155548 856.957825,401.641296
	C854.410889,402.537689 851.863953,403.434052 848.619019,404.249359
	C847.262695,404.595947 846.604248,405.023621 845.945801,405.451233
	C845.037537,405.718964 844.129272,405.986725 842.477112,406.197327
	C841.127441,406.526398 840.521667,406.912567 839.915955,407.298706
	C839.647522,407.451721 839.358887,407.522339 838.416870,407.340790
	C837.217957,407.135895 836.652161,407.100800 836.086426,407.065674
z"/>
<path fill="#93A6CB" opacity="1.000000" stroke="none"
	d="
M660.750977,36.468948
	C662.377441,35.996132 664.003601,35.110600 665.630432,35.109505
	C762.777771,35.043964 859.925171,35.048725 957.072571,35.079136
	C958.354187,35.079536 959.635742,35.493103 960.602051,36.222122
	C958.626160,36.812340 956.965454,36.965939 955.304810,36.965916
	C859.100159,36.964611 762.895447,36.953377 666.690796,36.918255
	C664.710815,36.917534 662.730896,36.625225 660.750977,36.468948
z"/>
<path fill="#D9EAFD" opacity="1.000000" stroke="none"
	d="
M660.431641,36.525009
	C662.730896,36.625225 664.710815,36.917534 666.690796,36.918255
	C762.895447,36.953377 859.100159,36.964611 955.304810,36.965916
	C956.965454,36.965939 958.626160,36.812340 960.752197,36.587223
	C961.636658,36.452271 962.055725,36.460518 962.846069,36.901825
	C963.542908,37.545609 963.868469,37.756336 964.194092,37.967045
	C964.294373,38.445141 964.394592,38.923252 964.428223,39.764992
	C963.164246,40.082409 961.966736,40.036194 960.113525,40.020821
	C959.457764,40.051662 959.069397,39.883030 958.963257,39.496281
	C957.318848,38.750000 955.780701,38.076488 954.242371,38.075809
	C858.844971,38.033665 763.447632,38.031052 668.050354,38.148067
	C665.784546,38.150845 663.520386,39.549938 661.255493,40.297760
	C660.550476,40.184330 659.845459,40.070900 658.785034,39.948338
	C658.389160,39.766235 658.348633,39.593262 658.567444,39.018936
	C658.910339,38.188545 658.993835,37.759502 659.077393,37.330452
	C659.422363,37.080662 659.767273,36.830868 660.431641,36.525009
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M657.295410,51.083450
	C657.778687,51.761070 658.015137,52.577103 658.014893,53.393059
	C658.000488,99.977745 657.966492,146.562424 657.789307,193.601486
	C657.112427,192.647125 656.118469,191.239243 656.115845,189.829514
	C656.033325,144.863037 656.039612,99.896370 656.083130,54.929787
	C656.084290,53.693523 656.640747,52.457798 657.295410,51.083450
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M657.289429,203.083893
	C657.773743,216.364578 657.920166,229.784637 658.020569,243.205017
	C658.060303,248.512161 657.997864,253.820068 657.858154,259.586426
	C657.170532,258.996857 656.121155,257.951294 656.115173,256.899719
	C656.017334,239.745682 656.040405,222.590836 656.092834,205.436340
	C656.095093,204.697861 656.640564,203.961029 657.289429,203.083893
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M798.261292,411.246399
	C800.605408,411.312347 803.206665,411.638123 805.927246,412.289459
	C803.537231,412.245422 801.027832,411.875824 798.261292,411.246399
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M809.255249,413.185974
	C810.523743,412.770630 812.026123,412.607208 813.758362,412.704865
	C812.488525,413.123260 810.988892,413.280579 809.255249,413.185974
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M964.724243,265.995850
	C964.435364,265.253967 964.412415,264.433167 964.633240,263.266815
	C964.914734,263.919830 964.952454,264.918396 964.724243,265.995850
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M963.592834,274.076843
	C963.144043,273.814606 962.912415,273.496460 962.819580,272.768341
	C963.292053,272.235535 963.625610,272.112732 963.959229,271.989899
	C963.909485,272.666901 963.859680,273.343903 963.592834,274.076843
z"/>
<path fill="#93A6CB" opacity="1.000000" stroke="none"
	d="
M658.465210,266.142822
	C659.020752,266.808655 659.406250,267.785980 659.650757,269.101746
	C659.104858,268.444855 658.700073,267.449585 658.465210,266.142822
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M818.279053,412.653717
	C818.921143,412.080963 819.896484,411.627686 821.240967,411.282043
	C820.610901,411.850830 819.611633,412.312042 818.279053,412.653717
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M791.641418,409.611511
	C792.553894,409.509796 793.672729,409.687195 794.924377,410.186768
	C793.987366,410.302887 792.917603,410.096741 791.641418,409.611511
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M835.896240,407.283936
	C836.652161,407.100800 837.217957,407.135895 838.199829,407.280701
	C837.322815,407.952271 836.029724,408.514191 834.368225,409.035034
	C834.568604,408.496704 835.137268,407.999420 835.896240,407.283936
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M823.112976,411.486481
	C823.490540,411.057617 824.064331,410.778412 824.811523,410.726013
	C824.426392,411.180634 823.867798,411.408356 823.112976,411.486481
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M828.234253,410.538513
	C828.618164,410.018066 829.297424,409.619476 830.302979,409.330627
	C829.929443,409.847046 829.229431,410.253693 828.234253,410.538513
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M840.145203,407.432495
	C840.521667,406.912567 841.127441,406.526398 842.118652,406.198303
	C841.794189,406.693024 841.084351,407.129639 840.145203,407.432495
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M785.525146,407.771851
	C786.173767,407.699951 787.006409,407.888977 787.937134,408.415466
	C787.259827,408.512878 786.484497,408.272827 785.525146,407.771851
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M747.695190,393.520935
	C748.317810,393.507721 749.087891,393.778687 749.951416,394.364136
	C749.310791,394.387421 748.576721,394.096252 747.695190,393.520935
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M774.636047,404.566895
	C775.248840,404.495239 776.032104,404.690155 776.937988,405.180481
	C776.309204,405.261688 775.557861,405.047577 774.636047,404.566895
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M846.249207,405.543457
	C846.604248,405.023621 847.262695,404.595947 848.250916,404.247314
	C847.904724,404.762756 847.228638,405.199219 846.249207,405.543457
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M768.658569,402.549652
	C769.264893,402.481750 770.043274,402.679840 770.941772,403.171631
	C770.318176,403.248749 769.574341,403.032196 768.658569,402.549652
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M857.271057,401.696777
	C857.605103,401.155548 858.252380,400.669830 859.244019,400.258789
	C858.920349,400.806396 858.252319,401.279327 857.271057,401.696777
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M763.611816,400.601318
	C764.231628,400.557465 765.034790,400.773102 765.944214,401.305420
	C765.298706,401.368317 764.546936,401.114532 763.611816,400.601318
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M959.507446,292.026611
	C959.288757,291.499512 959.347473,290.914795 959.651978,290.151123
	C959.860107,290.637756 959.822510,291.303406 959.507446,292.026611
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M952.353394,311.989716
	C952.244446,311.446381 952.415283,310.875153 952.867615,310.174072
	C952.977112,310.683441 952.805115,311.322662 952.353394,311.989716
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M954.413818,307.013123
	C954.259949,306.479126 954.385803,305.903839 954.771240,305.168152
	C954.918396,305.662445 954.806030,306.317139 954.413818,307.013123
z"/>
<path fill="#B0BDD8" opacity="1.000000" stroke="none"
	d="
M963.926514,271.641998
	C963.625610,272.112732 963.292053,272.235535 962.722107,272.480835
	C962.633911,271.798370 962.782104,270.993378 963.236938,270.072632
	C963.660339,270.402557 963.777100,270.848328 963.926514,271.641998
z"/>
<path fill="#516590" opacity="1.000000" stroke="none"
	d="
M961.545166,284.007080
	C961.337708,283.477600 961.402039,282.900970 961.719604,282.158356
	C961.920898,282.648224 961.868896,283.304077 961.545166,284.007080
z"/>
<path fill="#93A6CB" opacity="1.000000" stroke="none"
	d="
M660.413818,279.122437
	C660.945557,279.513275 661.327087,280.189270 661.573975,281.172302
	C661.047424,280.788727 660.655457,280.098145 660.413818,279.122437
z"/>
<path fill="#93A6CB" opacity="1.000000" stroke="none"
	d="
M659.650818,274.152161
	C660.068481,274.544830 660.298340,275.108398 660.308228,275.829102
	C659.879822,275.431824 659.671387,274.877411 659.650818,274.152161
z"/>
<path fill="#C4D0E9" opacity="1.000000" stroke="none"
	d="
M658.803833,37.376411
	C658.993835,37.759502 658.910339,38.188545 658.668396,38.772316
	C658.516724,38.425480 658.523499,37.923923 658.803833,37.376411
z"/>
<path fill="#C1D0E5" opacity="1.000000" stroke="none"
	d="
M964.163818,37.645279
	C963.868469,37.756336 963.542908,37.545609 963.130615,37.047127
	C963.407104,36.947411 963.770325,37.135452 964.163818,37.645279
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M116.359756,144.709412
	C115.483269,142.816284 114.872421,140.659470 114.167511,138.119232
	C114.530487,137.494125 114.987534,137.252457 115.721481,137.011688
	C116.207397,139.490311 116.416397,141.968002 116.359756,144.709412
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M171.220367,126.853745
	C170.752838,126.183342 170.535599,125.353432 170.462616,124.217087
	C170.894791,124.838516 171.182709,125.766380 171.220367,126.853745
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M171.745636,97.110718
	C172.247269,97.558563 172.487778,98.118607 172.546417,98.849197
	C172.071213,98.420799 171.777878,97.821861 171.745636,97.110718
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M204.778259,140.622864
	C204.492294,141.188599 204.035782,141.536575 203.275299,141.905975
	C203.516785,141.419968 204.062241,140.912537 204.778259,140.622864
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M212.932526,140.765930
	C213.444534,140.531937 214.020920,140.551468 214.794098,140.807343
	C214.326233,141.035599 213.661560,141.027527 212.932526,140.765930
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M164.485962,126.024673
	C164.474915,126.684868 164.133179,127.409973 163.491791,128.245636
	C163.513184,127.600639 163.834244,126.845116 164.485962,126.024673
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M177.706390,129.158203
	C178.268478,129.501129 178.600830,129.990509 178.843018,130.781387
	C178.327454,130.490158 177.902054,129.897400 177.706390,129.158203
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M191.822479,140.707352
	C192.165146,140.134048 192.831360,139.682877 193.805832,139.313385
	C193.458069,139.873199 192.802048,140.351334 191.822479,140.707352
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M173.592682,139.363480
	C173.061417,138.965988 172.683044,138.246872 172.413086,137.223633
	C172.929535,137.626968 173.337570,138.334427 173.592682,139.363480
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M212.927475,102.516418
	C213.465668,102.343323 214.047699,102.443314 214.814484,102.790688
	C214.323242,102.955215 213.647293,102.872360 212.927475,102.516418
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M166.570038,103.266586
	C166.005859,102.889023 165.599365,102.191956 165.290161,101.191063
	C165.834229,101.573853 166.280975,102.260468 166.570038,103.266586
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M166.328979,122.049667
	C166.454208,122.738556 166.248169,123.538589 165.765152,124.506180
	C165.658020,123.836082 165.827850,122.998444 166.328979,122.049667
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M168.754166,119.599800
	C168.517319,120.217171 168.094437,120.620132 167.363693,121.066628
	C167.559937,120.535240 168.064026,119.960312 168.754166,119.599800
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M591.473267,390.015198
	C590.132446,396.444153 586.802490,399.776764 580.623413,399.991852
	C567.338257,400.454407 554.041138,400.623566 540.747498,400.726135
	C539.085083,400.738922 537.414062,399.623505 535.564575,398.683044
	C547.689880,398.233398 560.023499,397.608582 572.296143,398.215576
	C580.331055,398.612915 586.462646,396.500031 591.473267,390.015198
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M601.785217,324.750977
	C590.368469,330.679657 578.679749,336.235107 567.136108,342.077087
	C565.427490,342.941803 561.758484,343.619537 564.028809,347.638214
	C560.426086,346.646973 560.352112,344.442871 563.002380,342.165649
	C565.239319,340.243591 567.855347,338.762695 570.650574,337.041779
	C578.670227,333.330383 586.286194,329.536560 594.050598,326.075806
	C596.337952,325.056305 599.045349,324.979309 601.785217,324.750977
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M529.947632,393.176636
	C523.649658,399.947357 515.780518,401.891693 507.008453,400.764587
	C504.960907,400.501526 502.987244,399.663300 500.835266,398.757294
	C502.841888,398.294098 505.137695,397.611145 507.117981,398.130737
	C514.598633,400.093536 520.700684,397.587372 526.478271,393.154755
	C527.228943,392.578796 528.707581,392.951691 529.947632,393.176636
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M589.731567,381.193970
	C590.538086,382.145935 591.115967,383.280426 591.610352,384.735901
	C590.852173,383.830109 590.177490,382.603271 589.731567,381.193970
z"/>
<path fill="#444662" opacity="1.000000" stroke="none"
	d="
M500.637695,398.031677
	C499.734406,397.870087 498.811279,397.340759 497.758728,396.496124
	C498.625458,396.675201 499.621674,397.169556 500.637695,398.031677
z"/>
<path fill="#DDDDE4" opacity="1.000000" stroke="none"
	d="
M349.959351,132.886307
	C352.052673,130.137558 353.949921,127.688423 356.509125,124.384735
	C358.725037,127.503517 360.706635,129.856125 362.112946,132.513199
	C362.592041,133.418411 362.039154,135.836823 361.243622,136.279053
	C358.122467,138.014160 354.774719,139.416122 351.374695,140.522614
	C350.528442,140.798019 348.183990,139.425201 348.222168,138.944443
	C348.376770,136.996429 349.191833,135.100830 349.959351,132.886307
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M385.363953,136.904724
	C384.946991,132.624649 384.918854,128.250000 385.006378,123.420074
	C388.513214,127.435005 387.194763,132.119751 385.363953,136.904724
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M327.562561,90.891800
	C327.175293,90.372063 327.049072,90.007904 326.904053,89.354950
	C327.913574,90.145279 328.941956,91.224396 329.982452,92.657303
	C329.270905,92.356514 328.547272,91.701942 327.562561,90.891800
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M385.054108,116.900894
	C384.679138,116.459885 384.558990,115.878853 384.610321,115.128639
	C384.957520,115.559937 385.133209,116.160408 385.054108,116.900894
z"/>
<path fill="#4C4D6B" opacity="1.000000" stroke="none"
	d="
M296.280029,386.135559
	C296.033722,385.515289 296.034760,385.141876 296.044586,384.491669
	C297.196838,383.167389 298.340332,382.119843 299.483826,381.072296
	C299.960602,381.185425 300.437408,381.298523 300.914215,381.411652
	C300.520416,383.345398 300.126617,385.279114 299.732788,387.212860
	C298.664307,386.936035 297.595825,386.659241 296.280029,386.135559
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M297.510010,403.724670
	C297.514801,404.453796 297.317383,404.970581 297.119995,405.487335
	C296.856415,405.356689 296.592804,405.226044 296.329224,405.095428
	C296.655396,404.567719 296.981598,404.040009 297.510010,403.724670
z"/>
<path fill="#434564" opacity="1.000000" stroke="none"
	d="
M301.577515,406.046326
	C301.197296,406.277557 300.819489,406.275452 300.443970,406.245361
	C300.432648,406.244476 300.444733,405.951416 300.445923,405.794556
	C300.824066,405.799347 301.202179,405.804138 301.577515,406.046326
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M90.902687,123.056580
	C90.749184,122.966568 90.595680,122.876556 90.296753,122.561371
	C90.466324,119.466324 90.781319,116.596436 91.096321,113.726555
	C91.624733,113.696869 92.153137,113.667191 92.681549,113.637512
	C94.975334,119.685616 96.548912,125.899467 96.339203,133.045898
	C96.481560,133.535339 96.504463,133.789948 96.434814,133.896027
	C95.004700,133.769379 93.644226,133.536652 92.036453,132.963684
	C92.216553,131.955917 92.643959,131.288391 93.511147,130.271576
	C93.661057,128.934814 93.371185,127.947357 93.081314,126.959900
	C92.745827,126.499413 92.410339,126.038933 92.257660,125.125359
	C91.927872,124.133705 91.415283,123.595146 90.902687,123.056580
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M73.477272,136.348328
	C72.114212,134.094238 70.929993,131.453537 69.809464,128.425232
	C71.134148,130.679001 72.395126,133.320374 73.477272,136.348328
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M48.247063,131.598236
	C48.661026,130.861404 49.024307,130.480499 49.624813,129.986389
	C49.216469,131.882812 48.570900,133.892426 47.595757,136.005493
	C47.576244,134.724014 47.886311,133.339096 48.247063,131.598236
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M55.649769,129.046265
	C55.370930,130.440628 54.706333,131.865250 53.749207,133.463974
	C54.059120,132.117554 54.661564,130.597031 55.649769,129.046265
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M80.378220,144.737671
	C79.609253,144.309128 79.095200,143.651428 78.492523,142.683167
	C79.146988,143.084564 79.890068,143.796524 80.378220,144.737671
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M35.990883,148.733841
	C36.700321,148.368362 37.499676,148.285141 38.693817,148.287048
	C38.086002,148.586823 37.083401,148.801453 35.990883,148.733841
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M110.739532,140.072723
	C110.593765,140.952545 110.094124,141.853287 109.298241,142.873230
	C109.463219,142.026169 109.924431,141.059906 110.739532,140.072723
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M81.938477,149.877380
	C81.323784,149.322968 80.775284,148.429718 80.333115,147.225861
	C80.961189,147.789673 81.482925,148.664108 81.938477,149.877380
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M44.944916,139.897400
	C44.869438,139.513733 44.886337,139.570404 44.855129,139.572754
	C45.056499,139.485809 45.289082,139.396530 45.873466,139.180939
	C46.047455,139.697784 45.869640,140.340973 45.423431,141.017792
	C45.110153,140.794632 45.065269,140.537857 44.944916,139.897400
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M88.140930,134.205704
	C88.504036,133.722321 89.011436,133.462463 89.805466,133.284973
	C89.489799,133.721298 88.887505,134.075256 88.140930,134.205704
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M131.238617,121.440430
	C130.966324,122.100777 130.344589,122.617668 129.404831,123.120461
	C129.687592,122.503227 130.288391,121.900101 131.238617,121.440430
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M67.012344,122.652107
	C66.448738,122.749916 65.882568,122.559372 65.184830,122.089348
	C65.705429,121.994499 66.357605,122.179123 67.012344,122.652107
z"/>
<path fill="#5E5E74" opacity="1.000000" stroke="none"
	d="
M126.023666,115.767906
	C126.272453,115.163918 126.856483,114.621628 127.754486,114.089218
	C127.498619,114.675949 126.928764,115.252777 126.023666,115.767906
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M75.968475,374.090088
	C76.945328,374.847473 77.655594,375.788422 78.560944,376.956573
	C78.861832,377.560242 78.967621,377.936707 79.161720,378.593079
	C78.067314,377.339874 76.884605,375.806763 75.968475,374.090088
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M64.950790,380.144440
	C64.761284,380.764526 64.213638,381.365387 63.353004,382.027893
	C63.557556,381.434753 64.075104,380.779999 64.950790,380.144440
z"/>
<path fill="#37395A" opacity="1.000000" stroke="none"
	d="
M115.111237,388.141602
	C114.996346,387.939056 115.360527,387.868774 115.544327,387.860962
	C115.924522,388.057312 116.120918,388.261475 116.317307,388.465637
	C115.953583,388.425140 115.589859,388.384674 115.111237,388.141602
z"/>
<path fill="#252751" opacity="1.000000" stroke="none"
	d="
M543.053040,134.004730
	C543.682861,134.768692 544.167236,135.892517 544.974060,136.218811
	C546.473938,136.825348 548.161865,136.966888 549.771484,137.302032
	C549.913940,135.782028 550.558228,134.094070 550.115051,132.770050
	C547.745239,125.689240 549.571228,119.611435 554.735168,114.744247
	C557.998657,111.668381 561.769104,110.474396 566.906982,112.072121
	C579.158386,115.881927 591.731567,118.657043 604.620605,122.245682
	C604.703613,125.140526 604.340759,127.639740 603.977905,130.138947
	C593.971008,131.645523 586.489563,138.329163 577.909973,142.777283
	C572.650208,145.504242 567.078979,147.625793 561.783875,150.290085
	C555.455200,153.474426 550.065308,151.301804 545.638123,147.041977
	C542.775940,144.287994 541.105591,140.295380 539.145081,136.297241
	C540.610352,135.159348 541.831726,134.582047 543.053040,134.004730
M582.912781,125.918999
	C578.155579,124.305832 573.460938,122.458321 568.618103,121.165916
	C565.632690,120.369194 562.402039,120.027603 559.315979,120.180275
	C554.605835,120.413300 550.741943,124.066162 551.279114,127.886429
	C551.796021,131.563492 552.766174,135.343582 554.390442,138.660599
	C557.083130,144.159698 569.820618,142.080536 574.043884,135.440460
	C574.043884,135.440460 574.377014,135.380890 575.143738,135.711258
	C579.001404,134.126144 582.907959,132.644211 586.672119,130.861557
	C587.355652,130.537857 587.456421,128.983719 587.826233,127.997627
	C586.888000,127.646957 585.949768,127.296288 584.362122,126.948868
	C583.948120,126.828262 583.534058,126.707657 582.912781,125.918999
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M543.013428,133.624512
	C541.831726,134.582047 540.610352,135.159348 539.081726,135.938446
	C537.503174,129.861679 535.502441,123.628212 535.111145,117.295280
	C534.272522,103.725594 534.768799,90.066879 533.755310,76.516640
	C532.971375,66.035355 530.437134,55.694912 529.290710,45.225094
	C528.918945,41.829834 530.477173,38.223251 531.152588,34.713326
	C531.591248,34.641399 532.029846,34.569469 532.468445,34.497543
	C533.313354,38.150658 534.532227,41.763718 534.928650,45.464874
	C535.879944,54.345074 536.645874,63.255947 537.121033,72.173920
	C537.941223,87.567673 538.227844,102.993896 539.289185,118.368462
	C539.635681,123.387932 541.696777,128.289047 543.013428,133.624512
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M604.374451,130.136383
	C604.340759,127.639740 604.703613,125.140526 605.028809,122.267746
	C606.355652,122.604065 608.962341,123.550140 608.879700,123.984879
	C608.404541,126.483978 608.700562,129.856323 604.374451,130.136383
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M49.555058,66.438644
	C42.143047,69.896713 35.076805,73.190422 28.010559,76.484131
	C27.578136,75.860306 27.145712,75.236481 26.713289,74.612663
	C31.806108,70.411446 36.898930,66.210228 41.991749,62.009007
	C42.120785,62.544586 42.249817,63.080162 42.378849,63.615738
	C45.086189,63.457760 48.093731,64.017082 50.453812,63.029358
	C71.019791,54.422234 91.475548,45.551311 111.944305,36.713032
	C113.741280,35.937115 115.397713,34.835720 118.361389,33.200047
	C115.300705,38.129105 67.999329,60.295799 49.555058,66.438644
z"/>
<path fill="#F7F8FA" opacity="1.000000" stroke="none"
	d="
M436.781555,238.988617
	C432.292145,243.301971 427.042633,245.776993 420.354614,245.816452
	C405.848053,243.718552 405.846436,243.718552 405.846710,229.584381
	C405.846924,218.610123 406.064117,207.629822 405.752869,196.664474
	C405.623688,192.113739 407.840942,190.523788 411.622772,189.614227
	C418.282715,188.012482 424.805603,188.343933 431.637634,190.674988
	C437.056641,193.977432 440.626007,198.349136 442.292114,204.884842
	C442.765839,206.878586 443.194824,208.183716 443.623779,209.488846
	C443.623047,209.828827 443.622284,210.168808 443.547394,211.097565
	C443.599121,215.464066 443.725006,219.241821 443.850891,223.019562
	C443.758453,223.348648 443.666016,223.677719 443.325684,224.465790
	C442.928528,225.989273 442.779327,227.053741 442.630096,228.118210
	C442.002167,229.683197 441.374207,231.248199 440.443481,233.344666
	C439.794495,234.592819 439.448334,235.309479 439.102173,236.026138
	C439.102173,236.026138 438.821594,236.266541 438.496063,236.583649
	C437.707550,237.596725 437.244537,238.292664 436.781555,238.988617
z"/>
<path fill="#212550" opacity="1.000000" stroke="none"
	d="
M402.003418,203.601166
	C402.049164,199.640686 402.049164,196.120468 402.049164,192.600266
	C402.480927,192.594162 402.912659,192.588074 403.344421,192.581970
	C403.344421,207.508743 403.344421,222.435516 403.344421,237.362289
	C402.882172,237.385895 402.419922,237.409485 401.957672,237.433090
	C401.957672,226.302536 401.957672,215.171982 402.003418,203.601166
z"/>
<path fill="#212550" opacity="1.000000" stroke="none"
	d="
M402.569550,240.495117
	C403.052917,240.552490 403.347595,240.795868 403.642303,241.039246
	C403.450195,241.229660 403.258057,241.420074 403.065948,241.610489
	C402.837585,241.300705 402.609222,240.990921 402.569550,240.495117
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M468.875549,127.732407
	C463.393860,130.112503 460.797028,128.741806 458.044525,121.214935
	C463.117950,121.458237 467.850220,121.379471 472.484436,122.015335
	C475.552704,122.436340 474.740479,124.173386 472.380066,125.865685
	C470.943512,126.701118 469.909515,127.216759 468.875549,127.732407
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M448.326660,128.630234
	C447.995819,128.618225 447.688751,128.526520 447.213623,128.207932
	C445.586823,127.005661 444.151917,125.950546 441.701843,124.148956
	C442.271149,122.269028 443.092346,119.557220 444.020508,116.487122
	C448.703400,115.059227 453.293610,114.045929 457.847870,112.890907
	C459.550354,112.459129 461.169037,111.696953 462.946869,110.757919
	C465.078766,110.343643 467.089722,110.256874 469.513428,110.306091
	C470.528229,111.111168 471.130249,111.780258 471.911865,112.668533
	C471.714752,113.195198 471.255432,113.832397 470.973480,113.761749
	C464.627258,112.171577 458.704407,113.922440 452.823669,115.984306
	C450.309387,116.865860 447.828003,117.841270 443.918152,119.302193
	C446.396729,122.605286 448.159515,124.954506 449.529144,127.771820
	C448.866211,128.370026 448.596436,128.500122 448.326660,128.630234
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M485.562469,116.040482
	C486.239075,116.164146 486.536285,116.300751 486.944183,116.661896
	C486.696960,120.019211 486.339020,123.151978 486.002075,126.670074
	C485.397614,127.513176 484.772186,127.970955 483.849915,128.437897
	C482.677826,128.319443 481.802612,128.191864 480.485718,128.055862
	C485.541016,120.658310 485.536957,120.664909 477.161621,115.499641
	C476.190491,114.900726 475.294952,114.179169 474.162659,113.233688
	C477.701630,113.986412 481.442322,115.019920 485.562469,116.040482
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M457.955688,132.749405
	C455.836304,132.093307 453.731171,131.051987 451.260620,130.057770
	C450.895203,130.104874 450.936890,130.087830 450.953369,129.758133
	C450.930420,128.974594 450.890991,128.520752 450.851532,128.066910
	C453.224365,129.499329 455.597168,130.931747 457.955688,132.749405
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M469.048126,128.078674
	C469.909515,127.216759 470.943512,126.701118 472.327393,126.171623
	C472.462921,127.320190 472.248505,128.482620 472.034119,129.645035
	C471.096283,129.238342 470.158508,128.831650 469.048126,128.078674
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M464.003723,142.344421
	C463.311035,142.777542 462.557220,142.925293 461.418701,143.068665
	C461.197083,142.506485 461.360229,141.948654 461.765320,141.213379
	C462.652374,141.376938 463.297516,141.717987 464.003723,142.344421
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M479.670532,128.035110
	C479.242828,128.692627 478.454254,129.340866 477.349182,130.042389
	C477.791626,129.405731 478.550659,128.715790 479.670532,128.035110
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M472.697418,133.984222
	C472.819183,134.489883 472.675873,134.992981 472.259338,135.782227
	C472.134857,135.372803 472.283600,134.677231 472.697418,133.984222
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M450.641357,128.060410
	C450.890991,128.520752 450.930420,128.974594 450.941589,129.770111
	C450.158875,129.797821 449.404388,129.483856 448.488281,128.900055
	C448.596436,128.500122 448.866211,128.370026 449.573486,128.137878
	C450.010986,128.035828 450.431183,128.053909 450.641357,128.060410
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M477.974731,140.587692
	C478.496552,140.391708 479.063293,140.464798 479.818054,140.769623
	C479.343933,140.953156 478.681824,140.904953 477.974731,140.587692
z"/>
<path fill="#EBECF2" opacity="1.000000" stroke="none"
	d="
M478.184021,211.084381
	C478.128937,206.669479 478.249969,202.355087 478.263214,198.040344
	C478.290161,189.255920 480.202148,187.669373 489.521667,189.180862
	C492.097382,192.819962 494.229431,196.464386 496.349731,200.916306
	C496.438446,203.528931 496.538879,205.334061 496.639343,207.139191
	C496.390167,208.150589 496.141022,209.161972 495.854523,210.563110
	C490.275787,216.682526 486.809113,216.851837 478.661713,211.641495
	C478.320007,211.508881 478.311401,211.184708 478.184021,211.084381
z"/>
<path fill="#212550" opacity="1.000000" stroke="none"
	d="
M98.984871,217.000000
	C98.381332,207.176315 100.431961,197.692459 97.244278,187.787384
	C100.951263,187.787384 104.652115,187.787384 107.100014,187.787384
	C106.454056,192.160721 105.263222,196.822617 105.169159,201.506546
	C104.902176,214.800781 105.084457,228.104004 105.087486,241.403687
	C105.088989,248.012512 105.086655,248.012207 98.238831,247.975174
	C97.579155,247.971603 96.919441,247.974701 95.633003,247.974701
	C101.253494,241.425308 98.306503,233.959793 98.937073,226.971741
	C99.219795,223.838562 98.984901,220.658691 98.984871,217.000000
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M426.032776,63.964088
	C426.912689,64.390732 427.763031,64.848557 428.613342,65.306366
	C428.210938,65.758659 427.808533,66.210953 427.406128,66.663239
	C426.915161,66.026512 426.424194,65.389778 425.937378,64.404137
	C425.941528,64.055229 426.003174,63.995270 426.032776,63.964088
z"/>
<path fill="#6B6D84" opacity="1.000000" stroke="none"
	d="
M432.036011,62.550167
	C432.452637,62.323494 432.817017,62.309204 433.710205,62.438168
	C433.487274,62.641796 432.735474,62.702175 432.036011,62.550167
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M439.052185,141.573380
	C441.028107,141.131958 443.106384,141.041916 445.615906,141.076111
	C443.749603,141.441818 441.452087,141.683289 439.052185,141.573380
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M422.382385,117.700699
	C422.999481,118.026703 423.485596,118.704018 423.920410,119.708023
	C423.329865,119.373825 422.790619,118.712921 422.382385,117.700699
z"/>
<path fill="#E5E7EF" opacity="1.000000" stroke="none"
	d="
M273.448486,216.504425
	C273.975159,215.555435 274.501801,214.606430 275.158569,213.026855
	C275.709442,211.146179 276.130219,209.896042 276.551025,208.645920
	C277.172668,207.403687 277.794281,206.161453 278.389221,204.563995
	C278.362549,204.208755 278.526794,203.927856 278.776306,203.573792
	C279.259766,202.456070 279.493683,201.692444 279.727600,200.928802
	C279.727600,200.928802 280.004700,200.590836 280.372986,200.357437
	C281.167419,200.067703 281.593628,200.011353 282.019806,199.955017
	C282.050568,200.125610 282.081329,200.296204 282.181091,200.995178
	C282.678253,202.205780 283.106445,202.888016 283.534607,203.570251
	C285.436859,209.333542 287.359161,215.090378 289.219238,220.867249
	C289.491028,221.711304 289.466339,222.650833 288.822998,223.653870
	C282.452118,223.753326 276.837128,223.745087 271.170044,223.361877
	C271.448334,221.305008 271.778748,219.623108 272.109161,217.941208
	C272.109161,217.941208 272.216003,217.745865 272.395996,217.521027
	C272.866852,217.032257 273.157684,216.768341 273.448486,216.504425
z"/>
<path fill="#52556F" opacity="1.000000" stroke="none"
	d="
M271.222137,223.736847
	C276.837128,223.745087 282.452118,223.753326 288.524475,223.861816
	C289.248322,224.463684 289.514801,224.965286 289.906769,225.722580
	C283.661377,225.986923 277.290497,225.995605 270.596039,225.710052
	C270.588989,224.856171 270.905579,224.296509 271.222137,223.736847
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M279.391968,201.023972
	C279.493683,201.692444 279.259766,202.456070 278.779419,203.411133
	C278.707458,202.774734 278.881866,201.946930 279.391968,201.023972
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M282.018890,199.642120
	C281.593628,200.011353 281.167419,200.067703 280.419312,200.143875
	C280.278107,199.607468 280.458801,199.051224 280.639526,198.494980
	C281.098999,198.773056 281.558502,199.051147 282.018890,199.642120
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M283.659698,203.243759
	C283.106445,202.888016 282.678253,202.205780 282.321411,201.214081
	C282.856781,201.575500 283.320801,202.246384 283.659698,203.243759
z"/>
<path fill="#E3E3E9" opacity="1.000000" stroke="none"
	d="
M49.956490,224.950531
	C49.572937,224.860550 49.189381,224.770584 48.507629,224.698929
	C43.599922,223.800583 42.570801,221.963531 44.999310,217.361404
	C47.891006,211.881500 49.592037,205.773270 51.947182,199.612457
	C52.902760,199.691498 54.268036,199.925262 54.454247,200.525085
	C56.790237,208.049713 58.955677,215.627289 60.601929,223.513153
	C56.678207,224.206833 53.317348,224.578690 49.956490,224.950531
z"/>
<path fill="#3C3C5B" opacity="1.000000" stroke="none"
	d="
M50.234138,225.261353
	C53.317348,224.578690 56.678207,224.206833 60.475430,223.813934
	C60.946243,224.252182 60.980690,224.711502 61.028336,225.513580
	C57.531620,225.761627 54.021706,225.666901 50.234138,225.261353
z"/>
<path fill="#BAB9C5" opacity="1.000000" stroke="none"
	d="
M379.717102,127.279099
	C380.121490,129.157700 380.312988,131.334183 380.218475,133.764923
	C379.789703,131.871796 379.646973,129.724380 379.717102,127.279099
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M256.712860,443.197632
	C257.071808,443.879517 257.246613,444.769745 257.159912,445.836060
	C256.775177,445.143433 256.651978,444.274689 256.712860,443.197632
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M256.224121,449.613525
	C256.347626,450.259064 256.208801,451.075500 255.744446,451.998444
	C255.599854,451.331451 255.780823,450.557953 256.224121,449.613525
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M255.331085,437.201294
	C255.860794,437.570465 256.312805,438.243958 256.628784,439.238464
	C256.079651,438.874878 255.666519,438.190277 255.331085,437.201294
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M444.163361,222.746643
	C443.725006,219.241821 443.599121,215.464066 443.649506,211.333954
	C444.042450,214.812286 444.259155,218.643021 444.163361,222.746643
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M443.751343,209.119690
	C443.194824,208.183716 442.765839,206.878586 442.455872,205.227600
	C443.009552,206.171356 443.444244,207.460953 443.751343,209.119690
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M442.946442,227.972717
	C442.779327,227.053741 442.928528,225.989273 443.348389,224.722839
	C443.500275,225.622986 443.381531,226.725113 442.946442,227.972717
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M437.067230,238.990814
	C437.244537,238.292664 437.707550,237.596725 438.458862,236.764618
	C438.644653,237.268280 438.542114,237.908066 438.181885,238.766617
	C437.733826,238.987900 437.543396,238.990448 437.067230,238.990814
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M439.452576,235.973099
	C439.448334,235.309479 439.794495,234.592819 440.398010,233.702866
	C440.371185,234.326401 440.087067,235.123230 439.452576,235.973099
z"/>
<path fill="#C5C4CB" opacity="1.000000" stroke="none"
	d="
M517.903992,128.623749
	C516.691772,127.967628 515.479553,127.311508 513.737305,126.302628
	C512.927551,124.984970 512.647888,124.020065 512.368164,123.055161
	C513.540710,122.899712 514.872681,122.321190 515.848145,122.688713
	C517.283813,123.229622 518.465271,124.445374 519.755005,125.373657
	C519.755005,125.373657 519.738464,125.727341 519.719666,126.175964
	C519.731873,127.024666 519.762817,127.424744 519.793823,127.824829
	C519.793823,127.824829 519.962402,128.012314 519.549988,127.998497
	C518.726379,128.197708 518.315186,128.410721 517.903992,128.623749
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M519.807007,124.997627
	C518.465271,124.445374 517.283813,123.229622 515.848145,122.688713
	C514.872681,122.321190 513.540710,122.899712 512.368164,123.055161
	C512.647888,124.020065 512.927551,124.984970 513.396240,126.247566
	C510.752808,127.228172 509.446075,125.375244 510.259338,123.341042
	C510.833069,121.905876 513.593201,120.172951 514.916687,120.490776
	C516.786926,120.939934 518.232117,123.159081 519.807007,124.997627
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M514.895508,138.760864
	C513.906982,138.755600 512.864197,138.359451 511.628601,137.675705
	C512.570923,137.715393 513.706116,138.042694 514.895508,138.760864
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M518.007202,128.872726
	C518.315186,128.410721 518.726379,128.197708 519.473267,127.898956
	C519.242798,128.249390 518.676636,128.685547 518.007202,128.872726
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M520.102783,127.843979
	C519.762817,127.424744 519.731873,127.024666 519.794312,126.336472
	C520.416016,126.273270 520.944275,126.498177 521.472534,126.723076
	C521.118958,127.103096 520.765320,127.483109 520.102783,127.843979
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M510.720459,115.900558
	C510.866486,115.973892 511.017609,116.107559 511.168701,116.241226
	C511.077118,116.191917 510.985535,116.142601 510.752136,116.008560
	C510.610321,115.923851 510.725586,115.960892 510.720459,115.900558
z"/>
<path fill="#252751" opacity="1.000000" stroke="none"
	d="
M589.339050,226.113464
	C588.776001,225.337311 588.515991,224.754745 588.033936,223.666763
	C587.643616,221.978729 587.475403,220.796097 587.488586,219.306519
	C587.240295,218.294891 586.810608,217.590225 586.224060,216.553467
	C585.411377,214.140533 584.755493,212.059723 584.324341,209.823425
	C584.091064,209.091095 583.633057,208.514236 583.030273,207.623016
	C582.691223,206.408478 582.496948,205.508286 582.478027,204.288666
	C582.181396,203.287384 581.709351,202.605545 581.137329,201.696121
	C581.037354,201.468521 581.009583,200.972122 581.065552,200.603256
	C580.104492,199.554489 579.087402,198.874603 578.070312,198.194702
	C578.070312,198.194702 577.951538,198.018799 577.866638,197.950745
	C579.107178,193.566498 580.432617,189.250336 581.758057,184.934174
	C591.972351,205.561188 595.575562,228.141510 606.978699,247.806671
	C603.831238,247.806671 600.434937,247.806671 598.164246,247.806671
	C595.212463,240.359955 592.427307,233.333511 589.339050,226.113464
z"/>
<path fill="#E5E7EF" opacity="1.000000" stroke="none"
	d="
M581.009583,200.972122
	C581.009583,200.972122 581.037354,201.468521 581.051636,202.000763
	C581.478149,203.224686 581.890381,203.916397 582.302673,204.608093
	C582.496948,205.508286 582.691223,206.408478 582.955688,207.930511
	C583.383728,209.027878 583.741699,209.503403 584.099609,209.978912
	C584.755493,212.059723 585.411377,214.140533 586.139160,216.858536
	C586.576355,218.201630 586.941711,218.907547 587.307129,219.613464
	C587.475403,220.796097 587.643616,221.978729 587.740967,223.519577
	C581.913391,223.877792 576.156677,223.877792 569.478271,223.877792
	C572.512207,215.851135 575.186096,208.777145 578.192993,201.262665
	C579.353882,200.872147 580.181702,200.922134 581.009583,200.972122
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M581.065552,200.603256
	C580.181702,200.922134 579.353882,200.872147 578.257507,200.898102
	C578.001099,200.276657 578.013184,199.579269 578.047791,198.538300
	C579.087402,198.874603 580.104492,199.554489 581.065552,200.603256
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M302.511902,86.770370
	C297.959290,86.749008 293.775116,86.556099 289.590912,86.363182
	C289.328003,86.044800 289.065094,85.726418 288.802155,85.408035
	C290.768158,84.237038 292.627411,82.784447 294.734528,81.985664
	C296.369965,81.365669 298.314545,81.438187 300.122314,81.433182
	C301.657684,81.428932 303.193970,81.753860 304.729828,81.933144
	C304.113342,83.488373 303.496826,85.043602 302.511902,86.770370
z"/>
<path fill="#E5E7EF" opacity="1.000000" stroke="none"
	d="
M514.329163,443.309723
	C513.592773,439.724121 513.222900,435.974609 512.926270,431.808014
	C518.692078,430.463623 521.088440,431.633881 521.731262,435.655212
	C522.416382,439.940643 520.593628,441.881287 514.329163,443.309723
z"/>
<path fill="#606178" opacity="1.000000" stroke="none"
	d="
M496.935120,206.988998
	C496.538879,205.334061 496.438446,203.528931 496.487915,201.293091
	C496.835541,202.854507 497.033234,204.846664 496.935120,206.988998
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M348.246094,286.178772
	C347.972412,279.307037 347.970886,272.623047 347.980164,265.470703
	C348.511475,264.281311 349.031921,263.560303 350.132141,262.036072
	C350.132141,270.628662 350.139923,278.313721 350.064972,285.997986
	C350.063721,286.125854 349.056183,286.243896 348.246094,286.178772
z"/>
<path fill="#8F8F9F" opacity="1.000000" stroke="none"
	d="
M57.480797,446.015625
	C57.677914,443.240234 58.281837,440.494843 58.945541,437.380188
	C60.001133,439.731384 60.996952,442.451874 61.984055,445.578247
	C60.612759,446.004669 59.250179,446.025116 57.480797,446.015625
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M350.946533,66.133987
	C351.556519,65.147980 352.236328,64.438629 353.194214,63.639027
	C354.998566,62.949512 356.524811,62.350258 358.060577,61.747280
	C356.344299,59.221279 355.242828,57.600121 354.228760,55.646194
	C355.600372,55.213020 356.884583,55.112610 358.562195,55.014198
	C359.045624,55.152187 359.131836,55.290897 359.226318,55.423752
	C360.800934,57.638596 362.376587,59.852684 363.951996,62.066948
	C361.317535,63.687859 358.707336,65.350494 356.034027,66.904579
	C355.217773,67.379105 354.227966,67.555161 352.583679,67.617699
	C351.579956,67.238594 351.310242,67.109688 351.040497,66.980782
	C351.032440,66.790741 351.024384,66.600693 350.946533,66.133987
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M351.167419,67.266632
	C351.310242,67.109688 351.579956,67.238594 352.193878,67.659805
	C352.538055,67.952103 352.432861,68.114700 352.375916,68.193504
	C351.977417,68.032364 351.635864,67.792419 351.167419,67.266632
z"/>
<path fill="#282847" opacity="1.000000" stroke="none"
	d="
M391.384277,448.039673
	C391.176788,450.210358 391.431732,452.110504 390.956635,453.806152
	C390.585785,455.129669 389.308044,456.199097 387.619812,458.481079
	C387.619812,453.338623 387.619812,449.983887 387.619812,446.509583
	C391.154572,445.589447 391.154572,445.589447 391.384277,448.039673
z"/>
<path fill="#FAFAFB" opacity="1.000000" stroke="none"
	d="
M463.993225,89.004700
	C464.328552,89.197655 464.557861,89.489555 464.787170,89.781456
	C464.502167,89.804161 464.217163,89.826866 463.801056,89.572693
	C463.669952,89.295807 463.887177,89.103645 463.993225,89.004700
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M426.443054,35.568787
	C426.392731,35.490322 426.595367,35.461189 426.595367,35.461189
	C426.595367,35.461189 426.493378,35.647247 426.443054,35.568787
z"/>
<path fill="#4B4B64" opacity="1.000000" stroke="none"
	d="
M360.988556,272.985626
	C360.845947,273.183716 360.719971,273.400269 360.593994,273.616852
	C360.602356,273.402222 360.610657,273.187622 360.829346,273.006409
	C361.039764,273.039825 361.005188,273.004089 360.988556,272.985626
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M271.170044,223.361877
	C270.905579,224.296509 270.588989,224.856171 270.126465,225.702774
	C269.385803,226.321243 268.791107,226.652771 267.851379,226.998840
	C268.790100,224.013657 270.073822,221.013901 271.733368,217.977692
	C271.778748,219.623108 271.448334,221.305008 271.170044,223.361877
z"/>
<path fill="#2F325C" opacity="1.000000" stroke="none"
	d="
M276.419617,208.315918
	C276.130219,209.896042 275.709442,211.146179 275.111908,212.685349
	C271.148651,211.733337 274.051971,209.764755 274.499481,208.129013
	C274.553131,207.932877 275.666199,208.026566 276.419617,208.315918
z"/>
<path fill="#28294D" opacity="1.000000" stroke="none"
	d="
M273.315491,216.176239
	C273.157684,216.768341 272.866852,217.032257 272.312683,217.447235
	C272.146301,216.692169 272.243286,215.786041 272.340271,214.879929
	C272.621002,215.202621 272.901764,215.525330 273.315491,216.176239
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M93.048141,127.354874
	C93.371185,127.947357 93.661057,128.934814 93.654602,130.008759
	C93.243843,129.313431 93.129410,128.531647 93.048141,127.354874
z"/>
<path fill="#4D4C64" opacity="1.000000" stroke="none"
	d="
M90.920937,123.359436
	C91.415283,123.595146 91.927872,124.133705 92.208908,124.840378
	C91.977348,125.008484 91.554306,124.997002 91.355255,124.925560
	C91.083870,124.456841 91.011528,124.059563 90.920937,123.359436
z"/>
<path fill="#295279" opacity="1.000000" stroke="none"
	d="
M959.069397,39.883030
	C959.069397,39.883030 959.457764,40.051662 959.669189,40.057236
	C960.075500,41.138542 960.270386,42.214275 959.933105,43.668602
	C958.476440,44.115280 957.551941,44.183357 956.303467,44.176079
	C955.315796,44.085205 954.652039,44.069687 953.593750,43.987198
	C952.136047,43.962868 951.072937,44.005508 949.612671,43.956127
	C948.138062,43.939522 947.060547,44.014938 945.572205,44.025841
	C943.777893,43.988083 942.394409,44.014843 940.591187,43.943336
	C938.458191,43.865986 936.744934,43.886898 934.564087,43.868202
	C929.069092,43.905334 924.041626,43.982075 918.558105,43.959808
	C914.061768,43.933228 910.021606,44.005657 905.542603,44.016388
	C902.741821,43.994686 900.379944,44.034679 897.557129,43.970539
	C875.058044,43.936852 853.019836,44.007301 830.517822,44.015228
	C823.375488,43.994404 816.697021,44.036098 809.557678,43.973312
	C801.725037,43.938351 794.353394,44.007866 786.523315,44.015240
	C782.049622,43.996292 778.034424,44.039490 773.558228,43.977928
	C765.058472,43.943882 757.019592,44.014584 748.518738,44.022232
	C743.043945,43.998562 738.031250,44.037945 732.557495,43.973122
	C722.057556,43.941708 712.018616,44.014496 701.519531,44.025352
	C696.697815,43.950779 692.336121,43.938133 687.552856,43.843338
	C685.417969,43.851185 683.704712,43.941181 681.529907,43.975113
	C677.010803,43.816605 672.953369,43.714153 668.628845,43.404961
	C663.931946,43.204235 665.103333,46.576382 665.101318,48.948437
	C665.045349,113.209488 664.981812,177.470749 665.137024,241.731461
	C665.153503,248.561157 666.508423,255.387634 667.194763,262.593079
	C667.109680,263.985687 667.072205,265.000824 666.678101,266.042664
	C665.441101,266.440857 664.560730,266.812317 663.680420,267.183777
	C663.284424,264.425934 662.888428,261.668060 662.870483,258.331238
	C663.483826,256.316833 663.924255,254.881500 663.924988,253.445923
	C663.957642,187.897644 663.962585,122.349350 663.887939,56.801151
	C663.886108,55.182796 662.953674,53.565495 662.455261,51.947704
	C662.408447,48.929935 662.361572,45.912170 662.636719,42.263130
	C665.126526,41.092102 667.296448,40.073425 669.461853,40.082951
	C717.923401,40.296215 766.384277,40.662315 814.845764,40.882271
	C821.638184,40.913097 828.435364,40.041660 835.226746,40.090275
	C854.191772,40.226028 873.154236,40.764812 892.119141,40.864632
	C902.245789,40.917931 912.374023,40.302795 922.504028,40.152683
	C934.691162,39.972099 946.880798,39.965153 959.069397,39.883030
z"/>
<path fill="#315882" opacity="1.000000" stroke="none"
	d="
M960.212280,257.991333
	C959.603760,264.104828 958.995239,270.218353 957.922363,276.666504
	C957.237976,277.145386 957.017822,277.289612 956.797668,277.433838
	C957.074829,277.625580 957.352051,277.817291 957.629150,278.009003
	C955.990784,284.366516 954.352417,290.724030 952.314575,297.571472
	C951.723999,298.817963 951.532837,299.574615 951.341614,300.331238
	C942.741821,325.944824 928.035400,347.555573 908.306885,365.851807
	C897.369873,375.994843 884.981934,384.205383 871.584106,390.489441
	C859.561768,396.128387 846.829712,400.254272 834.126282,405.256775
	C830.816223,405.939789 827.790649,406.413727 824.227417,406.572968
	C823.462036,405.535645 823.234253,404.813049 823.399841,404.052368
	C826.522095,402.958130 829.251038,401.902008 832.290466,400.826843
	C833.012146,400.754669 833.423279,400.701569 834.223145,400.717346
	C838.070496,399.488464 841.529053,398.190704 845.324829,396.871063
	C846.335754,396.797424 847.009399,396.745728 848.017578,396.755127
	C848.921753,396.267334 849.491394,395.718475 850.398804,395.110657
	C851.417480,394.969299 852.098328,394.886932 853.104370,394.837860
	C853.980164,394.331360 854.530823,393.791565 855.410767,393.172974
	C856.408630,392.988983 857.077209,392.883789 858.124756,392.819031
	C861.024658,391.296600 863.545654,389.733765 866.348877,388.099365
	C867.012695,387.957397 867.394165,387.886993 868.133789,387.848999
	C869.687012,387.000977 870.882080,386.120544 872.428589,385.155609
	C874.464966,384.349915 876.149841,383.628662 878.197632,382.907593
	C880.391113,381.380585 882.221802,379.853333 884.375366,378.231506
	C885.723572,377.707550 886.748779,377.278229 888.125427,376.873108
	C889.637695,375.899750 890.798645,374.902191 892.183472,373.652649
	C895.910400,370.571167 899.413452,367.741669 903.234131,364.803101
	C905.664673,362.765747 907.777588,360.837463 910.162964,358.760376
	C911.254150,357.693207 912.072815,356.774811 913.200195,355.760925
	C913.991577,354.765991 914.474182,353.866486 914.977173,352.982269
	C914.997559,352.997559 914.966064,352.957153 915.306702,352.930603
	C916.421204,351.927399 917.195129,350.950714 918.202393,349.813843
	C918.675110,349.149353 918.914429,348.645111 919.473877,348.052338
	C921.842712,345.290497 923.891235,342.617188 925.997437,339.744934
	C926.055054,339.545959 926.142883,339.141083 926.447876,339.058105
	C927.146362,338.300995 927.539917,337.626892 927.984985,336.745239
	C928.036621,336.537750 928.112244,336.116821 928.447144,336.047913
	C929.816772,334.293762 930.851501,332.608521 932.022034,330.687439
	C932.397766,329.969177 932.637634,329.486755 933.141968,328.850006
	C933.575378,328.129700 933.744385,327.563721 934.195618,326.819336
	C935.597717,324.726776 936.717590,322.812653 937.928223,320.546204
	C939.116150,317.524719 940.213440,314.855530 941.609741,312.064880
	C942.849609,309.904449 943.790344,307.865417 944.909180,305.505310
	C946.359863,301.133362 947.632446,297.082489 949.219421,292.833893
	C949.951721,290.707275 950.369568,288.778351 950.845398,286.632385
	C950.903320,286.415344 951.078491,286.001648 951.414917,285.940155
	C952.161438,284.912994 952.571594,283.947327 952.973389,282.638824
	C952.909180,281.842682 952.853271,281.389343 952.856323,280.616333
	C952.941772,279.864471 952.968262,279.432251 953.295776,278.827209
	C954.020386,277.158752 954.444031,275.663177 954.909424,273.765564
	C954.954834,272.555481 954.958435,271.747467 954.974976,270.568481
	C954.966309,269.454193 954.944580,268.710876 954.961060,267.641724
	C955.010376,266.878815 955.021423,266.441711 955.290100,265.768250
	C955.682983,264.378906 955.818298,263.225952 955.968140,261.665283
	C955.985901,260.169556 955.989075,259.081604 956.016418,257.684204
	C956.071228,256.963867 956.101929,256.552948 956.171204,255.814407
	C956.555664,254.518723 956.901611,253.550705 957.584351,252.781464
	C958.684875,254.650604 959.448608,256.320953 960.212280,257.991333
z"/>
<path fill="#375C87" opacity="1.000000" stroke="none"
	d="
M823.006470,404.090424
	C823.234253,404.813049 823.462036,405.535645 823.809570,406.520142
	C822.229858,407.229034 820.530334,407.676056 818.299744,407.885559
	C817.155579,407.960114 816.542542,408.272247 815.929504,408.584381
	C813.589172,408.698883 811.248840,408.813354 808.404419,408.506470
	C806.919739,408.106689 805.939026,408.128235 804.958374,408.149780
	C800.586975,407.325348 796.215576,406.500885 791.310669,405.235748
	C789.453308,404.566040 788.129456,404.337067 786.805664,404.108063
	C786.402710,404.106293 785.999756,404.104523 785.141846,403.783966
	C784.103882,403.321075 783.520813,403.176971 782.937805,403.032898
	C750.185303,393.472870 721.924194,376.804626 699.808899,350.440430
	C686.831055,334.969147 677.278320,317.544098 670.469482,298.581665
	C669.798767,296.713654 669.452026,294.729340 669.369080,292.400696
	C670.838562,292.003143 671.893921,292.003845 672.980591,292.392517
	C675.599487,298.893188 678.187012,305.005798 680.827393,311.453308
	C681.283142,312.832855 681.686035,313.877533 682.091797,315.242249
	C682.671204,316.088654 683.247742,316.614990 683.879761,317.481018
	C684.350708,319.125244 684.766113,320.429779 685.153442,322.110870
	C686.261780,324.677002 687.184204,327.017365 688.592346,329.015472
	C690.126404,331.192352 692.110962,333.051788 694.002197,335.356384
	C694.787842,336.740814 695.470520,337.818420 696.136658,339.260803
	C699.736389,343.761902 703.352661,347.898224 707.127136,352.323425
	C708.897644,354.372864 710.510010,356.133423 712.225159,358.216797
	C714.891907,360.686493 717.455872,362.833344 720.189331,365.267761
	C722.890991,367.384521 725.423157,369.213745 728.010010,371.361023
	C728.733704,372.088318 729.402771,372.497498 730.392822,373.007629
	C733.439026,374.801392 736.164185,376.494202 738.981934,378.502319
	C741.385742,380.208649 743.697144,381.599701 746.325562,383.127991
	C748.363586,383.924774 750.084534,384.584290 751.906006,385.536194
	C752.677124,386.213165 753.347778,386.597778 754.338989,387.133789
	C757.707214,388.607086 760.754822,389.928986 763.911682,391.543213
	C764.717285,392.170105 765.413696,392.504639 766.404602,392.891357
	C767.093201,393.004028 767.487366,393.064575 767.984558,393.461517
	C770.094482,394.476837 772.101257,395.155792 774.480103,395.890381
	C780.251038,397.615845 785.649963,399.285675 791.107422,401.335327
	C794.822754,402.400574 798.479614,403.086029 802.445679,403.810608
	C803.170044,403.863617 803.585144,403.877472 804.206970,404.176941
	C805.324951,404.558502 806.236206,404.654449 807.503052,404.791199
	C808.574036,404.840546 809.289368,404.849060 810.172729,405.129211
	C811.225098,405.217896 812.109253,405.035004 813.305908,404.861237
	C814.034058,404.841309 814.449646,404.812286 815.218018,404.852478
	C816.380310,404.576355 817.189880,404.230988 818.312744,403.890717
	C819.042236,403.863159 819.458557,403.830505 820.263794,403.864319
	C821.437317,403.984009 822.221863,404.037201 823.006470,404.090424
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M958.963257,39.496281
	C946.880798,39.965153 934.691162,39.972099 922.504028,40.152683
	C912.374023,40.302795 902.245789,40.917931 892.119141,40.864632
	C873.154236,40.764812 854.191772,40.226028 835.226746,40.090275
	C828.435364,40.041660 821.638184,40.913097 814.845764,40.882271
	C766.384277,40.662315 717.923401,40.296215 669.461853,40.082951
	C667.296448,40.073425 665.126526,41.092102 662.555420,41.820839
	C661.834717,41.582062 661.517212,41.154312 661.227600,40.512161
	C663.520386,39.549938 665.784546,38.150845 668.050354,38.148067
	C763.447632,38.031052 858.844971,38.033665 954.242371,38.075809
	C955.780701,38.076488 957.318848,38.750000 958.963257,39.496281
z"/>
<path fill="#517197" opacity="1.000000" stroke="none"
	d="
M662.268982,52.311516
	C662.953674,53.565495 663.886108,55.182796 663.887939,56.801151
	C663.962585,122.349350 663.957642,187.897644 663.924988,253.445923
	C663.924255,254.881500 663.483826,256.316833 662.930969,257.937927
	C662.385620,256.503235 661.959412,254.882965 661.958618,253.262512
	C661.927002,187.228516 661.933167,121.194511 661.941650,55.160503
	C661.941772,54.332108 662.033630,53.503716 662.268982,52.311516
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M672.949219,292.004517
	C671.893921,292.003845 670.838562,292.003143 669.387451,292.003357
	C668.991699,292.004303 668.779175,292.155609 668.749512,291.865479
	C668.321960,290.891693 667.924072,290.208038 667.526245,289.524353
	C666.222656,282.371399 664.919006,275.218414 663.647949,267.624634
	C664.560730,266.812317 665.441101,266.440857 666.831055,266.316589
	C667.621033,267.349457 667.901245,268.135132 668.121155,269.256531
	C668.086121,270.042694 668.111389,270.493134 668.135803,271.300262
	C668.466064,272.807770 668.797241,273.958557 669.120483,275.480408
	C669.709106,277.899170 670.305725,279.946869 670.694519,282.158295
	C670.683960,282.883911 670.881165,283.445831 671.084412,284.318298
	C671.113403,285.042297 671.136353,285.455780 671.108154,286.242554
	C671.687744,288.412079 672.318481,290.208313 672.949219,292.004517
z"/>
<path fill="#517197" opacity="1.000000" stroke="none"
	d="
M786.914856,404.464111
	C788.129456,404.337067 789.453308,404.566040 790.926514,405.091370
	C789.725342,405.198547 788.374695,405.009338 786.914856,404.464111
z"/>
<path fill="#517197" opacity="1.000000" stroke="none"
	d="
M805.197021,408.383209
	C805.939026,408.128235 806.919739,408.106689 807.978394,408.383179
	C807.182861,408.659698 806.309326,408.638184 805.197021,408.383209
z"/>
<path fill="#517197" opacity="1.000000" stroke="none"
	d="
M816.209106,408.692078
	C816.542542,408.272247 817.155579,407.960114 817.902100,407.885864
	C817.520020,408.349121 817.004333,408.574463 816.209106,408.692078
z"/>
<path fill="#517197" opacity="1.000000" stroke="none"
	d="
M783.001770,403.314575
	C783.520813,403.176971 784.103882,403.321075 784.843506,403.732208
	C784.355286,403.864899 783.710510,403.730560 783.001770,403.314575
z"/>
<path fill="#9BAFCA" opacity="1.000000" stroke="none"
	d="
M667.402039,289.837402
	C667.924072,290.208038 668.321960,290.891693 668.619385,291.875610
	C668.105286,291.500732 667.691589,290.825592 667.402039,289.837402
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M956.627380,44.251434
	C957.551941,44.183357 958.476440,44.115280 959.869568,44.076530
	C960.529846,46.254032 960.888062,48.402142 960.888977,50.550400
	C960.915588,114.574471 960.907410,178.598557 960.897522,242.622635
	C960.897400,243.451614 960.805298,244.280609 960.501160,245.539749
	C960.246155,245.969910 960.071899,245.919678 960.041870,245.577362
	C959.963928,244.777359 959.916077,244.319672 959.780762,243.668640
	C959.511169,243.243027 959.278381,243.085129 958.621521,243.032867
	C958.002686,243.112274 957.757446,243.160461 957.437683,242.759125
	C957.164795,237.997971 956.796509,233.686478 956.793518,229.374741
	C956.754089,172.437729 956.774597,115.500664 956.747803,58.563637
	C956.745850,54.417019 956.494690,50.270515 956.509033,45.833359
	C956.648193,45.112316 956.637756,44.681873 956.627380,44.251434
z"/>
<path fill="#315882" opacity="1.000000" stroke="none"
	d="
M960.071899,245.919678
	C960.071899,245.919678 960.246155,245.969910 960.334534,245.978394
	C960.531311,247.062836 960.639771,248.138763 960.276001,249.681961
	C958.960205,250.531952 958.116638,250.914688 957.127747,250.946259
	C957.158936,248.589676 957.335449,246.584290 957.827026,244.774170
	C958.785278,245.286179 959.428589,245.602936 960.071899,245.919678
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M957.273071,251.297424
	C958.116638,250.914688 958.960205,250.531952 960.135376,250.067932
	C960.533691,252.389999 960.600342,254.793335 960.439697,257.593994
	C959.448608,256.320953 958.684875,254.650604 957.626465,252.570557
	C957.347046,251.870682 957.327515,251.582855 957.273071,251.297424
z"/>
<path fill="#6983A4" opacity="1.000000" stroke="none"
	d="
M951.639893,300.200195
	C951.532837,299.574615 951.723999,298.817963 952.205200,297.936615
	C952.309448,298.564301 952.123779,299.316711 951.639893,300.200195
z"/>
<path fill="#6983A4" opacity="1.000000" stroke="none"
	d="
M957.784546,277.886536
	C957.352051,277.817291 957.074829,277.625580 956.797668,277.433838
	C957.017822,277.289612 957.237976,277.145386 957.725342,276.997620
	C958.110413,277.260162 958.092896,277.516815 957.784546,277.886536
z"/>
<path fill="#EBECF2" opacity="1.000000" stroke="none"
	d="
M574.377014,135.380890
	C574.377014,135.380890 574.043884,135.440460 573.544067,135.551208
	C571.678528,136.272614 570.328552,136.921967 568.944519,137.487778
	C558.087769,141.926178 556.877441,141.173325 553.852295,129.917908
	C552.622620,125.342743 554.380127,123.171783 558.418091,122.351341
	C560.463989,121.935638 562.738098,121.968475 564.790161,122.384705
	C570.931580,123.630379 577.014404,125.165146 583.120056,126.587051
	C583.534058,126.707657 583.948120,126.828262 584.770447,127.266121
	C584.677368,128.485260 584.401001,129.751389 583.634827,130.224701
	C580.632812,132.079239 577.476196,133.683578 574.377014,135.380890
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M583.016418,126.253029
	C577.014404,125.165146 570.931580,123.630379 564.790161,122.384705
	C562.738098,121.968475 560.463989,121.935638 558.418091,122.351341
	C554.380127,123.171783 552.622620,125.342743 553.852295,129.917908
	C556.877441,141.173325 558.087769,141.926178 568.944519,137.487778
	C570.328552,136.921967 571.678528,136.272614 573.422058,135.668472
	C569.820618,142.080536 557.083130,144.159698 554.390442,138.660599
	C552.766174,135.343582 551.796021,131.563492 551.279114,127.886429
	C550.741943,124.066162 554.605835,120.413300 559.315979,120.180275
	C562.402039,120.027603 565.632690,120.369194 568.618103,121.165916
	C573.460938,122.458321 578.155579,124.305832 583.016418,126.253029
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M574.760376,135.546066
	C577.476196,133.683578 580.632812,132.079239 583.634827,130.224701
	C584.401001,129.751389 584.677368,128.485260 585.095154,127.264496
	C585.949768,127.296288 586.888000,127.646957 587.826233,127.997620
	C587.456421,128.983719 587.355652,130.537857 586.672119,130.861557
	C582.907959,132.644211 579.001404,134.126144 574.760376,135.546066
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M582.478027,204.288666
	C581.890381,203.916397 581.478149,203.224686 581.151611,202.228363
	C581.709351,202.605545 582.181396,203.287384 582.478027,204.288666
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M584.324341,209.823425
	C583.741699,209.503403 583.383728,209.027878 583.100464,208.244873
	C583.633057,208.514236 584.091064,209.091095 584.324341,209.823425
z"/>
<path fill="#5A5C77" opacity="1.000000" stroke="none"
	d="
M587.488525,219.306519
	C586.941711,218.907547 586.576355,218.201630 586.295898,217.190643
	C586.810608,217.590225 587.240295,218.294891 587.488525,219.306519
z"/>
<path fill="#50A6DB" opacity="1.000000" stroke="none"
	d="
M671.159302,285.869263
	C671.136353,285.455780 671.113403,285.042297 671.298645,284.157349
	C671.305298,283.122131 671.103821,282.558380 670.902283,281.994598
	C670.305725,279.946869 669.709106,277.899170 669.495483,275.462036
	C671.618103,275.320312 673.357666,275.567993 675.554932,275.856232
	C685.312439,275.881744 694.612305,275.866699 704.266724,275.901367
	C705.450012,275.340210 706.278625,274.729340 707.362854,273.887299
	C707.814575,272.769440 708.010681,271.882812 708.405884,270.779236
	C707.725586,269.722992 706.846191,268.883728 705.679260,267.904053
	C704.594299,267.496643 703.796753,267.229584 702.775513,266.698151
	C701.532349,266.493500 700.512878,266.553223 699.493408,266.612946
	C699.690369,267.413116 699.887329,268.213287 699.814453,269.298157
	C690.722656,269.975769 681.900635,270.368652 672.970947,270.420410
	C671.302673,269.693146 669.742065,269.306976 668.181458,268.920807
	C667.901245,268.135132 667.621033,267.349457 667.187744,266.289856
	C667.072205,265.000824 667.109680,263.985687 667.377930,262.593292
	C667.608765,262.216034 667.979065,262.202789 668.250854,262.426453
	C678.060303,263.082550 687.595703,263.593414 697.138000,263.853546
	C698.408386,263.888184 699.713440,262.651031 701.465332,262.003723
	C706.287537,261.760101 710.646851,261.515656 715.405029,261.244202
	C716.868042,261.247406 717.932251,261.277618 719.288330,261.537415
	C721.369690,261.871857 723.159119,261.976746 725.040527,262.429565
	C727.371643,264.542267 729.299988,265.115540 730.525696,261.383423
	C732.279724,261.290863 733.637207,261.289246 735.268799,261.510071
	C737.364990,261.587646 739.187012,261.442688 741.380981,261.268066
	C742.497803,261.253906 743.242737,261.269440 744.217834,261.498993
	C745.281555,261.831818 746.115112,261.950592 747.015686,262.460999
	C748.784058,268.538696 748.499268,268.980591 742.967041,268.995667
	C735.690918,269.015503 728.411682,268.899017 721.141296,269.106171
	C719.798950,269.144440 718.492432,270.440399 717.169373,271.155853
	C717.760376,272.113495 718.351379,273.071136 719.205933,274.144226
	C719.959167,274.561462 720.448975,274.863220 721.063477,275.538452
	C721.715881,276.247894 722.241333,276.872955 722.771484,276.877014
	C732.474426,276.951813 742.181702,277.093506 751.877930,276.837769
	C753.620972,276.791809 755.319153,275.042633 757.284424,273.845276
	C757.719177,272.733490 757.907593,271.856262 758.321533,270.778870
	C757.659790,269.750244 756.772522,268.921753 755.578369,268.039795
	C754.531860,267.615479 753.792297,267.244659 752.979858,266.543701
	C752.277954,264.816101 751.648804,263.418640 751.041321,261.804871
	C751.062988,261.588531 751.069824,261.153717 751.459229,261.122925
	C752.889282,261.097015 753.929932,261.101898 755.077393,261.320099
	C755.394409,261.781281 755.645935,261.975677 756.027710,262.460327
	C757.999817,264.574890 759.703491,264.928589 761.384949,262.139343
	C762.501648,262.098236 763.247498,262.100769 764.190796,262.332977
	C765.260437,262.392395 766.132629,262.222137 767.328064,262.039368
	C768.435486,261.786865 769.219666,261.546906 770.468445,261.288208
	C775.605774,261.177124 780.278625,261.084778 785.410767,261.054413
	C789.228149,261.231537 792.586182,261.346649 795.960693,261.821777
	C799.134827,268.990631 799.120544,269.011658 791.394409,269.006927
	C784.397522,269.002655 777.396057,268.864319 770.407593,269.104614
	C768.952942,269.154633 767.546448,270.607117 766.117737,271.413269
	C766.989014,272.887543 767.559143,274.752869 768.818787,275.722687
	C770.003601,276.634888 771.911743,276.911224 773.508911,276.933136
	C781.670349,277.044952 789.835876,277.066650 797.995605,276.902039
	C799.363953,276.874451 800.710815,275.777618 802.451904,275.131409
	C803.869202,275.041565 804.902039,274.995209 806.301514,274.929016
	C809.274414,273.444702 810.729980,271.900055 806.793701,269.881073
	C806.306763,269.564880 806.117493,269.303711 805.957642,268.640015
	C804.557678,265.821808 799.765320,265.777924 801.500427,261.336121
	C804.574097,261.322388 807.211731,261.407867 809.915894,261.844635
	C811.154114,262.786774 812.300476,263.818207 813.502075,263.887146
	C817.364624,264.109009 821.260681,264.162445 825.116516,263.892029
	C826.788330,263.774750 828.393433,262.708038 830.454224,262.042297
	C832.585510,262.008728 834.291565,262.005432 836.271240,262.288788
	C838.820129,262.927368 841.195374,262.991272 843.334717,263.734314
	C844.718994,264.215118 845.758179,265.689362 846.952026,266.718384
	C845.584167,267.480560 844.235535,268.858215 842.845337,268.901520
	C835.696533,269.124084 828.534058,268.894623 821.383850,269.092957
	C819.901489,269.134094 818.450867,270.318939 816.992798,270.988953
	C817.000000,271.001221 816.976318,270.984833 816.682251,271.022583
	C816.572571,271.715942 816.756958,272.371521 817.083313,273.283081
	C817.809204,274.043640 818.393066,274.548218 819.077759,275.442017
	C819.383545,276.082764 819.591370,276.556519 819.793152,276.553986
	C831.480530,276.406769 843.167358,276.223663 854.853943,276.024292
	C855.337280,276.016083 855.964783,275.973389 856.271240,275.680817
	C857.190308,274.803558 858.713074,273.730255 858.636108,272.853180
	C858.545166,271.817108 857.029236,270.906128 856.025269,269.619263
	C854.972046,268.803894 854.024597,268.310120 853.012451,267.485352
	C852.296448,265.467316 851.645081,263.780273 851.393433,262.059265
	C852.860413,262.006439 853.927734,261.987518 855.202271,262.233582
	C856.606384,262.332886 857.803162,262.167236 859.372375,261.991089
	C860.489014,262.005768 861.233337,262.030975 862.033203,262.380493
	C863.069702,262.497467 864.050476,262.290161 865.401367,262.059601
	C866.512634,262.015930 867.253845,261.995514 868.232544,262.250366
	C870.668213,262.420227 872.866577,262.314850 875.480225,262.171936
	C877.285583,262.147888 878.675598,262.161346 880.335510,262.420288
	C882.732056,262.466339 884.858704,262.266907 887.354980,262.074493
	C888.461731,262.129364 889.198853,262.177185 890.056091,262.570801
	C893.247253,264.454956 896.201538,265.430023 898.444885,261.224731
	C899.504639,261.198212 900.212280,261.222687 901.025513,261.588776
	C902.916382,262.585907 904.707214,263.817322 906.486084,263.800201
	C915.592773,263.712677 924.697937,263.341553 933.799744,262.972931
	C935.535034,262.902679 937.252686,262.397766 939.305786,262.093628
	C940.067566,262.130341 940.502075,262.166779 941.043213,262.541565
	C944.095398,262.606079 947.040833,262.332275 950.323608,262.050629
	C951.110840,262.041992 951.560791,262.041199 952.202087,262.297943
	C953.273193,263.705200 954.152832,264.854889 955.032532,266.004608
	C955.021423,266.441711 955.010376,266.878815 954.568481,267.648071
	C953.347168,268.057709 952.556763,268.135162 951.479553,268.163635
	C950.812866,268.036102 950.432983,267.957581 949.973022,267.534851
	C947.955261,266.806061 944.523682,265.712494 944.316406,266.149170
	C942.676880,269.603638 939.800659,268.990387 937.057495,268.997681
	C930.939270,269.013916 924.813049,268.836395 918.708496,269.125549
	C917.229187,269.195557 915.821106,270.769684 914.380310,271.652161
	C915.221313,272.448883 916.062317,273.245605 917.097168,274.270874
	C917.842346,274.715607 918.393677,274.931732 919.065308,275.524048
	C928.840820,276.190674 938.510681,276.879791 948.141846,276.523224
	C950.949341,276.419281 951.851318,277.233154 952.994751,279.000061
	C952.968262,279.432251 952.941772,279.864471 952.551636,280.690399
	C951.833496,281.779083 951.479126,282.474030 951.105835,283.522919
	C951.084167,284.585114 951.081360,285.293396 951.078491,286.001648
	C951.078491,286.001648 950.903320,286.415344 950.411499,286.682739
	C947.455994,286.966888 944.958313,286.749237 942.542969,287.099792
	C941.344543,287.273712 940.297607,288.491760 939.182190,289.237427
	C940.128845,290.436218 940.874084,292.338379 942.066223,292.679718
	C944.204102,293.291901 946.610718,292.965637 948.905029,293.031586
	C947.632446,297.082489 946.359863,301.133362 944.591309,305.546326
	C943.446106,305.902496 942.796814,305.896545 941.991455,305.631409
	C941.231140,304.573730 940.626831,303.775208 939.954651,302.614319
	C938.046875,301.552460 936.206970,300.852966 934.367065,300.153473
	C933.883972,301.740936 933.400940,303.328400 932.486023,304.928345
	C930.035583,304.940613 928.017029,304.940399 925.704346,304.663025
	C922.990417,304.271332 920.518616,303.821411 918.172668,304.184540
	C917.011475,304.364319 916.082031,306.041351 915.047791,307.040955
	C916.363708,308.053223 917.679626,309.065491 919.463989,310.074341
	C925.952637,310.059326 931.972717,310.047668 938.208862,310.288574
	C939.386841,311.089569 940.348755,311.637939 941.310669,312.186340
	C940.213440,314.855530 939.116150,317.524719 937.585266,320.620819
	C935.778320,321.354645 934.405029,321.661560 932.875366,321.692200
	C931.841553,320.872986 930.964111,320.330048 930.005493,319.432373
	C928.227539,316.440247 926.448914,316.100739 924.062256,318.455231
	C922.889160,319.612549 921.152344,320.860382 919.639038,320.901337
	C911.055359,321.133698 902.458679,320.892975 893.875916,321.141541
	C892.571411,321.179352 891.316467,322.930847 890.038635,323.889648
	C891.066895,325.225861 892.095154,326.562073 893.572266,327.905701
	C906.336304,327.631775 918.651428,327.350464 931.011292,327.375671
	C931.663147,328.122894 932.270325,328.563599 932.877502,329.004333
	C932.637634,329.486755 932.397766,329.969177 931.698364,330.762573
	C930.196716,332.754669 929.154480,334.435730 928.112244,336.116821
	C928.112244,336.116821 928.036621,336.537750 927.665405,336.805481
	C926.910339,337.762482 926.526611,338.451782 926.142883,339.141083
	C926.142883,339.141083 926.055054,339.545959 925.610474,339.745392
	C923.417358,339.458496 921.688782,338.701630 919.914001,338.570312
	C918.458923,338.462646 916.948792,339.099457 915.463074,339.406250
	C915.833862,341.189972 915.986694,343.059845 916.646545,344.729340
	C917.148193,345.998535 918.294312,347.013031 919.153687,348.140869
	C918.914429,348.645111 918.675110,349.149353 917.868652,349.852631
	C916.523010,351.020142 915.744507,351.988647 914.966064,352.957153
	C914.966064,352.957153 914.997559,352.997559 914.647461,353.043457
	C913.828674,354.011688 913.360046,354.934052 912.891418,355.856384
	C912.072815,356.774811 911.254150,357.693207 909.806519,358.771545
	C907.433228,357.644745 905.688965,356.358002 903.724731,355.028015
	C903.504700,354.984741 903.062439,354.910950 902.983459,354.558044
	C897.960205,347.472321 896.288879,358.845367 892.076660,356.162506
	C891.561523,356.985626 891.040894,357.805511 890.548889,358.642212
	C890.526123,358.680878 890.758911,358.869812 890.985229,359.259644
	C891.378845,360.045013 891.659851,360.559479 892.041992,361.461182
	C894.463867,362.229614 896.821289,362.467102 899.091431,363.046234
	C900.437500,363.389618 901.646118,364.272064 902.916504,364.912170
	C899.413452,367.741669 895.910400,370.571167 891.830444,373.680115
	C890.093811,374.922699 888.933899,375.885803 887.774048,376.848907
	C886.748779,377.278229 885.723572,377.707550 884.112549,377.948303
	C882.017456,375.541260 880.781921,373.030457 878.870728,371.241394
	C878.050476,370.473663 874.511047,370.953156 874.445251,371.295685
	C873.843079,374.432007 871.566895,373.788452 869.497192,374.149902
	C868.298096,374.359283 867.273499,375.567596 866.170410,376.326355
	C867.171997,377.499908 867.968689,379.276184 869.224121,379.702759
	C871.014038,380.311035 873.228088,379.600433 875.089539,380.096466
	C876.177063,380.386322 876.930847,381.928589 877.834778,382.907410
	C876.149841,383.628662 874.464966,384.349915 872.083862,385.115509
	C870.183716,386.045471 868.979736,386.931061 867.775696,387.816589
	C867.394165,387.886993 867.012695,387.957397 865.986084,388.081940
	C862.809265,389.683594 860.277527,391.231079 857.745850,392.778564
	C857.077209,392.883789 856.408630,392.988983 855.096558,393.134766
	C853.895142,393.718384 853.337158,394.261444 852.779236,394.804535
	C852.098328,394.886932 851.417480,394.969299 850.085205,395.086548
	C848.850281,395.645569 848.266663,396.169769 847.682983,396.694000
	C847.009399,396.745728 846.335754,396.797424 845.094604,396.645813
	C840.962891,397.844452 837.398621,399.246460 833.834412,400.648499
	C833.423279,400.701569 833.012146,400.754669 832.035339,400.606445
	C827.604736,401.536011 823.739746,402.666931 819.874817,403.797852
	C819.458557,403.830505 819.042236,403.863159 818.107178,403.661072
	C816.680725,403.878601 815.773010,404.330933 814.865295,404.783234
	C814.449646,404.812286 814.034058,404.841309 813.113525,404.638062
	C811.740662,404.556335 810.872620,404.706970 810.004639,404.857574
	C809.289368,404.849060 808.574036,404.840546 807.410034,404.501923
	C805.974304,404.078308 804.987244,403.984802 804.000183,403.891296
	C803.585144,403.877472 803.170044,403.863617 802.314575,403.468323
	C798.265686,402.376404 794.657288,401.665924 791.048889,400.955475
	C785.649963,399.285675 780.251038,397.615845 774.374573,395.558380
	C771.891846,394.488861 769.886658,393.806976 767.881470,393.125122
	C767.487366,393.064575 767.093201,393.004028 766.317505,392.582214
	C765.224731,391.897552 764.513611,391.574219 763.802490,391.250854
	C760.754822,389.928986 757.707214,388.607086 754.287842,386.804565
	C753.212585,385.963898 752.509033,385.603851 751.805542,385.243835
	C750.084534,384.584290 748.363586,383.924774 746.319885,382.734833
	C745.989685,381.417725 745.982117,380.631042 746.353271,379.865509
	C747.488831,379.871887 748.245789,379.857086 749.239197,380.146637
	C751.406616,380.407074 753.746704,381.023285 755.161499,380.146515
	C756.803833,379.128693 758.993530,375.754395 758.583313,375.221527
	C756.749146,372.838928 754.246216,370.775665 751.577576,369.370239
	C750.921875,369.024933 748.690063,371.542114 747.270996,372.839691
	C746.689026,373.371826 746.340637,374.159393 745.588440,374.844543
	C744.895081,374.850250 744.499268,374.842194 744.011108,374.503784
	C741.174194,373.312805 741.174194,373.312805 738.889404,378.187012
	C736.164185,376.494202 733.439026,374.801392 730.327759,372.695770
	C729.279602,371.869629 728.617493,371.456299 727.955322,371.042969
	C725.423157,369.213745 722.890991,367.384521 720.188354,364.905090
	C720.017334,363.528778 720.016724,362.802734 720.443237,362.065247
	C722.581726,362.074219 724.293152,362.094604 726.275513,362.373138
	C727.997253,362.697357 729.532898,363.100891 730.881775,362.761841
	C734.051208,361.965240 734.501587,359.413513 731.941772,356.682312
	C731.209229,355.938080 730.625122,355.443298 729.977051,354.605896
	C728.361938,353.089935 726.810730,351.916595 724.102966,349.868439
	C724.102966,352.980896 724.102966,354.528107 724.092407,356.079834
	C724.081787,356.084381 724.077148,356.112640 723.636475,356.081055
	C719.504700,356.664337 715.813599,357.279144 712.122437,357.893951
	C710.510010,356.133423 708.897644,354.372864 707.104675,351.976898
	C706.016663,349.901794 705.109253,348.462097 704.260986,347.116211
	C704.960327,346.015381 705.540100,345.102783 706.421875,344.097168
	C707.205444,343.373566 707.686951,342.742950 708.471619,342.028687
	C710.431824,338.730438 708.729858,337.604889 705.499390,337.161255
	C704.109741,336.676788 703.057251,336.251465 701.939636,335.489410
	C699.885620,333.388885 699.060181,333.966919 699.294434,336.474182
	C699.415283,337.766785 699.664429,339.047363 699.936584,340.878448
	C698.110168,339.921417 697.131714,339.408722 696.153259,338.896027
	C695.470520,337.818420 694.787842,336.740814 693.989746,334.992188
	C692.842407,332.581604 691.810547,330.842010 690.127563,328.004822
	C695.426331,328.004822 699.503601,328.011627 703.580872,328.003448
	C711.907532,327.986755 720.246094,328.190460 728.551514,327.759583
	C730.344177,327.666565 732.017517,325.275513 733.745850,323.942993
	C731.943298,322.208282 730.341797,320.132477 728.245178,318.896637
	C727.329102,318.356598 725.371460,319.454681 723.937683,319.954651
	C722.212158,320.556366 720.554077,321.868225 718.843750,321.909149
	C710.355286,322.112183 701.859192,322.018372 693.365906,321.983429
	C690.637512,321.972198 687.909668,321.821320 685.181519,321.734314
	C684.766113,320.429779 684.350708,319.125244 683.899658,317.151855
	C683.272400,315.962708 682.680725,315.442474 682.088989,314.922211
	C681.686035,313.877533 681.283142,312.832855 681.039429,311.219147
	C682.473877,310.471222 683.749084,310.292328 685.421509,310.101807
	C686.879456,310.103088 687.940125,310.116028 689.313110,310.397461
	C694.869324,310.768005 700.121765,311.061371 705.350708,310.828033
	C706.550354,310.774506 707.669128,308.909363 708.841309,307.583008
	C708.855408,306.894257 708.853333,306.500427 708.878784,305.754272
	C707.924561,304.616638 706.942749,303.831421 705.744141,303.012848
	C705.527283,302.979492 705.101013,302.875366 705.013916,302.520935
	C703.272400,300.340851 700.699158,298.478668 699.448669,301.328430
	C698.075195,304.458191 696.130920,303.973389 693.940430,304.010223
	C690.622131,304.066071 687.302063,304.021301 683.982727,304.006866
	C678.001160,303.980835 674.204712,298.318329 676.440796,292.138245
	C678.241211,292.152954 679.626587,292.177826 681.212158,292.402161
	C681.996887,291.737030 682.581482,290.872437 683.141052,289.657196
	C682.443176,288.166901 681.770203,287.027222 681.024353,285.519897
	C678.942627,282.545532 677.083862,281.370483 674.862366,285.124939
	C674.433594,285.849670 672.434143,285.645111 671.159302,285.869263
M816.492065,308.378052
	C817.325745,308.925171 818.159424,309.472290 819.931213,310.027771
	C830.067261,310.035431 840.203674,310.087250 850.338989,310.004089
	C851.897583,309.991302 853.451050,309.357025 855.625732,308.727753
	C857.242432,307.195099 857.832764,305.786743 854.768982,304.204437
	C853.554504,303.660797 852.340027,303.117126 851.049194,301.917816
	C850.084595,300.949188 849.119934,299.980560 847.112610,297.964966
	C847.112610,301.089325 847.112610,302.620331 846.437683,304.657867
	C837.633667,304.803009 828.829590,304.948151 819.274231,305.014282
	C818.497620,306.014709 817.721008,307.015167 816.492065,308.378052
M842.042542,361.592133
	C842.687317,361.771667 843.332092,361.951202 844.915833,362.087860
	C855.949585,362.089264 866.983398,362.090637 878.433350,362.562775
	C880.699768,363.167938 882.006104,362.757019 881.079590,359.288147
	C879.408325,357.478333 877.737000,355.668488 875.937195,353.162231
	C874.988037,352.529755 874.038879,351.897278 873.089661,351.264801
	C872.760498,352.548645 872.431274,353.832458 871.869446,355.895660
	C870.517212,356.261230 869.167786,356.930145 867.812256,356.942749
	C859.536865,357.019653 851.260010,356.947540 842.550842,356.460510
	C841.718140,357.201874 840.543457,357.814575 840.195862,358.738464
	C840.019836,359.206299 841.337830,360.236237 842.000000,361.000000
	C842.000000,361.000000 841.987366,361.019470 842.042542,361.592133
M776.875366,283.212006
	C773.115906,281.597107 773.065552,281.648682 772.556274,287.598633
	C771.373779,287.657684 770.191223,287.716766 768.780273,287.036804
	C760.485107,286.769287 752.189880,286.381897 743.894714,286.381866
	C742.825134,286.381836 739.541931,287.794739 743.166016,290.570923
	C743.778748,291.042938 744.391541,291.514954 745.937439,292.081085
	C756.503967,292.088409 767.070435,292.096436 777.636963,292.102448
	C779.823425,292.103699 782.153992,292.306854 782.671753,288.937317
	C782.425110,288.307159 782.178528,287.677002 781.265442,286.880829
	C779.850952,286.225769 778.436462,285.570679 777.052734,284.422729
	C777.052734,284.422729 777.042480,283.927246 776.875366,283.212006
M773.004517,356.513702
	C773.004517,356.513702 773.021057,357.009918 772.081055,357.004028
	C762.421936,357.026764 752.762878,357.049500 742.419006,357.102783
	C742.573547,358.084259 742.728027,359.065704 743.354065,360.696777
	C744.546753,361.151947 745.735962,361.991486 746.932617,362.002075
	C757.233459,362.093201 767.536926,362.110840 777.835815,361.932983
	C779.264648,361.908295 780.672974,360.698395 782.741882,359.918335
	C782.490356,358.948364 782.238892,357.978394 781.479553,356.785919
	C780.995911,356.518188 780.512207,356.250458 779.784363,355.380371
	C778.859985,354.579559 777.935547,353.778778 776.867371,352.258453
	C773.189453,350.557159 773.121460,350.623627 773.004517,356.513702
M744.054749,326.737457
	C744.741211,327.101227 745.427673,327.464996 746.836243,327.877350
	C747.559448,327.876129 748.282654,327.874908 749.471558,328.466858
	C751.352905,328.030426 753.234192,327.593964 755.906677,327.225189
	C758.940125,327.439667 761.973633,327.654144 765.396790,328.434540
	C766.595398,328.248993 767.794006,328.063416 769.827637,327.913788
	C771.220215,327.900085 772.612732,327.886383 774.272339,328.364319
	C774.846008,328.199127 775.419617,328.033936 776.631470,327.892822
	C777.057129,327.884430 777.482788,327.876068 778.685059,327.959045
	C780.124573,326.515778 781.876465,325.241577 782.806641,323.522736
	C783.073608,323.029297 780.966797,321.251434 779.339844,319.986786
	C778.934265,319.934662 778.528687,319.882568 777.960999,319.148773
	C776.532715,316.550110 775.144592,316.394409 773.120728,318.778748
	C772.162354,319.907898 770.358582,320.895660 768.909668,320.935944
	C761.320862,321.147064 753.721619,320.957886 746.129944,321.107635
	C744.844177,321.132965 743.577515,322.131409 742.302124,322.680237
	C742.831238,323.809937 743.360352,324.939636 743.947144,326.046509
	C743.947144,326.046509 743.929260,326.105896 744.054749,326.737457
M867.213501,271.032593
	C867.432678,272.054169 867.651855,273.075775 868.339783,274.206268
	C868.339783,274.206268 868.815430,274.278809 869.136047,274.999359
	C869.369324,275.226471 869.600586,275.650146 869.836182,275.652496
	C880.747620,275.763092 891.662903,275.988647 902.567078,275.736481
	C904.045532,275.702301 905.468079,273.252197 906.916565,271.920746
	C904.928284,269.958252 903.261841,267.129639 900.873962,266.242371
	C897.542480,265.004456 896.970459,268.112244 895.897766,270.822235
	C886.553406,270.847809 877.208984,270.873352 867.213501,271.032593
M892.520203,287.380707
	C891.737366,287.657166 890.954529,287.933594 890.171692,288.209991
	C890.732788,289.172821 891.293884,290.135681 892.121277,291.523010
	C892.383484,291.726166 892.645630,291.929352 893.164856,292.885590
	C894.355225,293.250000 895.542847,293.919373 896.736389,293.930206
	C905.661743,294.011108 914.588806,294.006561 923.514038,293.912170
	C925.125488,293.895142 926.927795,293.694641 928.285461,292.938690
	C929.696228,292.153168 931.849854,290.205841 931.601257,289.447571
	C931.057312,287.788025 929.198608,286.559418 927.280396,285.071747
	C926.885010,285.002380 926.489685,284.933044 925.917542,284.181122
	C924.672058,283.397675 923.426575,282.614197 921.275452,281.261108
	C922.335327,287.701111 917.650879,286.524933 914.067078,287.919373
	C907.039124,287.896637 900.011169,287.873901 892.520203,287.380707
M827.901611,284.203827
	C826.408508,283.473724 824.915344,282.743652 823.422241,282.013550
	C823.434448,282.593048 823.446716,283.172546 823.458923,283.752014
	C821.286560,284.506500 819.148193,285.775787 816.935608,285.921906
	C809.357178,286.422394 801.747253,286.437439 794.164246,286.887939
	C793.081177,286.952271 791.354736,288.296844 791.226624,289.227875
	C791.070190,290.364380 792.019592,291.997650 792.989929,292.843262
	C793.880005,293.618774 795.431213,293.925842 796.695190,293.936066
	C806.647949,294.016357 816.602051,294.019104 826.554626,293.924500
	C827.997314,293.910797 829.633789,293.573212 830.832886,292.826843
	C833.547791,291.137024 834.517700,289.051544 830.497375,286.716949
	C829.682861,286.105469 828.868347,285.493988 827.901611,284.203827
M719.997253,344.001801
	C719.997253,344.001801 719.944275,344.070587 720.158264,344.850342
	C720.848206,345.221008 721.536011,345.909760 722.228455,345.914551
	C732.376526,345.984711 742.526184,346.038025 752.672363,345.884460
	C754.202026,345.861328 756.070312,345.128448 757.132935,344.071381
	C758.118347,343.091156 759.069519,340.393982 758.587402,339.917084
	C756.669128,338.019562 754.267883,336.532654 751.843994,335.285309
	C751.318115,335.014679 749.990967,336.427917 748.974670,336.953033
	C747.545532,337.691528 746.075806,338.874268 744.599487,338.911224
	C736.785034,339.106873 728.960388,338.901123 721.146118,339.100983
	C719.809204,339.135132 718.505127,340.458069 717.185913,341.185669
	C718.100159,342.142334 719.014404,343.098999 719.997253,344.001801
M850.588623,321.993958
	C849.425964,321.992126 848.246826,321.865021 847.104126,322.015076
	C844.883484,322.306732 841.252014,320.879028 841.495544,324.657288
	C841.575256,325.894623 845.385986,327.757355 847.549561,327.843231
	C856.504211,328.198578 865.481628,327.996338 874.450500,327.962006
	C875.767578,327.956940 877.325500,328.154694 878.341614,327.543213
	C879.730042,326.707733 881.881958,324.418701 881.664673,324.085938
	C880.410706,322.165283 878.752319,320.329865 876.826843,319.096252
	C875.739685,318.399811 872.682434,318.529572 872.550964,318.940125
	C871.302246,322.838074 868.208984,321.935455 865.517334,321.974548
	C860.867615,322.042084 856.216370,321.995209 850.588623,321.993958
M721.984436,304.962250
	C720.712402,305.745392 719.440369,306.528534 718.168335,307.311646
	C719.409973,308.450684 720.624817,310.542877 721.897400,310.578613
	C732.518372,310.876709 743.154602,310.960571 753.773621,310.661102
	C755.456421,310.613647 757.075989,308.323761 758.724854,307.070679
	C757.600403,305.596497 756.674438,303.890259 755.296753,302.712250
	C753.869629,301.492004 752.004639,300.783936 749.725769,299.514679
	C749.329834,304.983673 746.071472,305.127716 742.330750,305.016724
	C735.855164,304.824585 729.369812,304.959137 721.984436,304.962250
M819.450928,327.980408
	C822.280701,327.965759 825.222839,328.417847 827.900940,327.773163
	C829.700928,327.339874 831.668335,325.613861 832.469666,323.942932
	C832.817932,323.216644 830.653870,320.857300 829.212219,319.823273
	C827.815430,318.821350 825.881531,318.568207 824.183533,317.986237
	C824.253967,318.539917 824.324341,319.093597 824.394775,319.647278
	C821.909058,320.431488 819.448303,321.780701 816.932922,321.891815
	C809.954834,322.200165 802.952820,321.923706 795.963074,322.042389
	C794.377991,322.069244 792.804138,322.760864 791.225159,323.146454
	C791.125549,323.825287 791.025940,324.504089 790.926331,325.182892
	C793.280396,326.116852 795.598022,327.727234 797.995361,327.856110
	C804.801025,328.221954 811.639221,327.982574 819.450928,327.980408
M710.505615,292.972565
	C716.825500,292.968445 723.153870,293.137665 729.458984,292.830383
	C730.917480,292.759308 732.296509,291.059296 733.712097,290.108795
	C731.838684,287.995605 730.118835,285.702179 727.990295,283.888336
	C727.414307,283.397522 725.540955,284.209930 724.371155,284.688507
	C722.751587,285.351044 721.256470,286.903778 719.669189,286.959045
	C712.526306,287.207703 705.363342,286.898743 698.222656,287.177094
	C696.515686,287.243591 694.866638,288.793365 693.190918,289.660889
	C694.971313,290.770538 696.653687,292.571838 698.553162,292.841095
	C702.139160,293.349304 705.850037,292.976044 710.505615,292.972565
M863.495300,292.998169
	C867.975952,292.978363 872.466370,293.129089 876.933533,292.873688
	C879.539673,292.724701 882.561096,291.345764 881.213074,288.384491
	C880.198547,286.155640 877.138611,284.741760 874.755188,283.372253
	C874.381042,283.157257 872.891052,285.349152 871.684021,285.987915
	C870.473206,286.628632 868.975037,286.984589 867.595825,287.005432
	C860.626953,287.110748 853.647949,286.886902 846.690735,287.193085
	C844.826355,287.275116 843.026001,288.813019 841.196289,289.682556
	C843.151917,290.783813 845.038452,292.651581 847.076843,292.835510
	C852.180359,293.295990 857.352722,292.993286 863.495300,292.998169
M784.488281,304.961578
	C778.792114,304.961578 773.096008,304.961578 767.133545,304.961578
	C768.674133,310.054504 769.528320,310.870758 773.393372,310.914673
	C780.196533,310.992035 787.002319,311.003326 793.804810,310.899384
	C797.095581,310.849121 800.463684,310.830811 803.634644,310.097198
	C805.220276,309.730316 807.812378,307.225616 807.580750,306.662872
	C806.765015,304.681305 805.193298,302.648773 803.357483,301.601807
	C802.437195,301.076965 800.316711,302.616150 798.757141,303.265289
	C797.471008,303.800629 796.241455,304.792999 794.934204,304.892700
	C791.799622,305.131805 788.633972,304.964874 784.488281,304.961578
M768.505920,339.451965
	C766.671143,343.286407 767.683289,344.912720 772.307129,344.969116
	C781.091064,345.076263 789.879089,345.101715 798.661438,344.942871
	C801.903320,344.884247 806.779724,346.533630 807.327576,341.925598
	C807.558594,339.982941 803.042419,337.473083 800.669800,335.236267
	C800.592224,335.163147 800.356995,335.257324 800.195251,335.273499
	C800.289490,335.733032 800.383667,336.192596 800.477905,336.652161
	C797.708984,337.468689 794.966431,338.862885 792.166077,338.990662
	C784.557373,339.337708 776.924133,339.148407 768.505920,339.451965
M856.518738,374.278992
	C854.527283,372.723083 852.535828,371.167175 850.544373,369.611267
	C850.472778,370.297974 850.401184,370.984711 850.329529,371.671417
	C847.848389,372.469757 845.391296,373.852661 842.881592,373.956024
	C835.564148,374.257324 828.224731,373.979401 820.896423,374.091705
	C819.322632,374.115814 817.759338,374.826233 816.191223,375.220490
	C816.101318,375.833527 816.011353,376.446564 815.921448,377.059601
	C818.183594,378.036316 820.422058,379.785370 822.712097,379.855774
	C832.531494,380.157654 842.366394,380.004700 852.194946,379.930542
	C855.343811,379.906799 857.279663,378.486084 856.518738,374.278992
M867.197144,309.458221
	C868.925659,309.945923 870.647888,310.828003 872.383667,310.855286
	C881.547180,310.999451 890.714294,310.960480 899.879517,310.894684
	C901.167419,310.885468 902.775452,310.758636 903.655640,310.007172
	C904.750854,309.072235 906.196045,306.937531 905.809631,306.192566
	C904.832825,304.309479 903.075195,302.678406 901.280396,301.463257
	C900.720825,301.084412 899.048584,302.373932 897.874084,302.872253
	C896.193970,303.585022 894.519287,304.825623 892.814087,304.875366
	C885.321350,305.093994 877.818176,304.931915 870.319336,304.981720
	C867.845642,304.998138 865.281006,305.149780 867.197144,309.458221
M866.301514,340.758759
	C865.577820,343.956757 867.246643,344.992188 870.101379,344.990387
	C880.747681,344.983704 891.396851,345.108215 902.037048,344.852539
	C903.613037,344.814667 905.146301,342.998047 906.699402,342.004395
	C905.486694,340.369629 904.578613,338.216003 902.963013,337.267426
	C901.715149,336.534790 899.536987,337.109985 897.849976,337.468506
	C895.491089,337.969910 893.229370,339.297546 890.882263,339.417847
	C882.847046,339.829681 874.792725,339.868622 866.301514,340.758759
M796.866943,397.020905
	C804.333862,397.024841 811.800903,397.009613 819.267700,397.041962
	C822.357788,397.055359 825.499023,397.520447 828.513184,397.076080
	C829.808472,396.885132 832.023560,394.339172 831.782837,393.833496
	C830.822205,391.816010 829.318420,389.788879 827.480652,388.575806
	C826.622009,388.009003 824.527039,389.240295 823.022766,389.746704
	C821.365479,390.304565 819.746399,391.482941 818.105042,391.493256
	C810.722229,391.539886 803.334778,391.118256 795.955872,391.250519
	C794.651855,391.273926 793.380737,393.129333 792.094421,394.138733
	C793.383057,395.096069 794.671631,396.053436 796.866943,397.020905
M800.635864,363.004852
	C808.966797,363.000458 817.308716,363.231995 825.621887,362.845520
	C828.064209,362.731995 830.425049,360.866333 832.823303,359.803711
	C831.083618,357.641693 829.624146,355.118835 827.491516,353.462769
	C826.344849,352.572388 822.533264,352.892334 822.488464,353.136444
	C821.782593,356.985443 818.882385,355.981140 816.570801,356.011169
	C810.906738,356.084869 805.217529,355.721588 799.585754,356.152679
	C796.651123,356.377350 791.322754,353.610535 791.356079,359.289124
	C791.385559,364.302826 796.412781,362.713837 800.635864,363.004852
M857.470032,339.219025
	C854.380554,337.327667 851.291016,335.436279 847.375977,333.039520
	C847.375977,335.893829 847.375977,337.259186 847.375977,338.999512
	C845.286743,338.999512 843.482239,338.998871 841.677673,338.999603
	C834.373352,339.002594 827.065308,338.888214 819.768433,339.122986
	C818.524109,339.163055 817.327881,340.698395 816.109436,341.542938
	C817.013611,342.722687 817.747864,344.117523 818.878418,345.010681
	C819.708496,345.666351 821.056091,345.909424 822.176086,345.917358
	C831.969971,345.987000 841.768799,346.128296 851.556519,345.875458
	C854.979614,345.787018 858.199829,344.478027 857.470032,339.219025
M796.431519,380.026550
	C797.262878,380.030396 798.101379,380.106628 798.924316,380.025269
	C802.179199,379.703400 806.890198,381.527344 807.674561,376.734436
	C808.455627,371.962250 803.694458,370.953918 800.305298,369.386292
	C800.189758,369.332855 799.990356,369.460724 799.442749,369.608795
	C799.326233,374.131104 796.098572,374.115723 792.539062,374.029663
	C786.058289,373.872894 779.568909,373.890198 773.087585,374.035095
	C770.864502,374.084778 767.223633,372.865143 767.328491,376.682190
	C767.423157,380.123779 770.769043,380.058685 773.504333,380.048645
	C780.820190,380.021790 788.136230,380.030060 796.431519,380.026550
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M957.127747,250.946228
	C957.327515,251.582855 957.347046,251.870682 957.289673,252.371780
	C956.901611,253.550705 956.555664,254.518723 955.723877,255.765106
	C952.890503,255.969574 950.543091,255.895676 948.153076,255.404327
	C948.036926,253.006592 947.963257,251.026306 948.125488,248.897583
	C948.008179,248.179123 947.655029,247.609116 947.210205,246.626343
	C946.732971,242.812698 946.347412,239.411804 946.231750,235.795883
	C946.032166,234.381088 945.562744,233.181335 945.026001,231.579895
	C945.307251,229.453278 945.655823,227.728317 946.322998,226.179642
	C947.694641,228.801315 948.747620,231.246704 949.800598,233.692108
	C950.301941,233.650909 950.803345,233.609695 951.304749,233.568481
	C951.304749,231.404480 951.600952,229.187637 951.226868,227.090317
	C950.795654,224.672409 949.772766,222.360031 949.397827,219.945572
	C950.525574,218.410141 951.756653,216.976669 951.898560,215.442459
	C952.218018,211.988342 951.998047,208.484329 951.998535,204.531921
	C951.999695,154.114273 952.018555,104.165291 951.930420,54.216484
	C951.926941,52.259663 950.899597,50.304649 950.349365,48.348801
	C948.155823,48.969166 945.962585,49.590122 943.768860,50.209602
	C942.841370,50.471523 941.912903,50.730270 940.965454,50.690895
	C940.620178,49.925251 940.294312,49.459167 939.957397,48.766857
	C939.946289,48.540627 939.941101,48.087646 940.089966,47.765228
	C940.496155,46.309074 940.753540,45.175335 941.010925,44.041595
	C942.394409,44.014843 943.777893,43.988083 945.637756,44.361317
	C947.781860,46.540371 949.158752,46.730457 950.009766,44.048149
	C951.072937,44.005508 952.136047,43.962868 953.628906,44.290077
	C954.825562,45.147942 955.592468,45.635952 956.359436,46.123962
	C956.494690,50.270515 956.745850,54.417019 956.747803,58.563637
	C956.774597,115.500664 956.754089,172.437729 956.793518,229.374741
	C956.796509,233.686478 957.164795,237.997971 957.390991,242.985016
	C957.377502,243.973938 957.408630,244.280090 957.512024,244.578903
	C957.335449,246.584290 957.158936,248.589676 957.127747,250.946228
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M668.895874,43.611702
	C672.953369,43.714153 677.010803,43.816605 681.528809,44.328430
	C682.344238,45.847389 682.699158,46.956974 683.046997,48.298836
	C683.039917,48.531109 683.020447,48.996635 682.793945,49.099972
	C682.289795,49.406055 682.096497,49.670498 681.591736,49.995708
	C680.697937,49.970051 680.143738,50.080441 679.710144,49.900494
	C671.962830,46.685776 671.000488,47.329357 671.000366,55.801933
	C670.999695,107.527504 670.949829,159.253250 671.128174,210.978210
	C671.138550,213.989365 673.000000,216.994110 673.999512,220.412140
	C673.378723,222.410324 672.994263,224.150070 672.089478,225.554642
	C670.169189,228.535583 670.593018,234.169724 672.943176,236.282974
	C674.309814,232.832336 675.713745,229.287689 677.483154,225.870270
	C678.247681,227.681885 678.646667,229.366287 678.648376,231.117783
	C677.587097,237.150284 676.923157,243.115677 676.178406,249.393890
	C676.060486,250.135239 676.023376,250.563751 675.715149,251.200439
	C674.992981,252.959198 674.541992,254.509811 673.645508,256.043884
	C671.412048,256.056091 669.624146,256.084808 667.652832,255.732056
	C667.317749,253.872559 667.033691,252.394531 667.033386,250.916458
	C667.020508,184.320602 667.012451,117.724716 667.119873,51.129017
	C667.123962,48.622295 668.277832,46.117432 668.895874,43.611702
z"/>
<path fill="#88CDF0" opacity="1.000000" stroke="none"
	d="
M774.019165,44.082687
	C778.034424,44.039490 782.049622,43.996292 786.621704,44.402321
	C794.593933,45.039169 802.009033,45.236877 809.425537,45.357880
	C809.616211,45.360989 809.820618,44.523354 810.018677,44.077805
	C816.697021,44.036098 823.375488,43.994404 830.616394,44.402252
	C832.200195,45.224148 833.220398,45.918068 834.242859,45.921326
	C854.348938,45.985485 874.455444,46.000702 894.561096,45.888760
	C895.716736,45.882324 896.865906,44.706348 898.018066,44.074677
	C900.379944,44.034679 902.741821,43.994686 905.639893,44.401299
	C910.555725,46.216591 914.939087,47.644924 919.014221,44.058815
	C924.041626,43.982075 929.069092,43.905334 934.551392,44.262703
	C935.001465,45.483578 934.996582,46.270344 934.594116,47.087532
	C931.482361,47.796932 928.768311,48.475918 925.790894,49.131130
	C925.358826,49.158092 925.190002,49.208828 924.775391,49.268120
	C924.529480,49.276684 924.047485,49.375896 923.738159,49.303284
	C922.825989,49.743725 922.223206,50.256783 921.244690,50.766556
	C918.930664,51.123844 916.992310,51.484421 914.926270,51.651897
	C914.564392,51.247936 914.298767,51.090179 913.961182,50.623390
	C912.276794,49.336384 910.711975,47.873123 908.969849,47.617413
	C906.573059,47.265602 904.042358,47.974285 901.568909,47.975788
	C853.626038,48.004906 805.683105,47.996990 757.740234,47.996983
	C743.923340,47.996979 730.106506,47.990307 716.289612,48.005894
	C713.995850,48.008484 711.383728,47.542751 710.981689,51.220547
	C710.977600,51.465355 710.997009,51.954655 710.621155,51.925613
	C708.519470,51.541599 706.793640,51.186623 704.978027,50.494148
	C703.845886,49.844688 702.803589,49.532734 701.344421,49.199295
	C698.980652,49.042694 697.033752,48.907578 694.995972,48.461426
	C694.167114,47.872143 693.429138,47.593887 692.300781,47.291344
	C690.607605,47.176590 689.304810,47.086132 688.001465,46.612305
	C687.992065,45.461124 687.983276,44.693306 687.974487,43.925484
	C692.336121,43.938133 696.697815,43.950779 701.619690,44.411491
	C702.702271,45.208130 703.221985,45.856049 703.747314,45.860706
	C712.687378,45.939964 721.628723,45.988701 730.567688,45.874542
	C731.392151,45.864014 732.201904,44.703732 733.018494,44.077324
	C738.031250,44.037945 743.043945,43.998562 748.618164,44.408478
	C749.701172,45.205593 750.219116,45.849842 750.744873,45.856361
	C757.686157,45.942451 764.629761,46.001587 771.569214,45.874641
	C772.396545,45.859505 773.203003,44.707653 774.019165,44.082687
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M674.091003,256.060425
	C674.541992,254.509811 674.992981,252.959198 676.004272,251.470566
	C676.942749,255.229141 676.586731,259.263794 680.717896,261.349274
	C676.299438,261.791107 672.139221,261.996948 667.979065,262.202789
	C667.979065,262.202789 667.608765,262.216034 667.425598,262.215820
	C666.508423,255.387634 665.153503,248.561157 665.137024,241.731461
	C664.981812,177.470749 665.045349,113.209488 665.101318,48.948437
	C665.103333,46.576382 663.931946,43.204235 668.628845,43.404961
	C668.277832,46.117432 667.123962,48.622295 667.119873,51.129017
	C667.012451,117.724716 667.020508,184.320602 667.033386,250.916458
	C667.033691,252.394531 667.317749,253.872559 667.751953,256.074951
	C670.053284,256.553009 672.072144,256.306732 674.091003,256.060425
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M897.557129,43.970539
	C896.865906,44.706348 895.716736,45.882324 894.561096,45.888760
	C874.455444,46.000702 854.348938,45.985485 834.242859,45.921326
	C833.220398,45.918068 832.200195,45.224148 831.080322,44.464775
	C853.019836,44.007301 875.058044,43.936852 897.557129,43.970539
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M732.557495,43.973122
	C732.201904,44.703732 731.392151,45.864014 730.567688,45.874542
	C721.628723,45.988701 712.687378,45.939964 703.747314,45.860706
	C703.221985,45.856049 702.702271,45.208130 702.079773,44.473423
	C712.018616,44.014496 722.057556,43.941708 732.557495,43.973122
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M773.558228,43.977936
	C773.203003,44.707653 772.396545,45.859505 771.569214,45.874641
	C764.629761,46.001587 757.686157,45.942451 750.744873,45.856361
	C750.219116,45.849842 749.701172,45.205593 749.080200,44.471535
	C757.019592,44.014584 765.058472,43.943882 773.558228,43.977936
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M809.557739,43.973320
	C809.820618,44.523354 809.616211,45.360989 809.425537,45.357880
	C802.009033,45.236877 794.593933,45.039169 787.080139,44.464466
	C794.353394,44.007866 801.725037,43.938351 809.557739,43.973320
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M918.558105,43.959808
	C914.939087,47.644924 910.555725,46.216591 906.078735,44.462997
	C910.021606,44.005657 914.061768,43.933228 918.558105,43.959808
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M934.991699,47.057110
	C934.996582,46.270344 935.001465,45.483578 935.019043,44.302311
	C936.744934,43.886898 938.458191,43.865986 940.591187,43.943333
	C940.753540,45.175335 940.496155,46.309074 939.685791,47.734268
	C937.777466,47.981628 936.422119,47.937534 935.040283,47.685043
	C935.013916,47.476643 934.991699,47.057110 934.991699,47.057110
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M687.552795,43.843338
	C687.983276,44.693306 687.992065,45.461124 687.631714,46.637119
	C685.859680,47.385712 684.456909,47.726131 683.054077,48.066559
	C682.699158,46.956974 682.344238,45.847389 681.990417,44.384491
	C683.704712,43.941181 685.417969,43.851185 687.552795,43.843338
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M949.612671,43.956123
	C949.158752,46.730457 947.781860,46.540371 946.048584,44.425835
	C947.060547,44.014938 948.138062,43.939522 949.612671,43.956123
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M956.509033,45.833359
	C955.592468,45.635952 954.825562,45.147942 954.023438,44.357048
	C954.652039,44.069687 955.315796,44.085205 956.303467,44.176079
	C956.637756,44.681873 956.648193,45.112316 956.509033,45.833359
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M918.945007,275.147858
	C918.393677,274.931732 917.842346,274.715607 917.144287,273.849792
	C918.040527,272.451111 919.049194,271.108063 920.131714,271.045685
	C930.160217,270.467560 940.465820,272.683533 950.053101,267.879059
	C950.432983,267.957581 950.812866,268.036102 951.544739,268.508575
	C952.918518,269.581512 953.940308,270.260498 954.962036,270.939453
	C954.958435,271.747467 954.954834,272.555481 954.491943,273.714478
	C942.336792,274.426270 930.640869,274.787048 918.945007,275.147858
z"/>
<path fill="#2C66A2" opacity="1.000000" stroke="none"
	d="
M878.197632,382.907623
	C876.930847,381.928589 876.177063,380.386322 875.089539,380.096466
	C873.228088,379.600433 871.014038,380.311035 869.224121,379.702759
	C867.968689,379.276184 867.171997,377.499908 866.170410,376.326355
	C867.273499,375.567596 868.298096,374.359283 869.497192,374.149902
	C871.566895,373.788452 873.843079,374.432007 874.445251,371.295685
	C874.511047,370.953156 878.050476,370.473663 878.870728,371.241394
	C880.781921,373.030457 882.017456,375.541260 883.789551,378.042908
	C882.221802,379.853333 880.391113,381.380585 878.197632,382.907623
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M919.065308,275.524048
	C930.640869,274.787048 942.336792,274.426270 954.450195,274.116547
	C954.444031,275.663177 954.020386,277.158752 953.295776,278.827209
	C951.851318,277.233154 950.949341,276.419281 948.141846,276.523224
	C938.510681,276.879791 928.840820,276.190674 919.065308,275.524048
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M949.219421,292.833893
	C946.610718,292.965637 944.204102,293.291901 942.066223,292.679718
	C940.874084,292.338379 940.128845,290.436218 939.182190,289.237427
	C940.297607,288.491760 941.344543,287.273712 942.542969,287.099792
	C944.958313,286.749237 947.455994,286.966888 950.353638,286.899780
	C950.369568,288.778351 949.951721,290.707275 949.219421,292.833893
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M919.473938,348.052307
	C918.294312,347.013031 917.148193,345.998535 916.646545,344.729340
	C915.986694,343.059845 915.833862,341.189972 915.463074,339.406250
	C916.948792,339.099457 918.458923,338.462646 919.914001,338.570312
	C921.688782,338.701630 923.417358,339.458496 925.552856,339.944336
	C923.891235,342.617188 921.842712,345.290497 919.473938,348.052307
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M940.936523,262.203217
	C940.502075,262.166779 940.067566,262.130341 939.081665,261.805786
	C937.334045,261.305420 936.137878,261.093109 935.028809,260.540100
	C936.249329,260.028503 937.377808,259.810272 938.516785,259.695831
	C941.529419,259.393188 945.379028,260.814758 946.343506,256.053101
	C947.043762,256.455139 947.506775,256.727753 948.254028,257.284912
	C951.022949,257.710876 953.507568,257.852264 955.992249,257.993622
	C955.989075,259.081604 955.985901,260.169556 955.672485,261.527283
	C954.244995,261.878174 953.127869,261.959290 952.010681,262.040405
	C951.560791,262.041199 951.110840,262.041992 950.067871,261.757202
	C946.628723,261.715485 943.782654,261.959351 940.936523,262.203217
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M903.234131,364.803101
	C901.646118,364.272064 900.437500,363.389618 899.091431,363.046234
	C896.821289,362.467102 894.463867,362.229614 892.508118,361.439362
	C895.030884,361.028961 897.188965,361.049072 899.346497,361.022156
	C905.156921,360.949677 905.470398,360.535522 903.944702,355.071259
	C905.688965,356.358002 907.433228,357.644745 909.533936,358.920349
	C907.777588,360.837463 905.664673,362.765747 903.234131,364.803101
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M820.263794,403.864319
	C823.739746,402.666931 827.604736,401.536011 831.724792,400.625488
	C829.251038,401.902008 826.522095,402.958130 823.399841,404.052368
	C822.221863,404.037201 821.437317,403.984009 820.263794,403.864319
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M834.223145,400.717346
	C837.398621,399.246460 840.962891,397.844452 844.757324,396.667725
	C841.529053,398.190704 838.070496,399.488464 834.223145,400.717346
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M933.031677,321.968445
	C934.405029,321.661560 935.778320,321.354645 937.494629,320.973145
	C936.717590,322.812653 935.597717,324.726776 933.861633,326.819336
	C932.798950,326.972534 932.352478,326.947296 931.977661,326.566406
	C932.376709,324.796631 932.704163,323.382538 933.031677,321.968445
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M942.147522,305.890625
	C942.796814,305.896545 943.446106,305.902496 944.413208,305.867432
	C943.790344,307.865417 942.849609,309.904449 941.609741,312.064880
	C940.348755,311.637939 939.386841,311.089569 938.417297,310.017303
	C939.655640,308.292480 940.901611,307.091553 942.147522,305.890625
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M858.124756,392.819031
	C860.277527,391.231079 862.809265,389.683594 865.703796,388.153503
	C863.545654,389.733765 861.024658,391.296600 858.124756,392.819031
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M956.016418,257.684204
	C953.507568,257.852264 951.022949,257.710876 948.296509,256.987610
	C948.101807,256.211090 948.148743,256.016449 948.195618,255.821793
	C950.543091,255.895676 952.890503,255.969574 955.685303,256.092773
	C956.101929,256.552948 956.071228,256.963867 956.016418,257.684204
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M952.202087,262.297943
	C953.127869,261.959290 954.244995,261.878174 955.657898,261.934998
	C955.818298,263.225952 955.682983,264.378906 955.290100,265.768250
	C954.152832,264.854889 953.273193,263.705200 952.202087,262.297943
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M928.447144,336.047913
	C929.154480,334.435730 930.196716,332.754669 931.562622,330.998444
	C930.851501,332.608521 929.816772,334.293762 928.447144,336.047913
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M954.975037,270.568512
	C953.940308,270.260498 952.918518,269.581512 951.831543,268.557556
	C952.556763,268.135162 953.347168,268.057709 954.530212,267.973877
	C954.944580,268.710876 954.966309,269.454193 954.975037,270.568512
z"/>
<path fill="#2C66A2" opacity="1.000000" stroke="none"
	d="
M888.125427,376.873108
	C888.933899,375.885803 890.093811,374.922699 891.606628,373.932129
	C890.798645,374.902191 889.637695,375.899750 888.125427,376.873108
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M868.133789,387.848999
	C868.979736,386.931061 870.183716,386.045471 871.732422,385.199982
	C870.882080,386.120544 869.687012,387.000977 868.133789,387.848999
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M915.306641,352.930603
	C915.744507,351.988647 916.523010,351.020142 917.635254,350.012878
	C917.195129,350.950714 916.421204,351.927399 915.306641,352.930603
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M931.906006,326.922089
	C932.352478,326.947296 932.798950,326.972534 933.579407,326.997742
	C933.744385,327.563721 933.575378,328.129700 933.141968,328.849976
	C932.270325,328.563599 931.663147,328.122894 931.244507,327.327148
	C931.433105,326.972076 931.906006,326.922089 931.906006,326.922089
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M951.414917,285.940155
	C951.081360,285.293396 951.084167,284.585114 951.413025,283.476501
	C952.153259,283.044647 952.567505,283.013153 952.981750,282.981628
	C952.571594,283.947327 952.161438,284.912994 951.414917,285.940155
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M913.200195,355.760925
	C913.360046,354.934052 913.828674,354.011688 914.627014,353.028168
	C914.474182,353.866486 913.991577,354.765991 913.200195,355.760925
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M848.017578,396.755066
	C848.266663,396.169769 848.850281,395.645569 849.747437,395.145508
	C849.491394,395.718475 848.921753,396.267334 848.017578,396.755066
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M853.104370,394.837830
	C853.337158,394.261444 853.895142,393.718384 854.767334,393.213562
	C854.530823,393.791565 853.980164,394.331360 853.104370,394.837830
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M952.973389,282.638794
	C952.567505,283.013153 952.153259,283.044647 951.431885,283.122559
	C951.479126,282.474030 951.833496,281.779083 952.492676,281.010071
	C952.853271,281.389343 952.909180,281.842682 952.973389,282.638794
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M926.447876,339.058105
	C926.526611,338.451782 926.910339,337.762482 927.613770,337.012970
	C927.539917,337.626892 927.146362,338.300995 926.447876,339.058105
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M685.153442,322.110870
	C687.909668,321.821320 690.637512,321.972198 693.365906,321.983429
	C701.859192,322.018372 710.355286,322.112183 718.843750,321.909149
	C720.554077,321.868225 722.212158,320.556366 723.937683,319.954651
	C725.371460,319.454681 727.329102,318.356598 728.245178,318.896637
	C730.341797,320.132477 731.943298,322.208282 733.745850,323.942993
	C732.017517,325.275513 730.344177,327.666565 728.551514,327.759583
	C720.246094,328.190460 711.907532,327.986755 703.580872,328.003448
	C699.503601,328.011627 695.426331,328.004822 690.127563,328.004822
	C691.810547,330.842010 692.842407,332.581604 693.886719,334.685394
	C692.110962,333.051788 690.126404,331.192352 688.592346,329.015472
	C687.184204,327.017365 686.261780,324.677002 685.153442,322.110870
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M671.108154,286.242554
	C672.434143,285.645111 674.433594,285.849670 674.862366,285.124939
	C677.083862,281.370483 678.942627,282.545532 680.662354,285.524841
	C676.065613,285.190308 674.845093,286.945160 676.025818,292.148407
	C674.204712,298.318329 678.001160,303.980835 683.982727,304.006866
	C687.302063,304.021301 690.622131,304.066071 693.940430,304.010223
	C696.130920,303.973389 698.075195,304.458191 699.448669,301.328430
	C700.699158,298.478668 703.272400,300.340851 704.619751,302.563599
	C697.707092,307.888062 689.746704,305.093842 681.669250,306.493469
	C683.157410,308.099121 684.090881,309.106293 685.024353,310.113464
	C683.749084,310.292328 682.473877,310.471222 680.986572,310.884277
	C678.187012,305.005798 675.599487,298.893188 672.980591,292.392517
	C672.318481,290.208313 671.687744,288.412079 671.108154,286.242554
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M696.136658,339.260803
	C697.131714,339.408722 698.110168,339.921417 699.936584,340.878448
	C699.664429,339.047363 699.415283,337.766785 699.294434,336.474182
	C699.060181,333.966919 699.885620,333.388885 701.937012,335.939575
	C702.205688,339.858673 700.599487,343.991516 706.119812,344.190155
	C705.540100,345.102783 704.960327,346.015381 704.260986,347.116211
	C705.109253,348.462097 706.016663,349.901794 706.946533,351.688019
	C703.352661,347.898224 699.736389,343.761902 696.136658,339.260803
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M720.016174,362.076660
	C720.016724,362.802734 720.017334,363.528778 720.018921,364.617554
	C717.455872,362.833344 714.891907,360.686493 712.225159,358.216797
	C715.813599,357.279144 719.504700,356.664337 723.541504,356.429993
	C722.019043,357.488556 720.150940,358.166626 718.128784,358.900635
	C718.850647,360.115417 719.433411,361.096039 720.016174,362.076660
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M738.981934,378.502319
	C741.174194,373.312805 741.174194,373.312805 743.675659,374.611267
	C741.990662,377.120941 741.990662,377.120941 745.974609,379.844330
	C745.982117,380.631042 745.989685,381.417725 746.002808,382.597595
	C743.697144,381.599701 741.385742,380.208649 738.981934,378.502319
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M791.107422,401.335327
	C794.657288,401.665924 798.265686,402.376404 802.005249,403.429169
	C798.479614,403.086029 794.822754,402.400574 791.107422,401.335327
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M767.984558,393.461517
	C769.886658,393.806976 771.891846,394.488861 774.002563,395.502716
	C772.101257,395.155792 770.094482,394.476837 767.984558,393.461517
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M810.172729,405.129211
	C810.872620,404.706970 811.740662,404.556335 812.801025,404.628906
	C812.109253,405.035004 811.225098,405.217896 810.172729,405.129211
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M815.218018,404.852478
	C815.773010,404.330933 816.680725,403.878601 817.793945,403.655945
	C817.189880,404.230988 816.380310,404.576355 815.218018,404.852478
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M804.206970,404.176941
	C804.987244,403.984802 805.974304,404.078308 807.054382,404.461090
	C806.236206,404.654449 805.324951,404.558502 804.206970,404.176941
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M763.911682,391.543213
	C764.513611,391.574219 765.224731,391.897552 766.022949,392.530029
	C765.413696,392.504639 764.717285,392.170105 763.911682,391.543213
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M682.091797,315.242249
	C682.680725,315.442474 683.272400,315.962708 683.844238,316.812134
	C683.247742,316.614990 682.671204,316.088654 682.091797,315.242249
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M728.010010,371.361053
	C728.617493,371.456299 729.279602,371.869629 730.006775,372.594849
	C729.402771,372.497498 728.733704,372.088318 728.010010,371.361053
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M751.906006,385.536194
	C752.509033,385.603851 753.212585,385.963898 753.967224,386.653137
	C753.347778,386.597778 752.677124,386.213165 751.906006,385.536194
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M675.097290,275.815674
	C673.357666,275.567993 671.618103,275.320312 669.503418,275.091003
	C668.797241,273.958557 668.466064,272.807770 668.521179,271.316772
	C669.948059,270.991943 670.988708,271.007263 672.028503,271.380798
	C673.050842,273.097931 674.074036,274.456818 675.097290,275.815674
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M672.029358,271.022583
	C670.988708,271.007263 669.948059,270.991943 668.522034,270.960083
	C668.111389,270.493134 668.086121,270.042694 668.121155,269.256531
	C669.742065,269.306976 671.302673,269.693146 672.714478,270.511597
	C672.386841,270.970062 672.208130,270.996307 672.029358,271.022583
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M670.694519,282.158295
	C671.103821,282.558380 671.305298,283.122131 671.292603,283.846832
	C670.881165,283.445831 670.683960,282.883911 670.694519,282.158295
z"/>
<path fill="#3A6995" opacity="1.000000" stroke="none"
	d="
M957.827026,244.774170
	C957.408630,244.280090 957.377502,243.973938 957.465454,243.434555
	C957.757446,243.160461 958.002686,243.112274 958.713257,243.227966
	C959.340393,243.648438 959.570251,243.805145 959.868164,243.861984
	C959.916077,244.319672 959.963928,244.777359 960.041870,245.577362
	C959.428589,245.602936 958.785278,245.286179 957.827026,244.774170
z"/>
<path fill="#315882" opacity="1.000000" stroke="none"
	d="
M959.780762,243.668640
	C959.570251,243.805145 959.340393,243.648438 959.086853,243.196762
	C959.278381,243.085129 959.511169,243.243027 959.780762,243.668640
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M680.976196,261.113281
	C676.586731,259.263794 676.942749,255.229141 676.275513,251.262421
	C676.023376,250.563751 676.060486,250.135239 676.524048,249.275528
	C677.648926,242.913116 678.347351,236.981903 679.045715,231.050674
	C678.646667,229.366287 678.247681,227.681885 677.409302,225.509064
	C676.711304,223.055481 676.452576,221.090332 676.149109,219.110596
	C676.104370,219.096008 676.116089,219.189392 676.502808,219.179901
	C677.918579,219.063110 678.947693,218.955811 680.009399,219.191605
	C680.441528,220.055649 680.840942,220.576584 681.187378,221.441086
	C681.803101,222.889664 682.471802,223.994690 683.102905,225.452179
	C683.420288,226.933731 683.775146,228.062805 684.042236,229.574783
	C683.207581,234.569077 682.460754,239.180481 681.456787,243.883347
	C681.125549,244.656342 681.051392,245.337875 680.963867,246.445587
	C680.608704,250.336792 680.266968,253.801804 679.845947,258.070526
	C682.109131,257.492035 683.448059,257.149811 685.208984,256.869507
	C686.756348,256.909241 687.881653,256.887024 689.296082,257.139648
	C692.512512,257.642212 695.727295,259.514893 698.257935,255.861359
	C699.000610,255.481140 699.476685,255.185318 700.127930,255.154297
	C700.894897,255.591690 701.486511,255.764282 702.351685,256.070709
	C704.065552,256.431915 705.505920,256.659271 707.295776,256.922546
	C708.457642,256.620575 709.270020,256.282715 710.398926,255.968567
	C711.138367,256.000031 711.561218,256.007812 712.338013,256.200439
	C714.810425,256.669495 716.929016,256.953644 719.255493,257.438538
	C720.360107,256.777405 721.256836,255.915482 722.454346,255.046524
	C723.156067,255.046234 723.557068,255.052979 724.012085,255.402802
	C725.512085,257.975555 727.002075,260.082611 730.393433,257.888428
	C732.517700,257.268677 734.284058,256.648254 736.424927,256.035461
	C738.626282,256.587433 740.453247,257.131714 742.653320,257.720367
	C745.392151,257.217407 747.757751,256.670105 750.369141,256.021057
	C751.065918,255.641983 751.516846,255.364685 752.131836,255.266235
	C753.268555,255.568893 754.241272,255.692719 755.520142,256.042358
	C757.563049,256.607635 759.299622,256.947113 761.248657,257.498383
	C762.347290,257.436554 763.233459,257.162933 764.468628,256.909180
	C766.388245,256.611176 767.958923,256.293274 769.801758,256.276947
	C773.909119,259.786621 777.387817,256.717316 781.382080,255.975708
	C782.791992,255.992325 783.817688,255.991318 784.916016,256.301392
	C785.360229,257.365692 785.731689,258.118927 785.843262,259.055176
	C785.372681,259.822937 785.162048,260.407684 784.951416,260.992432
	C780.278625,261.084778 775.605774,261.177124 770.328186,260.990173
	C768.813965,260.787109 767.904480,260.863403 766.622192,260.941772
	C765.504272,260.972504 764.759216,261.001190 763.839233,260.795227
	C762.753784,260.755127 761.843201,260.949615 760.539185,261.119812
	C759.095032,261.113739 758.044495,261.132019 756.860413,260.901184
	C756.141479,260.803650 755.556091,260.955200 754.970642,261.106781
	C753.929932,261.101898 752.889282,261.097015 751.202515,260.820557
	C748.366882,260.794312 746.177307,261.039673 743.987732,261.285004
	C743.242737,261.269440 742.497803,261.253906 741.169434,260.938110
	C738.722229,260.854431 736.858398,261.071014 734.994629,261.287598
	C733.637207,261.289246 732.279724,261.290863 730.180176,261.239929
	C728.944946,261.173767 728.451843,261.160217 727.705505,260.839661
	C724.633606,260.791016 721.815002,261.049438 718.996399,261.307861
	C717.932251,261.277618 716.868042,261.247406 715.151367,260.898682
	C710.001465,260.690979 705.504028,260.801788 700.674194,260.912781
	C699.898499,260.917236 699.455261,260.921478 698.814087,260.688080
	C697.749451,260.680756 696.882751,260.911102 695.597717,261.116974
	C693.782715,261.101929 692.386169,261.111359 690.821411,260.857910
	C689.766541,260.721008 688.879761,260.846954 687.627930,260.965088
	C685.167358,261.009277 683.071777,261.061279 680.976196,261.113281
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M851.077148,321.995148
	C856.216370,321.995209 860.867615,322.042084 865.517334,321.974548
	C868.208984,321.935455 871.302246,322.838074 872.550964,318.940125
	C872.682434,318.529572 875.739685,318.399811 876.826843,319.096252
	C878.752319,320.329865 880.410706,322.165283 881.664673,324.085938
	C881.881958,324.418701 879.730042,326.707733 878.341614,327.543213
	C877.325500,328.154694 875.767578,327.956940 874.450500,327.962006
	C865.481628,327.996338 856.504211,328.198578 847.549561,327.843231
	C845.385986,327.757355 841.575256,325.894623 841.495544,324.657288
	C841.252014,320.879028 844.883484,322.306732 847.104126,322.015076
	C848.246826,321.865021 849.425964,321.992126 851.077148,321.995148
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M722.436523,304.959473
	C729.369812,304.959137 735.855164,304.824585 742.330750,305.016724
	C746.071472,305.127716 749.329834,304.983673 749.725769,299.514679
	C752.004639,300.783936 753.869629,301.492004 755.296753,302.712250
	C756.674438,303.890259 757.600403,305.596497 758.724854,307.070648
	C757.075989,308.323761 755.456421,310.613647 753.773621,310.661102
	C743.154602,310.960571 732.518372,310.876709 721.897400,310.578613
	C720.624817,310.542877 719.409973,308.450684 718.168335,307.311646
	C719.440369,306.528534 720.712402,305.745392 722.436523,304.959473
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M818.957764,327.980957
	C811.639221,327.982574 804.801025,328.221954 797.995361,327.856110
	C795.598022,327.727234 793.280396,326.116852 790.926331,325.182892
	C791.025940,324.504089 791.125549,323.825287 791.225159,323.146454
	C792.804138,322.760864 794.377991,322.069244 795.963074,322.042389
	C802.952820,321.923706 809.954834,322.200165 816.932922,321.891815
	C819.448303,321.780701 821.909058,320.431488 824.394775,319.647278
	C824.324341,319.093597 824.253967,318.539917 824.183533,317.986237
	C825.881531,318.568207 827.815430,318.821350 829.212219,319.823273
	C830.653870,320.857300 832.817932,323.216644 832.469666,323.942932
	C831.668335,325.613861 829.700928,327.339874 827.900940,327.773163
	C825.222839,328.417847 822.280701,327.965759 818.957764,327.980957
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M710.007324,292.970856
	C705.850037,292.976044 702.139160,293.349304 698.553162,292.841095
	C696.653687,292.571838 694.971313,290.770538 693.190918,289.660919
	C694.866638,288.793365 696.515686,287.243591 698.222656,287.177094
	C705.363342,286.898743 712.526306,287.207703 719.669189,286.959045
	C721.256470,286.903778 722.751587,285.351044 724.371155,284.688507
	C725.540955,284.209930 727.414307,283.397522 727.990295,283.888336
	C730.118835,285.702179 731.838684,287.995605 733.712097,290.108826
	C732.296509,291.059296 730.917480,292.759308 729.458984,292.830383
	C723.153870,293.137665 716.825500,292.968445 710.007324,292.970856
z"/>
<path fill="#2C66A2" opacity="1.000000" stroke="none"
	d="
M862.996399,292.997467
	C857.352722,292.993286 852.180359,293.295990 847.076843,292.835510
	C845.038452,292.651581 843.151917,290.783813 841.196289,289.682556
	C843.026001,288.813019 844.826355,287.275116 846.690735,287.193085
	C853.647949,286.886902 860.626953,287.110748 867.595825,287.005432
	C868.975037,286.984589 870.473206,286.628632 871.684021,285.987915
	C872.891052,285.349152 874.381042,283.157257 874.755188,283.372253
	C877.138611,284.741760 880.198547,286.155640 881.213074,288.384491
	C882.561096,291.345764 879.539673,292.724701 876.933533,292.873688
	C872.466370,293.129089 867.975952,292.978363 862.996399,292.997467
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M784.984619,304.961670
	C788.633972,304.964874 791.799622,305.131805 794.934204,304.892700
	C796.241455,304.792999 797.471008,303.800629 798.757141,303.265289
	C800.316711,302.616150 802.437195,301.076965 803.357483,301.601807
	C805.193298,302.648773 806.765015,304.681305 807.580750,306.662872
	C807.812378,307.225616 805.220276,309.730316 803.634644,310.097198
	C800.463684,310.830811 797.095581,310.849121 793.804810,310.899384
	C787.002319,311.003326 780.196533,310.992035 773.393372,310.914673
	C769.528320,310.870758 768.674133,310.054504 767.133545,304.961578
	C773.096008,304.961578 778.792114,304.961578 784.984619,304.961670
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M768.903320,339.311859
	C776.924133,339.148407 784.557373,339.337708 792.166077,338.990662
	C794.966431,338.862885 797.708984,337.468689 800.477905,336.652161
	C800.383667,336.192596 800.289490,335.733032 800.195251,335.273499
	C800.356995,335.257324 800.592224,335.163147 800.669800,335.236267
	C803.042419,337.473083 807.558594,339.982941 807.327576,341.925598
	C806.779724,346.533630 801.903320,344.884247 798.661438,344.942871
	C789.879089,345.101715 781.091064,345.076263 772.307129,344.969116
	C767.683289,344.912720 766.671143,343.286407 768.903320,339.311859
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M856.679077,374.625427
	C857.279663,378.486084 855.343811,379.906799 852.194946,379.930542
	C842.366394,380.004700 832.531494,380.157654 822.712097,379.855774
	C820.422058,379.785370 818.183594,378.036316 815.921448,377.059601
	C816.011353,376.446564 816.101318,375.833527 816.191223,375.220490
	C817.759338,374.826233 819.322632,374.115814 820.896423,374.091705
	C828.224731,373.979401 835.564148,374.257324 842.881592,373.956024
	C845.391296,373.852661 847.848389,372.469757 850.329529,371.671417
	C850.401184,370.984711 850.472778,370.297974 850.544373,369.611267
	C852.535828,371.167175 854.527283,372.723083 856.679077,374.625427
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M866.914612,309.170715
	C865.281006,305.149780 867.845642,304.998138 870.319336,304.981720
	C877.818176,304.931915 885.321350,305.093994 892.814087,304.875366
	C894.519287,304.825623 896.193970,303.585022 897.874084,302.872253
	C899.048584,302.373932 900.720825,301.084412 901.280396,301.463257
	C903.075195,302.678406 904.832825,304.309479 905.809631,306.192566
	C906.196045,306.937531 904.750854,309.072235 903.655640,310.007172
	C902.775452,310.758636 901.167419,310.885468 899.879517,310.894684
	C890.714294,310.960480 881.547180,310.999451 872.383667,310.855286
	C870.647888,310.828003 868.925659,309.945923 866.914612,309.170715
z"/>
<path fill="#2C67A6" opacity="1.000000" stroke="none"
	d="
M866.523621,340.404266
	C874.792725,339.868622 882.847046,339.829681 890.882263,339.417847
	C893.229370,339.297546 895.491089,337.969910 897.849976,337.468506
	C899.536987,337.109985 901.715149,336.534790 902.963013,337.267426
	C904.578613,338.216003 905.486694,340.369629 906.699402,342.004395
	C905.146301,342.998047 903.613037,344.814667 902.037048,344.852539
	C891.396851,345.108215 880.747681,344.983704 870.101379,344.990387
	C867.246643,344.992188 865.577820,343.956757 866.523621,340.404266
z"/>
<path fill="#2C66A2" opacity="1.000000" stroke="none"
	d="
M796.413574,397.015839
	C794.671631,396.053436 793.383057,395.096069 792.094421,394.138733
	C793.380737,393.129333 794.651855,391.273926 795.955872,391.250519
	C803.334778,391.118256 810.722229,391.539886 818.105042,391.493256
	C819.746399,391.482941 821.365479,390.304565 823.022766,389.746704
	C824.527039,389.240295 826.622009,388.009003 827.480652,388.575806
	C829.318420,389.788879 830.822205,391.816010 831.782837,393.833496
	C832.023560,394.339172 829.808472,396.885132 828.513184,397.076080
	C825.499023,397.520447 822.357788,397.055359 819.267700,397.041962
	C811.800903,397.009613 804.333862,397.024841 796.413574,397.015839
z"/>
<path fill="#2C66A2" opacity="1.000000" stroke="none"
	d="
M876.065735,353.858673
	C877.737000,355.668488 879.408325,357.478333 880.794861,359.762543
	C879.679138,360.855286 878.848145,361.473663 878.017151,362.092010
	C866.983398,362.090637 855.949585,362.089264 844.297485,361.839264
	C843.115173,361.400269 842.551270,361.209869 841.987366,361.019470
	C841.987366,361.019470 842.000000,361.000000 842.001648,360.649597
	C842.330078,359.174500 842.656860,358.049805 842.983643,356.925110
	C851.260010,356.947540 859.536865,357.019653 867.812256,356.942749
	C869.167786,356.930145 870.517212,356.261230 872.323364,355.441467
	C873.873413,354.611084 874.969604,354.234863 876.065735,353.858673
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M931.977661,326.566406
	C931.906006,326.922089 931.433105,326.972076 931.199829,327.020599
	C918.651428,327.350464 906.336304,327.631775 893.490662,327.533661
	C891.138916,323.631256 892.812439,323.117096 896.070068,322.885132
	C907.425903,322.076447 919.195923,325.624756 930.086609,319.787109
	C930.964111,320.330048 931.841553,320.872986 932.875366,321.692200
	C932.704163,323.382538 932.376709,324.796631 931.977661,326.566406
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M782.090820,360.037170
	C780.672974,360.698395 779.264648,361.908295 777.835815,361.932983
	C767.536926,362.110840 757.233459,362.093201 746.932617,362.002075
	C745.735962,361.991486 744.546753,361.151947 743.164185,360.000183
	C743.017456,358.559784 743.060608,357.816010 743.103760,357.072235
	C752.762878,357.049500 762.421936,357.026764 772.944824,357.003723
	C775.881958,356.663177 777.955261,356.322968 780.028564,355.982758
	C780.512207,356.250458 780.995911,356.518188 781.726440,357.275696
	C782.012512,358.522736 782.051636,359.279938 782.090820,360.037170
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M800.158447,363.005981
	C796.412781,362.713837 791.385559,364.302826 791.356079,359.289124
	C791.322754,353.610535 796.651123,356.377350 799.585754,356.152679
	C805.217529,355.721588 810.906738,356.084869 816.570801,356.011169
	C818.882385,355.981140 821.782593,356.985443 822.488464,353.136444
	C822.533264,352.892334 826.344849,352.572388 827.491516,353.462769
	C829.624146,355.118835 831.083618,357.641693 832.823303,359.803711
	C830.425049,360.866333 828.064209,362.731995 825.621887,362.845520
	C817.308716,363.231995 808.966797,363.000458 800.158447,363.005981
M806.516113,361.021637
	C814.560059,360.649811 822.717896,361.852173 830.924133,359.053406
	C829.276001,357.281891 827.373718,356.077820 825.521240,356.150055
	C823.056946,356.246094 820.650330,357.809631 818.185547,357.908234
	C811.571594,358.172791 804.939270,357.950989 798.315430,358.024017
	C796.908936,358.039520 795.507141,358.487061 794.103210,358.735535
	C794.138489,359.496857 794.173767,360.258209 794.209045,361.019531
	C797.981079,361.019531 801.753052,361.019531 806.516113,361.021637
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M855.006897,309.010193
	C853.451050,309.357025 851.897583,309.991302 850.338989,310.004089
	C840.203674,310.087250 830.067261,310.035431 819.469788,309.699036
	C818.985657,308.939423 818.962952,308.508545 819.071045,307.782593
	C819.476440,306.689484 819.751038,305.891388 820.025574,305.093323
	C828.829590,304.948151 837.633667,304.803009 847.133240,304.378357
	C848.927734,303.590424 850.026611,303.081940 851.125549,302.573486
	C852.340027,303.117126 853.554504,303.660797 854.909302,304.916229
	C855.035400,306.755402 855.021118,307.882812 855.006897,309.010193
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M672.028503,271.380798
	C672.208130,270.996307 672.386841,270.970062 672.822144,270.852661
	C681.900635,270.368652 690.722656,269.975769 700.129089,269.272614
	C701.475464,268.295746 702.237366,267.629150 702.999268,266.962524
	C703.796753,267.229584 704.594299,267.496643 705.716797,268.230621
	C706.763489,269.463745 707.485107,270.229950 708.206726,270.996155
	C708.010681,271.882812 707.814575,272.769440 707.006592,273.852112
	C705.567200,274.649292 704.739624,275.250458 703.912109,275.851685
	C694.612305,275.866699 685.312439,275.881744 675.554932,275.856232
	C674.074036,274.456818 673.050842,273.097931 672.028503,271.380798
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M857.630981,339.560394
	C858.199829,344.478027 854.979614,345.787018 851.556519,345.875458
	C841.768799,346.128296 831.969971,345.987000 822.176086,345.917358
	C821.056091,345.909424 819.708496,345.666351 818.878418,345.010681
	C817.747864,344.117523 817.013611,342.722687 816.109436,341.542938
	C817.327881,340.698395 818.524109,339.163055 819.768433,339.122986
	C827.065308,338.888214 834.373352,339.002594 841.677673,338.999603
	C843.482239,338.998871 845.286743,338.999512 847.375977,338.999512
	C847.375977,337.259186 847.375977,335.893829 847.375977,333.039520
	C851.291016,335.436279 854.380554,337.327667 857.630981,339.560394
M850.998230,338.608337
	C848.918884,339.392365 846.863831,340.765533 844.755676,340.852661
	C837.776001,341.141144 830.776611,340.919220 823.786072,341.004456
	C822.220886,341.023560 820.661194,341.495148 817.744934,341.986603
	C819.634827,343.228912 820.137512,343.846558 820.645020,343.850616
	C831.128357,343.934052 841.614075,344.042999 852.093628,343.845367
	C853.300964,343.822571 854.474548,342.015015 855.663818,341.034973
	C854.334167,340.105225 853.004517,339.175507 850.998230,338.608337
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M795.941833,380.025482
	C788.136230,380.030060 780.820190,380.021790 773.504333,380.048645
	C770.769043,380.058685 767.423157,380.123779 767.328491,376.682190
	C767.223633,372.865143 770.864502,374.084778 773.087585,374.035095
	C779.568909,373.890198 786.058289,373.872894 792.539062,374.029663
	C796.098572,374.115723 799.326233,374.131104 799.442749,369.608795
	C799.990356,369.460724 800.189758,369.332855 800.305298,369.386292
	C803.694458,370.953918 808.455627,371.962250 807.674561,376.734436
	C806.890198,381.527344 802.179199,379.703400 798.924316,380.025269
	C798.101379,380.106628 797.262878,380.030396 795.941833,380.025482
M804.482788,377.692780
	C804.692993,376.740570 804.903198,375.788330 805.113342,374.836121
	C803.879211,374.676880 802.611084,374.255707 801.417725,374.410553
	C798.541931,374.783600 795.714172,375.781158 792.843445,375.887360
	C786.537476,376.120605 780.216553,375.928436 773.902405,375.984650
	C772.779480,375.994598 771.659668,376.365021 770.538452,376.569031
	C770.577393,377.031982 770.616333,377.494934 770.655212,377.957886
	C781.667908,377.957886 792.680603,377.957886 804.482788,377.692780
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M801.064331,261.435364
	C799.765320,265.777924 804.557678,265.821808 805.575439,268.600891
	C803.554016,268.884735 801.807434,268.586334 800.186279,268.912170
	C798.078674,269.335724 796.104370,270.712250 794.012939,270.865936
	C789.728088,271.180878 785.403442,270.952850 781.095154,270.950958
	C776.907715,270.949158 772.720276,270.950592 768.532898,270.950592
	C768.400879,271.670135 768.268799,272.389709 768.136780,273.109253
	C770.170898,273.741577 772.191833,274.866394 774.241455,274.921631
	C783.512390,275.171326 792.791443,275.118622 802.067566,275.174866
	C800.710815,275.777618 799.363953,276.874451 797.995605,276.902039
	C789.835876,277.066650 781.670349,277.044952 773.508911,276.933136
	C771.911743,276.911224 770.003601,276.634888 768.818787,275.722687
	C767.559143,274.752869 766.989014,272.887543 766.117737,271.413269
	C767.546448,270.607117 768.952942,269.154633 770.407593,269.104614
	C777.396057,268.864319 784.397522,269.002655 791.394409,269.006927
	C799.120544,269.011658 799.134827,268.990631 796.374634,261.694397
	C798.202698,261.283142 799.633545,261.359253 801.064331,261.435364
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M719.928650,344.055664
	C719.014404,343.098999 718.100159,342.142334 717.185913,341.185669
	C718.505127,340.458069 719.809204,339.135132 721.146118,339.100983
	C728.960388,338.901123 736.785034,339.106873 744.599487,338.911224
	C746.075806,338.874268 747.545532,337.691528 748.974670,336.953033
	C749.990967,336.427917 751.318115,335.014679 751.843994,335.285309
	C754.267883,336.532654 756.669128,338.019562 758.587402,339.917084
	C759.069519,340.393982 758.118347,343.091156 757.132935,344.071381
	C756.070312,345.128448 754.202026,345.861328 752.672363,345.884460
	C742.526184,346.038025 732.376526,345.984711 722.228455,345.914551
	C721.536011,345.909760 720.848206,345.221008 720.525269,344.434204
	C730.696350,344.014496 740.500366,344.021118 750.304382,343.995270
	C751.623901,343.991791 753.266724,344.272858 754.177124,343.615295
	C755.225830,342.857941 755.627136,341.204315 756.309570,339.939911
	C754.900940,339.472656 753.418579,338.461731 752.097717,338.640961
	C748.281250,339.158905 744.560791,340.589661 740.745483,340.862640
	C735.124084,341.264801 729.452454,341.031311 723.803772,340.954254
	C721.541260,340.923401 719.777466,341.212372 719.928650,344.055664
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M765.007080,327.868591
	C761.973633,327.654144 758.940125,327.439667 755.100891,327.132446
	C752.532043,327.317688 750.768921,327.595673 749.005859,327.873657
	C748.282654,327.874908 747.559448,327.876129 746.393433,327.552399
	C745.276855,326.853607 744.603027,326.479736 743.929260,326.105896
	C743.929260,326.105896 743.947144,326.046509 743.970581,325.636292
	C745.710449,324.482147 747.370361,323.295685 749.152771,323.067993
	C758.790588,321.837006 768.993835,325.745392 778.123108,319.830444
	C778.528687,319.882568 778.934265,319.934662 779.684570,320.343140
	C783.497742,324.324280 778.630920,325.482849 777.908447,327.867676
	C777.482788,327.876068 777.057129,327.884430 776.161743,327.677124
	C775.129761,327.598480 774.567505,327.735565 774.005310,327.872681
	C772.612732,327.886383 771.220215,327.900085 769.190552,327.658569
	C767.371399,327.558441 766.189209,327.713501 765.007080,327.868591
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M831.055237,286.969055
	C834.517700,289.051544 833.547791,291.137024 830.832886,292.826843
	C829.633789,293.573212 827.997314,293.910797 826.554626,293.924500
	C816.602051,294.019104 806.647949,294.016357 796.695190,293.936066
	C795.431213,293.925842 793.880005,293.618774 792.989929,292.843262
	C792.019592,291.997650 791.070190,290.364380 791.226624,289.227875
	C791.354736,288.296844 793.081177,286.952271 794.164246,286.887939
	C801.747253,286.437439 809.357178,286.422394 816.935608,285.921906
	C819.148193,285.775787 821.286560,284.506500 823.458923,283.752014
	C823.446716,283.172546 823.434448,282.593048 823.422241,282.013550
	C824.915344,282.743652 826.408508,283.473724 827.581787,284.589020
	C821.999756,289.074249 815.829163,287.969025 809.861389,287.998260
	C805.866333,288.017853 801.858765,287.812195 797.881958,288.079895
	C796.347778,288.183197 794.882996,289.316467 793.386597,289.980499
	C794.859863,290.674591 796.322693,291.942383 797.808167,291.969513
	C807.293457,292.142731 816.786011,291.918488 826.271240,292.093750
	C830.123779,292.164917 831.349976,290.441223 831.055237,286.969055
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M758.095947,270.979065
	C757.907593,271.856262 757.719177,272.733490 756.864380,273.873322
	C754.079834,274.426880 751.964966,274.940033 749.843018,274.970673
	C740.209351,275.109833 730.573669,275.112946 720.938721,275.164978
	C720.448975,274.863220 719.959167,274.561462 719.242310,273.724915
	C720.709106,272.448486 722.338989,271.324310 724.107300,271.028809
	C733.721558,269.422333 744.293213,274.554688 753.052673,266.873871
	C753.792297,267.244659 754.531860,267.615479 755.639160,268.352570
	C756.703186,269.472260 757.399597,270.225647 758.095947,270.979065
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M818.976990,275.052795
	C818.393066,274.548218 817.809204,274.043640 817.114014,272.943237
	C816.993958,271.893188 816.985168,271.439026 816.976318,270.984833
	C816.976318,270.984833 817.000000,271.001221 817.462891,270.995605
	C829.633240,269.824463 841.798584,273.731323 853.077148,267.816345
	C854.024597,268.310120 854.972046,268.803894 855.988281,270.030060
	C856.169983,274.963745 853.156921,274.981171 850.266541,274.995178
	C839.836853,275.045685 829.406860,275.038300 818.976990,275.052795
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M802.451904,275.131378
	C792.791443,275.118622 783.512390,275.171326 774.241455,274.921631
	C772.191833,274.866394 770.170898,273.741577 768.136780,273.109253
	C768.268799,272.389709 768.400879,271.670135 768.532898,270.950592
	C772.720276,270.950592 776.907715,270.949158 781.095154,270.950958
	C785.403442,270.952850 789.728088,271.180878 794.012939,270.865936
	C796.104370,270.712250 798.078674,269.335724 800.186279,268.912170
	C801.807434,268.586334 803.554016,268.884735 805.627014,268.944702
	C806.117493,269.303711 806.306763,269.564880 806.780212,270.248962
	C806.633972,272.136658 806.284424,273.542755 805.934937,274.948853
	C804.902039,274.995209 803.869202,275.041565 802.451904,275.131378
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M830.776306,286.843018
	C831.349976,290.441223 830.123779,292.164917 826.271240,292.093750
	C816.786011,291.918488 807.293457,292.142731 797.808167,291.969513
	C796.322693,291.942383 794.859863,290.674591 793.386597,289.980499
	C794.882996,289.316467 796.347778,288.183197 797.881958,288.079895
	C801.858765,287.812195 805.866333,288.017853 809.861389,287.998260
	C815.829163,287.969025 821.999756,289.074249 827.657898,284.928345
	C828.868347,285.493988 829.682861,286.105469 830.776306,286.843018
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M892.907837,292.132507
	C892.645630,291.929352 892.383484,291.726166 892.059753,290.971344
	C892.326599,289.563507 892.654907,288.707336 892.983215,287.851196
	C900.011169,287.873901 907.039124,287.896637 914.787170,288.207214
	C918.698730,289.165100 921.907776,290.074127 923.518372,285.776398
	C923.724060,285.227478 925.204468,285.156250 926.094299,284.863708
	C926.489685,284.933044 926.885010,285.002380 927.651672,285.445435
	C930.497131,290.301941 929.575989,291.916260 924.295959,291.971771
	C913.833862,292.081818 903.370605,292.085114 892.907837,292.132507
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M769.008728,287.775818
	C770.191223,287.716766 771.373779,287.657684 773.133789,287.334290
	C774.137756,287.044678 774.564087,287.019440 775.318481,286.952759
	C776.104980,286.246094 776.563477,285.580872 777.021973,284.915649
	C778.436462,285.570679 779.850952,286.225769 781.604858,287.296448
	C781.993713,288.153778 782.043152,288.595490 782.092529,289.037201
	C782.153992,292.306854 779.823425,292.103699 777.636963,292.102448
	C767.070435,292.096436 756.503967,292.088409 745.472839,291.653809
	C744.991028,290.463837 744.973816,289.701202 745.427734,288.918549
	C750.397766,288.894348 754.902466,289.026520 759.393921,288.839935
	C762.608032,288.706482 765.804443,288.145874 769.008728,287.775818
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M801.500427,261.336121
	C799.633545,261.359253 798.202698,261.283142 796.358032,261.334412
	C792.586182,261.346649 789.228149,261.231537 785.410767,261.054413
	C785.162048,260.407684 785.372681,259.822937 786.299316,259.084045
	C792.354309,258.541473 797.693298,258.153046 803.401733,257.829285
	C804.521545,257.901764 805.271973,257.909637 806.286011,258.230530
	C810.021423,258.338135 813.493164,258.132751 817.348633,257.953796
	C818.501526,257.968628 819.270569,257.957062 820.256836,258.238525
	C825.928345,258.644104 831.382568,258.756592 837.099854,259.037598
	C837.596924,259.766998 837.830994,260.327881 837.765930,260.957703
	C836.977112,261.351807 836.487305,261.676971 835.997559,262.002136
	C834.291565,262.005432 832.585510,262.008728 830.003540,261.996338
	C822.701538,261.818207 816.275391,261.655792 809.849304,261.493347
	C807.211731,261.407867 804.574097,261.322388 801.500427,261.336121
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M836.271240,262.288818
	C836.487305,261.676971 836.977112,261.351807 838.157532,260.984344
	C839.899292,260.930176 840.950439,260.918274 842.201294,261.172729
	C843.610901,261.333130 844.820740,261.227173 846.435364,261.127930
	C848.181580,261.141510 849.523010,261.148438 850.909119,261.388123
	C850.953796,261.620850 850.993774,262.093201 850.993774,262.093201
	C851.645081,263.780273 852.296448,265.467316 853.012451,267.485352
	C841.798584,273.731323 829.633240,269.824463 817.455688,270.983337
	C818.450867,270.318939 819.901489,269.134094 821.383850,269.092957
	C828.534058,268.894623 835.696533,269.124084 842.845337,268.901520
	C844.235535,268.858215 845.584167,267.480560 846.952026,266.718384
	C845.758179,265.689362 844.718994,264.215118 843.334717,263.734314
	C841.195374,262.991272 838.820129,262.927368 836.271240,262.288818
z"/>
<path fill="#29619E" opacity="1.000000" stroke="none"
	d="
M941.991455,305.631439
	C940.901611,307.091553 939.655640,308.292480 938.201294,309.764709
	C931.972717,310.047668 925.952637,310.059326 919.321045,309.719055
	C917.439209,306.979004 918.327454,306.092102 920.853699,305.940002
	C922.582397,305.835876 924.284485,305.289062 925.998474,304.940186
	C928.017029,304.940399 930.035583,304.940613 932.845215,304.913727
	C935.200928,302.363770 937.335144,301.745392 940.022583,302.976685
	C940.626831,303.775208 941.231140,304.573730 941.991455,305.631439
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M868.815430,274.278809
	C868.815430,274.278809 868.339783,274.206268 868.145508,273.752197
	C867.922363,272.498413 867.893494,271.698669 867.864624,270.898926
	C877.208984,270.873352 886.553406,270.847809 896.725403,270.833435
	C900.308533,269.529419 903.263306,267.321228 905.134460,273.739899
	C892.702026,273.924377 880.758728,274.101593 868.815430,274.278809
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M868.975708,274.639099
	C880.758728,274.101593 892.702026,273.924377 905.134460,273.739899
	C903.263306,267.321228 900.308533,269.529419 897.180054,270.800049
	C896.970459,268.112244 897.542480,265.004456 900.873962,266.242371
	C903.261841,267.129639 904.928284,269.958252 906.916565,271.920746
	C905.468079,273.252197 904.045532,275.702301 902.567078,275.736481
	C891.662903,275.988647 880.747620,275.763092 869.836182,275.652496
	C869.600586,275.650146 869.369324,275.226471 868.975708,274.639099
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M930.005493,319.432373
	C919.195923,325.624756 907.425903,322.076447 896.070068,322.885132
	C892.812439,323.117096 891.138916,323.631256 893.041748,327.526245
	C892.095154,326.562073 891.066895,325.225861 890.038635,323.889648
	C891.316467,322.930847 892.571411,321.179352 893.875916,321.141541
	C902.458679,320.892975 911.055359,321.133698 919.639038,320.901337
	C921.152344,320.860382 922.889160,319.612549 924.062256,318.455231
	C926.448914,316.100739 928.227539,316.440247 930.005493,319.432373
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M685.421509,310.101807
	C684.090881,309.106293 683.157410,308.099121 681.669250,306.493469
	C689.746704,305.093842 697.707092,307.888062 704.706787,302.918030
	C705.101013,302.875366 705.527283,302.979492 705.788818,303.340820
	C706.983948,304.503662 707.917603,305.305145 708.851257,306.106628
	C708.853333,306.500427 708.855408,306.894257 708.447815,307.674988
	C704.340332,308.386230 700.637390,308.661713 696.946411,309.051270
	C694.289612,309.331665 691.648804,309.764252 689.000854,310.128967
	C687.940125,310.116028 686.879456,310.103088 685.421509,310.101807
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M752.979858,266.543701
	C744.293213,274.554688 733.721558,269.422333 724.107300,271.028809
	C722.338989,271.324310 720.709106,272.448486 718.978882,273.609467
	C718.351379,273.071136 717.760376,272.113495 717.169373,271.155853
	C718.492432,270.440399 719.798950,269.144440 721.141296,269.106171
	C728.411682,268.899017 735.690918,269.015503 742.967041,268.995667
	C748.499268,268.980591 748.784058,268.538696 747.422974,262.429443
	C748.848816,262.011200 749.934204,262.016205 751.019653,262.021179
	C751.648804,263.418640 752.277954,264.816101 752.979858,266.543701
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M893.036377,292.509033
	C903.370605,292.085114 913.833862,292.081818 924.295959,291.971771
	C929.575989,291.916260 930.497131,290.301941 927.949890,285.486938
	C929.198608,286.559418 931.057312,287.788025 931.601257,289.447571
	C931.849854,290.205841 929.696228,292.153168 928.285461,292.938690
	C926.927795,293.694641 925.125488,293.895142 923.514038,293.912170
	C914.588806,294.006561 905.661743,294.011108 896.736389,293.930206
	C895.542847,293.919373 894.355225,293.250000 893.036377,292.509033
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M949.973022,267.534851
	C940.465820,272.683533 930.160217,270.467560 920.131714,271.045685
	C919.049194,271.108063 918.040527,272.451111 916.950439,273.621216
	C916.062317,273.245605 915.221313,272.448883 914.380310,271.652161
	C915.821106,270.769684 917.229187,269.195557 918.708496,269.125549
	C924.813049,268.836395 930.939270,269.013916 937.057495,268.997681
	C939.800659,268.990387 942.676880,269.603638 944.316406,266.149170
	C944.523682,265.712494 947.955261,266.806061 949.973022,267.534851
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M819.077759,275.442017
	C829.406860,275.038300 839.836853,275.045685 850.266541,274.995178
	C853.156921,274.981171 856.169983,274.963745 856.094116,270.351685
	C857.029236,270.906128 858.545166,271.817108 858.636108,272.853180
	C858.713074,273.730255 857.190308,274.803558 856.271240,275.680817
	C855.964783,275.973389 855.337280,276.016083 854.853943,276.024292
	C843.167358,276.223663 831.480530,276.406769 819.793152,276.553986
	C819.591370,276.556519 819.383545,276.082764 819.077759,275.442017
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M778.042053,319.489624
	C768.993835,325.745392 758.790588,321.837006 749.152771,323.067993
	C747.370361,323.295685 745.710449,324.482147 743.941772,325.647705
	C743.360352,324.939636 742.831238,323.809937 742.302124,322.680237
	C743.577515,322.131409 744.844177,321.132965 746.129944,321.107635
	C753.721619,320.957886 761.320862,321.147064 768.909668,320.935944
	C770.358582,320.895660 772.162354,319.907898 773.120728,318.778748
	C775.144592,316.394409 776.532715,316.550110 778.042053,319.489624
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M768.894531,287.406311
	C765.804443,288.145874 762.608032,288.706482 759.393921,288.839935
	C754.902466,289.026520 750.397766,288.894348 745.120972,288.954041
	C743.852173,289.357086 743.361084,289.704681 742.870056,290.052277
	C739.541931,287.794739 742.825134,286.381836 743.894714,286.381866
	C752.189880,286.381897 760.485107,286.769287 768.894531,287.406311
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M934.941650,260.880768
	C936.137878,261.093109 937.334045,261.305420 938.754395,261.805573
	C937.252686,262.397766 935.535034,262.902679 933.799744,262.972931
	C924.697937,263.341553 915.592773,263.712677 906.486084,263.800201
	C904.707214,263.817322 902.916382,262.585907 901.416992,261.549683
	C904.157471,261.150848 906.612061,261.132721 909.379150,261.073364
	C910.111572,260.991516 910.531372,260.950897 911.357788,260.953064
	C914.189636,261.023376 916.614929,261.050873 919.359375,261.050964
	C920.103699,260.982544 920.528870,260.941528 921.302490,260.943268
	C922.117371,260.955780 922.583801,260.925537 923.506348,260.926331
	C927.622253,260.931824 931.281921,260.906281 934.941650,260.880768
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M699.012024,260.925720
	C699.455261,260.921478 699.898499,260.917236 700.670349,261.185669
	C701.000183,261.639893 701.001343,261.821381 701.002441,262.002838
	C699.713440,262.651031 698.408386,263.888184 697.138000,263.853546
	C687.595703,263.593414 678.060303,263.082550 668.250854,262.426453
	C672.139221,261.996948 676.299438,261.791107 680.717896,261.349243
	C683.071777,261.061279 685.167358,261.009277 687.803467,261.216553
	C689.225830,261.357483 690.107666,261.239136 690.989563,261.120789
	C692.386169,261.111359 693.782715,261.101929 695.798828,261.342346
	C697.282959,261.370056 698.147461,261.147888 699.012024,260.925720
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M721.063477,275.538452
	C730.573669,275.112946 740.209351,275.109833 749.843018,274.970673
	C751.964966,274.940033 754.079834,274.426880 756.618042,274.107849
	C755.319153,275.042633 753.620972,276.791809 751.877930,276.837769
	C742.181702,277.093506 732.474426,276.951813 722.771484,276.877014
	C722.241333,276.872955 721.715881,276.247894 721.063477,275.538452
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M746.353271,379.865509
	C741.990662,377.120941 741.990662,377.120941 743.768066,374.941681
	C744.499268,374.842194 744.895081,374.850250 745.983887,374.907959
	C748.673706,374.132599 750.670593,373.307587 753.584839,372.103577
	C754.386658,373.237335 755.518494,374.837677 756.650330,376.437988
	C754.845337,377.291656 753.047668,378.161407 751.231628,378.990845
	C750.509644,379.320587 749.746887,379.561127 749.002686,379.842285
	C748.245789,379.857086 747.488831,379.871887 746.353271,379.865509
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M720.443237,362.065247
	C719.433411,361.096039 718.850647,360.115417 718.128784,358.900635
	C720.150940,358.166626 722.019043,357.488556 723.982117,356.461548
	C724.077148,356.112640 724.081787,356.084381 724.462341,356.020935
	C726.575623,355.621155 728.308350,355.284851 730.041077,354.948547
	C730.625122,355.443298 731.209229,355.938080 731.905396,357.075745
	C732.249451,362.242737 727.527649,359.991394 726.004517,362.114990
	C724.293152,362.094604 722.581726,362.074219 720.443237,362.065247
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M749.239197,380.146606
	C749.746887,379.561127 750.509644,379.320587 751.231628,378.990845
	C753.047668,378.161407 754.845337,377.291656 756.650330,376.437988
	C755.518494,374.837677 754.386658,373.237335 753.584839,372.103577
	C750.670593,373.307587 748.673706,374.132599 746.281372,374.894165
	C746.340637,374.159393 746.689026,373.371826 747.270996,372.839691
	C748.690063,371.542114 750.921875,369.024933 751.577576,369.370239
	C754.246216,370.775665 756.749146,372.838928 758.583313,375.221527
	C758.993530,375.754395 756.803833,379.128693 755.161499,380.146515
	C753.746704,381.023285 751.406616,380.407074 749.239197,380.146606
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M903.724731,355.028015
	C905.470398,360.535522 905.156921,360.949677 899.346497,361.022156
	C897.188965,361.049072 895.030884,361.028961 892.406982,361.052124
	C891.659851,360.559479 891.378845,360.045013 891.351257,359.122650
	C895.423950,357.446808 899.243225,356.178894 903.062439,354.910950
	C903.062439,354.910950 903.504700,354.984741 903.724731,355.028015
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M909.066589,261.114563
	C906.612061,261.132721 904.157471,261.150848 901.311401,261.208099
	C900.212280,261.222687 899.504639,261.198212 898.039856,261.181396
	C894.833801,261.534424 892.384949,261.879730 889.936035,262.225037
	C889.198853,262.177185 888.461731,262.129364 887.117676,261.779785
	C884.996155,261.312775 883.481506,261.147491 882.058350,260.605316
	C882.644714,259.852570 883.135803,259.155609 883.635010,259.149780
	C889.641724,259.079132 895.658630,258.920807 901.652832,259.206696
	C904.148743,259.325745 906.596802,260.448303 909.066589,261.114563
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M809.915894,261.844666
	C816.275391,261.655792 822.701538,261.818207 829.578247,262.026581
	C828.393433,262.708038 826.788330,263.774750 825.116516,263.892029
	C821.260681,264.162445 817.364624,264.109009 813.502075,263.887146
	C812.300476,263.818207 811.154114,262.786774 809.915894,261.844666
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M867.995117,261.975098
	C867.253845,261.995514 866.512634,262.015930 865.021179,262.008728
	C863.506531,262.006165 862.742065,262.031189 861.977600,262.056213
	C861.233337,262.030975 860.489014,262.005768 859.379639,261.720245
	C859.015930,261.279358 859.017395,261.098755 859.309937,260.645630
	C866.456177,259.804565 873.346497,258.280151 880.074707,261.389465
	C880.070984,261.825775 880.068298,262.000275 880.065613,262.174774
	C878.675598,262.161346 877.285583,262.147888 875.096313,262.098450
	C872.196472,262.033295 870.095764,262.004181 867.995117,261.975098
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M676.440796,292.138245
	C674.845093,286.945160 676.065613,285.190308 680.735291,285.892456
	C681.770203,287.027222 682.443176,288.166901 682.837219,289.768677
	C682.042908,290.888092 681.527466,291.545410 681.011963,292.202698
	C679.626587,292.177826 678.241211,292.152954 676.440796,292.138245
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M689.313110,310.397461
	C691.648804,309.764252 694.289612,309.331665 696.946411,309.051270
	C700.637390,308.661713 704.340332,308.386230 708.431641,307.969971
	C707.669128,308.909363 706.550354,310.774506 705.350708,310.828033
	C700.121765,311.061371 694.869324,310.768005 689.313110,310.397461
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M706.421875,344.097168
	C700.599487,343.991516 702.205688,339.858673 702.002075,336.276245
	C703.057251,336.251465 704.109741,336.676788 705.583618,337.482971
	C706.726135,339.279968 707.447327,340.696167 708.168457,342.112366
	C707.686951,342.742950 707.205444,343.373566 706.421875,344.097168
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M902.983459,354.558075
	C899.243225,356.178894 895.423950,357.446808 891.238647,358.851746
	C890.758911,358.869812 890.526123,358.680878 890.548889,358.642212
	C891.040894,357.805511 891.561523,356.985626 892.076660,356.162506
	C896.288879,358.845367 897.960205,347.472321 902.983459,354.558075
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M925.704346,304.663025
	C924.284485,305.289062 922.582397,305.835876 920.853699,305.940002
	C918.327454,306.092102 917.439209,306.979004 918.852600,309.722412
	C917.679626,309.065491 916.363708,308.053223 915.047791,307.040955
	C916.082031,306.041351 917.011475,304.364319 918.172668,304.184540
	C920.518616,303.821411 922.990417,304.271332 925.704346,304.663025
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M926.005920,284.522430
	C925.204468,285.156250 923.724060,285.227478 923.518372,285.776398
	C921.907776,290.074127 918.698730,289.165100 915.255615,288.191559
	C917.650879,286.524933 922.335327,287.701111 921.275452,281.261108
	C923.426575,282.614197 924.672058,283.397675 926.005920,284.522430
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M701.465332,262.003723
	C701.001343,261.821381 701.000183,261.639893 701.002808,261.185486
	C705.504028,260.801788 710.001465,260.690979 714.752563,260.925690
	C710.646851,261.515656 706.287537,261.760101 701.465332,262.003723
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M726.275513,362.373138
	C727.527649,359.991394 732.249451,362.242737 732.053955,357.325195
	C734.501587,359.413513 734.051208,361.965240 730.881775,362.761841
	C729.532898,363.100891 727.997253,362.697357 726.275513,362.373138
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M729.977051,354.605896
	C728.308350,355.284851 726.575623,355.621155 724.472900,356.016388
	C724.102966,354.528107 724.102966,352.980896 724.102966,349.868439
	C726.810730,351.916595 728.361938,353.089935 729.977051,354.605896
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M778.296753,327.913330
	C778.630920,325.482849 783.497742,324.324280 779.988892,320.380981
	C780.966797,321.251434 783.073608,323.029297 782.806641,323.522736
	C781.876465,325.241577 780.124573,326.515778 778.296753,327.913330
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M939.954712,302.614319
	C937.335144,301.745392 935.200928,302.363770 933.277100,304.901245
	C933.400940,303.328400 933.883972,301.740936 934.367065,300.153473
	C936.206970,300.852966 938.046875,301.552460 939.954712,302.614319
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M941.043213,262.541565
	C943.782654,261.959351 946.628723,261.715485 949.730591,261.765015
	C947.040833,262.332275 944.095398,262.606079 941.043213,262.541565
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M719.288330,261.537415
	C721.815002,261.049438 724.633606,260.791016 727.486938,261.077515
	C726.663940,261.775482 725.806213,261.928558 724.948547,262.081604
	C723.159119,261.976746 721.369690,261.871857 719.288330,261.537415
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M851.087402,302.245667
	C850.026611,303.081940 848.927734,303.590424 847.470703,304.125122
	C847.112610,302.620331 847.112610,301.089325 847.112610,297.964966
	C849.119934,299.980560 850.084595,300.949188 851.087402,302.245667
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M890.056091,262.570801
	C892.384949,261.879730 894.833801,261.534424 897.687744,261.232422
	C896.201538,265.430023 893.247253,264.454956 890.056091,262.570801
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M779.906494,355.681580
	C777.955261,356.322968 775.881958,356.663177 773.414856,357.006653
	C773.021057,357.009918 773.004517,356.513702 773.307373,356.121094
	C774.743896,354.811646 775.877502,353.894806 777.011169,352.977966
	C777.935547,353.778778 778.859985,354.579559 779.906494,355.681580
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M774.990479,286.994202
	C774.564087,287.019440 774.137756,287.044678 773.392578,287.086578
	C773.065552,281.648682 773.115906,281.597107 776.611450,283.644775
	C775.895203,285.049744 775.442810,286.021973 774.990479,286.994202
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M756.993896,261.150299
	C758.044495,261.132019 759.095032,261.113739 760.558411,261.378906
	C760.985535,261.835968 760.999817,262.009521 761.014160,262.183044
	C759.703491,264.928589 757.999817,264.574890 756.243164,262.341461
	C756.657410,261.704102 756.865417,261.461243 756.993896,261.150299
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M880.335510,262.420288
	C880.068298,262.000275 880.070984,261.825775 880.388428,261.354950
	C881.124390,261.033173 881.545654,261.007690 881.966919,260.982208
	C883.481506,261.147491 884.996155,261.312775 886.748047,261.772766
	C884.858704,262.266907 882.732056,262.466339 880.335510,262.420288
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M751.041321,261.804871
	C749.934204,262.016205 748.848816,262.011200 747.356079,262.037781
	C746.115112,261.950592 745.281555,261.831818 744.217834,261.499023
	C746.177307,261.039673 748.366882,260.794312 750.813110,260.851318
	C751.069824,261.153717 751.062988,261.588531 751.041321,261.804871
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M876.001465,353.510437
	C874.969604,354.234863 873.873413,354.611084 872.439697,355.051788
	C872.431274,353.832458 872.760498,352.548645 873.089661,351.264771
	C874.038879,351.897278 874.988037,352.529755 876.001465,353.510437
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M776.939270,352.618225
	C775.877502,353.894806 774.743896,354.811646 773.315430,355.872986
	C773.121460,350.623627 773.189453,350.557159 776.939270,352.618225
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M868.232544,262.250336
	C870.095764,262.004181 872.196472,262.033295 874.681030,262.135925
	C872.866577,262.314850 870.668213,262.420227 868.232544,262.250336
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M749.238708,328.170258
	C750.768921,327.595673 752.532043,327.317688 754.705322,327.098602
	C753.234192,327.593964 751.352905,328.030426 749.238708,328.170258
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M735.268799,261.510071
	C736.858398,261.071014 738.722229,260.854431 740.797546,260.967804
	C739.187012,261.442688 737.364990,261.587646 735.268799,261.510071
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M725.040527,262.429565
	C725.806213,261.928558 726.663940,261.775482 727.740234,261.384521
	C728.451843,261.160217 728.944946,261.173767 729.783569,261.330811
	C729.299988,265.115540 727.371643,264.542267 725.040527,262.429565
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M806.301514,274.929016
	C806.284424,273.542755 806.633972,272.136658 806.996948,270.362671
	C810.729980,271.900055 809.274414,273.444702 806.301514,274.929016
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M702.775513,266.698181
	C702.237366,267.629150 701.475464,268.295746 700.398865,268.987885
	C699.887329,268.213287 699.690369,267.413116 699.493408,266.612946
	C700.512878,266.553223 701.532349,266.493500 702.775513,266.698181
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M708.471619,342.028687
	C707.447327,340.696167 706.726135,339.279968 705.920654,337.542053
	C708.729858,337.604889 710.431824,338.730438 708.471619,342.028687
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M842.767212,356.692810
	C842.656860,358.049805 842.330078,359.174500 841.991821,360.655640
	C841.337830,360.236237 840.019836,359.206299 840.195862,358.738464
	C840.543457,357.814575 841.718140,357.201874 842.767212,356.692810
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M892.751709,287.615936
	C892.654907,288.707336 892.326599,289.563507 891.926636,290.759094
	C891.293884,290.135681 890.732788,289.172821 890.171692,288.210022
	C890.954529,287.933594 891.737366,287.657166 892.751709,287.615936
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M878.225220,362.327393
	C878.848145,361.473663 879.679138,360.855286 880.814819,360.130920
	C882.006104,362.757019 880.699768,363.167938 878.225220,362.327393
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M859.018799,260.918152
	C859.017395,261.098755 859.015930,261.279358 859.007263,261.730774
	C857.803162,262.167236 856.606384,262.332886 855.197388,261.967468
	C854.983521,261.258636 854.981873,261.080902 855.383850,260.931335
	C856.864563,260.945709 857.941650,260.931915 859.018799,260.918152
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M819.649902,305.053802
	C819.751038,305.891388 819.476440,306.689484 818.739746,307.764832
	C817.833191,308.033295 817.388794,308.024475 816.944458,308.015625
	C817.721008,307.015167 818.497620,306.014709 819.649902,305.053802
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M765.201904,328.151550
	C766.189209,327.713501 767.371399,327.558441 768.773071,327.640594
	C767.794006,328.063416 766.595398,328.248993 765.201904,328.151550
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M816.718262,308.196838
	C817.388794,308.024475 817.833191,308.033295 818.608887,308.059875
	C818.962952,308.508545 818.985657,308.939423 819.000732,309.694885
	C818.159424,309.472290 817.325745,308.925171 816.718262,308.196838
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M758.321533,270.778870
	C757.399597,270.225647 756.703186,269.472260 755.946045,268.406067
	C756.772522,268.921753 757.659790,269.750244 758.321533,270.778870
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M708.405884,270.779236
	C707.485107,270.229950 706.763489,269.463745 706.004272,268.370972
	C706.846191,268.883728 707.725586,269.722992 708.405884,270.779236
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M681.212158,292.402191
	C681.527466,291.545410 682.042908,290.888092 682.862183,290.119324
	C682.581482,290.872437 681.996887,291.737030 681.212158,292.402191
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M708.878784,305.754272
	C707.917603,305.305145 706.983948,304.503662 706.005615,303.374207
	C706.942749,303.831421 707.924561,304.616638 708.878784,305.754272
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M854.980286,260.903137
	C854.981873,261.080902 854.983521,261.258636 854.990112,261.702515
	C853.927734,261.987518 852.860413,262.006439 851.393433,262.059265
	C850.993774,262.093201 850.953796,261.620850 851.214600,261.227417
	C852.643677,260.857056 853.811951,260.880096 854.980286,260.903137
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M855.316284,308.868958
	C855.021118,307.882812 855.035400,306.755402 855.098389,305.201538
	C857.832764,305.786743 857.242432,307.195099 855.316284,308.868958
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M764.014160,261.029877
	C764.759216,261.001190 765.504272,260.972504 766.622192,261.220062
	C766.998352,261.681519 767.001648,261.866699 767.004883,262.051880
	C766.132629,262.222137 765.260437,262.392395 764.199463,262.064148
	C764.011902,261.387085 764.013000,261.208496 764.014160,261.029877
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M862.033203,262.380493
	C862.742065,262.031189 863.506531,262.006165 864.651123,262.031982
	C864.050476,262.290161 863.069702,262.497467 862.033203,262.380493
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M767.328064,262.039368
	C767.001648,261.866699 766.998352,261.681519 766.995117,261.218018
	C767.904480,260.863403 768.813965,260.787109 769.863647,261.008881
	C769.219666,261.546906 768.435486,261.786865 767.328064,262.039368
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M782.416382,359.977753
	C782.051636,359.279938 782.012512,358.522736 781.980408,357.386963
	C782.238892,357.978394 782.490356,358.948364 782.416382,359.977753
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M742.761353,357.087524
	C743.060608,357.816010 743.017456,358.559784 742.928467,359.675354
	C742.728027,359.065704 742.573547,358.084259 742.761353,357.087524
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M867.539062,270.965759
	C867.893494,271.698669 867.922363,272.498413 867.911133,273.697754
	C867.651855,273.075775 867.432678,272.054169 867.539062,270.965759
z"/>
<path fill="#3B7FB8" opacity="1.000000" stroke="none"
	d="
M704.266724,275.901367
	C704.739624,275.250458 705.567200,274.649292 706.750977,274.083313
	C706.278625,274.729340 705.450012,275.340210 704.266724,275.901367
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M775.318481,286.952759
	C775.442810,286.021973 775.895203,285.049744 776.695007,284.002380
	C777.042480,283.927246 777.052734,284.422729 777.037354,284.669189
	C776.563477,285.580872 776.104980,286.246094 775.318481,286.952759
z"/>
<path fill="#306CA7" opacity="1.000000" stroke="none"
	d="
M743.018066,290.311584
	C743.361084,289.704681 743.852173,289.357086 744.649902,288.974030
	C744.973816,289.701202 744.991028,290.463837 745.006226,291.606750
	C744.391541,291.514954 743.778748,291.042938 743.018066,290.311584
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M763.839233,260.795227
	C764.013000,261.208496 764.011902,261.387085 764.002075,261.834503
	C763.247498,262.100769 762.501648,262.098236 761.384949,262.139343
	C760.999817,262.009521 760.985535,261.835968 760.951904,261.403259
	C761.843201,260.949615 762.753784,260.755127 763.839233,260.795227
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M782.382141,288.987244
	C782.043152,288.595490 781.993713,288.153778 781.938110,287.379456
	C782.178528,287.677002 782.425110,288.307159 782.382141,288.987244
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M816.682251,271.022583
	C816.985168,271.439026 816.993958,271.893188 816.972046,272.687225
	C816.756958,272.371521 816.572571,271.715942 816.682251,271.022583
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M774.138794,328.118500
	C774.567505,327.735565 775.129761,327.598480 775.842651,327.665070
	C775.419617,328.033936 774.846008,328.199127 774.138794,328.118500
z"/>
<path fill="#4083B9" opacity="1.000000" stroke="none"
	d="
M743.992004,326.421692
	C744.603027,326.479736 745.276855,326.853607 746.032349,327.528107
	C745.427673,327.464996 744.741211,327.101227 743.992004,326.421692
z"/>
<path fill="#4590C5" opacity="1.000000" stroke="none"
	d="
M842.014954,361.305786
	C842.551270,361.209869 843.115173,361.400269 843.828003,361.860687
	C843.332092,361.951202 842.687317,361.771667 842.014954,361.305786
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M756.860413,260.901184
	C756.865417,261.461243 756.657410,261.704102 756.154358,261.997742
	C755.645935,261.975677 755.394409,261.781281 755.077393,261.320099
	C755.556091,260.955200 756.141479,260.803650 756.860413,260.901184
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M940.984924,50.990448
	C941.912903,50.730270 942.841370,50.471523 943.768860,50.209602
	C945.962585,49.590122 948.155823,48.969166 950.349365,48.348801
	C950.899597,50.304649 951.926941,52.259663 951.930420,54.216484
	C952.018555,104.165291 951.999695,154.114273 951.557556,204.531616
	C941.607666,208.282471 931.329163,203.519089 921.873901,207.779648
	C921.000610,208.173218 919.639832,207.541199 918.518616,207.318787
	C913.072998,206.238586 910.592468,209.153671 912.000000,215.336380
	C912.001648,216.119858 912.003235,216.567551 912.002625,217.347565
	C912.005066,218.123367 912.009766,218.566849 912.007202,219.005173
	C912.000000,219.000000 912.010315,219.014023 911.720947,219.033569
	C911.252808,219.689255 911.073975,220.325394 910.933350,221.340240
	C910.974915,222.479813 910.978210,223.240692 910.603149,224.042999
	C905.598755,224.058197 900.969482,223.920395 896.347900,224.050674
	C893.875061,224.120392 890.823486,225.739746 889.056580,224.778488
	C882.902710,221.430573 877.725525,224.442093 872.214661,225.546249
	C872.078186,225.986481 871.941650,226.426712 871.805115,226.866943
	C873.327332,227.933151 874.849487,228.999344 876.801208,230.366394
	C872.421265,230.366394 868.514954,230.366394 864.608582,230.366394
	C864.607422,230.128769 864.606201,229.891144 864.604980,229.653519
	C866.040466,229.132019 867.475891,228.610519 868.911316,228.089020
	C869.032654,227.543686 869.153992,226.998337 869.275330,226.453003
	C866.888977,225.685699 864.518494,224.504425 862.106262,224.412003
	C861.413513,224.385483 860.776733,227.619736 859.773743,229.133179
	C859.203918,229.992981 857.944275,230.395584 856.992310,230.606125
	C856.099548,227.793762 855.209717,225.379395 854.224548,222.601105
	C854.101868,221.488327 854.074463,220.739502 854.298889,219.769470
	C854.111450,218.356873 853.672241,217.165466 853.152588,215.565979
	C852.713806,212.104752 852.355469,209.051575 852.258545,205.783142
	C852.078491,204.371445 851.636963,203.175018 851.126465,201.611969
	C851.022949,200.500778 850.988342,199.756195 851.180542,198.860992
	C851.047363,198.126984 850.687439,197.543610 850.233765,196.541977
	C849.751404,192.751221 849.362854,189.378738 849.226868,185.817917
	C849.066223,184.743942 848.653015,183.858307 848.169434,182.644470
	C848.081726,181.869766 848.064331,181.423264 848.261719,180.818405
	C848.071899,180.100906 847.667236,179.541779 847.137695,178.765137
	C846.941956,178.396179 846.871033,178.244751 846.888672,177.677277
	C846.948914,175.851227 846.920593,174.441208 847.127441,172.885513
	C847.023438,172.146194 846.684265,171.552567 846.259644,170.552078
	C845.793274,167.425369 845.412292,164.705536 845.306641,161.787766
	C846.695129,159.498764 851.111206,158.546173 847.948059,154.664474
	C848.126038,153.988220 848.225159,153.601410 848.509888,153.108429
	C848.926270,152.824738 849.103821,152.604279 849.531433,152.287781
	C850.239197,152.160812 850.643555,152.086899 851.367920,151.964020
	C851.782715,150.940628 851.877380,149.966187 851.956238,148.565933
	C851.935669,146.435577 851.930786,144.731049 852.214966,142.789017
	C852.331299,140.633865 852.184326,138.713470 851.980530,136.799133
	C851.543884,132.697769 849.582947,133.830902 847.424316,135.286087
	C847.997681,137.000916 848.498230,138.497742 848.555603,140.011719
	C841.995117,141.587646 837.807434,137.431015 833.008240,134.481750
	C832.932373,123.928223 832.897644,113.838318 832.878357,103.748375
	C832.870728,99.735497 831.669739,96.880630 826.674927,97.280930
	C826.468018,97.167763 826.037537,96.974854 826.029297,96.595642
	C826.105347,95.274467 826.189636,94.332512 826.294800,93.157814
	C834.722290,97.255280 842.841431,101.202850 851.031494,105.470001
	C851.825562,106.130165 852.548706,106.470741 853.634460,106.842484
	C857.651062,108.345589 861.305054,109.817520 865.045044,111.597191
	C868.025208,114.225807 867.824097,111.769394 868.472778,110.000656
	C870.287903,109.212914 871.699402,108.425842 873.467346,107.667755
	C874.535461,107.769112 875.247070,107.841484 876.191589,108.199036
	C877.205322,108.612587 878.451050,109.110481 878.690857,108.808777
	C880.142700,106.982323 881.014282,104.524597 882.765930,103.155983
	C884.398376,101.880493 886.885254,101.698563 889.275208,100.987686
	C889.734985,100.885483 889.915649,100.830826 890.448730,100.831116
	C891.513306,100.885521 892.225464,100.884972 893.302795,100.896492
	C894.375854,99.966995 895.867554,98.668709 895.633972,98.155571
	C895.091064,96.962585 893.838623,95.534798 892.654968,95.298660
	C889.458496,94.660965 886.147705,94.595818 882.566650,94.254807
	C881.825745,94.191422 881.400574,94.176720 880.763428,93.872482
	C878.364929,93.370453 876.178284,93.157959 873.621155,92.947632
	C872.511536,92.921692 871.772339,92.893585 870.966431,92.553482
	C870.274231,91.176537 869.648743,90.111572 869.470337,89.033081
	C872.595398,89.078934 875.273438,89.138313 878.045898,89.527328
	C879.761108,89.907944 881.381775,89.958916 883.416626,90.048813
	C888.872620,90.452454 893.914490,90.817169 899.038025,91.501785
	C900.414856,91.871750 901.710022,91.921814 903.406250,91.969849
	C904.876343,91.990685 905.945435,92.013550 907.213684,92.275360
	C911.781799,90.716385 911.838074,90.485283 909.084412,85.625313
	C910.828064,84.826851 912.528931,84.536423 914.128174,83.962654
	C915.479919,83.477631 916.713867,82.664337 918.348083,81.989349
	C919.475586,81.348160 920.255005,80.713959 921.172241,79.751740
	C921.534790,78.287628 921.759644,77.151535 921.898499,75.618622
	C915.402832,75.006660 908.993286,74.779716 902.582031,74.633339
	C902.389648,74.628944 902.177979,75.468018 901.509277,75.946335
	C889.364014,76.285942 877.684937,76.593048 866.008789,76.554039
	C866.024963,75.517075 866.038147,74.826218 866.373901,74.095116
	C867.129333,74.039146 867.562195,74.023438 868.232178,74.274323
	C869.994385,74.082825 871.519409,73.624718 873.482910,73.123749
	C877.612549,72.719315 881.303833,72.357742 885.213501,72.257561
	C886.634766,72.060745 887.837769,71.602524 889.496460,71.100418
	C893.868835,70.960251 897.785461,70.863968 902.095032,70.837006
	C903.672607,70.323677 904.857117,69.741035 906.433105,69.105621
	C907.876892,69.015709 908.929260,68.978577 910.138184,69.171638
	C910.882935,69.012070 911.471069,68.622307 912.487061,68.175674
	C916.938599,67.731140 920.962280,67.343475 925.174561,67.211792
	C926.259521,67.051086 927.155884,66.634377 928.451416,66.158829
	C931.637512,66.186081 933.504028,65.336609 932.954346,61.748917
	C932.290833,61.309338 931.643311,61.168114 930.663208,61.035057
	C929.887207,61.032238 929.443848,61.021248 928.796448,60.746056
	C927.729126,60.322849 926.865784,60.163845 926.036499,59.660931
	C926.713684,57.875534 927.356812,56.434052 928.003296,54.675541
	C928.015076,53.936756 928.023621,53.515003 928.274780,53.013519
	C928.677002,52.874386 928.836548,52.814983 929.335144,52.813423
	C930.115051,52.763859 930.555908,52.656452 931.321655,52.624157
	C932.088135,52.750984 932.529907,52.802704 933.045776,53.237556
	C937.300232,56.050343 938.953796,55.496708 940.995605,50.990845
	C940.999634,50.996590 940.984924,50.990437 940.984924,50.990448
z"/>
<path fill="#487CA7" opacity="1.000000" stroke="none"
	d="
M932.971619,52.854431
	C932.529907,52.802704 932.088135,52.750984 931.257812,52.385540
	C930.244873,52.299736 929.620544,52.527653 928.996155,52.755577
	C928.836548,52.814983 928.677002,52.874386 927.924072,52.976646
	C926.460388,53.605446 925.590149,54.191391 924.315002,54.793297
	C922.291016,54.925133 920.671814,55.041000 918.748169,55.125824
	C917.966858,55.414272 917.490112,55.733768 916.686646,56.055122
	C915.927795,56.107597 915.495605,56.158215 914.698914,56.150078
	C913.858582,56.199829 913.382629,56.308331 912.605957,56.387535
	C911.557556,56.641685 910.809814,56.925140 909.694214,57.176208
	C907.550110,57.759892 905.773804,58.375965 903.613342,58.993668
	C901.504700,59.387020 899.780212,59.778744 897.754517,60.131378
	C896.968506,60.393440 896.483826,60.694592 895.603760,61.003021
	C894.154419,61.041374 893.100525,61.072441 891.827271,60.832264
	C888.406494,61.597656 885.204956,62.634293 881.614868,63.771614
	C878.480652,64.562531 875.735107,65.252769 872.690308,65.827591
	C870.928162,65.809982 869.465332,65.907784 867.836426,65.781311
	C867.111572,65.998009 866.552734,66.438995 865.601318,66.930588
	C862.810852,67.658203 860.412903,68.335236 857.601624,68.999084
	C854.453918,69.654732 851.719543,70.323555 848.592712,70.993782
	C844.864868,72.331085 841.474976,73.553612 838.244446,75.107414
	C837.662659,75.387199 837.380859,77.102623 837.568542,78.032532
	C838.481079,82.554710 838.903748,86.859024 833.183472,90.301735
	C835.603882,90.658104 836.799500,90.834137 837.997192,91.395729
	C838.073547,97.182770 842.069519,98.113403 846.461670,99.088486
	C851.192505,101.107407 855.620178,102.976006 860.348816,105.024239
	C862.820740,106.803467 864.991638,108.403069 866.862244,110.113831
	C866.027649,110.579811 865.493408,110.934624 864.959106,111.289444
	C861.305054,109.817520 857.651062,108.345589 853.507324,106.555176
	C852.331970,105.874596 851.646301,105.512505 850.960632,105.150421
	C842.841431,101.202850 834.722290,97.255280 826.294800,93.157814
	C826.189636,94.332512 826.105347,95.274467 825.654663,96.554344
	C824.812500,95.286697 824.336609,93.681129 824.110107,91.804550
	C826.441406,91.533539 828.523376,91.533539 831.223328,91.533539
	C829.859741,89.509506 828.973511,88.194092 828.154785,86.978806
	C829.117310,85.494217 830.877502,83.608475 830.558960,83.142014
	C827.506287,78.671227 830.864075,76.005478 833.352661,72.972649
	C834.084839,72.970779 834.503357,72.970131 834.993835,73.109856
	C835.156982,73.301407 835.248169,73.352585 835.339417,73.403755
	C835.216187,73.243477 835.092896,73.083206 834.974243,72.576630
	C834.988586,71.767258 834.998352,71.304176 835.294861,70.819046
	C835.964905,70.805939 836.348206,70.814888 837.144470,70.876373
	C840.718201,69.701202 843.878906,68.473495 847.408142,67.182388
	C848.523071,67.096184 849.269531,67.073372 850.222046,67.286041
	C851.969482,66.796349 853.510803,66.071182 855.453125,65.259583
	C857.492065,65.066170 859.130005,64.959183 861.097229,64.885681
	C861.954590,64.599747 862.482727,64.280334 863.346130,63.920677
	C864.356201,63.855518 865.030884,63.830601 866.049805,63.848686
	C866.941467,63.550716 867.489014,63.209743 868.404907,62.813309
	C870.747131,62.436760 872.720947,62.115665 875.035034,61.841103
	C875.924561,61.563576 876.473816,61.239521 877.300049,60.880547
	C877.948486,60.827297 878.319946,60.808960 879.031738,60.839699
	C879.921997,60.565323 880.471985,60.241871 881.353516,59.889053
	C882.349731,59.834835 883.014587,59.809982 884.009155,59.827263
	C884.909424,59.351608 885.479858,58.833820 886.406006,58.239189
	C888.733521,58.036839 890.705383,57.911324 893.005310,57.828003
	C893.906860,57.361572 894.480347,56.852947 895.454956,56.254715
	C899.247314,55.474583 902.638489,54.784058 906.194824,54.298054
	C906.924133,54.099716 907.488159,53.696861 908.436768,53.211716
	C910.128479,53.031475 911.435486,52.933533 913.086914,52.869942
	C913.972168,52.551205 914.513062,52.198109 915.054016,51.845009
	C916.992310,51.484421 918.930664,51.123844 921.578247,50.816612
	C922.874207,50.371937 923.460815,49.873917 924.047485,49.375896
	C924.047485,49.375896 924.529480,49.276684 924.899536,49.437695
	C925.480957,49.800579 925.728638,49.936104 926.425049,50.004341
	C929.580566,49.300087 932.323608,48.596760 935.066711,47.893436
	C936.422119,47.937534 937.777466,47.981628 939.536987,48.056686
	C939.941101,48.087646 939.946289,48.540627 939.710571,48.916862
	C939.262329,49.819569 939.049744,50.346035 938.539185,50.912498
	C937.847229,51.032429 937.453369,51.112370 936.742065,51.167137
	C935.847595,51.679790 935.270691,52.217609 934.406067,52.754944
	C933.736145,52.787777 933.353882,52.821106 932.971619,52.854431
z"/>
<path fill="#7CC5E7" opacity="1.000000" stroke="none"
	d="
M912.000000,215.000610
	C910.592468,209.153671 913.072998,206.238586 918.518616,207.318787
	C919.639832,207.541199 921.000610,208.173218 921.873901,207.779648
	C931.329163,203.519089 941.607666,208.282471 951.556580,205.000305
	C951.998047,208.484329 952.218018,211.988342 951.898560,215.442459
	C951.756653,216.976669 950.525574,218.410141 949.268188,219.671967
	C948.164185,218.638229 947.580872,217.821869 947.116394,216.718872
	C946.824280,215.620193 946.413330,214.808136 945.996765,213.634247
	C945.371094,212.297485 944.750977,211.322525 944.130920,210.347565
	C943.420593,211.231705 942.710327,212.115860 941.573975,213.000427
	C939.829651,213.050766 938.201904,212.618393 937.245483,213.232178
	C932.536011,216.254669 927.754272,214.406982 922.901001,214.081085
	C919.304138,213.839569 915.636230,214.655655 912.000000,215.000610
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M945.961853,236.010925
	C946.347412,239.411804 946.732971,242.812698 946.963745,246.642380
	C946.808899,247.071182 946.319031,247.087875 945.977051,246.869110
	C944.708374,241.712967 944.130737,236.675461 942.751404,231.867966
	C941.513672,227.553787 942.791626,224.871979 946.644104,223.135468
	C946.537537,224.247696 946.270935,225.125534 946.004333,226.003372
	C945.655823,227.728317 945.307251,229.453278 944.975464,231.942230
	C945.315369,233.807800 945.638611,234.909363 945.961853,236.010925
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M946.322998,226.179642
	C946.270935,225.125534 946.537537,224.247696 946.594971,222.793610
	C946.027588,221.402496 945.669373,220.587616 945.246704,219.475601
	C945.122742,218.775818 945.063110,218.373154 945.171265,217.729126
	C945.891968,217.326996 946.444763,217.166229 946.997620,217.005493
	C947.580872,217.821869 948.164185,218.638229 948.877075,219.728210
	C949.772766,222.360031 950.795654,224.672409 951.226868,227.090317
	C951.600952,229.187637 951.304749,231.404480 951.304749,233.568481
	C950.803345,233.609695 950.301941,233.650909 949.800598,233.692108
	C948.747620,231.246704 947.694641,228.801315 946.322998,226.179642
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M948.153076,255.404327
	C948.148743,256.016449 948.101807,256.211090 948.012268,256.703064
	C947.506775,256.727753 947.043762,256.455139 946.323303,255.610489
	C946.159424,252.929749 946.253052,250.821045 946.604980,248.766998
	C947.205322,248.896454 947.547485,248.971237 947.889587,249.046036
	C947.963257,251.026306 948.036926,253.006592 948.153076,255.404327
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M946.231750,235.795883
	C945.638611,234.909363 945.315369,233.807800 945.042725,232.343903
	C945.562744,233.181335 946.032166,234.381088 946.231750,235.795883
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M948.125488,248.897583
	C947.547485,248.971237 947.205322,248.896454 946.585083,248.497635
	C946.310974,247.811707 946.315002,247.449783 946.319031,247.087875
	C946.319031,247.087875 946.808899,247.071182 947.055359,247.055145
	C947.655029,247.609116 948.008179,248.179123 948.125488,248.897583
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M938.837219,50.872505
	C939.049744,50.346035 939.262329,49.819569 939.721680,49.143097
	C940.294312,49.459167 940.620178,49.925251 940.965454,50.690887
	C940.984924,50.990437 940.999634,50.996590 940.636414,50.990891
	C939.794556,50.947628 939.315857,50.910065 938.837219,50.872505
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M674.000000,220.001831
	C673.000000,216.994110 671.138550,213.989365 671.128174,210.978210
	C670.949829,159.253250 670.999695,107.527504 671.000366,55.801933
	C671.000488,47.329357 671.962830,46.685776 679.710144,49.900494
	C680.143738,50.080441 680.697937,49.970051 681.750793,50.294201
	C683.293701,50.996284 684.281799,51.398952 685.674683,51.825729
	C689.040039,52.280197 692.000671,52.710556 695.044006,53.483604
	C696.178528,54.145321 697.230347,54.464359 698.673950,54.794754
	C700.370483,54.891876 701.675293,54.977634 703.034912,55.381241
	C704.064392,55.785835 705.039062,55.872581 706.390381,56.001213
	C708.496643,56.415592 710.226135,56.788090 712.021240,57.466377
	C713.059998,57.844807 714.033081,57.917439 715.332764,58.000336
	C716.090332,58.072643 716.521240,58.134697 717.036865,58.520157
	C719.084106,59.225475 721.046753,59.607384 723.334473,60.002411
	C724.088074,60.081306 724.516602,60.147076 725.026794,60.527336
	C725.844543,61.150764 726.580627,61.459705 727.738647,61.774178
	C734.743713,62.934559 741.326782,64.089409 747.872559,65.544495
	C746.887878,66.563179 745.940613,67.281624 744.583374,67.990723
	C741.131592,67.593079 738.089844,67.204788 734.964417,66.498039
	C733.585999,66.119873 732.291138,66.060158 730.592163,65.962227
	C727.136414,65.576828 724.084961,65.229645 720.936340,64.520920
	C719.138977,63.839127 717.438782,63.518864 715.401611,63.194427
	C714.391174,63.185768 713.717590,63.181290 712.847534,62.886986
	C711.430664,62.743469 710.210388,62.889774 708.565125,63.036018
	C706.445190,62.951645 704.750183,62.867332 703.000732,62.513325
	C702.294983,62.171230 701.643738,62.098831 700.596558,62.030014
	C699.148315,61.965786 698.096008,61.897972 696.963135,61.508968
	C695.588440,61.125961 694.294250,61.064152 692.685059,61.038399
	C691.591797,61.390388 690.813477,61.706314 689.735413,62.048283
	C689.104370,62.471169 688.773132,62.868011 688.441895,63.264854
	C688.943848,63.514561 689.445740,63.764267 690.066895,64.256287
	C690.474854,64.953773 690.763611,65.408951 691.043091,66.257614
	C693.570129,68.083763 696.165222,69.424095 698.618164,70.987434
	C699.875732,71.788933 700.879211,72.988937 701.627686,74.055336
	C698.513855,75.999985 697.230713,77.917137 701.637085,79.924080
	C713.419189,80.569305 724.746704,81.192772 736.052612,82.236343
	C736.016724,83.761360 736.002380,84.866280 735.545654,85.989563
	C732.740784,86.017792 730.378174,86.027664 727.747070,85.747040
	C724.979492,85.936951 722.480469,86.417366 719.586487,86.936249
	C718.133911,87.004944 717.076233,87.035164 715.821289,86.806412
	C714.446838,87.887619 713.269775,89.227776 712.092651,90.567947
	C713.065063,91.032448 714.037354,91.496925 715.425476,91.962494
	C717.227234,91.971527 718.613220,91.979477 720.247437,92.266953
	C721.993591,92.690331 723.491516,92.834160 725.116821,93.273361
	C725.830261,94.713707 726.416321,95.858681 727.003113,97.393158
	C726.773315,100.666382 728.019592,102.140717 731.002625,102.327530
	C731.666748,103.243156 732.356628,104.304573 732.974487,104.264198
	C736.415405,104.039330 739.838867,103.547424 743.224182,103.532242
	C742.784424,107.963676 744.998230,108.488434 748.092712,107.360344
	C755.796814,104.551773 763.456909,101.622406 771.070679,99.118996
	C767.108398,101.791924 763.154785,104.000381 759.336853,106.422592
	C757.641418,107.498215 756.219788,109.005394 754.673889,110.316689
	C755.041992,110.942184 755.410156,111.567680 755.778259,112.193176
	C757.834900,111.577400 759.978577,111.161209 761.932129,110.309090
	C768.228455,107.562622 774.454834,104.655525 781.052673,101.840103
	C781.963745,101.278954 782.530273,100.688049 783.465454,100.078842
	C785.901489,101.045418 787.968811,102.030281 790.057373,103.482506
	C790.029480,112.962677 789.980408,121.975487 789.580322,131.034454
	C788.132080,133.031937 787.034790,134.983261 785.594666,136.962006
	C784.498291,137.643921 783.744690,138.298401 782.600952,139.042389
	C781.148560,139.217773 780.086304,139.303665 779.049927,139.019501
	C779.970154,137.380951 780.864624,136.112442 781.759033,134.843933
	C781.612793,134.417618 781.466553,133.991302 781.320312,133.564987
	C779.681458,133.833405 777.491089,133.539551 776.521545,134.490433
	C774.656250,136.319885 773.482117,138.854019 771.788940,141.402313
	C771.386780,144.133728 771.217041,146.558746 770.818604,149.137360
	C770.966431,149.873047 771.342957,150.455139 771.927490,151.269287
	C772.679504,151.788971 773.223450,152.076614 773.870605,152.548645
	C774.151001,152.963699 774.376526,153.127731 774.769775,153.522675
	C775.587524,154.225800 776.286011,154.631409 777.012695,155.254059
	C777.040833,155.471085 777.046875,155.908752 777.026001,156.308182
	C777.362305,158.145386 777.719482,159.583160 778.064575,161.400879
	C777.940002,162.531204 777.827576,163.281616 777.366150,164.072571
	C774.309570,165.402695 774.111023,163.904510 773.902161,161.679108
	C773.747192,160.028244 772.752136,158.456223 772.131226,156.849091
	C769.023254,163.528214 769.470764,164.653366 774.459717,166.811554
	C774.998047,168.951736 775.507263,170.976410 776.030640,173.427063
	C775.887756,175.255905 775.730774,176.658752 775.293091,178.112610
	C775.017761,179.113190 775.022949,180.062805 775.036499,181.342087
	C774.987976,182.106979 774.931091,182.542175 774.503296,183.074692
	C773.834412,184.920609 773.536255,186.669220 773.255981,188.834351
	C773.168701,191.498169 773.063538,193.745483 772.610596,196.061615
	C772.161072,197.746933 772.059265,199.363449 771.967041,201.314728
	C771.909485,202.090149 771.842346,202.530792 771.445618,203.062042
	C771.095398,204.773239 771.074768,206.393814 771.067871,208.420776
	C770.961121,209.900986 770.840698,210.974808 770.422241,212.092682
	C770.092529,213.095215 770.060791,214.053696 770.030273,215.385498
	C769.909180,216.493179 769.786926,217.227539 769.375854,218.039703
	C769.066711,219.080704 769.046326,220.043915 769.037598,221.421753
	C768.921082,223.211319 768.792908,224.586243 768.339355,226.060181
	C767.154480,227.137131 766.295044,228.115082 765.633179,228.868240
	C764.018066,227.330475 762.845886,226.214417 761.673706,225.098358
	C760.309937,226.886765 758.946167,228.675156 757.530762,230.531219
	C744.781006,230.531219 731.650269,230.531219 718.473450,230.531219
	C719.269958,229.166351 720.549194,227.810226 720.267822,227.275833
	C719.743652,226.280502 718.400696,225.485641 717.236450,225.110916
	C715.378845,224.513031 713.388733,224.326950 711.390747,223.608337
	C711.003723,222.114609 710.680603,220.979294 710.256348,219.555359
	C709.778870,218.797211 709.402405,218.327682 708.913208,217.475159
	C702.944397,216.730438 697.087402,216.383911 691.233032,215.996841
	C689.674805,215.893829 688.124817,215.666519 686.571106,215.496292
	C693.521667,212.266708 701.512512,216.740524 708.928345,210.528290
	C706.187622,209.064880 704.241272,207.115967 702.377808,207.192215
	C695.293518,207.482025 688.228149,208.359116 681.176636,209.194107
	C680.043640,209.328247 679.017700,210.366516 677.837463,211.047287
	C678.739807,212.562637 679.379822,213.637390 679.786743,214.320801
	C678.377991,216.189362 677.247009,217.689377 676.116089,219.189392
	C676.116089,219.189392 676.104370,219.096008 675.852234,219.157166
	C675.066711,219.479492 674.533386,219.740662 674.000000,220.001831
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M711.955627,57.160583
	C710.226135,56.788090 708.496643,56.415592 706.175903,55.745338
	C704.716431,55.319519 703.848267,55.191456 702.980042,55.063393
	C701.675293,54.977634 700.370483,54.891876 698.534058,54.481720
	C696.988647,53.818523 695.974915,53.479721 694.961243,53.140923
	C692.000671,52.710556 689.040039,52.280197 685.578186,51.531021
	C684.391418,50.473682 683.705933,49.735165 683.020447,48.996643
	C683.020447,48.996635 683.039917,48.531109 683.046997,48.298828
	C684.456909,47.726131 685.859680,47.385712 687.632263,47.020485
	C689.304810,47.086132 690.607605,47.176590 692.439209,47.568413
	C693.674316,48.170666 694.380554,48.471554 695.086853,48.772449
	C697.033752,48.907578 698.980652,49.042694 701.472412,49.515385
	C703.034180,50.179188 704.050964,50.505417 705.067810,50.831646
	C706.793640,51.186623 708.519470,51.541599 710.784912,52.181419
	C711.896545,52.590012 712.468567,52.713760 713.440491,52.901314
	C716.799255,53.377281 719.757996,53.789440 722.842041,54.491177
	C723.658569,55.128284 724.349854,55.475822 725.455811,55.884956
	C727.815552,56.034409 729.760559,56.122265 731.829956,56.501656
	C732.647034,57.152626 733.339783,57.512062 734.437439,57.919540
	C736.469299,58.043545 738.096191,58.119503 739.846313,58.485767
	C740.664429,59.093269 741.359314,59.410465 742.451782,59.801792
	C745.232666,60.252594 747.616089,60.629272 750.189209,61.321514
	C754.933472,62.685753 759.487976,63.734428 764.444458,64.840836
	C769.886414,65.995026 774.926331,67.091476 779.973267,68.488342
	C779.986877,69.193794 779.993408,69.598824 779.978027,70.300766
	C779.636597,71.065125 779.317078,71.532578 778.664246,72.000351
	C777.886475,72.000427 777.442017,72.000191 776.755493,71.726044
	C773.003052,70.637634 769.492737,69.823143 765.619141,68.873932
	C759.473938,67.574226 753.691956,66.409248 747.909912,65.244270
	C741.326782,64.089409 734.743713,62.934559 727.604492,61.488541
	C726.347290,60.869202 725.646179,60.541031 724.945129,60.212852
	C724.516602,60.147076 724.088074,60.081306 723.094910,59.742004
	C720.670898,59.044563 718.811584,58.620655 716.952209,58.196747
	C716.521240,58.134697 716.090332,58.072643 715.115723,57.745266
	C713.699951,57.373489 712.827820,57.267040 711.955627,57.160583
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M673.999512,220.412140
	C674.533386,219.740662 675.066711,219.479492 675.896973,219.171753
	C676.452576,221.090332 676.711304,223.055481 677.043823,225.381851
	C675.713745,229.287689 674.309814,232.832336 672.943176,236.282974
	C670.593018,234.169724 670.169189,228.535583 672.089478,225.554642
	C672.994263,224.150070 673.378723,222.410324 673.999512,220.412140
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M678.648376,231.117783
	C678.347351,236.981903 677.648926,242.913116 676.604919,248.962708
	C676.923157,243.115677 677.587097,237.150284 678.648376,231.117783
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M673.645508,256.043884
	C672.072144,256.306732 670.053284,256.553009 667.935303,256.456421
	C669.624146,256.084808 671.412048,256.056091 673.645508,256.043884
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M682.793945,49.099976
	C683.705933,49.735165 684.391418,50.473682 685.173401,51.506912
	C684.281799,51.398952 683.293701,50.996284 682.146545,50.295124
	C682.096497,49.670498 682.289795,49.406055 682.793945,49.099976
z"/>
<path fill="#7CC5E7" opacity="1.000000" stroke="none"
	d="
M739.723083,58.195450
	C738.096191,58.119503 736.469299,58.043545 734.369019,57.596954
	C733.165588,56.887596 732.435608,56.548862 731.705627,56.210121
	C729.760559,56.122265 727.815552,56.034409 725.382507,55.569294
	C724.168640,54.861893 723.442688,54.531750 722.716797,54.201607
	C719.757996,53.789440 716.799255,53.377281 713.378967,52.600945
	C712.273621,51.816425 711.629700,51.396080 710.985840,50.975739
	C711.383728,47.542751 713.995850,48.008484 716.289612,48.005894
	C730.106506,47.990307 743.923340,47.996979 757.740234,47.996983
	C805.683105,47.996990 853.626038,48.004906 901.568909,47.975788
	C904.042358,47.974285 906.573059,47.265602 908.969849,47.617413
	C910.711975,47.873123 912.276794,49.336384 913.732727,50.797867
	C913.277344,51.834858 913.009949,52.335220 912.742554,52.835587
	C911.435486,52.933533 910.128479,53.031475 908.138916,53.151451
	C906.980835,53.480167 906.505249,53.786858 906.029602,54.093544
	C902.638489,54.784058 899.247314,55.474583 895.143860,56.194748
	C893.846741,56.744862 893.262024,57.265335 892.677246,57.785812
	C890.705383,57.911324 888.733521,58.036839 886.094788,58.186317
	C884.845032,58.735222 884.262207,59.260162 883.679382,59.785118
	C883.014587,59.809982 882.349731,59.834835 881.167358,59.691315
	C879.997009,59.945499 879.344238,60.368061 878.691467,60.790623
	C878.319946,60.808960 877.948486,60.827297 877.114014,60.681404
	C875.998962,60.942959 875.346863,61.368752 874.694763,61.794556
	C872.720947,62.115665 870.747131,62.436760 868.214111,62.618523
	C867.005188,62.921345 866.355408,63.363495 865.705627,63.805664
	C865.030884,63.830601 864.356201,63.855518 863.166016,63.716232
	C862.023010,63.985416 861.395508,64.418800 860.767944,64.852188
	C859.130005,64.959183 857.492065,65.066170 855.106689,65.198372
	C852.911438,65.832581 851.463684,66.441574 850.015930,67.050568
	C849.269531,67.073372 848.523071,67.096184 847.016235,67.118301
	C843.081055,68.353020 839.906250,69.588440 836.731445,70.823853
	C836.348206,70.814888 835.964905,70.805939 835.079224,70.614197
	C833.697571,70.861679 832.818359,71.291954 831.616699,71.756439
	C830.865112,71.842583 830.435974,71.894516 829.768433,71.701866
	C827.332520,71.639999 825.134827,71.822731 822.918823,71.635162
	C821.732910,65.662308 815.638611,59.986927 811.152039,60.324089
	C805.960571,60.714230 800.198181,66.183067 799.575928,71.152115
	C797.490417,71.545547 795.745178,71.774384 793.666138,71.971687
	C792.885498,71.947304 792.438721,71.954453 791.724731,71.882362
	C791.087708,71.776329 790.717834,71.749542 790.230103,71.470528
	C789.397461,71.102386 788.682678,70.986473 787.687683,70.845963
	C787.032837,70.811005 786.658081,70.800667 786.180054,70.527695
	C785.374756,70.136246 784.672852,70.007416 783.682739,69.856895
	C783.009521,69.832321 782.624390,69.829430 782.132568,69.530067
	C781.339355,68.885033 780.652832,68.536476 779.966248,68.187927
	C774.926331,67.091476 769.886414,65.995026 764.339417,64.497437
	C759.221375,63.066193 754.610413,62.036076 749.999451,61.005955
	C747.616089,60.629272 745.232666,60.252594 742.368530,59.498802
	C741.166260,58.812943 740.444641,58.504192 739.723083,58.195450
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M935.040283,47.685036
	C932.323608,48.596760 929.580566,49.300087 926.431641,49.791534
	C926.025879,49.579659 926.054199,49.154900 926.054199,49.154900
	C928.768311,48.475918 931.482361,47.796932 934.594116,47.087532
	C934.991699,47.057110 935.013916,47.476643 935.040283,47.685036
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M704.978027,50.494148
	C704.050964,50.505417 703.034180,50.179188 701.889282,49.536865
	C702.803589,49.532734 703.845886,49.844688 704.978027,50.494148
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M694.995972,48.461418
	C694.380554,48.471554 693.674316,48.170666 692.829590,47.592705
	C693.429138,47.593887 694.167114,47.872143 694.995972,48.461418
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M923.738159,49.303284
	C923.460815,49.873917 922.874207,50.371937 921.953979,50.819901
	C922.223206,50.256783 922.825989,49.743725 923.738159,49.303284
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M710.981689,51.220543
	C711.629700,51.396080 712.273621,51.816425 712.979004,52.537140
	C712.468567,52.713760 711.896545,52.590012 711.160767,52.210457
	C710.997009,51.954655 710.977600,51.465355 710.981689,51.220543
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M913.086914,52.869942
	C913.009949,52.335220 913.277344,51.834858 913.773193,51.160011
	C914.298767,51.090179 914.564392,51.247936 914.926270,51.651909
	C914.513062,52.198109 913.972168,52.551205 913.086914,52.869942
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M925.790894,49.131126
	C926.054199,49.154900 926.025879,49.579659 926.019287,49.792465
	C925.728638,49.936104 925.480957,49.800579 925.145447,49.429131
	C925.190002,49.208828 925.358826,49.158092 925.790894,49.131126
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M945.977051,246.869110
	C946.315002,247.449783 946.310974,247.811707 946.326782,248.442978
	C946.253052,250.821045 946.159424,252.929749 946.085999,255.481064
	C945.379028,260.814758 941.529419,259.393188 938.516785,259.695831
	C937.377808,259.810272 936.249329,260.028503 935.028809,260.540100
	C931.281921,260.906281 927.622253,260.931824 923.453552,260.643066
	C922.615173,260.031372 922.285706,259.733978 921.956299,259.436584
	C921.622192,259.924561 921.288086,260.412537 920.954041,260.900513
	C920.528870,260.941528 920.103699,260.982544 919.130005,260.757050
	C916.002747,259.988190 913.284424,256.948914 910.951172,260.910278
	C910.531372,260.950897 910.111572,260.991516 909.379150,261.073364
	C906.596802,260.448303 904.148743,259.325745 901.652832,259.206696
	C895.658630,258.920807 889.641724,259.079132 883.635010,259.149780
	C883.135803,259.155609 882.644714,259.852570 882.058350,260.605316
	C881.545654,261.007690 881.124390,261.033173 880.389404,261.093140
	C873.346497,258.280151 866.456177,259.804565 859.309937,260.645599
	C857.941650,260.931915 856.864563,260.945709 855.383850,260.931335
	C853.811951,260.880096 852.643677,260.857056 851.169922,260.994690
	C849.523010,261.148438 848.181580,261.141510 846.237305,260.848816
	C844.423462,260.677460 843.212524,260.791931 842.001526,260.906403
	C840.950439,260.918274 839.899292,260.930176 838.456604,260.915405
	C837.830994,260.327881 837.596924,259.766998 837.128052,258.706482
	C836.861328,257.762939 836.829407,257.319061 837.026978,256.772614
	C837.465759,256.414673 837.675171,256.159302 838.304077,255.941971
	C839.839233,255.964279 840.954773,255.948563 842.372742,256.107697
	C843.780457,256.521210 844.885742,256.759888 846.174927,257.245850
	C847.238770,257.302612 848.118713,257.112091 849.394165,256.972046
	C851.103516,256.901978 852.417297,256.781433 854.162354,256.764984
	C855.756042,256.879913 856.918518,256.890747 858.364990,257.066315
	C859.474426,257.429626 860.299866,257.628204 861.520508,257.845886
	C863.677856,257.275574 865.439941,256.686157 867.580383,256.079651
	C868.968445,256.046417 869.978210,256.030273 871.281494,256.156677
	C872.395020,256.510559 873.215027,256.721802 874.402466,256.974487
	C875.508667,257.043915 876.247375,257.071930 877.213867,257.350403
	C878.658142,257.134521 879.874817,256.668213 881.126160,256.187592
	C881.160889,256.173309 881.200989,256.109833 881.500977,256.111084
	C882.198303,256.054749 882.595642,255.997162 883.378479,255.959412
	C884.537659,255.960922 885.311462,255.942627 886.310425,256.226257
	C890.456604,258.376465 894.344971,259.552795 898.376160,255.985458
	C899.499268,255.999878 900.248291,255.999481 901.247559,256.002686
	C901.664490,256.005707 901.831238,256.005096 902.315979,256.074158
	C903.065247,256.180786 903.496460,256.217743 904.283936,256.343475
	C906.094177,256.649048 907.548157,256.865875 909.176147,257.307281
	C910.235901,257.010284 911.121582,256.488678 912.382935,255.976318
	C913.509888,255.964081 914.261108,255.942627 915.177490,256.214966
	C918.011780,259.108582 919.524536,257.129761 921.392944,255.060471
	C922.754456,255.075790 923.741211,255.105881 924.929993,255.381592
	C925.716309,255.824265 926.300598,256.021301 927.317505,256.271393
	C929.200745,256.287109 930.651306,256.249786 932.424683,256.221405
	C933.178467,256.204224 933.609253,256.178131 934.219482,256.358093
	C934.965820,256.059113 935.532898,255.554031 936.342407,255.045380
	C936.584839,255.041824 937.068604,255.007431 937.240723,255.289154
	C938.546265,256.213715 939.679688,256.856567 940.813110,257.499451
	C941.550354,256.003906 942.287598,254.508347 943.286560,252.783493
	C943.273621,251.323837 942.999084,250.093491 942.731812,248.513916
	C942.729553,247.233795 942.720032,246.302917 942.775330,245.015808
	C942.485229,244.091904 942.130249,243.524246 941.761108,242.666702
	C941.757446,241.990128 941.767944,241.603424 941.843445,240.795288
	C941.333557,238.560165 940.758728,236.746521 940.122314,234.542191
	C939.948059,232.578415 939.835388,231.005341 939.801819,229.034363
	C939.526733,227.716415 939.172485,226.796356 939.006165,225.615280
	C939.444824,223.904144 939.695435,222.454025 940.217896,220.717636
	C942.096924,220.211838 943.703979,219.992294 945.311157,219.772736
	C945.669373,220.587616 946.027588,221.402496 946.434937,222.559235
	C942.791626,224.871979 941.513672,227.553787 942.751404,231.867966
	C944.130737,236.675461 944.708374,241.712967 945.977051,246.869110
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M742.280151,257.676025
	C740.453247,257.131714 738.626282,256.587433 736.398926,255.582306
	C735.155884,252.028564 737.870239,248.154099 733.950928,245.360229
	C734.322205,242.255280 733.333496,239.873657 730.499695,240.419968
	C729.366150,240.638489 728.823242,243.921143 727.661133,245.873718
	C726.606201,245.975662 725.901489,246.012939 724.776489,246.029236
	C723.234253,246.013062 722.112427,246.017853 720.589722,246.026306
	C717.631287,246.298386 715.073608,246.566788 711.984131,246.890991
	C711.984131,249.812759 711.984131,252.914154 711.984131,256.015564
	C711.561218,256.007812 711.138367,256.000031 710.385986,255.517548
	C709.546875,250.339264 709.037231,245.635666 708.527588,240.932068
	C708.173645,240.967255 707.819702,241.002457 707.465820,241.037643
	C706.994202,242.023926 706.522644,243.010193 705.763306,243.732697
	C705.369324,241.616302 705.263123,239.763718 705.504700,237.924683
	C707.561279,237.285843 709.270142,236.633438 711.424072,235.991211
	C715.753784,236.587372 719.638428,237.173340 724.365784,237.886429
	C727.587280,235.258377 731.807861,234.744064 736.485962,237.780090
	C737.474670,238.421722 739.632080,238.281570 740.689392,237.613235
	C744.299805,235.330933 747.741394,235.048050 751.143616,237.665955
	C753.780212,239.694794 755.305786,239.194412 756.429077,236.004562
	C757.530518,235.989624 758.264832,235.983047 759.435974,235.987427
	C761.910339,235.995682 763.947815,235.992966 766.241943,236.208710
	C766.642700,237.301163 766.786804,238.175171 766.660095,239.173889
	C765.571045,239.880661 764.752930,240.462708 763.561462,240.986969
	C759.995972,239.698593 757.071167,239.007492 756.730591,244.185226
	C756.332642,244.916718 756.173828,245.474823 756.012207,246.369904
	C756.038818,247.155487 756.068115,247.604080 755.827637,248.330872
	C755.443237,251.011551 755.328552,253.414047 755.213928,255.816559
	C754.241272,255.692719 753.268555,255.568893 752.133484,254.834503
	C750.968689,251.128662 749.966248,248.033417 748.973511,244.546692
	C748.010742,242.796799 747.155701,240.400452 746.043701,240.274628
	C742.715027,239.897964 743.041931,242.744202 742.643066,245.066620
	C739.623352,248.686111 738.517517,252.283691 741.989258,256.300659
	C742.122620,256.944092 742.201416,257.310059 742.280151,257.676025
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M784.843323,255.990295
	C783.817688,255.991318 782.791992,255.992325 781.342468,255.713104
	C780.878052,255.260223 780.837524,255.087585 780.879883,254.607666
	C780.985229,253.876495 781.007690,253.452621 781.317993,252.746918
	C781.721252,249.967178 781.836548,247.469238 781.990479,244.651520
	C782.047791,243.902939 782.066406,243.474152 782.342407,242.771988
	C783.021362,239.984238 783.443054,237.469864 783.924011,234.633041
	C783.992371,233.873917 784.001343,233.437256 784.086670,232.638702
	C784.366943,230.828445 784.570923,229.380066 784.836670,227.543488
	C784.939941,226.109116 784.981506,225.062927 785.303467,223.745193
	C786.051880,219.977356 786.519897,216.481064 787.018066,212.658142
	C787.048950,211.894180 787.049622,211.456879 787.305237,210.767822
	C787.648315,209.323593 787.736511,208.131134 787.875183,206.620209
	C787.939514,205.872528 787.953430,205.443314 788.262634,204.751129
	C788.967529,200.642838 789.377136,196.797516 789.846191,192.561493
	C789.949768,191.118851 789.993774,190.066895 790.315430,188.752533
	C791.427307,183.041046 792.261475,177.591965 793.375305,172.091888
	C794.028748,171.979599 794.402588,171.918289 795.109985,171.870575
	C795.977356,171.304108 796.511108,170.724014 797.364258,170.106644
	C798.111816,170.081284 798.539917,170.093201 799.080200,170.485641
	C800.544678,171.241684 801.894409,171.930450 803.249695,171.941483
	C811.548889,172.009033 819.849365,171.923065 828.384521,172.101013
	C828.858337,173.108521 829.097168,173.903244 829.252563,175.134201
	C829.075317,177.688828 828.981445,179.807205 828.875183,182.207062
	C827.553894,179.925903 826.398682,177.931396 825.170654,175.710449
	C825.097778,175.483994 824.979309,175.023209 824.961731,174.730957
	C824.298889,174.275299 823.653687,174.111877 822.668457,173.960205
	C821.875977,173.948090 821.423340,173.924210 820.666382,173.624741
	C813.840271,173.235596 807.317810,173.040451 800.797607,173.099915
	C799.861755,173.108459 798.937134,174.345276 797.963013,175.336578
	C797.815857,176.081665 797.713074,176.503815 797.297119,177.049286
	C796.366699,179.513626 795.749390,181.854630 795.139404,184.608139
	C795.122742,186.673065 795.098816,188.325485 794.815613,190.154617
	C794.695374,191.219330 794.834473,192.107346 794.989441,193.408295
	C794.907837,195.191193 794.810364,196.561157 794.411377,198.015289
	C793.795227,198.813858 793.480713,199.528244 793.168579,200.530731
	C793.147827,201.202179 793.124634,201.585556 792.836548,202.140808
	C792.687500,203.203262 792.803284,204.093796 792.946045,205.420105
	C792.871155,207.880615 792.769287,209.905380 792.369995,212.021851
	C791.785889,212.838425 791.499207,213.563263 791.214233,214.566956
	C791.195374,215.216995 791.174683,215.588181 790.906128,216.090866
	C790.754578,216.815399 790.850769,217.408432 790.952271,218.327271
	C790.911743,219.084839 790.865967,219.516617 790.470459,220.053131
	C790.074280,222.437576 790.027893,224.717255 789.987427,227.411346
	C789.119080,234.224976 788.244812,240.624222 787.263184,247.345734
	C787.164734,248.118805 787.173706,248.569580 786.869019,249.265411
	C786.308716,251.645508 786.061951,253.780563 785.571533,255.925339
	C785.327881,255.935059 784.843323,255.990280 784.843323,255.990295
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M705.156982,237.911118
	C705.263123,239.763718 705.369324,241.616302 705.757141,244.160477
	C706.341248,248.863586 706.643738,252.875122 706.946289,256.886658
	C705.505920,256.659271 704.065552,256.431915 702.314453,255.654877
	C701.340332,249.573288 700.598694,244.049286 700.040649,238.506775
	C699.652344,234.650040 697.590576,233.129456 693.832886,232.947723
	C689.613831,232.743668 687.677673,235.011307 687.116699,238.670319
	C686.193298,244.693558 685.548950,250.759598 684.786987,256.807587
	C683.448059,257.149811 682.109131,257.492035 679.845947,258.070526
	C680.266968,253.801804 680.608704,250.336792 681.221313,246.253723
	C681.566040,245.021088 681.640015,244.406494 681.713928,243.791885
	C682.460754,239.180481 683.207581,234.569077 684.495361,229.522980
	C691.030884,229.051865 697.025452,229.015442 703.052124,229.205109
	C703.084229,229.431213 703.183533,229.876801 703.143799,230.190216
	C703.420776,231.001801 703.737488,231.499969 704.099243,232.372620
	C704.481812,234.468430 704.819397,236.189774 705.156982,237.911118
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M676.502808,219.179901
	C677.247009,217.689377 678.377991,216.189362 679.786743,214.320801
	C679.379822,213.637390 678.739807,212.562637 677.837463,211.047287
	C679.017700,210.366516 680.043640,209.328247 681.176636,209.194107
	C688.228149,208.359116 695.293518,207.482025 702.377808,207.192215
	C704.241272,207.115967 706.187622,209.064880 708.928345,210.528290
	C701.512512,216.740524 693.521667,212.266708 686.571106,215.496292
	C688.124817,215.666519 689.674805,215.893829 691.233032,215.996841
	C697.087402,216.383911 702.944397,216.730438 708.648438,217.567688
	C708.321838,218.108871 708.147217,218.174515 707.517090,218.170563
	C699.284790,218.066376 691.507996,217.993408 683.731689,218.036026
	C682.478638,218.042877 681.228394,218.564728 679.976807,218.848511
	C678.947693,218.955811 677.918579,219.063110 676.502808,219.179901
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M680.009399,219.191605
	C681.228394,218.564728 682.478638,218.042877 683.731689,218.036026
	C691.507996,217.993408 699.284790,218.066376 707.596985,218.482941
	C708.874146,219.191254 709.615784,219.517609 710.357422,219.843964
	C710.680603,220.979294 711.003723,222.114609 711.117188,223.868698
	C710.153015,226.454407 708.354431,228.852219 708.938232,230.266953
	C709.519897,231.676422 712.482239,232.817856 714.416870,232.843201
	C731.958069,233.072906 749.502869,233.032043 767.019165,233.360870
	C766.659485,234.104889 766.327271,234.558441 765.577637,235.008362
	C763.106506,235.328644 761.052856,235.652557 758.999146,235.976471
	C758.264832,235.983047 757.530518,235.989624 756.129578,235.700790
	C740.640808,235.283554 725.818604,235.161743 710.640320,234.980576
	C705.543335,232.952469 706.146667,228.680115 705.909546,224.381226
	C704.336060,223.001465 702.797180,221.230133 701.181274,221.156830
	C694.546997,220.855850 687.889404,221.071777 681.240356,221.097534
	C680.840942,220.576584 680.441528,220.055649 680.009399,219.191605
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M685.208984,256.869507
	C685.548950,250.759598 686.193298,244.693558 687.116699,238.670319
	C687.677673,235.011307 689.613831,232.743668 693.832886,232.947723
	C697.590576,233.129456 699.652344,234.650040 700.040649,238.506775
	C700.598694,244.049286 701.340332,249.573288 702.040894,255.521027
	C701.486511,255.764282 700.894897,255.591690 700.127563,254.767975
	C699.232849,252.827133 698.513855,251.537430 697.560059,249.936752
	C696.900574,247.032913 696.611267,244.407379 695.997742,241.859940
	C695.654419,240.434494 694.773438,239.138535 694.078613,237.563690
	C693.836121,237.126846 693.649719,236.910583 693.463318,236.694336
	C693.271545,237.078690 693.079834,237.463058 692.525269,238.009125
	C691.673462,242.063934 691.184448,245.957016 690.404785,249.949860
	C689.795410,250.744110 689.476746,251.438599 689.120911,252.528870
	C689.058105,254.238052 689.032532,255.551437 689.006958,256.864807
	C687.881653,256.887024 686.756348,256.909241 685.208984,256.869507
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M689.296082,257.139648
	C689.032532,255.551437 689.058105,254.238052 689.428833,252.442291
	C690.081177,251.256638 690.388306,250.553375 690.695435,249.850098
	C691.184448,245.957016 691.673462,242.063934 692.839355,238.031433
	C693.722290,237.856094 693.928467,237.820175 694.134644,237.784241
	C694.773438,239.138535 695.654419,240.434494 695.997742,241.859940
	C696.611267,244.407379 696.900574,247.032913 697.588501,250.335205
	C697.898193,252.678345 697.944702,254.312042 697.991211,255.945755
	C695.727295,259.514893 692.512512,257.642212 689.296082,257.139648
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M681.187378,221.441101
	C687.889404,221.071777 694.546997,220.855850 701.181274,221.156830
	C702.797180,221.230133 704.336060,223.001465 705.587891,224.456085
	C704.828125,224.985397 704.390869,225.050690 703.489319,225.079285
	C696.396851,225.061630 689.768677,225.080658 683.140503,225.099701
	C682.471802,223.994690 681.803101,222.889664 681.187378,221.441101
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M712.338013,256.200439
	C711.984131,252.914154 711.984131,249.812759 711.984131,246.890991
	C715.073608,246.566788 717.631287,246.298386 720.585693,246.471588
	C721.018188,249.594254 721.053955,252.275314 720.800964,255.093857
	C720.023987,255.900162 719.535767,256.568970 719.047546,257.237793
	C716.929016,256.953644 714.810425,256.669495 712.338013,256.200439
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M683.102905,225.452179
	C689.768677,225.080658 696.396851,225.061630 703.498169,225.413818
	C703.654236,226.849701 703.337158,227.914352 703.020081,228.979019
	C697.025452,229.015442 691.030884,229.051865 684.583130,229.140091
	C683.775146,228.062805 683.420288,226.933731 683.102905,225.452179
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M755.520142,256.042358
	C755.328552,253.414047 755.443237,251.011551 756.160706,248.315796
	C757.519409,247.653473 758.275269,247.284393 759.426147,246.929367
	C760.874756,246.955826 761.928467,246.968216 763.139099,247.248871
	C763.648865,247.733902 764.001709,247.950653 764.331177,248.594452
	C764.183167,251.310486 764.058594,253.599487 763.584839,255.923676
	C762.502441,256.401428 761.769348,256.843994 761.036255,257.286560
	C759.299622,256.947113 757.563049,256.607635 755.520142,256.042358
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M742.653320,257.720367
	C742.201416,257.310059 742.122620,256.944092 742.005188,255.850708
	C741.969910,253.980423 742.054199,252.830872 741.960327,251.696045
	C741.738892,249.019501 742.762146,247.838074 745.589233,247.915436
	C748.272461,247.988876 750.074280,248.618759 750.012939,251.719620
	C749.983948,253.186035 750.082581,254.654999 750.123352,256.122803
	C747.757751,256.670105 745.392151,257.217407 742.653320,257.720367
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M763.934021,255.888474
	C764.058594,253.599487 764.183167,251.310486 764.610718,248.517639
	C765.256531,247.362442 765.599365,246.711121 766.068542,245.838531
	C766.462646,245.414749 766.730469,245.212250 767.291992,245.134872
	C768.387085,245.505188 769.188599,245.750366 769.993347,246.427155
	C770.042786,248.588470 770.088928,250.318176 770.084229,252.414062
	C770.006287,253.517944 769.979309,254.255615 769.854309,255.242111
	C769.680664,255.652420 769.605103,255.813919 769.529602,255.975403
	C767.958923,256.293274 766.388245,256.611176 764.420410,256.659790
	C763.993591,256.223175 763.963806,256.055817 763.934021,255.888474
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M750.369141,256.021057
	C750.082581,254.654999 749.983948,253.186035 750.012939,251.719620
	C750.074280,248.618759 748.272461,247.988876 745.589233,247.915436
	C742.762146,247.838074 741.738892,249.019501 741.960327,251.696045
	C742.054199,252.830872 741.969910,253.980423 741.950684,255.573227
	C738.517517,252.283691 739.623352,248.686111 742.960144,245.211884
	C745.417297,245.170532 747.190613,245.054352 748.963867,244.938171
	C749.966248,248.033417 750.968689,251.128662 751.969421,254.655655
	C751.516846,255.364685 751.065918,255.641983 750.369141,256.021057
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M784.916016,256.301361
	C784.843323,255.990280 785.327881,255.935059 785.911987,255.977692
	C787.683228,256.016510 788.870422,256.012665 790.479492,256.016846
	C792.589783,256.015350 794.278198,256.005859 796.282593,256.135040
	C798.461792,255.829712 800.325134,255.385712 802.407715,255.159668
	C802.762024,256.173309 802.897156,256.968964 803.032288,257.764648
	C797.693298,258.153046 792.354309,258.541473 786.559265,258.901001
	C785.731689,258.118927 785.360229,257.365692 784.916016,256.301361
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M707.295776,256.922546
	C706.643738,252.875122 706.341248,248.863586 706.044922,244.424255
	C706.522644,243.010193 706.994202,242.023926 707.465820,241.037643
	C707.819702,241.002457 708.173645,240.967255 708.527588,240.932068
	C709.037231,245.635666 709.546875,250.339264 710.069458,255.493851
	C709.270020,256.282715 708.457642,256.620575 707.295776,256.922546
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M733.937317,245.740143
	C737.870239,248.154099 735.155884,252.028564 736.024536,255.574646
	C734.284058,256.648254 732.517700,257.268677 730.282471,257.663330
	C729.507629,257.036682 729.201660,256.635773 729.126343,255.924072
	C735.208008,253.750793 735.421753,252.675201 731.234741,246.805237
	C732.257202,246.266144 733.097290,246.003143 733.937317,245.740143
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M721.089722,254.956375
	C721.053955,252.275314 721.018188,249.594254 720.986511,246.467911
	C722.112427,246.017853 723.234253,246.013062 724.743286,246.387512
	C725.449524,247.837265 725.768616,248.907745 726.046509,250.380737
	C725.925720,251.855759 725.846008,252.928284 725.487915,254.025238
	C724.792419,254.386337 724.375244,254.723022 723.958069,255.059723
	C723.557068,255.052979 723.156067,255.046234 722.187988,255.016571
	C721.443909,254.981232 721.266785,254.968811 721.089722,254.956375
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M769.801758,256.276947
	C769.605103,255.813919 769.680664,255.652420 770.315552,255.246140
	C774.182251,254.972549 777.489624,254.943741 780.796936,254.914948
	C780.837524,255.087585 780.878052,255.260223 780.958130,255.695465
	C777.387817,256.717316 773.909119,259.786621 769.801758,256.276947
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M724.012085,255.402802
	C724.375244,254.723022 724.792419,254.386337 725.732910,254.126465
	C726.477356,254.469818 726.698364,254.736359 727.020386,255.251633
	C727.414124,255.693344 727.707031,255.886337 728.223511,256.119843
	C728.447205,256.160370 728.895691,256.234833 728.895691,256.234863
	C729.201660,256.635773 729.507629,257.036682 729.924622,257.662689
	C727.002075,260.082611 725.512085,257.975555 724.012085,255.402802
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M698.257874,255.861359
	C697.944702,254.312042 697.898193,252.678345 697.823303,250.646179
	C698.513855,251.537430 699.232849,252.827133 699.952271,254.503174
	C699.476685,255.185318 699.000610,255.481140 698.257874,255.861359
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M720.800964,255.093857
	C721.266785,254.968811 721.443909,254.981232 721.887268,255.023621
	C721.256836,255.915482 720.360107,256.777405 719.255493,257.438538
	C719.535767,256.568970 720.023987,255.900162 720.800964,255.093857
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M698.814087,260.688049
	C698.147461,261.147888 697.282959,261.370056 696.217285,261.366821
	C696.882751,260.911102 697.749451,260.680756 698.814087,260.688049
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M763.584839,255.923676
	C763.963806,256.055817 763.993591,256.223175 764.071533,256.639893
	C763.233459,257.162933 762.347290,257.436554 761.248657,257.498352
	C761.769348,256.843994 762.502441,256.401428 763.584839,255.923676
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M690.821411,260.857941
	C690.107666,261.239136 689.225830,261.357483 688.168457,261.224365
	C688.879761,260.846954 689.766541,260.721008 690.821411,260.857941
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M681.456787,243.883347
	C681.640015,244.406494 681.566040,245.021088 681.234619,245.827545
	C681.051392,245.337875 681.125549,244.656342 681.456787,243.883347
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M806.020630,361.020569
	C801.753052,361.019531 797.981079,361.019531 794.209045,361.019531
	C794.173767,360.258209 794.138489,359.496857 794.103210,358.735535
	C795.507141,358.487061 796.908936,358.039520 798.315430,358.024017
	C804.939270,357.950989 811.571594,358.172791 818.185547,357.908234
	C820.650330,357.809631 823.056946,356.246094 825.521240,356.150055
	C827.373718,356.077820 829.276001,357.281891 830.924133,359.053406
	C822.717896,361.852173 814.560059,360.649811 806.020630,361.020569
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M851.336548,338.427063
	C853.004517,339.175507 854.334167,340.105225 855.663818,341.034973
	C854.474548,342.015015 853.300964,343.822571 852.093628,343.845367
	C841.614075,344.042999 831.128357,343.934052 820.645020,343.850616
	C820.137512,343.846558 819.634827,343.228912 817.744934,341.986603
	C820.661194,341.495148 822.220886,341.023560 823.786072,341.004456
	C830.776611,340.919220 837.776001,341.141144 844.755676,340.852661
	C846.863831,340.765533 848.918884,339.392365 851.336548,338.427063
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M804.088013,377.825317
	C792.680603,377.957886 781.667908,377.957886 770.655212,377.957886
	C770.616333,377.494934 770.577393,377.031982 770.538452,376.569031
	C771.659668,376.365021 772.779480,375.994598 773.902405,375.984650
	C780.216553,375.928436 786.537476,376.120605 792.843445,375.887360
	C795.714172,375.781158 798.541931,374.783600 801.417725,374.410553
	C802.611084,374.255707 803.879211,374.676880 805.113342,374.836121
	C804.903198,375.788330 804.692993,376.740570 804.088013,377.825317
z"/>
<path fill="#275C9A" opacity="1.000000" stroke="none"
	d="
M719.962952,344.028717
	C719.777466,341.212372 721.541260,340.923401 723.803772,340.954254
	C729.452454,341.031311 735.124084,341.264801 740.745483,340.862640
	C744.560791,340.589661 748.281250,339.158905 752.097717,338.640961
	C753.418579,338.461731 754.900940,339.472656 756.309570,339.939911
	C755.627136,341.204315 755.225830,342.857941 754.177124,343.615295
	C753.266724,344.272858 751.623901,343.991791 750.304382,343.995270
	C740.500366,344.021118 730.696350,344.014496 720.418274,344.044312
	C719.944275,344.070587 719.997253,344.001801 719.962952,344.028717
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M820.039673,257.945465
	C819.270569,257.957062 818.501526,257.968628 817.326538,257.583679
	C816.826233,256.700806 816.731812,256.214478 816.708557,255.290573
	C816.785522,251.763458 817.013855,248.653259 816.729004,245.590775
	C816.488342,243.003052 815.652832,240.470657 814.975586,237.550980
	C812.356873,235.473694 809.959167,234.917908 807.707581,238.019287
	C807.242798,238.367264 807.042725,238.625458 806.507263,238.950439
	C804.806580,238.936218 803.499756,238.900543 802.168091,238.485367
	C802.118408,237.094116 802.093506,236.082382 802.370728,234.994827
	C803.111755,234.283066 803.550537,233.647125 804.457153,233.018555
	C809.886047,233.091080 814.847107,233.156219 819.863159,233.673935
	C820.065247,241.325699 820.212219,248.524902 820.270874,256.088928
	C820.134888,256.950989 820.087280,257.448242 820.039673,257.945465
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M820.256836,258.238525
	C820.087280,257.448242 820.134888,256.950989 820.691772,256.172424
	C826.399841,256.219147 831.598694,256.547150 836.797485,256.875183
	C836.829407,257.319061 836.861328,257.762939 836.865051,258.537933
	C831.382568,258.756592 825.928345,258.644104 820.256836,258.238525
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M803.401733,257.829285
	C802.897156,256.968964 802.762024,256.173309 802.369385,254.711334
	C802.127441,250.737183 802.143005,247.429321 802.544189,244.104889
	C803.627258,245.265091 804.470154,246.382263 804.983398,247.634521
	C805.552734,249.023972 805.821350,250.536728 806.195801,252.374664
	C806.226807,253.752609 806.282959,254.751663 806.255981,256.107300
	C806.122620,256.948456 806.072449,257.432983 806.022339,257.917542
	C805.271973,257.909637 804.521545,257.901764 803.401733,257.829285
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M806.286011,258.230530
	C806.072449,257.432983 806.122620,256.948456 806.605347,256.229980
	C810.237671,255.906754 813.437561,255.817459 816.637390,255.728165
	C816.731812,256.214478 816.826233,256.700806 816.942749,257.557251
	C813.493164,258.132751 810.021423,258.338135 806.286011,258.230530
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M842.201294,261.172729
	C843.212524,260.791931 844.423462,260.677460 845.832520,260.842102
	C844.820740,261.227173 843.610901,261.333130 842.201294,261.172729
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M911.357788,260.953064
	C913.284424,256.948914 916.002747,259.988190 918.810852,260.784485
	C916.614929,261.050873 914.189636,261.023376 911.357788,260.953064
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M921.302490,260.943268
	C921.288086,260.412537 921.622192,259.924561 921.956299,259.436584
	C922.285706,259.733978 922.615173,260.031372 922.997375,260.612061
	C922.583801,260.925537 922.117371,260.955780 921.302490,260.943268
z"/>
<path fill="#4D85AD" opacity="1.000000" stroke="none"
	d="
M837.995117,91.010170
	C836.799500,90.834137 835.603882,90.658104 833.183472,90.301735
	C838.903748,86.859024 838.481079,82.554710 837.568542,78.032532
	C837.380859,77.102623 837.662659,75.387199 838.244446,75.107414
	C841.474976,73.553612 844.864868,72.331085 848.673096,71.364929
	C852.350098,74.380692 855.168762,72.537888 858.454956,70.969925
	C863.257568,70.096031 867.616394,69.225372 872.348633,68.310257
	C873.472656,68.227753 874.223267,68.189705 875.184937,68.363136
	C876.259521,68.362869 877.123108,68.151123 878.411377,67.950226
	C882.198975,67.556320 885.561951,67.151550 889.263977,66.818329
	C890.399841,66.583336 891.196533,66.276794 892.403931,65.967575
	C895.858643,65.587662 898.902710,65.210411 902.336731,64.890892
	C904.144043,64.604568 905.561401,64.260521 907.374756,63.930862
	C908.823975,63.883064 909.877136,63.820877 911.293701,63.832985
	C912.774597,63.619606 913.892090,63.331940 915.403320,63.042175
	C916.842224,62.953922 917.887329,62.867771 919.270752,62.845882
	C920.406067,62.607357 921.203003,62.304573 922.393677,62.008682
	C923.833557,61.945770 924.879761,61.875961 926.265320,61.864124
	C927.403198,61.618149 928.201843,61.314198 929.000427,61.010254
	C929.443848,61.021248 929.887207,61.032238 930.830444,61.276054
	C931.876953,61.688347 932.423645,61.867813 932.970337,62.047279
	C933.504028,65.336609 931.637512,66.186081 928.115540,66.093651
	C926.582275,66.376816 925.784119,66.666313 924.985962,66.955811
	C920.962280,67.343475 916.938599,67.731140 912.191772,68.121170
	C910.973022,68.396179 910.477295,68.668816 909.981628,68.941452
	C908.929260,68.978577 907.876892,69.015709 906.061096,69.055260
	C904.099121,69.627693 902.900574,70.197701 901.702026,70.767700
	C897.785461,70.863968 893.868835,70.960251 889.130432,71.054832
	C887.204102,71.367485 886.099609,71.681831 884.995117,71.996170
	C881.303833,72.357742 877.612549,72.719315 873.095337,73.067467
	C870.844666,73.371941 869.419861,73.689835 867.995117,74.007729
	C867.562195,74.023438 867.129333,74.039146 865.916016,74.051918
	C861.827576,74.098640 858.519592,74.148308 854.759277,74.135529
	C846.450684,73.927193 846.450684,73.927193 845.596497,83.009720
	C848.401917,83.009720 851.199768,83.009720 854.446411,83.008453
	C857.570740,83.031227 860.246277,83.055267 862.947510,83.044449
	C862.973083,83.009598 862.931091,83.076607 863.044434,83.461319
	C867.787903,84.179230 872.418030,84.512436 877.458130,84.892090
	C879.242371,84.972137 880.616699,85.005745 882.143066,85.246597
	C882.870422,85.336250 883.445862,85.218658 884.460632,85.106781
	C887.511292,85.151726 890.122620,85.190956 892.906494,85.576378
	C895.732666,86.239830 898.386169,86.557091 901.451904,86.908112
	C903.242310,86.964439 904.620605,86.986992 906.195190,87.276306
	C906.599121,89.040855 906.806824,90.538643 907.014526,92.036423
	C905.945435,92.013550 904.876343,91.990685 903.162598,91.707458
	C901.330688,91.358688 900.143555,91.270279 898.956360,91.181870
	C893.914490,90.817169 888.872620,90.452454 883.158447,89.776756
	C880.974609,89.376411 879.463013,89.287048 877.951416,89.197693
	C875.273438,89.138313 872.595398,89.078934 869.258667,88.998230
	C868.599854,88.976913 868.171326,88.971748 868.040161,88.771225
	C867.711914,88.285652 867.440186,88.143578 866.792847,88.176704
	C866.294067,88.248009 866.096130,88.287102 865.600952,88.261086
	C864.901733,88.230415 864.499756,88.264847 863.674072,88.221878
	C860.163696,87.756409 857.076965,87.368347 853.713745,86.697769
	C850.758118,86.685394 846.868958,83.442093 846.002441,89.229973
	C846.003235,89.653854 846.004089,89.823402 845.608521,89.997032
	C843.139771,90.334183 841.067444,90.667244 838.745117,91.001968
	C838.328430,91.005814 838.161804,91.007996 837.995117,91.010170
z"/>
<path fill="#3B5670" opacity="1.000000" stroke="none"
	d="
M799.916199,70.987503
	C800.198181,66.183067 805.960571,60.714230 811.152039,60.324089
	C815.638611,59.986927 821.732910,65.662308 822.663452,71.784592
	C822.266113,72.864609 822.105774,73.424896 821.676270,74.244164
	C821.647583,79.861389 821.841309,85.222794 822.201294,90.572975
	C822.237305,91.108635 823.283386,91.576324 823.860718,92.075562
	C824.336609,93.681129 824.812500,95.286697 825.662964,96.933556
	C826.037537,96.974854 826.468018,97.167763 826.780762,97.587341
	C828.375732,99.997047 829.657959,101.987183 830.602051,103.983810
	C829.591553,103.979050 828.919189,103.967804 828.123474,103.611877
	C826.021423,102.478760 824.042664,101.690315 822.021973,100.594360
	C821.334656,99.523926 820.689392,98.761009 820.053467,97.624359
	C819.078552,96.459969 818.094238,95.669319 817.080200,94.502075
	C817.055786,93.118752 817.061157,92.112022 817.432983,90.982361
	C818.186584,89.537285 819.088257,88.121651 818.868042,86.909851
	C818.083496,82.592186 816.917358,78.343849 815.955566,73.738258
	C816.592712,72.243111 817.169983,71.078972 817.756470,69.570457
	C816.173706,66.162933 813.690186,63.959362 810.285828,65.240120
	C808.494141,65.914207 807.413086,68.477058 806.003723,70.593109
	C806.048035,72.357170 806.099731,73.715179 806.054077,75.458145
	C805.665649,80.874626 805.374634,85.906166 805.058105,91.331635
	C804.981079,92.776031 804.929565,93.826508 804.524902,94.910805
	C803.499207,95.934120 802.826599,96.923622 802.114014,98.287323
	C802.013489,99.409164 801.953064,100.156792 801.483276,100.907631
	C796.676941,100.594009 794.665466,102.545868 794.859375,107.036636
	C795.015930,110.660080 794.810242,114.299171 794.424927,118.055519
	C792.507874,120.648064 791.968750,123.014435 794.785645,125.366928
	C794.796387,126.099174 794.781677,126.517921 794.440674,127.045242
	C794.347046,128.796906 794.579712,130.440002 794.874023,132.341980
	C794.976746,132.773483 795.017639,132.946121 795.041565,133.431793
	C795.012512,134.163773 795.000427,134.582718 794.614380,135.000732
	C793.489197,134.995377 792.737976,134.990982 791.985413,134.518738
	C791.850281,123.565712 791.716614,113.080513 791.620361,102.264099
	C791.730835,101.264000 791.803894,100.595123 792.197021,99.925621
	C793.039734,99.362946 793.562378,98.800903 794.288147,98.114166
	C794.784729,97.832031 794.992737,97.598495 795.438721,97.208282
	C796.289368,96.462830 796.816589,95.797943 797.562500,94.943588
	C797.974609,94.211853 798.168152,93.669594 798.640381,93.043182
	C799.278503,92.310280 799.638000,91.661530 800.290039,90.715988
	C801.333313,84.764755 802.124878,79.114838 802.754883,73.447006
	C802.803711,73.008118 801.717712,72.443100 801.000977,71.719452
	C800.533936,71.330635 800.225037,71.159065 799.916199,70.987503
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M856.995300,231.004120
	C857.944275,230.395584 859.203918,229.992981 859.773743,229.133179
	C860.776733,227.619736 861.413513,224.385483 862.106262,224.412003
	C864.518494,224.504425 866.888977,225.685699 869.275330,226.453003
	C869.153992,226.998337 869.032654,227.543686 868.911316,228.089020
	C867.475891,228.610519 866.040466,229.132019 864.604980,229.653519
	C864.606201,229.891144 864.607422,230.128769 864.608582,230.366394
	C868.514954,230.366394 872.421265,230.366394 876.801208,230.366394
	C874.849487,228.999344 873.327332,227.933151 871.805115,226.866943
	C871.941650,226.426712 872.078186,225.986481 872.214661,225.546249
	C877.725525,224.442093 882.902710,221.430573 889.056580,224.778488
	C890.823486,225.739746 893.875061,224.120392 896.347900,224.050674
	C900.969482,223.920395 905.598755,224.058197 910.896118,224.176163
	C912.941528,225.274521 914.315552,226.281174 915.703796,227.580353
	C915.710510,228.465942 915.703003,229.059006 915.406372,229.803650
	C914.650146,230.900665 914.182983,231.846069 913.441406,232.843140
	C912.806946,232.989685 912.446899,233.084579 911.615906,233.098312
	C897.731934,233.084503 884.318848,233.151871 870.526733,233.166809
	C869.128845,233.141418 868.110046,233.168427 866.645386,233.105850
	C863.001038,232.477554 859.802612,231.938843 856.701904,231.301147
	C856.799683,231.202164 856.995300,231.004120 856.995300,231.004120
z"/>
<path fill="#487CA7" opacity="1.000000" stroke="none"
	d="
M866.005798,76.900146
	C877.684937,76.593048 889.364014,76.285942 901.977295,75.998589
	C908.591675,76.037498 914.271973,76.056656 919.969543,76.462051
	C919.981140,77.882927 919.975403,78.917557 919.598145,79.972038
	C916.819214,79.999062 914.411865,80.006233 911.811096,79.764236
	C910.719971,79.937790 909.822144,80.360497 908.554077,80.966095
	C906.723816,81.350388 905.264465,81.720947 903.803711,81.726868
	C890.202820,81.781906 876.601624,81.774246 862.745117,81.553551
	C861.328918,81.200508 860.168091,81.078682 858.776489,80.696228
	C857.366516,79.591301 856.187317,78.747002 855.460388,77.914902
	C859.277039,77.584778 862.641418,77.242462 866.005798,76.900146
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M910.930237,63.758694
	C909.877136,63.820877 908.823975,63.883064 907.132751,63.678131
	C904.978638,63.885063 903.462708,64.359123 901.946716,64.833176
	C898.902710,65.210411 895.858643,65.587662 892.210815,65.724823
	C890.713013,65.905434 889.818909,66.326111 888.924866,66.746780
	C885.561951,67.151550 882.198975,67.556320 878.214966,67.709053
	C876.720581,67.688568 875.847229,67.920105 874.973877,68.151657
	C874.223267,68.189705 873.472656,68.227753 872.441284,67.988892
	C872.436829,67.122314 872.713135,66.532646 872.989502,65.942993
	C875.735107,65.252769 878.480652,64.562531 881.997925,63.842960
	C885.861877,62.910248 888.954224,62.006870 892.046570,61.103500
	C893.100525,61.072441 894.154419,61.041374 895.764771,61.228695
	C896.899353,61.021549 897.477539,60.596012 898.055786,60.170471
	C899.780212,59.778744 901.504700,59.387020 903.829102,59.259796
	C906.306824,58.752399 908.184448,57.980511 910.062134,57.208611
	C910.809814,56.925140 911.557556,56.641685 912.688843,56.631397
	C913.736145,56.672649 914.399719,56.440739 915.063354,56.208832
	C915.495605,56.158215 915.927795,56.107597 916.853638,56.271900
	C917.915710,56.043499 918.484192,55.600178 919.052673,55.156860
	C920.671814,55.041000 922.291016,54.925133 924.724731,54.867775
	C926.359497,54.948380 927.179749,54.970474 928.000000,54.992569
	C927.356812,56.434052 926.713684,57.875534 926.028809,59.962337
	C925.966736,61.007153 925.946350,61.406651 925.926025,61.806149
	C924.879761,61.875961 923.833557,61.945770 922.202759,61.758148
	C920.723022,61.927681 919.827759,62.354645 918.932495,62.781616
	C917.887329,62.867771 916.842224,62.953922 915.191406,62.774437
	C913.367249,62.925430 912.148743,63.342064 910.930237,63.758694
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M846.800049,178.093323
	C846.871033,178.244751 846.941956,178.396179 847.034546,179.084412
	C847.034851,180.066849 847.013489,180.512497 846.716187,181.221817
	C846.438232,182.595749 846.323853,183.719208 846.452515,184.814102
	C847.250000,191.596664 848.102051,198.372818 848.594849,205.110046
	C847.565918,205.022232 846.877991,204.975479 846.142212,204.604919
	C846.085999,203.844757 846.077637,203.408371 846.303101,202.785248
	C846.159546,201.731491 845.782227,200.864502 845.324829,199.603485
	C845.181641,198.139069 845.118530,197.068695 845.294556,195.799042
	C845.094360,194.695648 844.655090,193.791504 844.182861,192.572952
	C844.128662,191.837723 844.107361,191.416885 844.322449,190.796722
	C844.328674,189.727615 844.098633,188.857880 843.867065,187.593063
	C843.241638,183.136841 842.617615,179.075684 842.223328,174.855270
	C842.242859,174.109894 842.032654,173.523773 841.797119,172.581360
	C841.517944,170.819046 841.264221,169.413025 841.228882,167.844757
	C841.057190,167.079880 840.666992,166.477249 840.227417,165.462555
	C839.999023,163.677795 839.819885,162.305130 839.643188,160.646027
	C839.100098,159.897537 838.554504,159.435471 838.020630,158.589294
	C838.045288,157.179474 838.058228,156.153763 838.431885,155.085800
	C839.511230,154.043106 840.229797,153.042679 841.080566,151.759399
	C841.508789,150.716522 841.804871,149.956497 842.471436,149.169525
	C844.087830,148.530075 845.333679,147.917572 846.579529,147.305099
	C845.749268,146.423111 844.919006,145.541077 844.064087,144.343048
	C844.002258,143.389099 843.965088,142.751190 844.328125,142.079407
	C849.317505,141.906647 850.513000,144.386322 849.729553,148.460678
	C849.483765,149.738953 849.390869,151.046631 849.227966,152.340851
	C849.103821,152.604279 848.926270,152.824738 848.158081,153.064819
	C847.072754,153.747543 846.524719,154.367706 845.809082,155.061707
	C845.641479,155.135513 845.286194,155.224930 844.981873,155.177979
	C844.386169,155.744492 844.094788,156.357941 843.788208,157.312958
	C843.643555,158.975800 843.513977,160.297089 843.274231,162.056946
	C844.376099,167.694794 845.588074,172.894058 846.800049,178.093323
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M837.997192,91.395729
	C838.161804,91.007996 838.328430,91.005814 839.073853,91.170349
	C843.082947,92.233040 846.513184,93.129005 850.280884,94.143372
	C860.341797,97.686165 870.065247,101.110550 881.069946,104.986145
	C878.377075,106.528595 877.167908,107.221230 875.958679,107.913857
	C875.247070,107.841484 874.535461,107.769112 873.196594,107.453568
	C868.417969,105.664078 864.266602,104.117767 860.003845,102.260590
	C855.911377,100.471741 851.947571,98.942322 847.922180,97.596855
	C847.527771,97.464996 846.755371,98.464035 846.158386,98.938156
	C842.069519,98.113403 838.073547,97.182770 837.997192,91.395729
z"/>
<path fill="#82C2E8" opacity="1.000000" stroke="none"
	d="
M876.191589,108.199036
	C877.167908,107.221230 878.377075,106.528595 881.069946,104.986145
	C870.065247,101.110550 860.341797,97.686165 850.433716,93.900620
	C850.840576,93.080200 851.432129,92.620941 852.414307,92.168015
	C854.103271,92.235054 855.401550,92.295769 856.836182,92.633667
	C857.680237,93.204094 858.387939,93.497345 859.482422,93.851776
	C861.169250,94.022842 862.469238,94.132736 863.903564,94.555946
	C865.063049,95.153961 866.088135,95.438667 867.525574,95.790009
	C872.879150,96.653404 877.820374,97.450165 882.878052,98.540726
	C883.703491,99.123482 884.412476,99.412453 885.480591,99.758331
	C886.565918,99.846962 887.291992,99.878677 888.115479,100.147789
	C888.473938,100.601868 888.734985,100.818542 888.996033,101.035225
	C886.885254,101.698563 884.398376,101.880493 882.765930,103.155983
	C881.014282,104.524597 880.142700,106.982323 878.690857,108.808777
	C878.451050,109.110481 877.205322,108.612587 876.191589,108.199036
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M863.000549,81.784767
	C876.601624,81.774246 890.202820,81.781906 903.803711,81.726868
	C905.264465,81.720947 906.723816,81.350388 908.933838,81.050171
	C910.456726,80.985481 911.229614,81.019592 912.273010,81.325150
	C914.362366,81.729843 916.181213,81.863091 918.000000,81.996338
	C916.713867,82.664337 915.479919,83.477631 914.128174,83.962654
	C912.528931,84.536423 910.828064,84.826851 908.746582,85.626091
	C907.547607,86.344543 906.773254,86.677040 905.998901,87.009537
	C904.620605,86.986992 903.242310,86.964439 901.343323,86.538658
	C898.126404,85.833687 895.430176,85.531937 892.733948,85.230186
	C890.122620,85.190956 887.511292,85.151726 884.320374,84.866287
	C883.157532,84.759827 882.574341,84.899582 881.991089,85.039345
	C880.616699,85.005745 879.242371,84.972137 877.337585,84.519470
	C872.181824,83.759132 867.556458,83.417870 862.931091,83.076607
	C862.931091,83.076607 862.973083,83.009598 862.976807,82.721001
	C862.987183,82.216530 862.993896,82.000648 863.000549,81.784767
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M882.761536,98.246933
	C877.820374,97.450165 872.879150,96.653404 867.413147,95.470535
	C865.848572,94.803841 864.808899,94.523239 863.769165,94.242645
	C862.469238,94.132736 861.169250,94.022842 859.393433,93.539734
	C858.178345,92.896515 857.439026,92.626503 856.699768,92.356491
	C855.401550,92.295769 854.103271,92.235054 852.207153,91.867645
	C849.741150,91.038284 847.873047,90.515617 846.004883,89.992950
	C846.004089,89.823402 846.003235,89.653854 846.451538,89.233742
	C849.589783,88.999931 852.278870,89.016678 855.313171,89.171097
	C860.783264,90.494331 865.908264,91.679893 871.033203,92.865471
	C871.772339,92.893585 872.511536,92.921692 873.846497,93.225739
	C876.619995,93.721786 878.797668,93.941902 880.975342,94.162018
	C881.400574,94.176720 881.825745,94.191422 882.702759,94.586784
	C885.457947,95.634109 887.730347,96.680267 890.072510,96.871330
	C892.997681,97.109955 893.136414,98.730553 892.937622,100.884422
	C892.225464,100.884972 891.513306,100.885521 890.388916,100.569122
	C889.323853,100.138245 888.670959,100.024323 888.018066,99.910400
	C887.291992,99.878677 886.565918,99.846962 885.382751,99.461868
	C884.204285,98.821304 883.482910,98.534111 882.761536,98.246933
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M947.116394,216.718872
	C946.444763,217.166229 945.891968,217.326996 944.798828,217.737366
	C943.519043,217.904572 942.779541,217.822174 941.912476,217.377060
	C933.744568,216.830658 925.704529,216.636475 917.663330,216.517395
	C917.437500,216.514053 917.199768,217.312866 916.600403,217.810730
	C915.485901,217.913116 914.738525,217.942429 913.824158,217.731552
	C913.106384,217.332657 912.555603,217.173950 912.004883,217.015259
	C912.003235,216.567551 912.001648,216.119858 912.000000,215.336380
	C915.636230,214.655655 919.304138,213.839569 922.901001,214.081085
	C927.754272,214.406982 932.536011,216.254669 937.245483,213.232178
	C938.201904,212.618393 939.829651,213.050766 941.919067,213.033936
	C943.794312,213.376678 944.898376,213.686371 946.002441,213.996063
	C946.413330,214.808136 946.824280,215.620193 947.116394,216.718872
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M830.940247,103.977325
	C829.657959,101.987183 828.375732,99.997047 826.987671,97.700500
	C831.669739,96.880630 832.870728,99.735497 832.878357,103.748375
	C832.897644,113.838318 832.932373,123.928223 832.933350,134.555573
	C832.905762,135.092987 832.756775,135.240280 832.476868,135.117065
	C831.769775,134.341278 831.342529,133.688721 830.934204,132.565613
	C830.948853,122.722481 830.944519,113.349907 830.940247,103.977325
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M848.935913,205.151108
	C848.102051,198.372818 847.250000,191.596664 846.452515,184.814102
	C846.323853,183.719208 846.438232,182.595749 846.979858,181.231079
	C847.695374,180.976700 847.871155,180.976730 848.046936,180.976776
	C848.064331,181.423264 848.081726,181.869766 848.096680,182.975098
	C848.387512,184.424728 848.680908,185.215500 848.974304,186.006256
	C849.362854,189.378738 849.751404,192.751221 850.157715,196.828354
	C850.434937,198.025879 850.694336,198.518753 850.953735,199.011627
	C850.988342,199.756195 851.022949,200.500778 851.062744,201.973694
	C851.377686,203.800812 851.687439,204.899612 851.997131,205.998413
	C852.355469,209.051575 852.713806,212.104752 853.026611,215.848618
	C852.902161,216.729385 852.823181,216.919449 852.411743,216.991547
	C851.041748,213.556808 850.004089,210.240067 848.966309,206.626877
	C848.956116,205.937317 848.945984,205.544220 848.935913,205.151108
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M849.531433,152.287781
	C849.390869,151.046631 849.483765,149.738953 849.729553,148.460678
	C850.513000,144.386322 849.317505,141.906647 843.972351,142.056915
	C842.500244,142.051773 841.783997,142.035263 840.846313,141.752167
	C838.002075,139.403809 835.379456,137.322037 832.756775,135.240265
	C832.756775,135.240280 832.905762,135.092987 832.980652,135.019180
	C837.807434,137.431015 841.995117,141.587646 848.714722,140.273010
	C850.186646,141.353592 851.056274,142.190063 851.925903,143.026520
	C851.930786,144.731049 851.935669,146.435577 851.705688,148.781601
	C851.329895,150.286392 851.188904,151.149689 851.047852,152.012985
	C850.643555,152.086899 850.239197,152.160812 849.531433,152.287781
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M870.966431,92.553482
	C865.908264,91.679893 860.783264,90.494331 855.217712,88.902313
	C854.514771,87.990677 854.252502,87.485481 853.990173,86.980293
	C857.076965,87.368347 860.163696,87.756409 863.700684,88.475204
	C864.441589,89.074409 864.732300,89.342873 865.023071,89.611336
	C865.314758,89.182968 865.606445,88.754593 865.898132,88.326202
	C866.096130,88.287102 866.294067,88.248009 866.910522,88.381050
	C867.559937,88.792915 867.840698,88.932442 868.171326,88.971748
	C868.171326,88.971748 868.599854,88.976913 868.811523,89.011765
	C869.648743,90.111572 870.274231,91.176537 870.966431,92.553482
z"/>
<path fill="#82C2E8" opacity="1.000000" stroke="none"
	d="
M860.115234,102.571457
	C864.266602,104.117767 868.417969,105.664078 872.840088,107.424583
	C871.699402,108.425842 870.287903,109.212914 868.245728,109.992783
	C867.614990,109.985573 867.162537,110.002670 867.162537,110.002670
	C864.991638,108.403069 862.820740,106.803467 860.341919,104.648849
	C860.061035,103.586372 860.088135,103.078911 860.115234,102.571457
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M866.008789,76.554031
	C862.641418,77.242462 859.277039,77.584778 855.465454,77.543060
	C855.082642,76.172012 855.147156,75.184990 855.211609,74.197975
	C858.519592,74.148308 861.827576,74.098640 865.593445,74.092171
	C866.038147,74.826218 866.024963,75.517075 866.008789,76.554031
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M919.952209,76.075806
	C914.271973,76.056656 908.591675,76.037498 902.443359,75.966095
	C902.177979,75.468018 902.389648,74.628944 902.582031,74.633339
	C908.993286,74.779716 915.402832,75.006660 921.559937,75.618744
	C920.855591,76.035721 920.403870,76.055763 919.952209,76.075806
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M846.888672,177.677277
	C845.588074,172.894058 844.376099,167.694794 843.538696,162.150452
	C844.286011,161.865494 844.658691,161.925598 845.031372,161.985718
	C845.412292,164.705536 845.793274,167.425369 846.169067,170.835602
	C846.406677,172.027740 846.649475,172.529480 846.892212,173.031204
	C846.920593,174.441208 846.948914,175.851227 846.888672,177.677277
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M893.302795,100.896492
	C893.136414,98.730553 892.997681,97.109955 890.072510,96.871330
	C887.730347,96.680267 885.457947,95.634109 883.018433,94.635468
	C886.147705,94.595818 889.458496,94.660965 892.654968,95.298660
	C893.838623,95.534798 895.091064,96.962585 895.633972,98.155571
	C895.867554,98.668709 894.375854,99.966995 893.302795,100.896492
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M852.214966,142.789017
	C851.056274,142.190063 850.186646,141.353592 849.157837,140.255844
	C848.498230,138.497742 847.997681,137.000916 847.424316,135.286087
	C849.582947,133.830902 851.543884,132.697769 851.980530,136.799133
	C852.184326,138.713470 852.331299,140.633865 852.214966,142.789017
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M845.306641,161.787781
	C844.658691,161.925598 844.286011,161.865494 843.648865,161.711884
	C843.513977,160.297089 843.643555,158.975800 844.068176,157.197174
	C844.670898,156.234879 844.978577,155.729904 845.286194,155.224930
	C845.286194,155.224930 845.641479,155.135513 846.125488,155.074158
	C847.029419,154.993164 847.449341,154.973541 847.869263,154.953918
	C851.111206,158.546173 846.695129,159.498764 845.306641,161.787781
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M913.991211,217.971741
	C914.738525,217.942429 915.485901,217.913116 916.792725,217.951508
	C917.644287,218.162048 917.867126,218.376678 917.839233,218.979126
	C916.142029,219.955841 914.626221,220.616531 913.205994,221.235580
	C914.185730,223.623047 914.937683,225.455444 915.689636,227.287811
	C914.315552,226.281174 912.941528,225.274521 911.274414,224.134720
	C910.978210,223.240692 910.974915,222.479813 911.197998,221.195312
	C911.619690,220.119125 911.815002,219.566574 912.010315,219.014023
	C912.010315,219.014023 912.000000,219.000000 912.304382,218.986145
	C913.069580,218.638763 913.530396,218.305252 913.991211,217.971741
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M906.195190,87.276306
	C906.773254,86.677040 907.547607,86.344543 908.659790,86.011276
	C911.838074,90.485283 911.781799,90.716385 907.213684,92.275360
	C906.806824,90.538643 906.599121,89.040855 906.195190,87.276306
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M938.539185,50.912495
	C939.315857,50.910065 939.794556,50.947628 940.632324,50.985146
	C938.953796,55.496708 937.300232,56.050343 933.045776,53.237556
	C933.353882,52.821106 933.736145,52.787777 934.744263,52.806343
	C935.933289,52.302921 936.496399,51.747608 937.059509,51.192299
	C937.453369,51.112370 937.847229,51.032429 938.539185,50.912495
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M918.348083,81.989349
	C916.181213,81.863091 914.362366,81.729843 912.273193,81.064804
	C912.003296,80.359802 912.003845,80.186600 912.004456,80.013397
	C914.411865,80.006233 916.819214,79.999062 919.864380,80.005127
	C920.679565,80.038834 920.857056,80.059311 921.034485,80.079773
	C920.255005,80.713959 919.475586,81.348160 918.348083,81.989349
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M854.319885,222.965027
	C855.209717,225.379395 856.099548,227.793762 856.992310,230.606140
	C856.995300,231.004120 856.799683,231.202164 856.410278,231.129044
	C855.323975,229.704788 854.627075,228.353653 853.949768,226.637665
	C853.915527,225.547043 853.861633,224.821259 853.927979,223.809341
	C854.138794,223.337143 854.229370,223.151077 854.319885,222.965027
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M880.763428,93.872482
	C878.797668,93.941902 876.619995,93.721786 874.216980,93.223572
	C876.178284,93.157959 878.364929,93.370453 880.763428,93.872482
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M878.045898,89.527328
	C879.463013,89.287048 880.974609,89.376411 882.744324,89.737823
	C881.381775,89.958916 879.761108,89.907944 878.045898,89.527328
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M868.232178,74.274323
	C869.419861,73.689835 870.844666,73.371941 872.656982,73.110336
	C871.519409,73.624718 869.994385,74.082825 868.232178,74.274323
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M852.258545,205.783142
	C851.687439,204.899612 851.377686,203.800812 851.131714,202.340317
	C851.636963,203.175018 852.078491,204.371445 852.258545,205.783142
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M866.862244,110.113831
	C867.162537,110.002670 867.614990,109.985573 867.842041,109.993454
	C867.824097,111.769394 868.025208,114.225807 865.045044,111.597183
	C865.493408,110.934624 866.027649,110.579811 866.862244,110.113831
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M899.038025,91.501778
	C900.143555,91.270279 901.330688,91.358688 902.761536,91.709488
	C901.710022,91.921814 900.414856,91.871750 899.038025,91.501778
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M852.744202,217.109512
	C852.823181,216.919449 852.902161,216.729385 853.107056,216.256683
	C853.672241,217.165466 854.111450,218.356873 854.039185,219.763245
	C853.354675,219.979126 853.181702,219.980042 852.998657,219.619812
	C852.907166,218.542282 852.825684,217.825897 852.744202,217.109512
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M853.008667,219.980972
	C853.181702,219.980042 853.354675,219.979126 853.787354,219.984436
	C854.074463,220.739502 854.101868,221.488327 854.224548,222.601105
	C854.229370,223.151077 854.138794,223.337143 853.610596,223.719986
	C853.118103,222.604843 853.063416,221.292908 853.008667,219.980972
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M885.213501,72.257568
	C886.099609,71.681831 887.204102,71.367485 888.674683,71.098724
	C887.837769,71.602524 886.634766,72.060745 885.213501,72.257568
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M902.095032,70.837021
	C902.900574,70.197701 904.099121,69.627693 905.669678,69.108040
	C904.857117,69.741035 903.672607,70.323677 902.095032,70.837021
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M921.172241,79.751747
	C920.857056,80.059311 920.679565,80.038834 920.235901,79.985268
	C919.975403,78.917557 919.981140,77.882927 919.969543,76.462051
	C920.403870,76.055763 920.855591,76.035721 921.645874,76.015564
	C921.759644,77.151535 921.534790,78.287628 921.172241,79.751747
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M925.174561,67.211807
	C925.784119,66.666313 926.582275,66.376816 927.716309,66.152489
	C927.155884,66.634377 926.259521,67.051086 925.174561,67.211807
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M926.265320,61.864124
	C925.946350,61.406651 925.966736,61.007153 925.994751,60.306248
	C926.865784,60.163845 927.729126,60.322849 928.796448,60.746048
	C928.201843,61.314198 927.403198,61.618149 926.265320,61.864124
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M928.003296,54.675545
	C927.179749,54.970474 926.359497,54.948380 925.129517,54.851807
	C925.590149,54.191391 926.460388,53.605446 927.681396,53.056374
	C928.023621,53.515003 928.015076,53.936756 928.003296,54.675545
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M849.226868,185.817932
	C848.680908,185.215500 848.387512,184.424728 848.166992,183.303314
	C848.653015,183.858307 849.066223,184.743942 849.226868,185.817932
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M851.367920,151.964020
	C851.188904,151.149689 851.329895,150.286392 851.721436,149.207428
	C851.877380,149.966187 851.782715,150.940628 851.367920,151.964020
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M848.261719,180.818405
	C847.871155,180.976730 847.695374,180.976700 847.255859,180.967407
	C847.013489,180.512497 847.034851,180.066849 847.159424,179.301941
	C847.667236,179.541779 848.071899,180.100906 848.261719,180.818405
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M847.948059,154.664474
	C847.449341,154.973541 847.029419,154.993164 846.293091,155.000336
	C846.524719,154.367706 847.072754,153.747543 847.972534,153.170990
	C848.225159,153.601410 848.126038,153.988220 847.948059,154.664474
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M929.335144,52.813419
	C929.620544,52.527653 930.244873,52.299736 930.933044,52.310432
	C930.555908,52.656452 930.115051,52.763859 929.335144,52.813419
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M847.127441,172.885513
	C846.649475,172.529480 846.406677,172.027740 846.254517,171.242493
	C846.684265,171.552567 847.023438,172.146194 847.127441,172.885513
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M851.180542,198.860992
	C850.694336,198.518753 850.434937,198.025879 850.251526,197.246628
	C850.687439,197.543610 851.047363,198.126984 851.180542,198.860992
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M851.031494,105.470001
	C851.646301,105.512505 852.331970,105.874596 853.144775,106.523994
	C852.548706,106.470741 851.825562,106.130165 851.031494,105.470001
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M888.115479,100.147797
	C888.670959,100.024323 889.323853,100.138245 890.036499,100.514160
	C889.915649,100.830826 889.734985,100.885483 889.275208,100.987686
	C888.734985,100.818542 888.473938,100.601868 888.115479,100.147797
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M932.954346,61.748920
	C932.423645,61.867813 931.876953,61.688347 931.163086,61.267883
	C931.643311,61.168114 932.290833,61.309338 932.954346,61.748920
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M911.720947,219.033569
	C911.815002,219.566574 911.619690,220.119125 911.159790,220.816589
	C911.073975,220.325394 911.252808,219.689255 911.720947,219.033569
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M913.824158,217.731552
	C913.530396,218.305252 913.069580,218.638763 912.311584,218.991302
	C912.009766,218.566849 912.005066,218.123367 912.002625,217.347565
	C912.555603,217.173950 913.106384,217.332657 913.824158,217.731552
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M910.138184,69.171646
	C910.477295,68.668816 910.973022,68.396179 911.763916,68.178040
	C911.471069,68.622307 910.882935,69.012070 910.138184,69.171646
z"/>
<path fill="#3A6995" opacity="1.000000" stroke="none"
	d="
M824.110107,91.804550
	C823.283386,91.576324 822.237305,91.108635 822.201294,90.572975
	C821.841309,85.222794 821.647583,79.861389 822.087891,74.250153
	C825.181458,73.313591 827.594116,72.630013 830.006775,71.946449
	C830.435974,71.894516 830.865112,71.842583 831.717957,72.032059
	C832.440735,72.506950 832.739868,72.740417 833.039062,72.973877
	C830.864075,76.005478 827.506287,78.671227 830.558960,83.142014
	C830.877502,83.608475 829.117310,85.494217 828.154785,86.978806
	C828.973511,88.194092 829.859741,89.509506 831.223328,91.533539
	C828.523376,91.533539 826.441406,91.533539 824.110107,91.804550
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M872.690308,65.827576
	C872.713135,66.532646 872.436829,67.122314 872.067871,68.033340
	C867.616394,69.225372 863.257568,70.096031 858.457825,70.643356
	C858.016296,69.884109 858.015625,69.448189 858.015015,69.012268
	C860.412903,68.335236 862.810852,67.658203 865.895813,66.942886
	C867.056091,66.604919 867.529236,66.305252 868.002441,66.005585
	C869.465332,65.907784 870.928162,65.809982 872.690308,65.827576
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M860.003845,102.260590
	C860.088135,103.078911 860.061035,103.586372 860.040894,104.469215
	C855.620178,102.976006 851.192505,101.107407 846.461670,99.088486
	C846.755371,98.464035 847.527771,97.464996 847.922180,97.596855
	C851.947571,98.942322 855.911377,100.471741 860.003845,102.260590
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M857.601624,68.999084
	C858.015625,69.448189 858.016296,69.884109 858.014099,70.646591
	C855.168762,72.537888 852.350098,74.380692 849.065552,71.363541
	C851.719543,70.323555 854.453918,69.654732 857.601624,68.999084
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M837.144470,70.876389
	C839.906250,69.588440 843.081055,68.353020 846.647705,67.181702
	C843.878906,68.473495 840.718201,69.701202 837.144470,70.876389
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M891.827271,60.832260
	C888.954224,62.006870 885.861877,62.910248 882.386475,63.742275
	C885.204956,62.634293 888.406494,61.597656 891.827271,60.832260
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M909.694214,57.176220
	C908.184448,57.980511 906.306824,58.752399 904.213379,59.258163
	C905.773804,58.375965 907.550110,57.759892 909.694214,57.176220
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M833.352661,72.972656
	C832.739868,72.740417 832.440735,72.506950 832.040405,71.997856
	C832.818359,71.291954 833.697571,70.861679 834.792419,70.636253
	C834.998352,71.304176 834.988586,71.767258 834.981445,72.607819
	C834.984070,72.985313 834.921936,72.969482 834.921936,72.969482
	C834.503357,72.970131 834.084839,72.970779 833.352661,72.972656
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M850.222046,67.286041
	C851.463684,66.441574 852.911438,65.832581 854.705627,65.284805
	C853.510803,66.071182 851.969482,66.796349 850.222046,67.286041
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M914.698914,56.150074
	C914.399719,56.440739 913.736145,56.672649 912.989624,56.660698
	C913.382629,56.308331 913.858582,56.199829 914.698914,56.150074
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M893.005310,57.828003
	C893.262024,57.265335 893.846741,56.744862 894.742676,56.284355
	C894.480347,56.852947 893.906860,57.361572 893.005310,57.828003
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M918.748169,55.125816
	C918.484192,55.600178 917.915710,56.043499 917.180298,56.270042
	C917.490112,55.733768 917.966858,55.414272 918.748169,55.125816
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M936.742065,51.167133
	C936.496399,51.747608 935.933289,52.302921 935.031982,52.806831
	C935.270691,52.217609 935.847595,51.679790 936.742065,51.167133
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M906.194824,54.298065
	C906.505249,53.786858 906.980835,53.480167 907.754272,53.233742
	C907.488159,53.696861 906.924133,54.099716 906.194824,54.298065
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M897.754517,60.131386
	C897.477539,60.596012 896.899353,61.021549 896.160156,61.221413
	C896.483826,60.694592 896.968506,60.393440 897.754517,60.131386
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M866.049805,63.848671
	C866.355408,63.363495 867.005188,62.921345 867.845764,62.673981
	C867.489014,63.209743 866.941467,63.550716 866.049805,63.848671
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M861.097229,64.885681
	C861.395508,64.418800 862.023010,63.985416 862.830688,63.756470
	C862.482727,64.280334 861.954590,64.599747 861.097229,64.885681
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M884.009155,59.827251
	C884.262207,59.260162 884.845032,58.735222 885.739136,58.263153
	C885.479858,58.833820 884.909424,59.351608 884.009155,59.827251
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M879.031738,60.839699
	C879.344238,60.368061 879.997009,59.945499 880.835938,59.720676
	C880.471985,60.241871 879.921997,60.565323 879.031738,60.839699
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M875.035034,61.841087
	C875.346863,61.368752 875.998962,60.942959 876.837097,60.716316
	C876.473816,61.239521 875.924561,61.563576 875.035034,61.841087
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M867.836426,65.781296
	C867.529236,66.305252 867.056091,66.604919 866.288330,66.892288
	C866.552734,66.438995 867.111572,65.998009 867.836426,65.781296
z"/>
<path fill="#3A6995" opacity="1.000000" stroke="none"
	d="
M834.976807,72.954124
	C835.092896,73.083206 835.216187,73.243477 835.339417,73.403755
	C835.248169,73.352585 835.156982,73.301407 834.993835,73.109856
	C834.921936,72.969482 834.984070,72.985313 834.976807,72.954124
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M945.996826,213.634247
	C944.898376,213.686371 943.794312,213.376678 942.345093,213.033493
	C942.710327,212.115860 943.420593,211.231705 944.130920,210.347565
	C944.750977,211.322525 945.371094,212.297485 945.996826,213.634247
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M942.040100,217.739777
	C942.779541,217.822174 943.519043,217.904572 944.630981,217.978729
	C945.063110,218.373154 945.122742,218.775818 945.246704,219.475616
	C943.703979,219.992294 942.096924,220.211838 939.758667,220.718140
	C934.393188,220.985336 929.758789,220.965744 925.088806,220.568604
	C925.038574,219.684662 925.023926,219.178299 925.340454,218.439255
	C931.127808,218.050980 936.583923,217.895370 942.040100,217.739777
z"/>
<path fill="#4D85AD" opacity="1.000000" stroke="none"
	d="
M776.997559,71.999954
	C777.442017,72.000191 777.886475,72.000427 778.667847,72.330666
	C779.009705,73.101089 779.014587,73.541512 778.596069,73.988388
	C776.763000,74.010956 775.353455,74.027084 773.491821,74.038322
	C769.932373,74.114639 766.825012,74.195854 763.283875,74.238785
	C756.908264,73.790810 750.933044,73.651711 745.031067,72.920891
	C727.022949,70.691002 709.043152,68.233223 691.052307,65.864136
	C690.763611,65.408951 690.474854,64.953773 690.103149,63.925304
	C690.025146,62.908760 690.030151,62.465511 690.035217,62.022251
	C690.813477,61.706314 691.591797,61.390388 692.926880,61.301399
	C694.670410,61.628944 695.856995,61.729553 697.043640,61.830162
	C698.096008,61.897972 699.148315,61.965786 700.775940,62.267727
	C701.919189,62.595573 702.487183,62.689297 703.055176,62.783020
	C704.750183,62.867332 706.445190,62.951645 708.783875,63.278580
	C710.633057,63.406403 711.838562,63.291607 713.044067,63.176811
	C713.717590,63.181290 714.391174,63.185768 715.558533,63.530426
	C717.712708,64.207886 719.373108,64.545174 721.033447,64.882462
	C724.084961,65.229645 727.136414,65.576828 730.834351,66.227509
	C732.669800,66.626175 733.858948,66.721336 735.048035,66.816498
	C738.089844,67.204788 741.131592,67.593079 744.841736,68.264801
	C752.314636,69.658981 759.119202,70.769714 766.203613,72.188644
	C769.988159,72.331215 773.492859,72.165588 776.997559,71.999954
z"/>
<path fill="#82C2E8" opacity="1.000000" stroke="none"
	d="
M691.043091,66.257614
	C709.043152,68.233223 727.022949,70.691002 745.031067,72.920891
	C750.933044,73.651711 756.908264,73.790810 763.248291,74.605057
	C758.377686,75.446884 753.108948,75.884155 747.384399,76.280472
	C736.958435,76.120949 726.988281,76.002380 716.921997,75.520081
	C714.216370,75.110260 711.606873,75.064186 708.664978,75.019196
	C707.554077,75.318436 706.775635,75.616585 705.598145,75.921562
	C704.135376,75.936661 703.071472,75.944939 702.010620,75.629318
	C702.008240,74.873238 702.002869,74.441040 701.997559,74.008850
	C700.879211,72.988937 699.875732,71.788933 698.618164,70.987434
	C696.165222,69.424095 693.570129,68.083763 691.043091,66.257614
z"/>
<path fill="#487CA7" opacity="1.000000" stroke="none"
	d="
M702.007568,75.953209
	C703.071472,75.944939 704.135376,75.936661 705.770569,76.180527
	C707.225769,76.301773 708.109558,76.170868 709.438721,76.037003
	C712.262085,75.983963 714.640076,75.933891 717.018127,75.883820
	C726.988281,76.002380 736.958435,76.120949 747.553223,76.624603
	C753.447144,77.346542 758.716431,77.683395 763.989685,78.388031
	C763.965332,79.717926 763.937073,80.680031 763.457642,81.706070
	C754.029114,81.785416 745.051636,81.800835 736.074219,81.816246
	C724.746704,81.192772 713.419189,80.569305 701.605957,79.572205
	C701.416016,78.116783 701.711792,77.034988 702.007568,75.953209
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M774.650513,153.225159
	C774.376526,153.127731 774.151001,152.963699 773.941772,152.105240
	C773.912842,150.989197 773.989990,150.488235 773.908386,150.014664
	C772.651794,142.727203 772.649536,142.750778 779.838684,141.948914
	C781.277222,141.788467 782.688232,141.381546 784.031982,141.407028
	C782.937683,142.698288 781.923218,143.670792 780.538330,144.697769
	C778.918091,145.463196 777.668274,146.174149 776.418396,146.885132
	C777.259827,147.679642 778.101257,148.474167 779.013794,149.563248
	C780.075378,150.572067 781.065979,151.286316 782.039001,152.353134
	C782.669128,153.502731 783.316772,154.299774 783.968567,155.470459
	C783.649597,157.534973 783.326416,159.225861 782.978760,161.292740
	C782.890442,162.413208 782.826660,163.157654 782.414978,164.021881
	C781.688354,167.432465 781.309631,170.723282 780.938660,174.416016
	C780.989380,175.889511 781.032349,176.961105 781.015991,177.992645
	C780.956665,177.952606 780.821228,177.906479 780.500488,177.997879
	C780.143982,179.398041 780.108337,180.706802 780.063721,182.381897
	C779.980652,183.476776 779.906494,184.205338 779.529297,184.997925
	C779.136414,186.041962 779.046448,187.021957 778.956421,188.363434
	C778.902405,189.444962 778.848511,190.164993 778.482544,190.981888
	C778.078918,192.387772 777.987427,193.696793 777.911255,195.381668
	C777.840698,196.503448 777.754822,197.249374 777.318848,198.085846
	C776.670898,199.804962 776.372986,201.433563 776.064819,203.494934
	C775.294678,210.912735 774.534729,217.897751 773.469055,224.908798
	C772.753113,224.971664 772.342834,225.008484 771.658203,224.772919
	C771.442932,221.191345 771.502136,217.882187 771.609558,214.268829
	C771.679810,213.340698 771.701843,212.716736 772.042908,211.856903
	C772.590820,208.079987 772.819641,204.538940 773.040527,200.675354
	C773.104675,199.929977 773.176880,199.507126 773.594116,198.973892
	C774.325562,195.236557 774.711975,191.609604 775.081238,187.665649
	C775.125610,186.930298 775.187073,186.511963 775.605957,185.953293
	C776.137878,184.052475 776.312378,182.291992 776.548828,180.234100
	C776.611877,179.325226 776.613037,178.713791 776.954224,177.871689
	C777.766602,173.641357 778.238953,169.641678 778.701477,165.408539
	C778.699463,164.863174 778.726562,164.552979 778.930176,163.965729
	C779.126038,162.805069 779.164612,161.923157 779.177002,160.661850
	C778.449463,158.824554 777.748169,157.366638 777.046875,155.908752
	C777.046875,155.908752 777.040833,155.471085 776.975464,154.903687
	C776.156860,153.965912 775.403687,153.595535 774.650513,153.225159
z"/>
<path fill="#4D85AD" opacity="1.000000" stroke="none"
	d="
M719.999207,91.987427
	C718.613220,91.979477 717.227234,91.971527 715.309021,91.674118
	C715.190735,89.944885 715.604675,88.505127 716.018616,87.065369
	C717.076233,87.035164 718.133911,87.004944 720.015259,86.980011
	C723.231140,86.669373 725.623413,86.353455 728.015625,86.037529
	C730.378174,86.027664 732.740784,86.017792 736.003540,86.018105
	C743.553711,85.611351 750.203613,85.194412 757.171997,84.813156
	C758.039978,84.313461 758.589600,83.778091 759.578735,83.206436
	C762.681396,83.116142 765.344543,83.062126 768.423462,83.016747
	C770.226990,83.017456 771.614746,83.009537 773.334229,83.036285
	C774.229248,83.452003 774.792480,83.833038 775.145325,84.071709
	C772.603760,85.068230 770.287415,85.976425 767.526489,86.913559
	C764.020386,87.548599 760.958923,88.154709 757.438477,88.797646
	C746.332642,89.609840 735.685791,90.385201 724.652466,91.108627
	C722.843750,91.366943 721.421448,91.677185 719.999207,91.987427
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M767.046631,233.070435
	C749.502869,233.032043 731.958069,233.072906 714.416870,232.843201
	C712.482239,232.817856 709.519897,231.676422 708.938232,230.266953
	C708.354431,228.852219 710.153015,226.454407 711.181030,224.227112
	C713.388733,224.326950 715.378845,224.513031 717.236450,225.110916
	C718.400696,225.485641 719.743652,226.280502 720.267822,227.275833
	C720.549194,227.810226 719.269958,229.166351 718.473450,230.531219
	C731.650269,230.531219 744.781006,230.531219 757.530762,230.531219
	C758.946167,228.675156 760.309937,226.886765 761.673706,225.098358
	C762.845886,226.214417 764.018066,227.330475 765.633179,228.868240
	C766.295044,228.115082 767.154480,227.137131 768.407715,226.439194
	C768.574158,228.499893 768.346802,230.280579 767.898804,232.181305
	C767.467651,232.557709 767.257141,232.814072 767.046631,233.070435
z"/>
<path fill="#82C2E8" opacity="1.000000" stroke="none"
	d="
M725.039001,91.160553
	C735.685791,90.385201 746.332642,89.609840 757.816528,88.878082
	C759.793640,89.298523 760.933655,89.675354 761.765381,90.280136
	C753.357422,91.789474 745.257690,93.070854 736.841675,94.283783
	C735.962402,94.747787 735.399414,95.280243 734.532959,95.836517
	C733.825195,95.887726 733.420715,95.915115 732.794922,95.700203
	C730.716553,95.973137 728.859497,96.488388 727.002441,97.003647
	C726.416321,95.858681 725.830261,94.713707 725.123291,92.969841
	C725.014587,91.967491 725.026794,91.564018 725.039001,91.160553
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M771.134644,98.741516
	C763.456909,101.622406 755.796814,104.551773 748.092712,107.360344
	C744.998230,108.488434 742.784424,107.963676 743.601196,103.518257
	C751.986145,100.720993 759.949951,98.323090 768.337769,95.952637
	C770.166138,95.952202 771.570496,95.924309 772.980347,96.236183
	C772.965332,97.027748 772.944763,97.479546 772.664429,97.961273
	C771.981323,98.241302 771.557983,98.491402 771.134644,98.741516
z"/>
<path fill="#4D85AD" opacity="1.000000" stroke="none"
	d="
M771.070679,99.118988
	C771.557983,98.491402 771.981323,98.241302 773.045654,97.996231
	C776.114502,97.996452 778.542236,97.991631 780.977173,98.334984
	C780.995911,99.147987 781.007507,99.612823 780.992920,100.371155
	C780.880554,101.046547 780.794312,101.428436 780.708130,101.810333
	C774.454834,104.655525 768.228455,107.562622 761.932129,110.309090
	C759.978577,111.161209 757.834900,111.577400 755.778259,112.193176
	C755.410156,111.567680 755.041992,110.942184 754.673889,110.316689
	C756.219788,109.005394 757.641418,107.498215 759.336853,106.422592
	C763.154785,104.000381 767.108398,101.791924 771.070679,99.118988
z"/>
<path fill="#83C8ED" opacity="1.000000" stroke="none"
	d="
M767.913757,95.925186
	C759.949951,98.323090 751.986145,100.720993 743.645325,103.132874
	C739.838867,103.547424 736.415405,104.039330 732.974487,104.264198
	C732.356628,104.304573 731.666748,103.243156 731.383545,102.319916
	C733.489502,101.251160 735.222107,100.552948 737.360962,99.870224
	C747.834656,97.621788 757.902039,95.357864 767.983337,93.447968
	C767.969421,94.509720 767.941589,95.217453 767.913757,95.925186
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M768.007629,83.008118
	C765.344543,83.062126 762.681396,83.116142 759.259521,83.165840
	C757.951721,83.700180 757.402649,84.238831 756.853516,84.777473
	C750.203613,85.194412 743.553711,85.611351 736.445923,85.999741
	C736.002380,84.866280 736.016724,83.761360 736.052612,82.236343
	C745.051636,81.800835 754.029114,81.785416 763.861694,81.813461
	C765.817871,81.881554 766.918884,81.906204 768.014343,82.200142
	C768.008423,82.648987 768.008057,82.828552 768.007629,83.008118
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M765.923767,71.880447
	C759.119202,70.769714 752.314636,69.658981 745.251709,68.274155
	C745.940613,67.281624 746.887878,66.563179 747.872559,65.544510
	C753.691956,66.409248 759.473938,67.574226 765.622559,69.234070
	C765.967407,70.446106 765.945557,71.163277 765.923767,71.880447
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M791.582947,102.595306
	C791.716614,113.080513 791.850281,123.565712 791.984375,134.518616
	C791.984741,134.986313 791.963928,134.974136 791.691711,135.097885
	C790.862122,135.419891 790.304688,135.618134 789.797607,135.500168
	C789.875732,133.785400 789.903564,132.386841 789.931335,130.988297
	C789.980408,121.975487 790.029480,112.962677 790.325317,103.450439
	C790.908997,102.832443 791.245972,102.713875 791.582947,102.595306
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M778.772949,164.244461
	C778.726562,164.552979 778.699463,164.863174 778.379883,165.596573
	C777.384216,168.345749 776.700378,170.673431 776.016602,173.001099
	C775.507263,170.976410 774.998047,168.951736 774.459717,166.811554
	C769.470764,164.653366 769.023254,163.528214 772.131226,156.849091
	C772.752136,158.456223 773.747192,160.028244 773.902161,161.679108
	C774.111023,163.904510 774.309570,165.402695 777.634521,164.111267
	C778.425598,164.154434 778.599304,164.199448 778.772949,164.244461
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M784.111938,141.088287
	C782.688232,141.381546 781.277222,141.788467 779.838684,141.948914
	C772.649536,142.750778 772.651794,142.727203 773.908386,150.014664
	C773.989990,150.488235 773.912842,150.989197 773.838440,151.920837
	C773.223450,152.076614 772.679504,151.788971 771.987976,150.980194
	C771.575989,149.967285 771.311646,149.475525 771.047302,148.983765
	C771.217041,146.558746 771.386780,144.133728 772.160828,141.350922
	C774.851440,140.458618 776.937805,139.924088 779.024109,139.389557
	C780.086304,139.303665 781.148560,139.217773 782.937256,139.058868
	C784.112244,138.987579 784.560669,138.989319 785.253235,139.158386
	C785.638184,139.887650 785.778992,140.449570 785.617676,141.021194
	C784.914429,141.050034 784.513184,141.069153 784.111938,141.088287
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M791.620361,102.264084
	C791.245972,102.713875 790.908997,102.832443 790.304077,102.983078
	C787.968811,102.030281 785.901489,101.045418 783.438171,100.051208
	C783.042175,100.041862 782.990295,99.987137 783.153076,99.685432
	C786.860535,97.569626 790.405212,95.755524 793.986267,93.980865
	C794.022644,94.020317 794.096191,94.096809 794.099121,94.432457
	C794.439758,95.608345 794.777527,96.448586 795.115234,97.288834
	C794.992737,97.598495 794.784729,97.832031 793.961914,98.065796
	C792.913940,98.736839 792.395386,99.331535 791.876953,99.926239
	C791.803894,100.595123 791.730835,101.264000 791.620361,102.264084
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M779.049927,139.019516
	C776.937805,139.924088 774.851440,140.458618 772.393250,141.044525
	C773.482117,138.854019 774.656250,136.319885 776.521545,134.490433
	C777.491089,133.539551 779.681458,133.833405 781.320312,133.564987
	C781.466553,133.991302 781.612793,134.417618 781.759033,134.843933
	C780.864624,136.112442 779.970154,137.380951 779.049927,139.019516
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M768.119385,232.061264
	C768.346802,230.280579 768.574158,228.499893 768.733154,226.340195
	C768.792908,224.586243 768.921082,223.211319 769.282593,221.197937
	C769.565491,219.693634 769.615051,218.827759 769.664673,217.961899
	C769.786926,217.227539 769.909180,216.493179 770.295837,215.348221
	C770.893921,214.816071 771.227600,214.694534 771.561340,214.572998
	C771.502136,217.882187 771.442932,221.191345 771.668335,225.007339
	C771.952881,225.514160 771.973389,225.984070 771.970032,226.238464
	C771.972229,226.662399 771.977844,226.831924 771.990601,227.001160
	C771.997864,227.000885 771.995728,226.983261 771.635620,227.044830
	C770.223450,228.758011 769.171448,230.409637 768.119385,232.061264
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M736.954651,99.854721
	C735.222107,100.552948 733.489502,101.251160 731.376038,101.956993
	C728.019592,102.140717 726.773315,100.666382 727.003113,97.393143
	C728.859497,96.488388 730.716553,95.973137 732.581299,95.975647
	C731.437073,97.239815 730.285095,97.986221 729.133118,98.732628
	C729.293457,99.106659 729.453735,99.480682 729.614075,99.854713
	C732.060913,99.854713 734.507812,99.854713 736.954651,99.854721
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M775.098328,187.982651
	C774.711975,191.609604 774.325562,195.236557 773.504333,198.593628
	C773.032471,197.546768 772.995361,196.769791 772.958313,195.992798
	C773.063538,193.745483 773.168701,191.498169 773.556519,188.727020
	C774.258850,188.129669 774.678589,188.056152 775.098328,187.982651
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M776.030701,173.427063
	C776.700378,170.673431 777.384216,168.345749 778.389648,165.830048
	C778.238953,169.641678 777.766602,173.641357 776.695007,177.869202
	C775.921692,178.085464 775.747742,178.073532 775.573730,178.061615
	C775.730774,176.658752 775.887756,175.255905 776.030701,173.427063
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M773.048462,200.997894
	C772.819641,204.538940 772.590820,208.079987 771.792603,211.847839
	C771.055725,212.065979 770.888062,212.057312 770.720337,212.048630
	C770.840698,210.974808 770.961121,209.900986 771.314697,208.145126
	C771.623596,205.965866 771.699341,204.468658 771.775146,202.971436
	C771.842346,202.530792 771.909485,202.090149 772.239868,201.319489
	C772.684937,200.992279 772.866699,200.995087 773.048462,200.997894
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M789.580322,131.034454
	C789.903564,132.386841 789.875732,133.785400 789.498779,135.599335
	C788.193848,136.457184 787.238098,136.899628 786.196655,137.239838
	C786.110840,137.137589 785.937500,136.934616 785.937500,136.934601
	C787.034790,134.983261 788.132080,133.031937 789.580322,131.034454
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M715.821289,86.806412
	C715.604675,88.505127 715.190735,89.944885 714.893250,91.673019
	C714.037354,91.496925 713.065063,91.032448 712.092651,90.567947
	C713.269775,89.227776 714.446838,87.887619 715.821289,86.806412
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M727.747070,85.747040
	C725.623413,86.353455 723.231140,86.669373 720.410156,86.941544
	C722.480469,86.417366 724.979492,85.936951 727.747070,85.747040
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M702.010620,75.629318
	C701.711792,77.034988 701.416016,78.116783 701.151367,79.550446
	C697.230713,77.917137 698.513855,75.999985 701.627686,74.055328
	C702.002869,74.441040 702.008240,74.873238 702.010620,75.629318
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M717.036865,58.520157
	C718.811584,58.620655 720.670898,59.044563 722.769836,59.728882
	C721.046753,59.607384 719.084106,59.225475 717.036865,58.520157
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M724.652466,91.108627
	C725.026794,91.564018 725.014587,91.967491 724.995972,92.674469
	C723.491516,92.834160 721.993591,92.690331 720.247437,92.266960
	C721.421448,91.677185 722.843750,91.366943 724.652466,91.108627
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M775.081238,187.665649
	C774.678589,188.056152 774.258850,188.129669 773.538574,188.310501
	C773.536255,186.669220 773.834412,184.920609 774.560425,183.463837
	C775.075012,184.535004 775.161743,185.314316 775.248474,186.093628
	C775.187073,186.511963 775.125610,186.930298 775.081238,187.665649
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M775.605957,185.953293
	C775.161743,185.314316 775.075012,184.535004 774.931213,183.366547
	C774.931091,182.542175 774.987976,182.106979 775.291870,181.298340
	C775.854797,180.793762 776.170837,180.662628 776.486816,180.531509
	C776.312378,182.291992 776.137878,184.052475 775.605957,185.953293
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M720.936340,64.520920
	C719.373108,64.545174 717.712708,64.207886 715.895447,63.534603
	C717.438782,63.518864 719.138977,63.839127 720.936340,64.520920
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M771.445557,203.062042
	C771.699341,204.468658 771.623596,205.965866 771.300964,207.738739
	C771.074768,206.393814 771.095398,204.773239 771.445557,203.062042
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M773.040466,200.675354
	C772.866699,200.995087 772.684937,200.992279 772.230286,200.984711
	C772.059265,199.363449 772.161072,197.746933 772.610596,196.061615
	C772.995361,196.769791 773.032471,197.546768 773.159302,198.704010
	C773.176880,199.507126 773.104675,199.929977 773.040466,200.675354
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M770.422241,212.092682
	C770.888062,212.057312 771.055725,212.065979 771.473633,212.083710
	C771.701843,212.716736 771.679810,213.340698 771.609558,214.268829
	C771.227600,214.694534 770.893921,214.816071 770.294617,214.974884
	C770.060791,214.053696 770.092529,213.095215 770.422241,212.092682
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M777.026001,156.308167
	C777.748169,157.366638 778.449463,158.824554 778.894836,160.656342
	C778.451477,161.027130 778.264099,161.024048 778.076660,161.020950
	C777.719482,159.583160 777.362305,158.145386 777.026001,156.308167
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M776.548828,180.234100
	C776.170837,180.662628 775.854797,180.793762 775.283447,180.968658
	C775.022949,180.062805 775.017761,179.113190 775.293091,178.112610
	C775.747742,178.073532 775.921692,178.085464 776.354980,178.099854
	C776.613037,178.713791 776.611877,179.325226 776.548828,180.234100
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M712.847534,62.886986
	C711.838562,63.291607 710.633057,63.406403 709.208801,63.278633
	C710.210388,62.889774 711.430664,62.743469 712.847534,62.886986
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M696.963135,61.508965
	C695.856995,61.729553 694.670410,61.628944 693.241882,61.265335
	C694.294250,61.064152 695.588440,61.125961 696.963135,61.508965
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M734.964417,66.498039
	C733.858948,66.721336 732.669800,66.626175 731.238525,66.265732
	C732.291138,66.060158 733.585999,66.119873 734.964417,66.498039
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M712.021240,57.466377
	C712.827820,57.267040 713.699951,57.373489 714.789185,57.735008
	C714.033081,57.917439 713.059998,57.844807 712.021240,57.466377
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M695.044006,53.483604
	C695.974915,53.479721 696.988647,53.818523 698.142212,54.470360
	C697.230347,54.464359 696.178528,54.145321 695.044006,53.483604
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M703.034912,55.381241
	C703.848267,55.191456 704.716431,55.319519 705.799194,55.703457
	C705.039062,55.872581 704.064392,55.785835 703.034912,55.381241
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M769.375854,218.039703
	C769.615051,218.827759 769.565491,219.693634 769.270996,220.783310
	C769.046326,220.043915 769.066711,219.080704 769.375854,218.039703
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M785.009094,138.991058
	C784.560669,138.989319 784.112244,138.987579 783.327454,138.969360
	C783.744690,138.298401 784.498291,137.643921 785.594727,136.962036
	C785.937500,136.934616 786.110840,137.137589 786.044556,137.450928
	C785.655212,138.173172 785.332153,138.582108 785.009094,138.991058
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M778.064575,161.400879
	C778.264099,161.024048 778.451477,161.027130 778.921021,161.035736
	C779.164612,161.923157 779.126038,162.805069 778.930176,163.965729
	C778.599304,164.199448 778.425598,164.154434 777.983582,164.070724
	C777.827576,163.281616 777.940002,162.531204 778.064575,161.400879
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M770.818604,149.137360
	C771.311646,149.475525 771.575989,149.967285 771.779907,150.748138
	C771.342957,150.455139 770.966431,149.873047 770.818604,149.137360
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M774.769775,153.522675
	C775.403687,153.595535 776.156860,153.965912 776.947266,154.686646
	C776.286011,154.631409 775.587524,154.225800 774.769775,153.522675
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M781.052612,101.840096
	C780.794312,101.428436 780.880554,101.046547 781.320801,100.344475
	C782.113281,100.011909 782.551758,99.999519 782.990295,99.987137
	C782.990295,99.987137 783.042175,100.041862 783.069458,100.069504
	C782.530273,100.688049 781.963745,101.278954 781.052612,101.840096
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M703.000732,62.513325
	C702.487183,62.689297 701.919189,62.595573 701.171875,62.264141
	C701.643738,62.098831 702.294983,62.171230 703.000732,62.513325
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M710.256348,219.555359
	C709.615784,219.517609 708.874146,219.191254 708.052612,218.552521
	C708.147217,218.174515 708.321838,218.108871 708.761230,217.950684
	C709.402405,218.327682 709.778870,218.797211 710.256348,219.555359
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M689.735413,62.048290
	C690.030151,62.465511 690.025146,62.908760 689.983887,63.682995
	C689.445740,63.764267 688.943848,63.514561 688.441895,63.264854
	C688.773132,62.868011 689.104370,62.471169 689.735413,62.048290
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M725.026794,60.527344
	C725.646179,60.541031 726.347290,60.869202 727.182495,61.483009
	C726.580627,61.459705 725.844543,61.150764 725.026794,60.527344
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M783.153076,99.685425
	C782.551758,99.999519 782.113281,100.011909 781.346924,100.050972
	C781.007507,99.612823 780.995911,99.147987 781.140381,98.037781
	C783.204895,94.587303 785.113464,91.782188 787.015259,88.554504
	C786.708313,85.537056 785.570251,82.683632 786.275330,80.399017
	C787.942932,74.995285 785.512756,73.857727 780.673828,73.993202
	C779.901733,73.987953 779.460632,73.984947 779.019531,73.981934
	C779.014587,73.541512 779.009705,73.101089 779.001221,72.330353
	C779.317078,71.532578 779.636597,71.065125 780.351807,70.294861
	C781.244812,69.936882 781.742004,69.881714 782.239258,69.826538
	C782.624390,69.829430 783.009521,69.832321 783.869141,70.142220
	C784.990173,70.562927 785.636780,70.676628 786.283386,70.790321
	C786.658081,70.800667 787.032837,70.811005 787.883850,71.133316
	C789.022766,71.537773 789.685364,71.630264 790.347961,71.722755
	C790.717834,71.749542 791.087708,71.776329 791.613708,72.196342
	C792.379272,73.839264 793.020203,75.074791 793.589783,76.342392
	C794.255798,77.824379 795.512390,79.405891 795.357544,80.817581
	C795.010559,83.982635 793.824585,87.049438 793.318481,90.210419
	C793.246887,90.657402 795.070496,91.407806 795.858032,92.256165
	C795.116150,92.976845 794.533020,93.459137 793.949890,93.941422
	C790.405212,95.755524 786.860535,97.569626 783.153076,99.685425
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M766.203613,72.188652
	C765.945557,71.163277 765.967407,70.446106 765.985779,69.368790
	C769.492737,69.823143 773.003052,70.637634 776.755493,71.726044
	C773.492859,72.165588 769.988159,72.331215 766.203613,72.188652
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M750.189209,61.321518
	C754.610413,62.036076 759.221375,63.066193 763.937378,64.439705
	C759.487976,63.734428 754.933472,62.685753 750.189209,61.321518
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M722.842041,54.491180
	C723.442688,54.531750 724.168640,54.861893 724.967896,55.507698
	C724.349854,55.475822 723.658569,55.128284 722.842041,54.491180
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M731.829956,56.501656
	C732.435608,56.548862 733.165588,56.887596 733.963989,57.548912
	C733.339783,57.512062 732.647034,57.152626 731.829956,56.501656
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M739.846313,58.485756
	C740.444641,58.504192 741.166260,58.812943 741.971008,59.424675
	C741.359314,59.410465 740.664429,59.093269 739.846313,58.485756
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M782.132568,69.530067
	C781.742004,69.881714 781.244812,69.936882 780.373779,69.997955
	C779.993408,69.598824 779.986877,69.193794 779.973267,68.488342
	C780.652832,68.536476 781.339355,68.885033 782.132568,69.530067
z"/>
<path fill="#366189" opacity="1.000000" stroke="none"
	d="
M796.016907,92.017761
	C795.070496,91.407806 793.246887,90.657402 793.318481,90.210419
	C793.824585,87.049438 795.010559,83.982635 795.357544,80.817581
	C795.512390,79.405891 794.255798,77.824379 793.589783,76.342392
	C793.020203,75.074791 792.379272,73.839264 791.880859,72.275581
	C792.438721,71.954453 792.885498,71.947304 793.705444,72.332146
	C796.776428,75.497360 799.306946,76.766708 801.159180,71.936691
	C801.717712,72.443100 802.803711,73.008118 802.754883,73.447006
	C802.124878,79.114838 801.333313,84.764755 800.008545,90.596214
	C798.612732,91.141197 797.791016,91.509163 796.733276,91.926361
	C796.497253,91.975594 796.016907,92.017761 796.016907,92.017761
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M801.000977,71.719437
	C799.306946,76.766708 796.776428,75.497360 794.039307,72.363678
	C795.745178,71.774384 797.490417,71.545547 799.575928,71.152107
	C800.225037,71.159065 800.533936,71.330635 801.000977,71.719437
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M829.768433,71.701859
	C827.594116,72.630013 825.181458,73.313591 822.357178,73.991180
	C822.105774,73.424896 822.266113,72.864609 822.681824,72.154892
	C825.134827,71.822731 827.332520,71.639999 829.768433,71.701859
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M786.180054,70.527695
	C785.636780,70.676628 784.990173,70.562927 784.157227,70.163910
	C784.672852,70.007416 785.374756,70.136246 786.180054,70.527695
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M790.230103,71.470528
	C789.685364,71.630264 789.022766,71.537773 788.164001,71.157928
	C788.682678,70.986473 789.397461,71.102386 790.230103,71.470528
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M837.026978,256.772614
	C831.598694,256.547150 826.399841,256.219147 820.780151,255.807617
	C820.212219,248.524902 820.065247,241.325699 819.916321,233.610870
	C819.914368,233.095230 820.021973,232.977982 820.422607,232.994659
	C821.881653,234.537262 823.599060,235.955002 823.870728,237.610062
	C824.589355,241.987488 824.657898,246.469711 825.032471,250.906250
	C825.258301,253.580811 826.484741,255.533554 829.441162,254.901978
	C830.942383,254.581299 833.374695,253.344406 833.422791,252.419662
	C833.617920,248.666077 833.252441,244.844360 832.719604,241.101044
	C831.933167,235.576492 830.778503,230.105377 829.877930,224.595612
	C829.382751,221.566193 829.282410,218.463669 828.661438,215.465073
	C827.219238,208.501495 825.343933,201.621521 824.085754,194.628220
	C823.301514,190.269272 823.344971,185.763580 822.974854,181.327255
	C822.683594,177.835297 820.156006,177.019333 817.335693,177.158463
	C813.802673,177.332748 814.439880,179.895294 814.579102,182.165268
	C813.830078,182.116043 813.400269,182.102768 812.758911,181.801544
	C811.376770,181.366623 810.206177,181.219650 809.021606,180.722839
	C807.709045,175.282074 805.572388,181.446960 803.753418,179.997772
	C803.504395,179.995193 803.006409,179.991882 802.803711,179.740570
	C801.735596,179.992126 800.870239,180.495010 800.002197,181.464447
	C799.663879,187.617203 799.328308,193.303421 798.653809,199.028183
	C797.548218,200.045105 796.781433,201.023483 796.010864,202.467438
	C795.019104,210.677505 793.933350,218.411209 793.078552,226.170364
	C792.537231,231.084259 792.441162,236.046219 791.949463,240.967026
	C791.666321,243.800522 791.965210,247.337006 787.370605,247.023453
	C788.244812,240.624222 789.119080,234.224976 790.265625,227.133728
	C790.632080,224.277252 790.726135,222.112823 790.820190,219.948380
	C790.865967,219.516617 790.911743,219.084839 791.177856,218.191406
	C791.316833,217.139618 791.235413,216.549484 791.153931,215.959366
	C791.174683,215.588181 791.195374,215.216995 791.501587,214.436890
	C792.080505,213.328674 792.373901,212.629395 792.667358,211.930115
	C792.769287,209.905380 792.871155,207.880615 793.200317,205.249557
	C793.318848,203.751801 793.210144,202.860367 793.101440,201.968918
	C793.124634,201.585556 793.147827,201.202179 793.465210,200.417068
	C794.077271,199.320587 794.395142,198.625854 794.712952,197.931122
	C794.810364,196.561157 794.907837,195.191193 795.229675,193.224045
	C795.327698,191.743881 795.201294,190.860901 795.074890,189.977905
	C795.098816,188.325485 795.122742,186.673065 795.478271,184.481049
	C796.409973,181.602951 797.010132,179.264450 797.610229,176.925964
	C797.713074,176.503815 797.815857,176.081665 798.430664,175.318558
	C801.758179,174.964172 804.579834,175.065292 807.387573,174.911270
	C811.920166,174.662628 816.443481,174.246002 820.970764,173.900345
	C821.423340,173.924210 821.875977,173.948090 822.825073,174.215210
	C823.874146,174.646713 824.426758,174.834961 824.979309,175.023193
	C824.979309,175.023209 825.097778,175.483994 825.111206,176.114410
	C825.753845,180.313171 826.402466,183.878220 827.008606,187.450470
	C829.019897,199.303055 831.015869,211.158234 833.000000,223.439148
	C833.672424,228.893967 834.362549,233.922028 835.021973,239.372253
	C835.330444,241.869034 835.669678,243.943649 836.035278,246.361313
	C836.373596,247.803406 836.685547,248.902435 837.009399,250.379288
	C837.309021,252.472717 837.596741,254.188339 837.884521,255.903946
	C837.675171,256.159302 837.465759,256.414673 837.026978,256.772614
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M939.722656,229.432251
	C939.835388,231.005341 939.948059,232.578415 940.063232,234.915710
	C940.636597,237.525513 941.207520,239.371124 941.778442,241.216736
	C941.767944,241.603424 941.757446,241.990128 941.585815,242.871902
	C941.853394,244.035339 942.281982,244.703690 942.710571,245.372040
	C942.720032,246.302917 942.729553,247.233795 942.530884,248.780640
	C942.556763,250.602020 942.790771,251.807404 943.024841,253.012802
	C942.287598,254.508347 941.550354,256.003906 940.813110,257.499451
	C939.679688,256.856567 938.546265,256.213715 937.258057,254.841309
	C936.419617,249.064270 935.237061,244.019653 935.208130,238.968430
	C935.184326,234.811798 933.553650,233.356979 929.831421,233.030273
	C925.632629,232.661713 923.707031,234.910034 923.083618,238.656311
	C922.623535,241.421021 922.368469,244.219833 921.741455,247.287109
	C921.313232,250.072266 921.165710,252.573746 921.018127,255.075241
	C919.524536,257.129761 918.011780,259.108582 915.248291,255.843323
	C916.394348,247.756866 917.634583,240.335876 918.932495,232.587936
	C919.371033,231.232101 919.752014,230.203232 920.586853,229.130386
	C926.696777,229.047180 932.352844,229.007965 938.297363,229.038116
	C938.964722,229.215759 939.343689,229.324005 939.722656,229.432251
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M870.987915,256.014099
	C869.978210,256.030273 868.968445,256.046417 867.516235,255.628326
	C867.069885,252.789261 867.066040,250.384491 867.310425,247.759735
	C866.700195,246.686539 865.841614,245.833328 864.987793,244.583435
	C865.327820,240.395691 863.058411,239.737518 859.994019,239.633362
	C859.985168,238.171402 859.978455,237.108841 860.188049,235.926666
	C860.684753,235.609451 860.873230,235.346008 861.367004,235.013702
	C862.824280,235.006958 863.884094,235.003235 865.153442,235.275940
	C869.136047,239.581467 872.545471,236.490051 876.406006,235.010803
	C877.513000,235.021820 878.250977,235.029190 879.192200,235.282349
	C880.593689,236.360870 881.791992,237.193604 882.953064,238.368805
	C881.672913,239.167084 880.283508,240.231537 879.212219,239.973755
	C874.484680,238.836212 873.009766,240.126068 873.616943,245.042740
	C868.949524,248.013550 871.899170,252.410187 870.987915,256.014099
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M922.022034,247.003448
	C922.368469,244.219833 922.623535,241.421021 923.083618,238.656311
	C923.707031,234.910034 925.632629,232.661713 929.831421,233.030273
	C933.553650,233.356979 935.184326,234.811798 935.208130,238.968430
	C935.237061,244.019653 936.419617,249.064270 937.085876,254.559601
	C937.068604,255.007431 936.584839,255.041824 936.010742,255.024597
	C934.998047,254.989868 934.559387,254.972382 934.057129,254.596039
	C933.357483,252.484085 932.721558,250.730972 932.083252,248.552002
	C932.071472,246.423508 932.062012,244.720840 932.392456,242.948334
	C934.610352,241.145081 934.770996,239.772263 931.719727,238.766418
	C927.787537,235.802200 926.565979,238.058090 926.087891,241.358475
	C925.623413,244.564392 925.377625,247.801971 924.692017,250.962143
	C923.572815,249.600250 922.797424,248.301834 922.022034,247.003448
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M845.991028,256.998535
	C844.885742,256.759888 843.780457,256.521210 842.373840,255.716644
	C842.047180,254.103485 842.021790,253.056244 842.244507,251.813629
	C842.060425,250.724091 841.628296,249.829910 841.144104,248.561310
	C840.835876,246.481644 840.579773,244.776413 840.615845,242.983673
	C840.642212,241.916626 840.376465,240.937073 840.079468,239.632568
	C840.029541,238.872849 840.010742,238.438110 840.242920,237.808105
	C840.036255,236.730331 839.578552,235.847824 839.072754,234.609360
	C838.818115,232.862137 838.611572,231.470886 838.689148,229.982300
	C838.703674,228.905884 838.434021,227.926804 838.092712,226.719620
	C838.021057,226.491516 837.875183,226.036102 837.932129,225.699921
	C838.009155,224.910477 838.029358,224.457214 838.298584,224.007950
	C838.547546,224.011932 839.045410,223.998672 839.431885,224.055359
	C840.522156,224.937027 841.711304,225.686569 841.853088,226.598907
	C843.013794,234.069199 844.070618,241.559052 844.957642,249.066742
	C845.293030,251.904968 845.969666,253.592758 849.284180,252.422684
	C850.343201,252.048843 851.561707,252.126602 852.865417,252.204132
	C853.271057,252.646851 853.518433,252.883163 853.779541,253.478622
	C853.772522,254.778824 853.751831,255.719879 853.731140,256.660919
	C852.417297,256.781433 851.103516,256.901978 849.346558,256.646729
	C847.932617,256.513519 846.961792,256.756012 845.991028,256.998535
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M867.062256,247.979706
	C867.066040,250.384491 867.069885,252.789261 867.137878,255.645386
	C865.439941,256.686157 863.677856,257.275574 861.449463,257.536163
	C860.055420,256.411621 859.127563,255.615891 858.172485,254.468964
	C858.101135,253.414581 858.056946,252.711411 858.238159,251.854706
	C858.260437,251.133728 858.057312,250.566284 857.856812,249.672943
	C857.816040,248.914917 857.772644,248.482803 858.068359,247.921906
	C859.293213,247.471497 860.178833,247.149887 861.376831,246.864578
	C862.107727,246.882294 862.526428,246.863708 863.302734,246.897095
	C864.794373,247.292603 865.928284,247.636154 867.062256,247.979706
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M925.124390,220.946152
	C929.758789,220.965744 934.393188,220.985336 939.486816,221.004395
	C939.695435,222.454025 939.444824,223.904144 938.609131,225.582977
	C931.708557,225.558746 925.392883,225.305786 918.918457,224.739624
	C919.073059,219.959549 923.044922,222.183243 925.124390,220.946152
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M898.002014,255.970673
	C894.344971,259.552795 890.456604,258.376465 886.300232,255.777374
	C886.079895,251.696548 886.094971,248.366547 886.411865,244.887573
	C888.493591,245.453583 890.273376,246.168518 891.651489,246.937973
	C886.499390,247.653046 887.752441,251.377563 888.436218,253.854919
	C888.740662,254.958038 891.861145,255.918304 893.654053,255.837982
	C896.917480,255.691772 897.043091,250.524246 894.016296,246.507355
	C895.368286,245.808212 896.630920,245.449066 897.916992,245.540695
	C897.960876,249.317871 897.981445,252.644272 898.002014,255.970673
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M918.874878,232.914902
	C917.634583,240.335876 916.394348,247.756866 915.083191,255.549500
	C914.261108,255.942627 913.509888,255.964081 912.347046,255.702484
	C911.904480,255.237656 911.873535,255.055908 911.875244,254.508484
	C911.926392,251.426071 911.944946,248.709366 912.233032,245.876160
	C912.996094,245.170166 913.489624,244.580673 914.359131,243.917023
	C915.153442,241.906952 915.571838,239.971024 916.029907,237.677551
	C917.004700,235.851639 917.939758,234.383270 918.874878,232.914902
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M876.986145,257.099976
	C876.247375,257.071930 875.508667,257.043915 874.346558,256.581390
	C873.949341,253.480667 873.303650,250.521851 874.283813,248.271088
	C874.776672,247.139481 878.224121,247.294617 880.740234,246.786026
	C880.925781,250.540710 881.063416,253.325272 881.200989,256.109833
	C881.200989,256.109833 881.160889,256.173309 880.749939,256.121094
	C879.221375,256.412598 878.103760,256.756287 876.986145,257.099976
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M881.500977,256.111084
	C881.063416,253.325272 880.925781,250.540710 880.740234,246.786026
	C878.224121,247.294617 874.776672,247.139481 874.283813,248.271088
	C873.303650,250.521851 873.949341,253.480667 873.979126,256.539978
	C873.215027,256.721802 872.395020,256.510559 871.281494,256.156677
	C871.899170,252.410187 868.949524,248.013550 874.046021,245.056396
	C877.552612,245.348969 880.241699,245.686234 882.935181,246.475372
	C882.957397,249.931335 882.975220,252.935455 882.993042,255.939575
	C882.595642,255.997162 882.198303,256.054749 881.500977,256.111084
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M932.052612,243.018188
	C932.062012,244.720840 932.071472,246.423508 931.794922,248.778839
	C931.706543,251.691833 931.904175,253.952148 932.101807,256.212463
	C930.651306,256.249786 929.200745,256.287109 927.360474,255.823517
	C927.562439,250.496063 928.154114,245.669540 928.769836,240.647430
	C930.048645,241.258316 930.902527,241.666229 931.830078,242.310242
	C931.903809,242.546371 932.052612,243.018188 932.052612,243.018188
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M931.756409,242.074127
	C930.902527,241.666229 930.048645,241.258316 928.769836,240.647430
	C928.154114,245.669540 927.562439,250.496063 926.927734,255.770477
	C926.300598,256.021301 925.716309,255.824265 925.018494,254.973282
	C924.948547,253.221436 924.992188,252.123535 925.035889,251.025635
	C925.377625,247.801971 925.623413,244.564392 926.087891,241.358475
	C926.565979,238.058090 927.787537,235.802200 931.726685,239.147659
	C931.877747,240.553574 931.817078,241.313843 931.756409,242.074127
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M909.002075,257.082672
	C907.548157,256.865875 906.094177,256.649048 904.192810,255.977158
	C904.165283,252.617828 904.585266,249.713577 905.380981,246.851135
	C906.509094,246.858948 907.261475,246.824951 908.338745,246.865509
	C909.107666,246.966568 909.551575,246.993057 909.992188,247.430847
	C909.665161,250.566269 909.341492,253.290375 908.999512,256.281311
	C908.988159,256.726318 908.995117,256.904480 909.002075,257.082672
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M919.077271,225.052811
	C925.392883,225.305786 931.708557,225.558746 938.421143,225.843994
	C939.172485,226.796356 939.526733,227.716415 939.801819,229.034363
	C939.343689,229.324005 938.964722,229.215759 938.198242,228.648834
	C931.885559,228.126480 925.960510,228.062836 919.735046,227.962311
	C919.315552,226.967880 919.196411,226.010345 919.077271,225.052811
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M858.012817,252.008224
	C858.056946,252.711411 858.101135,253.414581 858.110291,254.814743
	C858.077209,255.975021 858.079102,256.438324 858.080994,256.901611
	C856.918518,256.890747 855.756042,256.879913 854.162354,256.764984
	C853.751831,255.719879 853.772522,254.778824 854.065796,253.289032
	C853.924316,251.810623 853.510132,250.880981 853.022644,249.730865
	C852.949341,249.510361 852.793579,249.072510 852.858398,248.730103
	C852.941772,247.925644 852.960327,247.463608 853.228027,246.832794
	C853.651428,246.102158 853.825745,245.540314 854.330994,244.991730
	C855.103088,245.020889 855.544312,245.036789 855.993774,245.388000
	C856.577759,246.499084 857.153442,247.274887 857.729187,248.050690
	C857.772644,248.482803 857.816040,248.914917 857.654358,249.836746
	C857.637146,250.887054 857.824951,251.447632 858.012817,252.008224
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M898.376160,255.985458
	C897.981445,252.644272 897.960876,249.317871 898.146973,245.266815
	C899.262634,244.367142 900.171570,244.192108 901.067627,244.371826
	C901.116150,245.196457 901.177551,245.666336 901.198364,246.564819
	C901.124634,249.010223 901.091614,251.027008 901.058472,253.350494
	C901.055237,254.066193 901.052063,254.475220 901.029297,255.162628
	C901.005493,255.627060 901.001343,255.813080 900.997253,255.999084
	C900.248291,255.999481 899.499268,255.999878 898.376160,255.985458
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M883.378540,255.959396
	C882.975220,252.935455 882.957397,249.931335 883.246460,246.342773
	C884.405579,245.517715 885.257751,245.277130 886.109985,245.036530
	C886.094971,248.366547 886.079895,251.696548 886.075073,255.475449
	C885.311462,255.942627 884.537659,255.960922 883.378540,255.959396
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M901.058594,253.043823
	C901.091614,251.027008 901.124634,249.010223 901.547302,246.528870
	C902.647766,245.996735 903.358643,245.929138 904.271240,245.971588
	C904.728882,246.266846 904.906311,246.509399 905.005188,246.809341
	C904.585266,249.713577 904.165283,252.617828 903.836548,255.888382
	C903.496460,256.217743 903.065247,256.180786 902.304321,255.777695
	C901.926636,255.219925 901.878662,255.028275 901.819702,254.579132
	C901.558716,253.895691 901.308655,253.469757 901.058594,253.043823
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M924.692017,250.962143
	C924.992188,252.123535 924.948547,253.221436 924.816406,254.727661
	C923.741211,255.105881 922.754456,255.075790 921.392944,255.060471
	C921.165710,252.573746 921.313232,250.072266 921.741455,247.287109
	C922.797424,248.301834 923.572815,249.600250 924.692017,250.962143
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M841.996399,252.009003
	C842.021790,253.056244 842.047180,254.103485 842.071411,255.541779
	C840.954773,255.948563 839.839233,255.964279 838.304077,255.941971
	C837.596741,254.188339 837.309021,252.472717 837.338928,250.429657
	C838.310730,251.055481 838.964844,252.008743 839.599731,252.933945
	C840.017151,251.979019 840.458435,250.969574 840.966431,250.257248
	C841.354248,251.039261 841.675293,251.524139 841.996399,252.009003
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M932.424683,256.221405
	C931.904175,253.952148 931.706543,251.691833 931.797241,249.204681
	C932.721558,250.730972 933.357483,252.484085 934.012695,254.893982
	C934.034729,255.751190 934.037415,255.951599 934.040100,256.152008
	C933.609253,256.178131 933.178467,256.204224 932.424683,256.221405
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M846.174927,257.245819
	C846.961792,256.756012 847.932617,256.513519 848.951050,256.596283
	C848.118713,257.112091 847.238770,257.302612 846.174927,257.245819
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M941.843445,240.795288
	C941.207520,239.371124 940.636597,237.525513 940.124756,235.306396
	C940.758728,236.746521 941.333557,238.560165 941.843445,240.795288
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M877.213867,257.350403
	C878.103760,256.756287 879.221375,256.412598 880.715210,256.135376
	C879.874817,256.668213 878.658142,257.134521 877.213867,257.350403
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M943.286499,252.783493
	C942.790771,251.807404 942.556763,250.602020 942.523682,249.129898
	C942.999084,250.093491 943.273621,251.323837 943.286499,252.783493
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M909.176147,257.307281
	C908.995117,256.904480 908.988159,256.726318 909.284424,256.163757
	C910.339355,255.477631 911.091003,255.175919 911.842651,254.874207
	C911.873535,255.055908 911.904480,255.237656 911.971375,255.693253
	C911.121582,256.488678 910.235901,257.010284 909.176147,257.307281
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M858.364990,257.066315
	C858.079102,256.438324 858.077209,255.975021 858.137451,255.165939
	C859.127563,255.615891 860.055420,256.411621 861.054199,257.517090
	C860.299866,257.628204 859.474426,257.429626 858.364990,257.066315
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M942.775391,245.015808
	C942.281982,244.703690 941.853394,244.035339 941.599976,243.161789
	C942.130249,243.524246 942.485229,244.091904 942.775391,245.015808
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M934.219482,256.358093
	C934.037415,255.951599 934.034729,255.751190 934.076355,255.252838
	C934.559387,254.972382 934.998047,254.989868 935.768311,255.028137
	C935.532898,255.554031 934.965820,256.059113 934.219482,256.358093
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M901.830627,254.836624
	C901.878662,255.028275 901.926636,255.219925 901.986267,255.708038
	C901.831238,256.005096 901.664490,256.005707 901.247559,256.002686
	C901.001343,255.813080 901.005493,255.627060 901.225098,255.162888
	C901.440552,254.884750 901.830627,254.836624 901.830627,254.836624
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M710.996460,235.039917
	C725.818604,235.161743 740.640808,235.283554 755.762451,235.709152
	C755.305786,239.194412 753.780212,239.694794 751.143616,237.665955
	C747.741394,235.048050 744.299805,235.330933 740.689392,237.613235
	C739.632080,238.281570 737.474670,238.421722 736.485962,237.780090
	C731.807861,234.744064 727.587280,235.258377 724.365784,237.886429
	C719.638428,237.173340 715.753784,236.587372 711.429932,235.756042
	C710.990784,235.510696 710.996460,235.039917 710.996460,235.039917
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M762.982178,246.980606
	C761.928467,246.968216 760.874756,246.955826 759.321411,246.712326
	C758.625793,246.211823 758.371216,246.020126 758.018860,245.619843
	C757.643005,244.892975 757.306396,244.452408 756.969788,244.011841
	C757.071167,239.007492 759.995972,239.698593 763.583984,241.394287
	C763.975647,243.225220 763.971619,244.591034 763.753052,246.075012
	C763.261169,246.390686 763.075684,246.653152 762.982178,246.980606
z"/>
<path fill="#47455B" opacity="1.000000" stroke="none"
	d="
M710.640320,234.980576
	C710.996460,235.039917 710.990784,235.510696 710.984863,235.745865
	C709.270142,236.633438 707.561279,237.285843 705.504700,237.924683
	C704.819397,236.189774 704.481812,234.468430 704.316467,232.204346
	C704.053589,231.066681 703.618591,230.471741 703.183533,229.876801
	C703.183533,229.876801 703.084229,229.431213 703.052124,229.205109
	C703.337158,227.914352 703.654236,226.849701 703.962463,225.450516
	C704.390869,225.050690 704.828125,224.985397 705.587036,224.845245
	C706.146667,228.680115 705.543335,232.952469 710.640320,234.980576
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M767.898804,232.181305
	C769.171448,230.409637 770.223450,228.758011 771.643188,227.454193
	C772.056274,228.892975 772.101685,229.983948 772.119141,231.441559
	C772.049927,232.542480 772.008728,233.276764 771.617310,234.071228
	C769.851868,236.074417 768.436584,238.017426 767.006348,239.731873
	C766.991333,239.503326 766.930969,239.049179 766.930969,239.049179
	C766.786804,238.175171 766.642700,237.301163 766.245728,235.964218
	C765.992920,235.501282 765.995117,235.012009 765.995117,235.011993
	C766.327271,234.558441 766.659485,234.104889 767.019165,233.360886
	C767.257141,232.814072 767.467651,232.557709 767.898804,232.181305
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M733.950928,245.360229
	C733.097290,246.003143 732.257202,246.266144 730.887756,246.785309
	C729.896118,247.032867 729.433838,247.024261 728.865112,246.777161
	C728.509583,246.295471 728.260498,246.052246 728.011414,245.809036
	C728.823242,243.921143 729.366150,240.638489 730.499695,240.419968
	C733.333496,239.873657 734.322205,242.255280 733.950928,245.360229
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M748.973511,244.546707
	C747.190613,245.054352 745.417297,245.170532 743.326904,245.141449
	C743.041931,242.744202 742.715027,239.897964 746.043701,240.274628
	C747.155701,240.400452 748.010742,242.796799 748.973511,244.546707
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M766.660095,239.173889
	C766.930969,239.049179 766.991333,239.503326 766.998535,240.079819
	C767.017395,241.119156 767.028931,241.582001 767.035156,242.361954
	C767.036743,243.101639 767.043640,243.524200 767.034546,244.212372
	C767.011841,244.655228 767.005127,244.832489 766.998352,245.009750
	C766.730469,245.212250 766.462646,245.414749 765.740051,245.824768
	C764.846008,246.007156 764.406799,245.982010 763.967529,245.956863
	C763.971619,244.591034 763.975647,243.225220 763.957275,241.452072
	C764.752930,240.462708 765.571045,239.880661 766.660095,239.173889
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M727.661133,245.873703
	C728.260498,246.052246 728.509583,246.295471 728.739502,247.071442
	C727.842773,248.395569 726.965210,249.186935 726.087646,249.978271
	C725.768616,248.907745 725.449524,247.837265 725.163696,246.408493
	C725.901489,246.012939 726.606201,245.975662 727.661133,245.873703
z"/>
<path fill="#515068" opacity="1.000000" stroke="none"
	d="
M765.577637,235.008362
	C765.995117,235.012009 765.992920,235.501282 765.989136,235.745773
	C763.947815,235.992966 761.910339,235.995682 759.435974,235.987427
	C761.052856,235.652557 763.106506,235.328644 765.577637,235.008362
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M758.058105,245.906158
	C758.371216,246.020126 758.625793,246.211823 758.926514,246.698273
	C758.275269,247.284393 757.519409,247.653473 756.430420,248.037613
	C756.068115,247.604080 756.038818,247.155487 756.352966,246.359604
	C757.150330,245.976929 757.604248,245.941544 758.058105,245.906158
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M758.018860,245.619843
	C757.604248,245.941544 757.150330,245.976929 756.355713,246.022644
	C756.173828,245.474823 756.332642,244.916718 756.730591,244.185226
	C757.306396,244.452408 757.643005,244.892975 758.018860,245.619843
z"/>
<path fill="#C2944A" opacity="1.000000" stroke="none"
	d="
M852.793579,249.072510
	C852.793579,249.072510 852.949341,249.510361 852.958496,250.072906
	C852.880859,251.089539 852.794067,251.543625 852.707214,251.997711
	C851.561707,252.126602 850.343201,252.048843 849.284180,252.422684
	C845.969666,253.592758 845.293030,251.904968 844.957642,249.066742
	C844.070618,241.559052 843.013794,234.069199 841.853088,226.598907
	C841.711304,225.686569 840.522156,224.937027 839.416992,223.619476
	C839.006653,221.091949 838.997620,219.057037 839.269897,216.752228
	C840.004395,213.266800 841.285400,209.804230 837.043823,207.654160
	C837.371460,206.216766 837.674744,205.121918 837.984009,203.648865
	C837.326660,202.176773 836.663330,201.082901 835.997559,199.746216
	C835.995178,199.503433 835.997559,199.017807 835.999878,198.611938
	C835.673523,196.469147 835.344910,194.732208 835.010498,192.622086
	C834.999084,191.502731 834.993530,190.756577 835.249023,189.759979
	C835.339172,186.088943 835.445068,182.621185 834.873657,179.268860
	C834.611145,177.728424 833.019897,176.414459 832.020691,174.620911
	C831.742981,171.802704 831.896118,168.955917 827.506897,170.028549
	C823.385986,169.949066 819.722473,169.890656 815.953674,169.488800
	C813.671021,167.681793 811.561890,166.765930 809.500061,169.904831
	C805.686157,169.988251 802.327087,170.046692 798.968079,170.105118
	C798.539917,170.093201 798.111816,170.081284 797.040649,170.086609
	C795.857239,170.688248 795.316833,171.272629 794.776367,171.856995
	C794.402588,171.918289 794.028748,171.979599 793.161072,171.822296
	C791.789734,172.987061 790.384155,174.287216 790.150208,175.771973
	C789.727295,178.456345 790.003967,181.250931 789.623901,184.066208
	C785.980164,188.714981 785.028503,193.647690 787.014038,199.424561
	C787.330383,201.555283 787.648865,203.284683 787.967346,205.014084
	C787.953430,205.443314 787.939514,205.872528 787.602539,206.660217
	C786.856750,207.344589 786.433960,207.670486 785.640381,208.071884
	C784.525024,211.113205 783.780334,214.079025 783.042236,217.436615
	C783.348877,219.889236 783.648987,221.950073 783.638550,224.173141
	C780.975891,226.189255 779.983826,228.305984 782.027710,231.340607
	C782.022827,232.108978 782.028198,232.548126 781.760864,233.181747
	C781.327087,234.923782 781.166016,236.471344 781.004578,238.345963
	C780.999451,239.109070 780.994690,239.545105 780.637573,240.053513
	C780.193848,241.759491 780.102478,243.393112 780.010559,245.461914
	C779.990417,247.926361 779.970825,249.955627 779.572144,251.994888
	C776.785278,251.997070 774.377380,251.989258 771.975159,251.609192
	C771.984741,250.491684 771.988708,249.746445 772.342407,248.945282
	C773.457336,247.250931 774.222595,245.612488 774.986084,243.580704
	C774.983826,242.138458 774.983215,241.089569 774.990295,239.617737
	C774.994690,237.786453 774.991394,236.378098 774.987427,234.555084
	C774.998596,232.758133 775.010559,231.375854 775.379272,229.924088
	C776.481018,226.559250 777.226013,223.263901 777.973633,219.510040
	C777.999146,215.370880 778.022156,211.690262 778.418701,207.953766
	C782.712158,203.388885 782.691162,198.302338 780.983276,192.554291
	C781.000305,190.761353 781.014221,189.382217 781.438293,187.986023
	C782.565308,186.729324 783.696350,185.561859 783.927124,184.237564
	C784.918579,178.546036 785.713623,172.817078 786.442078,167.084183
	C786.858826,163.804672 788.475647,162.867203 791.765015,162.916153
	C805.086670,163.114410 818.413269,162.960739 831.737305,163.044525
	C833.507568,163.055664 835.273987,163.684753 837.036072,164.418610
	C837.031555,165.853790 837.033142,166.898010 837.022278,168.382782
	C837.342773,173.584503 837.509644,178.367615 838.133667,183.090332
	C838.276978,184.175201 839.991150,185.052505 840.988525,186.450607
	C841.002808,188.577789 841.010986,190.279694 840.740906,192.233078
	C841.642578,196.660095 842.822510,200.835632 844.131226,205.242599
	C844.552368,205.666321 844.844788,205.858582 845.135315,206.393341
	C845.138489,207.420746 845.143494,208.105652 845.090820,209.193695
	C844.696045,211.384277 844.359009,213.171768 844.015320,215.391205
	C844.359985,218.683197 844.657593,221.552475 845.143372,224.389526
	C845.193481,224.682205 846.366272,224.782608 847.267883,225.222916
	C847.688049,229.294861 847.858337,233.116150 848.017212,237.387711
	C849.015076,241.553970 850.024414,245.269943 851.328369,248.995789
	C852.013123,249.027939 852.403381,249.050217 852.793579,249.072510
z"/>
<path fill="#C2944A" opacity="1.000000" stroke="none"
	d="
M787.263184,247.345734
	C791.965210,247.337006 791.666321,243.800522 791.949463,240.967026
	C792.441162,236.046219 792.537231,231.084259 793.078552,226.170364
	C793.933350,218.411209 795.019104,210.677505 796.349121,202.430435
	C797.458374,200.948441 798.225525,199.969040 798.992676,198.989624
	C799.328308,193.303421 799.663879,187.617203 800.321289,181.439331
	C801.430847,180.629089 802.218628,180.310486 803.006409,179.991882
	C803.006409,179.991882 803.504395,179.995193 803.742798,180.412460
	C803.669983,183.260941 803.144348,185.687286 803.088684,188.124329
	C802.935425,194.847977 803.069946,201.579010 802.853882,208.299530
	C802.818054,209.415161 801.698730,210.579086 800.896118,211.572083
	C798.000977,215.153946 798.286377,218.569168 800.721069,222.357880
	C801.951355,224.272369 802.271545,226.771759 802.866333,229.318909
	C803.149353,230.757812 803.569336,231.884491 803.989319,233.011169
	C803.550537,233.647125 803.111755,234.283066 802.144775,234.720825
	C800.686829,234.836243 799.076294,234.970795 798.938965,235.492859
	C798.115356,238.624588 796.225525,242.494751 797.335449,244.896118
	C799.406189,249.376282 798.115295,252.517395 795.966614,255.996368
	C794.278198,256.005859 792.589783,256.015350 790.454651,255.630524
	C789.066162,253.164261 788.124390,251.092300 787.182617,249.020355
	C787.173706,248.569580 787.164734,248.118805 787.263184,247.345734
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M833.017700,223.012405
	C831.015869,211.158234 829.019897,199.303055 827.008606,187.450470
	C826.402466,183.878220 825.753845,180.313171 825.184082,176.340866
	C826.398682,177.931396 827.553894,179.925903 828.875183,182.207062
	C828.981445,179.807205 829.075317,177.688828 829.518677,175.221054
	C830.243469,174.917770 830.618774,174.963867 830.993896,175.376892
	C831.036255,176.476425 831.078857,177.209030 831.076660,178.349075
	C831.359802,180.503311 831.687744,182.250137 832.007751,184.392532
	C832.044922,185.841415 832.090149,186.894745 832.130676,188.330719
	C832.765686,190.806732 833.405396,192.900085 834.031982,195.388397
	C834.060181,196.831985 834.101440,197.880615 834.099915,199.343796
	C834.710449,202.838211 835.363708,205.918076 836.015869,209.367767
	C836.064026,210.474487 836.113220,211.211395 836.115051,212.367401
	C836.111572,216.159302 836.155457,219.532089 835.801758,222.925812
	C834.608643,222.968628 833.813171,222.990524 833.017700,223.012405
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M816.058899,169.832245
	C819.722473,169.890656 823.385986,169.949066 827.526489,170.336105
	C828.052063,171.072556 828.100769,171.480392 828.149414,171.888229
	C819.849365,171.923065 811.548889,172.009033 803.249695,171.941483
	C801.894409,171.930450 800.544678,171.241684 799.080200,170.485641
	C802.327087,170.046692 805.686157,169.988251 809.934814,169.951904
	C812.569275,169.926727 814.314087,169.879471 816.058899,169.832245
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M820.666382,173.624741
	C816.443481,174.246002 811.920166,174.662628 807.387573,174.911270
	C804.579834,175.065292 801.758179,174.964172 798.475037,174.995621
	C798.937134,174.345276 799.861755,173.108459 800.797607,173.099915
	C807.317810,173.040451 813.840271,173.235596 820.666382,173.624741
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M789.988464,183.999496
	C790.003967,181.250931 789.727295,178.456345 790.150208,175.771973
	C790.384155,174.287216 791.789734,172.987061 792.881409,171.873276
	C792.261475,177.591965 791.427307,183.041046 790.046753,188.545303
	C789.663147,187.066803 789.825806,185.533157 789.988464,183.999496
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M789.623901,184.066208
	C789.825806,185.533157 789.663147,187.066803 789.769104,188.807709
	C789.993774,190.066895 789.949768,191.118851 789.509521,192.662476
	C788.414307,195.110519 787.715271,197.066879 787.016174,199.023224
	C785.028503,193.647690 785.980164,188.714981 789.623901,184.066208
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M771.969543,251.981415
	C774.377380,251.989258 776.785278,251.997070 779.696106,252.222229
	C780.476074,252.635956 780.753113,252.832336 781.030090,253.028732
	C781.007690,253.452621 780.985229,253.876495 780.879883,254.607666
	C777.489624,254.943741 774.182251,254.972549 770.413696,254.997330
	C769.979309,254.255615 770.006287,253.517944 770.388550,252.402771
	C771.152405,252.010651 771.560974,251.996033 771.969543,251.981415
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M786.869019,249.265411
	C788.124390,251.092300 789.066162,253.164261 790.032776,255.622528
	C788.870422,256.012665 787.683228,256.016510 786.155640,255.967972
	C786.061951,253.780563 786.308716,251.645508 786.869019,249.265411
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M783.949036,224.010910
	C783.648987,221.950073 783.348877,219.889236 783.383972,217.360840
	C784.808777,215.590454 785.898376,214.287628 786.987915,212.984787
	C786.519897,216.481064 786.051880,219.977356 785.034790,223.747040
	C784.306885,224.017242 784.127930,224.014069 783.949036,224.010910
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M787.014038,199.424561
	C787.715271,197.066879 788.414307,195.110519 789.450012,193.053177
	C789.377136,196.797516 788.967529,200.642838 788.262634,204.751129
	C787.648865,203.284683 787.330383,201.555283 787.014038,199.424561
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M787.018066,212.658142
	C785.898376,214.287628 784.808777,215.590454 783.377441,216.969055
	C783.780334,214.079025 784.525024,211.113205 785.642456,208.414169
	C786.360291,209.460495 786.705322,210.240021 787.050354,211.019562
	C787.049622,211.456879 787.048950,211.894180 787.018066,212.658142
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M783.638550,224.173141
	C784.127930,224.014069 784.306885,224.017242 784.754395,224.018585
	C784.981506,225.062927 784.939941,226.109116 784.538086,227.620056
	C783.464478,229.060318 782.751282,230.035843 782.038025,231.011383
	C779.983826,228.305984 780.975891,226.189255 783.638550,224.173141
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M828.384521,172.101013
	C828.100769,171.480392 828.052063,171.072556 827.983826,170.357162
	C831.896118,168.955917 831.742981,171.802704 831.761230,174.626343
	C831.339600,175.009109 831.166870,175.009537 830.994080,175.009964
	C830.618774,174.963867 830.243469,174.917770 829.602051,174.784821
	C829.097168,173.903244 828.858337,173.108521 828.384521,172.101013
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M780.989929,239.981155
	C780.994690,239.545105 780.999451,239.109070 781.257629,238.143127
	C782.295532,236.727325 783.080139,235.841431 783.864746,234.955521
	C783.443054,237.469864 783.021362,239.984238 782.065063,242.566162
	C781.350220,241.749542 781.170105,240.865341 780.989929,239.981155
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M781.317993,252.746918
	C780.753113,252.832336 780.476074,252.635956 780.075134,252.212219
	C779.970825,249.955627 779.990417,247.926361 780.333984,245.448975
	C781.089294,244.990982 781.520569,244.981140 781.951843,244.971313
	C781.836548,247.469238 781.721252,249.967178 781.317993,252.746918
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M790.470459,220.053131
	C790.726135,222.112823 790.632080,224.277252 790.259766,226.719315
	C790.027893,224.717255 790.074280,222.437576 790.470459,220.053131
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M797.297119,177.049286
	C797.010132,179.264450 796.409973,181.602951 795.471008,184.068542
	C795.749390,181.854630 796.366699,179.513626 797.297119,177.049286
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M781.990479,244.651520
	C781.520569,244.981140 781.089294,244.990982 780.334595,245.013779
	C780.102478,243.393112 780.193848,241.759491 780.637573,240.053513
	C781.170105,240.865341 781.350220,241.749542 781.807739,242.839554
	C782.066406,243.474152 782.047791,243.902939 781.990479,244.651520
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M783.924072,234.633057
	C783.080139,235.841431 782.295532,236.727325 781.257935,237.816071
	C781.166016,236.471344 781.327087,234.923782 782.089844,233.187561
	C783.131165,232.999481 783.570740,233.000031 784.010376,233.000595
	C784.001343,233.437256 783.992371,233.873917 783.924072,234.633057
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M784.086670,232.638702
	C783.570740,233.000031 783.131165,232.999481 782.362549,232.993103
	C782.028198,232.548126 782.022827,232.108978 782.027710,231.340607
	C782.751282,230.035843 783.464478,229.060318 784.476318,228.008240
	C784.570923,229.380066 784.366943,230.828445 784.086670,232.638702
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M787.305237,210.767807
	C786.705322,210.240021 786.360291,209.460495 786.013184,208.338669
	C786.433960,207.670486 786.856750,207.344589 787.552124,206.978683
	C787.736511,208.131134 787.648315,209.323593 787.305237,210.767807
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M794.815613,190.154617
	C795.201294,190.860901 795.327698,191.743881 795.213806,192.811096
	C794.834473,192.107346 794.695374,191.219330 794.815613,190.154617
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M792.836548,202.140808
	C793.210144,202.860367 793.318848,203.751801 793.173340,204.813797
	C792.803284,204.093796 792.687500,203.203262 792.836548,202.140808
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M794.411377,198.015289
	C794.395142,198.625854 794.077271,199.320587 793.462769,200.128967
	C793.480713,199.528244 793.795227,198.813858 794.411377,198.015289
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M795.109985,171.870605
	C795.316833,171.272629 795.857239,170.688248 796.721252,170.123901
	C796.511108,170.724014 795.977356,171.304108 795.109985,171.870605
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M792.369934,212.021851
	C792.373901,212.629395 792.080505,213.328674 791.499756,214.158020
	C791.499207,213.563263 791.785889,212.838425 792.369934,212.021851
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M824.961731,174.730957
	C824.426758,174.834961 823.874146,174.646713 823.165039,174.203461
	C823.653687,174.111877 824.298889,174.275299 824.961731,174.730957
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M790.906189,216.090866
	C791.235413,216.549484 791.316833,217.139618 791.172607,217.865601
	C790.850769,217.408432 790.754578,216.815399 790.906189,216.090866
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M703.143799,230.190216
	C703.618591,230.471741 704.053589,231.066681 704.271362,231.829880
	C703.737488,231.499969 703.420776,231.001801 703.143799,230.190216
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M690.404724,249.949860
	C690.388306,250.553375 690.081177,251.256638 689.466064,252.046509
	C689.476746,251.438599 689.795410,250.744110 690.404724,249.949860
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M694.078613,237.563690
	C693.928467,237.820175 693.722290,237.856094 693.202148,237.869705
	C693.079834,237.463058 693.271545,237.078690 693.463318,236.694336
	C693.649719,236.910583 693.836121,237.126846 694.078613,237.563690
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M763.753052,246.075012
	C764.406799,245.982010 764.846008,246.007156 765.613770,246.046051
	C765.599365,246.711121 765.256531,247.362442 764.634094,248.090576
	C764.001709,247.950653 763.648865,247.733902 763.139099,247.248871
	C763.075684,246.653152 763.261169,246.390686 763.753052,246.075012
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M771.975159,251.609177
	C771.560974,251.996033 771.152405,252.010651 770.439453,252.036560
	C770.088928,250.318176 770.042786,248.588470 770.276001,246.170761
	C771.026001,241.658844 771.496704,237.834961 771.967529,234.011063
	C772.008728,233.276764 772.049927,232.542480 772.354614,231.314774
	C773.077698,230.544342 773.537231,230.267319 774.253174,229.988983
	C774.680664,229.989655 774.851624,229.991608 775.022522,229.993576
	C775.010559,231.375854 774.998596,232.758133 774.722900,234.794159
	C774.633667,236.978821 774.808167,238.509750 774.982605,240.040680
	C774.983215,241.089569 774.983826,242.138458 774.621460,243.632233
	C773.503235,245.718460 772.747925,247.359833 771.992676,249.001190
	C771.988708,249.746445 771.984741,250.491684 771.975159,251.609177
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M771.617310,234.071228
	C771.496704,237.834961 771.026001,241.658844 770.272705,245.739136
	C769.188599,245.750366 768.387085,245.505188 767.291992,245.134888
	C767.005127,244.832489 767.011841,244.655228 767.324585,244.187622
	C767.939392,243.581482 768.248230,243.265701 768.557007,242.949951
	C768.051514,242.648239 767.546021,242.346542 767.040466,242.044830
	C767.028931,241.582001 767.017395,241.119156 767.013550,240.308380
	C768.436584,238.017426 769.851868,236.074417 771.617310,234.071228
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M796.282593,256.135040
	C798.115295,252.517395 799.406189,249.376282 797.335449,244.896118
	C796.225525,242.494751 798.115356,238.624588 798.938965,235.492859
	C799.076294,234.970795 800.686829,234.836243 801.842590,234.796631
	C802.093506,236.082382 802.118408,237.094116 802.093506,238.921280
	C802.081909,241.198273 802.120239,242.659866 802.158569,244.121445
	C802.143005,247.429321 802.127441,250.737183 802.150146,254.493378
	C800.325134,255.385712 798.461792,255.829712 796.282593,256.135040
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M726.046509,250.380768
	C726.965210,249.186935 727.842773,248.395569 728.845947,247.309937
	C729.433838,247.024261 729.896118,247.032867 730.705322,247.061401
	C735.421753,252.675201 735.208008,253.750793 729.126343,255.924057
	C728.895691,256.234833 728.447205,256.160370 728.112061,255.878738
	C727.491089,255.399048 727.205261,255.200989 726.919434,255.002930
	C726.698364,254.736359 726.477356,254.469818 726.011292,254.102051
	C725.846008,252.928284 725.925720,251.855759 726.046509,250.380768
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M727.020386,255.251648
	C727.205261,255.200989 727.491089,255.399048 727.888428,255.838211
	C727.707031,255.886337 727.414124,255.693344 727.020386,255.251648
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M816.708557,255.290573
	C813.437561,255.817459 810.237671,255.906754 806.688477,255.873383
	C806.282959,254.751663 806.226807,253.752609 806.449219,252.059784
	C806.785583,247.220322 806.843323,243.074631 806.901062,238.928955
	C807.042725,238.625458 807.242798,238.367264 808.155518,238.061264
	C810.900085,237.950027 812.990356,237.931915 815.080627,237.913788
	C815.652832,240.470657 816.488342,243.003052 816.729004,245.590775
	C817.013855,248.653259 816.785522,251.763458 816.708557,255.290573
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M804.457153,233.018555
	C803.569336,231.884491 803.149353,230.757812 803.252441,229.315964
	C806.454712,229.001877 807.819519,228.183136 806.286316,225.272797
	C805.953674,224.641434 806.097778,223.758911 806.331665,223.007202
	C807.053589,223.047928 807.466187,223.073517 807.928711,223.414093
	C808.646790,224.523956 809.315002,225.318832 809.990479,226.505157
	C809.871155,230.091278 811.496399,230.125717 814.081543,229.559479
	C816.810730,228.961685 819.772156,228.855484 820.021973,232.977982
	C820.021973,232.977982 819.914368,233.095230 819.861206,233.158295
	C814.847107,233.156219 809.886047,233.091080 804.457153,233.018555
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M806.507263,238.950439
	C806.843323,243.074631 806.785583,247.220322 806.474365,251.680878
	C805.821350,250.536728 805.552734,249.023972 804.983398,247.634521
	C804.470154,246.382263 803.627258,245.265091 802.544189,244.104889
	C802.120239,242.659866 802.081909,241.198273 802.118225,239.300781
	C803.499756,238.900543 804.806580,238.936218 806.507263,238.950439
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M814.975586,237.550995
	C812.990356,237.931915 810.900085,237.950027 808.361816,237.926178
	C809.959167,234.917908 812.356873,235.473694 814.975586,237.550995
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M854.759277,74.135529
	C855.147156,75.184990 855.082642,76.172012 855.013184,77.530869
	C856.187317,78.747002 857.366516,79.591301 858.548767,80.970825
	C857.033752,82.007263 855.515686,82.508492 853.997620,83.009720
	C851.199768,83.009720 848.401917,83.009720 845.596497,83.009720
	C846.450684,73.927193 846.450684,73.927193 854.759277,74.135529
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M845.608521,89.997040
	C847.873047,90.515617 849.741150,91.038284 851.816467,91.861320
	C851.432129,92.620941 850.840576,93.080200 850.096313,93.782211
	C846.513184,93.129005 843.082947,92.233040 839.323853,91.168686
	C841.067444,90.667244 843.139771,90.334183 845.608521,89.997040
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M863.044434,83.461319
	C867.556458,83.417870 872.181824,83.759132 876.927734,84.473022
	C872.418030,84.512436 867.787903,84.179230 863.044434,83.461319
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M853.713745,86.697769
	C854.252502,87.485481 854.514771,87.990677 854.872559,88.764648
	C852.278870,89.016678 849.589783,88.999931 846.451538,88.979416
	C846.868958,83.442093 850.758118,86.685394 853.713745,86.697769
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M892.906494,85.576378
	C895.430176,85.531937 898.126404,85.833687 900.931152,86.504883
	C898.386169,86.557091 895.732666,86.239830 892.906494,85.576378
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M854.446411,83.008453
	C855.515686,82.508492 857.033752,82.007263 858.779541,81.231445
	C860.168091,81.078682 861.328918,81.200508 862.745117,81.553551
	C862.993896,82.000648 862.987183,82.216530 862.951172,82.755859
	C860.246277,83.055267 857.570740,83.031227 854.446411,83.008453
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M902.336731,64.890900
	C903.462708,64.359123 904.978638,63.885063 906.736694,63.663742
	C905.561401,64.260521 904.144043,64.604568 902.336731,64.890900
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M911.293701,63.832985
	C912.148743,63.342064 913.367249,62.925430 914.797668,62.776535
	C913.892090,63.331940 912.774597,63.619606 911.293701,63.832985
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M919.270752,62.845879
	C919.827759,62.354645 920.723022,61.927681 921.809143,61.751251
	C921.203003,62.304573 920.406067,62.607357 919.270752,62.845879
z"/>
<path fill="#73B3DA" opacity="1.000000" stroke="none"
	d="
M875.184937,68.363129
	C875.847229,67.920105 876.720581,67.688568 877.790283,67.698196
	C877.123108,68.151123 876.259521,68.362869 875.184937,68.363129
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M889.263977,66.818329
	C889.818909,66.326111 890.713013,65.905434 891.800171,65.727501
	C891.196533,66.276794 890.399841,66.583336 889.263977,66.818329
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M865.600952,88.261093
	C865.606445,88.754593 865.314758,89.182968 865.023071,89.611336
	C864.732300,89.342873 864.441589,89.074409 864.124268,88.552620
	C864.499756,88.264847 864.901733,88.230415 865.600952,88.261093
z"/>
<path fill="#76B4DA" opacity="1.000000" stroke="none"
	d="
M882.143066,85.246590
	C882.574341,84.899582 883.157532,84.759827 883.881042,84.860565
	C883.445862,85.218658 882.870422,85.336250 882.143066,85.246590
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M868.040161,88.771225
	C867.840698,88.932442 867.559937,88.792915 867.211426,88.348831
	C867.440186,88.143578 867.711914,88.285652 868.040161,88.771225
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M795.058594,133.118759
	C795.017639,132.946121 794.976746,132.773483 794.926270,131.913391
	C794.866821,129.796173 794.816895,128.366425 794.766968,126.936676
	C794.781677,126.517921 794.796387,126.099174 794.853638,124.925156
	C794.852478,122.090370 794.808838,120.010849 794.765198,117.931320
	C794.810242,114.299171 795.015930,110.660080 794.859375,107.036636
	C794.665466,102.545868 796.676941,100.594009 801.859741,100.979736
	C804.110779,101.349396 805.576111,101.650169 806.928467,102.220474
	C806.538269,103.000008 806.261108,103.510033 805.656250,104.016479
	C804.565674,104.303993 803.802917,104.595093 802.630249,104.916107
	C798.944702,105.172813 798.901428,107.520065 798.908691,109.941833
	C798.927490,116.201500 798.838013,122.462791 798.958069,128.720245
	C799.012451,131.558121 798.041931,133.142288 795.058594,133.118759
z"/>
<path fill="#696661" opacity="1.000000" stroke="none"
	d="
M804.878052,94.876984
	C804.929565,93.826508 804.981079,92.776031 805.418640,91.339325
	C806.413086,90.559875 807.533997,90.185883 807.549561,89.770462
	C807.687622,86.088684 807.629761,82.399567 807.629761,78.464790
	C810.501526,78.464790 812.511536,78.464790 814.705627,78.464790
	C814.984680,81.761475 815.131592,84.840210 815.561646,87.878883
	C815.720703,89.002838 816.545410,90.032585 817.066528,91.105301
	C817.061157,92.112022 817.055786,93.118752 816.608643,94.548340
	C812.403992,94.939804 808.641052,94.908394 804.878052,94.876984
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M817.432983,90.982361
	C816.545410,90.032585 815.720703,89.002838 815.561646,87.878883
	C815.131592,84.840210 814.984680,81.761475 814.705627,78.464790
	C812.511536,78.464790 810.501526,78.464790 807.629761,78.464790
	C807.629761,82.399567 807.687622,86.088684 807.549561,89.770462
	C807.533997,90.185883 806.413086,90.559875 805.444214,90.945396
	C805.374634,85.906166 805.665649,80.874626 806.439209,75.380142
	C809.913086,74.634552 812.904358,74.351906 815.895630,74.069267
	C816.917358,78.343849 818.083496,82.592186 818.868042,86.909851
	C819.088257,88.121651 818.186584,89.537285 817.432983,90.982361
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M795.041565,133.431793
	C798.041931,133.142288 799.012451,131.558121 798.958069,128.720245
	C798.838013,122.462791 798.927490,116.201500 798.908691,109.941833
	C798.901428,107.520065 798.944702,105.172813 802.596313,105.279755
	C802.668396,106.763603 802.364502,107.913727 802.020508,109.525131
	C801.924744,116.318619 801.869141,122.650833 801.502136,129.052887
	C801.450867,130.085083 801.711060,131.047440 802.182373,132.050095
	C802.393616,132.090393 802.820557,132.142090 802.871582,132.429535
	C802.974365,133.104904 803.026123,133.492813 803.053711,134.265594
	C803.010742,135.416870 802.991882,136.183289 802.533203,136.970276
	C799.758667,136.978439 797.424011,136.966019 795.050110,136.629913
	C795.003418,135.871384 794.995911,135.436539 794.988403,135.001678
	C795.000427,134.582718 795.012512,134.163773 795.041565,133.431793
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M822.063965,100.901855
	C824.042664,101.690315 826.021423,102.478760 828.050415,103.949181
	C828.097229,105.089157 828.093750,105.547165 827.780518,106.290543
	C827.375916,115.099174 827.281189,123.622444 827.136719,132.391708
	C827.056763,132.802246 827.026428,132.966797 826.625854,133.025085
	C825.542053,130.166748 824.469116,127.450790 824.188171,124.655243
	C823.567383,118.477486 823.345215,112.259682 822.922241,105.730797
	C821.882385,104.256973 820.880798,103.110565 820.088867,101.732819
	C820.886963,101.301613 821.475464,101.101730 822.063965,100.901855
z"/>
<path fill="#696661" opacity="1.000000" stroke="none"
	d="
M822.021973,100.594345
	C821.475464,101.101730 820.886963,101.301613 819.788879,101.736755
	C818.876038,101.969810 818.472717,101.967590 817.766968,101.693176
	C813.990173,101.597633 810.515869,101.774292 807.041504,101.950951
	C805.576111,101.650169 804.110779,101.349396 802.268982,100.976517
	C801.953064,100.156792 802.013489,99.409164 802.564453,98.312492
	C808.717957,97.974991 814.381042,97.986542 820.044067,97.998093
	C820.689392,98.761009 821.334656,99.523926 822.021973,100.594345
z"/>
<path fill="#486278" opacity="1.000000" stroke="none"
	d="
M828.090271,106.005165
	C828.093750,105.547165 828.097229,105.089157 828.173706,104.293854
	C828.919189,103.967804 829.591553,103.979050 830.602051,103.983810
	C830.944519,113.349907 830.948853,122.722481 830.613647,132.551819
	C829.505249,132.717331 828.736328,132.426071 828.258789,131.816589
	C828.396790,123.000641 828.243530,114.502907 828.090271,106.005165
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M820.053467,97.624352
	C814.381042,97.986542 808.717957,97.974991 802.604492,97.938278
	C802.826599,96.923622 803.499207,95.934120 804.524963,94.910805
	C808.641052,94.908394 812.403992,94.939804 816.638428,94.924942
	C818.094238,95.669319 819.078552,96.459969 820.053467,97.624352
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M815.955566,73.738258
	C812.904358,74.351906 809.913086,74.634552 806.536621,74.995193
	C806.099731,73.715179 806.048035,72.357170 806.403564,70.531723
	C810.456238,70.014465 814.101746,69.964653 817.747192,69.914841
	C817.169983,71.078972 816.592712,72.243111 815.955566,73.738258
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M817.756470,69.570450
	C814.101746,69.964653 810.456238,70.014465 806.410950,70.125671
	C807.413086,68.477058 808.494141,65.914207 810.285828,65.240120
	C813.690186,63.959362 816.173706,66.162933 817.756470,69.570450
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M794.424927,118.055519
	C794.808838,120.010849 794.852478,122.090370 794.828125,124.611671
	C791.968750,123.014435 792.507874,120.648064 794.424927,118.055519
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M794.440674,127.045242
	C794.816895,128.366425 794.866821,129.796173 794.864563,131.654510
	C794.579712,130.440002 794.347046,128.796906 794.440674,127.045242
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M795.858032,92.256157
	C796.016907,92.017761 796.497253,91.975594 796.980225,92.116447
	C797.762695,92.547318 798.062134,92.837326 798.361694,93.127335
	C798.168152,93.669594 797.974609,94.211853 797.232727,94.817886
	C795.821594,94.620041 794.958923,94.358421 794.096191,94.096809
	C794.096191,94.096809 794.022644,94.020317 793.986267,93.980873
	C794.533020,93.459137 795.116150,92.976845 795.858032,92.256157
z"/>
<path fill="#7BC7EA" opacity="1.000000" stroke="none"
	d="
M794.099121,94.432457
	C794.958923,94.358421 795.821594,94.620041 797.014099,95.007355
	C796.816589,95.797943 796.289368,96.462830 795.438721,97.208267
	C794.777527,96.448586 794.439758,95.608345 794.099121,94.432457
z"/>
<path fill="#4379A1" opacity="1.000000" stroke="none"
	d="
M798.640320,93.043182
	C798.062134,92.837326 797.762695,92.547318 797.216309,92.067215
	C797.791016,91.509163 798.612732,91.141197 799.716003,90.893005
	C799.638000,91.661530 799.278503,92.310280 798.640320,93.043182
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M794.614380,135.000732
	C794.995911,135.436539 795.003418,135.871384 794.725464,136.693878
	C794.011108,137.172333 793.582031,137.263153 792.884033,137.260406
	C792.425720,137.152542 792.236389,137.138260 792.033386,136.765762
	C792.001099,135.929749 791.982544,135.451950 791.963928,134.974136
	C791.963928,134.974136 791.984741,134.986313 791.985779,134.986450
	C792.737976,134.990982 793.489197,134.995377 794.614380,135.000732
z"/>
<path fill="#487491" opacity="1.000000" stroke="none"
	d="
M792.197021,99.925613
	C792.395386,99.331535 792.913940,98.736839 793.758667,98.190498
	C793.562378,98.800903 793.039734,99.362946 792.197021,99.925613
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M918.918457,224.739624
	C919.196411,226.010345 919.315552,226.967880 919.738403,228.257874
	C920.072388,228.784988 920.102661,228.979691 920.132996,229.174377
	C919.752014,230.203232 919.371033,231.232101 918.932495,232.587936
	C917.939758,234.383270 917.004700,235.851639 915.703979,237.661896
	C914.903687,237.992538 914.468994,237.981293 913.822754,237.698151
	C912.094238,236.988052 910.577209,236.549866 908.832031,235.981934
	C908.394836,235.576828 908.185730,235.301483 908.346191,235.011383
	C909.839539,234.390900 910.963196,233.785187 912.086853,233.179474
	C912.446899,233.084579 912.806946,232.989685 913.832397,232.861649
	C914.897034,231.769699 915.296326,230.710876 915.695557,229.652054
	C915.703003,229.059006 915.710510,228.465942 915.703796,227.580353
	C914.937683,225.455444 914.185730,223.623047 913.205994,221.235580
	C914.626221,220.616531 916.142029,219.955841 918.274963,219.004807
	C920.931213,218.700272 922.970215,218.686096 925.009277,218.671921
	C925.023926,219.178299 925.038574,219.684662 925.088806,220.568604
	C923.044922,222.183243 919.073059,219.959549 918.918457,224.739624
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M911.615906,233.098297
	C910.963196,233.785187 909.839539,234.390900 908.017883,235.005615
	C906.881470,235.017151 906.443054,235.019684 905.535767,235.009048
	C896.374207,235.009445 887.681580,235.023010 878.988953,235.036560
	C878.250977,235.029190 877.513000,235.021820 876.014282,234.996063
	C873.804321,234.391525 872.355042,233.805359 870.905823,233.219208
	C884.318848,233.151871 897.731934,233.084503 911.615906,233.098297
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M864.943970,234.999512
	C863.884094,235.003235 862.824280,235.006958 860.984985,234.998505
	C852.993286,233.202530 852.252075,232.259552 853.930115,227.002533
	C854.627075,228.353653 855.323975,229.704788 856.312500,231.228027
	C859.802612,231.938843 863.001038,232.477554 866.572998,233.404678
	C866.278992,234.195236 865.611450,234.597382 864.943970,234.999512
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M865.153442,235.275955
	C865.611450,234.597382 866.278992,234.195236 867.018860,233.494263
	C868.110046,233.168427 869.128845,233.141418 870.526733,233.166809
	C872.355042,233.805359 873.804321,234.391525 875.645264,234.992401
	C872.545471,236.490051 869.136047,239.581467 865.153442,235.275955
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M915.406372,229.803650
	C915.296326,230.710876 914.897034,231.769699 914.106812,232.809998
	C914.182983,231.846069 914.650146,230.900665 915.406372,229.803650
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M911.811096,79.764236
	C912.003845,80.186600 912.003296,80.359802 912.002625,80.793350
	C911.229614,81.019592 910.456726,80.985481 909.304138,80.867294
	C909.822144,80.360497 910.719971,79.937790 911.811096,79.764236
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M778.942749,149.268677
	C778.101257,148.474167 777.259827,147.679642 776.418396,146.885132
	C777.668274,146.174149 778.918091,145.463196 781.006714,144.803955
	C802.593262,144.790115 823.341003,144.724564 844.088806,144.659042
	C844.919006,145.541077 845.749268,146.423111 846.579529,147.305099
	C845.333679,147.917572 844.087830,148.530075 841.997681,149.085159
	C820.416565,149.108047 799.679626,149.188354 778.942749,149.268677
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M837.042175,164.027679
	C835.273987,163.684753 833.507568,163.055664 831.737305,163.044525
	C818.413269,162.960739 805.086670,163.114410 791.765015,162.916153
	C788.475647,162.867203 786.858826,163.804672 786.442078,167.084183
	C785.713623,172.817078 784.918579,178.546036 783.927124,184.237564
	C783.696350,185.561859 782.565308,186.729324 781.193298,187.979553
	C780.538086,187.990128 780.048767,187.999725 780.038330,187.615280
	C779.962708,186.465195 779.897583,185.699554 779.832397,184.933914
	C779.906494,184.205338 779.980652,183.476776 780.329346,182.134918
	C780.676331,180.316559 780.748779,179.111526 780.821228,177.906479
	C780.821228,177.906479 780.956665,177.952606 781.371094,177.909973
	C782.172913,175.243408 782.560303,172.619476 782.952881,169.583466
	C783.027405,167.800507 783.096680,166.429657 783.512390,164.955673
	C784.240845,163.235291 784.622864,161.618027 785.413086,159.946503
	C789.194519,159.659012 792.567749,159.425812 796.017334,159.498795
	C797.082275,159.599854 798.070862,159.394730 799.522705,159.152466
	C812.660278,159.068024 825.334595,159.020706 838.008911,158.973389
	C838.554504,159.435471 839.100098,159.897537 839.357605,160.725403
	C838.393738,162.070038 837.717957,163.048859 837.042175,164.027679
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M838.020630,158.589294
	C825.334595,159.020706 812.660278,159.068024 799.134888,159.086792
	C797.502869,159.103027 796.721924,159.147827 795.940918,159.192612
	C792.567749,159.425812 789.194519,159.659012 785.150696,160.036530
	C783.987793,160.426132 783.495544,160.671448 783.003296,160.916748
	C783.326416,159.225861 783.649597,157.534973 784.440308,155.443054
	C802.629028,155.070694 820.350159,155.099380 838.071228,155.128052
	C838.058228,156.153763 838.045288,157.179474 838.020630,158.589294
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M844.064087,144.343018
	C823.341003,144.724564 802.593262,144.790115 781.377075,144.749481
	C781.923218,143.670792 782.937683,142.698288 784.031982,141.407043
	C784.513184,141.069153 784.914429,141.050034 785.877808,141.044922
	C786.613342,141.064713 786.786743,141.070480 787.026489,141.403107
	C788.101562,141.477966 789.110474,141.225983 790.492432,140.983429
	C791.614014,140.964264 792.362488,140.935669 793.572449,140.919922
	C805.994141,140.930298 817.954346,140.927826 830.252686,140.953354
	C831.041443,140.988007 831.492126,140.994675 832.280884,141.163422
	C835.435242,141.556595 838.251526,141.787674 841.067810,142.018753
	C841.783997,142.035263 842.500244,142.051773 843.572144,142.090790
	C843.965088,142.751190 844.002258,143.389099 844.064087,144.343018
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M779.013794,149.563248
	C799.679626,149.188354 820.416565,149.108047 841.627197,149.112106
	C841.804871,149.956497 841.508789,150.716522 840.617676,151.753448
	C820.700623,152.020416 801.378540,152.010498 782.056519,152.000580
	C781.065979,151.286316 780.075378,150.572067 779.013794,149.563248
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M782.039001,152.353119
	C801.378540,152.010498 820.700623,152.020416 840.485474,152.036285
	C840.229797,153.042679 839.511230,154.043106 838.431885,155.085815
	C820.350159,155.099380 802.629028,155.070694 784.436157,155.069427
	C783.316772,154.299774 782.669128,153.502731 782.039001,152.353119
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M841.019165,191.981598
	C841.010986,190.279694 841.002808,188.577789 840.997192,186.019409
	C840.977417,181.784241 840.955139,178.405533 841.198059,175.023209
	C841.640015,175.017899 841.816772,175.016220 841.993591,175.014526
	C842.617615,179.075684 843.241638,183.136841 843.647339,187.800110
	C843.648010,189.266815 843.867065,190.131439 844.086060,190.996063
	C844.107361,191.416885 844.128662,191.837723 844.110352,192.920563
	C844.398987,194.387817 844.727234,195.193054 845.055542,195.998291
	C845.118530,197.068695 845.181641,198.139069 845.185730,199.606079
	C845.126709,200.002686 844.855347,199.994141 844.507263,199.915665
	C843.112549,197.218658 842.065857,194.600128 841.019165,191.981598
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M837.036072,164.418625
	C837.717957,163.048859 838.393738,162.070038 839.355103,161.011841
	C839.819885,162.305130 839.999023,163.677795 840.157837,165.769226
	C840.428528,166.994324 840.719482,167.500656 841.010437,168.006989
	C841.264221,169.413025 841.517944,170.819046 841.530151,172.588150
	C841.109863,172.959030 840.931030,172.966843 840.418823,172.897339
	C839.068542,171.194092 838.051697,169.568161 837.034790,167.942230
	C837.033142,166.898010 837.031555,165.853790 837.036072,164.418625
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M845.148560,208.790573
	C845.143494,208.105652 845.138489,207.420746 845.347900,206.247101
	C845.771606,205.481842 845.980835,205.205292 846.190125,204.928726
	C846.877991,204.975479 847.565918,205.022232 848.594849,205.110046
	C848.945984,205.544220 848.956116,205.937317 848.738220,206.794617
	C848.051575,207.840515 847.593018,208.422241 846.799438,208.988739
	C846.025818,208.912537 845.587158,208.851562 845.148560,208.790573
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M844.322388,190.796722
	C843.867065,190.131439 843.648010,189.266815 843.648743,188.195160
	C844.098633,188.857880 844.328674,189.727615 844.322388,190.796722
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M846.142212,204.604919
	C845.980835,205.205292 845.771606,205.481842 845.349731,205.904617
	C844.844788,205.858582 844.552368,205.666321 844.155640,204.941315
	C844.373169,203.931870 844.695068,203.455154 845.280029,202.980316
	C845.718506,202.978790 845.893921,202.975403 846.069275,202.972000
	C846.077637,203.408371 846.085999,203.844757 846.142212,204.604919
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M846.303101,202.785248
	C845.893921,202.975403 845.718506,202.978790 845.278320,202.607040
	C844.960815,201.485977 844.908081,200.740051 844.855347,199.994141
	C844.855347,199.994141 845.126709,200.002686 845.265869,200.000107
	C845.782227,200.864502 846.159546,201.731491 846.303101,202.785248
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M845.294556,195.799042
	C844.727234,195.193054 844.398987,194.387817 844.143311,193.234970
	C844.655090,193.791504 845.094360,194.695648 845.294556,195.799042
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M841.228882,167.844757
	C840.719482,167.500656 840.428528,166.994324 840.207153,166.181305
	C840.666992,166.477249 841.057190,167.079880 841.228882,167.844757
z"/>
<path fill="#497797" opacity="1.000000" stroke="none"
	d="
M844.981873,155.177979
	C844.978577,155.729904 844.670898,156.234879 844.083313,156.855621
	C844.094788,156.357941 844.386169,155.744492 844.981873,155.177979
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M840.752197,172.974655
	C840.931030,172.966843 841.109863,172.959030 841.555542,172.944458
	C842.032654,173.523773 842.242859,174.109894 842.223328,174.855270
	C841.816772,175.016220 841.640015,175.017899 841.205322,174.678406
	C840.882324,173.883041 840.817261,173.428848 840.752197,172.974655
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M863.903564,94.555954
	C864.808899,94.523239 865.848572,94.803841 867.000732,95.403915
	C866.088135,95.438667 865.063049,95.153961 863.903564,94.555954
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M882.878052,98.540718
	C883.482910,98.534111 884.204285,98.821304 885.023560,99.404953
	C884.412476,99.412453 883.703491,99.123482 882.878052,98.540718
z"/>
<path fill="#5B92BC" opacity="1.000000" stroke="none"
	d="
M856.836182,92.633667
	C857.439026,92.626503 858.178345,92.896515 859.006592,93.478561
	C858.387939,93.497345 857.680237,93.204094 856.836182,92.633667
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M925.340454,218.439255
	C922.970215,218.686096 920.931213,218.700272 918.456421,218.688766
	C917.867126,218.376678 917.644287,218.162048 917.159912,217.878433
	C917.199768,217.312866 917.437500,216.514053 917.663330,216.517395
	C925.704529,216.636475 933.744568,216.830658 941.912476,217.377060
	C936.583923,217.895370 931.127808,218.050980 925.340454,218.439255
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M840.846313,141.752167
	C838.251526,141.787674 835.435242,141.556595 832.275269,140.839569
	C831.276489,139.580490 830.621338,138.807343 829.710571,137.899765
	C828.945312,137.495407 828.435730,137.225464 827.854370,136.712006
	C827.520325,135.356125 827.258179,134.243729 826.996033,133.131332
	C827.026428,132.966797 827.056763,132.802246 827.330994,132.374939
	C827.574951,132.112167 827.967407,132.134796 827.967407,132.134796
	C828.736328,132.426071 829.505249,132.717331 830.594727,133.022369
	C831.342529,133.688721 831.769775,134.341278 832.476868,135.117050
	C835.379456,137.322037 838.002075,139.403809 840.846313,141.752167
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M847.134399,209.003952
	C847.593018,208.422241 848.051575,207.840515 848.738281,207.091064
	C850.004089,210.240067 851.041748,213.556808 852.411743,216.991547
	C852.825684,217.825897 852.907166,218.542282 852.998657,219.619812
	C853.063416,221.292908 853.118103,222.604843 853.490295,224.006134
	C853.861633,224.821259 853.915527,225.547043 853.949768,226.637665
	C852.252075,232.259552 852.993286,233.202530 860.587646,235.001541
	C860.873230,235.346008 860.684753,235.609451 859.817322,235.912323
	C857.835449,237.683868 856.440552,239.350159 854.790039,241.014496
	C854.364441,241.017715 854.194397,241.022903 853.889343,240.700592
	C852.906311,238.878799 852.058289,237.384506 851.158569,235.529083
	C851.074036,234.437561 851.041260,233.707138 851.228760,232.819550
	C851.043945,232.079681 850.638855,231.497025 850.184570,230.551422
	C850.106812,229.456848 850.078308,228.725235 850.266479,227.827393
	C850.059570,227.062103 849.635986,226.463028 849.172607,225.481567
	C849.095886,224.074463 849.058960,223.049759 849.266479,221.823578
	C849.288086,220.725845 849.065247,219.829575 848.818726,218.575684
	C848.548462,216.810120 848.301880,215.402191 848.295288,213.796478
	C848.101257,212.693161 847.667297,211.787628 847.195374,210.570190
	C847.149719,209.840164 847.142029,209.422058 847.134399,209.003952
z"/>
<path fill="#5389B4" opacity="1.000000" stroke="none"
	d="
M778.596069,73.988388
	C779.460632,73.984947 779.901733,73.987953 780.666687,74.361092
	C777.892639,82.270287 780.248779,87.835358 787.021973,88.977081
	C785.113464,91.782188 783.204895,94.587303 781.133179,97.689606
	C778.542236,97.991631 776.114502,97.996452 773.305481,97.966309
	C772.944763,97.479546 772.965332,97.027748 773.051392,95.900902
	C775.358154,93.897072 777.599304,92.568291 779.785583,91.272018
	C779.033997,90.936493 778.025024,90.486099 776.756287,89.747650
	C774.661316,89.304466 772.826111,89.149338 770.943542,88.645599
	C769.921143,87.826187 768.946167,87.355392 767.971130,86.884613
	C770.287415,85.976425 772.603760,85.068230 775.145325,84.071709
	C774.792480,83.833038 774.229248,83.452003 773.269165,82.683502
	C771.254944,82.174309 769.637390,82.052582 768.019897,81.930855
	C766.918884,81.906204 765.817871,81.881554 764.312805,81.749527
	C763.937073,80.680031 763.965332,79.717926 764.444946,78.377167
	C766.674500,77.996513 768.464966,77.860939 770.228333,78.022102
	C773.286621,78.301605 774.375122,76.928581 773.943909,74.043213
	C775.353455,74.027084 776.763000,74.010956 778.596069,73.988388
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M773.491821,74.038322
	C774.375122,76.928581 773.286621,78.301605 770.228333,78.022102
	C768.464966,77.860939 766.674500,77.996513 764.440979,78.009384
	C758.716431,77.683395 753.447144,77.346542 748.009033,76.665558
	C753.108948,75.884155 758.377686,75.446884 763.682129,74.643341
	C766.825012,74.195854 769.932373,74.114639 773.491821,74.038322
z"/>
<path fill="#78B9DB" opacity="1.000000" stroke="none"
	d="
M716.921997,75.520081
	C714.640076,75.933891 712.262085,75.983963 709.440308,75.781372
	C708.996887,75.358513 708.997131,75.188316 708.997375,75.018120
	C711.606873,75.064186 714.216370,75.110260 716.921997,75.520081
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M708.664978,75.019196
	C708.997131,75.188316 708.996887,75.358513 708.994995,75.784332
	C708.109558,76.170868 707.225769,76.301773 706.169556,76.173706
	C706.775635,75.616585 707.554077,75.318436 708.664978,75.019196
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M778.045166,208.009628
	C778.022156,211.690262 777.999146,215.370880 777.612793,219.594666
	C776.221985,222.111877 775.194519,224.085953 774.081543,225.761536
	C773.922180,225.269623 773.848450,225.076187 773.774780,224.882767
	C774.534729,217.897751 775.294678,210.912735 776.376526,203.462921
	C777.117371,202.991043 777.536377,202.983963 778.210754,203.184723
	C778.325867,204.931595 778.185486,206.470612 778.045166,208.009628
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M783.165955,165.058792
	C783.096680,166.429657 783.027405,167.800507 782.703735,169.805634
	C781.943176,171.631287 781.437012,172.822693 780.930908,174.014099
	C781.309631,170.723282 781.688354,167.432465 782.522339,164.309433
	C783.040405,164.671082 783.103149,164.864929 783.165955,165.058792
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M780.938599,174.416016
	C781.437012,172.822693 781.943176,171.631287 782.698486,170.217712
	C782.560303,172.619476 782.172913,175.243408 781.430420,177.950012
	C781.032349,176.961105 780.989380,175.889511 780.938599,174.416016
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M773.469055,224.908798
	C773.848450,225.076187 773.922180,225.269623 774.030884,226.151672
	C774.042786,227.890274 774.019775,228.940277 773.996765,229.990265
	C773.537231,230.267319 773.077698,230.544342 772.382568,230.948151
	C772.101685,229.983948 772.056274,228.892975 772.003296,227.392639
	C771.995728,226.983261 771.997864,227.000885 772.167297,226.916489
	C772.215576,226.549423 772.094482,226.266754 771.973389,225.984070
	C771.973389,225.984070 771.952881,225.514160 771.942749,225.279739
	C772.342834,225.008484 772.753113,224.971664 773.469055,224.908798
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M780.048767,187.999725
	C780.048767,187.999725 780.538086,187.990128 780.783081,187.996613
	C781.014221,189.382217 781.000305,190.761353 780.662109,192.567017
	C779.909546,193.006393 779.481323,193.019257 779.019531,192.673401
	C778.922241,191.838150 778.858398,191.361588 778.794617,190.885040
	C778.848511,190.164993 778.902405,189.444962 779.229614,188.361908
	C779.684814,187.999161 779.866760,187.999435 780.048767,187.999725
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M777.955322,202.976868
	C777.536377,202.983963 777.117371,202.991043 776.386719,203.030151
	C776.372986,201.433563 776.670898,199.804962 777.461182,198.085541
	C777.953552,197.994736 778.232422,197.986801 778.157288,198.399017
	C778.039917,200.199783 777.997620,201.588318 777.955322,202.976868
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M783.512390,164.955673
	C783.103149,164.864929 783.040405,164.671082 782.870239,164.189667
	C782.826660,163.157654 782.890442,162.413208 782.978760,161.292755
	C783.495544,160.671448 783.987793,160.426132 784.742432,160.090805
	C784.622864,161.618027 784.240845,163.235291 783.512390,164.955673
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M780.500488,177.997879
	C780.748779,179.111526 780.676331,180.316559 780.338257,181.768585
	C780.108337,180.706802 780.143982,179.398041 780.500488,177.997879
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M778.482544,190.981888
	C778.858398,191.361588 778.922241,191.838150 778.991455,192.996429
	C778.984619,194.110626 778.972412,194.543076 778.694092,194.982681
	C778.250671,194.995163 778.073303,195.000504 777.895935,195.005829
	C777.987427,193.696793 778.078918,192.387772 778.482544,190.981888
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M780.038330,187.615280
	C779.866760,187.999435 779.684814,187.999161 779.229736,188.000427
	C779.046448,187.021957 779.136414,186.041962 779.529419,184.997925
	C779.897583,185.699554 779.962708,186.465195 780.038330,187.615280
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M777.911255,195.381668
	C778.073303,195.000504 778.250671,194.995163 778.947876,195.173828
	C779.055969,196.234146 778.644165,197.110474 778.232422,197.986786
	C778.232422,197.986801 777.953552,197.994736 777.811279,197.995026
	C777.754822,197.249374 777.840698,196.503448 777.911255,195.381668
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M767.526489,86.913544
	C768.946167,87.355392 769.921143,87.826187 770.537842,88.659698
	C767.477600,89.365669 764.775635,89.708939 762.073669,90.052193
	C760.933655,89.675354 759.793640,89.298523 758.275513,88.841248
	C760.958923,88.154709 764.020386,87.548599 767.526489,86.913544
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M768.014343,82.200142
	C769.637390,82.052582 771.254944,82.174309 772.937439,82.648827
	C771.614746,83.009537 770.226990,83.017456 768.423462,83.016747
	C768.008057,82.828552 768.008423,82.648987 768.014343,82.200142
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M757.171997,84.813156
	C757.402649,84.238831 757.951721,83.700180 758.819946,83.202118
	C758.589600,83.778091 758.039978,84.313461 757.171997,84.813156
z"/>
<path fill="#4A82A9" opacity="1.000000" stroke="none"
	d="
M761.765381,90.280144
	C764.775635,89.708939 767.477600,89.365669 770.585205,89.008316
	C772.826111,89.149338 774.661316,89.304466 776.414307,89.887596
	C773.544556,91.241714 770.757019,92.167831 767.969421,93.093941
	C757.902039,95.357864 747.834656,97.621788 737.360962,99.870209
	C734.507812,99.854713 732.060913,99.854713 729.614075,99.854713
	C729.453735,99.480682 729.293457,99.106659 729.133118,98.732628
	C730.285095,97.986221 731.437073,97.239815 732.802612,96.217957
	C733.420715,95.915115 733.825195,95.887726 734.850098,95.870773
	C736.033020,95.371559 736.595520,94.861908 737.157959,94.352249
	C745.257690,93.070854 753.357422,91.789474 761.765381,90.280144
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M736.841675,94.283798
	C736.595520,94.861908 736.033020,95.371559 735.153442,95.846962
	C735.399414,95.280243 735.962402,94.747787 736.841675,94.283798
z"/>
<path fill="#639CC4" opacity="1.000000" stroke="none"
	d="
M767.983337,93.447968
	C770.757019,92.167831 773.544556,91.241714 776.674072,90.175644
	C778.025024,90.486099 779.033997,90.936493 779.785583,91.272018
	C777.599304,92.568291 775.358154,93.897072 773.045898,95.561134
	C771.570496,95.924309 770.166138,95.952202 768.337769,95.952637
	C767.941589,95.217453 767.969421,94.509720 767.983337,93.447968
z"/>
<path fill="#3B5670" opacity="1.000000" stroke="none"
	d="
M786.960205,141.076233
	C786.786743,141.070480 786.613342,141.064713 786.179871,141.035217
	C785.778992,140.449570 785.638184,139.887650 785.253235,139.158386
	C785.332153,138.582108 785.655212,138.173172 786.130371,137.553162
	C787.238098,136.899628 788.193848,136.457184 789.448425,135.915558
	C790.304688,135.618134 790.862122,135.419891 791.691711,135.097885
	C791.982544,135.451950 792.001099,135.929749 791.884521,137.020325
	C791.155212,138.422333 790.561035,139.211548 789.626465,140.003281
	C788.510803,140.362610 787.735474,140.719421 786.960205,141.076233
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M771.970032,226.238464
	C772.094482,226.266754 772.215576,226.549423 772.160034,226.916763
	C771.977844,226.831924 771.972229,226.662399 771.970032,226.238464
z"/>
<path fill="#4D85AD" opacity="1.000000" stroke="none"
	d="
M787.015259,88.554504
	C780.248779,87.835358 777.892639,82.270287 780.997681,74.363335
	C785.512756,73.857727 787.942932,74.995285 786.275330,80.399017
	C785.570251,82.683632 786.708313,85.537056 787.015259,88.554504
z"/>
<path fill="#BE934C" opacity="1.000000" stroke="none"
	d="
M820.422607,232.994659
	C819.772156,228.855484 816.810730,228.961685 814.081543,229.559479
	C811.496399,230.125717 809.871155,230.091278 810.348633,226.461441
	C812.135376,225.341476 813.571411,224.656647 815.238892,224.080627
	C815.921448,224.430206 816.372559,224.670990 817.195251,224.908020
	C821.293762,222.833405 820.767761,221.235809 817.005615,219.570786
	C816.975708,217.440628 816.960876,215.736267 817.228027,213.785370
	C817.336182,211.684128 817.162415,209.829453 816.984741,207.527679
	C816.980957,204.398682 816.981079,201.716782 816.988770,198.662445
	C816.650818,197.183304 816.305359,196.076584 815.924683,194.697662
	C815.836304,194.250397 815.783081,194.075317 815.779114,193.581543
	C815.848083,192.833527 815.867798,192.404221 816.184570,191.741318
	C815.894714,188.724442 820.266663,185.027313 814.918701,182.889389
	C814.901855,182.660400 814.898193,182.201202 814.898193,182.201202
	C814.439880,179.895294 813.802673,177.332748 817.335693,177.158463
	C820.156006,177.019333 822.683594,177.835297 822.974854,181.327255
	C823.344971,185.763580 823.301514,190.269272 824.085754,194.628220
	C825.343933,201.621521 827.219238,208.501495 828.661438,215.465073
	C829.282410,218.463669 829.382751,221.566193 829.877930,224.595612
	C830.778503,230.105377 831.933167,235.576492 832.719604,241.101044
	C833.252441,244.844360 833.617920,248.666077 833.422791,252.419662
	C833.374695,253.344406 830.942383,254.581299 829.441162,254.901978
	C826.484741,255.533554 825.258301,253.580811 825.032471,250.906250
	C824.657898,246.469711 824.589355,241.987488 823.870728,237.610062
	C823.599060,235.955002 821.881653,234.537262 820.422607,232.994659
z"/>
<path fill="#BE934C" opacity="1.000000" stroke="none"
	d="
M806.022339,222.992065
	C806.097778,223.758911 805.953674,224.641434 806.286316,225.272797
	C807.819519,228.183136 806.454712,229.001877 803.389343,229.003754
	C802.271545,226.771759 801.951355,224.272369 800.721069,222.357880
	C798.286377,218.569168 798.000977,215.153946 800.896118,211.572083
	C801.698730,210.579086 802.818054,209.415161 802.853882,208.299530
	C803.069946,201.579010 802.935425,194.847977 803.088684,188.124329
	C803.144348,185.687286 803.669983,183.260941 803.991821,180.415039
	C805.572388,181.446960 807.709045,175.282074 808.908936,180.971924
	C808.573486,182.059082 808.336731,182.547287 807.870605,183.155441
	C807.446594,183.554520 807.251953,183.833664 806.874878,184.158203
	C806.619934,184.304306 806.474426,184.483398 806.485840,184.494080
	C806.657104,184.653732 806.849121,184.791122 807.048828,185.205612
	C807.069519,185.658646 807.077576,185.839859 806.821045,186.202454
	C806.378479,198.586563 806.200439,210.789322 806.022339,222.992065
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M833.000000,223.439148
	C833.813171,222.990524 834.608643,222.968628 835.811462,223.130096
	C836.218811,223.313431 836.243042,223.719849 836.201660,224.056900
	C836.731873,224.941345 837.303528,225.488724 837.875183,226.036102
	C837.875183,226.036102 838.021057,226.491516 838.034302,227.113983
	C838.166626,228.517502 838.285828,229.298553 838.405029,230.079620
	C838.611572,231.470886 838.818115,232.862137 839.015747,234.987946
	C838.991821,236.486160 838.976807,237.249832 838.718872,238.207092
	C838.930847,239.285339 839.385742,240.170013 839.902039,241.395340
	C840.083496,242.181061 840.203552,242.626099 840.323608,243.071167
	C840.579773,244.776413 840.835876,246.481644 841.053345,248.813110
	C840.976318,249.612946 840.937988,249.786530 840.899658,249.960114
	C840.458435,250.969574 840.017151,251.979019 839.599731,252.933945
	C838.964844,252.008743 838.310730,251.055481 837.327026,250.051834
	C836.685547,248.902435 836.373596,247.803406 836.303406,246.089264
	C836.047668,243.299454 835.550171,241.124756 835.052734,238.950073
	C834.362549,233.922028 833.672424,228.893967 833.000000,223.439148
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M807.085571,186.021057
	C807.077576,185.839859 807.069519,185.658646 807.053589,185.000702
	C807.045776,184.524002 807.057312,184.112823 807.057312,184.112823
	C807.251953,183.833664 807.446594,183.554520 808.242188,183.147736
	C810.218872,182.709900 811.594604,182.399689 812.970398,182.089478
	C813.400269,182.102768 813.830078,182.116043 814.579102,182.165268
	C814.898193,182.201202 814.901855,182.660400 814.918457,183.264816
	C814.231567,184.575165 813.570068,185.330368 812.814697,185.975693
	C811.634949,186.983627 810.391602,187.917160 809.175293,188.882263
	C810.647278,189.680466 812.097534,190.523285 813.600830,191.257370
	C814.310608,191.603989 815.122131,191.742233 815.887573,191.974915
	C815.867798,192.404221 815.848083,192.833527 815.361145,193.610443
	C809.888794,194.870865 806.992004,193.471054 807.893738,187.708420
	C807.973267,187.200562 807.371155,186.586029 807.085571,186.021057
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M835.021973,239.372238
	C835.550171,241.124756 836.047668,243.299454 836.277100,245.746185
	C835.669678,243.943649 835.330444,241.869034 835.021973,239.372238
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M812.758911,181.801544
	C811.594604,182.399689 810.218872,182.709900 808.471558,183.027802
	C808.336731,182.547287 808.573486,182.059082 808.922852,181.321762
	C810.206177,181.219650 811.376770,181.366623 812.758911,181.801544
z"/>
<path fill="#BE934C" opacity="1.000000" stroke="none"
	d="
M798.653809,199.028183
	C798.225525,199.969040 797.458374,200.948441 796.352905,201.964844
	C796.781433,201.023483 797.548218,200.045105 798.653809,199.028183
z"/>
<path fill="#BE934C" opacity="1.000000" stroke="none"
	d="
M802.803711,179.740570
	C802.218628,180.310486 801.430847,180.629089 800.323975,180.972794
	C800.870239,180.495010 801.735596,179.992126 802.803711,179.740570
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M920.586853,229.130402
	C920.102661,228.979691 920.072388,228.784988 920.038757,228.294739
	C925.960510,228.062836 931.885559,228.126480 937.909790,228.579437
	C932.352844,229.007965 926.696777,229.047180 920.586853,229.130402
z"/>
<path fill="#696661" opacity="1.000000" stroke="none"
	d="
M906.004639,235.022217
	C906.443054,235.019684 906.881470,235.017151 907.648193,235.020386
	C908.185730,235.301483 908.394836,235.576828 908.819458,236.359406
	C909.635620,240.271591 912.158691,243.874298 908.013794,246.790955
	C907.261475,246.824951 906.509094,246.858948 905.380981,246.851135
	C904.906311,246.509399 904.728882,246.266846 904.192078,245.650970
	C902.967590,244.819229 902.024109,244.418167 901.080566,244.017090
	C900.171570,244.192108 899.262634,244.367142 898.123657,244.816040
	C896.630920,245.449066 895.368286,245.808212 893.705322,246.542755
	C892.887756,246.906601 892.470459,246.895035 892.053223,246.883469
	C890.273376,246.168518 888.493591,245.453583 886.411865,244.887573
	C885.257751,245.277130 884.405579,245.517715 883.242065,245.890900
	C880.241699,245.686234 877.552612,245.348969 874.434448,244.998047
	C873.009766,240.126068 874.484680,238.836212 879.212219,239.973755
	C880.283508,240.231537 881.672913,239.167084 883.350952,238.352112
	C888.048401,237.466293 893.546448,235.039688 896.301025,236.831284
	C901.171448,239.998978 903.062561,236.854126 906.004639,235.022217
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M905.535767,235.009033
	C903.062561,236.854126 901.171448,239.998978 896.301025,236.831284
	C893.546448,235.039688 888.048401,237.466293 883.388123,238.009644
	C881.791992,237.193604 880.593689,236.360870 879.192200,235.282349
	C887.681580,235.023010 896.374207,235.009445 905.535767,235.009033
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M855.045654,241.016464
	C856.440552,239.350159 857.835449,237.683868 859.601074,236.031952
	C859.978455,237.108841 859.985168,238.171402 859.847046,239.921448
	C856.139587,243.561813 860.742981,244.726120 861.064514,246.828278
	C860.178833,247.149887 859.293213,247.471497 858.068359,247.921906
	C857.153442,247.274887 856.577759,246.499084 856.001831,245.018341
	C855.682922,243.214417 855.364319,242.115448 855.045654,241.016464
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M861.376831,246.864563
	C860.742981,244.726120 856.139587,243.561813 859.849304,240.320862
	C863.058411,239.737518 865.327820,240.395691 864.681030,244.631989
	C863.894714,245.666504 863.419861,246.255798 862.945068,246.845108
	C862.526428,246.863708 862.107727,246.882294 861.376831,246.864563
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M863.302734,246.897064
	C863.419861,246.255798 863.894714,245.666504 864.676270,245.028656
	C865.841614,245.833328 866.700195,246.686539 867.310486,247.759735
	C865.928284,247.636154 864.794373,247.292603 863.302734,246.897064
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M931.830078,242.310242
	C931.817078,241.313843 931.877747,240.553574 931.931458,239.412048
	C934.770996,239.772263 934.610352,241.145081 932.392456,242.948334
	C932.052612,243.018188 931.903809,242.546371 931.830078,242.310242
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M836.243042,223.719849
	C836.243042,223.719849 836.218811,223.313431 836.209106,223.109161
	C836.155457,219.532089 836.111572,216.159302 836.447876,212.458099
	C837.548157,213.760498 838.268311,215.391312 838.988525,217.022125
	C838.997620,219.057037 839.006653,221.091949 839.030518,223.562775
	C839.045410,223.998672 838.547546,224.011932 837.992310,223.987000
	C837.039062,223.881332 836.641052,223.800598 836.243042,223.719849
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M838.961853,238.013489
	C838.976807,237.249832 838.991821,236.486160 839.063843,235.343903
	C839.578552,235.847824 840.036255,236.730331 839.985413,237.808868
	C839.305176,238.007751 839.133545,238.010620 838.961853,238.013489
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M838.718872,238.207092
	C839.133545,238.010620 839.305176,238.007751 839.734375,238.004120
	C840.010742,238.438110 840.029541,238.872849 840.013794,239.907578
	C839.933044,240.689926 839.886902,240.872299 839.840698,241.054672
	C839.385742,240.170013 838.930847,239.285339 838.718872,238.207092
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M839.902039,241.395340
	C839.886902,240.872299 839.933044,240.689926 840.044922,240.232544
	C840.376465,240.937073 840.642212,241.916626 840.615845,242.983673
	C840.203552,242.626099 840.083496,242.181061 839.902039,241.395340
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M838.689148,229.982300
	C838.285828,229.298553 838.166626,228.517502 838.105957,227.342072
	C838.434021,227.926804 838.703674,228.905884 838.689148,229.982300
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M840.966431,250.257263
	C840.937988,249.786530 840.976318,249.612946 841.105347,249.187531
	C841.628296,249.829910 842.060425,250.724091 842.244507,251.813644
	C841.675293,251.524139 841.354248,251.039261 840.966431,250.257263
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M852.865417,252.204117
	C852.794067,251.543625 852.880859,251.089539 853.031860,250.293411
	C853.510132,250.880981 853.924316,251.810623 854.052185,252.929871
	C853.518433,252.883163 853.271057,252.646851 852.865417,252.204117
z"/>
<path fill="#73644E" opacity="1.000000" stroke="none"
	d="
M836.201660,224.056900
	C836.641052,223.800598 837.039062,223.881332 837.743286,223.983017
	C838.029358,224.457214 838.009155,224.910477 837.932129,225.699921
	C837.303528,225.488724 836.731873,224.941345 836.201660,224.056900
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M858.238159,251.854706
	C857.824951,251.447632 857.637146,250.887054 857.651733,250.162659
	C858.057312,250.566284 858.260437,251.133728 858.238159,251.854706
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M891.651489,246.937973
	C892.470459,246.895035 892.887756,246.906601 893.615967,246.882736
	C897.043091,250.524246 896.917480,255.691772 893.654053,255.837982
	C891.861145,255.918304 888.740662,254.958038 888.436218,253.854919
	C887.752441,251.377563 886.499390,247.653046 891.651489,246.937973
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M908.338745,246.865509
	C912.158691,243.874298 909.635620,240.271591 909.047485,236.489166
	C910.577209,236.549866 912.094238,236.988052 913.810913,238.129456
	C914.001343,240.552170 913.992249,242.271667 913.983154,243.991180
	C913.489624,244.580673 912.996094,245.170166 911.939697,245.905457
	C910.916382,246.374008 910.455933,246.696777 909.995483,247.019547
	C909.551575,246.993057 909.107666,246.966568 908.338745,246.865509
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M909.992188,247.430847
	C910.455933,246.696777 910.916382,246.374008 911.670166,246.021942
	C911.944946,248.709366 911.926392,251.426071 911.875244,254.508499
	C911.091003,255.175919 910.339355,255.477631 909.302734,255.896912
	C909.341492,253.290375 909.665161,250.566269 909.992188,247.430847
z"/>
<path fill="#696661" opacity="1.000000" stroke="none"
	d="
M914.359131,243.917023
	C913.992249,242.271667 914.001343,240.552170 914.022339,238.401367
	C914.468994,237.981293 914.903687,237.992538 915.664307,238.019440
	C915.571838,239.971024 915.153442,241.906952 914.359131,243.917023
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M851.210327,235.890198
	C852.058289,237.384506 852.906311,238.878799 853.884399,241.095139
	C854.009644,242.870926 854.004822,243.924698 854.000000,244.978455
	C853.825745,245.540314 853.651428,246.102158 852.979126,246.833954
	C852.481079,247.003906 851.982849,247.009598 851.985657,246.679413
	C851.953735,245.910782 851.919067,245.472321 851.924622,244.695175
	C851.640869,243.573135 851.316956,242.789795 850.991455,241.593948
	C850.925720,239.813324 850.861511,238.445206 850.889771,236.776611
	C851.058289,236.280823 851.134338,236.085510 851.210327,235.890198
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M854.330933,244.991714
	C854.004822,243.924698 854.009644,242.870926 854.019409,241.422623
	C854.194397,241.022903 854.364441,241.017715 854.790100,241.014511
	C855.364319,242.115448 855.682922,243.214417 855.993530,244.683029
	C855.544312,245.036789 855.103088,245.020889 854.330933,244.991714
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M851.982849,247.009598
	C851.982849,247.009598 852.481079,247.003906 852.729980,247.002731
	C852.960327,247.463608 852.941772,247.925644 852.858398,248.730103
	C852.403381,249.050217 852.013123,249.027939 851.342163,248.703003
	C851.368530,247.936768 851.675720,247.473190 851.982849,247.009598
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M901.067627,244.371826
	C902.024109,244.418167 902.967590,244.819229 903.990356,245.540924
	C903.358643,245.929138 902.647766,245.996735 901.587891,246.100266
	C901.177551,245.666336 901.116150,245.196457 901.067627,244.371826
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M901.819702,254.579132
	C901.830627,254.836624 901.440552,254.884750 901.244751,254.884491
	C901.052063,254.475220 901.055237,254.066193 901.058472,253.350494
	C901.308655,253.469757 901.558716,253.895691 901.819702,254.579132
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M767.035156,242.361938
	C767.546021,242.346542 768.051514,242.648239 768.557007,242.949951
	C768.248230,243.265701 767.939392,243.581482 767.340576,243.922012
	C767.043640,243.524200 767.036743,243.101639 767.035156,242.361938
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M840.418823,172.897339
	C840.817261,173.428848 840.882324,173.883041 840.940125,174.682022
	C840.955139,178.405533 840.977417,181.784241 840.991089,185.594147
	C839.991150,185.052505 838.276978,184.175201 838.133667,183.090332
	C837.509644,178.367615 837.342773,173.584503 837.022339,168.382782
	C838.051697,169.568161 839.068542,171.194092 840.418823,172.897339
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M778.157288,198.399017
	C778.644165,197.110474 779.055969,196.234146 779.213989,195.166687
	C778.972412,194.543076 778.984619,194.110626 779.024902,193.355148
	C779.481323,193.019257 779.909546,193.006393 780.658997,192.980820
	C782.691162,198.302338 782.712158,203.388885 778.418701,207.953766
	C778.185486,206.470612 778.325867,204.931595 778.210754,203.184723
	C777.997620,201.588318 778.039917,200.199783 778.157288,198.399017
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M830.993896,175.376892
	C831.166870,175.009537 831.339600,175.009109 831.771729,175.003250
	C833.019897,176.414459 834.611145,177.728424 834.873657,179.268860
	C835.445068,182.621185 835.339172,186.088943 834.996948,189.584625
	C833.700989,189.089172 832.918152,188.518616 832.135315,187.948059
	C832.090149,186.894745 832.044922,185.841415 832.281250,184.140976
	C832.082336,181.643127 831.601868,179.792389 831.121460,177.941650
	C831.078857,177.209030 831.036255,176.476425 830.993896,175.376892
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M851.158569,235.529083
	C851.134338,236.085510 851.058289,236.280823 850.547119,236.753967
	C849.417603,237.000336 848.723145,236.968872 848.028687,236.937424
	C847.858337,233.116150 847.688049,229.294861 847.267944,224.891617
	C847.333557,223.541245 847.648865,222.772842 848.228821,222.007355
	C848.669678,222.015198 848.845825,222.020111 849.022095,222.025040
	C849.058960,223.049759 849.095886,224.074463 849.120361,225.795929
	C849.421875,226.992981 849.735840,227.493286 850.049805,227.993591
	C850.078308,228.725235 850.106812,229.456848 850.129639,230.851959
	C850.418762,232.002533 850.713562,232.489639 851.008423,232.976746
	C851.041260,233.707138 851.074036,234.437561 851.158569,235.529083
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M848.017212,237.387711
	C848.723145,236.968872 849.417603,237.000336 850.454712,237.054443
	C850.861511,238.445206 850.925720,239.813324 850.742065,241.789169
	C850.957642,243.275894 851.421021,244.154877 851.884399,245.033875
	C851.919067,245.472321 851.953735,245.910782 851.985657,246.679413
	C851.675720,247.473190 851.368530,247.936768 851.047607,248.693146
	C850.024414,245.269943 849.015076,241.553970 848.017212,237.387711
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M844.507263,199.915665
	C844.908081,200.740051 844.960815,201.485977 845.015259,202.605164
	C844.695068,203.455154 844.373169,203.931870 844.026855,204.709869
	C842.822510,200.835632 841.642578,196.660095 840.740906,192.233078
	C842.065857,194.600128 843.112549,197.218658 844.507263,199.915665
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M847.964172,222.004425
	C847.648865,222.772842 847.333557,223.541245 847.018188,224.640945
	C846.366272,224.782608 845.193481,224.682205 845.143372,224.389526
	C844.657593,221.552475 844.359985,218.683197 844.350952,215.459778
	C845.718933,216.395035 846.744690,217.693634 847.838867,219.364716
	C847.926208,220.492935 847.945190,221.248672 847.964172,222.004425
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M774.253174,229.988983
	C774.019775,228.940277 774.042786,227.890274 774.116455,226.450150
	C775.194519,224.085953 776.221985,222.111877 777.610229,220.053177
	C777.226013,223.263901 776.481018,226.559250 775.379272,229.924088
	C774.851624,229.991608 774.680664,229.989655 774.253174,229.988983
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M847.770386,218.992233
	C846.744690,217.693634 845.718933,216.395035 844.357605,215.027832
	C844.359009,213.171768 844.696045,211.384277 845.090820,209.193695
	C845.587158,208.851562 846.025818,208.912537 846.799377,208.988739
	C847.142029,209.422058 847.149719,209.840164 847.120789,210.917328
	C847.407898,212.382355 847.731628,213.188309 848.055298,213.994263
	C848.301880,215.402191 848.548462,216.810120 848.551270,218.589844
	C848.128479,218.971848 847.949402,218.982040 847.770386,218.992233
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M839.269897,216.752228
	C838.268311,215.391312 837.548157,213.760498 836.495239,212.039001
	C836.113220,211.211395 836.064026,210.474487 836.235474,209.260513
	C836.722778,208.577744 836.910583,208.315491 837.019470,207.996704
	C841.285400,209.804230 840.004395,213.266800 839.269897,216.752228
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M837.043823,207.654160
	C836.910583,208.315491 836.722778,208.577744 836.236511,208.890686
	C835.363708,205.918076 834.710449,202.838211 834.407227,199.361633
	C835.170715,198.982559 835.584167,199.000183 835.997559,199.017822
	C835.997559,199.017807 835.995178,199.503433 835.996155,200.122696
	C836.657410,201.836990 837.317688,202.932022 837.978027,204.027069
	C837.674744,205.121918 837.371460,206.216766 837.043823,207.654160
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M832.130676,188.330719
	C832.918152,188.518616 833.700989,189.089172 834.735901,189.835083
	C834.993530,190.756577 834.999084,191.502731 834.984924,192.916565
	C834.658508,194.053955 834.351807,194.523682 834.045105,194.993439
	C833.405396,192.900085 832.765686,190.806732 832.130676,188.330719
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M815.953674,169.488785
	C814.314087,169.879471 812.569275,169.926727 810.389709,169.926910
	C811.561890,166.765930 813.671021,167.681793 815.953674,169.488785
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M772.342407,248.945282
	C772.747925,247.359833 773.503235,245.718460 774.623169,244.025574
	C774.222595,245.612488 773.457336,247.250931 772.342407,248.945282
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M834.031982,195.388397
	C834.351807,194.523682 834.658508,194.053955 834.990723,193.289764
	C835.344910,194.732208 835.673523,196.469147 835.999878,198.611938
	C835.584167,199.000183 835.170715,198.982559 834.450012,198.947083
	C834.101440,197.880615 834.060181,196.831985 834.031982,195.388397
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M837.984009,203.648849
	C837.317688,202.932022 836.657410,201.836990 835.998535,200.365479
	C836.663330,201.082901 837.326660,202.176773 837.984009,203.648849
z"/>
<path fill="#C29957" opacity="1.000000" stroke="none"
	d="
M774.990295,239.617737
	C774.808167,238.509750 774.633667,236.978821 774.723633,235.208832
	C774.991394,236.378098 774.994690,237.786453 774.990295,239.617737
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M831.076599,178.349075
	C831.601868,179.792389 832.082336,181.643127 832.289307,183.745407
	C831.687744,182.250137 831.359802,180.503311 831.076599,178.349075
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M806.821106,186.202438
	C807.371155,186.586029 807.973267,187.200562 807.893738,187.708420
	C806.992004,193.471054 809.888794,194.870865 815.311890,193.929169
	C815.783081,194.075317 815.836304,194.250397 815.672729,194.899261
	C815.964294,196.593674 816.472717,197.814285 816.981079,199.034882
	C816.981079,201.716782 816.980957,204.398682 816.710693,207.742981
	C815.945862,209.946304 815.451172,211.487244 814.530029,213.024902
	C809.248169,212.240479 807.356689,214.362244 807.975403,219.134521
	C808.143372,220.430099 807.921631,221.776184 807.878784,223.099091
	C807.466187,223.073517 807.053589,223.047928 806.331665,223.007202
	C806.200439,210.789322 806.378479,198.586563 806.821106,186.202438
M814.610535,207.499573
	C814.239441,207.108963 813.913879,206.657715 813.488892,206.338821
	C812.067749,205.272369 810.611084,204.253281 809.168030,203.216049
	C810.606018,202.687576 812.043823,202.158813 813.481995,201.630829
	C813.911316,201.473221 814.341431,201.317886 814.771179,201.161514
	C814.892334,200.694061 815.013489,200.226608 815.134705,199.759155
	C813.286499,199.283081 811.438354,198.807007 809.590149,198.330948
	C809.170105,201.592606 807.812439,205.104980 808.598389,208.044159
	C809.357971,210.884857 812.301697,209.707809 814.610535,207.499573
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M807.928711,223.414093
	C807.921631,221.776184 808.143372,220.430099 807.975403,219.134521
	C807.356689,214.362244 809.248169,212.240479 814.570251,213.238647
	C815.037048,213.455688 815.097290,213.886932 815.063538,214.250717
	C814.021118,215.131744 812.972046,215.584503 812.014954,216.184006
	C811.015381,216.810074 810.104370,217.577469 809.154663,218.283127
	C810.124207,219.129456 810.989624,220.181229 812.102234,220.745605
	C812.777893,221.088348 813.835632,220.677979 814.847656,220.595673
	C814.913635,221.990372 814.960510,222.981110 815.007385,223.971832
	C813.571411,224.656647 812.135376,225.341476 810.341309,226.070007
	C809.315002,225.318832 808.646790,224.523956 807.928711,223.414093
z"/>
<path fill="#746D63" opacity="1.000000" stroke="none"
	d="
M818.069458,101.965378
	C818.472717,101.967590 818.876038,101.969810 819.579224,101.968094
	C820.880798,103.110565 821.882385,104.256973 822.583618,105.712044
	C819.546570,105.493904 819.469971,107.002296 819.545776,108.986961
	C813.404846,109.013222 807.732727,109.038544 802.060669,109.063858
	C802.364502,107.913727 802.668396,106.763603 803.006226,105.249832
	C803.802917,104.595093 804.565674,104.303993 805.955139,104.301460
	C809.480225,104.722633 812.405762,105.127083 815.262695,104.842659
	C816.283691,104.741013 817.138672,102.972862 818.069458,101.965378
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M817.766968,101.693176
	C817.138672,102.972862 816.283691,104.741013 815.262695,104.842659
	C812.405762,105.127083 809.480225,104.722633 806.282898,104.305038
	C806.261108,103.510033 806.538269,103.000008 806.928467,102.220474
	C810.515869,101.774292 813.990173,101.597633 817.766968,101.693176
z"/>
<path fill="#AF9568" opacity="1.000000" stroke="none"
	d="
M802.020508,109.525131
	C807.732727,109.038544 813.404846,109.013222 819.588013,109.318512
	C820.143799,110.092262 820.188538,110.535393 820.146118,111.442184
	C819.925232,119.223404 819.791504,126.540970 819.333740,133.844254
	C818.366333,133.772095 817.722778,133.714218 816.962646,133.336441
	C815.581055,131.722397 814.316040,130.428253 813.427734,129.054962
	C814.505127,127.011230 815.205811,125.046646 815.932495,122.651627
	C815.936279,120.776100 815.914062,119.331009 815.919617,117.479630
	C815.902893,114.825928 816.814514,112.047050 812.982727,111.551483
	C811.925903,111.449547 810.939209,111.662064 809.637085,111.951340
	C808.798462,112.657745 808.275330,113.287392 807.412109,114.036430
	C806.895386,118.595436 806.702942,123.034698 806.598694,127.476021
	C806.594421,127.657318 807.421143,127.858116 808.070862,128.267212
	C808.833984,128.709946 809.387024,128.935272 809.933960,129.555710
	C807.558838,130.681229 805.189697,131.411652 802.820557,132.142090
	C802.820557,132.142090 802.393616,132.090393 802.189087,131.670425
	C801.927612,130.494659 801.870605,129.738846 801.813538,128.983047
	C801.869141,122.650833 801.924744,116.318619 802.020508,109.525131
z"/>
<path fill="#A48F65" opacity="1.000000" stroke="none"
	d="
M827.926147,136.955521
	C828.435730,137.225464 828.945312,137.495407 829.710388,138.261475
	C829.948730,139.480179 829.931702,140.202774 829.914612,140.925354
	C817.954346,140.927826 805.994141,140.930298 793.545532,140.562454
	C793.089172,139.246078 793.121094,138.300018 793.153015,137.353973
	C793.582031,137.263153 794.011108,137.172333 794.764771,137.017548
	C797.424011,136.966019 799.758667,136.978439 802.988281,137.014282
	C806.916199,137.039612 809.949280,137.041534 813.421387,137.056824
	C815.906433,137.051651 817.952454,137.033112 820.401001,137.028442
	C821.877258,137.003403 822.950867,136.964523 824.415283,136.954071
	C825.846130,136.973495 826.886108,136.964508 827.926147,136.955521
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M813.051086,129.134094
	C814.316040,130.428253 815.581055,131.722397 816.560547,133.436676
	C815.174194,133.896408 814.073242,133.935974 812.521057,133.965149
	C809.072449,133.930069 806.075195,133.905396 803.077881,133.880707
	C803.026123,133.492813 802.974365,133.104904 802.871582,132.429535
	C805.189697,131.411652 807.558838,130.681229 810.320984,129.495056
	C811.493042,129.070892 812.272034,129.102493 813.051086,129.134094
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M803.053711,134.265594
	C806.075195,133.905396 809.072449,133.930069 812.525818,134.348633
	C812.981995,135.509506 812.982178,136.276489 812.982300,137.043472
	C809.949280,137.041534 806.916199,137.039612 803.428101,136.993683
	C802.991882,136.183289 803.010742,135.416870 803.053711,134.265594
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M801.502136,129.052887
	C801.870605,129.738846 801.927612,130.494659 801.977905,131.630127
	C801.711060,131.047440 801.450867,130.085083 801.502136,129.052887
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M813.421387,137.056824
	C812.982178,136.276489 812.981995,135.509506 812.977112,134.359039
	C814.073242,133.935974 815.174194,133.896408 816.677185,133.756592
	C817.722778,133.714218 818.366333,133.772095 819.740906,133.735519
	C820.692383,126.211952 820.916992,118.782944 821.095337,111.352814
	C821.098206,111.235016 820.533264,111.103592 820.233276,110.978531
	C820.188538,110.535393 820.143799,110.092262 820.056885,109.317566
	C819.469971,107.002296 819.546570,105.493904 822.621887,106.039459
	C823.345215,112.259682 823.567383,118.477486 824.188171,124.655243
	C824.469116,127.450790 825.542053,130.166748 826.625854,133.025085
	C827.258179,134.243729 827.520325,135.356125 827.854370,136.712006
	C826.886108,136.964508 825.846130,136.973495 824.340759,136.618149
	C822.167053,134.387024 820.804260,134.281418 819.998474,137.014572
	C817.952454,137.033112 815.906433,137.051651 813.421387,137.056824
z"/>
<path fill="#6B6871" opacity="1.000000" stroke="none"
	d="
M828.258789,131.816589
	C827.967407,132.134796 827.574951,132.112167 827.380737,132.128937
	C827.281189,123.622444 827.375916,115.099174 827.780518,106.290543
	C828.243530,114.502907 828.396790,123.000641 828.258789,131.816589
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M792.884033,137.260406
	C793.121094,138.300018 793.089172,139.246078 793.084106,140.549606
	C792.362488,140.935669 791.614014,140.964264 790.451660,140.740463
	C790.037842,140.488052 789.966797,140.000748 789.966797,140.000763
	C790.561035,139.211548 791.155212,138.422333 791.898193,137.378540
	C792.236389,137.138260 792.425720,137.152542 792.884033,137.260406
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M796.017334,159.498795
	C796.721924,159.147827 797.502869,159.103027 798.671631,159.123901
	C798.070862,159.394730 797.082275,159.599854 796.017334,159.498795
z"/>
<path fill="#415C69" opacity="1.000000" stroke="none"
	d="
M789.626465,140.003265
	C789.966797,140.000748 790.037842,140.488052 790.078613,140.731018
	C789.110474,141.225983 788.101562,141.477966 787.026489,141.403076
	C787.735474,140.719421 788.510803,140.362610 789.626465,140.003265
z"/>
<path fill="#83786F" opacity="1.000000" stroke="none"
	d="
M830.252686,140.953354
	C829.931702,140.202774 829.948730,139.480179 829.965942,138.395905
	C830.621338,138.807343 831.276489,139.580490 831.937195,140.677490
	C831.492126,140.994675 831.041443,140.988007 830.252686,140.953354
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M848.295288,213.796478
	C847.731628,213.188309 847.407898,212.382355 847.158752,211.229248
	C847.667297,211.787628 848.101257,212.693161 848.295288,213.796478
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M847.838867,219.364716
	C847.949402,218.982040 848.128479,218.971848 848.574951,218.947479
	C849.065247,219.829575 849.288086,220.725845 849.266479,221.823578
	C848.845825,222.020111 848.669678,222.015198 848.228821,222.007355
	C847.945190,221.248672 847.926208,220.492935 847.838867,219.364716
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M851.228699,232.819550
	C850.713562,232.489639 850.418762,232.002533 850.178833,231.214890
	C850.638855,231.497025 851.043945,232.079681 851.228699,232.819550
z"/>
<path fill="#6E6554" opacity="1.000000" stroke="none"
	d="
M850.266479,227.827393
	C849.735840,227.493286 849.421875,226.992981 849.160156,226.178299
	C849.635986,226.463028 850.059570,227.062103 850.266479,227.827393
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M816.184570,191.741318
	C815.122131,191.742233 814.310608,191.603989 813.600830,191.257370
	C812.097534,190.523285 810.647278,189.680466 809.175293,188.882263
	C810.391602,187.917160 811.634949,186.983627 812.814697,185.975693
	C813.570068,185.330368 814.231567,184.575165 814.935303,183.493805
	C820.266663,185.027313 815.894714,188.724442 816.184570,191.741318
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M815.238892,224.080627
	C814.960510,222.981110 814.913635,221.990372 814.847656,220.595673
	C813.835632,220.677979 812.777893,221.088348 812.102234,220.745605
	C810.989624,220.181229 810.124207,219.129456 809.154663,218.283127
	C810.104370,217.577469 811.015381,216.810074 812.014954,216.184006
	C812.972046,215.584503 814.021118,215.131744 815.370605,214.278305
	C816.123047,213.972046 816.534546,214.001984 816.946106,214.031921
	C816.960876,215.736267 816.975708,217.440628 816.987732,219.982101
	C816.931152,222.183411 816.877441,223.547607 816.823669,224.911774
	C816.372559,224.670990 815.921448,224.430206 815.238892,224.080627
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M817.228027,213.785370
	C816.534546,214.001984 816.123047,213.972046 815.404419,213.914520
	C815.097290,213.886932 815.037048,213.455688 814.996826,213.241943
	C815.451172,211.487244 815.945862,209.946304 816.714600,208.190063
	C817.162415,209.829453 817.336182,211.684128 817.228027,213.785370
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M817.195251,224.908020
	C816.877441,223.547607 816.931152,222.183411 817.002808,220.407913
	C820.767761,221.235809 821.293762,222.833405 817.195251,224.908020
z"/>
<path fill="#B9955A" opacity="1.000000" stroke="none"
	d="
M816.988708,198.662460
	C816.472717,197.814285 815.964294,196.593674 815.707886,195.171463
	C816.305359,196.076584 816.650818,197.183304 816.988708,198.662460
z"/>
<path fill="#817459" opacity="1.000000" stroke="none"
	d="
M806.874878,184.158203
	C807.057312,184.112823 807.045776,184.524002 807.041016,184.728912
	C806.849121,184.791122 806.657104,184.653732 806.485840,184.494080
	C806.474426,184.483398 806.619934,184.304306 806.874878,184.158203
z"/>
<path fill="#A78C5C" opacity="1.000000" stroke="none"
	d="
M851.924622,244.695175
	C851.421021,244.154877 850.957642,243.275894 850.743652,242.201675
	C851.316956,242.789795 851.640869,243.573135 851.924622,244.695175
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M814.440430,207.786591
	C812.301697,209.707809 809.357971,210.884857 808.598389,208.044159
	C807.812439,205.104980 809.170105,201.592606 809.590149,198.330933
	C811.438354,198.807007 813.286499,199.283081 815.134705,199.759155
	C815.013489,200.226608 814.892334,200.694061 814.771179,201.161514
	C814.341431,201.317886 813.911316,201.473221 813.481995,201.630829
	C812.043823,202.158813 810.606018,202.687576 809.168030,203.216049
	C810.611084,204.253281 812.067749,205.272369 813.488892,206.338821
	C813.913879,206.657715 814.239441,207.108963 814.440430,207.786591
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M807.752136,113.917046
	C808.275330,113.287392 808.798462,112.657745 810.023804,111.995407
	C811.501587,111.930458 812.277161,111.898201 813.052795,111.865952
	C816.814514,112.047050 815.902893,114.825928 815.572632,117.549149
	C808.980774,120.782547 808.378967,120.450516 807.752136,113.917046
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M807.412109,114.036430
	C808.378967,120.450516 808.980774,120.782547 815.544800,117.955452
	C815.914062,119.331009 815.936279,120.776100 815.540405,122.634384
	C808.161316,121.887291 808.161316,121.887291 807.860718,128.049835
	C807.421143,127.858116 806.594421,127.657318 806.598694,127.476021
	C806.702942,123.034698 806.895386,118.595436 807.412109,114.036430
z"/>
<path fill="#5D5742" opacity="1.000000" stroke="none"
	d="
M808.070862,128.267212
	C808.161316,121.887291 808.161316,121.887291 815.514343,123.064819
	C815.205811,125.046646 814.505127,127.011230 813.427734,129.054962
	C812.272034,129.102493 811.493042,129.070892 810.327026,129.099945
	C809.387024,128.935272 808.833984,128.709946 808.070862,128.267212
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M820.146118,111.442184
	C820.533264,111.103592 821.098206,111.235016 821.095337,111.352814
	C820.916992,118.782944 820.692383,126.211952 820.064819,133.749802
	C819.791504,126.540970 819.925232,119.223404 820.146118,111.442184
z"/>
<path fill="#938261" opacity="1.000000" stroke="none"
	d="
M812.982727,111.551483
	C812.277161,111.898201 811.501587,111.930458 810.339233,111.918655
	C810.939209,111.662064 811.925903,111.449547 812.982727,111.551483
z"/>
<path fill="#695F4F" opacity="1.000000" stroke="none"
	d="
M820.401001,137.028442
	C820.804260,134.281418 822.167053,134.387024 823.949951,136.589722
	C822.950867,136.964523 821.877258,137.003403 820.401001,137.028442
z"/>
</svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
